/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: SpRK5AFZKqfH

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import Button from "../../Button"; // plasmic-import: In8OlLBJG380/component
import FeaturesProductHeader from "../../FeaturesProductHeader"; // plasmic-import: nCl4kJqd_uCB/component
import Logo from "../../Logo"; // plasmic-import: 2Sac1UHK8925/component
import FeaturesCard from "../../FeaturesCard"; // plasmic-import: eBFTaYn0ldI-/component
import ListItem from "../../ListItem"; // plasmic-import: vpKD71-ztgZQ/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicCapabilitiesCards.module.css"; // plasmic-import: SpRK5AFZKqfH/css

import Icon94Icon from "./icons/PlasmicIcon__Icon94"; // plasmic-import: rJ3m87VuqZP7/icon
import Icon93Icon from "./icons/PlasmicIcon__Icon93"; // plasmic-import: VguYknml6de0/icon
import IconIcon from "./icons/PlasmicIcon__Icon"; // plasmic-import: kE4-BqL_BWFR/icon
import Icon96Icon from "./icons/PlasmicIcon__Icon96"; // plasmic-import: xi9uum6Ew9BB/icon
import Icon95Icon from "./icons/PlasmicIcon__Icon95"; // plasmic-import: 63bJ0LQvlKU1/icon
import Icon99Icon from "./icons/PlasmicIcon__Icon99"; // plasmic-import: lheCXa09NEEk/icon
import Icon98Icon from "./icons/PlasmicIcon__Icon98"; // plasmic-import: hPeZTIcs3pas/icon
import Icon97Icon from "./icons/PlasmicIcon__Icon97"; // plasmic-import: QyF55fz7HGtJ/icon
import Icon100Icon from "./icons/PlasmicIcon__Icon100"; // plasmic-import: Vo1A93Umywxk/icon
import Icon5Icon from "./icons/PlasmicIcon__Icon5"; // plasmic-import: z8Bk5fXmTx-P/icon

createPlasmicElementProxy;

export type PlasmicCapabilitiesCards__VariantMembers = {};
export type PlasmicCapabilitiesCards__VariantsArgs = {};
type VariantPropType = keyof PlasmicCapabilitiesCards__VariantsArgs;
export const PlasmicCapabilitiesCards__VariantProps =
  new Array<VariantPropType>();

export type PlasmicCapabilitiesCards__ArgsType = {};
type ArgPropType = keyof PlasmicCapabilitiesCards__ArgsType;
export const PlasmicCapabilitiesCards__ArgProps = new Array<ArgPropType>();

export type PlasmicCapabilitiesCards__OverridesType = {
  myEvaluations?: Flex__<"section">;
  desktop?: Flex__<"div">;
  key2?: Flex__<"div">;
  list?: Flex__<"div">;
  row2?: Flex__<"div">;
  narrowCard?: Flex__<"div">;
  header?: Flex__<"div">;
  title196?: Flex__<"div">;
  content?: Flex__<"div">;
  desc?: Flex__<"div">;
  placeholder?: Flex__<"div">;
  header13?: Flex__<"div">;
  list16?: Flex__<"div">;
  item193?: Flex__<"div">;
  left193?: Flex__<"div">;
  icon193?: Flex__<"div">;
  title197?: Flex__<"div">;
  item194?: Flex__<"div">;
  left194?: Flex__<"div">;
  icon194?: Flex__<"div">;
  title198?: Flex__<"div">;
  item195?: Flex__<"div">;
  left195?: Flex__<"div">;
  icon195?: Flex__<"div">;
  title199?: Flex__<"div">;
  item196?: Flex__<"div">;
  left196?: Flex__<"div">;
  icon196?: Flex__<"div">;
  title200?: Flex__<"div">;
  item197?: Flex__<"div">;
  left197?: Flex__<"div">;
  icon197?: Flex__<"div">;
  title201?: Flex__<"div">;
  item198?: Flex__<"div">;
  left198?: Flex__<"div">;
  icon198?: Flex__<"div">;
  title202?: Flex__<"div">;
  item199?: Flex__<"div">;
  left199?: Flex__<"div">;
  icon199?: Flex__<"div">;
  title203?: Flex__<"div">;
  item200?: Flex__<"div">;
  left200?: Flex__<"div">;
  icon200?: Flex__<"div">;
  title204?: Flex__<"div">;
  item201?: Flex__<"div">;
  left201?: Flex__<"div">;
  icon201?: Flex__<"div">;
  title205?: Flex__<"div">;
  item202?: Flex__<"div">;
  left202?: Flex__<"div">;
  icon202?: Flex__<"div">;
  title206?: Flex__<"div">;
  item203?: Flex__<"div">;
  left203?: Flex__<"div">;
  icon203?: Flex__<"div">;
  title207?: Flex__<"div">;
  item204?: Flex__<"div">;
  left204?: Flex__<"div">;
  icon204?: Flex__<"div">;
  title208?: Flex__<"div">;
  item205?: Flex__<"div">;
  left205?: Flex__<"div">;
  icon205?: Flex__<"div">;
  title209?: Flex__<"div">;
  item206?: Flex__<"div">;
  left206?: Flex__<"div">;
  icon206?: Flex__<"div">;
  title210?: Flex__<"div">;
  item207?: Flex__<"div">;
  left207?: Flex__<"div">;
  icon207?: Flex__<"div">;
  title211?: Flex__<"div">;
  item208?: Flex__<"div">;
  left208?: Flex__<"div">;
  icon208?: Flex__<"div">;
  title212?: Flex__<"div">;
  item209?: Flex__<"div">;
  left209?: Flex__<"div">;
  icon209?: Flex__<"div">;
  title213?: Flex__<"div">;
  item210?: Flex__<"div">;
  left210?: Flex__<"div">;
  icon210?: Flex__<"div">;
  title214?: Flex__<"div">;
  item211?: Flex__<"div">;
  left211?: Flex__<"div">;
  icon211?: Flex__<"div">;
  title215?: Flex__<"div">;
  item212?: Flex__<"div">;
  left212?: Flex__<"div">;
  icon212?: Flex__<"div">;
  title216?: Flex__<"div">;
  item213?: Flex__<"div">;
  left213?: Flex__<"div">;
  icon213?: Flex__<"div">;
  title217?: Flex__<"div">;
  item214?: Flex__<"div">;
  left214?: Flex__<"div">;
  icon214?: Flex__<"div">;
  title218?: Flex__<"div">;
  item215?: Flex__<"div">;
  left215?: Flex__<"div">;
  icon215?: Flex__<"div">;
  title219?: Flex__<"div">;
  item216?: Flex__<"div">;
  left216?: Flex__<"div">;
  icon216?: Flex__<"div">;
  title220?: Flex__<"div">;
  btn?: Flex__<typeof Button>;
  figmaPaste?: Flex__<"div">;
  narrowCard3?: Flex__<"div">;
  header14?: Flex__<"div">;
  title221?: Flex__<"div">;
  content3?: Flex__<"div">;
  desc3?: Flex__<"div">;
  placeholder3?: Flex__<"div">;
  header15?: Flex__<"div">;
  list17?: Flex__<"div">;
  item217?: Flex__<"div">;
  left217?: Flex__<"div">;
  icon217?: Flex__<"div">;
  title222?: Flex__<"div">;
  item218?: Flex__<"div">;
  left218?: Flex__<"div">;
  icon218?: Flex__<"div">;
  title223?: Flex__<"div">;
  item219?: Flex__<"div">;
  left219?: Flex__<"div">;
  icon219?: Flex__<"div">;
  title224?: Flex__<"div">;
  item220?: Flex__<"div">;
  left220?: Flex__<"div">;
  icon220?: Flex__<"div">;
  title225?: Flex__<"div">;
  item221?: Flex__<"div">;
  left221?: Flex__<"div">;
  icon221?: Flex__<"div">;
  title226?: Flex__<"div">;
  item222?: Flex__<"div">;
  left222?: Flex__<"div">;
  icon222?: Flex__<"div">;
  title227?: Flex__<"div">;
  item223?: Flex__<"div">;
  left223?: Flex__<"div">;
  icon223?: Flex__<"div">;
  title228?: Flex__<"div">;
  item224?: Flex__<"div">;
  left224?: Flex__<"div">;
  icon224?: Flex__<"div">;
  title229?: Flex__<"div">;
  item225?: Flex__<"div">;
  left225?: Flex__<"div">;
  icon225?: Flex__<"div">;
  title230?: Flex__<"div">;
  item226?: Flex__<"div">;
  left226?: Flex__<"div">;
  icon226?: Flex__<"div">;
  title231?: Flex__<"div">;
  item227?: Flex__<"div">;
  left227?: Flex__<"div">;
  icon227?: Flex__<"div">;
  title232?: Flex__<"div">;
  item228?: Flex__<"div">;
  left228?: Flex__<"div">;
  icon228?: Flex__<"div">;
  title233?: Flex__<"div">;
  item229?: Flex__<"div">;
  left229?: Flex__<"div">;
  icon229?: Flex__<"div">;
  title234?: Flex__<"div">;
  item230?: Flex__<"div">;
  left230?: Flex__<"div">;
  icon230?: Flex__<"div">;
  title235?: Flex__<"div">;
  item231?: Flex__<"div">;
  left231?: Flex__<"div">;
  icon231?: Flex__<"div">;
  title236?: Flex__<"div">;
  item232?: Flex__<"div">;
  left232?: Flex__<"div">;
  icon232?: Flex__<"div">;
  title237?: Flex__<"div">;
  item233?: Flex__<"div">;
  left233?: Flex__<"div">;
  icon233?: Flex__<"div">;
  title238?: Flex__<"div">;
  item234?: Flex__<"div">;
  left234?: Flex__<"div">;
  icon234?: Flex__<"div">;
  title239?: Flex__<"div">;
  item235?: Flex__<"div">;
  left235?: Flex__<"div">;
  icon235?: Flex__<"div">;
  title240?: Flex__<"div">;
  item236?: Flex__<"div">;
  left236?: Flex__<"div">;
  icon236?: Flex__<"div">;
  title241?: Flex__<"div">;
  item237?: Flex__<"div">;
  left237?: Flex__<"div">;
  icon237?: Flex__<"div">;
  title242?: Flex__<"div">;
  item238?: Flex__<"div">;
  left238?: Flex__<"div">;
  icon238?: Flex__<"div">;
  title243?: Flex__<"div">;
  item239?: Flex__<"div">;
  left239?: Flex__<"div">;
  icon239?: Flex__<"div">;
  title244?: Flex__<"div">;
  item240?: Flex__<"div">;
  left240?: Flex__<"div">;
  icon240?: Flex__<"div">;
  title245?: Flex__<"div">;
  btn3?: Flex__<typeof Button>;
  narrowCard2?: Flex__<"div">;
  header16?: Flex__<"div">;
  title246?: Flex__<"div">;
  content2?: Flex__<"div">;
  desc2?: Flex__<"div">;
  placeholder2?: Flex__<"div">;
  header17?: Flex__<"div">;
  list18?: Flex__<"div">;
  item241?: Flex__<"div">;
  left241?: Flex__<"div">;
  icon241?: Flex__<"div">;
  title247?: Flex__<"div">;
  item242?: Flex__<"div">;
  left242?: Flex__<"div">;
  icon242?: Flex__<"div">;
  title248?: Flex__<"div">;
  item243?: Flex__<"div">;
  left243?: Flex__<"div">;
  icon243?: Flex__<"div">;
  title249?: Flex__<"div">;
  item244?: Flex__<"div">;
  left244?: Flex__<"div">;
  icon244?: Flex__<"div">;
  title250?: Flex__<"div">;
  item245?: Flex__<"div">;
  left245?: Flex__<"div">;
  icon245?: Flex__<"div">;
  title251?: Flex__<"div">;
  item246?: Flex__<"div">;
  left246?: Flex__<"div">;
  icon246?: Flex__<"div">;
  title252?: Flex__<"div">;
  item247?: Flex__<"div">;
  left247?: Flex__<"div">;
  icon247?: Flex__<"div">;
  title253?: Flex__<"div">;
  item248?: Flex__<"div">;
  left248?: Flex__<"div">;
  icon248?: Flex__<"div">;
  title254?: Flex__<"div">;
  item249?: Flex__<"div">;
  left249?: Flex__<"div">;
  icon249?: Flex__<"div">;
  title255?: Flex__<"div">;
  item250?: Flex__<"div">;
  left250?: Flex__<"div">;
  icon250?: Flex__<"div">;
  title256?: Flex__<"div">;
  item251?: Flex__<"div">;
  left251?: Flex__<"div">;
  icon251?: Flex__<"div">;
  title257?: Flex__<"div">;
  item252?: Flex__<"div">;
  left252?: Flex__<"div">;
  icon252?: Flex__<"div">;
  title258?: Flex__<"div">;
  item253?: Flex__<"div">;
  left253?: Flex__<"div">;
  icon253?: Flex__<"div">;
  title259?: Flex__<"div">;
  item254?: Flex__<"div">;
  left254?: Flex__<"div">;
  icon254?: Flex__<"div">;
  title260?: Flex__<"div">;
  item255?: Flex__<"div">;
  left255?: Flex__<"div">;
  icon255?: Flex__<"div">;
  title261?: Flex__<"div">;
  item256?: Flex__<"div">;
  left256?: Flex__<"div">;
  icon256?: Flex__<"div">;
  title262?: Flex__<"div">;
  item257?: Flex__<"div">;
  left257?: Flex__<"div">;
  icon257?: Flex__<"div">;
  title263?: Flex__<"div">;
  item258?: Flex__<"div">;
  left258?: Flex__<"div">;
  icon258?: Flex__<"div">;
  title264?: Flex__<"div">;
  item259?: Flex__<"div">;
  left259?: Flex__<"div">;
  icon259?: Flex__<"div">;
  title265?: Flex__<"div">;
  item260?: Flex__<"div">;
  left260?: Flex__<"div">;
  icon260?: Flex__<"div">;
  title266?: Flex__<"div">;
  item261?: Flex__<"div">;
  left261?: Flex__<"div">;
  icon261?: Flex__<"div">;
  title267?: Flex__<"div">;
  item262?: Flex__<"div">;
  left262?: Flex__<"div">;
  icon262?: Flex__<"div">;
  title268?: Flex__<"div">;
  item263?: Flex__<"div">;
  left263?: Flex__<"div">;
  icon263?: Flex__<"div">;
  title269?: Flex__<"div">;
  item264?: Flex__<"div">;
  left264?: Flex__<"div">;
  icon264?: Flex__<"div">;
  title270?: Flex__<"div">;
  btn2?: Flex__<typeof Button>;
  row3?: Flex__<"div">;
  figmaPaste2?: Flex__<"div">;
  narrowCard4?: Flex__<"div">;
  header18?: Flex__<"div">;
  title271?: Flex__<"div">;
  content4?: Flex__<"div">;
  desc4?: Flex__<"div">;
  placeholder4?: Flex__<"div">;
  header19?: Flex__<"div">;
  list19?: Flex__<"div">;
  item265?: Flex__<"div">;
  left265?: Flex__<"div">;
  icon265?: Flex__<"div">;
  title272?: Flex__<"div">;
  item266?: Flex__<"div">;
  left266?: Flex__<"div">;
  icon266?: Flex__<"div">;
  title273?: Flex__<"div">;
  item267?: Flex__<"div">;
  left267?: Flex__<"div">;
  icon267?: Flex__<"div">;
  title274?: Flex__<"div">;
  item268?: Flex__<"div">;
  left268?: Flex__<"div">;
  icon268?: Flex__<"div">;
  title275?: Flex__<"div">;
  item269?: Flex__<"div">;
  left269?: Flex__<"div">;
  icon269?: Flex__<"div">;
  title276?: Flex__<"div">;
  item270?: Flex__<"div">;
  left270?: Flex__<"div">;
  icon270?: Flex__<"div">;
  title277?: Flex__<"div">;
  item271?: Flex__<"div">;
  left271?: Flex__<"div">;
  icon271?: Flex__<"div">;
  title278?: Flex__<"div">;
  item272?: Flex__<"div">;
  left272?: Flex__<"div">;
  icon272?: Flex__<"div">;
  title279?: Flex__<"div">;
  item273?: Flex__<"div">;
  left273?: Flex__<"div">;
  icon273?: Flex__<"div">;
  title280?: Flex__<"div">;
  item274?: Flex__<"div">;
  left274?: Flex__<"div">;
  icon274?: Flex__<"div">;
  title281?: Flex__<"div">;
  item275?: Flex__<"div">;
  left275?: Flex__<"div">;
  icon275?: Flex__<"div">;
  title282?: Flex__<"div">;
  item276?: Flex__<"div">;
  left276?: Flex__<"div">;
  icon276?: Flex__<"div">;
  title283?: Flex__<"div">;
  item277?: Flex__<"div">;
  left277?: Flex__<"div">;
  icon277?: Flex__<"div">;
  title284?: Flex__<"div">;
  item278?: Flex__<"div">;
  left278?: Flex__<"div">;
  icon278?: Flex__<"div">;
  title285?: Flex__<"div">;
  item279?: Flex__<"div">;
  left279?: Flex__<"div">;
  icon279?: Flex__<"div">;
  title286?: Flex__<"div">;
  item280?: Flex__<"div">;
  left280?: Flex__<"div">;
  icon280?: Flex__<"div">;
  title287?: Flex__<"div">;
  item281?: Flex__<"div">;
  left281?: Flex__<"div">;
  icon281?: Flex__<"div">;
  title288?: Flex__<"div">;
  item282?: Flex__<"div">;
  left282?: Flex__<"div">;
  icon282?: Flex__<"div">;
  title289?: Flex__<"div">;
  item283?: Flex__<"div">;
  left283?: Flex__<"div">;
  icon283?: Flex__<"div">;
  title290?: Flex__<"div">;
  item284?: Flex__<"div">;
  left284?: Flex__<"div">;
  icon284?: Flex__<"div">;
  title291?: Flex__<"div">;
  item285?: Flex__<"div">;
  left285?: Flex__<"div">;
  icon285?: Flex__<"div">;
  title292?: Flex__<"div">;
  item286?: Flex__<"div">;
  left286?: Flex__<"div">;
  icon286?: Flex__<"div">;
  title293?: Flex__<"div">;
  item287?: Flex__<"div">;
  left287?: Flex__<"div">;
  icon287?: Flex__<"div">;
  title294?: Flex__<"div">;
  item288?: Flex__<"div">;
  left288?: Flex__<"div">;
  icon288?: Flex__<"div">;
  title295?: Flex__<"div">;
  btn4?: Flex__<typeof Button>;
  narrowCard5?: Flex__<"div">;
  header20?: Flex__<"div">;
  title296?: Flex__<"div">;
  content5?: Flex__<"div">;
  desc5?: Flex__<"div">;
  placeholder5?: Flex__<"div">;
  header21?: Flex__<"div">;
  list20?: Flex__<"div">;
  item289?: Flex__<"div">;
  left289?: Flex__<"div">;
  icon289?: Flex__<"div">;
  title297?: Flex__<"div">;
  item290?: Flex__<"div">;
  left290?: Flex__<"div">;
  icon290?: Flex__<"div">;
  title298?: Flex__<"div">;
  item291?: Flex__<"div">;
  left291?: Flex__<"div">;
  icon291?: Flex__<"div">;
  title299?: Flex__<"div">;
  item292?: Flex__<"div">;
  left292?: Flex__<"div">;
  icon292?: Flex__<"div">;
  title300?: Flex__<"div">;
  item293?: Flex__<"div">;
  left293?: Flex__<"div">;
  icon293?: Flex__<"div">;
  title301?: Flex__<"div">;
  item294?: Flex__<"div">;
  left294?: Flex__<"div">;
  icon294?: Flex__<"div">;
  title302?: Flex__<"div">;
  item295?: Flex__<"div">;
  left295?: Flex__<"div">;
  icon295?: Flex__<"div">;
  title303?: Flex__<"div">;
  item296?: Flex__<"div">;
  left296?: Flex__<"div">;
  icon296?: Flex__<"div">;
  title304?: Flex__<"div">;
  item297?: Flex__<"div">;
  left297?: Flex__<"div">;
  icon297?: Flex__<"div">;
  title305?: Flex__<"div">;
  item298?: Flex__<"div">;
  left298?: Flex__<"div">;
  icon298?: Flex__<"div">;
  title306?: Flex__<"div">;
  item299?: Flex__<"div">;
  left299?: Flex__<"div">;
  icon299?: Flex__<"div">;
  title307?: Flex__<"div">;
  item300?: Flex__<"div">;
  left300?: Flex__<"div">;
  icon300?: Flex__<"div">;
  title308?: Flex__<"div">;
  item301?: Flex__<"div">;
  left301?: Flex__<"div">;
  icon301?: Flex__<"div">;
  title309?: Flex__<"div">;
  item302?: Flex__<"div">;
  left302?: Flex__<"div">;
  icon302?: Flex__<"div">;
  title310?: Flex__<"div">;
  item303?: Flex__<"div">;
  left303?: Flex__<"div">;
  icon303?: Flex__<"div">;
  title311?: Flex__<"div">;
  item304?: Flex__<"div">;
  left304?: Flex__<"div">;
  icon304?: Flex__<"div">;
  title312?: Flex__<"div">;
  item305?: Flex__<"div">;
  left305?: Flex__<"div">;
  icon305?: Flex__<"div">;
  title313?: Flex__<"div">;
  item306?: Flex__<"div">;
  left306?: Flex__<"div">;
  icon306?: Flex__<"div">;
  title314?: Flex__<"div">;
  item307?: Flex__<"div">;
  left307?: Flex__<"div">;
  icon307?: Flex__<"div">;
  title315?: Flex__<"div">;
  item308?: Flex__<"div">;
  left308?: Flex__<"div">;
  icon308?: Flex__<"div">;
  title316?: Flex__<"div">;
  item309?: Flex__<"div">;
  left309?: Flex__<"div">;
  icon309?: Flex__<"div">;
  title317?: Flex__<"div">;
  item310?: Flex__<"div">;
  left310?: Flex__<"div">;
  icon310?: Flex__<"div">;
  title318?: Flex__<"div">;
  item311?: Flex__<"div">;
  left311?: Flex__<"div">;
  icon311?: Flex__<"div">;
  title319?: Flex__<"div">;
  item312?: Flex__<"div">;
  left312?: Flex__<"div">;
  icon312?: Flex__<"div">;
  title320?: Flex__<"div">;
  btn5?: Flex__<typeof Button>;
  narrowCard6?: Flex__<"div">;
  header22?: Flex__<"div">;
  title321?: Flex__<"div">;
  content6?: Flex__<"div">;
  desc6?: Flex__<"div">;
  placeholder6?: Flex__<"div">;
  header23?: Flex__<"div">;
  list21?: Flex__<"div">;
  item313?: Flex__<"div">;
  left313?: Flex__<"div">;
  icon313?: Flex__<"div">;
  title322?: Flex__<"div">;
  item314?: Flex__<"div">;
  left314?: Flex__<"div">;
  icon314?: Flex__<"div">;
  title323?: Flex__<"div">;
  item315?: Flex__<"div">;
  left315?: Flex__<"div">;
  icon315?: Flex__<"div">;
  title324?: Flex__<"div">;
  item316?: Flex__<"div">;
  left316?: Flex__<"div">;
  icon316?: Flex__<"div">;
  title325?: Flex__<"div">;
  item317?: Flex__<"div">;
  left317?: Flex__<"div">;
  icon317?: Flex__<"div">;
  title326?: Flex__<"div">;
  item318?: Flex__<"div">;
  left318?: Flex__<"div">;
  icon318?: Flex__<"div">;
  title327?: Flex__<"div">;
  item319?: Flex__<"div">;
  left319?: Flex__<"div">;
  icon319?: Flex__<"div">;
  title328?: Flex__<"div">;
  item320?: Flex__<"div">;
  left320?: Flex__<"div">;
  icon320?: Flex__<"div">;
  title329?: Flex__<"div">;
  item321?: Flex__<"div">;
  left321?: Flex__<"div">;
  icon321?: Flex__<"div">;
  title330?: Flex__<"div">;
  item322?: Flex__<"div">;
  left322?: Flex__<"div">;
  icon322?: Flex__<"div">;
  title331?: Flex__<"div">;
  item323?: Flex__<"div">;
  left323?: Flex__<"div">;
  icon323?: Flex__<"div">;
  title332?: Flex__<"div">;
  item324?: Flex__<"div">;
  left324?: Flex__<"div">;
  icon324?: Flex__<"div">;
  title333?: Flex__<"div">;
  item325?: Flex__<"div">;
  left325?: Flex__<"div">;
  icon325?: Flex__<"div">;
  title334?: Flex__<"div">;
  item326?: Flex__<"div">;
  left326?: Flex__<"div">;
  icon326?: Flex__<"div">;
  title335?: Flex__<"div">;
  item327?: Flex__<"div">;
  left327?: Flex__<"div">;
  icon327?: Flex__<"div">;
  title336?: Flex__<"div">;
  item328?: Flex__<"div">;
  left328?: Flex__<"div">;
  icon328?: Flex__<"div">;
  title337?: Flex__<"div">;
  item329?: Flex__<"div">;
  left329?: Flex__<"div">;
  icon329?: Flex__<"div">;
  title338?: Flex__<"div">;
  item330?: Flex__<"div">;
  left330?: Flex__<"div">;
  icon330?: Flex__<"div">;
  title339?: Flex__<"div">;
  item331?: Flex__<"div">;
  left331?: Flex__<"div">;
  icon331?: Flex__<"div">;
  title340?: Flex__<"div">;
  item332?: Flex__<"div">;
  left332?: Flex__<"div">;
  icon332?: Flex__<"div">;
  title341?: Flex__<"div">;
  item333?: Flex__<"div">;
  left333?: Flex__<"div">;
  icon333?: Flex__<"div">;
  title342?: Flex__<"div">;
  item334?: Flex__<"div">;
  left334?: Flex__<"div">;
  icon334?: Flex__<"div">;
  title343?: Flex__<"div">;
  item335?: Flex__<"div">;
  left335?: Flex__<"div">;
  icon335?: Flex__<"div">;
  title344?: Flex__<"div">;
  item336?: Flex__<"div">;
  left336?: Flex__<"div">;
  icon336?: Flex__<"div">;
  title345?: Flex__<"div">;
  btn6?: Flex__<typeof Button>;
  row4?: Flex__<"div">;
  figmaPaste3?: Flex__<"div">;
  narrowCard7?: Flex__<"div">;
  header24?: Flex__<"div">;
  title346?: Flex__<"div">;
  content7?: Flex__<"div">;
  desc7?: Flex__<"div">;
  placeholder7?: Flex__<"div">;
  header25?: Flex__<"div">;
  list22?: Flex__<"div">;
  item337?: Flex__<"div">;
  left337?: Flex__<"div">;
  icon337?: Flex__<"div">;
  title347?: Flex__<"div">;
  item338?: Flex__<"div">;
  left338?: Flex__<"div">;
  icon338?: Flex__<"div">;
  title348?: Flex__<"div">;
  item339?: Flex__<"div">;
  left339?: Flex__<"div">;
  icon339?: Flex__<"div">;
  title349?: Flex__<"div">;
  item340?: Flex__<"div">;
  left340?: Flex__<"div">;
  icon340?: Flex__<"div">;
  title350?: Flex__<"div">;
  item341?: Flex__<"div">;
  left341?: Flex__<"div">;
  icon341?: Flex__<"div">;
  title351?: Flex__<"div">;
  item342?: Flex__<"div">;
  left342?: Flex__<"div">;
  icon342?: Flex__<"div">;
  title352?: Flex__<"div">;
  item343?: Flex__<"div">;
  left343?: Flex__<"div">;
  icon343?: Flex__<"div">;
  title353?: Flex__<"div">;
  item344?: Flex__<"div">;
  left344?: Flex__<"div">;
  icon344?: Flex__<"div">;
  title354?: Flex__<"div">;
  item345?: Flex__<"div">;
  left345?: Flex__<"div">;
  icon345?: Flex__<"div">;
  title355?: Flex__<"div">;
  item346?: Flex__<"div">;
  left346?: Flex__<"div">;
  icon346?: Flex__<"div">;
  title356?: Flex__<"div">;
  item347?: Flex__<"div">;
  left347?: Flex__<"div">;
  icon347?: Flex__<"div">;
  title357?: Flex__<"div">;
  item348?: Flex__<"div">;
  left348?: Flex__<"div">;
  icon348?: Flex__<"div">;
  title358?: Flex__<"div">;
  item349?: Flex__<"div">;
  left349?: Flex__<"div">;
  icon349?: Flex__<"div">;
  title359?: Flex__<"div">;
  item350?: Flex__<"div">;
  left350?: Flex__<"div">;
  icon350?: Flex__<"div">;
  title360?: Flex__<"div">;
  item351?: Flex__<"div">;
  left351?: Flex__<"div">;
  icon351?: Flex__<"div">;
  title361?: Flex__<"div">;
  item352?: Flex__<"div">;
  left352?: Flex__<"div">;
  icon352?: Flex__<"div">;
  title362?: Flex__<"div">;
  item353?: Flex__<"div">;
  left353?: Flex__<"div">;
  icon353?: Flex__<"div">;
  title363?: Flex__<"div">;
  item354?: Flex__<"div">;
  left354?: Flex__<"div">;
  icon354?: Flex__<"div">;
  title364?: Flex__<"div">;
  item355?: Flex__<"div">;
  left355?: Flex__<"div">;
  icon355?: Flex__<"div">;
  title365?: Flex__<"div">;
  item356?: Flex__<"div">;
  left356?: Flex__<"div">;
  icon356?: Flex__<"div">;
  title366?: Flex__<"div">;
  item357?: Flex__<"div">;
  left357?: Flex__<"div">;
  icon357?: Flex__<"div">;
  title367?: Flex__<"div">;
  item358?: Flex__<"div">;
  left358?: Flex__<"div">;
  icon358?: Flex__<"div">;
  title368?: Flex__<"div">;
  item359?: Flex__<"div">;
  left359?: Flex__<"div">;
  icon359?: Flex__<"div">;
  title369?: Flex__<"div">;
  item360?: Flex__<"div">;
  left360?: Flex__<"div">;
  icon360?: Flex__<"div">;
  title370?: Flex__<"div">;
  btn7?: Flex__<typeof Button>;
  narrowCard8?: Flex__<"div">;
  header26?: Flex__<"div">;
  title371?: Flex__<"div">;
  content8?: Flex__<"div">;
  desc8?: Flex__<"div">;
  placeholder8?: Flex__<"div">;
  header27?: Flex__<"div">;
  list23?: Flex__<"div">;
  item361?: Flex__<"div">;
  left361?: Flex__<"div">;
  icon361?: Flex__<"div">;
  title372?: Flex__<"div">;
  item362?: Flex__<"div">;
  left362?: Flex__<"div">;
  icon362?: Flex__<"div">;
  title373?: Flex__<"div">;
  item363?: Flex__<"div">;
  left363?: Flex__<"div">;
  icon363?: Flex__<"div">;
  title374?: Flex__<"div">;
  item364?: Flex__<"div">;
  left364?: Flex__<"div">;
  icon364?: Flex__<"div">;
  title375?: Flex__<"div">;
  item365?: Flex__<"div">;
  left365?: Flex__<"div">;
  icon365?: Flex__<"div">;
  title376?: Flex__<"div">;
  item366?: Flex__<"div">;
  left366?: Flex__<"div">;
  icon366?: Flex__<"div">;
  title377?: Flex__<"div">;
  item367?: Flex__<"div">;
  left367?: Flex__<"div">;
  icon367?: Flex__<"div">;
  title378?: Flex__<"div">;
  item368?: Flex__<"div">;
  left368?: Flex__<"div">;
  icon368?: Flex__<"div">;
  title379?: Flex__<"div">;
  item369?: Flex__<"div">;
  left369?: Flex__<"div">;
  icon369?: Flex__<"div">;
  title380?: Flex__<"div">;
  item370?: Flex__<"div">;
  left370?: Flex__<"div">;
  icon370?: Flex__<"div">;
  title381?: Flex__<"div">;
  item371?: Flex__<"div">;
  left371?: Flex__<"div">;
  icon371?: Flex__<"div">;
  title382?: Flex__<"div">;
  item372?: Flex__<"div">;
  left372?: Flex__<"div">;
  icon372?: Flex__<"div">;
  title383?: Flex__<"div">;
  item373?: Flex__<"div">;
  left373?: Flex__<"div">;
  icon373?: Flex__<"div">;
  title384?: Flex__<"div">;
  item374?: Flex__<"div">;
  left374?: Flex__<"div">;
  icon374?: Flex__<"div">;
  title385?: Flex__<"div">;
  item375?: Flex__<"div">;
  left375?: Flex__<"div">;
  icon375?: Flex__<"div">;
  title386?: Flex__<"div">;
  item376?: Flex__<"div">;
  left376?: Flex__<"div">;
  icon376?: Flex__<"div">;
  title387?: Flex__<"div">;
  item377?: Flex__<"div">;
  left377?: Flex__<"div">;
  icon377?: Flex__<"div">;
  title388?: Flex__<"div">;
  item378?: Flex__<"div">;
  left378?: Flex__<"div">;
  icon378?: Flex__<"div">;
  title389?: Flex__<"div">;
  item379?: Flex__<"div">;
  left379?: Flex__<"div">;
  icon379?: Flex__<"div">;
  title390?: Flex__<"div">;
  item380?: Flex__<"div">;
  left380?: Flex__<"div">;
  icon380?: Flex__<"div">;
  title391?: Flex__<"div">;
  item381?: Flex__<"div">;
  left381?: Flex__<"div">;
  icon381?: Flex__<"div">;
  title392?: Flex__<"div">;
  item382?: Flex__<"div">;
  left382?: Flex__<"div">;
  icon382?: Flex__<"div">;
  title393?: Flex__<"div">;
  item383?: Flex__<"div">;
  left383?: Flex__<"div">;
  icon383?: Flex__<"div">;
  title394?: Flex__<"div">;
  item384?: Flex__<"div">;
  left384?: Flex__<"div">;
  icon384?: Flex__<"div">;
  title395?: Flex__<"div">;
  btn8?: Flex__<typeof Button>;
  tablet?: Flex__<"div">;
  row6?: Flex__<"div">;
  featuresProductHeader?: Flex__<typeof FeaturesProductHeader>;
  key4?: Flex__<"div">;
  header4?: Flex__<"header">;
  list11?: Flex__<"div">;
  row7?: Flex__<"div">;
  figmaPaste5?: Flex__<"div">;
  narrowCard17?: Flex__<"div">;
  header9?: Flex__<"div">;
  title100?: Flex__<"div">;
  content17?: Flex__<"div">;
  desc17?: Flex__<"div">;
  placeholder17?: Flex__<"div">;
  header10?: Flex__<"div">;
  list7?: Flex__<"div">;
  item97?: Flex__<"div">;
  left97?: Flex__<"div">;
  icon97?: Flex__<"div">;
  title2?: Flex__<"div">;
  item98?: Flex__<"div">;
  left98?: Flex__<"div">;
  icon98?: Flex__<"div">;
  title101?: Flex__<"div">;
  item99?: Flex__<"div">;
  left99?: Flex__<"div">;
  icon99?: Flex__<"div">;
  title102?: Flex__<"div">;
  item100?: Flex__<"div">;
  left100?: Flex__<"div">;
  icon100?: Flex__<"div">;
  title103?: Flex__<"div">;
  item101?: Flex__<"div">;
  left101?: Flex__<"div">;
  icon101?: Flex__<"div">;
  title104?: Flex__<"div">;
  item102?: Flex__<"div">;
  left102?: Flex__<"div">;
  icon102?: Flex__<"div">;
  title105?: Flex__<"div">;
  item103?: Flex__<"div">;
  left103?: Flex__<"div">;
  icon103?: Flex__<"div">;
  title106?: Flex__<"div">;
  item104?: Flex__<"div">;
  left104?: Flex__<"div">;
  icon104?: Flex__<"div">;
  title107?: Flex__<"div">;
  item105?: Flex__<"div">;
  left105?: Flex__<"div">;
  icon105?: Flex__<"div">;
  title108?: Flex__<"div">;
  item106?: Flex__<"div">;
  left106?: Flex__<"div">;
  icon106?: Flex__<"div">;
  title109?: Flex__<"div">;
  item107?: Flex__<"div">;
  left107?: Flex__<"div">;
  icon107?: Flex__<"div">;
  title110?: Flex__<"div">;
  item108?: Flex__<"div">;
  left108?: Flex__<"div">;
  icon108?: Flex__<"div">;
  title111?: Flex__<"div">;
  item109?: Flex__<"div">;
  left109?: Flex__<"div">;
  icon109?: Flex__<"div">;
  title112?: Flex__<"div">;
  item110?: Flex__<"div">;
  left110?: Flex__<"div">;
  icon110?: Flex__<"div">;
  title113?: Flex__<"div">;
  item111?: Flex__<"div">;
  left111?: Flex__<"div">;
  icon111?: Flex__<"div">;
  title114?: Flex__<"div">;
  item112?: Flex__<"div">;
  left112?: Flex__<"div">;
  icon112?: Flex__<"div">;
  title115?: Flex__<"div">;
  item113?: Flex__<"div">;
  left113?: Flex__<"div">;
  icon113?: Flex__<"div">;
  title116?: Flex__<"div">;
  item114?: Flex__<"div">;
  left114?: Flex__<"div">;
  icon114?: Flex__<"div">;
  title117?: Flex__<"div">;
  item115?: Flex__<"div">;
  left115?: Flex__<"div">;
  icon115?: Flex__<"div">;
  title118?: Flex__<"div">;
  item116?: Flex__<"div">;
  left116?: Flex__<"div">;
  icon116?: Flex__<"div">;
  title119?: Flex__<"div">;
  item117?: Flex__<"div">;
  left117?: Flex__<"div">;
  icon117?: Flex__<"div">;
  title120?: Flex__<"div">;
  item118?: Flex__<"div">;
  left118?: Flex__<"div">;
  icon118?: Flex__<"div">;
  title121?: Flex__<"div">;
  item119?: Flex__<"div">;
  left119?: Flex__<"div">;
  icon119?: Flex__<"div">;
  title122?: Flex__<"div">;
  item120?: Flex__<"div">;
  left120?: Flex__<"div">;
  icon120?: Flex__<"div">;
  title123?: Flex__<"div">;
  btn17?: Flex__<typeof Button>;
  narrowCard18?: Flex__<"div">;
  header11?: Flex__<"div">;
  title124?: Flex__<"div">;
  content18?: Flex__<"div">;
  desc18?: Flex__<"div">;
  placeholder18?: Flex__<"div">;
  header12?: Flex__<"div">;
  list8?: Flex__<"div">;
  item121?: Flex__<"div">;
  left121?: Flex__<"div">;
  icon121?: Flex__<"div">;
  title125?: Flex__<"div">;
  item122?: Flex__<"div">;
  left122?: Flex__<"div">;
  icon122?: Flex__<"div">;
  title126?: Flex__<"div">;
  item123?: Flex__<"div">;
  left123?: Flex__<"div">;
  icon123?: Flex__<"div">;
  title127?: Flex__<"div">;
  item124?: Flex__<"div">;
  left124?: Flex__<"div">;
  icon124?: Flex__<"div">;
  title128?: Flex__<"div">;
  item125?: Flex__<"div">;
  left125?: Flex__<"div">;
  icon125?: Flex__<"div">;
  title129?: Flex__<"div">;
  item126?: Flex__<"div">;
  left126?: Flex__<"div">;
  icon126?: Flex__<"div">;
  title130?: Flex__<"div">;
  item127?: Flex__<"div">;
  left127?: Flex__<"div">;
  icon127?: Flex__<"div">;
  title131?: Flex__<"div">;
  item128?: Flex__<"div">;
  left128?: Flex__<"div">;
  icon128?: Flex__<"div">;
  title132?: Flex__<"div">;
  item129?: Flex__<"div">;
  left129?: Flex__<"div">;
  icon129?: Flex__<"div">;
  title133?: Flex__<"div">;
  item130?: Flex__<"div">;
  left130?: Flex__<"div">;
  icon130?: Flex__<"div">;
  title134?: Flex__<"div">;
  item131?: Flex__<"div">;
  left131?: Flex__<"div">;
  icon131?: Flex__<"div">;
  title135?: Flex__<"div">;
  item132?: Flex__<"div">;
  left132?: Flex__<"div">;
  icon132?: Flex__<"div">;
  title136?: Flex__<"div">;
  item133?: Flex__<"div">;
  left133?: Flex__<"div">;
  icon133?: Flex__<"div">;
  title137?: Flex__<"div">;
  item134?: Flex__<"div">;
  left134?: Flex__<"div">;
  icon134?: Flex__<"div">;
  title138?: Flex__<"div">;
  item135?: Flex__<"div">;
  left135?: Flex__<"div">;
  icon135?: Flex__<"div">;
  title139?: Flex__<"div">;
  item136?: Flex__<"div">;
  left136?: Flex__<"div">;
  icon136?: Flex__<"div">;
  title140?: Flex__<"div">;
  item137?: Flex__<"div">;
  left137?: Flex__<"div">;
  icon137?: Flex__<"div">;
  title141?: Flex__<"div">;
  item138?: Flex__<"div">;
  left138?: Flex__<"div">;
  icon138?: Flex__<"div">;
  title142?: Flex__<"div">;
  item139?: Flex__<"div">;
  left139?: Flex__<"div">;
  icon139?: Flex__<"div">;
  title143?: Flex__<"div">;
  item140?: Flex__<"div">;
  left140?: Flex__<"div">;
  icon140?: Flex__<"div">;
  title144?: Flex__<"div">;
  item141?: Flex__<"div">;
  left141?: Flex__<"div">;
  icon141?: Flex__<"div">;
  title145?: Flex__<"div">;
  item142?: Flex__<"div">;
  left142?: Flex__<"div">;
  icon142?: Flex__<"div">;
  title146?: Flex__<"div">;
  item143?: Flex__<"div">;
  left143?: Flex__<"div">;
  icon143?: Flex__<"div">;
  title147?: Flex__<"div">;
  item144?: Flex__<"div">;
  left144?: Flex__<"div">;
  icon144?: Flex__<"div">;
  title148?: Flex__<"div">;
  btn18?: Flex__<typeof Button>;
  row8?: Flex__<"div">;
  figmaPaste6?: Flex__<"div">;
  narrowCard19?: Flex__<"div">;
  header40?: Flex__<"div">;
  title149?: Flex__<"div">;
  content19?: Flex__<"div">;
  desc19?: Flex__<"div">;
  placeholder19?: Flex__<"div">;
  header41?: Flex__<"div">;
  list9?: Flex__<"div">;
  item145?: Flex__<"div">;
  left145?: Flex__<"div">;
  icon145?: Flex__<"div">;
  title150?: Flex__<"div">;
  item146?: Flex__<"div">;
  left146?: Flex__<"div">;
  icon146?: Flex__<"div">;
  title151?: Flex__<"div">;
  item147?: Flex__<"div">;
  left147?: Flex__<"div">;
  icon147?: Flex__<"div">;
  title152?: Flex__<"div">;
  item148?: Flex__<"div">;
  left148?: Flex__<"div">;
  icon148?: Flex__<"div">;
  title153?: Flex__<"div">;
  item149?: Flex__<"div">;
  left149?: Flex__<"div">;
  icon149?: Flex__<"div">;
  title154?: Flex__<"div">;
  item150?: Flex__<"div">;
  left150?: Flex__<"div">;
  icon150?: Flex__<"div">;
  title155?: Flex__<"div">;
  item151?: Flex__<"div">;
  left151?: Flex__<"div">;
  icon151?: Flex__<"div">;
  title156?: Flex__<"div">;
  item152?: Flex__<"div">;
  left152?: Flex__<"div">;
  icon152?: Flex__<"div">;
  title157?: Flex__<"div">;
  item153?: Flex__<"div">;
  left153?: Flex__<"div">;
  icon153?: Flex__<"div">;
  title158?: Flex__<"div">;
  item154?: Flex__<"div">;
  left154?: Flex__<"div">;
  icon154?: Flex__<"div">;
  title159?: Flex__<"div">;
  item155?: Flex__<"div">;
  left155?: Flex__<"div">;
  icon155?: Flex__<"div">;
  title160?: Flex__<"div">;
  item156?: Flex__<"div">;
  left156?: Flex__<"div">;
  icon156?: Flex__<"div">;
  title161?: Flex__<"div">;
  item157?: Flex__<"div">;
  left157?: Flex__<"div">;
  icon157?: Flex__<"div">;
  title162?: Flex__<"div">;
  item158?: Flex__<"div">;
  left158?: Flex__<"div">;
  icon158?: Flex__<"div">;
  title163?: Flex__<"div">;
  item159?: Flex__<"div">;
  left159?: Flex__<"div">;
  icon159?: Flex__<"div">;
  title164?: Flex__<"div">;
  item160?: Flex__<"div">;
  left160?: Flex__<"div">;
  icon160?: Flex__<"div">;
  title165?: Flex__<"div">;
  item161?: Flex__<"div">;
  left161?: Flex__<"div">;
  icon161?: Flex__<"div">;
  title166?: Flex__<"div">;
  item162?: Flex__<"div">;
  left162?: Flex__<"div">;
  icon162?: Flex__<"div">;
  title167?: Flex__<"div">;
  item163?: Flex__<"div">;
  left163?: Flex__<"div">;
  icon163?: Flex__<"div">;
  title168?: Flex__<"div">;
  item164?: Flex__<"div">;
  left164?: Flex__<"div">;
  icon164?: Flex__<"div">;
  title169?: Flex__<"div">;
  item165?: Flex__<"div">;
  left165?: Flex__<"div">;
  icon165?: Flex__<"div">;
  title170?: Flex__<"div">;
  item166?: Flex__<"div">;
  left166?: Flex__<"div">;
  icon166?: Flex__<"div">;
  title171?: Flex__<"div">;
  item167?: Flex__<"div">;
  left167?: Flex__<"div">;
  icon167?: Flex__<"div">;
  title172?: Flex__<"div">;
  item168?: Flex__<"div">;
  left168?: Flex__<"div">;
  icon168?: Flex__<"div">;
  title173?: Flex__<"div">;
  btn19?: Flex__<typeof Button>;
  narrowCard20?: Flex__<"div">;
  header42?: Flex__<"div">;
  title174?: Flex__<"div">;
  content20?: Flex__<"div">;
  desc20?: Flex__<"div">;
  placeholder20?: Flex__<"div">;
  header43?: Flex__<"div">;
  list10?: Flex__<"div">;
  item169?: Flex__<"div">;
  left169?: Flex__<"div">;
  icon169?: Flex__<"div">;
  title175?: Flex__<"div">;
  item170?: Flex__<"div">;
  left170?: Flex__<"div">;
  icon170?: Flex__<"div">;
  title176?: Flex__<"div">;
  item171?: Flex__<"div">;
  left171?: Flex__<"div">;
  icon171?: Flex__<"div">;
  title177?: Flex__<"div">;
  item172?: Flex__<"div">;
  left172?: Flex__<"div">;
  icon172?: Flex__<"div">;
  title178?: Flex__<"div">;
  item173?: Flex__<"div">;
  left173?: Flex__<"div">;
  icon173?: Flex__<"div">;
  title179?: Flex__<"div">;
  item174?: Flex__<"div">;
  left174?: Flex__<"div">;
  icon174?: Flex__<"div">;
  title180?: Flex__<"div">;
  item175?: Flex__<"div">;
  left175?: Flex__<"div">;
  icon175?: Flex__<"div">;
  title181?: Flex__<"div">;
  item176?: Flex__<"div">;
  left176?: Flex__<"div">;
  icon176?: Flex__<"div">;
  title182?: Flex__<"div">;
  item177?: Flex__<"div">;
  left177?: Flex__<"div">;
  icon177?: Flex__<"div">;
  title183?: Flex__<"div">;
  item178?: Flex__<"div">;
  left178?: Flex__<"div">;
  icon178?: Flex__<"div">;
  title184?: Flex__<"div">;
  item179?: Flex__<"div">;
  left179?: Flex__<"div">;
  icon179?: Flex__<"div">;
  title185?: Flex__<"div">;
  item180?: Flex__<"div">;
  left180?: Flex__<"div">;
  icon180?: Flex__<"div">;
  title186?: Flex__<"div">;
  item181?: Flex__<"div">;
  left181?: Flex__<"div">;
  icon181?: Flex__<"div">;
  title187?: Flex__<"div">;
  item182?: Flex__<"div">;
  left182?: Flex__<"div">;
  icon182?: Flex__<"div">;
  title188?: Flex__<"div">;
  item183?: Flex__<"div">;
  left183?: Flex__<"div">;
  icon183?: Flex__<"div">;
  title189?: Flex__<"div">;
  item184?: Flex__<"div">;
  left184?: Flex__<"div">;
  icon184?: Flex__<"div">;
  title190?: Flex__<"div">;
  item185?: Flex__<"div">;
  left185?: Flex__<"div">;
  icon185?: Flex__<"div">;
  title191?: Flex__<"div">;
  item186?: Flex__<"div">;
  left186?: Flex__<"div">;
  icon186?: Flex__<"div">;
  title192?: Flex__<"div">;
  item187?: Flex__<"div">;
  left187?: Flex__<"div">;
  icon187?: Flex__<"div">;
  title193?: Flex__<"div">;
  item188?: Flex__<"div">;
  left188?: Flex__<"div">;
  icon188?: Flex__<"div">;
  title194?: Flex__<"div">;
  item189?: Flex__<"div">;
  left189?: Flex__<"div">;
  icon189?: Flex__<"div">;
  title195?: Flex__<"div">;
  item190?: Flex__<"div">;
  left190?: Flex__<"div">;
  icon190?: Flex__<"div">;
  title499?: Flex__<"div">;
  item191?: Flex__<"div">;
  left191?: Flex__<"div">;
  icon191?: Flex__<"div">;
  title500?: Flex__<"div">;
  item192?: Flex__<"div">;
  left192?: Flex__<"div">;
  icon192?: Flex__<"div">;
  title501?: Flex__<"div">;
  btn20?: Flex__<typeof Button>;
  narrowCard21?: Flex__<"div">;
  header44?: Flex__<"div">;
  title502?: Flex__<"div">;
  content21?: Flex__<"div">;
  desc21?: Flex__<"div">;
  placeholder21?: Flex__<"div">;
  header45?: Flex__<"div">;
  list28?: Flex__<"div">;
  item481?: Flex__<"div">;
  left481?: Flex__<"div">;
  icon481?: Flex__<"div">;
  title503?: Flex__<"div">;
  item482?: Flex__<"div">;
  left482?: Flex__<"div">;
  icon482?: Flex__<"div">;
  title504?: Flex__<"div">;
  item483?: Flex__<"div">;
  left483?: Flex__<"div">;
  icon483?: Flex__<"div">;
  title505?: Flex__<"div">;
  item484?: Flex__<"div">;
  left484?: Flex__<"div">;
  icon484?: Flex__<"div">;
  title506?: Flex__<"div">;
  item485?: Flex__<"div">;
  left485?: Flex__<"div">;
  icon485?: Flex__<"div">;
  title507?: Flex__<"div">;
  item486?: Flex__<"div">;
  left486?: Flex__<"div">;
  icon486?: Flex__<"div">;
  title508?: Flex__<"div">;
  item487?: Flex__<"div">;
  left487?: Flex__<"div">;
  icon487?: Flex__<"div">;
  title509?: Flex__<"div">;
  item488?: Flex__<"div">;
  left488?: Flex__<"div">;
  icon488?: Flex__<"div">;
  title510?: Flex__<"div">;
  item489?: Flex__<"div">;
  left489?: Flex__<"div">;
  icon489?: Flex__<"div">;
  title511?: Flex__<"div">;
  item490?: Flex__<"div">;
  left490?: Flex__<"div">;
  icon490?: Flex__<"div">;
  title512?: Flex__<"div">;
  item491?: Flex__<"div">;
  left491?: Flex__<"div">;
  icon491?: Flex__<"div">;
  title513?: Flex__<"div">;
  item492?: Flex__<"div">;
  left492?: Flex__<"div">;
  icon492?: Flex__<"div">;
  title514?: Flex__<"div">;
  item493?: Flex__<"div">;
  left493?: Flex__<"div">;
  icon493?: Flex__<"div">;
  title515?: Flex__<"div">;
  item494?: Flex__<"div">;
  left494?: Flex__<"div">;
  icon494?: Flex__<"div">;
  title516?: Flex__<"div">;
  item495?: Flex__<"div">;
  left495?: Flex__<"div">;
  icon495?: Flex__<"div">;
  title517?: Flex__<"div">;
  item496?: Flex__<"div">;
  left496?: Flex__<"div">;
  icon496?: Flex__<"div">;
  title518?: Flex__<"div">;
  item497?: Flex__<"div">;
  left497?: Flex__<"div">;
  icon497?: Flex__<"div">;
  title519?: Flex__<"div">;
  item498?: Flex__<"div">;
  left498?: Flex__<"div">;
  icon498?: Flex__<"div">;
  title520?: Flex__<"div">;
  item499?: Flex__<"div">;
  left499?: Flex__<"div">;
  icon499?: Flex__<"div">;
  title521?: Flex__<"div">;
  item500?: Flex__<"div">;
  left500?: Flex__<"div">;
  icon500?: Flex__<"div">;
  title522?: Flex__<"div">;
  item501?: Flex__<"div">;
  left501?: Flex__<"div">;
  icon501?: Flex__<"div">;
  title523?: Flex__<"div">;
  item502?: Flex__<"div">;
  left502?: Flex__<"div">;
  icon502?: Flex__<"div">;
  title524?: Flex__<"div">;
  item503?: Flex__<"div">;
  left503?: Flex__<"div">;
  icon503?: Flex__<"div">;
  title525?: Flex__<"div">;
  item504?: Flex__<"div">;
  left504?: Flex__<"div">;
  icon504?: Flex__<"div">;
  title526?: Flex__<"div">;
  btn21?: Flex__<typeof Button>;
  narrowCard22?: Flex__<"div">;
  header46?: Flex__<"div">;
  title527?: Flex__<"div">;
  content22?: Flex__<"div">;
  desc22?: Flex__<"div">;
  placeholder22?: Flex__<"div">;
  header47?: Flex__<"div">;
  list29?: Flex__<"div">;
  item505?: Flex__<"div">;
  left505?: Flex__<"div">;
  icon505?: Flex__<"div">;
  title528?: Flex__<"div">;
  item506?: Flex__<"div">;
  left506?: Flex__<"div">;
  icon506?: Flex__<"div">;
  title529?: Flex__<"div">;
  item507?: Flex__<"div">;
  left507?: Flex__<"div">;
  icon507?: Flex__<"div">;
  title530?: Flex__<"div">;
  item508?: Flex__<"div">;
  left508?: Flex__<"div">;
  icon508?: Flex__<"div">;
  title531?: Flex__<"div">;
  item509?: Flex__<"div">;
  left509?: Flex__<"div">;
  icon509?: Flex__<"div">;
  title532?: Flex__<"div">;
  item510?: Flex__<"div">;
  left510?: Flex__<"div">;
  icon510?: Flex__<"div">;
  title533?: Flex__<"div">;
  item511?: Flex__<"div">;
  left511?: Flex__<"div">;
  icon511?: Flex__<"div">;
  title534?: Flex__<"div">;
  item512?: Flex__<"div">;
  left512?: Flex__<"div">;
  icon512?: Flex__<"div">;
  title535?: Flex__<"div">;
  item513?: Flex__<"div">;
  left513?: Flex__<"div">;
  icon513?: Flex__<"div">;
  title536?: Flex__<"div">;
  item514?: Flex__<"div">;
  left514?: Flex__<"div">;
  icon514?: Flex__<"div">;
  title537?: Flex__<"div">;
  item515?: Flex__<"div">;
  left515?: Flex__<"div">;
  icon515?: Flex__<"div">;
  title538?: Flex__<"div">;
  item516?: Flex__<"div">;
  left516?: Flex__<"div">;
  icon516?: Flex__<"div">;
  title539?: Flex__<"div">;
  item517?: Flex__<"div">;
  left517?: Flex__<"div">;
  icon517?: Flex__<"div">;
  title540?: Flex__<"div">;
  item518?: Flex__<"div">;
  left518?: Flex__<"div">;
  icon518?: Flex__<"div">;
  title541?: Flex__<"div">;
  item519?: Flex__<"div">;
  left519?: Flex__<"div">;
  icon519?: Flex__<"div">;
  title542?: Flex__<"div">;
  item520?: Flex__<"div">;
  left520?: Flex__<"div">;
  icon520?: Flex__<"div">;
  title543?: Flex__<"div">;
  item521?: Flex__<"div">;
  left521?: Flex__<"div">;
  icon521?: Flex__<"div">;
  title544?: Flex__<"div">;
  item522?: Flex__<"div">;
  left522?: Flex__<"div">;
  icon522?: Flex__<"div">;
  title545?: Flex__<"div">;
  item523?: Flex__<"div">;
  left523?: Flex__<"div">;
  icon523?: Flex__<"div">;
  title546?: Flex__<"div">;
  item524?: Flex__<"div">;
  left524?: Flex__<"div">;
  icon524?: Flex__<"div">;
  title547?: Flex__<"div">;
  item525?: Flex__<"div">;
  left525?: Flex__<"div">;
  icon525?: Flex__<"div">;
  title548?: Flex__<"div">;
  item526?: Flex__<"div">;
  left526?: Flex__<"div">;
  icon526?: Flex__<"div">;
  title549?: Flex__<"div">;
  item527?: Flex__<"div">;
  left527?: Flex__<"div">;
  icon527?: Flex__<"div">;
  title550?: Flex__<"div">;
  item528?: Flex__<"div">;
  left528?: Flex__<"div">;
  icon528?: Flex__<"div">;
  title551?: Flex__<"div">;
  btn22?: Flex__<typeof Button>;
  row9?: Flex__<"div">;
  figmaPaste7?: Flex__<"div">;
  narrowCard23?: Flex__<"div">;
  header48?: Flex__<"div">;
  title552?: Flex__<"div">;
  content23?: Flex__<"div">;
  desc23?: Flex__<"div">;
  placeholder23?: Flex__<"div">;
  header49?: Flex__<"div">;
  list30?: Flex__<"div">;
  item529?: Flex__<"div">;
  left529?: Flex__<"div">;
  icon529?: Flex__<"div">;
  title553?: Flex__<"div">;
  item530?: Flex__<"div">;
  left530?: Flex__<"div">;
  icon530?: Flex__<"div">;
  title554?: Flex__<"div">;
  item531?: Flex__<"div">;
  left531?: Flex__<"div">;
  icon531?: Flex__<"div">;
  title555?: Flex__<"div">;
  item532?: Flex__<"div">;
  left532?: Flex__<"div">;
  icon532?: Flex__<"div">;
  title556?: Flex__<"div">;
  item533?: Flex__<"div">;
  left533?: Flex__<"div">;
  icon533?: Flex__<"div">;
  title557?: Flex__<"div">;
  item534?: Flex__<"div">;
  left534?: Flex__<"div">;
  icon534?: Flex__<"div">;
  title558?: Flex__<"div">;
  item535?: Flex__<"div">;
  left535?: Flex__<"div">;
  icon535?: Flex__<"div">;
  title559?: Flex__<"div">;
  item536?: Flex__<"div">;
  left536?: Flex__<"div">;
  icon536?: Flex__<"div">;
  title560?: Flex__<"div">;
  item537?: Flex__<"div">;
  left537?: Flex__<"div">;
  icon537?: Flex__<"div">;
  title561?: Flex__<"div">;
  item538?: Flex__<"div">;
  left538?: Flex__<"div">;
  icon538?: Flex__<"div">;
  title562?: Flex__<"div">;
  item539?: Flex__<"div">;
  left539?: Flex__<"div">;
  icon539?: Flex__<"div">;
  title563?: Flex__<"div">;
  item540?: Flex__<"div">;
  left540?: Flex__<"div">;
  icon540?: Flex__<"div">;
  title564?: Flex__<"div">;
  item541?: Flex__<"div">;
  left541?: Flex__<"div">;
  icon541?: Flex__<"div">;
  title565?: Flex__<"div">;
  item542?: Flex__<"div">;
  left542?: Flex__<"div">;
  icon542?: Flex__<"div">;
  title566?: Flex__<"div">;
  item543?: Flex__<"div">;
  left543?: Flex__<"div">;
  icon543?: Flex__<"div">;
  title567?: Flex__<"div">;
  item544?: Flex__<"div">;
  left544?: Flex__<"div">;
  icon544?: Flex__<"div">;
  title568?: Flex__<"div">;
  item545?: Flex__<"div">;
  left545?: Flex__<"div">;
  icon545?: Flex__<"div">;
  title569?: Flex__<"div">;
  item546?: Flex__<"div">;
  left546?: Flex__<"div">;
  icon546?: Flex__<"div">;
  title570?: Flex__<"div">;
  item547?: Flex__<"div">;
  left547?: Flex__<"div">;
  icon547?: Flex__<"div">;
  title571?: Flex__<"div">;
  item548?: Flex__<"div">;
  left548?: Flex__<"div">;
  icon548?: Flex__<"div">;
  title572?: Flex__<"div">;
  item549?: Flex__<"div">;
  left549?: Flex__<"div">;
  icon549?: Flex__<"div">;
  title573?: Flex__<"div">;
  item550?: Flex__<"div">;
  left550?: Flex__<"div">;
  icon550?: Flex__<"div">;
  title574?: Flex__<"div">;
  item551?: Flex__<"div">;
  left551?: Flex__<"div">;
  icon551?: Flex__<"div">;
  title575?: Flex__<"div">;
  item552?: Flex__<"div">;
  left552?: Flex__<"div">;
  icon552?: Flex__<"div">;
  title576?: Flex__<"div">;
  btn23?: Flex__<typeof Button>;
  narrowCard24?: Flex__<"div">;
  header50?: Flex__<"div">;
  title577?: Flex__<"div">;
  content24?: Flex__<"div">;
  desc24?: Flex__<"div">;
  placeholder24?: Flex__<"div">;
  header51?: Flex__<"div">;
  list31?: Flex__<"div">;
  item553?: Flex__<"div">;
  left553?: Flex__<"div">;
  icon553?: Flex__<"div">;
  title578?: Flex__<"div">;
  item554?: Flex__<"div">;
  left554?: Flex__<"div">;
  icon554?: Flex__<"div">;
  title579?: Flex__<"div">;
  item555?: Flex__<"div">;
  left555?: Flex__<"div">;
  icon555?: Flex__<"div">;
  title580?: Flex__<"div">;
  item556?: Flex__<"div">;
  left556?: Flex__<"div">;
  icon556?: Flex__<"div">;
  title581?: Flex__<"div">;
  item557?: Flex__<"div">;
  left557?: Flex__<"div">;
  icon557?: Flex__<"div">;
  title582?: Flex__<"div">;
  item558?: Flex__<"div">;
  left558?: Flex__<"div">;
  icon558?: Flex__<"div">;
  title583?: Flex__<"div">;
  item559?: Flex__<"div">;
  left559?: Flex__<"div">;
  icon559?: Flex__<"div">;
  title584?: Flex__<"div">;
  item560?: Flex__<"div">;
  left560?: Flex__<"div">;
  icon560?: Flex__<"div">;
  title585?: Flex__<"div">;
  item561?: Flex__<"div">;
  left561?: Flex__<"div">;
  icon561?: Flex__<"div">;
  title586?: Flex__<"div">;
  item562?: Flex__<"div">;
  left562?: Flex__<"div">;
  icon562?: Flex__<"div">;
  title587?: Flex__<"div">;
  item563?: Flex__<"div">;
  left563?: Flex__<"div">;
  icon563?: Flex__<"div">;
  title588?: Flex__<"div">;
  item564?: Flex__<"div">;
  left564?: Flex__<"div">;
  icon564?: Flex__<"div">;
  title589?: Flex__<"div">;
  item565?: Flex__<"div">;
  left565?: Flex__<"div">;
  icon565?: Flex__<"div">;
  title590?: Flex__<"div">;
  item566?: Flex__<"div">;
  left566?: Flex__<"div">;
  icon566?: Flex__<"div">;
  title591?: Flex__<"div">;
  item567?: Flex__<"div">;
  left567?: Flex__<"div">;
  icon567?: Flex__<"div">;
  title592?: Flex__<"div">;
  item568?: Flex__<"div">;
  left568?: Flex__<"div">;
  icon568?: Flex__<"div">;
  title593?: Flex__<"div">;
  item569?: Flex__<"div">;
  left569?: Flex__<"div">;
  icon569?: Flex__<"div">;
  title594?: Flex__<"div">;
  item570?: Flex__<"div">;
  left570?: Flex__<"div">;
  icon570?: Flex__<"div">;
  title595?: Flex__<"div">;
  item571?: Flex__<"div">;
  left571?: Flex__<"div">;
  icon571?: Flex__<"div">;
  title596?: Flex__<"div">;
  item572?: Flex__<"div">;
  left572?: Flex__<"div">;
  icon572?: Flex__<"div">;
  title597?: Flex__<"div">;
  item573?: Flex__<"div">;
  left573?: Flex__<"div">;
  icon573?: Flex__<"div">;
  title598?: Flex__<"div">;
  item574?: Flex__<"div">;
  left574?: Flex__<"div">;
  icon574?: Flex__<"div">;
  title599?: Flex__<"div">;
  item575?: Flex__<"div">;
  left575?: Flex__<"div">;
  icon575?: Flex__<"div">;
  title600?: Flex__<"div">;
  item576?: Flex__<"div">;
  left576?: Flex__<"div">;
  icon576?: Flex__<"div">;
  title601?: Flex__<"div">;
  btn24?: Flex__<typeof Button>;
  row10?: Flex__<"div">;
  row11?: Flex__<"div">;
  figmaPaste8?: Flex__<"div">;
  narrowCard25?: Flex__<"div">;
  header52?: Flex__<"div">;
  title602?: Flex__<"div">;
  content25?: Flex__<"div">;
  desc25?: Flex__<"div">;
  placeholder25?: Flex__<"div">;
  header53?: Flex__<"div">;
  list32?: Flex__<"div">;
  item577?: Flex__<"div">;
  left577?: Flex__<"div">;
  icon577?: Flex__<"div">;
  title603?: Flex__<"div">;
  item578?: Flex__<"div">;
  left578?: Flex__<"div">;
  icon578?: Flex__<"div">;
  title604?: Flex__<"div">;
  item579?: Flex__<"div">;
  left579?: Flex__<"div">;
  icon579?: Flex__<"div">;
  title605?: Flex__<"div">;
  item580?: Flex__<"div">;
  left580?: Flex__<"div">;
  icon580?: Flex__<"div">;
  title606?: Flex__<"div">;
  item581?: Flex__<"div">;
  left581?: Flex__<"div">;
  icon581?: Flex__<"div">;
  title607?: Flex__<"div">;
  item582?: Flex__<"div">;
  left582?: Flex__<"div">;
  icon582?: Flex__<"div">;
  title608?: Flex__<"div">;
  item583?: Flex__<"div">;
  left583?: Flex__<"div">;
  icon583?: Flex__<"div">;
  title609?: Flex__<"div">;
  item584?: Flex__<"div">;
  left584?: Flex__<"div">;
  icon584?: Flex__<"div">;
  title610?: Flex__<"div">;
  item585?: Flex__<"div">;
  left585?: Flex__<"div">;
  icon585?: Flex__<"div">;
  title611?: Flex__<"div">;
  item586?: Flex__<"div">;
  left586?: Flex__<"div">;
  icon586?: Flex__<"div">;
  title612?: Flex__<"div">;
  item587?: Flex__<"div">;
  left587?: Flex__<"div">;
  icon587?: Flex__<"div">;
  title613?: Flex__<"div">;
  item588?: Flex__<"div">;
  left588?: Flex__<"div">;
  icon588?: Flex__<"div">;
  title614?: Flex__<"div">;
  item589?: Flex__<"div">;
  left589?: Flex__<"div">;
  icon589?: Flex__<"div">;
  title615?: Flex__<"div">;
  item590?: Flex__<"div">;
  left590?: Flex__<"div">;
  icon590?: Flex__<"div">;
  title616?: Flex__<"div">;
  item591?: Flex__<"div">;
  left591?: Flex__<"div">;
  icon591?: Flex__<"div">;
  title617?: Flex__<"div">;
  item592?: Flex__<"div">;
  left592?: Flex__<"div">;
  icon592?: Flex__<"div">;
  title618?: Flex__<"div">;
  item593?: Flex__<"div">;
  left593?: Flex__<"div">;
  icon593?: Flex__<"div">;
  title619?: Flex__<"div">;
  item594?: Flex__<"div">;
  left594?: Flex__<"div">;
  icon594?: Flex__<"div">;
  title620?: Flex__<"div">;
  item595?: Flex__<"div">;
  left595?: Flex__<"div">;
  icon595?: Flex__<"div">;
  title621?: Flex__<"div">;
  item596?: Flex__<"div">;
  left596?: Flex__<"div">;
  icon596?: Flex__<"div">;
  title622?: Flex__<"div">;
  item597?: Flex__<"div">;
  left597?: Flex__<"div">;
  icon597?: Flex__<"div">;
  title623?: Flex__<"div">;
  item598?: Flex__<"div">;
  left598?: Flex__<"div">;
  icon598?: Flex__<"div">;
  title624?: Flex__<"div">;
  item599?: Flex__<"div">;
  left599?: Flex__<"div">;
  icon599?: Flex__<"div">;
  title625?: Flex__<"div">;
  item600?: Flex__<"div">;
  left600?: Flex__<"div">;
  icon600?: Flex__<"div">;
  title626?: Flex__<"div">;
  btn25?: Flex__<typeof Button>;
  narrowCard26?: Flex__<"div">;
  header54?: Flex__<"div">;
  title627?: Flex__<"div">;
  content26?: Flex__<"div">;
  desc26?: Flex__<"div">;
  placeholder26?: Flex__<"div">;
  header55?: Flex__<"div">;
  list33?: Flex__<"div">;
  item601?: Flex__<"div">;
  left601?: Flex__<"div">;
  icon601?: Flex__<"div">;
  title628?: Flex__<"div">;
  item602?: Flex__<"div">;
  left602?: Flex__<"div">;
  icon602?: Flex__<"div">;
  title629?: Flex__<"div">;
  item603?: Flex__<"div">;
  left603?: Flex__<"div">;
  icon603?: Flex__<"div">;
  title630?: Flex__<"div">;
  item604?: Flex__<"div">;
  left604?: Flex__<"div">;
  icon604?: Flex__<"div">;
  title631?: Flex__<"div">;
  item605?: Flex__<"div">;
  left605?: Flex__<"div">;
  icon605?: Flex__<"div">;
  title632?: Flex__<"div">;
  item606?: Flex__<"div">;
  left606?: Flex__<"div">;
  icon606?: Flex__<"div">;
  title633?: Flex__<"div">;
  item607?: Flex__<"div">;
  left607?: Flex__<"div">;
  icon607?: Flex__<"div">;
  title634?: Flex__<"div">;
  item608?: Flex__<"div">;
  left608?: Flex__<"div">;
  icon608?: Flex__<"div">;
  title635?: Flex__<"div">;
  item609?: Flex__<"div">;
  left609?: Flex__<"div">;
  icon609?: Flex__<"div">;
  title636?: Flex__<"div">;
  item610?: Flex__<"div">;
  left610?: Flex__<"div">;
  icon610?: Flex__<"div">;
  title637?: Flex__<"div">;
  item611?: Flex__<"div">;
  left611?: Flex__<"div">;
  icon611?: Flex__<"div">;
  title638?: Flex__<"div">;
  item612?: Flex__<"div">;
  left612?: Flex__<"div">;
  icon612?: Flex__<"div">;
  title639?: Flex__<"div">;
  item613?: Flex__<"div">;
  left613?: Flex__<"div">;
  icon613?: Flex__<"div">;
  title640?: Flex__<"div">;
  item614?: Flex__<"div">;
  left614?: Flex__<"div">;
  icon614?: Flex__<"div">;
  title641?: Flex__<"div">;
  item615?: Flex__<"div">;
  left615?: Flex__<"div">;
  icon615?: Flex__<"div">;
  title642?: Flex__<"div">;
  item616?: Flex__<"div">;
  left616?: Flex__<"div">;
  icon616?: Flex__<"div">;
  title643?: Flex__<"div">;
  item617?: Flex__<"div">;
  left617?: Flex__<"div">;
  icon617?: Flex__<"div">;
  title644?: Flex__<"div">;
  item618?: Flex__<"div">;
  left618?: Flex__<"div">;
  icon618?: Flex__<"div">;
  title645?: Flex__<"div">;
  item619?: Flex__<"div">;
  left619?: Flex__<"div">;
  icon619?: Flex__<"div">;
  title646?: Flex__<"div">;
  item620?: Flex__<"div">;
  left620?: Flex__<"div">;
  icon620?: Flex__<"div">;
  title647?: Flex__<"div">;
  item621?: Flex__<"div">;
  left621?: Flex__<"div">;
  icon621?: Flex__<"div">;
  title648?: Flex__<"div">;
  item622?: Flex__<"div">;
  left622?: Flex__<"div">;
  icon622?: Flex__<"div">;
  title649?: Flex__<"div">;
  item623?: Flex__<"div">;
  left623?: Flex__<"div">;
  icon623?: Flex__<"div">;
  title650?: Flex__<"div">;
  item624?: Flex__<"div">;
  left624?: Flex__<"div">;
  icon624?: Flex__<"div">;
  title651?: Flex__<"div">;
  btn26?: Flex__<typeof Button>;
  all3?: Flex__<"div">;
  title3?: Flex__<"h2">;
  sections3?: Flex__<"div">;
  col8?: Flex__<"div">;
  list12?: Flex__<"div">;
  col9?: Flex__<"div">;
  section5?: Flex__<"div">;
  list13?: Flex__<"div">;
  section6?: Flex__<"div">;
  list14?: Flex__<"div">;
  col10?: Flex__<"div">;
  list15?: Flex__<"div">;
  mobile?: Flex__<"div">;
  header3?: Flex__<"div">;
  key3?: Flex__<"div">;
  header2?: Flex__<"header">;
  list6?: Flex__<"div">;
  figmaPaste4?: Flex__<"div">;
  narrowCard9?: Flex__<"div">;
  header28?: Flex__<"div">;
  title?: Flex__<"div">;
  content9?: Flex__<"div">;
  desc9?: Flex__<"div">;
  placeholder9?: Flex__<"div">;
  header29?: Flex__<"div">;
  list24?: Flex__<"div">;
  item?: Flex__<"div">;
  left?: Flex__<"div">;
  icon?: Flex__<"div">;
  title396?: Flex__<"div">;
  item2?: Flex__<"div">;
  left2?: Flex__<"div">;
  icon2?: Flex__<"div">;
  title397?: Flex__<"div">;
  item3?: Flex__<"div">;
  left3?: Flex__<"div">;
  icon3?: Flex__<"div">;
  title4?: Flex__<"div">;
  item4?: Flex__<"div">;
  left4?: Flex__<"div">;
  icon4?: Flex__<"div">;
  title5?: Flex__<"div">;
  item5?: Flex__<"div">;
  left5?: Flex__<"div">;
  icon5?: Flex__<"div">;
  title6?: Flex__<"div">;
  item6?: Flex__<"div">;
  left6?: Flex__<"div">;
  icon6?: Flex__<"div">;
  title7?: Flex__<"div">;
  item7?: Flex__<"div">;
  left7?: Flex__<"div">;
  icon7?: Flex__<"div">;
  title8?: Flex__<"div">;
  item8?: Flex__<"div">;
  left8?: Flex__<"div">;
  icon8?: Flex__<"div">;
  title9?: Flex__<"div">;
  item9?: Flex__<"div">;
  left9?: Flex__<"div">;
  icon9?: Flex__<"div">;
  title10?: Flex__<"div">;
  item10?: Flex__<"div">;
  left10?: Flex__<"div">;
  icon10?: Flex__<"div">;
  title11?: Flex__<"div">;
  item11?: Flex__<"div">;
  left11?: Flex__<"div">;
  icon11?: Flex__<"div">;
  title12?: Flex__<"div">;
  item12?: Flex__<"div">;
  left12?: Flex__<"div">;
  icon12?: Flex__<"div">;
  title13?: Flex__<"div">;
  item13?: Flex__<"div">;
  left13?: Flex__<"div">;
  icon13?: Flex__<"div">;
  title14?: Flex__<"div">;
  item14?: Flex__<"div">;
  left14?: Flex__<"div">;
  icon14?: Flex__<"div">;
  title15?: Flex__<"div">;
  item15?: Flex__<"div">;
  left15?: Flex__<"div">;
  icon15?: Flex__<"div">;
  title16?: Flex__<"div">;
  item16?: Flex__<"div">;
  left16?: Flex__<"div">;
  icon16?: Flex__<"div">;
  title17?: Flex__<"div">;
  item17?: Flex__<"div">;
  left17?: Flex__<"div">;
  icon17?: Flex__<"div">;
  title18?: Flex__<"div">;
  item18?: Flex__<"div">;
  left18?: Flex__<"div">;
  icon18?: Flex__<"div">;
  title19?: Flex__<"div">;
  item19?: Flex__<"div">;
  left19?: Flex__<"div">;
  icon19?: Flex__<"div">;
  title20?: Flex__<"div">;
  item20?: Flex__<"div">;
  left20?: Flex__<"div">;
  icon20?: Flex__<"div">;
  title21?: Flex__<"div">;
  item21?: Flex__<"div">;
  left21?: Flex__<"div">;
  icon21?: Flex__<"div">;
  title22?: Flex__<"div">;
  item22?: Flex__<"div">;
  left22?: Flex__<"div">;
  icon22?: Flex__<"div">;
  title23?: Flex__<"div">;
  item23?: Flex__<"div">;
  left23?: Flex__<"div">;
  icon23?: Flex__<"div">;
  title24?: Flex__<"div">;
  item24?: Flex__<"div">;
  left24?: Flex__<"div">;
  icon24?: Flex__<"div">;
  title25?: Flex__<"div">;
  btn9?: Flex__<typeof Button>;
  narrowCard10?: Flex__<"div">;
  header30?: Flex__<"div">;
  title26?: Flex__<"div">;
  content10?: Flex__<"div">;
  desc10?: Flex__<"div">;
  placeholder10?: Flex__<"div">;
  header31?: Flex__<"div">;
  list2?: Flex__<"div">;
  item25?: Flex__<"div">;
  left25?: Flex__<"div">;
  icon25?: Flex__<"div">;
  title27?: Flex__<"div">;
  item26?: Flex__<"div">;
  left26?: Flex__<"div">;
  icon26?: Flex__<"div">;
  title28?: Flex__<"div">;
  item27?: Flex__<"div">;
  left27?: Flex__<"div">;
  icon27?: Flex__<"div">;
  title29?: Flex__<"div">;
  item28?: Flex__<"div">;
  left28?: Flex__<"div">;
  icon28?: Flex__<"div">;
  title30?: Flex__<"div">;
  item29?: Flex__<"div">;
  left29?: Flex__<"div">;
  icon29?: Flex__<"div">;
  title31?: Flex__<"div">;
  item30?: Flex__<"div">;
  left30?: Flex__<"div">;
  icon30?: Flex__<"div">;
  title32?: Flex__<"div">;
  item31?: Flex__<"div">;
  left31?: Flex__<"div">;
  icon31?: Flex__<"div">;
  title33?: Flex__<"div">;
  item32?: Flex__<"div">;
  left32?: Flex__<"div">;
  icon32?: Flex__<"div">;
  title34?: Flex__<"div">;
  item33?: Flex__<"div">;
  left33?: Flex__<"div">;
  icon33?: Flex__<"div">;
  title35?: Flex__<"div">;
  item34?: Flex__<"div">;
  left34?: Flex__<"div">;
  icon34?: Flex__<"div">;
  title36?: Flex__<"div">;
  item35?: Flex__<"div">;
  left35?: Flex__<"div">;
  icon35?: Flex__<"div">;
  title37?: Flex__<"div">;
  item36?: Flex__<"div">;
  left36?: Flex__<"div">;
  icon36?: Flex__<"div">;
  title38?: Flex__<"div">;
  item37?: Flex__<"div">;
  left37?: Flex__<"div">;
  icon37?: Flex__<"div">;
  title39?: Flex__<"div">;
  item38?: Flex__<"div">;
  left38?: Flex__<"div">;
  icon38?: Flex__<"div">;
  title40?: Flex__<"div">;
  item39?: Flex__<"div">;
  left39?: Flex__<"div">;
  icon39?: Flex__<"div">;
  title41?: Flex__<"div">;
  item40?: Flex__<"div">;
  left40?: Flex__<"div">;
  icon40?: Flex__<"div">;
  title42?: Flex__<"div">;
  item41?: Flex__<"div">;
  left41?: Flex__<"div">;
  icon41?: Flex__<"div">;
  title43?: Flex__<"div">;
  item42?: Flex__<"div">;
  left42?: Flex__<"div">;
  icon42?: Flex__<"div">;
  title44?: Flex__<"div">;
  item43?: Flex__<"div">;
  left43?: Flex__<"div">;
  icon43?: Flex__<"div">;
  title45?: Flex__<"div">;
  item44?: Flex__<"div">;
  left44?: Flex__<"div">;
  icon44?: Flex__<"div">;
  title46?: Flex__<"div">;
  item45?: Flex__<"div">;
  left45?: Flex__<"div">;
  icon45?: Flex__<"div">;
  title47?: Flex__<"div">;
  item46?: Flex__<"div">;
  left46?: Flex__<"div">;
  icon46?: Flex__<"div">;
  title48?: Flex__<"div">;
  item47?: Flex__<"div">;
  left47?: Flex__<"div">;
  icon47?: Flex__<"div">;
  title49?: Flex__<"div">;
  item48?: Flex__<"div">;
  left48?: Flex__<"div">;
  icon48?: Flex__<"div">;
  title50?: Flex__<"div">;
  btn10?: Flex__<typeof Button>;
  narrowCard11?: Flex__<"div">;
  header5?: Flex__<"div">;
  title51?: Flex__<"div">;
  content11?: Flex__<"div">;
  desc11?: Flex__<"div">;
  placeholder11?: Flex__<"div">;
  header6?: Flex__<"div">;
  list3?: Flex__<"div">;
  item49?: Flex__<"div">;
  left49?: Flex__<"div">;
  icon49?: Flex__<"div">;
  title52?: Flex__<"div">;
  item50?: Flex__<"div">;
  left50?: Flex__<"div">;
  icon50?: Flex__<"div">;
  title53?: Flex__<"div">;
  item51?: Flex__<"div">;
  left51?: Flex__<"div">;
  icon51?: Flex__<"div">;
  title54?: Flex__<"div">;
  item52?: Flex__<"div">;
  left52?: Flex__<"div">;
  icon52?: Flex__<"div">;
  title55?: Flex__<"div">;
  item53?: Flex__<"div">;
  left53?: Flex__<"div">;
  icon53?: Flex__<"div">;
  title56?: Flex__<"div">;
  item54?: Flex__<"div">;
  left54?: Flex__<"div">;
  icon54?: Flex__<"div">;
  title57?: Flex__<"div">;
  item55?: Flex__<"div">;
  left55?: Flex__<"div">;
  icon55?: Flex__<"div">;
  title58?: Flex__<"div">;
  item56?: Flex__<"div">;
  left56?: Flex__<"div">;
  icon56?: Flex__<"div">;
  title59?: Flex__<"div">;
  item57?: Flex__<"div">;
  left57?: Flex__<"div">;
  icon57?: Flex__<"div">;
  title60?: Flex__<"div">;
  item58?: Flex__<"div">;
  left58?: Flex__<"div">;
  icon58?: Flex__<"div">;
  title61?: Flex__<"div">;
  item59?: Flex__<"div">;
  left59?: Flex__<"div">;
  icon59?: Flex__<"div">;
  title62?: Flex__<"div">;
  item60?: Flex__<"div">;
  left60?: Flex__<"div">;
  icon60?: Flex__<"div">;
  title63?: Flex__<"div">;
  item61?: Flex__<"div">;
  left61?: Flex__<"div">;
  icon61?: Flex__<"div">;
  title64?: Flex__<"div">;
  item62?: Flex__<"div">;
  left62?: Flex__<"div">;
  icon62?: Flex__<"div">;
  title65?: Flex__<"div">;
  item63?: Flex__<"div">;
  left63?: Flex__<"div">;
  icon63?: Flex__<"div">;
  title66?: Flex__<"div">;
  item64?: Flex__<"div">;
  left64?: Flex__<"div">;
  icon64?: Flex__<"div">;
  title67?: Flex__<"div">;
  item65?: Flex__<"div">;
  left65?: Flex__<"div">;
  icon65?: Flex__<"div">;
  title68?: Flex__<"div">;
  item66?: Flex__<"div">;
  left66?: Flex__<"div">;
  icon66?: Flex__<"div">;
  title69?: Flex__<"div">;
  item67?: Flex__<"div">;
  left67?: Flex__<"div">;
  icon67?: Flex__<"div">;
  title70?: Flex__<"div">;
  item68?: Flex__<"div">;
  left68?: Flex__<"div">;
  icon68?: Flex__<"div">;
  title71?: Flex__<"div">;
  item69?: Flex__<"div">;
  left69?: Flex__<"div">;
  icon69?: Flex__<"div">;
  title72?: Flex__<"div">;
  item70?: Flex__<"div">;
  left70?: Flex__<"div">;
  icon70?: Flex__<"div">;
  title73?: Flex__<"div">;
  item71?: Flex__<"div">;
  left71?: Flex__<"div">;
  icon71?: Flex__<"div">;
  title74?: Flex__<"div">;
  item72?: Flex__<"div">;
  left72?: Flex__<"div">;
  icon72?: Flex__<"div">;
  title75?: Flex__<"div">;
  btn11?: Flex__<typeof Button>;
  narrowCard12?: Flex__<"div">;
  header7?: Flex__<"div">;
  title76?: Flex__<"div">;
  content12?: Flex__<"div">;
  desc12?: Flex__<"div">;
  placeholder12?: Flex__<"div">;
  header8?: Flex__<"div">;
  list4?: Flex__<"div">;
  item73?: Flex__<"div">;
  left73?: Flex__<"div">;
  icon73?: Flex__<"div">;
  title77?: Flex__<"div">;
  item74?: Flex__<"div">;
  left74?: Flex__<"div">;
  icon74?: Flex__<"div">;
  title78?: Flex__<"div">;
  item75?: Flex__<"div">;
  left75?: Flex__<"div">;
  icon75?: Flex__<"div">;
  title79?: Flex__<"div">;
  item76?: Flex__<"div">;
  left76?: Flex__<"div">;
  icon76?: Flex__<"div">;
  title80?: Flex__<"div">;
  item77?: Flex__<"div">;
  left77?: Flex__<"div">;
  icon77?: Flex__<"div">;
  title81?: Flex__<"div">;
  item78?: Flex__<"div">;
  left78?: Flex__<"div">;
  icon78?: Flex__<"div">;
  title82?: Flex__<"div">;
  item79?: Flex__<"div">;
  left79?: Flex__<"div">;
  icon79?: Flex__<"div">;
  title83?: Flex__<"div">;
  item80?: Flex__<"div">;
  left80?: Flex__<"div">;
  icon80?: Flex__<"div">;
  title84?: Flex__<"div">;
  item81?: Flex__<"div">;
  left81?: Flex__<"div">;
  icon81?: Flex__<"div">;
  title85?: Flex__<"div">;
  item82?: Flex__<"div">;
  left82?: Flex__<"div">;
  icon82?: Flex__<"div">;
  title86?: Flex__<"div">;
  item83?: Flex__<"div">;
  left83?: Flex__<"div">;
  icon83?: Flex__<"div">;
  title87?: Flex__<"div">;
  item84?: Flex__<"div">;
  left84?: Flex__<"div">;
  icon84?: Flex__<"div">;
  title88?: Flex__<"div">;
  item85?: Flex__<"div">;
  left85?: Flex__<"div">;
  icon85?: Flex__<"div">;
  title89?: Flex__<"div">;
  item86?: Flex__<"div">;
  left86?: Flex__<"div">;
  icon86?: Flex__<"div">;
  title90?: Flex__<"div">;
  item87?: Flex__<"div">;
  left87?: Flex__<"div">;
  icon87?: Flex__<"div">;
  title91?: Flex__<"div">;
  item88?: Flex__<"div">;
  left88?: Flex__<"div">;
  icon88?: Flex__<"div">;
  title92?: Flex__<"div">;
  item89?: Flex__<"div">;
  left89?: Flex__<"div">;
  icon89?: Flex__<"div">;
  title93?: Flex__<"div">;
  item90?: Flex__<"div">;
  left90?: Flex__<"div">;
  icon90?: Flex__<"div">;
  title94?: Flex__<"div">;
  item91?: Flex__<"div">;
  left91?: Flex__<"div">;
  icon91?: Flex__<"div">;
  title95?: Flex__<"div">;
  item92?: Flex__<"div">;
  left92?: Flex__<"div">;
  icon92?: Flex__<"div">;
  title96?: Flex__<"div">;
  item93?: Flex__<"div">;
  left93?: Flex__<"div">;
  icon93?: Flex__<"div">;
  title97?: Flex__<"div">;
  item94?: Flex__<"div">;
  left94?: Flex__<"div">;
  icon94?: Flex__<"div">;
  title98?: Flex__<"div">;
  item95?: Flex__<"div">;
  left95?: Flex__<"div">;
  icon95?: Flex__<"div">;
  title99?: Flex__<"div">;
  item96?: Flex__<"div">;
  left96?: Flex__<"div">;
  icon96?: Flex__<"div">;
  title398?: Flex__<"div">;
  btn12?: Flex__<typeof Button>;
  narrowCard13?: Flex__<"div">;
  header32?: Flex__<"div">;
  title399?: Flex__<"div">;
  content13?: Flex__<"div">;
  desc13?: Flex__<"div">;
  placeholder13?: Flex__<"div">;
  header33?: Flex__<"div">;
  list5?: Flex__<"div">;
  item385?: Flex__<"div">;
  left385?: Flex__<"div">;
  icon385?: Flex__<"div">;
  title400?: Flex__<"div">;
  item386?: Flex__<"div">;
  left386?: Flex__<"div">;
  icon386?: Flex__<"div">;
  title401?: Flex__<"div">;
  item387?: Flex__<"div">;
  left387?: Flex__<"div">;
  icon387?: Flex__<"div">;
  title402?: Flex__<"div">;
  item388?: Flex__<"div">;
  left388?: Flex__<"div">;
  icon388?: Flex__<"div">;
  title403?: Flex__<"div">;
  item389?: Flex__<"div">;
  left389?: Flex__<"div">;
  icon389?: Flex__<"div">;
  title404?: Flex__<"div">;
  item390?: Flex__<"div">;
  left390?: Flex__<"div">;
  icon390?: Flex__<"div">;
  title405?: Flex__<"div">;
  item391?: Flex__<"div">;
  left391?: Flex__<"div">;
  icon391?: Flex__<"div">;
  title406?: Flex__<"div">;
  item392?: Flex__<"div">;
  left392?: Flex__<"div">;
  icon392?: Flex__<"div">;
  title407?: Flex__<"div">;
  item393?: Flex__<"div">;
  left393?: Flex__<"div">;
  icon393?: Flex__<"div">;
  title408?: Flex__<"div">;
  item394?: Flex__<"div">;
  left394?: Flex__<"div">;
  icon394?: Flex__<"div">;
  title409?: Flex__<"div">;
  item395?: Flex__<"div">;
  left395?: Flex__<"div">;
  icon395?: Flex__<"div">;
  title410?: Flex__<"div">;
  item396?: Flex__<"div">;
  left396?: Flex__<"div">;
  icon396?: Flex__<"div">;
  title411?: Flex__<"div">;
  item397?: Flex__<"div">;
  left397?: Flex__<"div">;
  icon397?: Flex__<"div">;
  title412?: Flex__<"div">;
  item398?: Flex__<"div">;
  left398?: Flex__<"div">;
  icon398?: Flex__<"div">;
  title413?: Flex__<"div">;
  item399?: Flex__<"div">;
  left399?: Flex__<"div">;
  icon399?: Flex__<"div">;
  title414?: Flex__<"div">;
  item400?: Flex__<"div">;
  left400?: Flex__<"div">;
  icon400?: Flex__<"div">;
  title415?: Flex__<"div">;
  item401?: Flex__<"div">;
  left401?: Flex__<"div">;
  icon401?: Flex__<"div">;
  title416?: Flex__<"div">;
  item402?: Flex__<"div">;
  left402?: Flex__<"div">;
  icon402?: Flex__<"div">;
  title417?: Flex__<"div">;
  item403?: Flex__<"div">;
  left403?: Flex__<"div">;
  icon403?: Flex__<"div">;
  title418?: Flex__<"div">;
  item404?: Flex__<"div">;
  left404?: Flex__<"div">;
  icon404?: Flex__<"div">;
  title419?: Flex__<"div">;
  item405?: Flex__<"div">;
  left405?: Flex__<"div">;
  icon405?: Flex__<"div">;
  title420?: Flex__<"div">;
  item406?: Flex__<"div">;
  left406?: Flex__<"div">;
  icon406?: Flex__<"div">;
  title421?: Flex__<"div">;
  item407?: Flex__<"div">;
  left407?: Flex__<"div">;
  icon407?: Flex__<"div">;
  title422?: Flex__<"div">;
  item408?: Flex__<"div">;
  left408?: Flex__<"div">;
  icon408?: Flex__<"div">;
  title423?: Flex__<"div">;
  btn13?: Flex__<typeof Button>;
  narrowCard14?: Flex__<"div">;
  header34?: Flex__<"div">;
  title424?: Flex__<"div">;
  content14?: Flex__<"div">;
  desc14?: Flex__<"div">;
  placeholder14?: Flex__<"div">;
  header35?: Flex__<"div">;
  list25?: Flex__<"div">;
  item409?: Flex__<"div">;
  left409?: Flex__<"div">;
  icon409?: Flex__<"div">;
  title425?: Flex__<"div">;
  item410?: Flex__<"div">;
  left410?: Flex__<"div">;
  icon410?: Flex__<"div">;
  title426?: Flex__<"div">;
  item411?: Flex__<"div">;
  left411?: Flex__<"div">;
  icon411?: Flex__<"div">;
  title427?: Flex__<"div">;
  item412?: Flex__<"div">;
  left412?: Flex__<"div">;
  icon412?: Flex__<"div">;
  title428?: Flex__<"div">;
  item413?: Flex__<"div">;
  left413?: Flex__<"div">;
  icon413?: Flex__<"div">;
  title429?: Flex__<"div">;
  item414?: Flex__<"div">;
  left414?: Flex__<"div">;
  icon414?: Flex__<"div">;
  title430?: Flex__<"div">;
  item415?: Flex__<"div">;
  left415?: Flex__<"div">;
  icon415?: Flex__<"div">;
  title431?: Flex__<"div">;
  item416?: Flex__<"div">;
  left416?: Flex__<"div">;
  icon416?: Flex__<"div">;
  title432?: Flex__<"div">;
  item417?: Flex__<"div">;
  left417?: Flex__<"div">;
  icon417?: Flex__<"div">;
  title433?: Flex__<"div">;
  item418?: Flex__<"div">;
  left418?: Flex__<"div">;
  icon418?: Flex__<"div">;
  title434?: Flex__<"div">;
  item419?: Flex__<"div">;
  left419?: Flex__<"div">;
  icon419?: Flex__<"div">;
  title435?: Flex__<"div">;
  item420?: Flex__<"div">;
  left420?: Flex__<"div">;
  icon420?: Flex__<"div">;
  title436?: Flex__<"div">;
  item421?: Flex__<"div">;
  left421?: Flex__<"div">;
  icon421?: Flex__<"div">;
  title437?: Flex__<"div">;
  item422?: Flex__<"div">;
  left422?: Flex__<"div">;
  icon422?: Flex__<"div">;
  title438?: Flex__<"div">;
  item423?: Flex__<"div">;
  left423?: Flex__<"div">;
  icon423?: Flex__<"div">;
  title439?: Flex__<"div">;
  item424?: Flex__<"div">;
  left424?: Flex__<"div">;
  icon424?: Flex__<"div">;
  title440?: Flex__<"div">;
  item425?: Flex__<"div">;
  left425?: Flex__<"div">;
  icon425?: Flex__<"div">;
  title441?: Flex__<"div">;
  item426?: Flex__<"div">;
  left426?: Flex__<"div">;
  icon426?: Flex__<"div">;
  title442?: Flex__<"div">;
  item427?: Flex__<"div">;
  left427?: Flex__<"div">;
  icon427?: Flex__<"div">;
  title443?: Flex__<"div">;
  item428?: Flex__<"div">;
  left428?: Flex__<"div">;
  icon428?: Flex__<"div">;
  title444?: Flex__<"div">;
  item429?: Flex__<"div">;
  left429?: Flex__<"div">;
  icon429?: Flex__<"div">;
  title445?: Flex__<"div">;
  item430?: Flex__<"div">;
  left430?: Flex__<"div">;
  icon430?: Flex__<"div">;
  title446?: Flex__<"div">;
  item431?: Flex__<"div">;
  left431?: Flex__<"div">;
  icon431?: Flex__<"div">;
  title447?: Flex__<"div">;
  item432?: Flex__<"div">;
  left432?: Flex__<"div">;
  icon432?: Flex__<"div">;
  title448?: Flex__<"div">;
  btn14?: Flex__<typeof Button>;
  narrowCard15?: Flex__<"div">;
  header36?: Flex__<"div">;
  title449?: Flex__<"div">;
  content15?: Flex__<"div">;
  desc15?: Flex__<"div">;
  placeholder15?: Flex__<"div">;
  header37?: Flex__<"div">;
  list26?: Flex__<"div">;
  item433?: Flex__<"div">;
  left433?: Flex__<"div">;
  icon433?: Flex__<"div">;
  title450?: Flex__<"div">;
  item434?: Flex__<"div">;
  left434?: Flex__<"div">;
  icon434?: Flex__<"div">;
  title451?: Flex__<"div">;
  item435?: Flex__<"div">;
  left435?: Flex__<"div">;
  icon435?: Flex__<"div">;
  title452?: Flex__<"div">;
  item436?: Flex__<"div">;
  left436?: Flex__<"div">;
  icon436?: Flex__<"div">;
  title453?: Flex__<"div">;
  item437?: Flex__<"div">;
  left437?: Flex__<"div">;
  icon437?: Flex__<"div">;
  title454?: Flex__<"div">;
  item438?: Flex__<"div">;
  left438?: Flex__<"div">;
  icon438?: Flex__<"div">;
  title455?: Flex__<"div">;
  item439?: Flex__<"div">;
  left439?: Flex__<"div">;
  icon439?: Flex__<"div">;
  title456?: Flex__<"div">;
  item440?: Flex__<"div">;
  left440?: Flex__<"div">;
  icon440?: Flex__<"div">;
  title457?: Flex__<"div">;
  item441?: Flex__<"div">;
  left441?: Flex__<"div">;
  icon441?: Flex__<"div">;
  title458?: Flex__<"div">;
  item442?: Flex__<"div">;
  left442?: Flex__<"div">;
  icon442?: Flex__<"div">;
  title459?: Flex__<"div">;
  item443?: Flex__<"div">;
  left443?: Flex__<"div">;
  icon443?: Flex__<"div">;
  title460?: Flex__<"div">;
  item444?: Flex__<"div">;
  left444?: Flex__<"div">;
  icon444?: Flex__<"div">;
  title461?: Flex__<"div">;
  item445?: Flex__<"div">;
  left445?: Flex__<"div">;
  icon445?: Flex__<"div">;
  title462?: Flex__<"div">;
  item446?: Flex__<"div">;
  left446?: Flex__<"div">;
  icon446?: Flex__<"div">;
  title463?: Flex__<"div">;
  item447?: Flex__<"div">;
  left447?: Flex__<"div">;
  icon447?: Flex__<"div">;
  title464?: Flex__<"div">;
  item448?: Flex__<"div">;
  left448?: Flex__<"div">;
  icon448?: Flex__<"div">;
  title465?: Flex__<"div">;
  item449?: Flex__<"div">;
  left449?: Flex__<"div">;
  icon449?: Flex__<"div">;
  title466?: Flex__<"div">;
  item450?: Flex__<"div">;
  left450?: Flex__<"div">;
  icon450?: Flex__<"div">;
  title467?: Flex__<"div">;
  item451?: Flex__<"div">;
  left451?: Flex__<"div">;
  icon451?: Flex__<"div">;
  title468?: Flex__<"div">;
  item452?: Flex__<"div">;
  left452?: Flex__<"div">;
  icon452?: Flex__<"div">;
  title469?: Flex__<"div">;
  item453?: Flex__<"div">;
  left453?: Flex__<"div">;
  icon453?: Flex__<"div">;
  title470?: Flex__<"div">;
  item454?: Flex__<"div">;
  left454?: Flex__<"div">;
  icon454?: Flex__<"div">;
  title471?: Flex__<"div">;
  item455?: Flex__<"div">;
  left455?: Flex__<"div">;
  icon455?: Flex__<"div">;
  title472?: Flex__<"div">;
  item456?: Flex__<"div">;
  left456?: Flex__<"div">;
  icon456?: Flex__<"div">;
  title473?: Flex__<"div">;
  btn15?: Flex__<typeof Button>;
  narrowCard16?: Flex__<"div">;
  header38?: Flex__<"div">;
  title474?: Flex__<"div">;
  content16?: Flex__<"div">;
  desc16?: Flex__<"div">;
  placeholder16?: Flex__<"div">;
  header39?: Flex__<"div">;
  list27?: Flex__<"div">;
  item457?: Flex__<"div">;
  left457?: Flex__<"div">;
  icon457?: Flex__<"div">;
  title475?: Flex__<"div">;
  item458?: Flex__<"div">;
  left458?: Flex__<"div">;
  icon458?: Flex__<"div">;
  title476?: Flex__<"div">;
  item459?: Flex__<"div">;
  left459?: Flex__<"div">;
  icon459?: Flex__<"div">;
  title477?: Flex__<"div">;
  item460?: Flex__<"div">;
  left460?: Flex__<"div">;
  icon460?: Flex__<"div">;
  title478?: Flex__<"div">;
  item461?: Flex__<"div">;
  left461?: Flex__<"div">;
  icon461?: Flex__<"div">;
  title479?: Flex__<"div">;
  item462?: Flex__<"div">;
  left462?: Flex__<"div">;
  icon462?: Flex__<"div">;
  title480?: Flex__<"div">;
  item463?: Flex__<"div">;
  left463?: Flex__<"div">;
  icon463?: Flex__<"div">;
  title481?: Flex__<"div">;
  item464?: Flex__<"div">;
  left464?: Flex__<"div">;
  icon464?: Flex__<"div">;
  title482?: Flex__<"div">;
  item465?: Flex__<"div">;
  left465?: Flex__<"div">;
  icon465?: Flex__<"div">;
  title483?: Flex__<"div">;
  item466?: Flex__<"div">;
  left466?: Flex__<"div">;
  icon466?: Flex__<"div">;
  title484?: Flex__<"div">;
  item467?: Flex__<"div">;
  left467?: Flex__<"div">;
  icon467?: Flex__<"div">;
  title485?: Flex__<"div">;
  item468?: Flex__<"div">;
  left468?: Flex__<"div">;
  icon468?: Flex__<"div">;
  title486?: Flex__<"div">;
  item469?: Flex__<"div">;
  left469?: Flex__<"div">;
  icon469?: Flex__<"div">;
  title487?: Flex__<"div">;
  item470?: Flex__<"div">;
  left470?: Flex__<"div">;
  icon470?: Flex__<"div">;
  title488?: Flex__<"div">;
  item471?: Flex__<"div">;
  left471?: Flex__<"div">;
  icon471?: Flex__<"div">;
  title489?: Flex__<"div">;
  item472?: Flex__<"div">;
  left472?: Flex__<"div">;
  icon472?: Flex__<"div">;
  title490?: Flex__<"div">;
  item473?: Flex__<"div">;
  left473?: Flex__<"div">;
  icon473?: Flex__<"div">;
  title491?: Flex__<"div">;
  item474?: Flex__<"div">;
  left474?: Flex__<"div">;
  icon474?: Flex__<"div">;
  title492?: Flex__<"div">;
  item475?: Flex__<"div">;
  left475?: Flex__<"div">;
  icon475?: Flex__<"div">;
  title493?: Flex__<"div">;
  item476?: Flex__<"div">;
  left476?: Flex__<"div">;
  icon476?: Flex__<"div">;
  title494?: Flex__<"div">;
  item477?: Flex__<"div">;
  left477?: Flex__<"div">;
  icon477?: Flex__<"div">;
  title495?: Flex__<"div">;
  item478?: Flex__<"div">;
  left478?: Flex__<"div">;
  icon478?: Flex__<"div">;
  title496?: Flex__<"div">;
  item479?: Flex__<"div">;
  left479?: Flex__<"div">;
  icon479?: Flex__<"div">;
  title497?: Flex__<"div">;
  item480?: Flex__<"div">;
  left480?: Flex__<"div">;
  icon480?: Flex__<"div">;
  title498?: Flex__<"div">;
  btn16?: Flex__<typeof Button>;
};

export interface DefaultCapabilitiesCardsProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicCapabilitiesCards__RenderFunc(props: {
  variants: PlasmicCapabilitiesCards__VariantsArgs;
  args: PlasmicCapabilitiesCards__ArgsType;
  overrides: PlasmicCapabilitiesCards__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"myEvaluations"}
      data-plasmic-override={overrides.myEvaluations}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_bvRZj1oZhhFBeMnkX2LkQu",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.myEvaluations
      )}
      id={"MyEvaluations"}
    >
      {(
        hasVariant(globalVariants, "mobile", "mobile")
          ? false
          : hasVariant(globalVariants, "mobile", "tabletPortrait")
            ? false
            : true
      ) ? (
        <div
          data-plasmic-name={"desktop"}
          data-plasmic-override={overrides.desktop}
          className={classNames("all", sty.desktop)}
        >
          <div
            data-plasmic-name={"key2"}
            data-plasmic-override={overrides.key2}
            className={classNames("all", sty.key2)}
          >
            <div
              data-plasmic-name={"list"}
              data-plasmic-override={overrides.list}
              className={classNames("all", sty.list)}
            >
              <div
                data-plasmic-name={"row2"}
                data-plasmic-override={overrides.row2}
                className={classNames("all", sty.row2)}
              >
                <div
                  data-plasmic-name={"narrowCard"}
                  data-plasmic-override={overrides.narrowCard}
                  className={classNames("all", sty.narrowCard)}
                >
                  <div
                    data-plasmic-name={"header"}
                    data-plasmic-override={overrides.header}
                    className={classNames("all", sty.header)}
                  >
                    <div
                      data-plasmic-name={"title196"}
                      data-plasmic-override={overrides.title196}
                      className={classNames("all", "__wab_text", sty.title196)}
                    >
                      {"Assessment \n& Competency Management"}
                    </div>
                    <Icon94Icon
                      className={classNames("all", sty.svg__b5SuU)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content"}
                    data-plasmic-override={overrides.content}
                    className={classNames("all", sty.content)}
                  >
                    <div
                      data-plasmic-name={"desc"}
                      data-plasmic-override={overrides.desc}
                      className={classNames("all", "__wab_text", sty.desc)}
                    >
                      {
                        "Strengthen assessment quality, support competency-based education, and transform educational information into meaningful insight."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder"}
                      data-plasmic-override={overrides.placeholder}
                      className={classNames("all", sty.placeholder)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header13"}
                          data-plasmic-override={overrides.header13}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header13
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list16"}
                        data-plasmic-override={overrides.list16}
                        className={classNames("all", sty.list16)}
                      >
                        <div
                          data-plasmic-name={"item193"}
                          data-plasmic-override={overrides.item193}
                          className={classNames("all", sty.item193)}
                        >
                          <div
                            data-plasmic-name={"left193"}
                            data-plasmic-override={overrides.left193}
                            className={classNames("all", sty.left193)}
                          >
                            <div
                              data-plasmic-name={"icon193"}
                              data-plasmic-override={overrides.icon193}
                              className={classNames("all", sty.icon193)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__tyiM)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title197"}
                            data-plasmic-override={overrides.title197}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title197
                            )}
                          >
                            {"SAGE\u2122"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item194"}
                          data-plasmic-override={overrides.item194}
                          className={classNames("all", sty.item194)}
                        >
                          <div
                            data-plasmic-name={"left194"}
                            data-plasmic-override={overrides.left194}
                            className={classNames("all", sty.left194)}
                          >
                            <div
                              data-plasmic-name={"icon194"}
                              data-plasmic-override={overrides.icon194}
                              className={classNames("all", sty.icon194)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___0Zidk)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title198"}
                            data-plasmic-override={overrides.title198}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title198
                            )}
                          >
                            {"Evaluations & Assessments"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item195"}
                          data-plasmic-override={overrides.item195}
                          className={classNames("all", sty.item195)}
                        >
                          <div
                            data-plasmic-name={"left195"}
                            data-plasmic-override={overrides.left195}
                            className={classNames("all", sty.left195)}
                          >
                            <div
                              data-plasmic-name={"icon195"}
                              data-plasmic-override={overrides.icon195}
                              className={classNames("all", sty.icon195)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___7Grl8)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title199"}
                            data-plasmic-override={overrides.title199}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title199
                            )}
                          >
                            {"MyInsights\u00ae"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item196"}
                          data-plasmic-override={overrides.item196}
                          className={classNames("all", sty.item196)}
                        >
                          <div
                            data-plasmic-name={"left196"}
                            data-plasmic-override={overrides.left196}
                            className={classNames("all", sty.left196)}
                          >
                            <div
                              data-plasmic-name={"icon196"}
                              data-plasmic-override={overrides.icon196}
                              className={classNames("all", sty.icon196)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__l5JZb)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title200"}
                            data-plasmic-override={overrides.title200}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title200
                            )}
                          >
                            {"Milestones & EPAs"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item197"}
                          data-plasmic-override={overrides.item197}
                          className={classNames("all", sty.item197)}
                        >
                          <div
                            data-plasmic-name={"left197"}
                            data-plasmic-override={overrides.left197}
                            className={classNames("all", sty.left197)}
                          >
                            <div
                              data-plasmic-name={"icon197"}
                              data-plasmic-override={overrides.icon197}
                              className={classNames("all", sty.icon197)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___8DHQd)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title201"}
                            data-plasmic-override={overrides.title201}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title201
                            )}
                          >
                            {"Narrative Predictive Value (NPV)"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item198"}
                          data-plasmic-override={overrides.item198}
                          className={classNames("all", sty.item198)}
                        >
                          <div
                            data-plasmic-name={"left198"}
                            data-plasmic-override={overrides.left198}
                            className={classNames("all", sty.left198)}
                          >
                            <div
                              data-plasmic-name={"icon198"}
                              data-plasmic-override={overrides.icon198}
                              className={classNames("all", sty.icon198)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__vT9De)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title202"}
                            data-plasmic-override={overrides.title202}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title202
                            )}
                          >
                            {"Performance Improvement Plans"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item199"}
                          data-plasmic-override={overrides.item199}
                          className={classNames("all", sty.item199)}
                        >
                          <div
                            data-plasmic-name={"left199"}
                            data-plasmic-override={overrides.left199}
                            className={classNames("all", sty.left199)}
                          >
                            <div
                              data-plasmic-name={"icon199"}
                              data-plasmic-override={overrides.icon199}
                              className={classNames("all", sty.icon199)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__sztw)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title203"}
                            data-plasmic-override={overrides.title203}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title203
                            )}
                          >
                            {"Performance Dashboard"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item200"}
                            data-plasmic-override={overrides.item200}
                            className={classNames("all", sty.item200)}
                          >
                            <div
                              data-plasmic-name={"left200"}
                              data-plasmic-override={overrides.left200}
                              className={classNames("all", sty.left200)}
                            >
                              <div
                                data-plasmic-name={"icon200"}
                                data-plasmic-override={overrides.icon200}
                                className={classNames("all", sty.icon200)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hufv)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title204"}
                              data-plasmic-override={overrides.title204}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title204
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item201"}
                            data-plasmic-override={overrides.item201}
                            className={classNames("all", sty.item201)}
                          >
                            <div
                              data-plasmic-name={"left201"}
                              data-plasmic-override={overrides.left201}
                              className={classNames("all", sty.left201)}
                            >
                              <div
                                data-plasmic-name={"icon201"}
                                data-plasmic-override={overrides.icon201}
                                className={classNames("all", sty.icon201)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___4CErg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title205"}
                              data-plasmic-override={overrides.title205}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title205
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item202"}
                            data-plasmic-override={overrides.item202}
                            className={classNames("all", sty.item202)}
                          >
                            <div
                              data-plasmic-name={"left202"}
                              data-plasmic-override={overrides.left202}
                              className={classNames("all", sty.left202)}
                            >
                              <div
                                data-plasmic-name={"icon202"}
                                data-plasmic-override={overrides.icon202}
                                className={classNames("all", sty.icon202)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__lyZQh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title206"}
                              data-plasmic-override={overrides.title206}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title206
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item203"}
                            data-plasmic-override={overrides.item203}
                            className={classNames("all", sty.item203)}
                          >
                            <div
                              data-plasmic-name={"left203"}
                              data-plasmic-override={overrides.left203}
                              className={classNames("all", sty.left203)}
                            >
                              <div
                                data-plasmic-name={"icon203"}
                                data-plasmic-override={overrides.icon203}
                                className={classNames("all", sty.icon203)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__r9VtT)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title207"}
                              data-plasmic-override={overrides.title207}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title207
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item204"}
                            data-plasmic-override={overrides.item204}
                            className={classNames("all", sty.item204)}
                          >
                            <div
                              data-plasmic-name={"left204"}
                              data-plasmic-override={overrides.left204}
                              className={classNames("all", sty.left204)}
                            >
                              <div
                                data-plasmic-name={"icon204"}
                                data-plasmic-override={overrides.icon204}
                                className={classNames("all", sty.icon204)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__zbMs)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title208"}
                              data-plasmic-override={overrides.title208}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title208
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item205"}
                            data-plasmic-override={overrides.item205}
                            className={classNames("all", sty.item205)}
                          >
                            <div
                              data-plasmic-name={"left205"}
                              data-plasmic-override={overrides.left205}
                              className={classNames("all", sty.left205)}
                            >
                              <div
                                data-plasmic-name={"icon205"}
                                data-plasmic-override={overrides.icon205}
                                className={classNames("all", sty.icon205)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__le6No)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title209"}
                              data-plasmic-override={overrides.title209}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title209
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item206"}
                            data-plasmic-override={overrides.item206}
                            className={classNames("all", sty.item206)}
                          >
                            <div
                              data-plasmic-name={"left206"}
                              data-plasmic-override={overrides.left206}
                              className={classNames("all", sty.left206)}
                            >
                              <div
                                data-plasmic-name={"icon206"}
                                data-plasmic-override={overrides.icon206}
                                className={classNames("all", sty.icon206)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__zRbYt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title210"}
                              data-plasmic-override={overrides.title210}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title210
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item207"}
                            data-plasmic-override={overrides.item207}
                            className={classNames("all", sty.item207)}
                          >
                            <div
                              data-plasmic-name={"left207"}
                              data-plasmic-override={overrides.left207}
                              className={classNames("all", sty.left207)}
                            >
                              <div
                                data-plasmic-name={"icon207"}
                                data-plasmic-override={overrides.icon207}
                                className={classNames("all", sty.icon207)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dMntY)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title211"}
                              data-plasmic-override={overrides.title211}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title211
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item208"}
                            data-plasmic-override={overrides.item208}
                            className={classNames("all", sty.item208)}
                          >
                            <div
                              data-plasmic-name={"left208"}
                              data-plasmic-override={overrides.left208}
                              className={classNames("all", sty.left208)}
                            >
                              <div
                                data-plasmic-name={"icon208"}
                                data-plasmic-override={overrides.icon208}
                                className={classNames("all", sty.icon208)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ltQwD)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title212"}
                              data-plasmic-override={overrides.title212}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title212
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item209"}
                            data-plasmic-override={overrides.item209}
                            className={classNames("all", sty.item209)}
                          >
                            <div
                              data-plasmic-name={"left209"}
                              data-plasmic-override={overrides.left209}
                              className={classNames("all", sty.left209)}
                            >
                              <div
                                data-plasmic-name={"icon209"}
                                data-plasmic-override={overrides.icon209}
                                className={classNames("all", sty.icon209)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wrHtu)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title213"}
                              data-plasmic-override={overrides.title213}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title213
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item210"}
                            data-plasmic-override={overrides.item210}
                            className={classNames("all", sty.item210)}
                          >
                            <div
                              data-plasmic-name={"left210"}
                              data-plasmic-override={overrides.left210}
                              className={classNames("all", sty.left210)}
                            >
                              <div
                                data-plasmic-name={"icon210"}
                                data-plasmic-override={overrides.icon210}
                                className={classNames("all", sty.icon210)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ifjsO)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title214"}
                              data-plasmic-override={overrides.title214}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title214
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item211"}
                            data-plasmic-override={overrides.item211}
                            className={classNames("all", sty.item211)}
                          >
                            <div
                              data-plasmic-name={"left211"}
                              data-plasmic-override={overrides.left211}
                              className={classNames("all", sty.left211)}
                            >
                              <div
                                data-plasmic-name={"icon211"}
                                data-plasmic-override={overrides.icon211}
                                className={classNames("all", sty.icon211)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__nc9Ij)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title215"}
                              data-plasmic-override={overrides.title215}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title215
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item212"}
                            data-plasmic-override={overrides.item212}
                            className={classNames("all", sty.item212)}
                          >
                            <div
                              data-plasmic-name={"left212"}
                              data-plasmic-override={overrides.left212}
                              className={classNames("all", sty.left212)}
                            >
                              <div
                                data-plasmic-name={"icon212"}
                                data-plasmic-override={overrides.icon212}
                                className={classNames("all", sty.icon212)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yY81T)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title216"}
                              data-plasmic-override={overrides.title216}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title216
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item213"}
                            data-plasmic-override={overrides.item213}
                            className={classNames("all", sty.item213)}
                          >
                            <div
                              data-plasmic-name={"left213"}
                              data-plasmic-override={overrides.left213}
                              className={classNames("all", sty.left213)}
                            >
                              <div
                                data-plasmic-name={"icon213"}
                                data-plasmic-override={overrides.icon213}
                                className={classNames("all", sty.icon213)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wl8Z6)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title217"}
                              data-plasmic-override={overrides.title217}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title217
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item214"}
                            data-plasmic-override={overrides.item214}
                            className={classNames("all", sty.item214)}
                          >
                            <div
                              data-plasmic-name={"left214"}
                              data-plasmic-override={overrides.left214}
                              className={classNames("all", sty.left214)}
                            >
                              <div
                                data-plasmic-name={"icon214"}
                                data-plasmic-override={overrides.icon214}
                                className={classNames("all", sty.icon214)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fyJt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title218"}
                              data-plasmic-override={overrides.title218}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title218
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item215"}
                            data-plasmic-override={overrides.item215}
                            className={classNames("all", sty.item215)}
                          >
                            <div
                              data-plasmic-name={"left215"}
                              data-plasmic-override={overrides.left215}
                              className={classNames("all", sty.left215)}
                            >
                              <div
                                data-plasmic-name={"icon215"}
                                data-plasmic-override={overrides.icon215}
                                className={classNames("all", sty.icon215)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__nyMl)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title219"}
                              data-plasmic-override={overrides.title219}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title219
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item216"}
                            data-plasmic-override={overrides.item216}
                            className={classNames("all", sty.item216)}
                          >
                            <div
                              data-plasmic-name={"left216"}
                              data-plasmic-override={overrides.left216}
                              className={classNames("all", sty.left216)}
                            >
                              <div
                                data-plasmic-name={"icon216"}
                                data-plasmic-override={overrides.icon216}
                                className={classNames("all", sty.icon216)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__agKgg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title220"}
                              data-plasmic-override={overrides.title220}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title220
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn"}
                        data-plasmic-override={overrides.btn}
                        className={classNames("__wab_instance", sty.btn)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames("all", sty.figmaPaste)}
                >
                  <div
                    data-plasmic-name={"narrowCard3"}
                    data-plasmic-override={overrides.narrowCard3}
                    className={classNames("all", sty.narrowCard3)}
                  >
                    <div
                      data-plasmic-name={"header14"}
                      data-plasmic-override={overrides.header14}
                      className={classNames("all", sty.header14)}
                    >
                      <div
                        data-plasmic-name={"title221"}
                        data-plasmic-override={overrides.title221}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title221
                        )}
                      >
                        {"Educational Operations"}
                      </div>
                      <Icon96Icon
                        className={classNames("all", sty.svg__hJh1J)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content3"}
                      data-plasmic-override={overrides.content3}
                      className={classNames("all", sty.content3)}
                    >
                      <div
                        data-plasmic-name={"desc3"}
                        data-plasmic-override={overrides.desc3}
                        className={classNames("all", "__wab_text", sty.desc3)}
                      >
                        {
                          "Manage the day-to-day activities that keep educational programs running efficiently."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder3"}
                        data-plasmic-override={overrides.placeholder3}
                        className={classNames("all", sty.placeholder3)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header15"}
                            data-plasmic-override={overrides.header15}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header15
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list17"}
                          data-plasmic-override={overrides.list17}
                          className={classNames("all", sty.list17)}
                        >
                          <div
                            data-plasmic-name={"item217"}
                            data-plasmic-override={overrides.item217}
                            className={classNames("all", sty.item217)}
                          >
                            <div
                              data-plasmic-name={"left217"}
                              data-plasmic-override={overrides.left217}
                              className={classNames("all", sty.left217)}
                            >
                              <div
                                data-plasmic-name={"icon217"}
                                data-plasmic-override={overrides.icon217}
                                className={classNames("all", sty.icon217)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___4S01R)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title222"}
                              data-plasmic-override={overrides.title222}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title222
                              )}
                            >
                              {"Clinical Hours"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item218"}
                            data-plasmic-override={overrides.item218}
                            className={classNames("all", sty.item218)}
                          >
                            <div
                              data-plasmic-name={"left218"}
                              data-plasmic-override={overrides.left218}
                              className={classNames("all", sty.left218)}
                            >
                              <div
                                data-plasmic-name={"icon218"}
                                data-plasmic-override={overrides.icon218}
                                className={classNames("all", sty.icon218)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jtLWg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title223"}
                              data-plasmic-override={overrides.title223}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title223
                              )}
                            >
                              {"MyQuickPass\u00ae"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item219"}
                            data-plasmic-override={overrides.item219}
                            className={classNames("all", sty.item219)}
                          >
                            <div
                              data-plasmic-name={"left219"}
                              data-plasmic-override={overrides.left219}
                              className={classNames("all", sty.left219)}
                            >
                              <div
                                data-plasmic-name={"icon219"}
                                data-plasmic-override={overrides.icon219}
                                className={classNames("all", sty.icon219)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gbuqp)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title224"}
                              data-plasmic-override={overrides.title224}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title224
                              )}
                            >
                              {"Scheduling"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item220"}
                            data-plasmic-override={overrides.item220}
                            className={classNames("all", sty.item220)}
                          >
                            <div
                              data-plasmic-name={"left220"}
                              data-plasmic-override={overrides.left220}
                              className={classNames("all", sty.left220)}
                            >
                              <div
                                data-plasmic-name={"icon220"}
                                data-plasmic-override={overrides.icon220}
                                className={classNames("all", sty.icon220)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kiCg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title225"}
                              data-plasmic-override={overrides.title225}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title225
                              )}
                            >
                              {"Automated Scheduling & Lottery"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item221"}
                            data-plasmic-override={overrides.item221}
                            className={classNames("all", sty.item221)}
                          >
                            <div
                              data-plasmic-name={"left221"}
                              data-plasmic-override={overrides.left221}
                              className={classNames("all", sty.left221)}
                            >
                              <div
                                data-plasmic-name={"icon221"}
                                data-plasmic-override={overrides.icon221}
                                className={classNames("all", sty.icon221)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___3XmA9)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title226"}
                              data-plasmic-override={overrides.title226}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title226
                              )}
                            >
                              {"Conference Tracking"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item222"}
                            data-plasmic-override={overrides.item222}
                            className={classNames("all", sty.item222)}
                          >
                            <div
                              data-plasmic-name={"left222"}
                              data-plasmic-override={overrides.left222}
                              className={classNames("all", sty.left222)}
                            >
                              <div
                                data-plasmic-name={"icon222"}
                                data-plasmic-override={overrides.icon222}
                                className={classNames("all", sty.icon222)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__db3Tb)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title227"}
                              data-plasmic-override={overrides.title227}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title227
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item223"}
                            data-plasmic-override={overrides.item223}
                            className={classNames("all", sty.item223)}
                          >
                            <div
                              data-plasmic-name={"left223"}
                              data-plasmic-override={overrides.left223}
                              className={classNames("all", sty.left223)}
                            >
                              <div
                                data-plasmic-name={"icon223"}
                                data-plasmic-override={overrides.icon223}
                                className={classNames("all", sty.icon223)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__do48U)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title228"}
                              data-plasmic-override={overrides.title228}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title228
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item224"}
                              data-plasmic-override={overrides.item224}
                              className={classNames("all", sty.item224)}
                            >
                              <div
                                data-plasmic-name={"left224"}
                                data-plasmic-override={overrides.left224}
                                className={classNames("all", sty.left224)}
                              >
                                <div
                                  data-plasmic-name={"icon224"}
                                  data-plasmic-override={overrides.icon224}
                                  className={classNames("all", sty.icon224)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pRYrm
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title229"}
                                data-plasmic-override={overrides.title229}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title229
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item225"}
                              data-plasmic-override={overrides.item225}
                              className={classNames("all", sty.item225)}
                            >
                              <div
                                data-plasmic-name={"left225"}
                                data-plasmic-override={overrides.left225}
                                className={classNames("all", sty.left225)}
                              >
                                <div
                                  data-plasmic-name={"icon225"}
                                  data-plasmic-override={overrides.icon225}
                                  className={classNames("all", sty.icon225)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__w5NPj
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title230"}
                                data-plasmic-override={overrides.title230}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title230
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item226"}
                              data-plasmic-override={overrides.item226}
                              className={classNames("all", sty.item226)}
                            >
                              <div
                                data-plasmic-name={"left226"}
                                data-plasmic-override={overrides.left226}
                                className={classNames("all", sty.left226)}
                              >
                                <div
                                  data-plasmic-name={"icon226"}
                                  data-plasmic-override={overrides.icon226}
                                  className={classNames("all", sty.icon226)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__mO4D5
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title231"}
                                data-plasmic-override={overrides.title231}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title231
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item227"}
                              data-plasmic-override={overrides.item227}
                              className={classNames("all", sty.item227)}
                            >
                              <div
                                data-plasmic-name={"left227"}
                                data-plasmic-override={overrides.left227}
                                className={classNames("all", sty.left227)}
                              >
                                <div
                                  data-plasmic-name={"icon227"}
                                  data-plasmic-override={overrides.icon227}
                                  className={classNames("all", sty.icon227)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__xiKbv
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title232"}
                                data-plasmic-override={overrides.title232}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title232
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item228"}
                              data-plasmic-override={overrides.item228}
                              className={classNames("all", sty.item228)}
                            >
                              <div
                                data-plasmic-name={"left228"}
                                data-plasmic-override={overrides.left228}
                                className={classNames("all", sty.left228)}
                              >
                                <div
                                  data-plasmic-name={"icon228"}
                                  data-plasmic-override={overrides.icon228}
                                  className={classNames("all", sty.icon228)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___9S06
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title233"}
                                data-plasmic-override={overrides.title233}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title233
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item229"}
                              data-plasmic-override={overrides.item229}
                              className={classNames("all", sty.item229)}
                            >
                              <div
                                data-plasmic-name={"left229"}
                                data-plasmic-override={overrides.left229}
                                className={classNames("all", sty.left229)}
                              >
                                <div
                                  data-plasmic-name={"icon229"}
                                  data-plasmic-override={overrides.icon229}
                                  className={classNames("all", sty.icon229)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pch4G
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title234"}
                                data-plasmic-override={overrides.title234}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title234
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item230"}
                              data-plasmic-override={overrides.item230}
                              className={classNames("all", sty.item230)}
                            >
                              <div
                                data-plasmic-name={"left230"}
                                data-plasmic-override={overrides.left230}
                                className={classNames("all", sty.left230)}
                              >
                                <div
                                  data-plasmic-name={"icon230"}
                                  data-plasmic-override={overrides.icon230}
                                  className={classNames("all", sty.icon230)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___8EE1D
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title235"}
                                data-plasmic-override={overrides.title235}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title235
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item231"}
                              data-plasmic-override={overrides.item231}
                              className={classNames("all", sty.item231)}
                            >
                              <div
                                data-plasmic-name={"left231"}
                                data-plasmic-override={overrides.left231}
                                className={classNames("all", sty.left231)}
                              >
                                <div
                                  data-plasmic-name={"icon231"}
                                  data-plasmic-override={overrides.icon231}
                                  className={classNames("all", sty.icon231)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__jvlEt
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title236"}
                                data-plasmic-override={overrides.title236}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title236
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item232"}
                              data-plasmic-override={overrides.item232}
                              className={classNames("all", sty.item232)}
                            >
                              <div
                                data-plasmic-name={"left232"}
                                data-plasmic-override={overrides.left232}
                                className={classNames("all", sty.left232)}
                              >
                                <div
                                  data-plasmic-name={"icon232"}
                                  data-plasmic-override={overrides.icon232}
                                  className={classNames("all", sty.icon232)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__jlssf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title237"}
                                data-plasmic-override={overrides.title237}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title237
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item233"}
                              data-plasmic-override={overrides.item233}
                              className={classNames("all", sty.item233)}
                            >
                              <div
                                data-plasmic-name={"left233"}
                                data-plasmic-override={overrides.left233}
                                className={classNames("all", sty.left233)}
                              >
                                <div
                                  data-plasmic-name={"icon233"}
                                  data-plasmic-override={overrides.icon233}
                                  className={classNames("all", sty.icon233)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__r81B)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title238"}
                                data-plasmic-override={overrides.title238}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title238
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item234"}
                              data-plasmic-override={overrides.item234}
                              className={classNames("all", sty.item234)}
                            >
                              <div
                                data-plasmic-name={"left234"}
                                data-plasmic-override={overrides.left234}
                                className={classNames("all", sty.left234)}
                              >
                                <div
                                  data-plasmic-name={"icon234"}
                                  data-plasmic-override={overrides.icon234}
                                  className={classNames("all", sty.icon234)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__iMqed
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title239"}
                                data-plasmic-override={overrides.title239}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title239
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item235"}
                              data-plasmic-override={overrides.item235}
                              className={classNames("all", sty.item235)}
                            >
                              <div
                                data-plasmic-name={"left235"}
                                data-plasmic-override={overrides.left235}
                                className={classNames("all", sty.left235)}
                              >
                                <div
                                  data-plasmic-name={"icon235"}
                                  data-plasmic-override={overrides.icon235}
                                  className={classNames("all", sty.icon235)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__o8C7)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title240"}
                                data-plasmic-override={overrides.title240}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title240
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item236"}
                              data-plasmic-override={overrides.item236}
                              className={classNames("all", sty.item236)}
                            >
                              <div
                                data-plasmic-name={"left236"}
                                data-plasmic-override={overrides.left236}
                                className={classNames("all", sty.left236)}
                              >
                                <div
                                  data-plasmic-name={"icon236"}
                                  data-plasmic-override={overrides.icon236}
                                  className={classNames("all", sty.icon236)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___2BKc8
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title241"}
                                data-plasmic-override={overrides.title241}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title241
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item237"}
                              data-plasmic-override={overrides.item237}
                              className={classNames("all", sty.item237)}
                            >
                              <div
                                data-plasmic-name={"left237"}
                                data-plasmic-override={overrides.left237}
                                className={classNames("all", sty.left237)}
                              >
                                <div
                                  data-plasmic-name={"icon237"}
                                  data-plasmic-override={overrides.icon237}
                                  className={classNames("all", sty.icon237)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__cweea
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title242"}
                                data-plasmic-override={overrides.title242}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title242
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item238"}
                              data-plasmic-override={overrides.item238}
                              className={classNames("all", sty.item238)}
                            >
                              <div
                                data-plasmic-name={"left238"}
                                data-plasmic-override={overrides.left238}
                                className={classNames("all", sty.left238)}
                              >
                                <div
                                  data-plasmic-name={"icon238"}
                                  data-plasmic-override={overrides.icon238}
                                  className={classNames("all", sty.icon238)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__miyzf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title243"}
                                data-plasmic-override={overrides.title243}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title243
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item239"}
                              data-plasmic-override={overrides.item239}
                              className={classNames("all", sty.item239)}
                            >
                              <div
                                data-plasmic-name={"left239"}
                                data-plasmic-override={overrides.left239}
                                className={classNames("all", sty.left239)}
                              >
                                <div
                                  data-plasmic-name={"icon239"}
                                  data-plasmic-override={overrides.icon239}
                                  className={classNames("all", sty.icon239)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___1NbxH
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title244"}
                                data-plasmic-override={overrides.title244}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title244
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item240"}
                              data-plasmic-override={overrides.item240}
                              className={classNames("all", sty.item240)}
                            >
                              <div
                                data-plasmic-name={"left240"}
                                data-plasmic-override={overrides.left240}
                                className={classNames("all", sty.left240)}
                              >
                                <div
                                  data-plasmic-name={"icon240"}
                                  data-plasmic-override={overrides.icon240}
                                  className={classNames("all", sty.icon240)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___01MyL
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title245"}
                                data-plasmic-override={overrides.title245}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title245
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn3"}
                          data-plasmic-override={overrides.btn3}
                          className={classNames("__wab_instance", sty.btn3)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard2"}
                    data-plasmic-override={overrides.narrowCard2}
                    className={classNames("all", sty.narrowCard2)}
                  >
                    <div
                      data-plasmic-name={"header16"}
                      data-plasmic-override={overrides.header16}
                      className={classNames("all", sty.header16)}
                    >
                      <div
                        data-plasmic-name={"title246"}
                        data-plasmic-override={overrides.title246}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title246
                        )}
                      >
                        {"Learning & Development"}
                      </div>
                      <Icon95Icon
                        className={classNames("all", sty.svg__vmcOh)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content2"}
                      data-plasmic-override={overrides.content2}
                      className={classNames("all", sty.content2)}
                    >
                      <div
                        data-plasmic-name={"desc2"}
                        data-plasmic-override={overrides.desc2}
                        className={classNames("all", "__wab_text", sty.desc2)}
                      >
                        {
                          "Support learner growth through integrated educational resources and competency development."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder2"}
                        data-plasmic-override={overrides.placeholder2}
                        className={classNames("all", sty.placeholder2)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header17"}
                            data-plasmic-override={overrides.header17}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header17
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list18"}
                          data-plasmic-override={overrides.list18}
                          className={classNames("all", sty.list18)}
                        >
                          <div
                            data-plasmic-name={"item241"}
                            data-plasmic-override={overrides.item241}
                            className={classNames("all", sty.item241)}
                          >
                            <div
                              data-plasmic-name={"left241"}
                              data-plasmic-override={overrides.left241}
                              className={classNames("all", sty.left241)}
                            >
                              <div
                                data-plasmic-name={"icon241"}
                                data-plasmic-override={overrides.icon241}
                                className={classNames("all", sty.icon241)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hofNd)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title247"}
                              data-plasmic-override={overrides.title247}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title247
                              )}
                            >
                              {"Learning Assignments"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item242"}
                            data-plasmic-override={overrides.item242}
                            className={classNames("all", sty.item242)}
                          >
                            <div
                              data-plasmic-name={"left242"}
                              data-plasmic-override={overrides.left242}
                              className={classNames("all", sty.left242)}
                            >
                              <div
                                data-plasmic-name={"icon242"}
                                data-plasmic-override={overrides.icon242}
                                className={classNames("all", sty.icon242)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kFMz)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title248"}
                              data-plasmic-override={overrides.title248}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title248
                              )}
                            >
                              {"MyQuiz\u2122"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item243"}
                            data-plasmic-override={overrides.item243}
                            className={classNames("all", sty.item243)}
                          >
                            <div
                              data-plasmic-name={"left243"}
                              data-plasmic-override={overrides.left243}
                              className={classNames("all", sty.left243)}
                            >
                              <div
                                data-plasmic-name={"icon243"}
                                data-plasmic-override={overrides.icon243}
                                className={classNames("all", sty.icon243)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__snBhu)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title249"}
                              data-plasmic-override={overrides.title249}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title249
                              )}
                            >
                              {"MyPortfolios\u00ae"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item244"}
                            data-plasmic-override={overrides.item244}
                            className={classNames("all", sty.item244)}
                          >
                            <div
                              data-plasmic-name={"left244"}
                              data-plasmic-override={overrides.left244}
                              className={classNames("all", sty.left244)}
                            >
                              <div
                                data-plasmic-name={"icon244"}
                                data-plasmic-override={overrides.icon244}
                                className={classNames("all", sty.icon244)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ps7Fp)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title250"}
                              data-plasmic-override={overrides.title250}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title250
                              )}
                            >
                              {"Curriculum Management"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item245"}
                            data-plasmic-override={overrides.item245}
                            className={classNames("all", sty.item245)}
                          >
                            <div
                              data-plasmic-name={"left245"}
                              data-plasmic-override={overrides.left245}
                              className={classNames("all", sty.left245)}
                            >
                              <div
                                data-plasmic-name={"icon245"}
                                data-plasmic-override={overrides.icon245}
                                className={classNames("all", sty.icon245)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___6YzSe)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title251"}
                              data-plasmic-override={overrides.title251}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title251
                              )}
                            >
                              {"Certificate & Diploma Management"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item246"}
                              data-plasmic-override={overrides.item246}
                              className={classNames("all", sty.item246)}
                            >
                              <div
                                data-plasmic-name={"left246"}
                                data-plasmic-override={overrides.left246}
                                className={classNames("all", sty.left246)}
                              >
                                <div
                                  data-plasmic-name={"icon246"}
                                  data-plasmic-override={overrides.icon246}
                                  className={classNames("all", sty.icon246)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__epK89
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title252"}
                                data-plasmic-override={overrides.title252}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title252
                                )}
                              >
                                {"Burnout Monitoring"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item247"}
                              data-plasmic-override={overrides.item247}
                              className={classNames("all", sty.item247)}
                            >
                              <div
                                data-plasmic-name={"left247"}
                                data-plasmic-override={overrides.left247}
                                className={classNames("all", sty.left247)}
                              >
                                <div
                                  data-plasmic-name={"icon247"}
                                  data-plasmic-override={overrides.icon247}
                                  className={classNames("all", sty.icon247)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__h8HsM
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title253"}
                                data-plasmic-override={overrides.title253}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title253
                                )}
                              >
                                {"Demographic Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item248"}
                              data-plasmic-override={overrides.item248}
                              className={classNames("all", sty.item248)}
                            >
                              <div
                                data-plasmic-name={"left248"}
                                data-plasmic-override={overrides.left248}
                                className={classNames("all", sty.left248)}
                              >
                                <div
                                  data-plasmic-name={"icon248"}
                                  data-plasmic-override={overrides.icon248}
                                  className={classNames("all", sty.icon248)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__pzWW)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title254"}
                                data-plasmic-override={overrides.title254}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title254
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item249"}
                              data-plasmic-override={overrides.item249}
                              className={classNames("all", sty.item249)}
                            >
                              <div
                                data-plasmic-name={"left249"}
                                data-plasmic-override={overrides.left249}
                                className={classNames("all", sty.left249)}
                              >
                                <div
                                  data-plasmic-name={"icon249"}
                                  data-plasmic-override={overrides.icon249}
                                  className={classNames("all", sty.icon249)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__smpJs
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title255"}
                                data-plasmic-override={overrides.title255}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title255
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item250"}
                              data-plasmic-override={overrides.item250}
                              className={classNames("all", sty.item250)}
                            >
                              <div
                                data-plasmic-name={"left250"}
                                data-plasmic-override={overrides.left250}
                                className={classNames("all", sty.left250)}
                              >
                                <div
                                  data-plasmic-name={"icon250"}
                                  data-plasmic-override={overrides.icon250}
                                  className={classNames("all", sty.icon250)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__giym2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title256"}
                                data-plasmic-override={overrides.title256}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title256
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item251"}
                              data-plasmic-override={overrides.item251}
                              className={classNames("all", sty.item251)}
                            >
                              <div
                                data-plasmic-name={"left251"}
                                data-plasmic-override={overrides.left251}
                                className={classNames("all", sty.left251)}
                              >
                                <div
                                  data-plasmic-name={"icon251"}
                                  data-plasmic-override={overrides.icon251}
                                  className={classNames("all", sty.icon251)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__vNp7U
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title257"}
                                data-plasmic-override={overrides.title257}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title257
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item252"}
                              data-plasmic-override={overrides.item252}
                              className={classNames("all", sty.item252)}
                            >
                              <div
                                data-plasmic-name={"left252"}
                                data-plasmic-override={overrides.left252}
                                className={classNames("all", sty.left252)}
                              >
                                <div
                                  data-plasmic-name={"icon252"}
                                  data-plasmic-override={overrides.icon252}
                                  className={classNames("all", sty.icon252)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__vs5Bh
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title258"}
                                data-plasmic-override={overrides.title258}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title258
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item253"}
                              data-plasmic-override={overrides.item253}
                              className={classNames("all", sty.item253)}
                            >
                              <div
                                data-plasmic-name={"left253"}
                                data-plasmic-override={overrides.left253}
                                className={classNames("all", sty.left253)}
                              >
                                <div
                                  data-plasmic-name={"icon253"}
                                  data-plasmic-override={overrides.icon253}
                                  className={classNames("all", sty.icon253)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__wAeFn
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title259"}
                                data-plasmic-override={overrides.title259}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title259
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item254"}
                              data-plasmic-override={overrides.item254}
                              className={classNames("all", sty.item254)}
                            >
                              <div
                                data-plasmic-name={"left254"}
                                data-plasmic-override={overrides.left254}
                                className={classNames("all", sty.left254)}
                              >
                                <div
                                  data-plasmic-name={"icon254"}
                                  data-plasmic-override={overrides.icon254}
                                  className={classNames("all", sty.icon254)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__f51ZO
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title260"}
                                data-plasmic-override={overrides.title260}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title260
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item255"}
                              data-plasmic-override={overrides.item255}
                              className={classNames("all", sty.item255)}
                            >
                              <div
                                data-plasmic-name={"left255"}
                                data-plasmic-override={overrides.left255}
                                className={classNames("all", sty.left255)}
                              >
                                <div
                                  data-plasmic-name={"icon255"}
                                  data-plasmic-override={overrides.icon255}
                                  className={classNames("all", sty.icon255)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__mppTg
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title261"}
                                data-plasmic-override={overrides.title261}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title261
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item256"}
                              data-plasmic-override={overrides.item256}
                              className={classNames("all", sty.item256)}
                            >
                              <div
                                data-plasmic-name={"left256"}
                                data-plasmic-override={overrides.left256}
                                className={classNames("all", sty.left256)}
                              >
                                <div
                                  data-plasmic-name={"icon256"}
                                  data-plasmic-override={overrides.icon256}
                                  className={classNames("all", sty.icon256)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__sg0Qq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title262"}
                                data-plasmic-override={overrides.title262}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title262
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item257"}
                              data-plasmic-override={overrides.item257}
                              className={classNames("all", sty.item257)}
                            >
                              <div
                                data-plasmic-name={"left257"}
                                data-plasmic-override={overrides.left257}
                                className={classNames("all", sty.left257)}
                              >
                                <div
                                  data-plasmic-name={"icon257"}
                                  data-plasmic-override={overrides.icon257}
                                  className={classNames("all", sty.icon257)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ca6Wf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title263"}
                                data-plasmic-override={overrides.title263}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title263
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item258"}
                              data-plasmic-override={overrides.item258}
                              className={classNames("all", sty.item258)}
                            >
                              <div
                                data-plasmic-name={"left258"}
                                data-plasmic-override={overrides.left258}
                                className={classNames("all", sty.left258)}
                              >
                                <div
                                  data-plasmic-name={"icon258"}
                                  data-plasmic-override={overrides.icon258}
                                  className={classNames("all", sty.icon258)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qzSee
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title264"}
                                data-plasmic-override={overrides.title264}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title264
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item259"}
                              data-plasmic-override={overrides.item259}
                              className={classNames("all", sty.item259)}
                            >
                              <div
                                data-plasmic-name={"left259"}
                                data-plasmic-override={overrides.left259}
                                className={classNames("all", sty.left259)}
                              >
                                <div
                                  data-plasmic-name={"icon259"}
                                  data-plasmic-override={overrides.icon259}
                                  className={classNames("all", sty.icon259)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__q1PX8
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title265"}
                                data-plasmic-override={overrides.title265}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title265
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item260"}
                              data-plasmic-override={overrides.item260}
                              className={classNames("all", sty.item260)}
                            >
                              <div
                                data-plasmic-name={"left260"}
                                data-plasmic-override={overrides.left260}
                                className={classNames("all", sty.left260)}
                              >
                                <div
                                  data-plasmic-name={"icon260"}
                                  data-plasmic-override={overrides.icon260}
                                  className={classNames("all", sty.icon260)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__yKzqj
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title266"}
                                data-plasmic-override={overrides.title266}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title266
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item261"}
                              data-plasmic-override={overrides.item261}
                              className={classNames("all", sty.item261)}
                            >
                              <div
                                data-plasmic-name={"left261"}
                                data-plasmic-override={overrides.left261}
                                className={classNames("all", sty.left261)}
                              >
                                <div
                                  data-plasmic-name={"icon261"}
                                  data-plasmic-override={overrides.icon261}
                                  className={classNames("all", sty.icon261)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__s24CD
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title267"}
                                data-plasmic-override={overrides.title267}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title267
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item262"}
                              data-plasmic-override={overrides.item262}
                              className={classNames("all", sty.item262)}
                            >
                              <div
                                data-plasmic-name={"left262"}
                                data-plasmic-override={overrides.left262}
                                className={classNames("all", sty.left262)}
                              >
                                <div
                                  data-plasmic-name={"icon262"}
                                  data-plasmic-override={overrides.icon262}
                                  className={classNames("all", sty.icon262)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__hdp9J
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title268"}
                                data-plasmic-override={overrides.title268}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title268
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item263"}
                              data-plasmic-override={overrides.item263}
                              className={classNames("all", sty.item263)}
                            >
                              <div
                                data-plasmic-name={"left263"}
                                data-plasmic-override={overrides.left263}
                                className={classNames("all", sty.left263)}
                              >
                                <div
                                  data-plasmic-name={"icon263"}
                                  data-plasmic-override={overrides.icon263}
                                  className={classNames("all", sty.icon263)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__bVHnJ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title269"}
                                data-plasmic-override={overrides.title269}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title269
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item264"}
                              data-plasmic-override={overrides.item264}
                              className={classNames("all", sty.item264)}
                            >
                              <div
                                data-plasmic-name={"left264"}
                                data-plasmic-override={overrides.left264}
                                className={classNames("all", sty.left264)}
                              >
                                <div
                                  data-plasmic-name={"icon264"}
                                  data-plasmic-override={overrides.icon264}
                                  className={classNames("all", sty.icon264)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zhnGb
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title270"}
                                data-plasmic-override={overrides.title270}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title270
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn2"}
                          data-plasmic-override={overrides.btn2}
                          className={classNames("__wab_instance", sty.btn2)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"row3"}
                data-plasmic-override={overrides.row3}
                className={classNames("all", sty.row3)}
              >
                <div
                  data-plasmic-name={"figmaPaste2"}
                  data-plasmic-override={overrides.figmaPaste2}
                  className={classNames("all", sty.figmaPaste2)}
                >
                  <div
                    data-plasmic-name={"narrowCard4"}
                    data-plasmic-override={overrides.narrowCard4}
                    className={classNames("all", sty.narrowCard4)}
                  >
                    <div
                      data-plasmic-name={"header18"}
                      data-plasmic-override={overrides.header18}
                      className={classNames("all", sty.header18)}
                    >
                      <div
                        data-plasmic-name={"title271"}
                        data-plasmic-override={overrides.title271}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title271
                        )}
                      >
                        {"Administrative Management"}
                      </div>
                      <Icon99Icon
                        className={classNames("all", sty.svg__c8Xa)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content4"}
                      data-plasmic-override={overrides.content4}
                      className={classNames("all", sty.content4)}
                    >
                      <div
                        data-plasmic-name={"desc4"}
                        data-plasmic-override={overrides.desc4}
                        className={classNames("all", "__wab_text", sty.desc4)}
                      >
                        {
                          "Simplify administrative workflows while supporting learners, faculty, and institutional leadership."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder4"}
                        data-plasmic-override={overrides.placeholder4}
                        className={classNames("all", sty.placeholder4)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header19"}
                            data-plasmic-override={overrides.header19}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header19
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list19"}
                          data-plasmic-override={overrides.list19}
                          className={classNames("all", sty.list19)}
                        >
                          <div
                            data-plasmic-name={"item265"}
                            data-plasmic-override={overrides.item265}
                            className={classNames("all", sty.item265)}
                          >
                            <div
                              data-plasmic-name={"left265"}
                              data-plasmic-override={overrides.left265}
                              className={classNames("all", sty.left265)}
                            >
                              <div
                                data-plasmic-name={"icon265"}
                                data-plasmic-override={overrides.icon265}
                                className={classNames("all", sty.icon265)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dWaWf)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title272"}
                              data-plasmic-override={overrides.title272}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title272
                              )}
                            >
                              {"Onboarding & Credentialing"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item266"}
                            data-plasmic-override={overrides.item266}
                            className={classNames("all", sty.item266)}
                          >
                            <div
                              data-plasmic-name={"left266"}
                              data-plasmic-override={overrides.left266}
                              className={classNames("all", sty.left266)}
                            >
                              <div
                                data-plasmic-name={"icon266"}
                                data-plasmic-override={overrides.icon266}
                                className={classNames("all", sty.icon266)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__s08Q0)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title273"}
                              data-plasmic-override={overrides.title273}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title273
                              )}
                            >
                              {"Electronic Agreements & Signatures"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item267"}
                            data-plasmic-override={overrides.item267}
                            className={classNames("all", sty.item267)}
                          >
                            <div
                              data-plasmic-name={"left267"}
                              data-plasmic-override={overrides.left267}
                              className={classNames("all", sty.left267)}
                            >
                              <div
                                data-plasmic-name={"icon267"}
                                data-plasmic-override={overrides.icon267}
                                className={classNames("all", sty.icon267)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__htjOy)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title274"}
                              data-plasmic-override={overrides.title274}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title274
                              )}
                            >
                              {"Custom Reporting"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item268"}
                              data-plasmic-override={overrides.item268}
                              className={classNames("all", sty.item268)}
                            >
                              <div
                                data-plasmic-name={"left268"}
                                data-plasmic-override={overrides.left268}
                                className={classNames("all", sty.left268)}
                              >
                                <div
                                  data-plasmic-name={"icon268"}
                                  data-plasmic-override={overrides.icon268}
                                  className={classNames("all", sty.icon268)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zRVhg
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title275"}
                                data-plasmic-override={overrides.title275}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title275
                                )}
                              >
                                {"Curriculum Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item269"}
                              data-plasmic-override={overrides.item269}
                              className={classNames("all", sty.item269)}
                            >
                              <div
                                data-plasmic-name={"left269"}
                                data-plasmic-override={overrides.left269}
                                className={classNames("all", sty.left269)}
                              >
                                <div
                                  data-plasmic-name={"icon269"}
                                  data-plasmic-override={overrides.icon269}
                                  className={classNames("all", sty.icon269)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fv0Hg
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title276"}
                                data-plasmic-override={overrides.title276}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title276
                                )}
                              >
                                {"Certificate & Diploma Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item270"}
                              data-plasmic-override={overrides.item270}
                              className={classNames("all", sty.item270)}
                            >
                              <div
                                data-plasmic-name={"left270"}
                                data-plasmic-override={overrides.left270}
                                className={classNames("all", sty.left270)}
                              >
                                <div
                                  data-plasmic-name={"icon270"}
                                  data-plasmic-override={overrides.icon270}
                                  className={classNames("all", sty.icon270)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___8XCl
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title277"}
                                data-plasmic-override={overrides.title277}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title277
                                )}
                              >
                                {"Burnout Monitoring"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item271"}
                              data-plasmic-override={overrides.item271}
                              className={classNames("all", sty.item271)}
                            >
                              <div
                                data-plasmic-name={"left271"}
                                data-plasmic-override={overrides.left271}
                                className={classNames("all", sty.left271)}
                              >
                                <div
                                  data-plasmic-name={"icon271"}
                                  data-plasmic-override={overrides.icon271}
                                  className={classNames("all", sty.icon271)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__wnhC3
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title278"}
                                data-plasmic-override={overrides.title278}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title278
                                )}
                              >
                                {"Demographic Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item272"}
                              data-plasmic-override={overrides.item272}
                              className={classNames("all", sty.item272)}
                            >
                              <div
                                data-plasmic-name={"left272"}
                                data-plasmic-override={overrides.left272}
                                className={classNames("all", sty.left272)}
                              >
                                <div
                                  data-plasmic-name={"icon272"}
                                  data-plasmic-override={overrides.icon272}
                                  className={classNames("all", sty.icon272)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__h5C3E
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title279"}
                                data-plasmic-override={overrides.title279}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title279
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item273"}
                              data-plasmic-override={overrides.item273}
                              className={classNames("all", sty.item273)}
                            >
                              <div
                                data-plasmic-name={"left273"}
                                data-plasmic-override={overrides.left273}
                                className={classNames("all", sty.left273)}
                              >
                                <div
                                  data-plasmic-name={"icon273"}
                                  data-plasmic-override={overrides.icon273}
                                  className={classNames("all", sty.icon273)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__tCqpF
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title280"}
                                data-plasmic-override={overrides.title280}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title280
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item274"}
                              data-plasmic-override={overrides.item274}
                              className={classNames("all", sty.item274)}
                            >
                              <div
                                data-plasmic-name={"left274"}
                                data-plasmic-override={overrides.left274}
                                className={classNames("all", sty.left274)}
                              >
                                <div
                                  data-plasmic-name={"icon274"}
                                  data-plasmic-override={overrides.icon274}
                                  className={classNames("all", sty.icon274)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___0SYxJ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title281"}
                                data-plasmic-override={overrides.title281}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title281
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item275"}
                              data-plasmic-override={overrides.item275}
                              className={classNames("all", sty.item275)}
                            >
                              <div
                                data-plasmic-name={"left275"}
                                data-plasmic-override={overrides.left275}
                                className={classNames("all", sty.left275)}
                              >
                                <div
                                  data-plasmic-name={"icon275"}
                                  data-plasmic-override={overrides.icon275}
                                  className={classNames("all", sty.icon275)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__uCaSq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title282"}
                                data-plasmic-override={overrides.title282}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title282
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item276"}
                              data-plasmic-override={overrides.item276}
                              className={classNames("all", sty.item276)}
                            >
                              <div
                                data-plasmic-name={"left276"}
                                data-plasmic-override={overrides.left276}
                                className={classNames("all", sty.left276)}
                              >
                                <div
                                  data-plasmic-name={"icon276"}
                                  data-plasmic-override={overrides.icon276}
                                  className={classNames("all", sty.icon276)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___9TaVt
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title283"}
                                data-plasmic-override={overrides.title283}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title283
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item277"}
                              data-plasmic-override={overrides.item277}
                              className={classNames("all", sty.item277)}
                            >
                              <div
                                data-plasmic-name={"left277"}
                                data-plasmic-override={overrides.left277}
                                className={classNames("all", sty.left277)}
                              >
                                <div
                                  data-plasmic-name={"icon277"}
                                  data-plasmic-override={overrides.icon277}
                                  className={classNames("all", sty.icon277)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___3IEb6
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title284"}
                                data-plasmic-override={overrides.title284}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title284
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item278"}
                              data-plasmic-override={overrides.item278}
                              className={classNames("all", sty.item278)}
                            >
                              <div
                                data-plasmic-name={"left278"}
                                data-plasmic-override={overrides.left278}
                                className={classNames("all", sty.left278)}
                              >
                                <div
                                  data-plasmic-name={"icon278"}
                                  data-plasmic-override={overrides.icon278}
                                  className={classNames("all", sty.icon278)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__vjDs)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title285"}
                                data-plasmic-override={overrides.title285}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title285
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item279"}
                              data-plasmic-override={overrides.item279}
                              className={classNames("all", sty.item279)}
                            >
                              <div
                                data-plasmic-name={"left279"}
                                data-plasmic-override={overrides.left279}
                                className={classNames("all", sty.left279)}
                              >
                                <div
                                  data-plasmic-name={"icon279"}
                                  data-plasmic-override={overrides.icon279}
                                  className={classNames("all", sty.icon279)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__tBgp)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title286"}
                                data-plasmic-override={overrides.title286}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title286
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item280"}
                              data-plasmic-override={overrides.item280}
                              className={classNames("all", sty.item280)}
                            >
                              <div
                                data-plasmic-name={"left280"}
                                data-plasmic-override={overrides.left280}
                                className={classNames("all", sty.left280)}
                              >
                                <div
                                  data-plasmic-name={"icon280"}
                                  data-plasmic-override={overrides.icon280}
                                  className={classNames("all", sty.icon280)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rfnlO
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title287"}
                                data-plasmic-override={overrides.title287}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title287
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item281"}
                              data-plasmic-override={overrides.item281}
                              className={classNames("all", sty.item281)}
                            >
                              <div
                                data-plasmic-name={"left281"}
                                data-plasmic-override={overrides.left281}
                                className={classNames("all", sty.left281)}
                              >
                                <div
                                  data-plasmic-name={"icon281"}
                                  data-plasmic-override={overrides.icon281}
                                  className={classNames("all", sty.icon281)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__u3FzC
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title288"}
                                data-plasmic-override={overrides.title288}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title288
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item282"}
                              data-plasmic-override={overrides.item282}
                              className={classNames("all", sty.item282)}
                            >
                              <div
                                data-plasmic-name={"left282"}
                                data-plasmic-override={overrides.left282}
                                className={classNames("all", sty.left282)}
                              >
                                <div
                                  data-plasmic-name={"icon282"}
                                  data-plasmic-override={overrides.icon282}
                                  className={classNames("all", sty.icon282)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___4LlLf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title289"}
                                data-plasmic-override={overrides.title289}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title289
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item283"}
                              data-plasmic-override={overrides.item283}
                              className={classNames("all", sty.item283)}
                            >
                              <div
                                data-plasmic-name={"left283"}
                                data-plasmic-override={overrides.left283}
                                className={classNames("all", sty.left283)}
                              >
                                <div
                                  data-plasmic-name={"icon283"}
                                  data-plasmic-override={overrides.icon283}
                                  className={classNames("all", sty.icon283)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__y2Iw8
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title290"}
                                data-plasmic-override={overrides.title290}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title290
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item284"}
                              data-plasmic-override={overrides.item284}
                              className={classNames("all", sty.item284)}
                            >
                              <div
                                data-plasmic-name={"left284"}
                                data-plasmic-override={overrides.left284}
                                className={classNames("all", sty.left284)}
                              >
                                <div
                                  data-plasmic-name={"icon284"}
                                  data-plasmic-override={overrides.icon284}
                                  className={classNames("all", sty.icon284)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__amPUk
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title291"}
                                data-plasmic-override={overrides.title291}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title291
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item285"}
                              data-plasmic-override={overrides.item285}
                              className={classNames("all", sty.item285)}
                            >
                              <div
                                data-plasmic-name={"left285"}
                                data-plasmic-override={overrides.left285}
                                className={classNames("all", sty.left285)}
                              >
                                <div
                                  data-plasmic-name={"icon285"}
                                  data-plasmic-override={overrides.icon285}
                                  className={classNames("all", sty.icon285)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__epcnW
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title292"}
                                data-plasmic-override={overrides.title292}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title292
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item286"}
                              data-plasmic-override={overrides.item286}
                              className={classNames("all", sty.item286)}
                            >
                              <div
                                data-plasmic-name={"left286"}
                                data-plasmic-override={overrides.left286}
                                className={classNames("all", sty.left286)}
                              >
                                <div
                                  data-plasmic-name={"icon286"}
                                  data-plasmic-override={overrides.icon286}
                                  className={classNames("all", sty.icon286)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lBzOv
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title293"}
                                data-plasmic-override={overrides.title293}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title293
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item287"}
                              data-plasmic-override={overrides.item287}
                              className={classNames("all", sty.item287)}
                            >
                              <div
                                data-plasmic-name={"left287"}
                                data-plasmic-override={overrides.left287}
                                className={classNames("all", sty.left287)}
                              >
                                <div
                                  data-plasmic-name={"icon287"}
                                  data-plasmic-override={overrides.icon287}
                                  className={classNames("all", sty.icon287)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___0GLFd
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title294"}
                                data-plasmic-override={overrides.title294}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title294
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item288"}
                              data-plasmic-override={overrides.item288}
                              className={classNames("all", sty.item288)}
                            >
                              <div
                                data-plasmic-name={"left288"}
                                data-plasmic-override={overrides.left288}
                                className={classNames("all", sty.left288)}
                              >
                                <div
                                  data-plasmic-name={"icon288"}
                                  data-plasmic-override={overrides.icon288}
                                  className={classNames("all", sty.icon288)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___98U3K
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title295"}
                                data-plasmic-override={overrides.title295}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title295
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn4"}
                          data-plasmic-override={overrides.btn4}
                          className={classNames("__wab_instance", sty.btn4)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard5"}
                    data-plasmic-override={overrides.narrowCard5}
                    className={classNames("all", sty.narrowCard5)}
                  >
                    <div
                      data-plasmic-name={"header20"}
                      data-plasmic-override={overrides.header20}
                      className={classNames("all", sty.header20)}
                    >
                      <div
                        data-plasmic-name={"title296"}
                        data-plasmic-override={overrides.title296}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title296
                        )}
                      >
                        {"Integrations \n& Connectivity"}
                      </div>
                      <Icon98Icon
                        className={classNames("all", sty.svg__cqV5)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content5"}
                      data-plasmic-override={overrides.content5}
                      className={classNames("all", sty.content5)}
                    >
                      <div
                        data-plasmic-name={"desc5"}
                        data-plasmic-override={overrides.desc5}
                        className={classNames("all", "__wab_text", sty.desc5)}
                      >
                        {
                          "Connect MyEvaluations with the systems your institution already uses."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder5"}
                        data-plasmic-override={overrides.placeholder5}
                        className={classNames("all", sty.placeholder5)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header21"}
                            data-plasmic-override={overrides.header21}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header21
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list20"}
                          data-plasmic-override={overrides.list20}
                          className={classNames("all", sty.list20)}
                        >
                          <div
                            data-plasmic-name={"item289"}
                            data-plasmic-override={overrides.item289}
                            className={classNames("all", sty.item289)}
                          >
                            <div
                              data-plasmic-name={"left289"}
                              data-plasmic-override={overrides.left289}
                              className={classNames("all", sty.left289)}
                            >
                              <div
                                data-plasmic-name={"icon289"}
                                data-plasmic-override={overrides.icon289}
                                className={classNames("all", sty.icon289)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__s8BRj)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title297"}
                              data-plasmic-override={overrides.title297}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title297
                              )}
                            >
                              {"EHR Connectivity"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item290"}
                            data-plasmic-override={overrides.item290}
                            className={classNames("all", sty.item290)}
                          >
                            <div
                              data-plasmic-name={"left290"}
                              data-plasmic-override={overrides.left290}
                              className={classNames("all", sty.left290)}
                            >
                              <div
                                data-plasmic-name={"icon290"}
                                data-plasmic-override={overrides.icon290}
                                className={classNames("all", sty.icon290)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__pm5Kd)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title298"}
                              data-plasmic-override={overrides.title298}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title298
                              )}
                            >
                              {"Clinical Log Integrations"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item291"}
                            data-plasmic-override={overrides.item291}
                            className={classNames("all", sty.item291)}
                          >
                            <div
                              data-plasmic-name={"left291"}
                              data-plasmic-override={overrides.left291}
                              className={classNames("all", sty.left291)}
                            >
                              <div
                                data-plasmic-name={"icon291"}
                                data-plasmic-override={overrides.icon291}
                                className={classNames("all", sty.icon291)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__zAZni)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title299"}
                              data-plasmic-override={overrides.title299}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title299
                              )}
                            >
                              {"Scheduling Integrations"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item292"}
                            data-plasmic-override={overrides.item292}
                            className={classNames("all", sty.item292)}
                          >
                            <div
                              data-plasmic-name={"left292"}
                              data-plasmic-override={overrides.left292}
                              className={classNames("all", sty.left292)}
                            >
                              <div
                                data-plasmic-name={"icon292"}
                                data-plasmic-override={overrides.icon292}
                                className={classNames("all", sty.icon292)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__m27Z1)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title300"}
                              data-plasmic-override={overrides.title300}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title300
                              )}
                            >
                              {"ERAS Data Import"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item293"}
                              data-plasmic-override={overrides.item293}
                              className={classNames("all", sty.item293)}
                            >
                              <div
                                data-plasmic-name={"left293"}
                                data-plasmic-override={overrides.left293}
                                className={classNames("all", sty.left293)}
                              >
                                <div
                                  data-plasmic-name={"icon293"}
                                  data-plasmic-override={overrides.icon293}
                                  className={classNames("all", sty.icon293)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___8IjDo
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title301"}
                                data-plasmic-override={overrides.title301}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title301
                                )}
                              >
                                {"Certificate & Diploma Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item294"}
                              data-plasmic-override={overrides.item294}
                              className={classNames("all", sty.item294)}
                            >
                              <div
                                data-plasmic-name={"left294"}
                                data-plasmic-override={overrides.left294}
                                className={classNames("all", sty.left294)}
                              >
                                <div
                                  data-plasmic-name={"icon294"}
                                  data-plasmic-override={overrides.icon294}
                                  className={classNames("all", sty.icon294)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__m6SSw
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title302"}
                                data-plasmic-override={overrides.title302}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title302
                                )}
                              >
                                {"Burnout Monitoring"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item295"}
                              data-plasmic-override={overrides.item295}
                              className={classNames("all", sty.item295)}
                            >
                              <div
                                data-plasmic-name={"left295"}
                                data-plasmic-override={overrides.left295}
                                className={classNames("all", sty.left295)}
                              >
                                <div
                                  data-plasmic-name={"icon295"}
                                  data-plasmic-override={overrides.icon295}
                                  className={classNames("all", sty.icon295)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__eApg2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title303"}
                                data-plasmic-override={overrides.title303}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title303
                                )}
                              >
                                {"Demographic Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item296"}
                              data-plasmic-override={overrides.item296}
                              className={classNames("all", sty.item296)}
                            >
                              <div
                                data-plasmic-name={"left296"}
                                data-plasmic-override={overrides.left296}
                                className={classNames("all", sty.left296)}
                              >
                                <div
                                  data-plasmic-name={"icon296"}
                                  data-plasmic-override={overrides.icon296}
                                  className={classNames("all", sty.icon296)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__oBiAg
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title304"}
                                data-plasmic-override={overrides.title304}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title304
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item297"}
                              data-plasmic-override={overrides.item297}
                              className={classNames("all", sty.item297)}
                            >
                              <div
                                data-plasmic-name={"left297"}
                                data-plasmic-override={overrides.left297}
                                className={classNames("all", sty.left297)}
                              >
                                <div
                                  data-plasmic-name={"icon297"}
                                  data-plasmic-override={overrides.icon297}
                                  className={classNames("all", sty.icon297)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__jUjNl
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title305"}
                                data-plasmic-override={overrides.title305}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title305
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item298"}
                              data-plasmic-override={overrides.item298}
                              className={classNames("all", sty.item298)}
                            >
                              <div
                                data-plasmic-name={"left298"}
                                data-plasmic-override={overrides.left298}
                                className={classNames("all", sty.left298)}
                              >
                                <div
                                  data-plasmic-name={"icon298"}
                                  data-plasmic-override={overrides.icon298}
                                  className={classNames("all", sty.icon298)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__i7Xo3
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title306"}
                                data-plasmic-override={overrides.title306}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title306
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item299"}
                              data-plasmic-override={overrides.item299}
                              className={classNames("all", sty.item299)}
                            >
                              <div
                                data-plasmic-name={"left299"}
                                data-plasmic-override={overrides.left299}
                                className={classNames("all", sty.left299)}
                              >
                                <div
                                  data-plasmic-name={"icon299"}
                                  data-plasmic-override={overrides.icon299}
                                  className={classNames("all", sty.icon299)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__o2PM)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title307"}
                                data-plasmic-override={overrides.title307}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title307
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item300"}
                              data-plasmic-override={overrides.item300}
                              className={classNames("all", sty.item300)}
                            >
                              <div
                                data-plasmic-name={"left300"}
                                data-plasmic-override={overrides.left300}
                                className={classNames("all", sty.left300)}
                              >
                                <div
                                  data-plasmic-name={"icon300"}
                                  data-plasmic-override={overrides.icon300}
                                  className={classNames("all", sty.icon300)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__f1No1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title308"}
                                data-plasmic-override={overrides.title308}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title308
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item301"}
                              data-plasmic-override={overrides.item301}
                              className={classNames("all", sty.item301)}
                            >
                              <div
                                data-plasmic-name={"left301"}
                                data-plasmic-override={overrides.left301}
                                className={classNames("all", sty.left301)}
                              >
                                <div
                                  data-plasmic-name={"icon301"}
                                  data-plasmic-override={overrides.icon301}
                                  className={classNames("all", sty.icon301)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___4E5M1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title309"}
                                data-plasmic-override={overrides.title309}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title309
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item302"}
                              data-plasmic-override={overrides.item302}
                              className={classNames("all", sty.item302)}
                            >
                              <div
                                data-plasmic-name={"left302"}
                                data-plasmic-override={overrides.left302}
                                className={classNames("all", sty.left302)}
                              >
                                <div
                                  data-plasmic-name={"icon302"}
                                  data-plasmic-override={overrides.icon302}
                                  className={classNames("all", sty.icon302)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__yd9Gm
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title310"}
                                data-plasmic-override={overrides.title310}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title310
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item303"}
                              data-plasmic-override={overrides.item303}
                              className={classNames("all", sty.item303)}
                            >
                              <div
                                data-plasmic-name={"left303"}
                                data-plasmic-override={overrides.left303}
                                className={classNames("all", sty.left303)}
                              >
                                <div
                                  data-plasmic-name={"icon303"}
                                  data-plasmic-override={overrides.icon303}
                                  className={classNames("all", sty.icon303)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ruMFh
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title311"}
                                data-plasmic-override={overrides.title311}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title311
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item304"}
                              data-plasmic-override={overrides.item304}
                              className={classNames("all", sty.item304)}
                            >
                              <div
                                data-plasmic-name={"left304"}
                                data-plasmic-override={overrides.left304}
                                className={classNames("all", sty.left304)}
                              >
                                <div
                                  data-plasmic-name={"icon304"}
                                  data-plasmic-override={overrides.icon304}
                                  className={classNames("all", sty.icon304)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__no9G)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title312"}
                                data-plasmic-override={overrides.title312}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title312
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item305"}
                              data-plasmic-override={overrides.item305}
                              className={classNames("all", sty.item305)}
                            >
                              <div
                                data-plasmic-name={"left305"}
                                data-plasmic-override={overrides.left305}
                                className={classNames("all", sty.left305)}
                              >
                                <div
                                  data-plasmic-name={"icon305"}
                                  data-plasmic-override={overrides.icon305}
                                  className={classNames("all", sty.icon305)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__i1G65
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title313"}
                                data-plasmic-override={overrides.title313}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title313
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item306"}
                              data-plasmic-override={overrides.item306}
                              className={classNames("all", sty.item306)}
                            >
                              <div
                                data-plasmic-name={"left306"}
                                data-plasmic-override={overrides.left306}
                                className={classNames("all", sty.left306)}
                              >
                                <div
                                  data-plasmic-name={"icon306"}
                                  data-plasmic-override={overrides.icon306}
                                  className={classNames("all", sty.icon306)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__gk86)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title314"}
                                data-plasmic-override={overrides.title314}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title314
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item307"}
                              data-plasmic-override={overrides.item307}
                              className={classNames("all", sty.item307)}
                            >
                              <div
                                data-plasmic-name={"left307"}
                                data-plasmic-override={overrides.left307}
                                className={classNames("all", sty.left307)}
                              >
                                <div
                                  data-plasmic-name={"icon307"}
                                  data-plasmic-override={overrides.icon307}
                                  className={classNames("all", sty.icon307)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__orIhu
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title315"}
                                data-plasmic-override={overrides.title315}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title315
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item308"}
                              data-plasmic-override={overrides.item308}
                              className={classNames("all", sty.item308)}
                            >
                              <div
                                data-plasmic-name={"left308"}
                                data-plasmic-override={overrides.left308}
                                className={classNames("all", sty.left308)}
                              >
                                <div
                                  data-plasmic-name={"icon308"}
                                  data-plasmic-override={overrides.icon308}
                                  className={classNames("all", sty.icon308)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__aPyxm
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title316"}
                                data-plasmic-override={overrides.title316}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title316
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item309"}
                              data-plasmic-override={overrides.item309}
                              className={classNames("all", sty.item309)}
                            >
                              <div
                                data-plasmic-name={"left309"}
                                data-plasmic-override={overrides.left309}
                                className={classNames("all", sty.left309)}
                              >
                                <div
                                  data-plasmic-name={"icon309"}
                                  data-plasmic-override={overrides.icon309}
                                  className={classNames("all", sty.icon309)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___5QE3J
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title317"}
                                data-plasmic-override={overrides.title317}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title317
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item310"}
                              data-plasmic-override={overrides.item310}
                              className={classNames("all", sty.item310)}
                            >
                              <div
                                data-plasmic-name={"left310"}
                                data-plasmic-override={overrides.left310}
                                className={classNames("all", sty.left310)}
                              >
                                <div
                                  data-plasmic-name={"icon310"}
                                  data-plasmic-override={overrides.icon310}
                                  className={classNames("all", sty.icon310)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__sdk4B
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title318"}
                                data-plasmic-override={overrides.title318}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title318
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item311"}
                              data-plasmic-override={overrides.item311}
                              className={classNames("all", sty.item311)}
                            >
                              <div
                                data-plasmic-name={"left311"}
                                data-plasmic-override={overrides.left311}
                                className={classNames("all", sty.left311)}
                              >
                                <div
                                  data-plasmic-name={"icon311"}
                                  data-plasmic-override={overrides.icon311}
                                  className={classNames("all", sty.icon311)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__iEp8Q
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title319"}
                                data-plasmic-override={overrides.title319}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title319
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item312"}
                              data-plasmic-override={overrides.item312}
                              className={classNames("all", sty.item312)}
                            >
                              <div
                                data-plasmic-name={"left312"}
                                data-plasmic-override={overrides.left312}
                                className={classNames("all", sty.left312)}
                              >
                                <div
                                  data-plasmic-name={"icon312"}
                                  data-plasmic-override={overrides.icon312}
                                  className={classNames("all", sty.icon312)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zgNYg
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title320"}
                                data-plasmic-override={overrides.title320}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title320
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn5"}
                          data-plasmic-override={overrides.btn5}
                          className={classNames("__wab_instance", sty.btn5)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard6"}
                    data-plasmic-override={overrides.narrowCard6}
                    className={classNames("all", sty.narrowCard6)}
                  >
                    <div
                      data-plasmic-name={"header22"}
                      data-plasmic-override={overrides.header22}
                      className={classNames("all", sty.header22)}
                    >
                      <div
                        data-plasmic-name={"title321"}
                        data-plasmic-override={overrides.title321}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title321
                        )}
                      >
                        {"Graduate \nMedical Education"}
                      </div>
                      <Icon97Icon
                        className={classNames("all", sty.svg__poaUi)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content6"}
                      data-plasmic-override={overrides.content6}
                      className={classNames("all", sty.content6)}
                    >
                      <div
                        data-plasmic-name={"desc6"}
                        data-plasmic-override={overrides.desc6}
                        className={classNames("all", "__wab_text", sty.desc6)}
                      >
                        {
                          "Purpose-built capabilities supporting residency and fellowship education."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder6"}
                        data-plasmic-override={overrides.placeholder6}
                        className={classNames("all", sty.placeholder6)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header23"}
                            data-plasmic-override={overrides.header23}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header23
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list21"}
                          data-plasmic-override={overrides.list21}
                          className={classNames("all", sty.list21)}
                        >
                          <div
                            data-plasmic-name={"item313"}
                            data-plasmic-override={overrides.item313}
                            className={classNames("all", sty.item313)}
                          >
                            <div
                              data-plasmic-name={"left313"}
                              data-plasmic-override={overrides.left313}
                              className={classNames("all", sty.left313)}
                            >
                              <div
                                data-plasmic-name={"icon313"}
                                data-plasmic-override={overrides.icon313}
                                className={classNames("all", sty.icon313)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___0Xoa)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title322"}
                              data-plasmic-override={overrides.title322}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title322
                              )}
                            >
                              {"Annual Program Evaluation (APE)"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item314"}
                            data-plasmic-override={overrides.item314}
                            className={classNames("all", sty.item314)}
                          >
                            <div
                              data-plasmic-name={"left314"}
                              data-plasmic-override={overrides.left314}
                              className={classNames("all", sty.left314)}
                            >
                              <div
                                data-plasmic-name={"icon314"}
                                data-plasmic-override={overrides.icon314}
                                className={classNames("all", sty.icon314)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vXpwr)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title323"}
                              data-plasmic-override={overrides.title323}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title323
                              )}
                            >
                              {"Common Program Requirements"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item315"}
                            data-plasmic-override={overrides.item315}
                            className={classNames("all", sty.item315)}
                          >
                            <div
                              data-plasmic-name={"left315"}
                              data-plasmic-override={overrides.left315}
                              className={classNames("all", sty.left315)}
                            >
                              <div
                                data-plasmic-name={"icon315"}
                                data-plasmic-override={overrides.icon315}
                                className={classNames("all", sty.icon315)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___2Ncyg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title324"}
                              data-plasmic-override={overrides.title324}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title324
                              )}
                            >
                              {"Institutional Requirements"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item316"}
                            data-plasmic-override={overrides.item316}
                            className={classNames("all", sty.item316)}
                          >
                            <div
                              data-plasmic-name={"left316"}
                              data-plasmic-override={overrides.left316}
                              className={classNames("all", sty.left316)}
                            >
                              <div
                                data-plasmic-name={"icon316"}
                                data-plasmic-override={overrides.icon316}
                                className={classNames("all", sty.icon316)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__psivh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title325"}
                              data-plasmic-override={overrides.title325}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title325
                              )}
                            >
                              {"Action Plans & Notifications"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item317"}
                            data-plasmic-override={overrides.item317}
                            className={classNames("all", sty.item317)}
                          >
                            <div
                              data-plasmic-name={"left317"}
                              data-plasmic-override={overrides.left317}
                              className={classNames("all", sty.left317)}
                            >
                              <div
                                data-plasmic-name={"icon317"}
                                data-plasmic-override={overrides.icon317}
                                className={classNames("all", sty.icon317)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__mlq82)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title326"}
                              data-plasmic-override={overrides.title326}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title326
                              )}
                            >
                              {"Procedure Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item318"}
                            data-plasmic-override={overrides.item318}
                            className={classNames("all", sty.item318)}
                          >
                            <div
                              data-plasmic-name={"left318"}
                              data-plasmic-override={overrides.left318}
                              className={classNames("all", sty.left318)}
                            >
                              <div
                                data-plasmic-name={"icon318"}
                                data-plasmic-override={overrides.icon318}
                                className={classNames("all", sty.icon318)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kmQya)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title327"}
                              data-plasmic-override={overrides.title327}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title327
                              )}
                            >
                              {"Patient Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item319"}
                            data-plasmic-override={overrides.item319}
                            className={classNames("all", sty.item319)}
                          >
                            <div
                              data-plasmic-name={"left319"}
                              data-plasmic-override={overrides.left319}
                              className={classNames("all", sty.left319)}
                            >
                              <div
                                data-plasmic-name={"icon319"}
                                data-plasmic-override={overrides.icon319}
                                className={classNames("all", sty.icon319)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___8AUx)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title328"}
                              data-plasmic-override={overrides.title328}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title328
                              )}
                            >
                              {"Centralized Procedure Reporting"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item320"}
                              data-plasmic-override={overrides.item320}
                              className={classNames("all", sty.item320)}
                            >
                              <div
                                data-plasmic-name={"left320"}
                                data-plasmic-override={overrides.left320}
                                className={classNames("all", sty.left320)}
                              >
                                <div
                                  data-plasmic-name={"icon320"}
                                  data-plasmic-override={overrides.icon320}
                                  className={classNames("all", sty.icon320)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zhYmA
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title329"}
                                data-plasmic-override={overrides.title329}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title329
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item321"}
                              data-plasmic-override={overrides.item321}
                              className={classNames("all", sty.item321)}
                            >
                              <div
                                data-plasmic-name={"left321"}
                                data-plasmic-override={overrides.left321}
                                className={classNames("all", sty.left321)}
                              >
                                <div
                                  data-plasmic-name={"icon321"}
                                  data-plasmic-override={overrides.icon321}
                                  className={classNames("all", sty.icon321)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__swYfL
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title330"}
                                data-plasmic-override={overrides.title330}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title330
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item322"}
                              data-plasmic-override={overrides.item322}
                              className={classNames("all", sty.item322)}
                            >
                              <div
                                data-plasmic-name={"left322"}
                                data-plasmic-override={overrides.left322}
                                className={classNames("all", sty.left322)}
                              >
                                <div
                                  data-plasmic-name={"icon322"}
                                  data-plasmic-override={overrides.icon322}
                                  className={classNames("all", sty.icon322)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__fTF5)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title331"}
                                data-plasmic-override={overrides.title331}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title331
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item323"}
                              data-plasmic-override={overrides.item323}
                              className={classNames("all", sty.item323)}
                            >
                              <div
                                data-plasmic-name={"left323"}
                                data-plasmic-override={overrides.left323}
                                className={classNames("all", sty.left323)}
                              >
                                <div
                                  data-plasmic-name={"icon323"}
                                  data-plasmic-override={overrides.icon323}
                                  className={classNames("all", sty.icon323)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fuZl2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title332"}
                                data-plasmic-override={overrides.title332}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title332
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item324"}
                              data-plasmic-override={overrides.item324}
                              className={classNames("all", sty.item324)}
                            >
                              <div
                                data-plasmic-name={"left324"}
                                data-plasmic-override={overrides.left324}
                                className={classNames("all", sty.left324)}
                              >
                                <div
                                  data-plasmic-name={"icon324"}
                                  data-plasmic-override={overrides.icon324}
                                  className={classNames("all", sty.icon324)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lSfuC
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title333"}
                                data-plasmic-override={overrides.title333}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title333
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item325"}
                              data-plasmic-override={overrides.item325}
                              className={classNames("all", sty.item325)}
                            >
                              <div
                                data-plasmic-name={"left325"}
                                data-plasmic-override={overrides.left325}
                                className={classNames("all", sty.left325)}
                              >
                                <div
                                  data-plasmic-name={"icon325"}
                                  data-plasmic-override={overrides.icon325}
                                  className={classNames("all", sty.icon325)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__p0P4Z
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title334"}
                                data-plasmic-override={overrides.title334}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title334
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item326"}
                              data-plasmic-override={overrides.item326}
                              className={classNames("all", sty.item326)}
                            >
                              <div
                                data-plasmic-name={"left326"}
                                data-plasmic-override={overrides.left326}
                                className={classNames("all", sty.left326)}
                              >
                                <div
                                  data-plasmic-name={"icon326"}
                                  data-plasmic-override={overrides.icon326}
                                  className={classNames("all", sty.icon326)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pA9Sz
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title335"}
                                data-plasmic-override={overrides.title335}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title335
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item327"}
                              data-plasmic-override={overrides.item327}
                              className={classNames("all", sty.item327)}
                            >
                              <div
                                data-plasmic-name={"left327"}
                                data-plasmic-override={overrides.left327}
                                className={classNames("all", sty.left327)}
                              >
                                <div
                                  data-plasmic-name={"icon327"}
                                  data-plasmic-override={overrides.icon327}
                                  className={classNames("all", sty.icon327)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__jZIh)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title336"}
                                data-plasmic-override={overrides.title336}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title336
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item328"}
                              data-plasmic-override={overrides.item328}
                              className={classNames("all", sty.item328)}
                            >
                              <div
                                data-plasmic-name={"left328"}
                                data-plasmic-override={overrides.left328}
                                className={classNames("all", sty.left328)}
                              >
                                <div
                                  data-plasmic-name={"icon328"}
                                  data-plasmic-override={overrides.icon328}
                                  className={classNames("all", sty.icon328)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__iqurI
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title337"}
                                data-plasmic-override={overrides.title337}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title337
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item329"}
                              data-plasmic-override={overrides.item329}
                              className={classNames("all", sty.item329)}
                            >
                              <div
                                data-plasmic-name={"left329"}
                                data-plasmic-override={overrides.left329}
                                className={classNames("all", sty.left329)}
                              >
                                <div
                                  data-plasmic-name={"icon329"}
                                  data-plasmic-override={overrides.icon329}
                                  className={classNames("all", sty.icon329)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__br6MW
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title338"}
                                data-plasmic-override={overrides.title338}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title338
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item330"}
                              data-plasmic-override={overrides.item330}
                              className={classNames("all", sty.item330)}
                            >
                              <div
                                data-plasmic-name={"left330"}
                                data-plasmic-override={overrides.left330}
                                className={classNames("all", sty.left330)}
                              >
                                <div
                                  data-plasmic-name={"icon330"}
                                  data-plasmic-override={overrides.icon330}
                                  className={classNames("all", sty.icon330)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__uETli
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title339"}
                                data-plasmic-override={overrides.title339}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title339
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item331"}
                              data-plasmic-override={overrides.item331}
                              className={classNames("all", sty.item331)}
                            >
                              <div
                                data-plasmic-name={"left331"}
                                data-plasmic-override={overrides.left331}
                                className={classNames("all", sty.left331)}
                              >
                                <div
                                  data-plasmic-name={"icon331"}
                                  data-plasmic-override={overrides.icon331}
                                  className={classNames("all", sty.icon331)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___5RgKe
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title340"}
                                data-plasmic-override={overrides.title340}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title340
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item332"}
                              data-plasmic-override={overrides.item332}
                              className={classNames("all", sty.item332)}
                            >
                              <div
                                data-plasmic-name={"left332"}
                                data-plasmic-override={overrides.left332}
                                className={classNames("all", sty.left332)}
                              >
                                <div
                                  data-plasmic-name={"icon332"}
                                  data-plasmic-override={overrides.icon332}
                                  className={classNames("all", sty.icon332)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__o4I1Q
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title341"}
                                data-plasmic-override={overrides.title341}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title341
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item333"}
                              data-plasmic-override={overrides.item333}
                              className={classNames("all", sty.item333)}
                            >
                              <div
                                data-plasmic-name={"left333"}
                                data-plasmic-override={overrides.left333}
                                className={classNames("all", sty.left333)}
                              >
                                <div
                                  data-plasmic-name={"icon333"}
                                  data-plasmic-override={overrides.icon333}
                                  className={classNames("all", sty.icon333)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__fGYy)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title342"}
                                data-plasmic-override={overrides.title342}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title342
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item334"}
                              data-plasmic-override={overrides.item334}
                              className={classNames("all", sty.item334)}
                            >
                              <div
                                data-plasmic-name={"left334"}
                                data-plasmic-override={overrides.left334}
                                className={classNames("all", sty.left334)}
                              >
                                <div
                                  data-plasmic-name={"icon334"}
                                  data-plasmic-override={overrides.icon334}
                                  className={classNames("all", sty.icon334)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__yuv6P
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title343"}
                                data-plasmic-override={overrides.title343}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title343
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item335"}
                              data-plasmic-override={overrides.item335}
                              className={classNames("all", sty.item335)}
                            >
                              <div
                                data-plasmic-name={"left335"}
                                data-plasmic-override={overrides.left335}
                                className={classNames("all", sty.left335)}
                              >
                                <div
                                  data-plasmic-name={"icon335"}
                                  data-plasmic-override={overrides.icon335}
                                  className={classNames("all", sty.icon335)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fsUSj
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title344"}
                                data-plasmic-override={overrides.title344}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title344
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item336"}
                              data-plasmic-override={overrides.item336}
                              className={classNames("all", sty.item336)}
                            >
                              <div
                                data-plasmic-name={"left336"}
                                data-plasmic-override={overrides.left336}
                                className={classNames("all", sty.left336)}
                              >
                                <div
                                  data-plasmic-name={"icon336"}
                                  data-plasmic-override={overrides.icon336}
                                  className={classNames("all", sty.icon336)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___1ULy8
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title345"}
                                data-plasmic-override={overrides.title345}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title345
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn6"}
                          data-plasmic-override={overrides.btn6}
                          className={classNames("__wab_instance", sty.btn6)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"row4"}
                data-plasmic-override={overrides.row4}
                className={classNames("all", sty.row4)}
              >
                <div
                  data-plasmic-name={"figmaPaste3"}
                  data-plasmic-override={overrides.figmaPaste3}
                  className={classNames("all", sty.figmaPaste3)}
                >
                  <div
                    data-plasmic-name={"narrowCard7"}
                    data-plasmic-override={overrides.narrowCard7}
                    className={classNames("all", sty.narrowCard7)}
                  >
                    <div
                      data-plasmic-name={"header24"}
                      data-plasmic-override={overrides.header24}
                      className={classNames("all", sty.header24)}
                    >
                      <div
                        data-plasmic-name={"title346"}
                        data-plasmic-override={overrides.title346}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title346
                        )}
                      >
                        {"Physician \nAssistant Education"}
                      </div>
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img__clTus)}
                        displayHeight={"32px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"32px"}
                        loader={"plasmic"}
                        loading={"lazy"}
                        src={{
                          src: "https://site-assets.plasmic.app/d6f7f0eca9cbc289d86cbd47375ec4b6.svg",
                          fullWidth: 32,
                          fullHeight: 32
                        }}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content7"}
                      data-plasmic-override={overrides.content7}
                      className={classNames("all", sty.content7)}
                    >
                      <div
                        data-plasmic-name={"desc7"}
                        data-plasmic-override={overrides.desc7}
                        className={classNames("all", "__wab_text", sty.desc7)}
                      >
                        {
                          "Designed to support competency-based Physician Assistant education."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder7"}
                        data-plasmic-override={overrides.placeholder7}
                        className={classNames("all", sty.placeholder7)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header25"}
                            data-plasmic-override={overrides.header25}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header25
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list22"}
                          data-plasmic-override={overrides.list22}
                          className={classNames("all", sty.list22)}
                        >
                          <div
                            data-plasmic-name={"item337"}
                            data-plasmic-override={overrides.item337}
                            className={classNames("all", sty.item337)}
                          >
                            <div
                              data-plasmic-name={"left337"}
                              data-plasmic-override={overrides.left337}
                              className={classNames("all", sty.left337)}
                            >
                              <div
                                data-plasmic-name={"icon337"}
                                data-plasmic-override={overrides.icon337}
                                className={classNames("all", sty.icon337)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__r88EN)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title347"}
                              data-plasmic-override={overrides.title347}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title347
                              )}
                            >
                              {"Curriculum Management"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item338"}
                            data-plasmic-override={overrides.item338}
                            className={classNames("all", sty.item338)}
                          >
                            <div
                              data-plasmic-name={"left338"}
                              data-plasmic-override={overrides.left338}
                              className={classNames("all", sty.left338)}
                            >
                              <div
                                data-plasmic-name={"icon338"}
                                data-plasmic-override={overrides.icon338}
                                className={classNames("all", sty.icon338)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kWjR7)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title348"}
                              data-plasmic-override={overrides.title348}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title348
                              )}
                            >
                              {"Procedure Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item339"}
                            data-plasmic-override={overrides.item339}
                            className={classNames("all", sty.item339)}
                          >
                            <div
                              data-plasmic-name={"left339"}
                              data-plasmic-override={overrides.left339}
                              className={classNames("all", sty.left339)}
                            >
                              <div
                                data-plasmic-name={"icon339"}
                                data-plasmic-override={overrides.icon339}
                                className={classNames("all", sty.icon339)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jdFEg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title349"}
                              data-plasmic-override={overrides.title349}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title349
                              )}
                            >
                              {"Patient Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item340"}
                            data-plasmic-override={overrides.item340}
                            className={classNames("all", sty.item340)}
                          >
                            <div
                              data-plasmic-name={"left340"}
                              data-plasmic-override={overrides.left340}
                              className={classNames("all", sty.left340)}
                            >
                              <div
                                data-plasmic-name={"icon340"}
                                data-plasmic-override={overrides.icon340}
                                className={classNames("all", sty.icon340)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vS2AC)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title350"}
                              data-plasmic-override={overrides.title350}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title350
                              )}
                            >
                              {"Learning Assignments"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item341"}
                            data-plasmic-override={overrides.item341}
                            className={classNames("all", sty.item341)}
                          >
                            <div
                              data-plasmic-name={"left341"}
                              data-plasmic-override={overrides.left341}
                              className={classNames("all", sty.left341)}
                            >
                              <div
                                data-plasmic-name={"icon341"}
                                data-plasmic-override={overrides.icon341}
                                className={classNames("all", sty.icon341)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vHxwn)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title351"}
                              data-plasmic-override={overrides.title351}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title351
                              )}
                            >
                              {"MyQuiz\u2122"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item342"}
                            data-plasmic-override={overrides.item342}
                            className={classNames("all", sty.item342)}
                          >
                            <div
                              data-plasmic-name={"left342"}
                              data-plasmic-override={overrides.left342}
                              className={classNames("all", sty.left342)}
                            >
                              <div
                                data-plasmic-name={"icon342"}
                                data-plasmic-override={overrides.icon342}
                                className={classNames("all", sty.icon342)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__d1PVp)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title352"}
                              data-plasmic-override={overrides.title352}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title352
                              )}
                            >
                              {"Performance Dashboard"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item343"}
                              data-plasmic-override={overrides.item343}
                              className={classNames("all", sty.item343)}
                            >
                              <div
                                data-plasmic-name={"left343"}
                                data-plasmic-override={overrides.left343}
                                className={classNames("all", sty.left343)}
                              >
                                <div
                                  data-plasmic-name={"icon343"}
                                  data-plasmic-override={overrides.icon343}
                                  className={classNames("all", sty.icon343)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__nnjK1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title353"}
                                data-plasmic-override={overrides.title353}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title353
                                )}
                              >
                                {"Centralized Procedure Reporting"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item344"}
                              data-plasmic-override={overrides.item344}
                              className={classNames("all", sty.item344)}
                            >
                              <div
                                data-plasmic-name={"left344"}
                                data-plasmic-override={overrides.left344}
                                className={classNames("all", sty.left344)}
                              >
                                <div
                                  data-plasmic-name={"icon344"}
                                  data-plasmic-override={overrides.icon344}
                                  className={classNames("all", sty.icon344)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fS06U
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title354"}
                                data-plasmic-override={overrides.title354}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title354
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item345"}
                              data-plasmic-override={overrides.item345}
                              className={classNames("all", sty.item345)}
                            >
                              <div
                                data-plasmic-name={"left345"}
                                data-plasmic-override={overrides.left345}
                                className={classNames("all", sty.left345)}
                              >
                                <div
                                  data-plasmic-name={"icon345"}
                                  data-plasmic-override={overrides.icon345}
                                  className={classNames("all", sty.icon345)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__xgLFe
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title355"}
                                data-plasmic-override={overrides.title355}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title355
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item346"}
                              data-plasmic-override={overrides.item346}
                              className={classNames("all", sty.item346)}
                            >
                              <div
                                data-plasmic-name={"left346"}
                                data-plasmic-override={overrides.left346}
                                className={classNames("all", sty.left346)}
                              >
                                <div
                                  data-plasmic-name={"icon346"}
                                  data-plasmic-override={overrides.icon346}
                                  className={classNames("all", sty.icon346)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ovobN
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title356"}
                                data-plasmic-override={overrides.title356}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title356
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item347"}
                              data-plasmic-override={overrides.item347}
                              className={classNames("all", sty.item347)}
                            >
                              <div
                                data-plasmic-name={"left347"}
                                data-plasmic-override={overrides.left347}
                                className={classNames("all", sty.left347)}
                              >
                                <div
                                  data-plasmic-name={"icon347"}
                                  data-plasmic-override={overrides.icon347}
                                  className={classNames("all", sty.icon347)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__hLfSu
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title357"}
                                data-plasmic-override={overrides.title357}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title357
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item348"}
                              data-plasmic-override={overrides.item348}
                              className={classNames("all", sty.item348)}
                            >
                              <div
                                data-plasmic-name={"left348"}
                                data-plasmic-override={overrides.left348}
                                className={classNames("all", sty.left348)}
                              >
                                <div
                                  data-plasmic-name={"icon348"}
                                  data-plasmic-override={overrides.icon348}
                                  className={classNames("all", sty.icon348)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__gcj0O
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title358"}
                                data-plasmic-override={overrides.title358}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title358
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item349"}
                              data-plasmic-override={overrides.item349}
                              className={classNames("all", sty.item349)}
                            >
                              <div
                                data-plasmic-name={"left349"}
                                data-plasmic-override={overrides.left349}
                                className={classNames("all", sty.left349)}
                              >
                                <div
                                  data-plasmic-name={"icon349"}
                                  data-plasmic-override={overrides.icon349}
                                  className={classNames("all", sty.icon349)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___6Q0T6
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title359"}
                                data-plasmic-override={overrides.title359}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title359
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item350"}
                              data-plasmic-override={overrides.item350}
                              className={classNames("all", sty.item350)}
                            >
                              <div
                                data-plasmic-name={"left350"}
                                data-plasmic-override={overrides.left350}
                                className={classNames("all", sty.left350)}
                              >
                                <div
                                  data-plasmic-name={"icon350"}
                                  data-plasmic-override={overrides.icon350}
                                  className={classNames("all", sty.icon350)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__niAvP
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title360"}
                                data-plasmic-override={overrides.title360}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title360
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item351"}
                              data-plasmic-override={overrides.item351}
                              className={classNames("all", sty.item351)}
                            >
                              <div
                                data-plasmic-name={"left351"}
                                data-plasmic-override={overrides.left351}
                                className={classNames("all", sty.left351)}
                              >
                                <div
                                  data-plasmic-name={"icon351"}
                                  data-plasmic-override={overrides.icon351}
                                  className={classNames("all", sty.icon351)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__kvByw
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title361"}
                                data-plasmic-override={overrides.title361}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title361
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item352"}
                              data-plasmic-override={overrides.item352}
                              className={classNames("all", sty.item352)}
                            >
                              <div
                                data-plasmic-name={"left352"}
                                data-plasmic-override={overrides.left352}
                                className={classNames("all", sty.left352)}
                              >
                                <div
                                  data-plasmic-name={"icon352"}
                                  data-plasmic-override={overrides.icon352}
                                  className={classNames("all", sty.icon352)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___7YAyq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title362"}
                                data-plasmic-override={overrides.title362}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title362
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item353"}
                              data-plasmic-override={overrides.item353}
                              className={classNames("all", sty.item353)}
                            >
                              <div
                                data-plasmic-name={"left353"}
                                data-plasmic-override={overrides.left353}
                                className={classNames("all", sty.left353)}
                              >
                                <div
                                  data-plasmic-name={"icon353"}
                                  data-plasmic-override={overrides.icon353}
                                  className={classNames("all", sty.icon353)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___7Fl6V
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title363"}
                                data-plasmic-override={overrides.title363}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title363
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item354"}
                              data-plasmic-override={overrides.item354}
                              className={classNames("all", sty.item354)}
                            >
                              <div
                                data-plasmic-name={"left354"}
                                data-plasmic-override={overrides.left354}
                                className={classNames("all", sty.left354)}
                              >
                                <div
                                  data-plasmic-name={"icon354"}
                                  data-plasmic-override={overrides.icon354}
                                  className={classNames("all", sty.icon354)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__aMj0)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title364"}
                                data-plasmic-override={overrides.title364}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title364
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item355"}
                              data-plasmic-override={overrides.item355}
                              className={classNames("all", sty.item355)}
                            >
                              <div
                                data-plasmic-name={"left355"}
                                data-plasmic-override={overrides.left355}
                                className={classNames("all", sty.left355)}
                              >
                                <div
                                  data-plasmic-name={"icon355"}
                                  data-plasmic-override={overrides.icon355}
                                  className={classNames("all", sty.icon355)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lwQRx
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title365"}
                                data-plasmic-override={overrides.title365}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title365
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item356"}
                              data-plasmic-override={overrides.item356}
                              className={classNames("all", sty.item356)}
                            >
                              <div
                                data-plasmic-name={"left356"}
                                data-plasmic-override={overrides.left356}
                                className={classNames("all", sty.left356)}
                              >
                                <div
                                  data-plasmic-name={"icon356"}
                                  data-plasmic-override={overrides.icon356}
                                  className={classNames("all", sty.icon356)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__lTGf)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title366"}
                                data-plasmic-override={overrides.title366}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title366
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item357"}
                              data-plasmic-override={overrides.item357}
                              className={classNames("all", sty.item357)}
                            >
                              <div
                                data-plasmic-name={"left357"}
                                data-plasmic-override={overrides.left357}
                                className={classNames("all", sty.left357)}
                              >
                                <div
                                  data-plasmic-name={"icon357"}
                                  data-plasmic-override={overrides.icon357}
                                  className={classNames("all", sty.icon357)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__u7Z2O
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title367"}
                                data-plasmic-override={overrides.title367}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title367
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item358"}
                              data-plasmic-override={overrides.item358}
                              className={classNames("all", sty.item358)}
                            >
                              <div
                                data-plasmic-name={"left358"}
                                data-plasmic-override={overrides.left358}
                                className={classNames("all", sty.left358)}
                              >
                                <div
                                  data-plasmic-name={"icon358"}
                                  data-plasmic-override={overrides.icon358}
                                  className={classNames("all", sty.icon358)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__o60J6
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title368"}
                                data-plasmic-override={overrides.title368}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title368
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item359"}
                              data-plasmic-override={overrides.item359}
                              className={classNames("all", sty.item359)}
                            >
                              <div
                                data-plasmic-name={"left359"}
                                data-plasmic-override={overrides.left359}
                                className={classNames("all", sty.left359)}
                              >
                                <div
                                  data-plasmic-name={"icon359"}
                                  data-plasmic-override={overrides.icon359}
                                  className={classNames("all", sty.icon359)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pM7Cm
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title369"}
                                data-plasmic-override={overrides.title369}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title369
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item360"}
                              data-plasmic-override={overrides.item360}
                              className={classNames("all", sty.item360)}
                            >
                              <div
                                data-plasmic-name={"left360"}
                                data-plasmic-override={overrides.left360}
                                className={classNames("all", sty.left360)}
                              >
                                <div
                                  data-plasmic-name={"icon360"}
                                  data-plasmic-override={overrides.icon360}
                                  className={classNames("all", sty.icon360)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__yTaGd
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title370"}
                                data-plasmic-override={overrides.title370}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title370
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn7"}
                          data-plasmic-override={overrides.btn7}
                          className={classNames("__wab_instance", sty.btn7)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard8"}
                    data-plasmic-override={overrides.narrowCard8}
                    className={classNames("all", sty.narrowCard8)}
                  >
                    <div
                      data-plasmic-name={"header26"}
                      data-plasmic-override={overrides.header26}
                      className={classNames("all", sty.header26)}
                    >
                      <div
                        data-plasmic-name={"title371"}
                        data-plasmic-override={overrides.title371}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title371
                        )}
                      >
                        {"Nursing Education"}
                      </div>
                      <Icon100Icon
                        className={classNames("all", sty.svg__oSbS)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content8"}
                      data-plasmic-override={overrides.content8}
                      className={classNames("all", sty.content8)}
                    >
                      <div
                        data-plasmic-name={"desc8"}
                        data-plasmic-override={overrides.desc8}
                        className={classNames("all", "__wab_text", sty.desc8)}
                      >
                        {
                          "Specialized tools supporting nursing education and clinical competency."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder8"}
                        data-plasmic-override={overrides.placeholder8}
                        className={classNames("all", sty.placeholder8)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header27"}
                            data-plasmic-override={overrides.header27}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header27
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list23"}
                          data-plasmic-override={overrides.list23}
                          className={classNames("all", sty.list23)}
                        >
                          <div
                            data-plasmic-name={"item361"}
                            data-plasmic-override={overrides.item361}
                            className={classNames("all", sty.item361)}
                          >
                            <div
                              data-plasmic-name={"left361"}
                              data-plasmic-override={overrides.left361}
                              className={classNames("all", sty.left361)}
                            >
                              <div
                                data-plasmic-name={"icon361"}
                                data-plasmic-override={overrides.icon361}
                                className={classNames("all", sty.icon361)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__sSz2A)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title372"}
                              data-plasmic-override={overrides.title372}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title372
                              )}
                            >
                              {"Clinical Activity Logger"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item362"}
                            data-plasmic-override={overrides.item362}
                            className={classNames("all", sty.item362)}
                          >
                            <div
                              data-plasmic-name={"left362"}
                              data-plasmic-override={overrides.left362}
                              className={classNames("all", sty.left362)}
                            >
                              <div
                                data-plasmic-name={"icon362"}
                                data-plasmic-override={overrides.icon362}
                                className={classNames("all", sty.icon362)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___3LbnX)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title373"}
                              data-plasmic-override={overrides.title373}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title373
                              )}
                            >
                              {"Return Demonstration Management"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item363"}
                            data-plasmic-override={overrides.item363}
                            className={classNames("all", sty.item363)}
                          >
                            <div
                              data-plasmic-name={"left363"}
                              data-plasmic-override={overrides.left363}
                              className={classNames("all", sty.left363)}
                            >
                              <div
                                data-plasmic-name={"icon363"}
                                data-plasmic-override={overrides.icon363}
                                className={classNames("all", sty.icon363)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__lLy4Q)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title374"}
                              data-plasmic-override={overrides.title374}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title374
                              )}
                            >
                              {"Return Demonstration Testing"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item364"}
                            data-plasmic-override={overrides.item364}
                            className={classNames("all", sty.item364)}
                          >
                            <div
                              data-plasmic-name={"left364"}
                              data-plasmic-override={overrides.left364}
                              className={classNames("all", sty.left364)}
                            >
                              <div
                                data-plasmic-name={"icon364"}
                                data-plasmic-override={overrides.icon364}
                                className={classNames("all", sty.icon364)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__deL7P)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title375"}
                              data-plasmic-override={overrides.title375}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title375
                              )}
                            >
                              {"Clinical Learning Contracts"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item365"}
                              data-plasmic-override={overrides.item365}
                              className={classNames("all", sty.item365)}
                            >
                              <div
                                data-plasmic-name={"left365"}
                                data-plasmic-override={overrides.left365}
                                className={classNames("all", sty.left365)}
                              >
                                <div
                                  data-plasmic-name={"icon365"}
                                  data-plasmic-override={overrides.icon365}
                                  className={classNames("all", sty.icon365)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ebMNn
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title376"}
                                data-plasmic-override={overrides.title376}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title376
                                )}
                              >
                                {"MyQuiz\u2122"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item366"}
                              data-plasmic-override={overrides.item366}
                              className={classNames("all", sty.item366)}
                            >
                              <div
                                data-plasmic-name={"left366"}
                                data-plasmic-override={overrides.left366}
                                className={classNames("all", sty.left366)}
                              >
                                <div
                                  data-plasmic-name={"icon366"}
                                  data-plasmic-override={overrides.icon366}
                                  className={classNames("all", sty.icon366)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__eSkY)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title377"}
                                data-plasmic-override={overrides.title377}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title377
                                )}
                              >
                                {"Performance Dashboard"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item367"}
                              data-plasmic-override={overrides.item367}
                              className={classNames("all", sty.item367)}
                            >
                              <div
                                data-plasmic-name={"left367"}
                                data-plasmic-override={overrides.left367}
                                className={classNames("all", sty.left367)}
                              >
                                <div
                                  data-plasmic-name={"icon367"}
                                  data-plasmic-override={overrides.icon367}
                                  className={classNames("all", sty.icon367)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___6L2Mi
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title378"}
                                data-plasmic-override={overrides.title378}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title378
                                )}
                              >
                                {"Centralized Procedure Reporting"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item368"}
                              data-plasmic-override={overrides.item368}
                              className={classNames("all", sty.item368)}
                            >
                              <div
                                data-plasmic-name={"left368"}
                                data-plasmic-override={overrides.left368}
                                className={classNames("all", sty.left368)}
                              >
                                <div
                                  data-plasmic-name={"icon368"}
                                  data-plasmic-override={overrides.icon368}
                                  className={classNames("all", sty.icon368)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__jn1M)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title379"}
                                data-plasmic-override={overrides.title379}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title379
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item369"}
                              data-plasmic-override={overrides.item369}
                              className={classNames("all", sty.item369)}
                            >
                              <div
                                data-plasmic-name={"left369"}
                                data-plasmic-override={overrides.left369}
                                className={classNames("all", sty.left369)}
                              >
                                <div
                                  data-plasmic-name={"icon369"}
                                  data-plasmic-override={overrides.icon369}
                                  className={classNames("all", sty.icon369)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__igfk1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title380"}
                                data-plasmic-override={overrides.title380}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title380
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item370"}
                              data-plasmic-override={overrides.item370}
                              className={classNames("all", sty.item370)}
                            >
                              <div
                                data-plasmic-name={"left370"}
                                data-plasmic-override={overrides.left370}
                                className={classNames("all", sty.left370)}
                              >
                                <div
                                  data-plasmic-name={"icon370"}
                                  data-plasmic-override={overrides.icon370}
                                  className={classNames("all", sty.icon370)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___5CbpZ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title381"}
                                data-plasmic-override={overrides.title381}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title381
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item371"}
                              data-plasmic-override={overrides.item371}
                              className={classNames("all", sty.item371)}
                            >
                              <div
                                data-plasmic-name={"left371"}
                                data-plasmic-override={overrides.left371}
                                className={classNames("all", sty.left371)}
                              >
                                <div
                                  data-plasmic-name={"icon371"}
                                  data-plasmic-override={overrides.icon371}
                                  className={classNames("all", sty.icon371)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ydFey
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title382"}
                                data-plasmic-override={overrides.title382}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title382
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item372"}
                              data-plasmic-override={overrides.item372}
                              className={classNames("all", sty.item372)}
                            >
                              <div
                                data-plasmic-name={"left372"}
                                data-plasmic-override={overrides.left372}
                                className={classNames("all", sty.left372)}
                              >
                                <div
                                  data-plasmic-name={"icon372"}
                                  data-plasmic-override={overrides.icon372}
                                  className={classNames("all", sty.icon372)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__wlFg1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title383"}
                                data-plasmic-override={overrides.title383}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title383
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item373"}
                              data-plasmic-override={overrides.item373}
                              className={classNames("all", sty.item373)}
                            >
                              <div
                                data-plasmic-name={"left373"}
                                data-plasmic-override={overrides.left373}
                                className={classNames("all", sty.left373)}
                              >
                                <div
                                  data-plasmic-name={"icon373"}
                                  data-plasmic-override={overrides.icon373}
                                  className={classNames("all", sty.icon373)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zUvy2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title384"}
                                data-plasmic-override={overrides.title384}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title384
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item374"}
                              data-plasmic-override={overrides.item374}
                              className={classNames("all", sty.item374)}
                            >
                              <div
                                data-plasmic-name={"left374"}
                                data-plasmic-override={overrides.left374}
                                className={classNames("all", sty.left374)}
                              >
                                <div
                                  data-plasmic-name={"icon374"}
                                  data-plasmic-override={overrides.icon374}
                                  className={classNames("all", sty.icon374)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__hqnTn
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title385"}
                                data-plasmic-override={overrides.title385}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title385
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item375"}
                              data-plasmic-override={overrides.item375}
                              className={classNames("all", sty.item375)}
                            >
                              <div
                                data-plasmic-name={"left375"}
                                data-plasmic-override={overrides.left375}
                                className={classNames("all", sty.left375)}
                              >
                                <div
                                  data-plasmic-name={"icon375"}
                                  data-plasmic-override={overrides.icon375}
                                  className={classNames("all", sty.icon375)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___9PjhB
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title386"}
                                data-plasmic-override={overrides.title386}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title386
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item376"}
                              data-plasmic-override={overrides.item376}
                              className={classNames("all", sty.item376)}
                            >
                              <div
                                data-plasmic-name={"left376"}
                                data-plasmic-override={overrides.left376}
                                className={classNames("all", sty.left376)}
                              >
                                <div
                                  data-plasmic-name={"icon376"}
                                  data-plasmic-override={overrides.icon376}
                                  className={classNames("all", sty.icon376)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__hFnhQ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title387"}
                                data-plasmic-override={overrides.title387}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title387
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item377"}
                              data-plasmic-override={overrides.item377}
                              className={classNames("all", sty.item377)}
                            >
                              <div
                                data-plasmic-name={"left377"}
                                data-plasmic-override={overrides.left377}
                                className={classNames("all", sty.left377)}
                              >
                                <div
                                  data-plasmic-name={"icon377"}
                                  data-plasmic-override={overrides.icon377}
                                  className={classNames("all", sty.icon377)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___1SgV
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title388"}
                                data-plasmic-override={overrides.title388}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title388
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item378"}
                              data-plasmic-override={overrides.item378}
                              className={classNames("all", sty.item378)}
                            >
                              <div
                                data-plasmic-name={"left378"}
                                data-plasmic-override={overrides.left378}
                                className={classNames("all", sty.left378)}
                              >
                                <div
                                  data-plasmic-name={"icon378"}
                                  data-plasmic-override={overrides.icon378}
                                  className={classNames("all", sty.icon378)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__s6X5F
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title389"}
                                data-plasmic-override={overrides.title389}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title389
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item379"}
                              data-plasmic-override={overrides.item379}
                              className={classNames("all", sty.item379)}
                            >
                              <div
                                data-plasmic-name={"left379"}
                                data-plasmic-override={overrides.left379}
                                className={classNames("all", sty.left379)}
                              >
                                <div
                                  data-plasmic-name={"icon379"}
                                  data-plasmic-override={overrides.icon379}
                                  className={classNames("all", sty.icon379)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__k8Qer
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title390"}
                                data-plasmic-override={overrides.title390}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title390
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item380"}
                              data-plasmic-override={overrides.item380}
                              className={classNames("all", sty.item380)}
                            >
                              <div
                                data-plasmic-name={"left380"}
                                data-plasmic-override={overrides.left380}
                                className={classNames("all", sty.left380)}
                              >
                                <div
                                  data-plasmic-name={"icon380"}
                                  data-plasmic-override={overrides.icon380}
                                  className={classNames("all", sty.icon380)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___0SNgK
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title391"}
                                data-plasmic-override={overrides.title391}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title391
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item381"}
                              data-plasmic-override={overrides.item381}
                              className={classNames("all", sty.item381)}
                            >
                              <div
                                data-plasmic-name={"left381"}
                                data-plasmic-override={overrides.left381}
                                className={classNames("all", sty.left381)}
                              >
                                <div
                                  data-plasmic-name={"icon381"}
                                  data-plasmic-override={overrides.icon381}
                                  className={classNames("all", sty.icon381)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qlsxo
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title392"}
                                data-plasmic-override={overrides.title392}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title392
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item382"}
                              data-plasmic-override={overrides.item382}
                              className={classNames("all", sty.item382)}
                            >
                              <div
                                data-plasmic-name={"left382"}
                                data-plasmic-override={overrides.left382}
                                className={classNames("all", sty.left382)}
                              >
                                <div
                                  data-plasmic-name={"icon382"}
                                  data-plasmic-override={overrides.icon382}
                                  className={classNames("all", sty.icon382)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qbjjz
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title393"}
                                data-plasmic-override={overrides.title393}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title393
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item383"}
                              data-plasmic-override={overrides.item383}
                              className={classNames("all", sty.item383)}
                            >
                              <div
                                data-plasmic-name={"left383"}
                                data-plasmic-override={overrides.left383}
                                className={classNames("all", sty.left383)}
                              >
                                <div
                                  data-plasmic-name={"icon383"}
                                  data-plasmic-override={overrides.icon383}
                                  className={classNames("all", sty.icon383)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__jEIj)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title394"}
                                data-plasmic-override={overrides.title394}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title394
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item384"}
                              data-plasmic-override={overrides.item384}
                              className={classNames("all", sty.item384)}
                            >
                              <div
                                data-plasmic-name={"left384"}
                                data-plasmic-override={overrides.left384}
                                className={classNames("all", sty.left384)}
                              >
                                <div
                                  data-plasmic-name={"icon384"}
                                  data-plasmic-override={overrides.icon384}
                                  className={classNames("all", sty.icon384)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__prSp)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title395"}
                                data-plasmic-override={overrides.title395}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title395
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn8"}
                          data-plasmic-override={overrides.btn8}
                          className={classNames("__wab_instance", sty.btn8)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? false
          : hasVariant(globalVariants, "mobile", "mobile")
            ? false
            : hasVariant(globalVariants, "mobile", "tabletPortrait")
              ? true
              : false
      ) ? (
        <div
          data-plasmic-name={"tablet"}
          data-plasmic-override={overrides.tablet}
          className={classNames("all", sty.tablet)}
        >
          <div
            data-plasmic-name={"row6"}
            data-plasmic-override={overrides.row6}
            className={classNames("all", sty.row6)}
          >
            <FeaturesProductHeader
              data-plasmic-name={"featuresProductHeader"}
              data-plasmic-override={overrides.featuresProductHeader}
              className={classNames(
                "__wab_instance",
                sty.featuresProductHeader
              )}
              description={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
                  : "MyEvaluations streamlines medical training with efficient scheduling, compliance tracking, and custom evaluations. The secure platform saves time and resources, enabling comprehensive reports for improved outcomes."
              }
              subtitle={
                hasVariant(globalVariants, "mobile", "mobile")
                  ? "Product"
                  : "Product"
              }
            />
          </div>
          <div
            data-plasmic-name={"key4"}
            data-plasmic-override={overrides.key4}
            className={classNames("all", sty.key4)}
          >
            <header
              data-plasmic-name={"header4"}
              data-plasmic-override={overrides.header4}
              className={classNames("all", sty.header4)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__kCPE
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list11"}
              data-plasmic-override={overrides.list11}
              className={classNames("all", sty.list11)}
            >
              <div
                data-plasmic-name={"row7"}
                data-plasmic-override={overrides.row7}
                className={classNames("all", sty.row7)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__pk0En
                  )}
                  desciption={
                    "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                  }
                  title={"Evaluations, Milestones & EPAs"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__nKw20)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___0NxAy
                  )}
                  desciption={
                    "Create guided PIPs to proactively identify weaknesses and systematically improve your program. Utilize Clinical Learning Contracts, set for nursing students, to align expectations and facilitate feedback for focused growth."
                  }
                  title={
                    "Performance Improvement Plans & Clinical Learning Contracts"
                  }
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__pZajE)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e7ed370b68c67f76e2ca004000c2ffc7.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <div
                  data-plasmic-name={"figmaPaste5"}
                  data-plasmic-override={overrides.figmaPaste5}
                  className={classNames("all", sty.figmaPaste5)}
                >
                  <div
                    data-plasmic-name={"narrowCard17"}
                    data-plasmic-override={overrides.narrowCard17}
                    className={classNames("all", sty.narrowCard17)}
                  >
                    <div
                      data-plasmic-name={"header9"}
                      data-plasmic-override={overrides.header9}
                      className={classNames("all", sty.header9)}
                    >
                      <div
                        data-plasmic-name={"title100"}
                        data-plasmic-override={overrides.title100}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title100
                        )}
                      >
                        {"Assessment \n& Competency Management"}
                      </div>
                      <Icon94Icon
                        className={classNames("all", sty.svg__fs94S)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content17"}
                      data-plasmic-override={overrides.content17}
                      className={classNames("all", sty.content17)}
                    >
                      <div
                        data-plasmic-name={"desc17"}
                        data-plasmic-override={overrides.desc17}
                        className={classNames("all", "__wab_text", sty.desc17)}
                      >
                        {
                          "Strengthen assessment quality, support competency-based education, and transform educational information into meaningful insight."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder17"}
                        data-plasmic-override={overrides.placeholder17}
                        className={classNames("all", sty.placeholder17)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header10"}
                            data-plasmic-override={overrides.header10}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header10
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list7"}
                          data-plasmic-override={overrides.list7}
                          className={classNames("all", sty.list7)}
                        >
                          <div
                            data-plasmic-name={"item97"}
                            data-plasmic-override={overrides.item97}
                            className={classNames("all", sty.item97)}
                          >
                            <div
                              data-plasmic-name={"left97"}
                              data-plasmic-override={overrides.left97}
                              className={classNames("all", sty.left97)}
                            >
                              <div
                                data-plasmic-name={"icon97"}
                                data-plasmic-override={overrides.icon97}
                                className={classNames("all", sty.icon97)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yrRzZ)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title2"}
                              data-plasmic-override={overrides.title2}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title2
                              )}
                            >
                              {"SAGE\u2122"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item98"}
                            data-plasmic-override={overrides.item98}
                            className={classNames("all", sty.item98)}
                          >
                            <div
                              data-plasmic-name={"left98"}
                              data-plasmic-override={overrides.left98}
                              className={classNames("all", sty.left98)}
                            >
                              <div
                                data-plasmic-name={"icon98"}
                                data-plasmic-override={overrides.icon98}
                                className={classNames("all", sty.icon98)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___2O6X)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title101"}
                              data-plasmic-override={overrides.title101}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title101
                              )}
                            >
                              {"Evaluations & Assessments"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item99"}
                            data-plasmic-override={overrides.item99}
                            className={classNames("all", sty.item99)}
                          >
                            <div
                              data-plasmic-name={"left99"}
                              data-plasmic-override={overrides.left99}
                              className={classNames("all", sty.left99)}
                            >
                              <div
                                data-plasmic-name={"icon99"}
                                data-plasmic-override={overrides.icon99}
                                className={classNames("all", sty.icon99)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__s1HJ)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title102"}
                              data-plasmic-override={overrides.title102}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title102
                              )}
                            >
                              {"MyInsights\u00ae"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item100"}
                            data-plasmic-override={overrides.item100}
                            className={classNames("all", sty.item100)}
                          >
                            <div
                              data-plasmic-name={"left100"}
                              data-plasmic-override={overrides.left100}
                              className={classNames("all", sty.left100)}
                            >
                              <div
                                data-plasmic-name={"icon100"}
                                data-plasmic-override={overrides.icon100}
                                className={classNames("all", sty.icon100)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__lmnDe)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title103"}
                              data-plasmic-override={overrides.title103}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title103
                              )}
                            >
                              {"Milestones & EPAs"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item101"}
                            data-plasmic-override={overrides.item101}
                            className={classNames("all", sty.item101)}
                          >
                            <div
                              data-plasmic-name={"left101"}
                              data-plasmic-override={overrides.left101}
                              className={classNames("all", sty.left101)}
                            >
                              <div
                                data-plasmic-name={"icon101"}
                                data-plasmic-override={overrides.icon101}
                                className={classNames("all", sty.icon101)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yOyfY)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title104"}
                              data-plasmic-override={overrides.title104}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title104
                              )}
                            >
                              {"Narrative Predictive Value (NPV)"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item102"}
                            data-plasmic-override={overrides.item102}
                            className={classNames("all", sty.item102)}
                          >
                            <div
                              data-plasmic-name={"left102"}
                              data-plasmic-override={overrides.left102}
                              className={classNames("all", sty.left102)}
                            >
                              <div
                                data-plasmic-name={"icon102"}
                                data-plasmic-override={overrides.icon102}
                                className={classNames("all", sty.icon102)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wcQy9)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title105"}
                              data-plasmic-override={overrides.title105}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title105
                              )}
                            >
                              {"Performance Improvement Plans"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item103"}
                            data-plasmic-override={overrides.item103}
                            className={classNames("all", sty.item103)}
                          >
                            <div
                              data-plasmic-name={"left103"}
                              data-plasmic-override={overrides.left103}
                              className={classNames("all", sty.left103)}
                            >
                              <div
                                data-plasmic-name={"icon103"}
                                data-plasmic-override={overrides.icon103}
                                className={classNames("all", sty.icon103)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__bqja)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title106"}
                              data-plasmic-override={overrides.title106}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title106
                              )}
                            >
                              {"Performance Dashboard"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item104"}
                              data-plasmic-override={overrides.item104}
                              className={classNames("all", sty.item104)}
                            >
                              <div
                                data-plasmic-name={"left104"}
                                data-plasmic-override={overrides.left104}
                                className={classNames("all", sty.left104)}
                              >
                                <div
                                  data-plasmic-name={"icon104"}
                                  data-plasmic-override={overrides.icon104}
                                  className={classNames("all", sty.icon104)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___3Hih2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title107"}
                                data-plasmic-override={overrides.title107}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title107
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item105"}
                              data-plasmic-override={overrides.item105}
                              className={classNames("all", sty.item105)}
                            >
                              <div
                                data-plasmic-name={"left105"}
                                data-plasmic-override={overrides.left105}
                                className={classNames("all", sty.left105)}
                              >
                                <div
                                  data-plasmic-name={"icon105"}
                                  data-plasmic-override={overrides.icon105}
                                  className={classNames("all", sty.icon105)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pPpin
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title108"}
                                data-plasmic-override={overrides.title108}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title108
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item106"}
                              data-plasmic-override={overrides.item106}
                              className={classNames("all", sty.item106)}
                            >
                              <div
                                data-plasmic-name={"left106"}
                                data-plasmic-override={overrides.left106}
                                className={classNames("all", sty.left106)}
                              >
                                <div
                                  data-plasmic-name={"icon106"}
                                  data-plasmic-override={overrides.icon106}
                                  className={classNames("all", sty.icon106)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pCa3T
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title109"}
                                data-plasmic-override={overrides.title109}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title109
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item107"}
                              data-plasmic-override={overrides.item107}
                              className={classNames("all", sty.item107)}
                            >
                              <div
                                data-plasmic-name={"left107"}
                                data-plasmic-override={overrides.left107}
                                className={classNames("all", sty.left107)}
                              >
                                <div
                                  data-plasmic-name={"icon107"}
                                  data-plasmic-override={overrides.icon107}
                                  className={classNames("all", sty.icon107)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___6SwQy
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title110"}
                                data-plasmic-override={overrides.title110}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title110
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item108"}
                              data-plasmic-override={overrides.item108}
                              className={classNames("all", sty.item108)}
                            >
                              <div
                                data-plasmic-name={"left108"}
                                data-plasmic-override={overrides.left108}
                                className={classNames("all", sty.left108)}
                              >
                                <div
                                  data-plasmic-name={"icon108"}
                                  data-plasmic-override={overrides.icon108}
                                  className={classNames("all", sty.icon108)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__jdJE)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title111"}
                                data-plasmic-override={overrides.title111}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title111
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item109"}
                              data-plasmic-override={overrides.item109}
                              className={classNames("all", sty.item109)}
                            >
                              <div
                                data-plasmic-name={"left109"}
                                data-plasmic-override={overrides.left109}
                                className={classNames("all", sty.left109)}
                              >
                                <div
                                  data-plasmic-name={"icon109"}
                                  data-plasmic-override={overrides.icon109}
                                  className={classNames("all", sty.icon109)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ujcGq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title112"}
                                data-plasmic-override={overrides.title112}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title112
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item110"}
                              data-plasmic-override={overrides.item110}
                              className={classNames("all", sty.item110)}
                            >
                              <div
                                data-plasmic-name={"left110"}
                                data-plasmic-override={overrides.left110}
                                className={classNames("all", sty.left110)}
                              >
                                <div
                                  data-plasmic-name={"icon110"}
                                  data-plasmic-override={overrides.icon110}
                                  className={classNames("all", sty.icon110)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qyW83
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title113"}
                                data-plasmic-override={overrides.title113}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title113
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item111"}
                              data-plasmic-override={overrides.item111}
                              className={classNames("all", sty.item111)}
                            >
                              <div
                                data-plasmic-name={"left111"}
                                data-plasmic-override={overrides.left111}
                                className={classNames("all", sty.left111)}
                              >
                                <div
                                  data-plasmic-name={"icon111"}
                                  data-plasmic-override={overrides.icon111}
                                  className={classNames("all", sty.icon111)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__oFcus
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title114"}
                                data-plasmic-override={overrides.title114}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title114
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item112"}
                              data-plasmic-override={overrides.item112}
                              className={classNames("all", sty.item112)}
                            >
                              <div
                                data-plasmic-name={"left112"}
                                data-plasmic-override={overrides.left112}
                                className={classNames("all", sty.left112)}
                              >
                                <div
                                  data-plasmic-name={"icon112"}
                                  data-plasmic-override={overrides.icon112}
                                  className={classNames("all", sty.icon112)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__glMol
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title115"}
                                data-plasmic-override={overrides.title115}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title115
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item113"}
                              data-plasmic-override={overrides.item113}
                              className={classNames("all", sty.item113)}
                            >
                              <div
                                data-plasmic-name={"left113"}
                                data-plasmic-override={overrides.left113}
                                className={classNames("all", sty.left113)}
                              >
                                <div
                                  data-plasmic-name={"icon113"}
                                  data-plasmic-override={overrides.icon113}
                                  className={classNames("all", sty.icon113)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__bbNb5
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title116"}
                                data-plasmic-override={overrides.title116}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title116
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item114"}
                              data-plasmic-override={overrides.item114}
                              className={classNames("all", sty.item114)}
                            >
                              <div
                                data-plasmic-name={"left114"}
                                data-plasmic-override={overrides.left114}
                                className={classNames("all", sty.left114)}
                              >
                                <div
                                  data-plasmic-name={"icon114"}
                                  data-plasmic-override={overrides.icon114}
                                  className={classNames("all", sty.icon114)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__nnEjq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title117"}
                                data-plasmic-override={overrides.title117}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title117
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item115"}
                              data-plasmic-override={overrides.item115}
                              className={classNames("all", sty.item115)}
                            >
                              <div
                                data-plasmic-name={"left115"}
                                data-plasmic-override={overrides.left115}
                                className={classNames("all", sty.left115)}
                              >
                                <div
                                  data-plasmic-name={"icon115"}
                                  data-plasmic-override={overrides.icon115}
                                  className={classNames("all", sty.icon115)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__spVwv
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title118"}
                                data-plasmic-override={overrides.title118}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title118
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item116"}
                              data-plasmic-override={overrides.item116}
                              className={classNames("all", sty.item116)}
                            >
                              <div
                                data-plasmic-name={"left116"}
                                data-plasmic-override={overrides.left116}
                                className={classNames("all", sty.left116)}
                              >
                                <div
                                  data-plasmic-name={"icon116"}
                                  data-plasmic-override={overrides.icon116}
                                  className={classNames("all", sty.icon116)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ozmw8
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title119"}
                                data-plasmic-override={overrides.title119}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title119
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item117"}
                              data-plasmic-override={overrides.item117}
                              className={classNames("all", sty.item117)}
                            >
                              <div
                                data-plasmic-name={"left117"}
                                data-plasmic-override={overrides.left117}
                                className={classNames("all", sty.left117)}
                              >
                                <div
                                  data-plasmic-name={"icon117"}
                                  data-plasmic-override={overrides.icon117}
                                  className={classNames("all", sty.icon117)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pAjkG
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title120"}
                                data-plasmic-override={overrides.title120}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title120
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item118"}
                              data-plasmic-override={overrides.item118}
                              className={classNames("all", sty.item118)}
                            >
                              <div
                                data-plasmic-name={"left118"}
                                data-plasmic-override={overrides.left118}
                                className={classNames("all", sty.left118)}
                              >
                                <div
                                  data-plasmic-name={"icon118"}
                                  data-plasmic-override={overrides.icon118}
                                  className={classNames("all", sty.icon118)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__hHN4)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title121"}
                                data-plasmic-override={overrides.title121}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title121
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item119"}
                              data-plasmic-override={overrides.item119}
                              className={classNames("all", sty.item119)}
                            >
                              <div
                                data-plasmic-name={"left119"}
                                data-plasmic-override={overrides.left119}
                                className={classNames("all", sty.left119)}
                              >
                                <div
                                  data-plasmic-name={"icon119"}
                                  data-plasmic-override={overrides.icon119}
                                  className={classNames("all", sty.icon119)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__bAeEx
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title122"}
                                data-plasmic-override={overrides.title122}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title122
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item120"}
                              data-plasmic-override={overrides.item120}
                              className={classNames("all", sty.item120)}
                            >
                              <div
                                data-plasmic-name={"left120"}
                                data-plasmic-override={overrides.left120}
                                className={classNames("all", sty.left120)}
                              >
                                <div
                                  data-plasmic-name={"icon120"}
                                  data-plasmic-override={overrides.icon120}
                                  className={classNames("all", sty.icon120)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qQ4Ty
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title123"}
                                data-plasmic-override={overrides.title123}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title123
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn17"}
                          data-plasmic-override={overrides.btn17}
                          className={classNames("__wab_instance", sty.btn17)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard18"}
                    data-plasmic-override={overrides.narrowCard18}
                    className={classNames("all", sty.narrowCard18)}
                  >
                    <div
                      data-plasmic-name={"header11"}
                      data-plasmic-override={overrides.header11}
                      className={classNames("all", sty.header11)}
                    >
                      <div
                        data-plasmic-name={"title124"}
                        data-plasmic-override={overrides.title124}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title124
                        )}
                      >
                        {"Educational Operations"}
                      </div>
                      <Icon96Icon
                        className={classNames("all", sty.svg__uw0T4)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content18"}
                      data-plasmic-override={overrides.content18}
                      className={classNames("all", sty.content18)}
                    >
                      <div
                        data-plasmic-name={"desc18"}
                        data-plasmic-override={overrides.desc18}
                        className={classNames("all", "__wab_text", sty.desc18)}
                      >
                        {
                          "Manage the day-to-day activities that keep educational programs running efficiently."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder18"}
                        data-plasmic-override={overrides.placeholder18}
                        className={classNames("all", sty.placeholder18)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header12"}
                            data-plasmic-override={overrides.header12}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header12
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list8"}
                          data-plasmic-override={overrides.list8}
                          className={classNames("all", sty.list8)}
                        >
                          <div
                            data-plasmic-name={"item121"}
                            data-plasmic-override={overrides.item121}
                            className={classNames("all", sty.item121)}
                          >
                            <div
                              data-plasmic-name={"left121"}
                              data-plasmic-override={overrides.left121}
                              className={classNames("all", sty.left121)}
                            >
                              <div
                                data-plasmic-name={"icon121"}
                                data-plasmic-override={overrides.icon121}
                                className={classNames("all", sty.icon121)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vxcsC)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title125"}
                              data-plasmic-override={overrides.title125}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title125
                              )}
                            >
                              {"Clinical Hours"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item122"}
                            data-plasmic-override={overrides.item122}
                            className={classNames("all", sty.item122)}
                          >
                            <div
                              data-plasmic-name={"left122"}
                              data-plasmic-override={overrides.left122}
                              className={classNames("all", sty.left122)}
                            >
                              <div
                                data-plasmic-name={"icon122"}
                                data-plasmic-override={overrides.icon122}
                                className={classNames("all", sty.icon122)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___9AvoH)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title126"}
                              data-plasmic-override={overrides.title126}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title126
                              )}
                            >
                              {"MyQuickPass\u00ae"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item123"}
                            data-plasmic-override={overrides.item123}
                            className={classNames("all", sty.item123)}
                          >
                            <div
                              data-plasmic-name={"left123"}
                              data-plasmic-override={overrides.left123}
                              className={classNames("all", sty.left123)}
                            >
                              <div
                                data-plasmic-name={"icon123"}
                                data-plasmic-override={overrides.icon123}
                                className={classNames("all", sty.icon123)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__emfza)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title127"}
                              data-plasmic-override={overrides.title127}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title127
                              )}
                            >
                              {"Scheduling"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item124"}
                            data-plasmic-override={overrides.item124}
                            className={classNames("all", sty.item124)}
                          >
                            <div
                              data-plasmic-name={"left124"}
                              data-plasmic-override={overrides.left124}
                              className={classNames("all", sty.left124)}
                            >
                              <div
                                data-plasmic-name={"icon124"}
                                data-plasmic-override={overrides.icon124}
                                className={classNames("all", sty.icon124)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__opb4J)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title128"}
                              data-plasmic-override={overrides.title128}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title128
                              )}
                            >
                              {"Automated Scheduling & Lottery"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item125"}
                            data-plasmic-override={overrides.item125}
                            className={classNames("all", sty.item125)}
                          >
                            <div
                              data-plasmic-name={"left125"}
                              data-plasmic-override={overrides.left125}
                              className={classNames("all", sty.left125)}
                            >
                              <div
                                data-plasmic-name={"icon125"}
                                data-plasmic-override={overrides.icon125}
                                className={classNames("all", sty.icon125)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__oO8W3)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title129"}
                              data-plasmic-override={overrides.title129}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title129
                              )}
                            >
                              {"Conference Tracking"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item126"}
                            data-plasmic-override={overrides.item126}
                            className={classNames("all", sty.item126)}
                          >
                            <div
                              data-plasmic-name={"left126"}
                              data-plasmic-override={overrides.left126}
                              className={classNames("all", sty.left126)}
                            >
                              <div
                                data-plasmic-name={"icon126"}
                                data-plasmic-override={overrides.icon126}
                                className={classNames("all", sty.icon126)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__viIev)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title130"}
                              data-plasmic-override={overrides.title130}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title130
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item127"}
                            data-plasmic-override={overrides.item127}
                            className={classNames("all", sty.item127)}
                          >
                            <div
                              data-plasmic-name={"left127"}
                              data-plasmic-override={overrides.left127}
                              className={classNames("all", sty.left127)}
                            >
                              <div
                                data-plasmic-name={"icon127"}
                                data-plasmic-override={overrides.icon127}
                                className={classNames("all", sty.icon127)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__azjI)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title131"}
                              data-plasmic-override={overrides.title131}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title131
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item128"}
                              data-plasmic-override={overrides.item128}
                              className={classNames("all", sty.item128)}
                            >
                              <div
                                data-plasmic-name={"left128"}
                                data-plasmic-override={overrides.left128}
                                className={classNames("all", sty.left128)}
                              >
                                <div
                                  data-plasmic-name={"icon128"}
                                  data-plasmic-override={overrides.icon128}
                                  className={classNames("all", sty.icon128)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__vnOyq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title132"}
                                data-plasmic-override={overrides.title132}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title132
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item129"}
                              data-plasmic-override={overrides.item129}
                              className={classNames("all", sty.item129)}
                            >
                              <div
                                data-plasmic-name={"left129"}
                                data-plasmic-override={overrides.left129}
                                className={classNames("all", sty.left129)}
                              >
                                <div
                                  data-plasmic-name={"icon129"}
                                  data-plasmic-override={overrides.icon129}
                                  className={classNames("all", sty.icon129)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__la6Zx
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title133"}
                                data-plasmic-override={overrides.title133}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title133
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item130"}
                              data-plasmic-override={overrides.item130}
                              className={classNames("all", sty.item130)}
                            >
                              <div
                                data-plasmic-name={"left130"}
                                data-plasmic-override={overrides.left130}
                                className={classNames("all", sty.left130)}
                              >
                                <div
                                  data-plasmic-name={"icon130"}
                                  data-plasmic-override={overrides.icon130}
                                  className={classNames("all", sty.icon130)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__lXTj)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title134"}
                                data-plasmic-override={overrides.title134}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title134
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item131"}
                              data-plasmic-override={overrides.item131}
                              className={classNames("all", sty.item131)}
                            >
                              <div
                                data-plasmic-name={"left131"}
                                data-plasmic-override={overrides.left131}
                                className={classNames("all", sty.left131)}
                              >
                                <div
                                  data-plasmic-name={"icon131"}
                                  data-plasmic-override={overrides.icon131}
                                  className={classNames("all", sty.icon131)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lZx2U
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title135"}
                                data-plasmic-override={overrides.title135}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title135
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item132"}
                              data-plasmic-override={overrides.item132}
                              className={classNames("all", sty.item132)}
                            >
                              <div
                                data-plasmic-name={"left132"}
                                data-plasmic-override={overrides.left132}
                                className={classNames("all", sty.left132)}
                              >
                                <div
                                  data-plasmic-name={"icon132"}
                                  data-plasmic-override={overrides.icon132}
                                  className={classNames("all", sty.icon132)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___3Y0X3
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title136"}
                                data-plasmic-override={overrides.title136}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title136
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item133"}
                              data-plasmic-override={overrides.item133}
                              className={classNames("all", sty.item133)}
                            >
                              <div
                                data-plasmic-name={"left133"}
                                data-plasmic-override={overrides.left133}
                                className={classNames("all", sty.left133)}
                              >
                                <div
                                  data-plasmic-name={"icon133"}
                                  data-plasmic-override={overrides.icon133}
                                  className={classNames("all", sty.icon133)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__jgMmz
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title137"}
                                data-plasmic-override={overrides.title137}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title137
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item134"}
                              data-plasmic-override={overrides.item134}
                              className={classNames("all", sty.item134)}
                            >
                              <div
                                data-plasmic-name={"left134"}
                                data-plasmic-override={overrides.left134}
                                className={classNames("all", sty.left134)}
                              >
                                <div
                                  data-plasmic-name={"icon134"}
                                  data-plasmic-override={overrides.icon134}
                                  className={classNames("all", sty.icon134)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__iexKb
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title138"}
                                data-plasmic-override={overrides.title138}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title138
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item135"}
                              data-plasmic-override={overrides.item135}
                              className={classNames("all", sty.item135)}
                            >
                              <div
                                data-plasmic-name={"left135"}
                                data-plasmic-override={overrides.left135}
                                className={classNames("all", sty.left135)}
                              >
                                <div
                                  data-plasmic-name={"icon135"}
                                  data-plasmic-override={overrides.icon135}
                                  className={classNames("all", sty.icon135)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__mBmht
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title139"}
                                data-plasmic-override={overrides.title139}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title139
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item136"}
                              data-plasmic-override={overrides.item136}
                              className={classNames("all", sty.item136)}
                            >
                              <div
                                data-plasmic-name={"left136"}
                                data-plasmic-override={overrides.left136}
                                className={classNames("all", sty.left136)}
                              >
                                <div
                                  data-plasmic-name={"icon136"}
                                  data-plasmic-override={overrides.icon136}
                                  className={classNames("all", sty.icon136)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ka3Ra
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title140"}
                                data-plasmic-override={overrides.title140}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title140
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item137"}
                              data-plasmic-override={overrides.item137}
                              className={classNames("all", sty.item137)}
                            >
                              <div
                                data-plasmic-name={"left137"}
                                data-plasmic-override={overrides.left137}
                                className={classNames("all", sty.left137)}
                              >
                                <div
                                  data-plasmic-name={"icon137"}
                                  data-plasmic-override={overrides.icon137}
                                  className={classNames("all", sty.icon137)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__sl2H4
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title141"}
                                data-plasmic-override={overrides.title141}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title141
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item138"}
                              data-plasmic-override={overrides.item138}
                              className={classNames("all", sty.item138)}
                            >
                              <div
                                data-plasmic-name={"left138"}
                                data-plasmic-override={overrides.left138}
                                className={classNames("all", sty.left138)}
                              >
                                <div
                                  data-plasmic-name={"icon138"}
                                  data-plasmic-override={overrides.icon138}
                                  className={classNames("all", sty.icon138)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__hFyEl
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title142"}
                                data-plasmic-override={overrides.title142}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title142
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item139"}
                              data-plasmic-override={overrides.item139}
                              className={classNames("all", sty.item139)}
                            >
                              <div
                                data-plasmic-name={"left139"}
                                data-plasmic-override={overrides.left139}
                                className={classNames("all", sty.left139)}
                              >
                                <div
                                  data-plasmic-name={"icon139"}
                                  data-plasmic-override={overrides.icon139}
                                  className={classNames("all", sty.icon139)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qSp6W
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title143"}
                                data-plasmic-override={overrides.title143}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title143
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item140"}
                              data-plasmic-override={overrides.item140}
                              className={classNames("all", sty.item140)}
                            >
                              <div
                                data-plasmic-name={"left140"}
                                data-plasmic-override={overrides.left140}
                                className={classNames("all", sty.left140)}
                              >
                                <div
                                  data-plasmic-name={"icon140"}
                                  data-plasmic-override={overrides.icon140}
                                  className={classNames("all", sty.icon140)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zKeVk
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title144"}
                                data-plasmic-override={overrides.title144}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title144
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item141"}
                              data-plasmic-override={overrides.item141}
                              className={classNames("all", sty.item141)}
                            >
                              <div
                                data-plasmic-name={"left141"}
                                data-plasmic-override={overrides.left141}
                                className={classNames("all", sty.left141)}
                              >
                                <div
                                  data-plasmic-name={"icon141"}
                                  data-plasmic-override={overrides.icon141}
                                  className={classNames("all", sty.icon141)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__d0NOn
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title145"}
                                data-plasmic-override={overrides.title145}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title145
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item142"}
                              data-plasmic-override={overrides.item142}
                              className={classNames("all", sty.item142)}
                            >
                              <div
                                data-plasmic-name={"left142"}
                                data-plasmic-override={overrides.left142}
                                className={classNames("all", sty.left142)}
                              >
                                <div
                                  data-plasmic-name={"icon142"}
                                  data-plasmic-override={overrides.icon142}
                                  className={classNames("all", sty.icon142)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__tgcz2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title146"}
                                data-plasmic-override={overrides.title146}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title146
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item143"}
                              data-plasmic-override={overrides.item143}
                              className={classNames("all", sty.item143)}
                            >
                              <div
                                data-plasmic-name={"left143"}
                                data-plasmic-override={overrides.left143}
                                className={classNames("all", sty.left143)}
                              >
                                <div
                                  data-plasmic-name={"icon143"}
                                  data-plasmic-override={overrides.icon143}
                                  className={classNames("all", sty.icon143)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__iQpy)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title147"}
                                data-plasmic-override={overrides.title147}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title147
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item144"}
                              data-plasmic-override={overrides.item144}
                              className={classNames("all", sty.item144)}
                            >
                              <div
                                data-plasmic-name={"left144"}
                                data-plasmic-override={overrides.left144}
                                className={classNames("all", sty.left144)}
                              >
                                <div
                                  data-plasmic-name={"icon144"}
                                  data-plasmic-override={overrides.icon144}
                                  className={classNames("all", sty.icon144)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__gUfOa
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title148"}
                                data-plasmic-override={overrides.title148}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title148
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn18"}
                          data-plasmic-override={overrides.btn18}
                          className={classNames("__wab_instance", sty.btn18)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"row8"}
                data-plasmic-override={overrides.row8}
                className={classNames("all", sty.row8)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__rIxYs
                  )}
                  desciption={
                    "Create custom curriculum for each rotation consisting of EPAs, evaluations, procedures, learning materials, quizzes, and more. Experience efficient planning, flexibility, and structured pathways for comprehensive and innovative education."
                  }
                  title={"Curriculum Management"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__ra1V)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/cb0239402e2936b1bf7362398e69386b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___74Wq6
                  )}
                  desciption={
                    "Stay on top of tasks, messages, and schedules. Ensure staff and students stay compliant effortlessly. Analyze individual academic performance, identify achievements and areas for improvement. Compare to benchmarks, and set improvement plans."
                  }
                  title={"Educational Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___2Qvuh)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/1f79a4c37de0c595115ccbeec901b877.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <div
                  data-plasmic-name={"figmaPaste6"}
                  data-plasmic-override={overrides.figmaPaste6}
                  className={classNames("all", sty.figmaPaste6)}
                >
                  <div
                    data-plasmic-name={"narrowCard19"}
                    data-plasmic-override={overrides.narrowCard19}
                    className={classNames("all", sty.narrowCard19)}
                  >
                    <div
                      data-plasmic-name={"header40"}
                      data-plasmic-override={overrides.header40}
                      className={classNames("all", sty.header40)}
                    >
                      <div
                        data-plasmic-name={"title149"}
                        data-plasmic-override={overrides.title149}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title149
                        )}
                      >
                        {"Learning & Development"}
                      </div>
                      <Icon95Icon
                        className={classNames("all", sty.svg__mN0Sf)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content19"}
                      data-plasmic-override={overrides.content19}
                      className={classNames("all", sty.content19)}
                    >
                      <div
                        data-plasmic-name={"desc19"}
                        data-plasmic-override={overrides.desc19}
                        className={classNames("all", "__wab_text", sty.desc19)}
                      >
                        {
                          "Support learner growth through integrated educational resources and competency development."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder19"}
                        data-plasmic-override={overrides.placeholder19}
                        className={classNames("all", sty.placeholder19)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header41"}
                            data-plasmic-override={overrides.header41}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header41
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list9"}
                          data-plasmic-override={overrides.list9}
                          className={classNames("all", sty.list9)}
                        >
                          <div
                            data-plasmic-name={"item145"}
                            data-plasmic-override={overrides.item145}
                            className={classNames("all", sty.item145)}
                          >
                            <div
                              data-plasmic-name={"left145"}
                              data-plasmic-override={overrides.left145}
                              className={classNames("all", sty.left145)}
                            >
                              <div
                                data-plasmic-name={"icon145"}
                                data-plasmic-override={overrides.icon145}
                                className={classNames("all", sty.icon145)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__riO3)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title150"}
                              data-plasmic-override={overrides.title150}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title150
                              )}
                            >
                              {"Learning Assignments"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item146"}
                            data-plasmic-override={overrides.item146}
                            className={classNames("all", sty.item146)}
                          >
                            <div
                              data-plasmic-name={"left146"}
                              data-plasmic-override={overrides.left146}
                              className={classNames("all", sty.left146)}
                            >
                              <div
                                data-plasmic-name={"icon146"}
                                data-plasmic-override={overrides.icon146}
                                className={classNames("all", sty.icon146)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yjEf1)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title151"}
                              data-plasmic-override={overrides.title151}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title151
                              )}
                            >
                              {"MyQuiz\u2122"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item147"}
                            data-plasmic-override={overrides.item147}
                            className={classNames("all", sty.item147)}
                          >
                            <div
                              data-plasmic-name={"left147"}
                              data-plasmic-override={overrides.left147}
                              className={classNames("all", sty.left147)}
                            >
                              <div
                                data-plasmic-name={"icon147"}
                                data-plasmic-override={overrides.icon147}
                                className={classNames("all", sty.icon147)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__y0PU)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title152"}
                              data-plasmic-override={overrides.title152}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title152
                              )}
                            >
                              {"MyPortfolios\u00ae"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item148"}
                            data-plasmic-override={overrides.item148}
                            className={classNames("all", sty.item148)}
                          >
                            <div
                              data-plasmic-name={"left148"}
                              data-plasmic-override={overrides.left148}
                              className={classNames("all", sty.left148)}
                            >
                              <div
                                data-plasmic-name={"icon148"}
                                data-plasmic-override={overrides.icon148}
                                className={classNames("all", sty.icon148)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wfgFw)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title153"}
                              data-plasmic-override={overrides.title153}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title153
                              )}
                            >
                              {"Curriculum Management"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item149"}
                            data-plasmic-override={overrides.item149}
                            className={classNames("all", sty.item149)}
                          >
                            <div
                              data-plasmic-name={"left149"}
                              data-plasmic-override={overrides.left149}
                              className={classNames("all", sty.left149)}
                            >
                              <div
                                data-plasmic-name={"icon149"}
                                data-plasmic-override={overrides.icon149}
                                className={classNames("all", sty.icon149)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yzEnH)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title154"}
                              data-plasmic-override={overrides.title154}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title154
                              )}
                            >
                              {"Certificate & Diploma Management"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item150"}
                              data-plasmic-override={overrides.item150}
                              className={classNames("all", sty.item150)}
                            >
                              <div
                                data-plasmic-name={"left150"}
                                data-plasmic-override={overrides.left150}
                                className={classNames("all", sty.left150)}
                              >
                                <div
                                  data-plasmic-name={"icon150"}
                                  data-plasmic-override={overrides.icon150}
                                  className={classNames("all", sty.icon150)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__aDgJ)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title155"}
                                data-plasmic-override={overrides.title155}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title155
                                )}
                              >
                                {"Burnout Monitoring"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item151"}
                              data-plasmic-override={overrides.item151}
                              className={classNames("all", sty.item151)}
                            >
                              <div
                                data-plasmic-name={"left151"}
                                data-plasmic-override={overrides.left151}
                                className={classNames("all", sty.left151)}
                              >
                                <div
                                  data-plasmic-name={"icon151"}
                                  data-plasmic-override={overrides.icon151}
                                  className={classNames("all", sty.icon151)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__hfgC)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title156"}
                                data-plasmic-override={overrides.title156}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title156
                                )}
                              >
                                {"Demographic Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item152"}
                              data-plasmic-override={overrides.item152}
                              className={classNames("all", sty.item152)}
                            >
                              <div
                                data-plasmic-name={"left152"}
                                data-plasmic-override={overrides.left152}
                                className={classNames("all", sty.left152)}
                              >
                                <div
                                  data-plasmic-name={"icon152"}
                                  data-plasmic-override={overrides.icon152}
                                  className={classNames("all", sty.icon152)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fVlvR
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title157"}
                                data-plasmic-override={overrides.title157}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title157
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item153"}
                              data-plasmic-override={overrides.item153}
                              className={classNames("all", sty.item153)}
                            >
                              <div
                                data-plasmic-name={"left153"}
                                data-plasmic-override={overrides.left153}
                                className={classNames("all", sty.left153)}
                              >
                                <div
                                  data-plasmic-name={"icon153"}
                                  data-plasmic-override={overrides.icon153}
                                  className={classNames("all", sty.icon153)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__mmEt0
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title158"}
                                data-plasmic-override={overrides.title158}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title158
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item154"}
                              data-plasmic-override={overrides.item154}
                              className={classNames("all", sty.item154)}
                            >
                              <div
                                data-plasmic-name={"left154"}
                                data-plasmic-override={overrides.left154}
                                className={classNames("all", sty.left154)}
                              >
                                <div
                                  data-plasmic-name={"icon154"}
                                  data-plasmic-override={overrides.icon154}
                                  className={classNames("all", sty.icon154)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rCZxR
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title159"}
                                data-plasmic-override={overrides.title159}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title159
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item155"}
                              data-plasmic-override={overrides.item155}
                              className={classNames("all", sty.item155)}
                            >
                              <div
                                data-plasmic-name={"left155"}
                                data-plasmic-override={overrides.left155}
                                className={classNames("all", sty.left155)}
                              >
                                <div
                                  data-plasmic-name={"icon155"}
                                  data-plasmic-override={overrides.icon155}
                                  className={classNames("all", sty.icon155)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__kGrsu
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title160"}
                                data-plasmic-override={overrides.title160}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title160
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item156"}
                              data-plasmic-override={overrides.item156}
                              className={classNames("all", sty.item156)}
                            >
                              <div
                                data-plasmic-name={"left156"}
                                data-plasmic-override={overrides.left156}
                                className={classNames("all", sty.left156)}
                              >
                                <div
                                  data-plasmic-name={"icon156"}
                                  data-plasmic-override={overrides.icon156}
                                  className={classNames("all", sty.icon156)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pCAgo
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title161"}
                                data-plasmic-override={overrides.title161}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title161
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item157"}
                              data-plasmic-override={overrides.item157}
                              className={classNames("all", sty.item157)}
                            >
                              <div
                                data-plasmic-name={"left157"}
                                data-plasmic-override={overrides.left157}
                                className={classNames("all", sty.left157)}
                              >
                                <div
                                  data-plasmic-name={"icon157"}
                                  data-plasmic-override={overrides.icon157}
                                  className={classNames("all", sty.icon157)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__cPh24
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title162"}
                                data-plasmic-override={overrides.title162}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title162
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item158"}
                              data-plasmic-override={overrides.item158}
                              className={classNames("all", sty.item158)}
                            >
                              <div
                                data-plasmic-name={"left158"}
                                data-plasmic-override={overrides.left158}
                                className={classNames("all", sty.left158)}
                              >
                                <div
                                  data-plasmic-name={"icon158"}
                                  data-plasmic-override={overrides.icon158}
                                  className={classNames("all", sty.icon158)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__kg5Te
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title163"}
                                data-plasmic-override={overrides.title163}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title163
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item159"}
                              data-plasmic-override={overrides.item159}
                              className={classNames("all", sty.item159)}
                            >
                              <div
                                data-plasmic-name={"left159"}
                                data-plasmic-override={overrides.left159}
                                className={classNames("all", sty.left159)}
                              >
                                <div
                                  data-plasmic-name={"icon159"}
                                  data-plasmic-override={overrides.icon159}
                                  className={classNames("all", sty.icon159)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__t0LfD
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title164"}
                                data-plasmic-override={overrides.title164}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title164
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item160"}
                              data-plasmic-override={overrides.item160}
                              className={classNames("all", sty.item160)}
                            >
                              <div
                                data-plasmic-name={"left160"}
                                data-plasmic-override={overrides.left160}
                                className={classNames("all", sty.left160)}
                              >
                                <div
                                  data-plasmic-name={"icon160"}
                                  data-plasmic-override={overrides.icon160}
                                  className={classNames("all", sty.icon160)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zJn3V
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title165"}
                                data-plasmic-override={overrides.title165}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title165
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item161"}
                              data-plasmic-override={overrides.item161}
                              className={classNames("all", sty.item161)}
                            >
                              <div
                                data-plasmic-name={"left161"}
                                data-plasmic-override={overrides.left161}
                                className={classNames("all", sty.left161)}
                              >
                                <div
                                  data-plasmic-name={"icon161"}
                                  data-plasmic-override={overrides.icon161}
                                  className={classNames("all", sty.icon161)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___9JgeD
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title166"}
                                data-plasmic-override={overrides.title166}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title166
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item162"}
                              data-plasmic-override={overrides.item162}
                              className={classNames("all", sty.item162)}
                            >
                              <div
                                data-plasmic-name={"left162"}
                                data-plasmic-override={overrides.left162}
                                className={classNames("all", sty.left162)}
                              >
                                <div
                                  data-plasmic-name={"icon162"}
                                  data-plasmic-override={overrides.icon162}
                                  className={classNames("all", sty.icon162)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lhBvB
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title167"}
                                data-plasmic-override={overrides.title167}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title167
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item163"}
                              data-plasmic-override={overrides.item163}
                              className={classNames("all", sty.item163)}
                            >
                              <div
                                data-plasmic-name={"left163"}
                                data-plasmic-override={overrides.left163}
                                className={classNames("all", sty.left163)}
                              >
                                <div
                                  data-plasmic-name={"icon163"}
                                  data-plasmic-override={overrides.icon163}
                                  className={classNames("all", sty.icon163)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ckRlg
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title168"}
                                data-plasmic-override={overrides.title168}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title168
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item164"}
                              data-plasmic-override={overrides.item164}
                              className={classNames("all", sty.item164)}
                            >
                              <div
                                data-plasmic-name={"left164"}
                                data-plasmic-override={overrides.left164}
                                className={classNames("all", sty.left164)}
                              >
                                <div
                                  data-plasmic-name={"icon164"}
                                  data-plasmic-override={overrides.icon164}
                                  className={classNames("all", sty.icon164)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___6MeDo
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title169"}
                                data-plasmic-override={overrides.title169}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title169
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item165"}
                              data-plasmic-override={overrides.item165}
                              className={classNames("all", sty.item165)}
                            >
                              <div
                                data-plasmic-name={"left165"}
                                data-plasmic-override={overrides.left165}
                                className={classNames("all", sty.left165)}
                              >
                                <div
                                  data-plasmic-name={"icon165"}
                                  data-plasmic-override={overrides.icon165}
                                  className={classNames("all", sty.icon165)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__u0UbO
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title170"}
                                data-plasmic-override={overrides.title170}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title170
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item166"}
                              data-plasmic-override={overrides.item166}
                              className={classNames("all", sty.item166)}
                            >
                              <div
                                data-plasmic-name={"left166"}
                                data-plasmic-override={overrides.left166}
                                className={classNames("all", sty.left166)}
                              >
                                <div
                                  data-plasmic-name={"icon166"}
                                  data-plasmic-override={overrides.icon166}
                                  className={classNames("all", sty.icon166)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__imJa3
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title171"}
                                data-plasmic-override={overrides.title171}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title171
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item167"}
                              data-plasmic-override={overrides.item167}
                              className={classNames("all", sty.item167)}
                            >
                              <div
                                data-plasmic-name={"left167"}
                                data-plasmic-override={overrides.left167}
                                className={classNames("all", sty.left167)}
                              >
                                <div
                                  data-plasmic-name={"icon167"}
                                  data-plasmic-override={overrides.icon167}
                                  className={classNames("all", sty.icon167)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rzLjz
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title172"}
                                data-plasmic-override={overrides.title172}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title172
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item168"}
                              data-plasmic-override={overrides.item168}
                              className={classNames("all", sty.item168)}
                            >
                              <div
                                data-plasmic-name={"left168"}
                                data-plasmic-override={overrides.left168}
                                className={classNames("all", sty.left168)}
                              >
                                <div
                                  data-plasmic-name={"icon168"}
                                  data-plasmic-override={overrides.icon168}
                                  className={classNames("all", sty.icon168)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ka2Ki
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title173"}
                                data-plasmic-override={overrides.title173}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title173
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn19"}
                          data-plasmic-override={overrides.btn19}
                          className={classNames("__wab_instance", sty.btn19)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard20"}
                    data-plasmic-override={overrides.narrowCard20}
                    className={classNames("all", sty.narrowCard20)}
                  >
                    <div
                      data-plasmic-name={"header42"}
                      data-plasmic-override={overrides.header42}
                      className={classNames("all", sty.header42)}
                    >
                      <div
                        data-plasmic-name={"title174"}
                        data-plasmic-override={overrides.title174}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title174
                        )}
                      >
                        {"Administrative Management"}
                      </div>
                      <Icon99Icon
                        className={classNames("all", sty.svg___0KcoA)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content20"}
                      data-plasmic-override={overrides.content20}
                      className={classNames("all", sty.content20)}
                    >
                      <div
                        data-plasmic-name={"desc20"}
                        data-plasmic-override={overrides.desc20}
                        className={classNames("all", "__wab_text", sty.desc20)}
                      >
                        {
                          "Simplify administrative workflows while supporting learners, faculty, and institutional leadership."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder20"}
                        data-plasmic-override={overrides.placeholder20}
                        className={classNames("all", sty.placeholder20)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header43"}
                            data-plasmic-override={overrides.header43}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header43
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list10"}
                          data-plasmic-override={overrides.list10}
                          className={classNames("all", sty.list10)}
                        >
                          <div
                            data-plasmic-name={"item169"}
                            data-plasmic-override={overrides.item169}
                            className={classNames("all", sty.item169)}
                          >
                            <div
                              data-plasmic-name={"left169"}
                              data-plasmic-override={overrides.left169}
                              className={classNames("all", sty.left169)}
                            >
                              <div
                                data-plasmic-name={"icon169"}
                                data-plasmic-override={overrides.icon169}
                                className={classNames("all", sty.icon169)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wjoab)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title175"}
                              data-plasmic-override={overrides.title175}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title175
                              )}
                            >
                              {"Onboarding & Credentialing"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item170"}
                            data-plasmic-override={overrides.item170}
                            className={classNames("all", sty.item170)}
                          >
                            <div
                              data-plasmic-name={"left170"}
                              data-plasmic-override={overrides.left170}
                              className={classNames("all", sty.left170)}
                            >
                              <div
                                data-plasmic-name={"icon170"}
                                data-plasmic-override={overrides.icon170}
                                className={classNames("all", sty.icon170)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__zWjlj)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title176"}
                              data-plasmic-override={overrides.title176}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title176
                              )}
                            >
                              {"Electronic Agreements & Signatures"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item171"}
                            data-plasmic-override={overrides.item171}
                            className={classNames("all", sty.item171)}
                          >
                            <div
                              data-plasmic-name={"left171"}
                              data-plasmic-override={overrides.left171}
                              className={classNames("all", sty.left171)}
                            >
                              <div
                                data-plasmic-name={"icon171"}
                                data-plasmic-override={overrides.icon171}
                                className={classNames("all", sty.icon171)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jzXR)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title177"}
                              data-plasmic-override={overrides.title177}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title177
                              )}
                            >
                              {"Custom Reporting"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item172"}
                              data-plasmic-override={overrides.item172}
                              className={classNames("all", sty.item172)}
                            >
                              <div
                                data-plasmic-name={"left172"}
                                data-plasmic-override={overrides.left172}
                                className={classNames("all", sty.left172)}
                              >
                                <div
                                  data-plasmic-name={"icon172"}
                                  data-plasmic-override={overrides.icon172}
                                  className={classNames("all", sty.icon172)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__yAawn
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title178"}
                                data-plasmic-override={overrides.title178}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title178
                                )}
                              >
                                {"Curriculum Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item173"}
                              data-plasmic-override={overrides.item173}
                              className={classNames("all", sty.item173)}
                            >
                              <div
                                data-plasmic-name={"left173"}
                                data-plasmic-override={overrides.left173}
                                className={classNames("all", sty.left173)}
                              >
                                <div
                                  data-plasmic-name={"icon173"}
                                  data-plasmic-override={overrides.icon173}
                                  className={classNames("all", sty.icon173)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__sp4K)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title179"}
                                data-plasmic-override={overrides.title179}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title179
                                )}
                              >
                                {"Certificate & Diploma Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item174"}
                              data-plasmic-override={overrides.item174}
                              className={classNames("all", sty.item174)}
                            >
                              <div
                                data-plasmic-name={"left174"}
                                data-plasmic-override={overrides.left174}
                                className={classNames("all", sty.left174)}
                              >
                                <div
                                  data-plasmic-name={"icon174"}
                                  data-plasmic-override={overrides.icon174}
                                  className={classNames("all", sty.icon174)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___1Z1Ts
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title180"}
                                data-plasmic-override={overrides.title180}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title180
                                )}
                              >
                                {"Burnout Monitoring"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item175"}
                              data-plasmic-override={overrides.item175}
                              className={classNames("all", sty.item175)}
                            >
                              <div
                                data-plasmic-name={"left175"}
                                data-plasmic-override={overrides.left175}
                                className={classNames("all", sty.left175)}
                              >
                                <div
                                  data-plasmic-name={"icon175"}
                                  data-plasmic-override={overrides.icon175}
                                  className={classNames("all", sty.icon175)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__kj3Vx
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title181"}
                                data-plasmic-override={overrides.title181}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title181
                                )}
                              >
                                {"Demographic Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item176"}
                              data-plasmic-override={overrides.item176}
                              className={classNames("all", sty.item176)}
                            >
                              <div
                                data-plasmic-name={"left176"}
                                data-plasmic-override={overrides.left176}
                                className={classNames("all", sty.left176)}
                              >
                                <div
                                  data-plasmic-name={"icon176"}
                                  data-plasmic-override={overrides.icon176}
                                  className={classNames("all", sty.icon176)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__pjFxd
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title182"}
                                data-plasmic-override={overrides.title182}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title182
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item177"}
                              data-plasmic-override={overrides.item177}
                              className={classNames("all", sty.item177)}
                            >
                              <div
                                data-plasmic-name={"left177"}
                                data-plasmic-override={overrides.left177}
                                className={classNames("all", sty.left177)}
                              >
                                <div
                                  data-plasmic-name={"icon177"}
                                  data-plasmic-override={overrides.icon177}
                                  className={classNames("all", sty.icon177)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__dpAQb
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title183"}
                                data-plasmic-override={overrides.title183}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title183
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item178"}
                              data-plasmic-override={overrides.item178}
                              className={classNames("all", sty.item178)}
                            >
                              <div
                                data-plasmic-name={"left178"}
                                data-plasmic-override={overrides.left178}
                                className={classNames("all", sty.left178)}
                              >
                                <div
                                  data-plasmic-name={"icon178"}
                                  data-plasmic-override={overrides.icon178}
                                  className={classNames("all", sty.icon178)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__cFWhx
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title184"}
                                data-plasmic-override={overrides.title184}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title184
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item179"}
                              data-plasmic-override={overrides.item179}
                              className={classNames("all", sty.item179)}
                            >
                              <div
                                data-plasmic-name={"left179"}
                                data-plasmic-override={overrides.left179}
                                className={classNames("all", sty.left179)}
                              >
                                <div
                                  data-plasmic-name={"icon179"}
                                  data-plasmic-override={overrides.icon179}
                                  className={classNames("all", sty.icon179)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__nuYu2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title185"}
                                data-plasmic-override={overrides.title185}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title185
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item180"}
                              data-plasmic-override={overrides.item180}
                              className={classNames("all", sty.item180)}
                            >
                              <div
                                data-plasmic-name={"left180"}
                                data-plasmic-override={overrides.left180}
                                className={classNames("all", sty.left180)}
                              >
                                <div
                                  data-plasmic-name={"icon180"}
                                  data-plasmic-override={overrides.icon180}
                                  className={classNames("all", sty.icon180)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__seaZc
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title186"}
                                data-plasmic-override={overrides.title186}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title186
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item181"}
                              data-plasmic-override={overrides.item181}
                              className={classNames("all", sty.item181)}
                            >
                              <div
                                data-plasmic-name={"left181"}
                                data-plasmic-override={overrides.left181}
                                className={classNames("all", sty.left181)}
                              >
                                <div
                                  data-plasmic-name={"icon181"}
                                  data-plasmic-override={overrides.icon181}
                                  className={classNames("all", sty.icon181)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__xj5Ir
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title187"}
                                data-plasmic-override={overrides.title187}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title187
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item182"}
                              data-plasmic-override={overrides.item182}
                              className={classNames("all", sty.item182)}
                            >
                              <div
                                data-plasmic-name={"left182"}
                                data-plasmic-override={overrides.left182}
                                className={classNames("all", sty.left182)}
                              >
                                <div
                                  data-plasmic-name={"icon182"}
                                  data-plasmic-override={overrides.icon182}
                                  className={classNames("all", sty.icon182)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ebLqX
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title188"}
                                data-plasmic-override={overrides.title188}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title188
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item183"}
                              data-plasmic-override={overrides.item183}
                              className={classNames("all", sty.item183)}
                            >
                              <div
                                data-plasmic-name={"left183"}
                                data-plasmic-override={overrides.left183}
                                className={classNames("all", sty.left183)}
                              >
                                <div
                                  data-plasmic-name={"icon183"}
                                  data-plasmic-override={overrides.icon183}
                                  className={classNames("all", sty.icon183)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ygesO
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title189"}
                                data-plasmic-override={overrides.title189}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title189
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item184"}
                              data-plasmic-override={overrides.item184}
                              className={classNames("all", sty.item184)}
                            >
                              <div
                                data-plasmic-name={"left184"}
                                data-plasmic-override={overrides.left184}
                                className={classNames("all", sty.left184)}
                              >
                                <div
                                  data-plasmic-name={"icon184"}
                                  data-plasmic-override={overrides.icon184}
                                  className={classNames("all", sty.icon184)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__n5Z8H
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title190"}
                                data-plasmic-override={overrides.title190}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title190
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item185"}
                              data-plasmic-override={overrides.item185}
                              className={classNames("all", sty.item185)}
                            >
                              <div
                                data-plasmic-name={"left185"}
                                data-plasmic-override={overrides.left185}
                                className={classNames("all", sty.left185)}
                              >
                                <div
                                  data-plasmic-name={"icon185"}
                                  data-plasmic-override={overrides.icon185}
                                  className={classNames("all", sty.icon185)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__zLdAh
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title191"}
                                data-plasmic-override={overrides.title191}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title191
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item186"}
                              data-plasmic-override={overrides.item186}
                              className={classNames("all", sty.item186)}
                            >
                              <div
                                data-plasmic-name={"left186"}
                                data-plasmic-override={overrides.left186}
                                className={classNames("all", sty.left186)}
                              >
                                <div
                                  data-plasmic-name={"icon186"}
                                  data-plasmic-override={overrides.icon186}
                                  className={classNames("all", sty.icon186)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__noZqJ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title192"}
                                data-plasmic-override={overrides.title192}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title192
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item187"}
                              data-plasmic-override={overrides.item187}
                              className={classNames("all", sty.item187)}
                            >
                              <div
                                data-plasmic-name={"left187"}
                                data-plasmic-override={overrides.left187}
                                className={classNames("all", sty.left187)}
                              >
                                <div
                                  data-plasmic-name={"icon187"}
                                  data-plasmic-override={overrides.icon187}
                                  className={classNames("all", sty.icon187)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___3Hrf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title193"}
                                data-plasmic-override={overrides.title193}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title193
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item188"}
                              data-plasmic-override={overrides.item188}
                              className={classNames("all", sty.item188)}
                            >
                              <div
                                data-plasmic-name={"left188"}
                                data-plasmic-override={overrides.left188}
                                className={classNames("all", sty.left188)}
                              >
                                <div
                                  data-plasmic-name={"icon188"}
                                  data-plasmic-override={overrides.icon188}
                                  className={classNames("all", sty.icon188)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__tUop3
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title194"}
                                data-plasmic-override={overrides.title194}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title194
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item189"}
                              data-plasmic-override={overrides.item189}
                              className={classNames("all", sty.item189)}
                            >
                              <div
                                data-plasmic-name={"left189"}
                                data-plasmic-override={overrides.left189}
                                className={classNames("all", sty.left189)}
                              >
                                <div
                                  data-plasmic-name={"icon189"}
                                  data-plasmic-override={overrides.icon189}
                                  className={classNames("all", sty.icon189)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fjzxy
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title195"}
                                data-plasmic-override={overrides.title195}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title195
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item190"}
                              data-plasmic-override={overrides.item190}
                              className={classNames("all", sty.item190)}
                            >
                              <div
                                data-plasmic-name={"left190"}
                                data-plasmic-override={overrides.left190}
                                className={classNames("all", sty.left190)}
                              >
                                <div
                                  data-plasmic-name={"icon190"}
                                  data-plasmic-override={overrides.icon190}
                                  className={classNames("all", sty.icon190)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__jcTv0
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title499"}
                                data-plasmic-override={overrides.title499}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title499
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item191"}
                              data-plasmic-override={overrides.item191}
                              className={classNames("all", sty.item191)}
                            >
                              <div
                                data-plasmic-name={"left191"}
                                data-plasmic-override={overrides.left191}
                                className={classNames("all", sty.left191)}
                              >
                                <div
                                  data-plasmic-name={"icon191"}
                                  data-plasmic-override={overrides.icon191}
                                  className={classNames("all", sty.icon191)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rXd0M
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title500"}
                                data-plasmic-override={overrides.title500}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title500
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item192"}
                              data-plasmic-override={overrides.item192}
                              className={classNames("all", sty.item192)}
                            >
                              <div
                                data-plasmic-name={"left192"}
                                data-plasmic-override={overrides.left192}
                                className={classNames("all", sty.left192)}
                              >
                                <div
                                  data-plasmic-name={"icon192"}
                                  data-plasmic-override={overrides.icon192}
                                  className={classNames("all", sty.icon192)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___6ZRoe
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title501"}
                                data-plasmic-override={overrides.title501}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title501
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn20"}
                          data-plasmic-override={overrides.btn20}
                          className={classNames("__wab_instance", sty.btn20)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard21"}
                  data-plasmic-override={overrides.narrowCard21}
                  className={classNames("all", sty.narrowCard21)}
                >
                  <div
                    data-plasmic-name={"header44"}
                    data-plasmic-override={overrides.header44}
                    className={classNames("all", sty.header44)}
                  >
                    <div
                      data-plasmic-name={"title502"}
                      data-plasmic-override={overrides.title502}
                      className={classNames("all", "__wab_text", sty.title502)}
                    >
                      {"Learning & Development"}
                    </div>
                    <Icon95Icon
                      className={classNames("all", sty.svg__eyuF)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content21"}
                    data-plasmic-override={overrides.content21}
                    className={classNames("all", sty.content21)}
                  >
                    <div
                      data-plasmic-name={"desc21"}
                      data-plasmic-override={overrides.desc21}
                      className={classNames("all", "__wab_text", sty.desc21)}
                    >
                      {
                        "Support learner growth through integrated educational resources and competency development."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder21"}
                      data-plasmic-override={overrides.placeholder21}
                      className={classNames("all", sty.placeholder21)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header45"}
                          data-plasmic-override={overrides.header45}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header45
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list28"}
                        data-plasmic-override={overrides.list28}
                        className={classNames("all", sty.list28)}
                      >
                        <div
                          data-plasmic-name={"item481"}
                          data-plasmic-override={overrides.item481}
                          className={classNames("all", sty.item481)}
                        >
                          <div
                            data-plasmic-name={"left481"}
                            data-plasmic-override={overrides.left481}
                            className={classNames("all", sty.left481)}
                          >
                            <div
                              data-plasmic-name={"icon481"}
                              data-plasmic-override={overrides.icon481}
                              className={classNames("all", sty.icon481)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__o8TL3)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title503"}
                            data-plasmic-override={overrides.title503}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title503
                            )}
                          >
                            {"Learning Assignments"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item482"}
                          data-plasmic-override={overrides.item482}
                          className={classNames("all", sty.item482)}
                        >
                          <div
                            data-plasmic-name={"left482"}
                            data-plasmic-override={overrides.left482}
                            className={classNames("all", sty.left482)}
                          >
                            <div
                              data-plasmic-name={"icon482"}
                              data-plasmic-override={overrides.icon482}
                              className={classNames("all", sty.icon482)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__k313Y)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title504"}
                            data-plasmic-override={overrides.title504}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title504
                            )}
                          >
                            {"MyQuiz\u2122"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item483"}
                          data-plasmic-override={overrides.item483}
                          className={classNames("all", sty.item483)}
                        >
                          <div
                            data-plasmic-name={"left483"}
                            data-plasmic-override={overrides.left483}
                            className={classNames("all", sty.left483)}
                          >
                            <div
                              data-plasmic-name={"icon483"}
                              data-plasmic-override={overrides.icon483}
                              className={classNames("all", sty.icon483)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__baHzU)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title505"}
                            data-plasmic-override={overrides.title505}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title505
                            )}
                          >
                            {"MyPortfolios\u00ae"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item484"}
                          data-plasmic-override={overrides.item484}
                          className={classNames("all", sty.item484)}
                        >
                          <div
                            data-plasmic-name={"left484"}
                            data-plasmic-override={overrides.left484}
                            className={classNames("all", sty.left484)}
                          >
                            <div
                              data-plasmic-name={"icon484"}
                              data-plasmic-override={overrides.icon484}
                              className={classNames("all", sty.icon484)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___9T8X)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title506"}
                            data-plasmic-override={overrides.title506}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title506
                            )}
                          >
                            {"Curriculum Management"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item485"}
                          data-plasmic-override={overrides.item485}
                          className={classNames("all", sty.item485)}
                        >
                          <div
                            data-plasmic-name={"left485"}
                            data-plasmic-override={overrides.left485}
                            className={classNames("all", sty.left485)}
                          >
                            <div
                              data-plasmic-name={"icon485"}
                              data-plasmic-override={overrides.icon485}
                              className={classNames("all", sty.icon485)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__oMJ4)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title507"}
                            data-plasmic-override={overrides.title507}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title507
                            )}
                          >
                            {"Certificate & Diploma Management"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item486"}
                            data-plasmic-override={overrides.item486}
                            className={classNames("all", sty.item486)}
                          >
                            <div
                              data-plasmic-name={"left486"}
                              data-plasmic-override={overrides.left486}
                              className={classNames("all", sty.left486)}
                            >
                              <div
                                data-plasmic-name={"icon486"}
                                data-plasmic-override={overrides.icon486}
                                className={classNames("all", sty.icon486)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hv2K)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title508"}
                              data-plasmic-override={overrides.title508}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title508
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item487"}
                            data-plasmic-override={overrides.item487}
                            className={classNames("all", sty.item487)}
                          >
                            <div
                              data-plasmic-name={"left487"}
                              data-plasmic-override={overrides.left487}
                              className={classNames("all", sty.left487)}
                            >
                              <div
                                data-plasmic-name={"icon487"}
                                data-plasmic-override={overrides.icon487}
                                className={classNames("all", sty.icon487)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__a6Rd)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title509"}
                              data-plasmic-override={overrides.title509}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title509
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item488"}
                            data-plasmic-override={overrides.item488}
                            className={classNames("all", sty.item488)}
                          >
                            <div
                              data-plasmic-name={"left488"}
                              data-plasmic-override={overrides.left488}
                              className={classNames("all", sty.left488)}
                            >
                              <div
                                data-plasmic-name={"icon488"}
                                data-plasmic-override={overrides.icon488}
                                className={classNames("all", sty.icon488)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__f9Onh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title510"}
                              data-plasmic-override={overrides.title510}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title510
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item489"}
                            data-plasmic-override={overrides.item489}
                            className={classNames("all", sty.item489)}
                          >
                            <div
                              data-plasmic-name={"left489"}
                              data-plasmic-override={overrides.left489}
                              className={classNames("all", sty.left489)}
                            >
                              <div
                                data-plasmic-name={"icon489"}
                                data-plasmic-override={overrides.icon489}
                                className={classNames("all", sty.icon489)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kuEa)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title511"}
                              data-plasmic-override={overrides.title511}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title511
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item490"}
                            data-plasmic-override={overrides.item490}
                            className={classNames("all", sty.item490)}
                          >
                            <div
                              data-plasmic-name={"left490"}
                              data-plasmic-override={overrides.left490}
                              className={classNames("all", sty.left490)}
                            >
                              <div
                                data-plasmic-name={"icon490"}
                                data-plasmic-override={overrides.icon490}
                                className={classNames("all", sty.icon490)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yRow4)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title512"}
                              data-plasmic-override={overrides.title512}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title512
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item491"}
                            data-plasmic-override={overrides.item491}
                            className={classNames("all", sty.item491)}
                          >
                            <div
                              data-plasmic-name={"left491"}
                              data-plasmic-override={overrides.left491}
                              className={classNames("all", sty.left491)}
                            >
                              <div
                                data-plasmic-name={"icon491"}
                                data-plasmic-override={overrides.icon491}
                                className={classNames("all", sty.icon491)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jt5KM)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title513"}
                              data-plasmic-override={overrides.title513}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title513
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item492"}
                            data-plasmic-override={overrides.item492}
                            className={classNames("all", sty.item492)}
                          >
                            <div
                              data-plasmic-name={"left492"}
                              data-plasmic-override={overrides.left492}
                              className={classNames("all", sty.left492)}
                            >
                              <div
                                data-plasmic-name={"icon492"}
                                data-plasmic-override={overrides.icon492}
                                className={classNames("all", sty.icon492)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__mZTw5)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title514"}
                              data-plasmic-override={overrides.title514}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title514
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item493"}
                            data-plasmic-override={overrides.item493}
                            className={classNames("all", sty.item493)}
                          >
                            <div
                              data-plasmic-name={"left493"}
                              data-plasmic-override={overrides.left493}
                              className={classNames("all", sty.left493)}
                            >
                              <div
                                data-plasmic-name={"icon493"}
                                data-plasmic-override={overrides.icon493}
                                className={classNames("all", sty.icon493)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___4SFcq)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title515"}
                              data-plasmic-override={overrides.title515}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title515
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item494"}
                            data-plasmic-override={overrides.item494}
                            className={classNames("all", sty.item494)}
                          >
                            <div
                              data-plasmic-name={"left494"}
                              data-plasmic-override={overrides.left494}
                              className={classNames("all", sty.left494)}
                            >
                              <div
                                data-plasmic-name={"icon494"}
                                data-plasmic-override={overrides.icon494}
                                className={classNames("all", sty.icon494)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xp4Z9)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title516"}
                              data-plasmic-override={overrides.title516}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title516
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item495"}
                            data-plasmic-override={overrides.item495}
                            className={classNames("all", sty.item495)}
                          >
                            <div
                              data-plasmic-name={"left495"}
                              data-plasmic-override={overrides.left495}
                              className={classNames("all", sty.left495)}
                            >
                              <div
                                data-plasmic-name={"icon495"}
                                data-plasmic-override={overrides.icon495}
                                className={classNames("all", sty.icon495)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vVoTt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title517"}
                              data-plasmic-override={overrides.title517}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title517
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item496"}
                            data-plasmic-override={overrides.item496}
                            className={classNames("all", sty.item496)}
                          >
                            <div
                              data-plasmic-name={"left496"}
                              data-plasmic-override={overrides.left496}
                              className={classNames("all", sty.left496)}
                            >
                              <div
                                data-plasmic-name={"icon496"}
                                data-plasmic-override={overrides.icon496}
                                className={classNames("all", sty.icon496)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___7Gy1F)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title518"}
                              data-plasmic-override={overrides.title518}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title518
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item497"}
                            data-plasmic-override={overrides.item497}
                            className={classNames("all", sty.item497)}
                          >
                            <div
                              data-plasmic-name={"left497"}
                              data-plasmic-override={overrides.left497}
                              className={classNames("all", sty.left497)}
                            >
                              <div
                                data-plasmic-name={"icon497"}
                                data-plasmic-override={overrides.icon497}
                                className={classNames("all", sty.icon497)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__sE18G)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title519"}
                              data-plasmic-override={overrides.title519}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title519
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item498"}
                            data-plasmic-override={overrides.item498}
                            className={classNames("all", sty.item498)}
                          >
                            <div
                              data-plasmic-name={"left498"}
                              data-plasmic-override={overrides.left498}
                              className={classNames("all", sty.left498)}
                            >
                              <div
                                data-plasmic-name={"icon498"}
                                data-plasmic-override={overrides.icon498}
                                className={classNames("all", sty.icon498)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___1Yako)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title520"}
                              data-plasmic-override={overrides.title520}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title520
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item499"}
                            data-plasmic-override={overrides.item499}
                            className={classNames("all", sty.item499)}
                          >
                            <div
                              data-plasmic-name={"left499"}
                              data-plasmic-override={overrides.left499}
                              className={classNames("all", sty.left499)}
                            >
                              <div
                                data-plasmic-name={"icon499"}
                                data-plasmic-override={overrides.icon499}
                                className={classNames("all", sty.icon499)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jfsuL)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title521"}
                              data-plasmic-override={overrides.title521}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title521
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item500"}
                            data-plasmic-override={overrides.item500}
                            className={classNames("all", sty.item500)}
                          >
                            <div
                              data-plasmic-name={"left500"}
                              data-plasmic-override={overrides.left500}
                              className={classNames("all", sty.left500)}
                            >
                              <div
                                data-plasmic-name={"icon500"}
                                data-plasmic-override={overrides.icon500}
                                className={classNames("all", sty.icon500)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gabYi)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title522"}
                              data-plasmic-override={overrides.title522}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title522
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item501"}
                            data-plasmic-override={overrides.item501}
                            className={classNames("all", sty.item501)}
                          >
                            <div
                              data-plasmic-name={"left501"}
                              data-plasmic-override={overrides.left501}
                              className={classNames("all", sty.left501)}
                            >
                              <div
                                data-plasmic-name={"icon501"}
                                data-plasmic-override={overrides.icon501}
                                className={classNames("all", sty.icon501)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__y34Lv)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title523"}
                              data-plasmic-override={overrides.title523}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title523
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item502"}
                            data-plasmic-override={overrides.item502}
                            className={classNames("all", sty.item502)}
                          >
                            <div
                              data-plasmic-name={"left502"}
                              data-plasmic-override={overrides.left502}
                              className={classNames("all", sty.left502)}
                            >
                              <div
                                data-plasmic-name={"icon502"}
                                data-plasmic-override={overrides.icon502}
                                className={classNames("all", sty.icon502)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__v2Wzy)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title524"}
                              data-plasmic-override={overrides.title524}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title524
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item503"}
                            data-plasmic-override={overrides.item503}
                            className={classNames("all", sty.item503)}
                          >
                            <div
                              data-plasmic-name={"left503"}
                              data-plasmic-override={overrides.left503}
                              className={classNames("all", sty.left503)}
                            >
                              <div
                                data-plasmic-name={"icon503"}
                                data-plasmic-override={overrides.icon503}
                                className={classNames("all", sty.icon503)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__d1J9P)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title525"}
                              data-plasmic-override={overrides.title525}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title525
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item504"}
                            data-plasmic-override={overrides.item504}
                            className={classNames("all", sty.item504)}
                          >
                            <div
                              data-plasmic-name={"left504"}
                              data-plasmic-override={overrides.left504}
                              className={classNames("all", sty.left504)}
                            >
                              <div
                                data-plasmic-name={"icon504"}
                                data-plasmic-override={overrides.icon504}
                                className={classNames("all", sty.icon504)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___5Y2K)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title526"}
                              data-plasmic-override={overrides.title526}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title526
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn21"}
                        data-plasmic-override={overrides.btn21}
                        className={classNames("__wab_instance", sty.btn21)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard22"}
                  data-plasmic-override={overrides.narrowCard22}
                  className={classNames("all", sty.narrowCard22)}
                >
                  <div
                    data-plasmic-name={"header46"}
                    data-plasmic-override={overrides.header46}
                    className={classNames("all", sty.header46)}
                  >
                    <div
                      data-plasmic-name={"title527"}
                      data-plasmic-override={overrides.title527}
                      className={classNames("all", "__wab_text", sty.title527)}
                    >
                      {"Administrative Management"}
                    </div>
                    <Icon99Icon
                      className={classNames("all", sty.svg__ytZcS)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content22"}
                    data-plasmic-override={overrides.content22}
                    className={classNames("all", sty.content22)}
                  >
                    <div
                      data-plasmic-name={"desc22"}
                      data-plasmic-override={overrides.desc22}
                      className={classNames("all", "__wab_text", sty.desc22)}
                    >
                      {
                        "Simplify administrative workflows while supporting learners, faculty, and institutional leadership."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder22"}
                      data-plasmic-override={overrides.placeholder22}
                      className={classNames("all", sty.placeholder22)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header47"}
                          data-plasmic-override={overrides.header47}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header47
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list29"}
                        data-plasmic-override={overrides.list29}
                        className={classNames("all", sty.list29)}
                      >
                        <div
                          data-plasmic-name={"item505"}
                          data-plasmic-override={overrides.item505}
                          className={classNames("all", sty.item505)}
                        >
                          <div
                            data-plasmic-name={"left505"}
                            data-plasmic-override={overrides.left505}
                            className={classNames("all", sty.left505)}
                          >
                            <div
                              data-plasmic-name={"icon505"}
                              data-plasmic-override={overrides.icon505}
                              className={classNames("all", sty.icon505)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___82V3L)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title528"}
                            data-plasmic-override={overrides.title528}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title528
                            )}
                          >
                            {"Onboarding & Credentialing"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item506"}
                          data-plasmic-override={overrides.item506}
                          className={classNames("all", sty.item506)}
                        >
                          <div
                            data-plasmic-name={"left506"}
                            data-plasmic-override={overrides.left506}
                            className={classNames("all", sty.left506)}
                          >
                            <div
                              data-plasmic-name={"icon506"}
                              data-plasmic-override={overrides.icon506}
                              className={classNames("all", sty.icon506)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__kVwN4)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title529"}
                            data-plasmic-override={overrides.title529}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title529
                            )}
                          >
                            {"Electronic Agreements & Signatures"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item507"}
                          data-plasmic-override={overrides.item507}
                          className={classNames("all", sty.item507)}
                        >
                          <div
                            data-plasmic-name={"left507"}
                            data-plasmic-override={overrides.left507}
                            className={classNames("all", sty.left507)}
                          >
                            <div
                              data-plasmic-name={"icon507"}
                              data-plasmic-override={overrides.icon507}
                              className={classNames("all", sty.icon507)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__hGqnq)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title530"}
                            data-plasmic-override={overrides.title530}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title530
                            )}
                          >
                            {"Custom Reporting"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item508"}
                            data-plasmic-override={overrides.item508}
                            className={classNames("all", sty.item508)}
                          >
                            <div
                              data-plasmic-name={"left508"}
                              data-plasmic-override={overrides.left508}
                              className={classNames("all", sty.left508)}
                            >
                              <div
                                data-plasmic-name={"icon508"}
                                data-plasmic-override={overrides.icon508}
                                className={classNames("all", sty.icon508)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___9AVzU)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title531"}
                              data-plasmic-override={overrides.title531}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title531
                              )}
                            >
                              {"Curriculum Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item509"}
                            data-plasmic-override={overrides.item509}
                            className={classNames("all", sty.item509)}
                          >
                            <div
                              data-plasmic-name={"left509"}
                              data-plasmic-override={overrides.left509}
                              className={classNames("all", sty.left509)}
                            >
                              <div
                                data-plasmic-name={"icon509"}
                                data-plasmic-override={overrides.icon509}
                                className={classNames("all", sty.icon509)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ejFnV)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title532"}
                              data-plasmic-override={overrides.title532}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title532
                              )}
                            >
                              {"Certificate & Diploma Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item510"}
                            data-plasmic-override={overrides.item510}
                            className={classNames("all", sty.item510)}
                          >
                            <div
                              data-plasmic-name={"left510"}
                              data-plasmic-override={overrides.left510}
                              className={classNames("all", sty.left510)}
                            >
                              <div
                                data-plasmic-name={"icon510"}
                                data-plasmic-override={overrides.icon510}
                                className={classNames("all", sty.icon510)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yBgGs)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title533"}
                              data-plasmic-override={overrides.title533}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title533
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item511"}
                            data-plasmic-override={overrides.item511}
                            className={classNames("all", sty.item511)}
                          >
                            <div
                              data-plasmic-name={"left511"}
                              data-plasmic-override={overrides.left511}
                              className={classNames("all", sty.left511)}
                            >
                              <div
                                data-plasmic-name={"icon511"}
                                data-plasmic-override={overrides.icon511}
                                className={classNames("all", sty.icon511)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wwCto)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title534"}
                              data-plasmic-override={overrides.title534}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title534
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item512"}
                            data-plasmic-override={overrides.item512}
                            className={classNames("all", sty.item512)}
                          >
                            <div
                              data-plasmic-name={"left512"}
                              data-plasmic-override={overrides.left512}
                              className={classNames("all", sty.left512)}
                            >
                              <div
                                data-plasmic-name={"icon512"}
                                data-plasmic-override={overrides.icon512}
                                className={classNames("all", sty.icon512)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__szR2U)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title535"}
                              data-plasmic-override={overrides.title535}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title535
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item513"}
                            data-plasmic-override={overrides.item513}
                            className={classNames("all", sty.item513)}
                          >
                            <div
                              data-plasmic-name={"left513"}
                              data-plasmic-override={overrides.left513}
                              className={classNames("all", sty.left513)}
                            >
                              <div
                                data-plasmic-name={"icon513"}
                                data-plasmic-override={overrides.icon513}
                                className={classNames("all", sty.icon513)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__tHKcE)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title536"}
                              data-plasmic-override={overrides.title536}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title536
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item514"}
                            data-plasmic-override={overrides.item514}
                            className={classNames("all", sty.item514)}
                          >
                            <div
                              data-plasmic-name={"left514"}
                              data-plasmic-override={overrides.left514}
                              className={classNames("all", sty.left514)}
                            >
                              <div
                                data-plasmic-name={"icon514"}
                                data-plasmic-override={overrides.icon514}
                                className={classNames("all", sty.icon514)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__rGiGi)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title537"}
                              data-plasmic-override={overrides.title537}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title537
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item515"}
                            data-plasmic-override={overrides.item515}
                            className={classNames("all", sty.item515)}
                          >
                            <div
                              data-plasmic-name={"left515"}
                              data-plasmic-override={overrides.left515}
                              className={classNames("all", sty.left515)}
                            >
                              <div
                                data-plasmic-name={"icon515"}
                                data-plasmic-override={overrides.icon515}
                                className={classNames("all", sty.icon515)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___8NzvG)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title538"}
                              data-plasmic-override={overrides.title538}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title538
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item516"}
                            data-plasmic-override={overrides.item516}
                            className={classNames("all", sty.item516)}
                          >
                            <div
                              data-plasmic-name={"left516"}
                              data-plasmic-override={overrides.left516}
                              className={classNames("all", sty.left516)}
                            >
                              <div
                                data-plasmic-name={"icon516"}
                                data-plasmic-override={overrides.icon516}
                                className={classNames("all", sty.icon516)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xvdDr)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title539"}
                              data-plasmic-override={overrides.title539}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title539
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item517"}
                            data-plasmic-override={overrides.item517}
                            className={classNames("all", sty.item517)}
                          >
                            <div
                              data-plasmic-name={"left517"}
                              data-plasmic-override={overrides.left517}
                              className={classNames("all", sty.left517)}
                            >
                              <div
                                data-plasmic-name={"icon517"}
                                data-plasmic-override={overrides.icon517}
                                className={classNames("all", sty.icon517)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ofFvo)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title540"}
                              data-plasmic-override={overrides.title540}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title540
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item518"}
                            data-plasmic-override={overrides.item518}
                            className={classNames("all", sty.item518)}
                          >
                            <div
                              data-plasmic-name={"left518"}
                              data-plasmic-override={overrides.left518}
                              className={classNames("all", sty.left518)}
                            >
                              <div
                                data-plasmic-name={"icon518"}
                                data-plasmic-override={overrides.icon518}
                                className={classNames("all", sty.icon518)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__pOsbU)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title541"}
                              data-plasmic-override={overrides.title541}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title541
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item519"}
                            data-plasmic-override={overrides.item519}
                            className={classNames("all", sty.item519)}
                          >
                            <div
                              data-plasmic-name={"left519"}
                              data-plasmic-override={overrides.left519}
                              className={classNames("all", sty.left519)}
                            >
                              <div
                                data-plasmic-name={"icon519"}
                                data-plasmic-override={overrides.icon519}
                                className={classNames("all", sty.icon519)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___7RwBd)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title542"}
                              data-plasmic-override={overrides.title542}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title542
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item520"}
                            data-plasmic-override={overrides.item520}
                            className={classNames("all", sty.item520)}
                          >
                            <div
                              data-plasmic-name={"left520"}
                              data-plasmic-override={overrides.left520}
                              className={classNames("all", sty.left520)}
                            >
                              <div
                                data-plasmic-name={"icon520"}
                                data-plasmic-override={overrides.icon520}
                                className={classNames("all", sty.icon520)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___5Fshe)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title543"}
                              data-plasmic-override={overrides.title543}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title543
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item521"}
                            data-plasmic-override={overrides.item521}
                            className={classNames("all", sty.item521)}
                          >
                            <div
                              data-plasmic-name={"left521"}
                              data-plasmic-override={overrides.left521}
                              className={classNames("all", sty.left521)}
                            >
                              <div
                                data-plasmic-name={"icon521"}
                                data-plasmic-override={overrides.icon521}
                                className={classNames("all", sty.icon521)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__g2Xbh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title544"}
                              data-plasmic-override={overrides.title544}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title544
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item522"}
                            data-plasmic-override={overrides.item522}
                            className={classNames("all", sty.item522)}
                          >
                            <div
                              data-plasmic-name={"left522"}
                              data-plasmic-override={overrides.left522}
                              className={classNames("all", sty.left522)}
                            >
                              <div
                                data-plasmic-name={"icon522"}
                                data-plasmic-override={overrides.icon522}
                                className={classNames("all", sty.icon522)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__glUlG)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title545"}
                              data-plasmic-override={overrides.title545}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title545
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item523"}
                            data-plasmic-override={overrides.item523}
                            className={classNames("all", sty.item523)}
                          >
                            <div
                              data-plasmic-name={"left523"}
                              data-plasmic-override={overrides.left523}
                              className={classNames("all", sty.left523)}
                            >
                              <div
                                data-plasmic-name={"icon523"}
                                data-plasmic-override={overrides.icon523}
                                className={classNames("all", sty.icon523)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__pNvyH)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title546"}
                              data-plasmic-override={overrides.title546}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title546
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item524"}
                            data-plasmic-override={overrides.item524}
                            className={classNames("all", sty.item524)}
                          >
                            <div
                              data-plasmic-name={"left524"}
                              data-plasmic-override={overrides.left524}
                              className={classNames("all", sty.left524)}
                            >
                              <div
                                data-plasmic-name={"icon524"}
                                data-plasmic-override={overrides.icon524}
                                className={classNames("all", sty.icon524)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__tUBuz)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title547"}
                              data-plasmic-override={overrides.title547}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title547
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item525"}
                            data-plasmic-override={overrides.item525}
                            className={classNames("all", sty.item525)}
                          >
                            <div
                              data-plasmic-name={"left525"}
                              data-plasmic-override={overrides.left525}
                              className={classNames("all", sty.left525)}
                            >
                              <div
                                data-plasmic-name={"icon525"}
                                data-plasmic-override={overrides.icon525}
                                className={classNames("all", sty.icon525)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___8Gtwi)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title548"}
                              data-plasmic-override={overrides.title548}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title548
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item526"}
                            data-plasmic-override={overrides.item526}
                            className={classNames("all", sty.item526)}
                          >
                            <div
                              data-plasmic-name={"left526"}
                              data-plasmic-override={overrides.left526}
                              className={classNames("all", sty.left526)}
                            >
                              <div
                                data-plasmic-name={"icon526"}
                                data-plasmic-override={overrides.icon526}
                                className={classNames("all", sty.icon526)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__sYeLh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title549"}
                              data-plasmic-override={overrides.title549}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title549
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item527"}
                            data-plasmic-override={overrides.item527}
                            className={classNames("all", sty.item527)}
                          >
                            <div
                              data-plasmic-name={"left527"}
                              data-plasmic-override={overrides.left527}
                              className={classNames("all", sty.left527)}
                            >
                              <div
                                data-plasmic-name={"icon527"}
                                data-plasmic-override={overrides.icon527}
                                className={classNames("all", sty.icon527)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hb9Dm)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title550"}
                              data-plasmic-override={overrides.title550}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title550
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item528"}
                            data-plasmic-override={overrides.item528}
                            className={classNames("all", sty.item528)}
                          >
                            <div
                              data-plasmic-name={"left528"}
                              data-plasmic-override={overrides.left528}
                              className={classNames("all", sty.left528)}
                            >
                              <div
                                data-plasmic-name={"icon528"}
                                data-plasmic-override={overrides.icon528}
                                className={classNames("all", sty.icon528)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ddqdZ)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title551"}
                              data-plasmic-override={overrides.title551}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title551
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn22"}
                        data-plasmic-override={overrides.btn22}
                        className={classNames("__wab_instance", sty.btn22)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"row9"}
                data-plasmic-override={overrides.row9}
                className={classNames("all", sty.row9)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__fqNpQ
                  )}
                  desciption={
                    "Fulfill ACGME requirements using Annual Program Evaluations. Streamline monitoring to ensure your program consistently meets high standards. Gain insights and strategic oversight to elevate program reputation. "
                  }
                  title={"ACGME Compliance Tracking"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img___321Oo)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/e0f7df98d28ee45e44aa7bee3fa42fa0.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard___6KucK
                  )}
                  desciption={
                    "Simplify onboarding and credentialing for new trainees. Print certificates and diplomas effortlessly. Manage ERAS data with accuracy. Streamline contract management with electronic signatures."
                  }
                  title={"Administrative Tools"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__mvAqi)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a46f0a440808da7c0237c86d05dd281c.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <div
                  data-plasmic-name={"figmaPaste7"}
                  data-plasmic-override={overrides.figmaPaste7}
                  className={classNames("all", sty.figmaPaste7)}
                >
                  <div
                    data-plasmic-name={"narrowCard23"}
                    data-plasmic-override={overrides.narrowCard23}
                    className={classNames("all", sty.narrowCard23)}
                  >
                    <div
                      data-plasmic-name={"header48"}
                      data-plasmic-override={overrides.header48}
                      className={classNames("all", sty.header48)}
                    >
                      <div
                        data-plasmic-name={"title552"}
                        data-plasmic-override={overrides.title552}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title552
                        )}
                      >
                        {"Integrations \n& Connectivity"}
                      </div>
                      <Icon98Icon
                        className={classNames("all", sty.svg__tfEHg)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content23"}
                      data-plasmic-override={overrides.content23}
                      className={classNames("all", sty.content23)}
                    >
                      <div
                        data-plasmic-name={"desc23"}
                        data-plasmic-override={overrides.desc23}
                        className={classNames("all", "__wab_text", sty.desc23)}
                      >
                        {
                          "Connect MyEvaluations with the systems your institution already uses."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder23"}
                        data-plasmic-override={overrides.placeholder23}
                        className={classNames("all", sty.placeholder23)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header49"}
                            data-plasmic-override={overrides.header49}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header49
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list30"}
                          data-plasmic-override={overrides.list30}
                          className={classNames("all", sty.list30)}
                        >
                          <div
                            data-plasmic-name={"item529"}
                            data-plasmic-override={overrides.item529}
                            className={classNames("all", sty.item529)}
                          >
                            <div
                              data-plasmic-name={"left529"}
                              data-plasmic-override={overrides.left529}
                              className={classNames("all", sty.left529)}
                            >
                              <div
                                data-plasmic-name={"icon529"}
                                data-plasmic-override={overrides.icon529}
                                className={classNames("all", sty.icon529)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__lj2)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title553"}
                              data-plasmic-override={overrides.title553}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title553
                              )}
                            >
                              {"EHR Connectivity"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item530"}
                            data-plasmic-override={overrides.item530}
                            className={classNames("all", sty.item530)}
                          >
                            <div
                              data-plasmic-name={"left530"}
                              data-plasmic-override={overrides.left530}
                              className={classNames("all", sty.left530)}
                            >
                              <div
                                data-plasmic-name={"icon530"}
                                data-plasmic-override={overrides.icon530}
                                className={classNames("all", sty.icon530)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__l9X8)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title554"}
                              data-plasmic-override={overrides.title554}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title554
                              )}
                            >
                              {"Clinical Log Integrations"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item531"}
                            data-plasmic-override={overrides.item531}
                            className={classNames("all", sty.item531)}
                          >
                            <div
                              data-plasmic-name={"left531"}
                              data-plasmic-override={overrides.left531}
                              className={classNames("all", sty.left531)}
                            >
                              <div
                                data-plasmic-name={"icon531"}
                                data-plasmic-override={overrides.icon531}
                                className={classNames("all", sty.icon531)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xWwQl)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title555"}
                              data-plasmic-override={overrides.title555}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title555
                              )}
                            >
                              {"Scheduling Integrations"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item532"}
                            data-plasmic-override={overrides.item532}
                            className={classNames("all", sty.item532)}
                          >
                            <div
                              data-plasmic-name={"left532"}
                              data-plasmic-override={overrides.left532}
                              className={classNames("all", sty.left532)}
                            >
                              <div
                                data-plasmic-name={"icon532"}
                                data-plasmic-override={overrides.icon532}
                                className={classNames("all", sty.icon532)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__eyXu0)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title556"}
                              data-plasmic-override={overrides.title556}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title556
                              )}
                            >
                              {"ERAS Data Import"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item533"}
                              data-plasmic-override={overrides.item533}
                              className={classNames("all", sty.item533)}
                            >
                              <div
                                data-plasmic-name={"left533"}
                                data-plasmic-override={overrides.left533}
                                className={classNames("all", sty.left533)}
                              >
                                <div
                                  data-plasmic-name={"icon533"}
                                  data-plasmic-override={overrides.icon533}
                                  className={classNames("all", sty.icon533)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__brArh
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title557"}
                                data-plasmic-override={overrides.title557}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title557
                                )}
                              >
                                {"Certificate & Diploma Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item534"}
                              data-plasmic-override={overrides.item534}
                              className={classNames("all", sty.item534)}
                            >
                              <div
                                data-plasmic-name={"left534"}
                                data-plasmic-override={overrides.left534}
                                className={classNames("all", sty.left534)}
                              >
                                <div
                                  data-plasmic-name={"icon534"}
                                  data-plasmic-override={overrides.icon534}
                                  className={classNames("all", sty.icon534)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___0CC5Q
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title558"}
                                data-plasmic-override={overrides.title558}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title558
                                )}
                              >
                                {"Burnout Monitoring"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item535"}
                              data-plasmic-override={overrides.item535}
                              className={classNames("all", sty.item535)}
                            >
                              <div
                                data-plasmic-name={"left535"}
                                data-plasmic-override={overrides.left535}
                                className={classNames("all", sty.left535)}
                              >
                                <div
                                  data-plasmic-name={"icon535"}
                                  data-plasmic-override={overrides.icon535}
                                  className={classNames("all", sty.icon535)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___9OHx2
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title559"}
                                data-plasmic-override={overrides.title559}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title559
                                )}
                              >
                                {"Demographic Management"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item536"}
                              data-plasmic-override={overrides.item536}
                              className={classNames("all", sty.item536)}
                            >
                              <div
                                data-plasmic-name={"left536"}
                                data-plasmic-override={overrides.left536}
                                className={classNames("all", sty.left536)}
                              >
                                <div
                                  data-plasmic-name={"icon536"}
                                  data-plasmic-override={overrides.icon536}
                                  className={classNames("all", sty.icon536)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___776T
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title560"}
                                data-plasmic-override={overrides.title560}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title560
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item537"}
                              data-plasmic-override={overrides.item537}
                              className={classNames("all", sty.item537)}
                            >
                              <div
                                data-plasmic-name={"left537"}
                                data-plasmic-override={overrides.left537}
                                className={classNames("all", sty.left537)}
                              >
                                <div
                                  data-plasmic-name={"icon537"}
                                  data-plasmic-override={overrides.icon537}
                                  className={classNames("all", sty.icon537)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qxyFw
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title561"}
                                data-plasmic-override={overrides.title561}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title561
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item538"}
                              data-plasmic-override={overrides.item538}
                              className={classNames("all", sty.item538)}
                            >
                              <div
                                data-plasmic-name={"left538"}
                                data-plasmic-override={overrides.left538}
                                className={classNames("all", sty.left538)}
                              >
                                <div
                                  data-plasmic-name={"icon538"}
                                  data-plasmic-override={overrides.icon538}
                                  className={classNames("all", sty.icon538)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___6Dj5M
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title562"}
                                data-plasmic-override={overrides.title562}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title562
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item539"}
                              data-plasmic-override={overrides.item539}
                              className={classNames("all", sty.item539)}
                            >
                              <div
                                data-plasmic-name={"left539"}
                                data-plasmic-override={overrides.left539}
                                className={classNames("all", sty.left539)}
                              >
                                <div
                                  data-plasmic-name={"icon539"}
                                  data-plasmic-override={overrides.icon539}
                                  className={classNames("all", sty.icon539)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lcDd9
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title563"}
                                data-plasmic-override={overrides.title563}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title563
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item540"}
                              data-plasmic-override={overrides.item540}
                              className={classNames("all", sty.item540)}
                            >
                              <div
                                data-plasmic-name={"left540"}
                                data-plasmic-override={overrides.left540}
                                className={classNames("all", sty.left540)}
                              >
                                <div
                                  data-plasmic-name={"icon540"}
                                  data-plasmic-override={overrides.icon540}
                                  className={classNames("all", sty.icon540)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__mVcAr
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title564"}
                                data-plasmic-override={overrides.title564}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title564
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item541"}
                              data-plasmic-override={overrides.item541}
                              className={classNames("all", sty.item541)}
                            >
                              <div
                                data-plasmic-name={"left541"}
                                data-plasmic-override={overrides.left541}
                                className={classNames("all", sty.left541)}
                              >
                                <div
                                  data-plasmic-name={"icon541"}
                                  data-plasmic-override={overrides.icon541}
                                  className={classNames("all", sty.icon541)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rPpjm
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title565"}
                                data-plasmic-override={overrides.title565}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title565
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item542"}
                              data-plasmic-override={overrides.item542}
                              className={classNames("all", sty.item542)}
                            >
                              <div
                                data-plasmic-name={"left542"}
                                data-plasmic-override={overrides.left542}
                                className={classNames("all", sty.left542)}
                              >
                                <div
                                  data-plasmic-name={"icon542"}
                                  data-plasmic-override={overrides.icon542}
                                  className={classNames("all", sty.icon542)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__o5EgZ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title566"}
                                data-plasmic-override={overrides.title566}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title566
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item543"}
                              data-plasmic-override={overrides.item543}
                              className={classNames("all", sty.item543)}
                            >
                              <div
                                data-plasmic-name={"left543"}
                                data-plasmic-override={overrides.left543}
                                className={classNames("all", sty.left543)}
                              >
                                <div
                                  data-plasmic-name={"icon543"}
                                  data-plasmic-override={overrides.icon543}
                                  className={classNames("all", sty.icon543)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__tWoNv
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title567"}
                                data-plasmic-override={overrides.title567}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title567
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item544"}
                              data-plasmic-override={overrides.item544}
                              className={classNames("all", sty.item544)}
                            >
                              <div
                                data-plasmic-name={"left544"}
                                data-plasmic-override={overrides.left544}
                                className={classNames("all", sty.left544)}
                              >
                                <div
                                  data-plasmic-name={"icon544"}
                                  data-plasmic-override={overrides.icon544}
                                  className={classNames("all", sty.icon544)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___25XYl
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title568"}
                                data-plasmic-override={overrides.title568}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title568
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item545"}
                              data-plasmic-override={overrides.item545}
                              className={classNames("all", sty.item545)}
                            >
                              <div
                                data-plasmic-name={"left545"}
                                data-plasmic-override={overrides.left545}
                                className={classNames("all", sty.left545)}
                              >
                                <div
                                  data-plasmic-name={"icon545"}
                                  data-plasmic-override={overrides.icon545}
                                  className={classNames("all", sty.icon545)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__hnnw)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title569"}
                                data-plasmic-override={overrides.title569}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title569
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item546"}
                              data-plasmic-override={overrides.item546}
                              className={classNames("all", sty.item546)}
                            >
                              <div
                                data-plasmic-name={"left546"}
                                data-plasmic-override={overrides.left546}
                                className={classNames("all", sty.left546)}
                              >
                                <div
                                  data-plasmic-name={"icon546"}
                                  data-plasmic-override={overrides.icon546}
                                  className={classNames("all", sty.icon546)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ogCvx
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title570"}
                                data-plasmic-override={overrides.title570}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title570
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item547"}
                              data-plasmic-override={overrides.item547}
                              className={classNames("all", sty.item547)}
                            >
                              <div
                                data-plasmic-name={"left547"}
                                data-plasmic-override={overrides.left547}
                                className={classNames("all", sty.left547)}
                              >
                                <div
                                  data-plasmic-name={"icon547"}
                                  data-plasmic-override={overrides.icon547}
                                  className={classNames("all", sty.icon547)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___3RJiQ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title571"}
                                data-plasmic-override={overrides.title571}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title571
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item548"}
                              data-plasmic-override={overrides.item548}
                              className={classNames("all", sty.item548)}
                            >
                              <div
                                data-plasmic-name={"left548"}
                                data-plasmic-override={overrides.left548}
                                className={classNames("all", sty.left548)}
                              >
                                <div
                                  data-plasmic-name={"icon548"}
                                  data-plasmic-override={overrides.icon548}
                                  className={classNames("all", sty.icon548)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___1Cyd
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title572"}
                                data-plasmic-override={overrides.title572}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title572
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item549"}
                              data-plasmic-override={overrides.item549}
                              className={classNames("all", sty.item549)}
                            >
                              <div
                                data-plasmic-name={"left549"}
                                data-plasmic-override={overrides.left549}
                                className={classNames("all", sty.left549)}
                              >
                                <div
                                  data-plasmic-name={"icon549"}
                                  data-plasmic-override={overrides.icon549}
                                  className={classNames("all", sty.icon549)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__vraA4
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title573"}
                                data-plasmic-override={overrides.title573}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title573
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item550"}
                              data-plasmic-override={overrides.item550}
                              className={classNames("all", sty.item550)}
                            >
                              <div
                                data-plasmic-name={"left550"}
                                data-plasmic-override={overrides.left550}
                                className={classNames("all", sty.left550)}
                              >
                                <div
                                  data-plasmic-name={"icon550"}
                                  data-plasmic-override={overrides.icon550}
                                  className={classNames("all", sty.icon550)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qUjCo
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title574"}
                                data-plasmic-override={overrides.title574}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title574
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item551"}
                              data-plasmic-override={overrides.item551}
                              className={classNames("all", sty.item551)}
                            >
                              <div
                                data-plasmic-name={"left551"}
                                data-plasmic-override={overrides.left551}
                                className={classNames("all", sty.left551)}
                              >
                                <div
                                  data-plasmic-name={"icon551"}
                                  data-plasmic-override={overrides.icon551}
                                  className={classNames("all", sty.icon551)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___5QXjU
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title575"}
                                data-plasmic-override={overrides.title575}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title575
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item552"}
                              data-plasmic-override={overrides.item552}
                              className={classNames("all", sty.item552)}
                            >
                              <div
                                data-plasmic-name={"left552"}
                                data-plasmic-override={overrides.left552}
                                className={classNames("all", sty.left552)}
                              >
                                <div
                                  data-plasmic-name={"icon552"}
                                  data-plasmic-override={overrides.icon552}
                                  className={classNames("all", sty.icon552)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___5931X
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title576"}
                                data-plasmic-override={overrides.title576}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title576
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn23"}
                          data-plasmic-override={overrides.btn23}
                          className={classNames("__wab_instance", sty.btn23)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard24"}
                    data-plasmic-override={overrides.narrowCard24}
                    className={classNames("all", sty.narrowCard24)}
                  >
                    <div
                      data-plasmic-name={"header50"}
                      data-plasmic-override={overrides.header50}
                      className={classNames("all", sty.header50)}
                    >
                      <div
                        data-plasmic-name={"title577"}
                        data-plasmic-override={overrides.title577}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title577
                        )}
                      >
                        {"Graduate \nMedical Education"}
                      </div>
                      <Icon97Icon
                        className={classNames("all", sty.svg__wpt3I)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content24"}
                      data-plasmic-override={overrides.content24}
                      className={classNames("all", sty.content24)}
                    >
                      <div
                        data-plasmic-name={"desc24"}
                        data-plasmic-override={overrides.desc24}
                        className={classNames("all", "__wab_text", sty.desc24)}
                      >
                        {
                          "Purpose-built capabilities supporting residency and fellowship education."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder24"}
                        data-plasmic-override={overrides.placeholder24}
                        className={classNames("all", sty.placeholder24)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header51"}
                            data-plasmic-override={overrides.header51}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header51
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list31"}
                          data-plasmic-override={overrides.list31}
                          className={classNames("all", sty.list31)}
                        >
                          <div
                            data-plasmic-name={"item553"}
                            data-plasmic-override={overrides.item553}
                            className={classNames("all", sty.item553)}
                          >
                            <div
                              data-plasmic-name={"left553"}
                              data-plasmic-override={overrides.left553}
                              className={classNames("all", sty.left553)}
                            >
                              <div
                                data-plasmic-name={"icon553"}
                                data-plasmic-override={overrides.icon553}
                                className={classNames("all", sty.icon553)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__lt3D)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title578"}
                              data-plasmic-override={overrides.title578}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title578
                              )}
                            >
                              {"Annual Program Evaluation (APE)"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item554"}
                            data-plasmic-override={overrides.item554}
                            className={classNames("all", sty.item554)}
                          >
                            <div
                              data-plasmic-name={"left554"}
                              data-plasmic-override={overrides.left554}
                              className={classNames("all", sty.left554)}
                            >
                              <div
                                data-plasmic-name={"icon554"}
                                data-plasmic-override={overrides.icon554}
                                className={classNames("all", sty.icon554)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__nG6Vi)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title579"}
                              data-plasmic-override={overrides.title579}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title579
                              )}
                            >
                              {"Common Program Requirements"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item555"}
                            data-plasmic-override={overrides.item555}
                            className={classNames("all", sty.item555)}
                          >
                            <div
                              data-plasmic-name={"left555"}
                              data-plasmic-override={overrides.left555}
                              className={classNames("all", sty.left555)}
                            >
                              <div
                                data-plasmic-name={"icon555"}
                                data-plasmic-override={overrides.icon555}
                                className={classNames("all", sty.icon555)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__oCq50)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title580"}
                              data-plasmic-override={overrides.title580}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title580
                              )}
                            >
                              {"Institutional Requirements"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item556"}
                            data-plasmic-override={overrides.item556}
                            className={classNames("all", sty.item556)}
                          >
                            <div
                              data-plasmic-name={"left556"}
                              data-plasmic-override={overrides.left556}
                              className={classNames("all", sty.left556)}
                            >
                              <div
                                data-plasmic-name={"icon556"}
                                data-plasmic-override={overrides.icon556}
                                className={classNames("all", sty.icon556)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jYh87)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title581"}
                              data-plasmic-override={overrides.title581}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title581
                              )}
                            >
                              {"Action Plans & Notifications"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item557"}
                            data-plasmic-override={overrides.item557}
                            className={classNames("all", sty.item557)}
                          >
                            <div
                              data-plasmic-name={"left557"}
                              data-plasmic-override={overrides.left557}
                              className={classNames("all", sty.left557)}
                            >
                              <div
                                data-plasmic-name={"icon557"}
                                data-plasmic-override={overrides.icon557}
                                className={classNames("all", sty.icon557)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___6Wtm1)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title582"}
                              data-plasmic-override={overrides.title582}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title582
                              )}
                            >
                              {"Procedure Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item558"}
                            data-plasmic-override={overrides.item558}
                            className={classNames("all", sty.item558)}
                          >
                            <div
                              data-plasmic-name={"left558"}
                              data-plasmic-override={overrides.left558}
                              className={classNames("all", sty.left558)}
                            >
                              <div
                                data-plasmic-name={"icon558"}
                                data-plasmic-override={overrides.icon558}
                                className={classNames("all", sty.icon558)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___6C2S7)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title583"}
                              data-plasmic-override={overrides.title583}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title583
                              )}
                            >
                              {"Patient Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item559"}
                            data-plasmic-override={overrides.item559}
                            className={classNames("all", sty.item559)}
                          >
                            <div
                              data-plasmic-name={"left559"}
                              data-plasmic-override={overrides.left559}
                              className={classNames("all", sty.left559)}
                            >
                              <div
                                data-plasmic-name={"icon559"}
                                data-plasmic-override={overrides.icon559}
                                className={classNames("all", sty.icon559)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__br4Zh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title584"}
                              data-plasmic-override={overrides.title584}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title584
                              )}
                            >
                              {"Centralized Procedure Reporting"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item560"}
                              data-plasmic-override={overrides.item560}
                              className={classNames("all", sty.item560)}
                            >
                              <div
                                data-plasmic-name={"left560"}
                                data-plasmic-override={overrides.left560}
                                className={classNames("all", sty.left560)}
                              >
                                <div
                                  data-plasmic-name={"icon560"}
                                  data-plasmic-override={overrides.icon560}
                                  className={classNames("all", sty.icon560)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__avckE
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title585"}
                                data-plasmic-override={overrides.title585}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title585
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item561"}
                              data-plasmic-override={overrides.item561}
                              className={classNames("all", sty.item561)}
                            >
                              <div
                                data-plasmic-name={"left561"}
                                data-plasmic-override={overrides.left561}
                                className={classNames("all", sty.left561)}
                              >
                                <div
                                  data-plasmic-name={"icon561"}
                                  data-plasmic-override={overrides.icon561}
                                  className={classNames("all", sty.icon561)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__wxOi8
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title586"}
                                data-plasmic-override={overrides.title586}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title586
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item562"}
                              data-plasmic-override={overrides.item562}
                              className={classNames("all", sty.item562)}
                            >
                              <div
                                data-plasmic-name={"left562"}
                                data-plasmic-override={overrides.left562}
                                className={classNames("all", sty.left562)}
                              >
                                <div
                                  data-plasmic-name={"icon562"}
                                  data-plasmic-override={overrides.icon562}
                                  className={classNames("all", sty.icon562)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ih2Uf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title587"}
                                data-plasmic-override={overrides.title587}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title587
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item563"}
                              data-plasmic-override={overrides.item563}
                              className={classNames("all", sty.item563)}
                            >
                              <div
                                data-plasmic-name={"left563"}
                                data-plasmic-override={overrides.left563}
                                className={classNames("all", sty.left563)}
                              >
                                <div
                                  data-plasmic-name={"icon563"}
                                  data-plasmic-override={overrides.icon563}
                                  className={classNames("all", sty.icon563)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___7GgGu
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title588"}
                                data-plasmic-override={overrides.title588}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title588
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item564"}
                              data-plasmic-override={overrides.item564}
                              className={classNames("all", sty.item564)}
                            >
                              <div
                                data-plasmic-name={"left564"}
                                data-plasmic-override={overrides.left564}
                                className={classNames("all", sty.left564)}
                              >
                                <div
                                  data-plasmic-name={"icon564"}
                                  data-plasmic-override={overrides.icon564}
                                  className={classNames("all", sty.icon564)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___88NUv
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title589"}
                                data-plasmic-override={overrides.title589}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title589
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item565"}
                              data-plasmic-override={overrides.item565}
                              className={classNames("all", sty.item565)}
                            >
                              <div
                                data-plasmic-name={"left565"}
                                data-plasmic-override={overrides.left565}
                                className={classNames("all", sty.left565)}
                              >
                                <div
                                  data-plasmic-name={"icon565"}
                                  data-plasmic-override={overrides.icon565}
                                  className={classNames("all", sty.icon565)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ivYnB
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title590"}
                                data-plasmic-override={overrides.title590}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title590
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item566"}
                              data-plasmic-override={overrides.item566}
                              className={classNames("all", sty.item566)}
                            >
                              <div
                                data-plasmic-name={"left566"}
                                data-plasmic-override={overrides.left566}
                                className={classNames("all", sty.left566)}
                              >
                                <div
                                  data-plasmic-name={"icon566"}
                                  data-plasmic-override={overrides.icon566}
                                  className={classNames("all", sty.icon566)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__nRwri
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title591"}
                                data-plasmic-override={overrides.title591}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title591
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item567"}
                              data-plasmic-override={overrides.item567}
                              className={classNames("all", sty.item567)}
                            >
                              <div
                                data-plasmic-name={"left567"}
                                data-plasmic-override={overrides.left567}
                                className={classNames("all", sty.left567)}
                              >
                                <div
                                  data-plasmic-name={"icon567"}
                                  data-plasmic-override={overrides.icon567}
                                  className={classNames("all", sty.icon567)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ann0G
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title592"}
                                data-plasmic-override={overrides.title592}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title592
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item568"}
                              data-plasmic-override={overrides.item568}
                              className={classNames("all", sty.item568)}
                            >
                              <div
                                data-plasmic-name={"left568"}
                                data-plasmic-override={overrides.left568}
                                className={classNames("all", sty.left568)}
                              >
                                <div
                                  data-plasmic-name={"icon568"}
                                  data-plasmic-override={overrides.icon568}
                                  className={classNames("all", sty.icon568)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__gb0Z1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title593"}
                                data-plasmic-override={overrides.title593}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title593
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item569"}
                              data-plasmic-override={overrides.item569}
                              className={classNames("all", sty.item569)}
                            >
                              <div
                                data-plasmic-name={"left569"}
                                data-plasmic-override={overrides.left569}
                                className={classNames("all", sty.left569)}
                              >
                                <div
                                  data-plasmic-name={"icon569"}
                                  data-plasmic-override={overrides.icon569}
                                  className={classNames("all", sty.icon569)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__esS7X
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title594"}
                                data-plasmic-override={overrides.title594}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title594
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item570"}
                              data-plasmic-override={overrides.item570}
                              className={classNames("all", sty.item570)}
                            >
                              <div
                                data-plasmic-name={"left570"}
                                data-plasmic-override={overrides.left570}
                                className={classNames("all", sty.left570)}
                              >
                                <div
                                  data-plasmic-name={"icon570"}
                                  data-plasmic-override={overrides.icon570}
                                  className={classNames("all", sty.icon570)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__kbmJw
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title595"}
                                data-plasmic-override={overrides.title595}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title595
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item571"}
                              data-plasmic-override={overrides.item571}
                              className={classNames("all", sty.item571)}
                            >
                              <div
                                data-plasmic-name={"left571"}
                                data-plasmic-override={overrides.left571}
                                className={classNames("all", sty.left571)}
                              >
                                <div
                                  data-plasmic-name={"icon571"}
                                  data-plasmic-override={overrides.icon571}
                                  className={classNames("all", sty.icon571)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__ySmW)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title596"}
                                data-plasmic-override={overrides.title596}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title596
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item572"}
                              data-plasmic-override={overrides.item572}
                              className={classNames("all", sty.item572)}
                            >
                              <div
                                data-plasmic-name={"left572"}
                                data-plasmic-override={overrides.left572}
                                className={classNames("all", sty.left572)}
                              >
                                <div
                                  data-plasmic-name={"icon572"}
                                  data-plasmic-override={overrides.icon572}
                                  className={classNames("all", sty.icon572)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__oyRi1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title597"}
                                data-plasmic-override={overrides.title597}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title597
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item573"}
                              data-plasmic-override={overrides.item573}
                              className={classNames("all", sty.item573)}
                            >
                              <div
                                data-plasmic-name={"left573"}
                                data-plasmic-override={overrides.left573}
                                className={classNames("all", sty.left573)}
                              >
                                <div
                                  data-plasmic-name={"icon573"}
                                  data-plasmic-override={overrides.icon573}
                                  className={classNames("all", sty.icon573)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__kadPy
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title598"}
                                data-plasmic-override={overrides.title598}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title598
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item574"}
                              data-plasmic-override={overrides.item574}
                              className={classNames("all", sty.item574)}
                            >
                              <div
                                data-plasmic-name={"left574"}
                                data-plasmic-override={overrides.left574}
                                className={classNames("all", sty.left574)}
                              >
                                <div
                                  data-plasmic-name={"icon574"}
                                  data-plasmic-override={overrides.icon574}
                                  className={classNames("all", sty.icon574)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___0UOz1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title599"}
                                data-plasmic-override={overrides.title599}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title599
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item575"}
                              data-plasmic-override={overrides.item575}
                              className={classNames("all", sty.item575)}
                            >
                              <div
                                data-plasmic-name={"left575"}
                                data-plasmic-override={overrides.left575}
                                className={classNames("all", sty.left575)}
                              >
                                <div
                                  data-plasmic-name={"icon575"}
                                  data-plasmic-override={overrides.icon575}
                                  className={classNames("all", sty.icon575)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__dhrp1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title600"}
                                data-plasmic-override={overrides.title600}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title600
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item576"}
                              data-plasmic-override={overrides.item576}
                              className={classNames("all", sty.item576)}
                            >
                              <div
                                data-plasmic-name={"left576"}
                                data-plasmic-override={overrides.left576}
                                className={classNames("all", sty.left576)}
                              >
                                <div
                                  data-plasmic-name={"icon576"}
                                  data-plasmic-override={overrides.icon576}
                                  className={classNames("all", sty.icon576)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rbQcr
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title601"}
                                data-plasmic-override={overrides.title601}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title601
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn24"}
                          data-plasmic-override={overrides.btn24}
                          className={classNames("__wab_instance", sty.btn24)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
              <div
                data-plasmic-name={"row10"}
                data-plasmic-override={overrides.row10}
                className={classNames("all", sty.row10)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__nnz9M
                  )}
                  desciption={
                    "Enhance training with accurate logs of procedural skills and patient encounters. Turn every clinical activity into a learning opportunity, ensuring a comprehensive educational experience."
                  }
                  title={"Procedure & Patient Logging"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__gogyk)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/f84f25cdb0e594e6d5e5dd86882a0815.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__ronxX
                  )}
                  desciption={
                    "Effortlessly manage GME schedules with built-in MySchedule module. Sync with AMION, QGenda, Momentum. Simplify clinical hour tracking with MyQuickPass. Streamline workflow, stay informed with instant updates."
                  }
                  title={"Scheduling & Compliance"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__dsbbk)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/8debbf898d018ca00021c1aa8e2fa91b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
              </div>
              <div
                data-plasmic-name={"row11"}
                data-plasmic-override={overrides.row11}
                className={classNames("all", sty.row11)}
              >
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__qJdkg
                  )}
                  desciption={
                    "Tailor tasks, diverse materials for student engagement. Assess with interactive quizzes, focusing on meaningful learning, knowledge retention, and efficient exam creation. Get valuable performance feedback."
                  }
                  title={"MyQuiz & Learning Assignments"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__aYrnM)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a3ca4aac0456c9eddccb298b95e5d36b.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <FeaturesCard
                  className={classNames(
                    "__wab_instance",
                    sty.featuresCard__tdYiV
                  )}
                  desciption={
                    "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                  }
                  title={"Return Demonstrations"}
                >
                  <PlasmicImg__
                    alt={""}
                    className={classNames(sty.img__s3JOu)}
                    displayHeight={"239px"}
                    displayMaxHeight={"none"}
                    displayMaxWidth={"100%"}
                    displayMinHeight={"0"}
                    displayMinWidth={"0"}
                    displayWidth={"auto"}
                    loader={"plasmic"}
                    loading={"lazy"}
                    src={{
                      src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                      fullWidth: 374,
                      fullHeight: 239,
                      aspectRatio: 1.564854
                    }}
                  />
                </FeaturesCard>
                <div
                  data-plasmic-name={"figmaPaste8"}
                  data-plasmic-override={overrides.figmaPaste8}
                  className={classNames("all", sty.figmaPaste8)}
                >
                  <div
                    data-plasmic-name={"narrowCard25"}
                    data-plasmic-override={overrides.narrowCard25}
                    className={classNames("all", sty.narrowCard25)}
                  >
                    <div
                      data-plasmic-name={"header52"}
                      data-plasmic-override={overrides.header52}
                      className={classNames("all", sty.header52)}
                    >
                      <div
                        data-plasmic-name={"title602"}
                        data-plasmic-override={overrides.title602}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title602
                        )}
                      >
                        {"Physician \nAssistant Education"}
                      </div>
                      <PlasmicImg__
                        alt={""}
                        className={classNames(sty.img__brc5J)}
                        displayHeight={"32px"}
                        displayMaxHeight={"none"}
                        displayMaxWidth={"100%"}
                        displayMinHeight={"0"}
                        displayMinWidth={"0"}
                        displayWidth={"32px"}
                        loader={"plasmic"}
                        loading={"lazy"}
                        src={{
                          src: "https://site-assets.plasmic.app/d6f7f0eca9cbc289d86cbd47375ec4b6.svg",
                          fullWidth: 32,
                          fullHeight: 32
                        }}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content25"}
                      data-plasmic-override={overrides.content25}
                      className={classNames("all", sty.content25)}
                    >
                      <div
                        data-plasmic-name={"desc25"}
                        data-plasmic-override={overrides.desc25}
                        className={classNames("all", "__wab_text", sty.desc25)}
                      >
                        {
                          "Designed to support competency-based Physician Assistant education."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder25"}
                        data-plasmic-override={overrides.placeholder25}
                        className={classNames("all", sty.placeholder25)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header53"}
                            data-plasmic-override={overrides.header53}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header53
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list32"}
                          data-plasmic-override={overrides.list32}
                          className={classNames("all", sty.list32)}
                        >
                          <div
                            data-plasmic-name={"item577"}
                            data-plasmic-override={overrides.item577}
                            className={classNames("all", sty.item577)}
                          >
                            <div
                              data-plasmic-name={"left577"}
                              data-plasmic-override={overrides.left577}
                              className={classNames("all", sty.left577)}
                            >
                              <div
                                data-plasmic-name={"icon577"}
                                data-plasmic-override={overrides.icon577}
                                className={classNames("all", sty.icon577)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gdrWu)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title603"}
                              data-plasmic-override={overrides.title603}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title603
                              )}
                            >
                              {"Curriculum Management"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item578"}
                            data-plasmic-override={overrides.item578}
                            className={classNames("all", sty.item578)}
                          >
                            <div
                              data-plasmic-name={"left578"}
                              data-plasmic-override={overrides.left578}
                              className={classNames("all", sty.left578)}
                            >
                              <div
                                data-plasmic-name={"icon578"}
                                data-plasmic-override={overrides.icon578}
                                className={classNames("all", sty.icon578)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__zZalX)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title604"}
                              data-plasmic-override={overrides.title604}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title604
                              )}
                            >
                              {"Procedure Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item579"}
                            data-plasmic-override={overrides.item579}
                            className={classNames("all", sty.item579)}
                          >
                            <div
                              data-plasmic-name={"left579"}
                              data-plasmic-override={overrides.left579}
                              className={classNames("all", sty.left579)}
                            >
                              <div
                                data-plasmic-name={"icon579"}
                                data-plasmic-override={overrides.icon579}
                                className={classNames("all", sty.icon579)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__z6Odh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title605"}
                              data-plasmic-override={overrides.title605}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title605
                              )}
                            >
                              {"Patient Logging"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item580"}
                            data-plasmic-override={overrides.item580}
                            className={classNames("all", sty.item580)}
                          >
                            <div
                              data-plasmic-name={"left580"}
                              data-plasmic-override={overrides.left580}
                              className={classNames("all", sty.left580)}
                            >
                              <div
                                data-plasmic-name={"icon580"}
                                data-plasmic-override={overrides.icon580}
                                className={classNames("all", sty.icon580)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___3Dtou)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title606"}
                              data-plasmic-override={overrides.title606}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title606
                              )}
                            >
                              {"Learning Assignments"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item581"}
                            data-plasmic-override={overrides.item581}
                            className={classNames("all", sty.item581)}
                          >
                            <div
                              data-plasmic-name={"left581"}
                              data-plasmic-override={overrides.left581}
                              className={classNames("all", sty.left581)}
                            >
                              <div
                                data-plasmic-name={"icon581"}
                                data-plasmic-override={overrides.icon581}
                                className={classNames("all", sty.icon581)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___4Th8)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title607"}
                              data-plasmic-override={overrides.title607}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title607
                              )}
                            >
                              {"MyQuiz\u2122"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item582"}
                            data-plasmic-override={overrides.item582}
                            className={classNames("all", sty.item582)}
                          >
                            <div
                              data-plasmic-name={"left582"}
                              data-plasmic-override={overrides.left582}
                              className={classNames("all", sty.left582)}
                            >
                              <div
                                data-plasmic-name={"icon582"}
                                data-plasmic-override={overrides.icon582}
                                className={classNames("all", sty.icon582)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dcx0D)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title608"}
                              data-plasmic-override={overrides.title608}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title608
                              )}
                            >
                              {"Performance Dashboard"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item583"}
                              data-plasmic-override={overrides.item583}
                              className={classNames("all", sty.item583)}
                            >
                              <div
                                data-plasmic-name={"left583"}
                                data-plasmic-override={overrides.left583}
                                className={classNames("all", sty.left583)}
                              >
                                <div
                                  data-plasmic-name={"icon583"}
                                  data-plasmic-override={overrides.icon583}
                                  className={classNames("all", sty.icon583)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__ksMaZ
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title609"}
                                data-plasmic-override={overrides.title609}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title609
                                )}
                              >
                                {"Centralized Procedure Reporting"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item584"}
                              data-plasmic-override={overrides.item584}
                              className={classNames("all", sty.item584)}
                            >
                              <div
                                data-plasmic-name={"left584"}
                                data-plasmic-override={overrides.left584}
                                className={classNames("all", sty.left584)}
                              >
                                <div
                                  data-plasmic-name={"icon584"}
                                  data-plasmic-override={overrides.icon584}
                                  className={classNames("all", sty.icon584)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__vrvsz
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title610"}
                                data-plasmic-override={overrides.title610}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title610
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item585"}
                              data-plasmic-override={overrides.item585}
                              className={classNames("all", sty.item585)}
                            >
                              <div
                                data-plasmic-name={"left585"}
                                data-plasmic-override={overrides.left585}
                                className={classNames("all", sty.left585)}
                              >
                                <div
                                  data-plasmic-name={"icon585"}
                                  data-plasmic-override={overrides.icon585}
                                  className={classNames("all", sty.icon585)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qyj7I
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title611"}
                                data-plasmic-override={overrides.title611}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title611
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item586"}
                              data-plasmic-override={overrides.item586}
                              className={classNames("all", sty.item586)}
                            >
                              <div
                                data-plasmic-name={"left586"}
                                data-plasmic-override={overrides.left586}
                                className={classNames("all", sty.left586)}
                              >
                                <div
                                  data-plasmic-name={"icon586"}
                                  data-plasmic-override={overrides.icon586}
                                  className={classNames("all", sty.icon586)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___9Elfk
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title612"}
                                data-plasmic-override={overrides.title612}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title612
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item587"}
                              data-plasmic-override={overrides.item587}
                              className={classNames("all", sty.item587)}
                            >
                              <div
                                data-plasmic-name={"left587"}
                                data-plasmic-override={overrides.left587}
                                className={classNames("all", sty.left587)}
                              >
                                <div
                                  data-plasmic-name={"icon587"}
                                  data-plasmic-override={overrides.icon587}
                                  className={classNames("all", sty.icon587)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___7G0Vf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title613"}
                                data-plasmic-override={overrides.title613}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title613
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item588"}
                              data-plasmic-override={overrides.item588}
                              className={classNames("all", sty.item588)}
                            >
                              <div
                                data-plasmic-name={"left588"}
                                data-plasmic-override={overrides.left588}
                                className={classNames("all", sty.left588)}
                              >
                                <div
                                  data-plasmic-name={"icon588"}
                                  data-plasmic-override={overrides.icon588}
                                  className={classNames("all", sty.icon588)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__z8CGk
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title614"}
                                data-plasmic-override={overrides.title614}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title614
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item589"}
                              data-plasmic-override={overrides.item589}
                              className={classNames("all", sty.item589)}
                            >
                              <div
                                data-plasmic-name={"left589"}
                                data-plasmic-override={overrides.left589}
                                className={classNames("all", sty.left589)}
                              >
                                <div
                                  data-plasmic-name={"icon589"}
                                  data-plasmic-override={overrides.icon589}
                                  className={classNames("all", sty.icon589)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__eKvA)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title615"}
                                data-plasmic-override={overrides.title615}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title615
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item590"}
                              data-plasmic-override={overrides.item590}
                              className={classNames("all", sty.item590)}
                            >
                              <div
                                data-plasmic-name={"left590"}
                                data-plasmic-override={overrides.left590}
                                className={classNames("all", sty.left590)}
                              >
                                <div
                                  data-plasmic-name={"icon590"}
                                  data-plasmic-override={overrides.icon590}
                                  className={classNames("all", sty.icon590)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__iJ1Wk
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title616"}
                                data-plasmic-override={overrides.title616}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title616
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item591"}
                              data-plasmic-override={overrides.item591}
                              className={classNames("all", sty.item591)}
                            >
                              <div
                                data-plasmic-name={"left591"}
                                data-plasmic-override={overrides.left591}
                                className={classNames("all", sty.left591)}
                              >
                                <div
                                  data-plasmic-name={"icon591"}
                                  data-plasmic-override={overrides.icon591}
                                  className={classNames("all", sty.icon591)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qiQpt
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title617"}
                                data-plasmic-override={overrides.title617}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title617
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item592"}
                              data-plasmic-override={overrides.item592}
                              className={classNames("all", sty.item592)}
                            >
                              <div
                                data-plasmic-name={"left592"}
                                data-plasmic-override={overrides.left592}
                                className={classNames("all", sty.left592)}
                              >
                                <div
                                  data-plasmic-name={"icon592"}
                                  data-plasmic-override={overrides.icon592}
                                  className={classNames("all", sty.icon592)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__mofGw
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title618"}
                                data-plasmic-override={overrides.title618}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title618
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item593"}
                              data-plasmic-override={overrides.item593}
                              className={classNames("all", sty.item593)}
                            >
                              <div
                                data-plasmic-name={"left593"}
                                data-plasmic-override={overrides.left593}
                                className={classNames("all", sty.left593)}
                              >
                                <div
                                  data-plasmic-name={"icon593"}
                                  data-plasmic-override={overrides.icon593}
                                  className={classNames("all", sty.icon593)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__xAs0U
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title619"}
                                data-plasmic-override={overrides.title619}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title619
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item594"}
                              data-plasmic-override={overrides.item594}
                              className={classNames("all", sty.item594)}
                            >
                              <div
                                data-plasmic-name={"left594"}
                                data-plasmic-override={overrides.left594}
                                className={classNames("all", sty.left594)}
                              >
                                <div
                                  data-plasmic-name={"icon594"}
                                  data-plasmic-override={overrides.icon594}
                                  className={classNames("all", sty.icon594)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__o2WSf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title620"}
                                data-plasmic-override={overrides.title620}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title620
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item595"}
                              data-plasmic-override={overrides.item595}
                              className={classNames("all", sty.item595)}
                            >
                              <div
                                data-plasmic-name={"left595"}
                                data-plasmic-override={overrides.left595}
                                className={classNames("all", sty.left595)}
                              >
                                <div
                                  data-plasmic-name={"icon595"}
                                  data-plasmic-override={overrides.icon595}
                                  className={classNames("all", sty.icon595)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___26Ljm
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title621"}
                                data-plasmic-override={overrides.title621}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title621
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item596"}
                              data-plasmic-override={overrides.item596}
                              className={classNames("all", sty.item596)}
                            >
                              <div
                                data-plasmic-name={"left596"}
                                data-plasmic-override={overrides.left596}
                                className={classNames("all", sty.left596)}
                              >
                                <div
                                  data-plasmic-name={"icon596"}
                                  data-plasmic-override={overrides.icon596}
                                  className={classNames("all", sty.icon596)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__iQkeO
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title622"}
                                data-plasmic-override={overrides.title622}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title622
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item597"}
                              data-plasmic-override={overrides.item597}
                              className={classNames("all", sty.item597)}
                            >
                              <div
                                data-plasmic-name={"left597"}
                                data-plasmic-override={overrides.left597}
                                className={classNames("all", sty.left597)}
                              >
                                <div
                                  data-plasmic-name={"icon597"}
                                  data-plasmic-override={overrides.icon597}
                                  className={classNames("all", sty.icon597)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__fc4JI
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title623"}
                                data-plasmic-override={overrides.title623}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title623
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item598"}
                              data-plasmic-override={overrides.item598}
                              className={classNames("all", sty.item598)}
                            >
                              <div
                                data-plasmic-name={"left598"}
                                data-plasmic-override={overrides.left598}
                                className={classNames("all", sty.left598)}
                              >
                                <div
                                  data-plasmic-name={"icon598"}
                                  data-plasmic-override={overrides.icon598}
                                  className={classNames("all", sty.icon598)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__n6HKt
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title624"}
                                data-plasmic-override={overrides.title624}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title624
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item599"}
                              data-plasmic-override={overrides.item599}
                              className={classNames("all", sty.item599)}
                            >
                              <div
                                data-plasmic-name={"left599"}
                                data-plasmic-override={overrides.left599}
                                className={classNames("all", sty.left599)}
                              >
                                <div
                                  data-plasmic-name={"icon599"}
                                  data-plasmic-override={overrides.icon599}
                                  className={classNames("all", sty.icon599)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lmF3N
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title625"}
                                data-plasmic-override={overrides.title625}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title625
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item600"}
                              data-plasmic-override={overrides.item600}
                              className={classNames("all", sty.item600)}
                            >
                              <div
                                data-plasmic-name={"left600"}
                                data-plasmic-override={overrides.left600}
                                className={classNames("all", sty.left600)}
                              >
                                <div
                                  data-plasmic-name={"icon600"}
                                  data-plasmic-override={overrides.icon600}
                                  className={classNames("all", sty.icon600)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__vZn7N
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title626"}
                                data-plasmic-override={overrides.title626}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title626
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn25"}
                          data-plasmic-override={overrides.btn25}
                          className={classNames("__wab_instance", sty.btn25)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"narrowCard26"}
                    data-plasmic-override={overrides.narrowCard26}
                    className={classNames("all", sty.narrowCard26)}
                  >
                    <div
                      data-plasmic-name={"header54"}
                      data-plasmic-override={overrides.header54}
                      className={classNames("all", sty.header54)}
                    >
                      <div
                        data-plasmic-name={"title627"}
                        data-plasmic-override={overrides.title627}
                        className={classNames(
                          "all",
                          "__wab_text",
                          sty.title627
                        )}
                      >
                        {"Nursing Education"}
                      </div>
                      <Icon100Icon
                        className={classNames("all", sty.svg__dmTuk)}
                        role={"img"}
                      />
                    </div>
                    <div
                      data-plasmic-name={"content26"}
                      data-plasmic-override={overrides.content26}
                      className={classNames("all", sty.content26)}
                    >
                      <div
                        data-plasmic-name={"desc26"}
                        data-plasmic-override={overrides.desc26}
                        className={classNames("all", "__wab_text", sty.desc26)}
                      >
                        {
                          "Specialized tools supporting nursing education and clinical competency."
                        }
                      </div>
                      <div
                        data-plasmic-name={"placeholder26"}
                        data-plasmic-override={overrides.placeholder26}
                        className={classNames("all", sty.placeholder26)}
                      >
                        {false ? (
                          <div
                            data-plasmic-name={"header55"}
                            data-plasmic-override={overrides.header55}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.header55
                            )}
                          >
                            {"Title"}
                          </div>
                        ) : null}
                        <div
                          data-plasmic-name={"list33"}
                          data-plasmic-override={overrides.list33}
                          className={classNames("all", sty.list33)}
                        >
                          <div
                            data-plasmic-name={"item601"}
                            data-plasmic-override={overrides.item601}
                            className={classNames("all", sty.item601)}
                          >
                            <div
                              data-plasmic-name={"left601"}
                              data-plasmic-override={overrides.left601}
                              className={classNames("all", sty.left601)}
                            >
                              <div
                                data-plasmic-name={"icon601"}
                                data-plasmic-override={overrides.icon601}
                                className={classNames("all", sty.icon601)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__rdHUx)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title628"}
                              data-plasmic-override={overrides.title628}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title628
                              )}
                            >
                              {"Clinical Activity Logger"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item602"}
                            data-plasmic-override={overrides.item602}
                            className={classNames("all", sty.item602)}
                          >
                            <div
                              data-plasmic-name={"left602"}
                              data-plasmic-override={overrides.left602}
                              className={classNames("all", sty.left602)}
                            >
                              <div
                                data-plasmic-name={"icon602"}
                                data-plasmic-override={overrides.icon602}
                                className={classNames("all", sty.icon602)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__cPJdB)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title629"}
                              data-plasmic-override={overrides.title629}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title629
                              )}
                            >
                              {"Return Demonstration Management"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item603"}
                            data-plasmic-override={overrides.item603}
                            className={classNames("all", sty.item603)}
                          >
                            <div
                              data-plasmic-name={"left603"}
                              data-plasmic-override={overrides.left603}
                              className={classNames("all", sty.left603)}
                            >
                              <div
                                data-plasmic-name={"icon603"}
                                data-plasmic-override={overrides.icon603}
                                className={classNames("all", sty.icon603)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__mq3H0)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title630"}
                              data-plasmic-override={overrides.title630}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title630
                              )}
                            >
                              {"Return Demonstration Testing"}
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"item604"}
                            data-plasmic-override={overrides.item604}
                            className={classNames("all", sty.item604)}
                          >
                            <div
                              data-plasmic-name={"left604"}
                              data-plasmic-override={overrides.left604}
                              className={classNames("all", sty.left604)}
                            >
                              <div
                                data-plasmic-name={"icon604"}
                                data-plasmic-override={overrides.icon604}
                                className={classNames("all", sty.icon604)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__j9Zky)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title631"}
                              data-plasmic-override={overrides.title631}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title631
                              )}
                            >
                              {"Clinical Learning Contracts"}
                            </div>
                          </div>
                          {false ? (
                            <div
                              data-plasmic-name={"item605"}
                              data-plasmic-override={overrides.item605}
                              className={classNames("all", sty.item605)}
                            >
                              <div
                                data-plasmic-name={"left605"}
                                data-plasmic-override={overrides.left605}
                                className={classNames("all", sty.left605)}
                              >
                                <div
                                  data-plasmic-name={"icon605"}
                                  data-plasmic-override={overrides.icon605}
                                  className={classNames("all", sty.icon605)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rwk0Z
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title632"}
                                data-plasmic-override={overrides.title632}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title632
                                )}
                              >
                                {"MyQuiz\u2122"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item606"}
                              data-plasmic-override={overrides.item606}
                              className={classNames("all", sty.item606)}
                            >
                              <div
                                data-plasmic-name={"left606"}
                                data-plasmic-override={overrides.left606}
                                className={classNames("all", sty.left606)}
                              >
                                <div
                                  data-plasmic-name={"icon606"}
                                  data-plasmic-override={overrides.icon606}
                                  className={classNames("all", sty.icon606)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__aSRb)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title633"}
                                data-plasmic-override={overrides.title633}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title633
                                )}
                              >
                                {"Performance Dashboard"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item607"}
                              data-plasmic-override={overrides.item607}
                              className={classNames("all", sty.item607)}
                            >
                              <div
                                data-plasmic-name={"left607"}
                                data-plasmic-override={overrides.left607}
                                className={classNames("all", sty.left607)}
                              >
                                <div
                                  data-plasmic-name={"icon607"}
                                  data-plasmic-override={overrides.icon607}
                                  className={classNames("all", sty.icon607)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___2Dlik
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title634"}
                                data-plasmic-override={overrides.title634}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title634
                                )}
                              >
                                {"Centralized Procedure Reporting"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item608"}
                              data-plasmic-override={overrides.item608}
                              className={classNames("all", sty.item608)}
                            >
                              <div
                                data-plasmic-name={"left608"}
                                data-plasmic-override={overrides.left608}
                                className={classNames("all", sty.left608)}
                              >
                                <div
                                  data-plasmic-name={"icon608"}
                                  data-plasmic-override={overrides.icon608}
                                  className={classNames("all", sty.icon608)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__qyT0C
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title635"}
                                data-plasmic-override={overrides.title635}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title635
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item609"}
                              data-plasmic-override={overrides.item609}
                              className={classNames("all", sty.item609)}
                            >
                              <div
                                data-plasmic-name={"left609"}
                                data-plasmic-override={overrides.left609}
                                className={classNames("all", sty.left609)}
                              >
                                <div
                                  data-plasmic-name={"icon609"}
                                  data-plasmic-override={overrides.icon609}
                                  className={classNames("all", sty.icon609)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__oUy4U
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title636"}
                                data-plasmic-override={overrides.title636}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title636
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item610"}
                              data-plasmic-override={overrides.item610}
                              className={classNames("all", sty.item610)}
                            >
                              <div
                                data-plasmic-name={"left610"}
                                data-plasmic-override={overrides.left610}
                                className={classNames("all", sty.left610)}
                              >
                                <div
                                  data-plasmic-name={"icon610"}
                                  data-plasmic-override={overrides.icon610}
                                  className={classNames("all", sty.icon610)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__hgPrK
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title637"}
                                data-plasmic-override={overrides.title637}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title637
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item611"}
                              data-plasmic-override={overrides.item611}
                              className={classNames("all", sty.item611)}
                            >
                              <div
                                data-plasmic-name={"left611"}
                                data-plasmic-override={overrides.left611}
                                className={classNames("all", sty.left611)}
                              >
                                <div
                                  data-plasmic-name={"icon611"}
                                  data-plasmic-override={overrides.icon611}
                                  className={classNames("all", sty.icon611)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__u79Nf
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title638"}
                                data-plasmic-override={overrides.title638}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title638
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item612"}
                              data-plasmic-override={overrides.item612}
                              className={classNames("all", sty.item612)}
                            >
                              <div
                                data-plasmic-name={"left612"}
                                data-plasmic-override={overrides.left612}
                                className={classNames("all", sty.left612)}
                              >
                                <div
                                  data-plasmic-name={"icon612"}
                                  data-plasmic-override={overrides.icon612}
                                  className={classNames("all", sty.icon612)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___8DSuw
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title639"}
                                data-plasmic-override={overrides.title639}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title639
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item613"}
                              data-plasmic-override={overrides.item613}
                              className={classNames("all", sty.item613)}
                            >
                              <div
                                data-plasmic-name={"left613"}
                                data-plasmic-override={overrides.left613}
                                className={classNames("all", sty.left613)}
                              >
                                <div
                                  data-plasmic-name={"icon613"}
                                  data-plasmic-override={overrides.icon613}
                                  className={classNames("all", sty.icon613)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___4JtOv
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title640"}
                                data-plasmic-override={overrides.title640}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title640
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item614"}
                              data-plasmic-override={overrides.item614}
                              className={classNames("all", sty.item614)}
                            >
                              <div
                                data-plasmic-name={"left614"}
                                data-plasmic-override={overrides.left614}
                                className={classNames("all", sty.left614)}
                              >
                                <div
                                  data-plasmic-name={"icon614"}
                                  data-plasmic-override={overrides.icon614}
                                  className={classNames("all", sty.icon614)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__i7FDo
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title641"}
                                data-plasmic-override={overrides.title641}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title641
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item615"}
                              data-plasmic-override={overrides.item615}
                              className={classNames("all", sty.item615)}
                            >
                              <div
                                data-plasmic-name={"left615"}
                                data-plasmic-override={overrides.left615}
                                className={classNames("all", sty.left615)}
                              >
                                <div
                                  data-plasmic-name={"icon615"}
                                  data-plasmic-override={overrides.icon615}
                                  className={classNames("all", sty.icon615)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__gejct
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title642"}
                                data-plasmic-override={overrides.title642}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title642
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item616"}
                              data-plasmic-override={overrides.item616}
                              className={classNames("all", sty.item616)}
                            >
                              <div
                                data-plasmic-name={"left616"}
                                data-plasmic-override={overrides.left616}
                                className={classNames("all", sty.left616)}
                              >
                                <div
                                  data-plasmic-name={"icon616"}
                                  data-plasmic-override={overrides.icon616}
                                  className={classNames("all", sty.icon616)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___0Fvdi
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title643"}
                                data-plasmic-override={overrides.title643}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title643
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item617"}
                              data-plasmic-override={overrides.item617}
                              className={classNames("all", sty.item617)}
                            >
                              <div
                                data-plasmic-name={"left617"}
                                data-plasmic-override={overrides.left617}
                                className={classNames("all", sty.left617)}
                              >
                                <div
                                  data-plasmic-name={"icon617"}
                                  data-plasmic-override={overrides.icon617}
                                  className={classNames("all", sty.icon617)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__rxlzY
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title644"}
                                data-plasmic-override={overrides.title644}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title644
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item618"}
                              data-plasmic-override={overrides.item618}
                              className={classNames("all", sty.item618)}
                            >
                              <div
                                data-plasmic-name={"left618"}
                                data-plasmic-override={overrides.left618}
                                className={classNames("all", sty.left618)}
                              >
                                <div
                                  data-plasmic-name={"icon618"}
                                  data-plasmic-override={overrides.icon618}
                                  className={classNames("all", sty.icon618)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__jfra1
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title645"}
                                data-plasmic-override={overrides.title645}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title645
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item619"}
                              data-plasmic-override={overrides.item619}
                              className={classNames("all", sty.item619)}
                            >
                              <div
                                data-plasmic-name={"left619"}
                                data-plasmic-override={overrides.left619}
                                className={classNames("all", sty.left619)}
                              >
                                <div
                                  data-plasmic-name={"icon619"}
                                  data-plasmic-override={overrides.icon619}
                                  className={classNames("all", sty.icon619)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__d0DX)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title646"}
                                data-plasmic-override={overrides.title646}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title646
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item620"}
                              data-plasmic-override={overrides.item620}
                              className={classNames("all", sty.item620)}
                            >
                              <div
                                data-plasmic-name={"left620"}
                                data-plasmic-override={overrides.left620}
                                className={classNames("all", sty.left620)}
                              >
                                <div
                                  data-plasmic-name={"icon620"}
                                  data-plasmic-override={overrides.icon620}
                                  className={classNames("all", sty.icon620)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__h9Oyq
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title647"}
                                data-plasmic-override={overrides.title647}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title647
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item621"}
                              data-plasmic-override={overrides.item621}
                              className={classNames("all", sty.item621)}
                            >
                              <div
                                data-plasmic-name={"left621"}
                                data-plasmic-override={overrides.left621}
                                className={classNames("all", sty.left621)}
                              >
                                <div
                                  data-plasmic-name={"icon621"}
                                  data-plasmic-override={overrides.icon621}
                                  className={classNames("all", sty.icon621)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__lZwIu
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title648"}
                                data-plasmic-override={overrides.title648}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title648
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item622"}
                              data-plasmic-override={overrides.item622}
                              className={classNames("all", sty.item622)}
                            >
                              <div
                                data-plasmic-name={"left622"}
                                data-plasmic-override={overrides.left622}
                                className={classNames("all", sty.left622)}
                              >
                                <div
                                  data-plasmic-name={"icon622"}
                                  data-plasmic-override={overrides.icon622}
                                  className={classNames("all", sty.icon622)}
                                >
                                  <Icon93Icon
                                    className={classNames("all", sty.svg__lftJ)}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title649"}
                                data-plasmic-override={overrides.title649}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title649
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item623"}
                              data-plasmic-override={overrides.item623}
                              className={classNames("all", sty.item623)}
                            >
                              <div
                                data-plasmic-name={"left623"}
                                data-plasmic-override={overrides.left623}
                                className={classNames("all", sty.left623)}
                              >
                                <div
                                  data-plasmic-name={"icon623"}
                                  data-plasmic-override={overrides.icon623}
                                  className={classNames("all", sty.icon623)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg__dd512
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title650"}
                                data-plasmic-override={overrides.title650}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title650
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                          {false ? (
                            <div
                              data-plasmic-name={"item624"}
                              data-plasmic-override={overrides.item624}
                              className={classNames("all", sty.item624)}
                            >
                              <div
                                data-plasmic-name={"left624"}
                                data-plasmic-override={overrides.left624}
                                className={classNames("all", sty.left624)}
                              >
                                <div
                                  data-plasmic-name={"icon624"}
                                  data-plasmic-override={overrides.icon624}
                                  className={classNames("all", sty.icon624)}
                                >
                                  <Icon93Icon
                                    className={classNames(
                                      "all",
                                      sty.svg___67G1R
                                    )}
                                    role={"img"}
                                  />
                                </div>
                              </div>
                              <div
                                data-plasmic-name={"title651"}
                                data-plasmic-override={overrides.title651}
                                className={classNames(
                                  "all",
                                  "__wab_text",
                                  sty.title651
                                )}
                              >
                                {"Feature Item"}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      {false ? (
                        <Button
                          data-plasmic-name={"btn26"}
                          data-plasmic-override={overrides.btn26}
                          className={classNames("__wab_instance", sty.btn26)}
                          size={"medium"}
                        />
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"all3"}
            data-plasmic-override={overrides.all3}
            className={classNames("all", sty.all3)}
          >
            <h2
              data-plasmic-name={"title3"}
              data-plasmic-override={overrides.title3}
              className={classNames(
                "all",
                "h2",
                "h2__bvRZj",
                "__wab_text",
                sty.title3
              )}
            >
              {"Full Feature List"}
            </h2>
            <div
              data-plasmic-name={"sections3"}
              data-plasmic-override={overrides.sections3}
              className={classNames("all", sty.sections3)}
            >
              <div
                data-plasmic-name={"col8"}
                data-plasmic-override={overrides.col8}
                className={classNames("all", sty.col8)}
              >
                <h3
                  className={classNames(
                    "all",
                    "h3",
                    "h3__bvRZj",
                    "__wab_text",
                    sty.h3__bvHvj
                  )}
                >
                  {"All Use Cases"}
                </h3>
                <div
                  data-plasmic-name={"list12"}
                  data-plasmic-override={overrides.list12}
                  className={classNames("all", sty.list12)}
                >
                  {(_par => (!_par ? [] : Array.isArray(_par) ? _par : [_par]))(
                    (() => {
                      try {
                        return [
                          {
                            text: "Evaluations/Assessments"
                          },
                          {
                            text: "MyInsight"
                          },
                          {
                            text: "Milestones & EPAs"
                          },
                          {
                            text: "Narrative Predictive Value (NPV)"
                          },
                          {
                            text: "Performance Improvement Plans"
                          },
                          {
                            text: "Clinical Hours (Duty-Hours)"
                          },
                          {
                            text: "MyQuickPass"
                          },
                          {
                            text: "Conference Tracking"
                          },
                          {
                            text: "Burnout Monitoring"
                          },
                          {
                            text: "EHR Connectivity"
                          },
                          {
                            text: "Clinical Log (3rd Party) Integration"
                          },
                          {
                            text: "Learning Assignments"
                          },
                          {
                            text: "MyQuiz (Quizzes/Exams)"
                          },
                          {
                            text: "Demographic Management"
                          },
                          {
                            text: "Onboarding & Credentialing"
                          },
                          {
                            text: "Certificate/Diploma Management"
                          },
                          {
                            text: "Schedule Management"
                          },
                          {
                            text: "Automatic Scheduling & Lottery"
                          },
                          {
                            text: "Schedule (3rd Party) Integration"
                          },
                          {
                            text: "MyPortfolios"
                          },
                          {
                            text: "Performance Dashboard"
                          },
                          {
                            text: "Custom Reporting"
                          },
                          {
                            text: "Electronic Contracts & Signatures"
                          }
                        ];
                      } catch (e) {
                        if (
                          e instanceof TypeError ||
                          e?.plasmicType === "PlasmicUndefinedDataError"
                        ) {
                          return [];
                        }
                        throw e;
                      }
                    })()
                  ).map((__plasmic_item_0, __plasmic_idx_0) => {
                    const currentItem = __plasmic_item_0;
                    const currentIndex = __plasmic_idx_0;
                    return (
                      <ListItem
                        className={classNames(
                          "__wab_instance",
                          sty.listItem__nnTIc
                        )}
                        key={currentIndex}
                        text={(() => {
                          try {
                            return currentItem.text;
                          } catch (e) {
                            if (
                              e instanceof TypeError ||
                              e?.plasmicType === "PlasmicUndefinedDataError"
                            ) {
                              return undefined;
                            }
                            throw e;
                          }
                        })()}
                      >
                        <Icon5Icon
                          className={classNames("all", sty.svg__bg81D)}
                          role={"img"}
                        />
                      </ListItem>
                    );
                  })}
                </div>
              </div>
              <div
                data-plasmic-name={"col9"}
                data-plasmic-override={overrides.col9}
                className={classNames("all", sty.col9)}
              >
                <div
                  data-plasmic-name={"section5"}
                  data-plasmic-override={overrides.section5}
                  className={classNames("all", sty.section5)}
                >
                  <h3
                    className={classNames(
                      "all",
                      "h3",
                      "h3__bvRZj",
                      "__wab_text",
                      sty.h3__laeQy
                    )}
                  >
                    {"GME & Physician Assistant Programs "}
                  </h3>
                  <div
                    data-plasmic-name={"list13"}
                    data-plasmic-override={overrides.list13}
                    className={classNames("all", sty.list13)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Curriculum Management"
                            },
                            {
                              text: "Procedure Logging"
                            },
                            {
                              text: "Patient Logging"
                            },
                            {
                              text: "Centralized Procedure Reporting"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__hcMw8
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__piHra)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"section6"}
                  data-plasmic-override={overrides.section6}
                  className={classNames("all", sty.section6)}
                >
                  <h3
                    className={classNames(
                      "all",
                      "h3",
                      "h3__bvRZj",
                      "__wab_text",
                      sty.h3__mIqPk
                    )}
                  >
                    {"GME Programs "}
                  </h3>
                  <div
                    data-plasmic-name={"list14"}
                    data-plasmic-override={overrides.list14}
                    className={classNames("all", sty.list14)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Annual Program Evaluations"
                            },
                            {
                              text: "Common Program Requirements"
                            },
                            {
                              text: "Institutional Requirements"
                            },
                            {
                              text: "Take Action Plans & Notifications"
                            },
                            {
                              text: "ERAS Data Importing"
                            },
                            {
                              text: "Electronic Contract Management"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__hcXaQ
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__jIqKx)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
                <div
                  data-plasmic-name={"col10"}
                  data-plasmic-override={overrides.col10}
                  className={classNames("all", sty.col10)}
                >
                  <h3
                    className={classNames(
                      "all",
                      "h3",
                      "h3__bvRZj",
                      "__wab_text",
                      sty.h3__fXtGx
                    )}
                  >
                    {"Nursing Programs"}
                  </h3>
                  <div
                    data-plasmic-name={"list15"}
                    data-plasmic-override={overrides.list15}
                    className={classNames("all", sty.list15)}
                  >
                    {(_par =>
                      !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                      (() => {
                        try {
                          return [
                            {
                              text: "Clinical Activity Logger"
                            },
                            {
                              text: "Return Demonstration Management"
                            },
                            {
                              text: "Return Demonstration Testing"
                            },
                            {
                              text: "Clinical Learning Contracts"
                            }
                          ];
                        } catch (e) {
                          if (
                            e instanceof TypeError ||
                            e?.plasmicType === "PlasmicUndefinedDataError"
                          ) {
                            return [];
                          }
                          throw e;
                        }
                      })()
                    ).map((__plasmic_item_0, __plasmic_idx_0) => {
                      const currentItem = __plasmic_item_0;
                      const currentIndex = __plasmic_idx_0;
                      return (
                        <ListItem
                          className={classNames(
                            "__wab_instance",
                            sty.listItem__eAeqC
                          )}
                          key={currentIndex}
                          text={(() => {
                            try {
                              return currentItem.text;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return undefined;
                              }
                              throw e;
                            }
                          })()}
                        >
                          <Icon5Icon
                            className={classNames("all", sty.svg__v7Ql)}
                            role={"img"}
                          />
                        </ListItem>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(
        hasVariant(globalVariants, "mobile", "mobileXSmall")
          ? true
          : hasVariant(globalVariants, "mobile", "mobile")
            ? true
            : false
      ) ? (
        <div
          data-plasmic-name={"mobile"}
          data-plasmic-override={overrides.mobile}
          className={classNames("all", sty.mobile)}
        >
          <div
            data-plasmic-name={"header3"}
            data-plasmic-override={overrides.header3}
            className={classNames("all", sty.header3)}
          />

          <div
            data-plasmic-name={"key3"}
            data-plasmic-override={overrides.key3}
            className={classNames("all", sty.key3)}
          >
            <header
              data-plasmic-name={"header2"}
              data-plasmic-override={overrides.header2}
              className={classNames("all", sty.header2)}
            >
              <h2
                className={classNames(
                  "all",
                  "h2",
                  "h2__bvRZj",
                  "__wab_text",
                  sty.h2__sZ67L
                )}
              >
                {"Key Features"}
              </h2>
            </header>
            <div
              data-plasmic-name={"list6"}
              data-plasmic-override={overrides.list6}
              className={classNames("all", sty.list6)}
            >
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__sfGzi
                )}
                desciption={
                  "Track trainee progress through  evaluations, navigate developmental milestones, and ensure competency with EPAs. This approach provides a clear view of growth improving the effectiveness of your training program."
                }
                title={"Evaluations, Milestones & EPAs"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img___5Rbwa)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"100%"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/b63c4ec01b7f0b5eb8b9273a00144d1a.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <FeaturesCard
                className={classNames(
                  "__wab_instance",
                  sty.featuresCard__wpM6M
                )}
                desciption={
                  "Make every nurse student demonstration a milestone. Standardize validation, ensure objective evaluation, and refine training processes. Get clear criteria and opportunities for feedback."
                }
                title={"Return Demonstrations"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__l4Ho0)}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loader={"plasmic"}
                  loading={"lazy"}
                  src={{
                    src: "https://site-assets.plasmic.app/a86286f943431a01b8c593770fd02a05.svg",
                    fullWidth: 374,
                    fullHeight: 239,
                    aspectRatio: 1.564854
                  }}
                />
              </FeaturesCard>
              <div
                data-plasmic-name={"figmaPaste4"}
                data-plasmic-override={overrides.figmaPaste4}
                className={classNames("all", sty.figmaPaste4)}
              >
                <div
                  data-plasmic-name={"narrowCard9"}
                  data-plasmic-override={overrides.narrowCard9}
                  className={classNames("all", sty.narrowCard9)}
                >
                  <div
                    data-plasmic-name={"header28"}
                    data-plasmic-override={overrides.header28}
                    className={classNames("all", sty.header28)}
                  >
                    <div
                      data-plasmic-name={"title"}
                      data-plasmic-override={overrides.title}
                      className={classNames("all", "__wab_text", sty.title)}
                    >
                      {"Assessment \n& Competency Management"}
                    </div>
                    <Icon94Icon
                      className={classNames("all", sty.svg__brMab)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content9"}
                    data-plasmic-override={overrides.content9}
                    className={classNames("all", sty.content9)}
                  >
                    <div
                      data-plasmic-name={"desc9"}
                      data-plasmic-override={overrides.desc9}
                      className={classNames("all", "__wab_text", sty.desc9)}
                    >
                      {
                        "Strengthen assessment quality, support competency-based education, and transform educational information into meaningful insight."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder9"}
                      data-plasmic-override={overrides.placeholder9}
                      className={classNames("all", sty.placeholder9)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header29"}
                          data-plasmic-override={overrides.header29}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header29
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list24"}
                        data-plasmic-override={overrides.list24}
                        className={classNames("all", sty.list24)}
                      >
                        <div
                          data-plasmic-name={"item"}
                          data-plasmic-override={overrides.item}
                          className={classNames("all", sty.item)}
                        >
                          <div
                            data-plasmic-name={"left"}
                            data-plasmic-override={overrides.left}
                            className={classNames("all", sty.left)}
                          >
                            <div
                              data-plasmic-name={"icon"}
                              data-plasmic-override={overrides.icon}
                              className={classNames("all", sty.icon)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__sWPat)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title396"}
                            data-plasmic-override={overrides.title396}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title396
                            )}
                          >
                            {"SAGE\u2122"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item2"}
                          data-plasmic-override={overrides.item2}
                          className={classNames("all", sty.item2)}
                        >
                          <div
                            data-plasmic-name={"left2"}
                            data-plasmic-override={overrides.left2}
                            className={classNames("all", sty.left2)}
                          >
                            <div
                              data-plasmic-name={"icon2"}
                              data-plasmic-override={overrides.icon2}
                              className={classNames("all", sty.icon2)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__uIuOc)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title397"}
                            data-plasmic-override={overrides.title397}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title397
                            )}
                          >
                            {"Evaluations & Assessments"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item3"}
                          data-plasmic-override={overrides.item3}
                          className={classNames("all", sty.item3)}
                        >
                          <div
                            data-plasmic-name={"left3"}
                            data-plasmic-override={overrides.left3}
                            className={classNames("all", sty.left3)}
                          >
                            <div
                              data-plasmic-name={"icon3"}
                              data-plasmic-override={overrides.icon3}
                              className={classNames("all", sty.icon3)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__fKebQ)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title4"}
                            data-plasmic-override={overrides.title4}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title4
                            )}
                          >
                            {"MyInsights\u00ae"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item4"}
                          data-plasmic-override={overrides.item4}
                          className={classNames("all", sty.item4)}
                        >
                          <div
                            data-plasmic-name={"left4"}
                            data-plasmic-override={overrides.left4}
                            className={classNames("all", sty.left4)}
                          >
                            <div
                              data-plasmic-name={"icon4"}
                              data-plasmic-override={overrides.icon4}
                              className={classNames("all", sty.icon4)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__f3Puy)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title5"}
                            data-plasmic-override={overrides.title5}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title5
                            )}
                          >
                            {"Milestones & EPAs"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item5"}
                          data-plasmic-override={overrides.item5}
                          className={classNames("all", sty.item5)}
                        >
                          <div
                            data-plasmic-name={"left5"}
                            data-plasmic-override={overrides.left5}
                            className={classNames("all", sty.left5)}
                          >
                            <div
                              data-plasmic-name={"icon5"}
                              data-plasmic-override={overrides.icon5}
                              className={classNames("all", sty.icon5)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__kiYdi)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title6"}
                            data-plasmic-override={overrides.title6}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title6
                            )}
                          >
                            {"Narrative Predictive Value (NPV)"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item6"}
                          data-plasmic-override={overrides.item6}
                          className={classNames("all", sty.item6)}
                        >
                          <div
                            data-plasmic-name={"left6"}
                            data-plasmic-override={overrides.left6}
                            className={classNames("all", sty.left6)}
                          >
                            <div
                              data-plasmic-name={"icon6"}
                              data-plasmic-override={overrides.icon6}
                              className={classNames("all", sty.icon6)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__vZm)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title7"}
                            data-plasmic-override={overrides.title7}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title7
                            )}
                          >
                            {"Performance Improvement Plans"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item7"}
                          data-plasmic-override={overrides.item7}
                          className={classNames("all", sty.item7)}
                        >
                          <div
                            data-plasmic-name={"left7"}
                            data-plasmic-override={overrides.left7}
                            className={classNames("all", sty.left7)}
                          >
                            <div
                              data-plasmic-name={"icon7"}
                              data-plasmic-override={overrides.icon7}
                              className={classNames("all", sty.icon7)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__gvTci)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title8"}
                            data-plasmic-override={overrides.title8}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title8
                            )}
                          >
                            {"Performance Dashboard"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item8"}
                            data-plasmic-override={overrides.item8}
                            className={classNames("all", sty.item8)}
                          >
                            <div
                              data-plasmic-name={"left8"}
                              data-plasmic-override={overrides.left8}
                              className={classNames("all", sty.left8)}
                            >
                              <div
                                data-plasmic-name={"icon8"}
                                data-plasmic-override={overrides.icon8}
                                className={classNames("all", sty.icon8)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fbZzS)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title9"}
                              data-plasmic-override={overrides.title9}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title9
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item9"}
                            data-plasmic-override={overrides.item9}
                            className={classNames("all", sty.item9)}
                          >
                            <div
                              data-plasmic-name={"left9"}
                              data-plasmic-override={overrides.left9}
                              className={classNames("all", sty.left9)}
                            >
                              <div
                                data-plasmic-name={"icon9"}
                                data-plasmic-override={overrides.icon9}
                                className={classNames("all", sty.icon9)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__f1VRk)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title10"}
                              data-plasmic-override={overrides.title10}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title10
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item10"}
                            data-plasmic-override={overrides.item10}
                            className={classNames("all", sty.item10)}
                          >
                            <div
                              data-plasmic-name={"left10"}
                              data-plasmic-override={overrides.left10}
                              className={classNames("all", sty.left10)}
                            >
                              <div
                                data-plasmic-name={"icon10"}
                                data-plasmic-override={overrides.icon10}
                                className={classNames("all", sty.icon10)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wR7Kx)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title11"}
                              data-plasmic-override={overrides.title11}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title11
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item11"}
                            data-plasmic-override={overrides.item11}
                            className={classNames("all", sty.item11)}
                          >
                            <div
                              data-plasmic-name={"left11"}
                              data-plasmic-override={overrides.left11}
                              className={classNames("all", sty.left11)}
                            >
                              <div
                                data-plasmic-name={"icon11"}
                                data-plasmic-override={overrides.icon11}
                                className={classNames("all", sty.icon11)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__h6TE)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title12"}
                              data-plasmic-override={overrides.title12}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title12
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item12"}
                            data-plasmic-override={overrides.item12}
                            className={classNames("all", sty.item12)}
                          >
                            <div
                              data-plasmic-name={"left12"}
                              data-plasmic-override={overrides.left12}
                              className={classNames("all", sty.left12)}
                            >
                              <div
                                data-plasmic-name={"icon12"}
                                data-plasmic-override={overrides.icon12}
                                className={classNames("all", sty.icon12)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___3MbVt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title13"}
                              data-plasmic-override={overrides.title13}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title13
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item13"}
                            data-plasmic-override={overrides.item13}
                            className={classNames("all", sty.item13)}
                          >
                            <div
                              data-plasmic-name={"left13"}
                              data-plasmic-override={overrides.left13}
                              className={classNames("all", sty.left13)}
                            >
                              <div
                                data-plasmic-name={"icon13"}
                                data-plasmic-override={overrides.icon13}
                                className={classNames("all", sty.icon13)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___9Fjo9)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title14"}
                              data-plasmic-override={overrides.title14}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title14
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item14"}
                            data-plasmic-override={overrides.item14}
                            className={classNames("all", sty.item14)}
                          >
                            <div
                              data-plasmic-name={"left14"}
                              data-plasmic-override={overrides.left14}
                              className={classNames("all", sty.left14)}
                            >
                              <div
                                data-plasmic-name={"icon14"}
                                data-plasmic-override={overrides.icon14}
                                className={classNames("all", sty.icon14)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xLe3V)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title15"}
                              data-plasmic-override={overrides.title15}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title15
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item15"}
                            data-plasmic-override={overrides.item15}
                            className={classNames("all", sty.item15)}
                          >
                            <div
                              data-plasmic-name={"left15"}
                              data-plasmic-override={overrides.left15}
                              className={classNames("all", sty.left15)}
                            >
                              <div
                                data-plasmic-name={"icon15"}
                                data-plasmic-override={overrides.icon15}
                                className={classNames("all", sty.icon15)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fKf4D)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title16"}
                              data-plasmic-override={overrides.title16}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title16
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item16"}
                            data-plasmic-override={overrides.item16}
                            className={classNames("all", sty.item16)}
                          >
                            <div
                              data-plasmic-name={"left16"}
                              data-plasmic-override={overrides.left16}
                              className={classNames("all", sty.left16)}
                            >
                              <div
                                data-plasmic-name={"icon16"}
                                data-plasmic-override={overrides.icon16}
                                className={classNames("all", sty.icon16)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dkZpc)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title17"}
                              data-plasmic-override={overrides.title17}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title17
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item17"}
                            data-plasmic-override={overrides.item17}
                            className={classNames("all", sty.item17)}
                          >
                            <div
                              data-plasmic-name={"left17"}
                              data-plasmic-override={overrides.left17}
                              className={classNames("all", sty.left17)}
                            >
                              <div
                                data-plasmic-name={"icon17"}
                                data-plasmic-override={overrides.icon17}
                                className={classNames("all", sty.icon17)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__r6Lcm)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title18"}
                              data-plasmic-override={overrides.title18}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title18
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item18"}
                            data-plasmic-override={overrides.item18}
                            className={classNames("all", sty.item18)}
                          >
                            <div
                              data-plasmic-name={"left18"}
                              data-plasmic-override={overrides.left18}
                              className={classNames("all", sty.left18)}
                            >
                              <div
                                data-plasmic-name={"icon18"}
                                data-plasmic-override={overrides.icon18}
                                className={classNames("all", sty.icon18)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__swdUz)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title19"}
                              data-plasmic-override={overrides.title19}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title19
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item19"}
                            data-plasmic-override={overrides.item19}
                            className={classNames("all", sty.item19)}
                          >
                            <div
                              data-plasmic-name={"left19"}
                              data-plasmic-override={overrides.left19}
                              className={classNames("all", sty.left19)}
                            >
                              <div
                                data-plasmic-name={"icon19"}
                                data-plasmic-override={overrides.icon19}
                                className={classNames("all", sty.icon19)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___6OJPz)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title20"}
                              data-plasmic-override={overrides.title20}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title20
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item20"}
                            data-plasmic-override={overrides.item20}
                            className={classNames("all", sty.item20)}
                          >
                            <div
                              data-plasmic-name={"left20"}
                              data-plasmic-override={overrides.left20}
                              className={classNames("all", sty.left20)}
                            >
                              <div
                                data-plasmic-name={"icon20"}
                                data-plasmic-override={overrides.icon20}
                                className={classNames("all", sty.icon20)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__tRk9W)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title21"}
                              data-plasmic-override={overrides.title21}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title21
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item21"}
                            data-plasmic-override={overrides.item21}
                            className={classNames("all", sty.item21)}
                          >
                            <div
                              data-plasmic-name={"left21"}
                              data-plasmic-override={overrides.left21}
                              className={classNames("all", sty.left21)}
                            >
                              <div
                                data-plasmic-name={"icon21"}
                                data-plasmic-override={overrides.icon21}
                                className={classNames("all", sty.icon21)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__m7PvK)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title22"}
                              data-plasmic-override={overrides.title22}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title22
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item22"}
                            data-plasmic-override={overrides.item22}
                            className={classNames("all", sty.item22)}
                          >
                            <div
                              data-plasmic-name={"left22"}
                              data-plasmic-override={overrides.left22}
                              className={classNames("all", sty.left22)}
                            >
                              <div
                                data-plasmic-name={"icon22"}
                                data-plasmic-override={overrides.icon22}
                                className={classNames("all", sty.icon22)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wXdMh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title23"}
                              data-plasmic-override={overrides.title23}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title23
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item23"}
                            data-plasmic-override={overrides.item23}
                            className={classNames("all", sty.item23)}
                          >
                            <div
                              data-plasmic-name={"left23"}
                              data-plasmic-override={overrides.left23}
                              className={classNames("all", sty.left23)}
                            >
                              <div
                                data-plasmic-name={"icon23"}
                                data-plasmic-override={overrides.icon23}
                                className={classNames("all", sty.icon23)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xAweh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title24"}
                              data-plasmic-override={overrides.title24}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title24
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item24"}
                            data-plasmic-override={overrides.item24}
                            className={classNames("all", sty.item24)}
                          >
                            <div
                              data-plasmic-name={"left24"}
                              data-plasmic-override={overrides.left24}
                              className={classNames("all", sty.left24)}
                            >
                              <div
                                data-plasmic-name={"icon24"}
                                data-plasmic-override={overrides.icon24}
                                className={classNames("all", sty.icon24)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__qWjkc)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title25"}
                              data-plasmic-override={overrides.title25}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title25
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn9"}
                        data-plasmic-override={overrides.btn9}
                        className={classNames("__wab_instance", sty.btn9)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard10"}
                  data-plasmic-override={overrides.narrowCard10}
                  className={classNames("all", sty.narrowCard10)}
                >
                  <div
                    data-plasmic-name={"header30"}
                    data-plasmic-override={overrides.header30}
                    className={classNames("all", sty.header30)}
                  >
                    <div
                      data-plasmic-name={"title26"}
                      data-plasmic-override={overrides.title26}
                      className={classNames("all", "__wab_text", sty.title26)}
                    >
                      {"Educational Operations"}
                    </div>
                    <Icon96Icon
                      className={classNames("all", sty.svg__ahPfA)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content10"}
                    data-plasmic-override={overrides.content10}
                    className={classNames("all", sty.content10)}
                  >
                    <div
                      data-plasmic-name={"desc10"}
                      data-plasmic-override={overrides.desc10}
                      className={classNames("all", "__wab_text", sty.desc10)}
                    >
                      {
                        "Manage the day-to-day activities that keep educational programs running efficiently."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder10"}
                      data-plasmic-override={overrides.placeholder10}
                      className={classNames("all", sty.placeholder10)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header31"}
                          data-plasmic-override={overrides.header31}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header31
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list2"}
                        data-plasmic-override={overrides.list2}
                        className={classNames("all", sty.list2)}
                      >
                        <div
                          data-plasmic-name={"item25"}
                          data-plasmic-override={overrides.item25}
                          className={classNames("all", sty.item25)}
                        >
                          <div
                            data-plasmic-name={"left25"}
                            data-plasmic-override={overrides.left25}
                            className={classNames("all", sty.left25)}
                          >
                            <div
                              data-plasmic-name={"icon25"}
                              data-plasmic-override={overrides.icon25}
                              className={classNames("all", sty.icon25)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__ufomx)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title27"}
                            data-plasmic-override={overrides.title27}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title27
                            )}
                          >
                            {"Clinical Hours"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item26"}
                          data-plasmic-override={overrides.item26}
                          className={classNames("all", sty.item26)}
                        >
                          <div
                            data-plasmic-name={"left26"}
                            data-plasmic-override={overrides.left26}
                            className={classNames("all", sty.left26)}
                          >
                            <div
                              data-plasmic-name={"icon26"}
                              data-plasmic-override={overrides.icon26}
                              className={classNames("all", sty.icon26)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__po2Ne)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title28"}
                            data-plasmic-override={overrides.title28}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title28
                            )}
                          >
                            {"MyQuickPass\u00ae"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item27"}
                          data-plasmic-override={overrides.item27}
                          className={classNames("all", sty.item27)}
                        >
                          <div
                            data-plasmic-name={"left27"}
                            data-plasmic-override={overrides.left27}
                            className={classNames("all", sty.left27)}
                          >
                            <div
                              data-plasmic-name={"icon27"}
                              data-plasmic-override={overrides.icon27}
                              className={classNames("all", sty.icon27)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__qwcx7)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title29"}
                            data-plasmic-override={overrides.title29}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title29
                            )}
                          >
                            {"Scheduling"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item28"}
                          data-plasmic-override={overrides.item28}
                          className={classNames("all", sty.item28)}
                        >
                          <div
                            data-plasmic-name={"left28"}
                            data-plasmic-override={overrides.left28}
                            className={classNames("all", sty.left28)}
                          >
                            <div
                              data-plasmic-name={"icon28"}
                              data-plasmic-override={overrides.icon28}
                              className={classNames("all", sty.icon28)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__ewzO)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title30"}
                            data-plasmic-override={overrides.title30}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title30
                            )}
                          >
                            {"Automated Scheduling & Lottery"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item29"}
                          data-plasmic-override={overrides.item29}
                          className={classNames("all", sty.item29)}
                        >
                          <div
                            data-plasmic-name={"left29"}
                            data-plasmic-override={overrides.left29}
                            className={classNames("all", sty.left29)}
                          >
                            <div
                              data-plasmic-name={"icon29"}
                              data-plasmic-override={overrides.icon29}
                              className={classNames("all", sty.icon29)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__gjdou)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title31"}
                            data-plasmic-override={overrides.title31}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title31
                            )}
                          >
                            {"Conference Tracking"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item30"}
                          data-plasmic-override={overrides.item30}
                          className={classNames("all", sty.item30)}
                        >
                          <div
                            data-plasmic-name={"left30"}
                            data-plasmic-override={overrides.left30}
                            className={classNames("all", sty.left30)}
                          >
                            <div
                              data-plasmic-name={"icon30"}
                              data-plasmic-override={overrides.icon30}
                              className={classNames("all", sty.icon30)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__wxeBr)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title32"}
                            data-plasmic-override={overrides.title32}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title32
                            )}
                          >
                            {"Burnout Monitoring"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item31"}
                          data-plasmic-override={overrides.item31}
                          className={classNames("all", sty.item31)}
                        >
                          <div
                            data-plasmic-name={"left31"}
                            data-plasmic-override={overrides.left31}
                            className={classNames("all", sty.left31)}
                          >
                            <div
                              data-plasmic-name={"icon31"}
                              data-plasmic-override={overrides.icon31}
                              className={classNames("all", sty.icon31)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__ieVKh)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title33"}
                            data-plasmic-override={overrides.title33}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title33
                            )}
                          >
                            {"Demographic Management"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item32"}
                            data-plasmic-override={overrides.item32}
                            className={classNames("all", sty.item32)}
                          >
                            <div
                              data-plasmic-name={"left32"}
                              data-plasmic-override={overrides.left32}
                              className={classNames("all", sty.left32)}
                            >
                              <div
                                data-plasmic-name={"icon32"}
                                data-plasmic-override={overrides.icon32}
                                className={classNames("all", sty.icon32)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__nDo32)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title34"}
                              data-plasmic-override={overrides.title34}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title34
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item33"}
                            data-plasmic-override={overrides.item33}
                            className={classNames("all", sty.item33)}
                          >
                            <div
                              data-plasmic-name={"left33"}
                              data-plasmic-override={overrides.left33}
                              className={classNames("all", sty.left33)}
                            >
                              <div
                                data-plasmic-name={"icon33"}
                                data-plasmic-override={overrides.icon33}
                                className={classNames("all", sty.icon33)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___1Xi9F)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title35"}
                              data-plasmic-override={overrides.title35}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title35
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item34"}
                            data-plasmic-override={overrides.item34}
                            className={classNames("all", sty.item34)}
                          >
                            <div
                              data-plasmic-name={"left34"}
                              data-plasmic-override={overrides.left34}
                              className={classNames("all", sty.left34)}
                            >
                              <div
                                data-plasmic-name={"icon34"}
                                data-plasmic-override={overrides.icon34}
                                className={classNames("all", sty.icon34)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vYcii)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title36"}
                              data-plasmic-override={overrides.title36}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title36
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item35"}
                            data-plasmic-override={overrides.item35}
                            className={classNames("all", sty.item35)}
                          >
                            <div
                              data-plasmic-name={"left35"}
                              data-plasmic-override={overrides.left35}
                              className={classNames("all", sty.left35)}
                            >
                              <div
                                data-plasmic-name={"icon35"}
                                data-plasmic-override={overrides.icon35}
                                className={classNames("all", sty.icon35)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__nqSjt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title37"}
                              data-plasmic-override={overrides.title37}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title37
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item36"}
                            data-plasmic-override={overrides.item36}
                            className={classNames("all", sty.item36)}
                          >
                            <div
                              data-plasmic-name={"left36"}
                              data-plasmic-override={overrides.left36}
                              className={classNames("all", sty.left36)}
                            >
                              <div
                                data-plasmic-name={"icon36"}
                                data-plasmic-override={overrides.icon36}
                                className={classNames("all", sty.icon36)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___2DiOp)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title38"}
                              data-plasmic-override={overrides.title38}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title38
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item37"}
                            data-plasmic-override={overrides.item37}
                            className={classNames("all", sty.item37)}
                          >
                            <div
                              data-plasmic-name={"left37"}
                              data-plasmic-override={overrides.left37}
                              className={classNames("all", sty.left37)}
                            >
                              <div
                                data-plasmic-name={"icon37"}
                                data-plasmic-override={overrides.icon37}
                                className={classNames("all", sty.icon37)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__u4EoD)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title39"}
                              data-plasmic-override={overrides.title39}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title39
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item38"}
                            data-plasmic-override={overrides.item38}
                            className={classNames("all", sty.item38)}
                          >
                            <div
                              data-plasmic-name={"left38"}
                              data-plasmic-override={overrides.left38}
                              className={classNames("all", sty.left38)}
                            >
                              <div
                                data-plasmic-name={"icon38"}
                                data-plasmic-override={overrides.icon38}
                                className={classNames("all", sty.icon38)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__l6I82)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title40"}
                              data-plasmic-override={overrides.title40}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title40
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item39"}
                            data-plasmic-override={overrides.item39}
                            className={classNames("all", sty.item39)}
                          >
                            <div
                              data-plasmic-name={"left39"}
                              data-plasmic-override={overrides.left39}
                              className={classNames("all", sty.left39)}
                            >
                              <div
                                data-plasmic-name={"icon39"}
                                data-plasmic-override={overrides.icon39}
                                className={classNames("all", sty.icon39)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jp22J)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title41"}
                              data-plasmic-override={overrides.title41}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title41
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item40"}
                            data-plasmic-override={overrides.item40}
                            className={classNames("all", sty.item40)}
                          >
                            <div
                              data-plasmic-name={"left40"}
                              data-plasmic-override={overrides.left40}
                              className={classNames("all", sty.left40)}
                            >
                              <div
                                data-plasmic-name={"icon40"}
                                data-plasmic-override={overrides.icon40}
                                className={classNames("all", sty.icon40)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__mj5Kt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title42"}
                              data-plasmic-override={overrides.title42}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title42
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item41"}
                            data-plasmic-override={overrides.item41}
                            className={classNames("all", sty.item41)}
                          >
                            <div
                              data-plasmic-name={"left41"}
                              data-plasmic-override={overrides.left41}
                              className={classNames("all", sty.left41)}
                            >
                              <div
                                data-plasmic-name={"icon41"}
                                data-plasmic-override={overrides.icon41}
                                className={classNames("all", sty.icon41)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__khUWh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title43"}
                              data-plasmic-override={overrides.title43}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title43
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item42"}
                            data-plasmic-override={overrides.item42}
                            className={classNames("all", sty.item42)}
                          >
                            <div
                              data-plasmic-name={"left42"}
                              data-plasmic-override={overrides.left42}
                              className={classNames("all", sty.left42)}
                            >
                              <div
                                data-plasmic-name={"icon42"}
                                data-plasmic-override={overrides.icon42}
                                className={classNames("all", sty.icon42)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__if9If)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title44"}
                              data-plasmic-override={overrides.title44}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title44
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item43"}
                            data-plasmic-override={overrides.item43}
                            className={classNames("all", sty.item43)}
                          >
                            <div
                              data-plasmic-name={"left43"}
                              data-plasmic-override={overrides.left43}
                              className={classNames("all", sty.left43)}
                            >
                              <div
                                data-plasmic-name={"icon43"}
                                data-plasmic-override={overrides.icon43}
                                className={classNames("all", sty.icon43)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__m0AvR)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title45"}
                              data-plasmic-override={overrides.title45}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title45
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item44"}
                            data-plasmic-override={overrides.item44}
                            className={classNames("all", sty.item44)}
                          >
                            <div
                              data-plasmic-name={"left44"}
                              data-plasmic-override={overrides.left44}
                              className={classNames("all", sty.left44)}
                            >
                              <div
                                data-plasmic-name={"icon44"}
                                data-plasmic-override={overrides.icon44}
                                className={classNames("all", sty.icon44)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__bQs4)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title46"}
                              data-plasmic-override={overrides.title46}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title46
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item45"}
                            data-plasmic-override={overrides.item45}
                            className={classNames("all", sty.item45)}
                          >
                            <div
                              data-plasmic-name={"left45"}
                              data-plasmic-override={overrides.left45}
                              className={classNames("all", sty.left45)}
                            >
                              <div
                                data-plasmic-name={"icon45"}
                                data-plasmic-override={overrides.icon45}
                                className={classNames("all", sty.icon45)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__scgUv)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title47"}
                              data-plasmic-override={overrides.title47}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title47
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item46"}
                            data-plasmic-override={overrides.item46}
                            className={classNames("all", sty.item46)}
                          >
                            <div
                              data-plasmic-name={"left46"}
                              data-plasmic-override={overrides.left46}
                              className={classNames("all", sty.left46)}
                            >
                              <div
                                data-plasmic-name={"icon46"}
                                data-plasmic-override={overrides.icon46}
                                className={classNames("all", sty.icon46)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__aoOv6)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title48"}
                              data-plasmic-override={overrides.title48}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title48
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item47"}
                            data-plasmic-override={overrides.item47}
                            className={classNames("all", sty.item47)}
                          >
                            <div
                              data-plasmic-name={"left47"}
                              data-plasmic-override={overrides.left47}
                              className={classNames("all", sty.left47)}
                            >
                              <div
                                data-plasmic-name={"icon47"}
                                data-plasmic-override={overrides.icon47}
                                className={classNames("all", sty.icon47)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___2SGDg)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title49"}
                              data-plasmic-override={overrides.title49}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title49
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item48"}
                            data-plasmic-override={overrides.item48}
                            className={classNames("all", sty.item48)}
                          >
                            <div
                              data-plasmic-name={"left48"}
                              data-plasmic-override={overrides.left48}
                              className={classNames("all", sty.left48)}
                            >
                              <div
                                data-plasmic-name={"icon48"}
                                data-plasmic-override={overrides.icon48}
                                className={classNames("all", sty.icon48)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kQnKy)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title50"}
                              data-plasmic-override={overrides.title50}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title50
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn10"}
                        data-plasmic-override={overrides.btn10}
                        className={classNames("__wab_instance", sty.btn10)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard11"}
                  data-plasmic-override={overrides.narrowCard11}
                  className={classNames("all", sty.narrowCard11)}
                >
                  <div
                    data-plasmic-name={"header5"}
                    data-plasmic-override={overrides.header5}
                    className={classNames("all", sty.header5)}
                  >
                    <div
                      data-plasmic-name={"title51"}
                      data-plasmic-override={overrides.title51}
                      className={classNames("all", "__wab_text", sty.title51)}
                    >
                      {"Learning & Development"}
                    </div>
                    <Icon95Icon
                      className={classNames("all", sty.svg__zj6Wi)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content11"}
                    data-plasmic-override={overrides.content11}
                    className={classNames("all", sty.content11)}
                  >
                    <div
                      data-plasmic-name={"desc11"}
                      data-plasmic-override={overrides.desc11}
                      className={classNames("all", "__wab_text", sty.desc11)}
                    >
                      {
                        "Support learner growth through integrated educational resources and competency development."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder11"}
                      data-plasmic-override={overrides.placeholder11}
                      className={classNames("all", sty.placeholder11)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header6"}
                          data-plasmic-override={overrides.header6}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header6
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list3"}
                        data-plasmic-override={overrides.list3}
                        className={classNames("all", sty.list3)}
                      >
                        <div
                          data-plasmic-name={"item49"}
                          data-plasmic-override={overrides.item49}
                          className={classNames("all", sty.item49)}
                        >
                          <div
                            data-plasmic-name={"left49"}
                            data-plasmic-override={overrides.left49}
                            className={classNames("all", sty.left49)}
                          >
                            <div
                              data-plasmic-name={"icon49"}
                              data-plasmic-override={overrides.icon49}
                              className={classNames("all", sty.icon49)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__rvPj)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title52"}
                            data-plasmic-override={overrides.title52}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title52
                            )}
                          >
                            {"Learning Assignments"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item50"}
                          data-plasmic-override={overrides.item50}
                          className={classNames("all", sty.item50)}
                        >
                          <div
                            data-plasmic-name={"left50"}
                            data-plasmic-override={overrides.left50}
                            className={classNames("all", sty.left50)}
                          >
                            <div
                              data-plasmic-name={"icon50"}
                              data-plasmic-override={overrides.icon50}
                              className={classNames("all", sty.icon50)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__digU1)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title53"}
                            data-plasmic-override={overrides.title53}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title53
                            )}
                          >
                            {"MyQuiz\u2122"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item51"}
                          data-plasmic-override={overrides.item51}
                          className={classNames("all", sty.item51)}
                        >
                          <div
                            data-plasmic-name={"left51"}
                            data-plasmic-override={overrides.left51}
                            className={classNames("all", sty.left51)}
                          >
                            <div
                              data-plasmic-name={"icon51"}
                              data-plasmic-override={overrides.icon51}
                              className={classNames("all", sty.icon51)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__vCt)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title54"}
                            data-plasmic-override={overrides.title54}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title54
                            )}
                          >
                            {"MyPortfolios\u00ae"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item52"}
                          data-plasmic-override={overrides.item52}
                          className={classNames("all", sty.item52)}
                        >
                          <div
                            data-plasmic-name={"left52"}
                            data-plasmic-override={overrides.left52}
                            className={classNames("all", sty.left52)}
                          >
                            <div
                              data-plasmic-name={"icon52"}
                              data-plasmic-override={overrides.icon52}
                              className={classNames("all", sty.icon52)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___9Xsie)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title55"}
                            data-plasmic-override={overrides.title55}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title55
                            )}
                          >
                            {"Curriculum Management"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item53"}
                          data-plasmic-override={overrides.item53}
                          className={classNames("all", sty.item53)}
                        >
                          <div
                            data-plasmic-name={"left53"}
                            data-plasmic-override={overrides.left53}
                            className={classNames("all", sty.left53)}
                          >
                            <div
                              data-plasmic-name={"icon53"}
                              data-plasmic-override={overrides.icon53}
                              className={classNames("all", sty.icon53)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___0Uenn)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title56"}
                            data-plasmic-override={overrides.title56}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title56
                            )}
                          >
                            {"Certificate & Diploma Management"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item54"}
                            data-plasmic-override={overrides.item54}
                            className={classNames("all", sty.item54)}
                          >
                            <div
                              data-plasmic-name={"left54"}
                              data-plasmic-override={overrides.left54}
                              className={classNames("all", sty.left54)}
                            >
                              <div
                                data-plasmic-name={"icon54"}
                                data-plasmic-override={overrides.icon54}
                                className={classNames("all", sty.icon54)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___6RZkS)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title57"}
                              data-plasmic-override={overrides.title57}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title57
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item55"}
                            data-plasmic-override={overrides.item55}
                            className={classNames("all", sty.item55)}
                          >
                            <div
                              data-plasmic-name={"left55"}
                              data-plasmic-override={overrides.left55}
                              className={classNames("all", sty.left55)}
                            >
                              <div
                                data-plasmic-name={"icon55"}
                                data-plasmic-override={overrides.icon55}
                                className={classNames("all", sty.icon55)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__t04Oi)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title58"}
                              data-plasmic-override={overrides.title58}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title58
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item56"}
                            data-plasmic-override={overrides.item56}
                            className={classNames("all", sty.item56)}
                          >
                            <div
                              data-plasmic-name={"left56"}
                              data-plasmic-override={overrides.left56}
                              className={classNames("all", sty.left56)}
                            >
                              <div
                                data-plasmic-name={"icon56"}
                                data-plasmic-override={overrides.icon56}
                                className={classNames("all", sty.icon56)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__twZ5T)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title59"}
                              data-plasmic-override={overrides.title59}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title59
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item57"}
                            data-plasmic-override={overrides.item57}
                            className={classNames("all", sty.item57)}
                          >
                            <div
                              data-plasmic-name={"left57"}
                              data-plasmic-override={overrides.left57}
                              className={classNames("all", sty.left57)}
                            >
                              <div
                                data-plasmic-name={"icon57"}
                                data-plasmic-override={overrides.icon57}
                                className={classNames("all", sty.icon57)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___5SBUf)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title60"}
                              data-plasmic-override={overrides.title60}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title60
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item58"}
                            data-plasmic-override={overrides.item58}
                            className={classNames("all", sty.item58)}
                          >
                            <div
                              data-plasmic-name={"left58"}
                              data-plasmic-override={overrides.left58}
                              className={classNames("all", sty.left58)}
                            >
                              <div
                                data-plasmic-name={"icon58"}
                                data-plasmic-override={overrides.icon58}
                                className={classNames("all", sty.icon58)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___0Kc6A)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title61"}
                              data-plasmic-override={overrides.title61}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title61
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item59"}
                            data-plasmic-override={overrides.item59}
                            className={classNames("all", sty.item59)}
                          >
                            <div
                              data-plasmic-name={"left59"}
                              data-plasmic-override={overrides.left59}
                              className={classNames("all", sty.left59)}
                            >
                              <div
                                data-plasmic-name={"icon59"}
                                data-plasmic-override={overrides.icon59}
                                className={classNames("all", sty.icon59)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__nxYlx)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title62"}
                              data-plasmic-override={overrides.title62}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title62
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item60"}
                            data-plasmic-override={overrides.item60}
                            className={classNames("all", sty.item60)}
                          >
                            <div
                              data-plasmic-name={"left60"}
                              data-plasmic-override={overrides.left60}
                              className={classNames("all", sty.left60)}
                            >
                              <div
                                data-plasmic-name={"icon60"}
                                data-plasmic-override={overrides.icon60}
                                className={classNames("all", sty.icon60)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xgskS)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title63"}
                              data-plasmic-override={overrides.title63}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title63
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item61"}
                            data-plasmic-override={overrides.item61}
                            className={classNames("all", sty.item61)}
                          >
                            <div
                              data-plasmic-name={"left61"}
                              data-plasmic-override={overrides.left61}
                              className={classNames("all", sty.left61)}
                            >
                              <div
                                data-plasmic-name={"icon61"}
                                data-plasmic-override={overrides.icon61}
                                className={classNames("all", sty.icon61)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hxNtd)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title64"}
                              data-plasmic-override={overrides.title64}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title64
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item62"}
                            data-plasmic-override={overrides.item62}
                            className={classNames("all", sty.item62)}
                          >
                            <div
                              data-plasmic-name={"left62"}
                              data-plasmic-override={overrides.left62}
                              className={classNames("all", sty.left62)}
                            >
                              <div
                                data-plasmic-name={"icon62"}
                                data-plasmic-override={overrides.icon62}
                                className={classNames("all", sty.icon62)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___29SvO)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title65"}
                              data-plasmic-override={overrides.title65}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title65
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item63"}
                            data-plasmic-override={overrides.item63}
                            className={classNames("all", sty.item63)}
                          >
                            <div
                              data-plasmic-name={"left63"}
                              data-plasmic-override={overrides.left63}
                              className={classNames("all", sty.left63)}
                            >
                              <div
                                data-plasmic-name={"icon63"}
                                data-plasmic-override={overrides.icon63}
                                className={classNames("all", sty.icon63)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fYmZ)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title66"}
                              data-plasmic-override={overrides.title66}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title66
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item64"}
                            data-plasmic-override={overrides.item64}
                            className={classNames("all", sty.item64)}
                          >
                            <div
                              data-plasmic-name={"left64"}
                              data-plasmic-override={overrides.left64}
                              className={classNames("all", sty.left64)}
                            >
                              <div
                                data-plasmic-name={"icon64"}
                                data-plasmic-override={overrides.icon64}
                                className={classNames("all", sty.icon64)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__zyJmp)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title67"}
                              data-plasmic-override={overrides.title67}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title67
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item65"}
                            data-plasmic-override={overrides.item65}
                            className={classNames("all", sty.item65)}
                          >
                            <div
                              data-plasmic-name={"left65"}
                              data-plasmic-override={overrides.left65}
                              className={classNames("all", sty.left65)}
                            >
                              <div
                                data-plasmic-name={"icon65"}
                                data-plasmic-override={overrides.icon65}
                                className={classNames("all", sty.icon65)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dyVmc)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title68"}
                              data-plasmic-override={overrides.title68}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title68
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item66"}
                            data-plasmic-override={overrides.item66}
                            className={classNames("all", sty.item66)}
                          >
                            <div
                              data-plasmic-name={"left66"}
                              data-plasmic-override={overrides.left66}
                              className={classNames("all", sty.left66)}
                            >
                              <div
                                data-plasmic-name={"icon66"}
                                data-plasmic-override={overrides.icon66}
                                className={classNames("all", sty.icon66)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__y4Dwv)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title69"}
                              data-plasmic-override={overrides.title69}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title69
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item67"}
                            data-plasmic-override={overrides.item67}
                            className={classNames("all", sty.item67)}
                          >
                            <div
                              data-plasmic-name={"left67"}
                              data-plasmic-override={overrides.left67}
                              className={classNames("all", sty.left67)}
                            >
                              <div
                                data-plasmic-name={"icon67"}
                                data-plasmic-override={overrides.icon67}
                                className={classNames("all", sty.icon67)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gjmGq)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title70"}
                              data-plasmic-override={overrides.title70}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title70
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item68"}
                            data-plasmic-override={overrides.item68}
                            className={classNames("all", sty.item68)}
                          >
                            <div
                              data-plasmic-name={"left68"}
                              data-plasmic-override={overrides.left68}
                              className={classNames("all", sty.left68)}
                            >
                              <div
                                data-plasmic-name={"icon68"}
                                data-plasmic-override={overrides.icon68}
                                className={classNames("all", sty.icon68)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___0KI8)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title71"}
                              data-plasmic-override={overrides.title71}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title71
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item69"}
                            data-plasmic-override={overrides.item69}
                            className={classNames("all", sty.item69)}
                          >
                            <div
                              data-plasmic-name={"left69"}
                              data-plasmic-override={overrides.left69}
                              className={classNames("all", sty.left69)}
                            >
                              <div
                                data-plasmic-name={"icon69"}
                                data-plasmic-override={overrides.icon69}
                                className={classNames("all", sty.icon69)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__affkO)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title72"}
                              data-plasmic-override={overrides.title72}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title72
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item70"}
                            data-plasmic-override={overrides.item70}
                            className={classNames("all", sty.item70)}
                          >
                            <div
                              data-plasmic-name={"left70"}
                              data-plasmic-override={overrides.left70}
                              className={classNames("all", sty.left70)}
                            >
                              <div
                                data-plasmic-name={"icon70"}
                                data-plasmic-override={overrides.icon70}
                                className={classNames("all", sty.icon70)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__aiOiA)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title73"}
                              data-plasmic-override={overrides.title73}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title73
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item71"}
                            data-plasmic-override={overrides.item71}
                            className={classNames("all", sty.item71)}
                          >
                            <div
                              data-plasmic-name={"left71"}
                              data-plasmic-override={overrides.left71}
                              className={classNames("all", sty.left71)}
                            >
                              <div
                                data-plasmic-name={"icon71"}
                                data-plasmic-override={overrides.icon71}
                                className={classNames("all", sty.icon71)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xiYdy)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title74"}
                              data-plasmic-override={overrides.title74}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title74
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item72"}
                            data-plasmic-override={overrides.item72}
                            className={classNames("all", sty.item72)}
                          >
                            <div
                              data-plasmic-name={"left72"}
                              data-plasmic-override={overrides.left72}
                              className={classNames("all", sty.left72)}
                            >
                              <div
                                data-plasmic-name={"icon72"}
                                data-plasmic-override={overrides.icon72}
                                className={classNames("all", sty.icon72)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gwwAq)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title75"}
                              data-plasmic-override={overrides.title75}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title75
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn11"}
                        data-plasmic-override={overrides.btn11}
                        className={classNames("__wab_instance", sty.btn11)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard12"}
                  data-plasmic-override={overrides.narrowCard12}
                  className={classNames("all", sty.narrowCard12)}
                >
                  <div
                    data-plasmic-name={"header7"}
                    data-plasmic-override={overrides.header7}
                    className={classNames("all", sty.header7)}
                  >
                    <div
                      data-plasmic-name={"title76"}
                      data-plasmic-override={overrides.title76}
                      className={classNames("all", "__wab_text", sty.title76)}
                    >
                      {"Administrative Management"}
                    </div>
                    <Icon99Icon
                      className={classNames("all", sty.svg__qoX4L)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content12"}
                    data-plasmic-override={overrides.content12}
                    className={classNames("all", sty.content12)}
                  >
                    <div
                      data-plasmic-name={"desc12"}
                      data-plasmic-override={overrides.desc12}
                      className={classNames("all", "__wab_text", sty.desc12)}
                    >
                      {
                        "Simplify administrative workflows while supporting learners, faculty, and institutional leadership."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder12"}
                      data-plasmic-override={overrides.placeholder12}
                      className={classNames("all", sty.placeholder12)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header8"}
                          data-plasmic-override={overrides.header8}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header8
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list4"}
                        data-plasmic-override={overrides.list4}
                        className={classNames("all", sty.list4)}
                      >
                        <div
                          data-plasmic-name={"item73"}
                          data-plasmic-override={overrides.item73}
                          className={classNames("all", sty.item73)}
                        >
                          <div
                            data-plasmic-name={"left73"}
                            data-plasmic-override={overrides.left73}
                            className={classNames("all", sty.left73)}
                          >
                            <div
                              data-plasmic-name={"icon73"}
                              data-plasmic-override={overrides.icon73}
                              className={classNames("all", sty.icon73)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__p7MJd)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title77"}
                            data-plasmic-override={overrides.title77}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title77
                            )}
                          >
                            {"Onboarding & Credentialing"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item74"}
                          data-plasmic-override={overrides.item74}
                          className={classNames("all", sty.item74)}
                        >
                          <div
                            data-plasmic-name={"left74"}
                            data-plasmic-override={overrides.left74}
                            className={classNames("all", sty.left74)}
                          >
                            <div
                              data-plasmic-name={"icon74"}
                              data-plasmic-override={overrides.icon74}
                              className={classNames("all", sty.icon74)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__ahrAf)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title78"}
                            data-plasmic-override={overrides.title78}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title78
                            )}
                          >
                            {"Electronic Agreements & Signatures"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item75"}
                          data-plasmic-override={overrides.item75}
                          className={classNames("all", sty.item75)}
                        >
                          <div
                            data-plasmic-name={"left75"}
                            data-plasmic-override={overrides.left75}
                            className={classNames("all", sty.left75)}
                          >
                            <div
                              data-plasmic-name={"icon75"}
                              data-plasmic-override={overrides.icon75}
                              className={classNames("all", sty.icon75)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__lHyUs)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title79"}
                            data-plasmic-override={overrides.title79}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title79
                            )}
                          >
                            {"Custom Reporting"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item76"}
                            data-plasmic-override={overrides.item76}
                            className={classNames("all", sty.item76)}
                          >
                            <div
                              data-plasmic-name={"left76"}
                              data-plasmic-override={overrides.left76}
                              className={classNames("all", sty.left76)}
                            >
                              <div
                                data-plasmic-name={"icon76"}
                                data-plasmic-override={overrides.icon76}
                                className={classNames("all", sty.icon76)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hUaat)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title80"}
                              data-plasmic-override={overrides.title80}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title80
                              )}
                            >
                              {"Curriculum Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item77"}
                            data-plasmic-override={overrides.item77}
                            className={classNames("all", sty.item77)}
                          >
                            <div
                              data-plasmic-name={"left77"}
                              data-plasmic-override={overrides.left77}
                              className={classNames("all", sty.left77)}
                            >
                              <div
                                data-plasmic-name={"icon77"}
                                data-plasmic-override={overrides.icon77}
                                className={classNames("all", sty.icon77)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__qKcct)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title81"}
                              data-plasmic-override={overrides.title81}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title81
                              )}
                            >
                              {"Certificate & Diploma Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item78"}
                            data-plasmic-override={overrides.item78}
                            className={classNames("all", sty.item78)}
                          >
                            <div
                              data-plasmic-name={"left78"}
                              data-plasmic-override={overrides.left78}
                              className={classNames("all", sty.left78)}
                            >
                              <div
                                data-plasmic-name={"icon78"}
                                data-plasmic-override={overrides.icon78}
                                className={classNames("all", sty.icon78)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___5TAr)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title82"}
                              data-plasmic-override={overrides.title82}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title82
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item79"}
                            data-plasmic-override={overrides.item79}
                            className={classNames("all", sty.item79)}
                          >
                            <div
                              data-plasmic-name={"left79"}
                              data-plasmic-override={overrides.left79}
                              className={classNames("all", sty.left79)}
                            >
                              <div
                                data-plasmic-name={"icon79"}
                                data-plasmic-override={overrides.icon79}
                                className={classNames("all", sty.icon79)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hmMjt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title83"}
                              data-plasmic-override={overrides.title83}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title83
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item80"}
                            data-plasmic-override={overrides.item80}
                            className={classNames("all", sty.item80)}
                          >
                            <div
                              data-plasmic-name={"left80"}
                              data-plasmic-override={overrides.left80}
                              className={classNames("all", sty.left80)}
                            >
                              <div
                                data-plasmic-name={"icon80"}
                                data-plasmic-override={overrides.icon80}
                                className={classNames("all", sty.icon80)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vtuDm)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title84"}
                              data-plasmic-override={overrides.title84}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title84
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item81"}
                            data-plasmic-override={overrides.item81}
                            className={classNames("all", sty.item81)}
                          >
                            <div
                              data-plasmic-name={"left81"}
                              data-plasmic-override={overrides.left81}
                              className={classNames("all", sty.left81)}
                            >
                              <div
                                data-plasmic-name={"icon81"}
                                data-plasmic-override={overrides.icon81}
                                className={classNames("all", sty.icon81)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gudWb)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title85"}
                              data-plasmic-override={overrides.title85}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title85
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item82"}
                            data-plasmic-override={overrides.item82}
                            className={classNames("all", sty.item82)}
                          >
                            <div
                              data-plasmic-name={"left82"}
                              data-plasmic-override={overrides.left82}
                              className={classNames("all", sty.left82)}
                            >
                              <div
                                data-plasmic-name={"icon82"}
                                data-plasmic-override={overrides.icon82}
                                className={classNames("all", sty.icon82)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__a5KC)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title86"}
                              data-plasmic-override={overrides.title86}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title86
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item83"}
                            data-plasmic-override={overrides.item83}
                            className={classNames("all", sty.item83)}
                          >
                            <div
                              data-plasmic-name={"left83"}
                              data-plasmic-override={overrides.left83}
                              className={classNames("all", sty.left83)}
                            >
                              <div
                                data-plasmic-name={"icon83"}
                                data-plasmic-override={overrides.icon83}
                                className={classNames("all", sty.icon83)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__store)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title87"}
                              data-plasmic-override={overrides.title87}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title87
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item84"}
                            data-plasmic-override={overrides.item84}
                            className={classNames("all", sty.item84)}
                          >
                            <div
                              data-plasmic-name={"left84"}
                              data-plasmic-override={overrides.left84}
                              className={classNames("all", sty.left84)}
                            >
                              <div
                                data-plasmic-name={"icon84"}
                                data-plasmic-override={overrides.icon84}
                                className={classNames("all", sty.icon84)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ttBv)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title88"}
                              data-plasmic-override={overrides.title88}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title88
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item85"}
                            data-plasmic-override={overrides.item85}
                            className={classNames("all", sty.item85)}
                          >
                            <div
                              data-plasmic-name={"left85"}
                              data-plasmic-override={overrides.left85}
                              className={classNames("all", sty.left85)}
                            >
                              <div
                                data-plasmic-name={"icon85"}
                                data-plasmic-override={overrides.icon85}
                                className={classNames("all", sty.icon85)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___5N2M)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title89"}
                              data-plasmic-override={overrides.title89}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title89
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item86"}
                            data-plasmic-override={overrides.item86}
                            className={classNames("all", sty.item86)}
                          >
                            <div
                              data-plasmic-name={"left86"}
                              data-plasmic-override={overrides.left86}
                              className={classNames("all", sty.left86)}
                            >
                              <div
                                data-plasmic-name={"icon86"}
                                data-plasmic-override={overrides.icon86}
                                className={classNames("all", sty.icon86)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__h8Fb)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title90"}
                              data-plasmic-override={overrides.title90}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title90
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item87"}
                            data-plasmic-override={overrides.item87}
                            className={classNames("all", sty.item87)}
                          >
                            <div
                              data-plasmic-name={"left87"}
                              data-plasmic-override={overrides.left87}
                              className={classNames("all", sty.left87)}
                            >
                              <div
                                data-plasmic-name={"icon87"}
                                data-plasmic-override={overrides.icon87}
                                className={classNames("all", sty.icon87)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__umu8S)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title91"}
                              data-plasmic-override={overrides.title91}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title91
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item88"}
                            data-plasmic-override={overrides.item88}
                            className={classNames("all", sty.item88)}
                          >
                            <div
                              data-plasmic-name={"left88"}
                              data-plasmic-override={overrides.left88}
                              className={classNames("all", sty.left88)}
                            >
                              <div
                                data-plasmic-name={"icon88"}
                                data-plasmic-override={overrides.icon88}
                                className={classNames("all", sty.icon88)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___9VbOl)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title92"}
                              data-plasmic-override={overrides.title92}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title92
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item89"}
                            data-plasmic-override={overrides.item89}
                            className={classNames("all", sty.item89)}
                          >
                            <div
                              data-plasmic-name={"left89"}
                              data-plasmic-override={overrides.left89}
                              className={classNames("all", sty.left89)}
                            >
                              <div
                                data-plasmic-name={"icon89"}
                                data-plasmic-override={overrides.icon89}
                                className={classNames("all", sty.icon89)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__lGtS)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title93"}
                              data-plasmic-override={overrides.title93}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title93
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item90"}
                            data-plasmic-override={overrides.item90}
                            className={classNames("all", sty.item90)}
                          >
                            <div
                              data-plasmic-name={"left90"}
                              data-plasmic-override={overrides.left90}
                              className={classNames("all", sty.left90)}
                            >
                              <div
                                data-plasmic-name={"icon90"}
                                data-plasmic-override={overrides.icon90}
                                className={classNames("all", sty.icon90)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fWwHs)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title94"}
                              data-plasmic-override={overrides.title94}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title94
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item91"}
                            data-plasmic-override={overrides.item91}
                            className={classNames("all", sty.item91)}
                          >
                            <div
                              data-plasmic-name={"left91"}
                              data-plasmic-override={overrides.left91}
                              className={classNames("all", sty.left91)}
                            >
                              <div
                                data-plasmic-name={"icon91"}
                                data-plasmic-override={overrides.icon91}
                                className={classNames("all", sty.icon91)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hdWru)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title95"}
                              data-plasmic-override={overrides.title95}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title95
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item92"}
                            data-plasmic-override={overrides.item92}
                            className={classNames("all", sty.item92)}
                          >
                            <div
                              data-plasmic-name={"left92"}
                              data-plasmic-override={overrides.left92}
                              className={classNames("all", sty.left92)}
                            >
                              <div
                                data-plasmic-name={"icon92"}
                                data-plasmic-override={overrides.icon92}
                                className={classNames("all", sty.icon92)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__mBgHl)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title96"}
                              data-plasmic-override={overrides.title96}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title96
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item93"}
                            data-plasmic-override={overrides.item93}
                            className={classNames("all", sty.item93)}
                          >
                            <div
                              data-plasmic-name={"left93"}
                              data-plasmic-override={overrides.left93}
                              className={classNames("all", sty.left93)}
                            >
                              <div
                                data-plasmic-name={"icon93"}
                                data-plasmic-override={overrides.icon93}
                                className={classNames("all", sty.icon93)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xCavn)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title97"}
                              data-plasmic-override={overrides.title97}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title97
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item94"}
                            data-plasmic-override={overrides.item94}
                            className={classNames("all", sty.item94)}
                          >
                            <div
                              data-plasmic-name={"left94"}
                              data-plasmic-override={overrides.left94}
                              className={classNames("all", sty.left94)}
                            >
                              <div
                                data-plasmic-name={"icon94"}
                                data-plasmic-override={overrides.icon94}
                                className={classNames("all", sty.icon94)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__o3Rm2)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title98"}
                              data-plasmic-override={overrides.title98}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title98
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item95"}
                            data-plasmic-override={overrides.item95}
                            className={classNames("all", sty.item95)}
                          >
                            <div
                              data-plasmic-name={"left95"}
                              data-plasmic-override={overrides.left95}
                              className={classNames("all", sty.left95)}
                            >
                              <div
                                data-plasmic-name={"icon95"}
                                data-plasmic-override={overrides.icon95}
                                className={classNames("all", sty.icon95)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gKe63)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title99"}
                              data-plasmic-override={overrides.title99}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title99
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item96"}
                            data-plasmic-override={overrides.item96}
                            className={classNames("all", sty.item96)}
                          >
                            <div
                              data-plasmic-name={"left96"}
                              data-plasmic-override={overrides.left96}
                              className={classNames("all", sty.left96)}
                            >
                              <div
                                data-plasmic-name={"icon96"}
                                data-plasmic-override={overrides.icon96}
                                className={classNames("all", sty.icon96)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___8FvxW)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title398"}
                              data-plasmic-override={overrides.title398}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title398
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn12"}
                        data-plasmic-override={overrides.btn12}
                        className={classNames("__wab_instance", sty.btn12)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard13"}
                  data-plasmic-override={overrides.narrowCard13}
                  className={classNames("all", sty.narrowCard13)}
                >
                  <div
                    data-plasmic-name={"header32"}
                    data-plasmic-override={overrides.header32}
                    className={classNames("all", sty.header32)}
                  >
                    <div
                      data-plasmic-name={"title399"}
                      data-plasmic-override={overrides.title399}
                      className={classNames("all", "__wab_text", sty.title399)}
                    >
                      {"Integrations \n& Connectivity"}
                    </div>
                    <Icon98Icon
                      className={classNames("all", sty.svg__gjp9F)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content13"}
                    data-plasmic-override={overrides.content13}
                    className={classNames("all", sty.content13)}
                  >
                    <div
                      data-plasmic-name={"desc13"}
                      data-plasmic-override={overrides.desc13}
                      className={classNames("all", "__wab_text", sty.desc13)}
                    >
                      {
                        "Connect MyEvaluations with the systems your institution already uses."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder13"}
                      data-plasmic-override={overrides.placeholder13}
                      className={classNames("all", sty.placeholder13)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header33"}
                          data-plasmic-override={overrides.header33}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header33
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list5"}
                        data-plasmic-override={overrides.list5}
                        className={classNames("all", sty.list5)}
                      >
                        <div
                          data-plasmic-name={"item385"}
                          data-plasmic-override={overrides.item385}
                          className={classNames("all", sty.item385)}
                        >
                          <div
                            data-plasmic-name={"left385"}
                            data-plasmic-override={overrides.left385}
                            className={classNames("all", sty.left385)}
                          >
                            <div
                              data-plasmic-name={"icon385"}
                              data-plasmic-override={overrides.icon385}
                              className={classNames("all", sty.icon385)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__cgRu5)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title400"}
                            data-plasmic-override={overrides.title400}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title400
                            )}
                          >
                            {"EHR Connectivity"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item386"}
                          data-plasmic-override={overrides.item386}
                          className={classNames("all", sty.item386)}
                        >
                          <div
                            data-plasmic-name={"left386"}
                            data-plasmic-override={overrides.left386}
                            className={classNames("all", sty.left386)}
                          >
                            <div
                              data-plasmic-name={"icon386"}
                              data-plasmic-override={overrides.icon386}
                              className={classNames("all", sty.icon386)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__kz8Kn)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title401"}
                            data-plasmic-override={overrides.title401}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title401
                            )}
                          >
                            {"Clinical Log Integrations"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item387"}
                          data-plasmic-override={overrides.item387}
                          className={classNames("all", sty.item387)}
                        >
                          <div
                            data-plasmic-name={"left387"}
                            data-plasmic-override={overrides.left387}
                            className={classNames("all", sty.left387)}
                          >
                            <div
                              data-plasmic-name={"icon387"}
                              data-plasmic-override={overrides.icon387}
                              className={classNames("all", sty.icon387)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__d0NyM)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title402"}
                            data-plasmic-override={overrides.title402}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title402
                            )}
                          >
                            {"Scheduling Integrations"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item388"}
                          data-plasmic-override={overrides.item388}
                          className={classNames("all", sty.item388)}
                        >
                          <div
                            data-plasmic-name={"left388"}
                            data-plasmic-override={overrides.left388}
                            className={classNames("all", sty.left388)}
                          >
                            <div
                              data-plasmic-name={"icon388"}
                              data-plasmic-override={overrides.icon388}
                              className={classNames("all", sty.icon388)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__huAi)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title403"}
                            data-plasmic-override={overrides.title403}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title403
                            )}
                          >
                            {"ERAS Data Import"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item389"}
                            data-plasmic-override={overrides.item389}
                            className={classNames("all", sty.item389)}
                          >
                            <div
                              data-plasmic-name={"left389"}
                              data-plasmic-override={overrides.left389}
                              className={classNames("all", sty.left389)}
                            >
                              <div
                                data-plasmic-name={"icon389"}
                                data-plasmic-override={overrides.icon389}
                                className={classNames("all", sty.icon389)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__biUe9)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title404"}
                              data-plasmic-override={overrides.title404}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title404
                              )}
                            >
                              {"Certificate & Diploma Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item390"}
                            data-plasmic-override={overrides.item390}
                            className={classNames("all", sty.item390)}
                          >
                            <div
                              data-plasmic-name={"left390"}
                              data-plasmic-override={overrides.left390}
                              className={classNames("all", sty.left390)}
                            >
                              <div
                                data-plasmic-name={"icon390"}
                                data-plasmic-override={overrides.icon390}
                                className={classNames("all", sty.icon390)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__m9N6)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title405"}
                              data-plasmic-override={overrides.title405}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title405
                              )}
                            >
                              {"Burnout Monitoring"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item391"}
                            data-plasmic-override={overrides.item391}
                            className={classNames("all", sty.item391)}
                          >
                            <div
                              data-plasmic-name={"left391"}
                              data-plasmic-override={overrides.left391}
                              className={classNames("all", sty.left391)}
                            >
                              <div
                                data-plasmic-name={"icon391"}
                                data-plasmic-override={overrides.icon391}
                                className={classNames("all", sty.icon391)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xgXxE)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title406"}
                              data-plasmic-override={overrides.title406}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title406
                              )}
                            >
                              {"Demographic Management"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item392"}
                            data-plasmic-override={overrides.item392}
                            className={classNames("all", sty.item392)}
                          >
                            <div
                              data-plasmic-name={"left392"}
                              data-plasmic-override={overrides.left392}
                              className={classNames("all", sty.left392)}
                            >
                              <div
                                data-plasmic-name={"icon392"}
                                data-plasmic-override={overrides.icon392}
                                className={classNames("all", sty.icon392)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vDFyl)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title407"}
                              data-plasmic-override={overrides.title407}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title407
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item393"}
                            data-plasmic-override={overrides.item393}
                            className={classNames("all", sty.item393)}
                          >
                            <div
                              data-plasmic-name={"left393"}
                              data-plasmic-override={overrides.left393}
                              className={classNames("all", sty.left393)}
                            >
                              <div
                                data-plasmic-name={"icon393"}
                                data-plasmic-override={overrides.icon393}
                                className={classNames("all", sty.icon393)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__bl4Z)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title408"}
                              data-plasmic-override={overrides.title408}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title408
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item394"}
                            data-plasmic-override={overrides.item394}
                            className={classNames("all", sty.item394)}
                          >
                            <div
                              data-plasmic-name={"left394"}
                              data-plasmic-override={overrides.left394}
                              className={classNames("all", sty.left394)}
                            >
                              <div
                                data-plasmic-name={"icon394"}
                                data-plasmic-override={overrides.icon394}
                                className={classNames("all", sty.icon394)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__qWt3)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title409"}
                              data-plasmic-override={overrides.title409}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title409
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item395"}
                            data-plasmic-override={overrides.item395}
                            className={classNames("all", sty.item395)}
                          >
                            <div
                              data-plasmic-name={"left395"}
                              data-plasmic-override={overrides.left395}
                              className={classNames("all", sty.left395)}
                            >
                              <div
                                data-plasmic-name={"icon395"}
                                data-plasmic-override={overrides.icon395}
                                className={classNames("all", sty.icon395)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ptwAh)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title410"}
                              data-plasmic-override={overrides.title410}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title410
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item396"}
                            data-plasmic-override={overrides.item396}
                            className={classNames("all", sty.item396)}
                          >
                            <div
                              data-plasmic-name={"left396"}
                              data-plasmic-override={overrides.left396}
                              className={classNames("all", sty.left396)}
                            >
                              <div
                                data-plasmic-name={"icon396"}
                                data-plasmic-override={overrides.icon396}
                                className={classNames("all", sty.icon396)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gDhKr)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title411"}
                              data-plasmic-override={overrides.title411}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title411
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item397"}
                            data-plasmic-override={overrides.item397}
                            className={classNames("all", sty.item397)}
                          >
                            <div
                              data-plasmic-name={"left397"}
                              data-plasmic-override={overrides.left397}
                              className={classNames("all", sty.left397)}
                            >
                              <div
                                data-plasmic-name={"icon397"}
                                data-plasmic-override={overrides.icon397}
                                className={classNames("all", sty.icon397)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jtYvv)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title412"}
                              data-plasmic-override={overrides.title412}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title412
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item398"}
                            data-plasmic-override={overrides.item398}
                            className={classNames("all", sty.item398)}
                          >
                            <div
                              data-plasmic-name={"left398"}
                              data-plasmic-override={overrides.left398}
                              className={classNames("all", sty.left398)}
                            >
                              <div
                                data-plasmic-name={"icon398"}
                                data-plasmic-override={overrides.icon398}
                                className={classNames("all", sty.icon398)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__tRpFm)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title413"}
                              data-plasmic-override={overrides.title413}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title413
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item399"}
                            data-plasmic-override={overrides.item399}
                            className={classNames("all", sty.item399)}
                          >
                            <div
                              data-plasmic-name={"left399"}
                              data-plasmic-override={overrides.left399}
                              className={classNames("all", sty.left399)}
                            >
                              <div
                                data-plasmic-name={"icon399"}
                                data-plasmic-override={overrides.icon399}
                                className={classNames("all", sty.icon399)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__eegUt)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title414"}
                              data-plasmic-override={overrides.title414}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title414
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item400"}
                            data-plasmic-override={overrides.item400}
                            className={classNames("all", sty.item400)}
                          >
                            <div
                              data-plasmic-name={"left400"}
                              data-plasmic-override={overrides.left400}
                              className={classNames("all", sty.left400)}
                            >
                              <div
                                data-plasmic-name={"icon400"}
                                data-plasmic-override={overrides.icon400}
                                className={classNames("all", sty.icon400)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jwLaj)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title415"}
                              data-plasmic-override={overrides.title415}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title415
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item401"}
                            data-plasmic-override={overrides.item401}
                            className={classNames("all", sty.item401)}
                          >
                            <div
                              data-plasmic-name={"left401"}
                              data-plasmic-override={overrides.left401}
                              className={classNames("all", sty.left401)}
                            >
                              <div
                                data-plasmic-name={"icon401"}
                                data-plasmic-override={overrides.icon401}
                                className={classNames("all", sty.icon401)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___13MSr)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title416"}
                              data-plasmic-override={overrides.title416}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title416
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item402"}
                            data-plasmic-override={overrides.item402}
                            className={classNames("all", sty.item402)}
                          >
                            <div
                              data-plasmic-name={"left402"}
                              data-plasmic-override={overrides.left402}
                              className={classNames("all", sty.left402)}
                            >
                              <div
                                data-plasmic-name={"icon402"}
                                data-plasmic-override={overrides.icon402}
                                className={classNames("all", sty.icon402)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___7D4Mf)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title417"}
                              data-plasmic-override={overrides.title417}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title417
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item403"}
                            data-plasmic-override={overrides.item403}
                            className={classNames("all", sty.item403)}
                          >
                            <div
                              data-plasmic-name={"left403"}
                              data-plasmic-override={overrides.left403}
                              className={classNames("all", sty.left403)}
                            >
                              <div
                                data-plasmic-name={"icon403"}
                                data-plasmic-override={overrides.icon403}
                                className={classNames("all", sty.icon403)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___6Feid)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title418"}
                              data-plasmic-override={overrides.title418}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title418
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item404"}
                            data-plasmic-override={overrides.item404}
                            className={classNames("all", sty.item404)}
                          >
                            <div
                              data-plasmic-name={"left404"}
                              data-plasmic-override={overrides.left404}
                              className={classNames("all", sty.left404)}
                            >
                              <div
                                data-plasmic-name={"icon404"}
                                data-plasmic-override={overrides.icon404}
                                className={classNames("all", sty.icon404)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ci2Cr)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title419"}
                              data-plasmic-override={overrides.title419}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title419
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item405"}
                            data-plasmic-override={overrides.item405}
                            className={classNames("all", sty.item405)}
                          >
                            <div
                              data-plasmic-name={"left405"}
                              data-plasmic-override={overrides.left405}
                              className={classNames("all", sty.left405)}
                            >
                              <div
                                data-plasmic-name={"icon405"}
                                data-plasmic-override={overrides.icon405}
                                className={classNames("all", sty.icon405)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__b3K0P)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title420"}
                              data-plasmic-override={overrides.title420}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title420
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item406"}
                            data-plasmic-override={overrides.item406}
                            className={classNames("all", sty.item406)}
                          >
                            <div
                              data-plasmic-name={"left406"}
                              data-plasmic-override={overrides.left406}
                              className={classNames("all", sty.left406)}
                            >
                              <div
                                data-plasmic-name={"icon406"}
                                data-plasmic-override={overrides.icon406}
                                className={classNames("all", sty.icon406)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___0Za7)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title421"}
                              data-plasmic-override={overrides.title421}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title421
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item407"}
                            data-plasmic-override={overrides.item407}
                            className={classNames("all", sty.item407)}
                          >
                            <div
                              data-plasmic-name={"left407"}
                              data-plasmic-override={overrides.left407}
                              className={classNames("all", sty.left407)}
                            >
                              <div
                                data-plasmic-name={"icon407"}
                                data-plasmic-override={overrides.icon407}
                                className={classNames("all", sty.icon407)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__p2KA)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title422"}
                              data-plasmic-override={overrides.title422}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title422
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item408"}
                            data-plasmic-override={overrides.item408}
                            className={classNames("all", sty.item408)}
                          >
                            <div
                              data-plasmic-name={"left408"}
                              data-plasmic-override={overrides.left408}
                              className={classNames("all", sty.left408)}
                            >
                              <div
                                data-plasmic-name={"icon408"}
                                data-plasmic-override={overrides.icon408}
                                className={classNames("all", sty.icon408)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__bnqhL)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title423"}
                              data-plasmic-override={overrides.title423}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title423
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn13"}
                        data-plasmic-override={overrides.btn13}
                        className={classNames("__wab_instance", sty.btn13)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard14"}
                  data-plasmic-override={overrides.narrowCard14}
                  className={classNames("all", sty.narrowCard14)}
                >
                  <div
                    data-plasmic-name={"header34"}
                    data-plasmic-override={overrides.header34}
                    className={classNames("all", sty.header34)}
                  >
                    <div
                      data-plasmic-name={"title424"}
                      data-plasmic-override={overrides.title424}
                      className={classNames("all", "__wab_text", sty.title424)}
                    >
                      {"Graduate \nMedical Education"}
                    </div>
                    <Icon97Icon
                      className={classNames("all", sty.svg__eg4Xl)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content14"}
                    data-plasmic-override={overrides.content14}
                    className={classNames("all", sty.content14)}
                  >
                    <div
                      data-plasmic-name={"desc14"}
                      data-plasmic-override={overrides.desc14}
                      className={classNames("all", "__wab_text", sty.desc14)}
                    >
                      {
                        "Purpose-built capabilities supporting residency and fellowship education."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder14"}
                      data-plasmic-override={overrides.placeholder14}
                      className={classNames("all", sty.placeholder14)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header35"}
                          data-plasmic-override={overrides.header35}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header35
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list25"}
                        data-plasmic-override={overrides.list25}
                        className={classNames("all", sty.list25)}
                      >
                        <div
                          data-plasmic-name={"item409"}
                          data-plasmic-override={overrides.item409}
                          className={classNames("all", sty.item409)}
                        >
                          <div
                            data-plasmic-name={"left409"}
                            data-plasmic-override={overrides.left409}
                            className={classNames("all", sty.left409)}
                          >
                            <div
                              data-plasmic-name={"icon409"}
                              data-plasmic-override={overrides.icon409}
                              className={classNames("all", sty.icon409)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__tmYIo)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title425"}
                            data-plasmic-override={overrides.title425}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title425
                            )}
                          >
                            {"Annual Program Evaluation (APE)"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item410"}
                          data-plasmic-override={overrides.item410}
                          className={classNames("all", sty.item410)}
                        >
                          <div
                            data-plasmic-name={"left410"}
                            data-plasmic-override={overrides.left410}
                            className={classNames("all", sty.left410)}
                          >
                            <div
                              data-plasmic-name={"icon410"}
                              data-plasmic-override={overrides.icon410}
                              className={classNames("all", sty.icon410)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__tzFpX)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title426"}
                            data-plasmic-override={overrides.title426}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title426
                            )}
                          >
                            {"Common Program Requirements"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item411"}
                          data-plasmic-override={overrides.item411}
                          className={classNames("all", sty.item411)}
                        >
                          <div
                            data-plasmic-name={"left411"}
                            data-plasmic-override={overrides.left411}
                            className={classNames("all", sty.left411)}
                          >
                            <div
                              data-plasmic-name={"icon411"}
                              data-plasmic-override={overrides.icon411}
                              className={classNames("all", sty.icon411)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__qkabf)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title427"}
                            data-plasmic-override={overrides.title427}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title427
                            )}
                          >
                            {"Institutional Requirements"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item412"}
                          data-plasmic-override={overrides.item412}
                          className={classNames("all", sty.item412)}
                        >
                          <div
                            data-plasmic-name={"left412"}
                            data-plasmic-override={overrides.left412}
                            className={classNames("all", sty.left412)}
                          >
                            <div
                              data-plasmic-name={"icon412"}
                              data-plasmic-override={overrides.icon412}
                              className={classNames("all", sty.icon412)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__vf2Zh)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title428"}
                            data-plasmic-override={overrides.title428}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title428
                            )}
                          >
                            {"Action Plans & Notifications"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item413"}
                          data-plasmic-override={overrides.item413}
                          className={classNames("all", sty.item413)}
                        >
                          <div
                            data-plasmic-name={"left413"}
                            data-plasmic-override={overrides.left413}
                            className={classNames("all", sty.left413)}
                          >
                            <div
                              data-plasmic-name={"icon413"}
                              data-plasmic-override={overrides.icon413}
                              className={classNames("all", sty.icon413)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__bN1E)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title429"}
                            data-plasmic-override={overrides.title429}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title429
                            )}
                          >
                            {"Procedure Logging"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item414"}
                          data-plasmic-override={overrides.item414}
                          className={classNames("all", sty.item414)}
                        >
                          <div
                            data-plasmic-name={"left414"}
                            data-plasmic-override={overrides.left414}
                            className={classNames("all", sty.left414)}
                          >
                            <div
                              data-plasmic-name={"icon414"}
                              data-plasmic-override={overrides.icon414}
                              className={classNames("all", sty.icon414)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__bc4Ih)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title430"}
                            data-plasmic-override={overrides.title430}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title430
                            )}
                          >
                            {"Patient Logging"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item415"}
                          data-plasmic-override={overrides.item415}
                          className={classNames("all", sty.item415)}
                        >
                          <div
                            data-plasmic-name={"left415"}
                            data-plasmic-override={overrides.left415}
                            className={classNames("all", sty.left415)}
                          >
                            <div
                              data-plasmic-name={"icon415"}
                              data-plasmic-override={overrides.icon415}
                              className={classNames("all", sty.icon415)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__e4LYq)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title431"}
                            data-plasmic-override={overrides.title431}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title431
                            )}
                          >
                            {"Centralized Procedure Reporting"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item416"}
                            data-plasmic-override={overrides.item416}
                            className={classNames("all", sty.item416)}
                          >
                            <div
                              data-plasmic-name={"left416"}
                              data-plasmic-override={overrides.left416}
                              className={classNames("all", sty.left416)}
                            >
                              <div
                                data-plasmic-name={"icon416"}
                                data-plasmic-override={overrides.icon416}
                                className={classNames("all", sty.icon416)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__neqFj)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title432"}
                              data-plasmic-override={overrides.title432}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title432
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item417"}
                            data-plasmic-override={overrides.item417}
                            className={classNames("all", sty.item417)}
                          >
                            <div
                              data-plasmic-name={"left417"}
                              data-plasmic-override={overrides.left417}
                              className={classNames("all", sty.left417)}
                            >
                              <div
                                data-plasmic-name={"icon417"}
                                data-plasmic-override={overrides.icon417}
                                className={classNames("all", sty.icon417)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wvoks)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title433"}
                              data-plasmic-override={overrides.title433}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title433
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item418"}
                            data-plasmic-override={overrides.item418}
                            className={classNames("all", sty.item418)}
                          >
                            <div
                              data-plasmic-name={"left418"}
                              data-plasmic-override={overrides.left418}
                              className={classNames("all", sty.left418)}
                            >
                              <div
                                data-plasmic-name={"icon418"}
                                data-plasmic-override={overrides.icon418}
                                className={classNames("all", sty.icon418)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ozObY)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title434"}
                              data-plasmic-override={overrides.title434}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title434
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item419"}
                            data-plasmic-override={overrides.item419}
                            className={classNames("all", sty.item419)}
                          >
                            <div
                              data-plasmic-name={"left419"}
                              data-plasmic-override={overrides.left419}
                              className={classNames("all", sty.left419)}
                            >
                              <div
                                data-plasmic-name={"icon419"}
                                data-plasmic-override={overrides.icon419}
                                className={classNames("all", sty.icon419)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__mFxjX)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title435"}
                              data-plasmic-override={overrides.title435}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title435
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item420"}
                            data-plasmic-override={overrides.item420}
                            className={classNames("all", sty.item420)}
                          >
                            <div
                              data-plasmic-name={"left420"}
                              data-plasmic-override={overrides.left420}
                              className={classNames("all", sty.left420)}
                            >
                              <div
                                data-plasmic-name={"icon420"}
                                data-plasmic-override={overrides.icon420}
                                className={classNames("all", sty.icon420)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___3EyOk)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title436"}
                              data-plasmic-override={overrides.title436}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title436
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item421"}
                            data-plasmic-override={overrides.item421}
                            className={classNames("all", sty.item421)}
                          >
                            <div
                              data-plasmic-name={"left421"}
                              data-plasmic-override={overrides.left421}
                              className={classNames("all", sty.left421)}
                            >
                              <div
                                data-plasmic-name={"icon421"}
                                data-plasmic-override={overrides.icon421}
                                className={classNames("all", sty.icon421)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__sIkFs)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title437"}
                              data-plasmic-override={overrides.title437}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title437
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item422"}
                            data-plasmic-override={overrides.item422}
                            className={classNames("all", sty.item422)}
                          >
                            <div
                              data-plasmic-name={"left422"}
                              data-plasmic-override={overrides.left422}
                              className={classNames("all", sty.left422)}
                            >
                              <div
                                data-plasmic-name={"icon422"}
                                data-plasmic-override={overrides.icon422}
                                className={classNames("all", sty.icon422)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__p63Ao)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title438"}
                              data-plasmic-override={overrides.title438}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title438
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item423"}
                            data-plasmic-override={overrides.item423}
                            className={classNames("all", sty.item423)}
                          >
                            <div
                              data-plasmic-name={"left423"}
                              data-plasmic-override={overrides.left423}
                              className={classNames("all", sty.left423)}
                            >
                              <div
                                data-plasmic-name={"icon423"}
                                data-plasmic-override={overrides.icon423}
                                className={classNames("all", sty.icon423)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__i2IhC)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title439"}
                              data-plasmic-override={overrides.title439}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title439
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item424"}
                            data-plasmic-override={overrides.item424}
                            className={classNames("all", sty.item424)}
                          >
                            <div
                              data-plasmic-name={"left424"}
                              data-plasmic-override={overrides.left424}
                              className={classNames("all", sty.left424)}
                            >
                              <div
                                data-plasmic-name={"icon424"}
                                data-plasmic-override={overrides.icon424}
                                className={classNames("all", sty.icon424)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___3Jl0M)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title440"}
                              data-plasmic-override={overrides.title440}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title440
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item425"}
                            data-plasmic-override={overrides.item425}
                            className={classNames("all", sty.item425)}
                          >
                            <div
                              data-plasmic-name={"left425"}
                              data-plasmic-override={overrides.left425}
                              className={classNames("all", sty.left425)}
                            >
                              <div
                                data-plasmic-name={"icon425"}
                                data-plasmic-override={overrides.icon425}
                                className={classNames("all", sty.icon425)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__hsHwb)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title441"}
                              data-plasmic-override={overrides.title441}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title441
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item426"}
                            data-plasmic-override={overrides.item426}
                            className={classNames("all", sty.item426)}
                          >
                            <div
                              data-plasmic-name={"left426"}
                              data-plasmic-override={overrides.left426}
                              className={classNames("all", sty.left426)}
                            >
                              <div
                                data-plasmic-name={"icon426"}
                                data-plasmic-override={overrides.icon426}
                                className={classNames("all", sty.icon426)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wTfnD)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title442"}
                              data-plasmic-override={overrides.title442}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title442
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item427"}
                            data-plasmic-override={overrides.item427}
                            className={classNames("all", sty.item427)}
                          >
                            <div
                              data-plasmic-name={"left427"}
                              data-plasmic-override={overrides.left427}
                              className={classNames("all", sty.left427)}
                            >
                              <div
                                data-plasmic-name={"icon427"}
                                data-plasmic-override={overrides.icon427}
                                className={classNames("all", sty.icon427)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__tTEaE)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title443"}
                              data-plasmic-override={overrides.title443}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title443
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item428"}
                            data-plasmic-override={overrides.item428}
                            className={classNames("all", sty.item428)}
                          >
                            <div
                              data-plasmic-name={"left428"}
                              data-plasmic-override={overrides.left428}
                              className={classNames("all", sty.left428)}
                            >
                              <div
                                data-plasmic-name={"icon428"}
                                data-plasmic-override={overrides.icon428}
                                className={classNames("all", sty.icon428)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__qKy1J)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title444"}
                              data-plasmic-override={overrides.title444}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title444
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item429"}
                            data-plasmic-override={overrides.item429}
                            className={classNames("all", sty.item429)}
                          >
                            <div
                              data-plasmic-name={"left429"}
                              data-plasmic-override={overrides.left429}
                              className={classNames("all", sty.left429)}
                            >
                              <div
                                data-plasmic-name={"icon429"}
                                data-plasmic-override={overrides.icon429}
                                className={classNames("all", sty.icon429)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jdw79)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title445"}
                              data-plasmic-override={overrides.title445}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title445
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item430"}
                            data-plasmic-override={overrides.item430}
                            className={classNames("all", sty.item430)}
                          >
                            <div
                              data-plasmic-name={"left430"}
                              data-plasmic-override={overrides.left430}
                              className={classNames("all", sty.left430)}
                            >
                              <div
                                data-plasmic-name={"icon430"}
                                data-plasmic-override={overrides.icon430}
                                className={classNames("all", sty.icon430)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kbEtk)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title446"}
                              data-plasmic-override={overrides.title446}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title446
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item431"}
                            data-plasmic-override={overrides.item431}
                            className={classNames("all", sty.item431)}
                          >
                            <div
                              data-plasmic-name={"left431"}
                              data-plasmic-override={overrides.left431}
                              className={classNames("all", sty.left431)}
                            >
                              <div
                                data-plasmic-name={"icon431"}
                                data-plasmic-override={overrides.icon431}
                                className={classNames("all", sty.icon431)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__tObB8)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title447"}
                              data-plasmic-override={overrides.title447}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title447
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item432"}
                            data-plasmic-override={overrides.item432}
                            className={classNames("all", sty.item432)}
                          >
                            <div
                              data-plasmic-name={"left432"}
                              data-plasmic-override={overrides.left432}
                              className={classNames("all", sty.left432)}
                            >
                              <div
                                data-plasmic-name={"icon432"}
                                data-plasmic-override={overrides.icon432}
                                className={classNames("all", sty.icon432)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___8R5L0)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title448"}
                              data-plasmic-override={overrides.title448}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title448
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn14"}
                        data-plasmic-override={overrides.btn14}
                        className={classNames("__wab_instance", sty.btn14)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard15"}
                  data-plasmic-override={overrides.narrowCard15}
                  className={classNames("all", sty.narrowCard15)}
                >
                  <div
                    data-plasmic-name={"header36"}
                    data-plasmic-override={overrides.header36}
                    className={classNames("all", sty.header36)}
                  >
                    <div
                      data-plasmic-name={"title449"}
                      data-plasmic-override={overrides.title449}
                      className={classNames("all", "__wab_text", sty.title449)}
                    >
                      {"Physician \nAssistant Education"}
                    </div>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__f0YeP)}
                      displayHeight={"32px"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"32px"}
                      loader={"plasmic"}
                      loading={"lazy"}
                      src={{
                        src: "https://site-assets.plasmic.app/d6f7f0eca9cbc289d86cbd47375ec4b6.svg",
                        fullWidth: 32,
                        fullHeight: 32
                      }}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content15"}
                    data-plasmic-override={overrides.content15}
                    className={classNames("all", sty.content15)}
                  >
                    <div
                      data-plasmic-name={"desc15"}
                      data-plasmic-override={overrides.desc15}
                      className={classNames("all", "__wab_text", sty.desc15)}
                    >
                      {
                        "Designed to support competency-based Physician Assistant education."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder15"}
                      data-plasmic-override={overrides.placeholder15}
                      className={classNames("all", sty.placeholder15)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header37"}
                          data-plasmic-override={overrides.header37}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header37
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list26"}
                        data-plasmic-override={overrides.list26}
                        className={classNames("all", sty.list26)}
                      >
                        <div
                          data-plasmic-name={"item433"}
                          data-plasmic-override={overrides.item433}
                          className={classNames("all", sty.item433)}
                        >
                          <div
                            data-plasmic-name={"left433"}
                            data-plasmic-override={overrides.left433}
                            className={classNames("all", sty.left433)}
                          >
                            <div
                              data-plasmic-name={"icon433"}
                              data-plasmic-override={overrides.icon433}
                              className={classNames("all", sty.icon433)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__uKbq)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title450"}
                            data-plasmic-override={overrides.title450}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title450
                            )}
                          >
                            {"Curriculum Management"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item434"}
                          data-plasmic-override={overrides.item434}
                          className={classNames("all", sty.item434)}
                        >
                          <div
                            data-plasmic-name={"left434"}
                            data-plasmic-override={overrides.left434}
                            className={classNames("all", sty.left434)}
                          >
                            <div
                              data-plasmic-name={"icon434"}
                              data-plasmic-override={overrides.icon434}
                              className={classNames("all", sty.icon434)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___3NyJq)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title451"}
                            data-plasmic-override={overrides.title451}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title451
                            )}
                          >
                            {"Procedure Logging"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item435"}
                          data-plasmic-override={overrides.item435}
                          className={classNames("all", sty.item435)}
                        >
                          <div
                            data-plasmic-name={"left435"}
                            data-plasmic-override={overrides.left435}
                            className={classNames("all", sty.left435)}
                          >
                            <div
                              data-plasmic-name={"icon435"}
                              data-plasmic-override={overrides.icon435}
                              className={classNames("all", sty.icon435)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__aqNOw)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title452"}
                            data-plasmic-override={overrides.title452}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title452
                            )}
                          >
                            {"Patient Logging"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item436"}
                          data-plasmic-override={overrides.item436}
                          className={classNames("all", sty.item436)}
                        >
                          <div
                            data-plasmic-name={"left436"}
                            data-plasmic-override={overrides.left436}
                            className={classNames("all", sty.left436)}
                          >
                            <div
                              data-plasmic-name={"icon436"}
                              data-plasmic-override={overrides.icon436}
                              className={classNames("all", sty.icon436)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__fDFx)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title453"}
                            data-plasmic-override={overrides.title453}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title453
                            )}
                          >
                            {"Learning Assignments"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item437"}
                          data-plasmic-override={overrides.item437}
                          className={classNames("all", sty.item437)}
                        >
                          <div
                            data-plasmic-name={"left437"}
                            data-plasmic-override={overrides.left437}
                            className={classNames("all", sty.left437)}
                          >
                            <div
                              data-plasmic-name={"icon437"}
                              data-plasmic-override={overrides.icon437}
                              className={classNames("all", sty.icon437)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__a4FO)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title454"}
                            data-plasmic-override={overrides.title454}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title454
                            )}
                          >
                            {"MyQuiz\u2122"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item438"}
                          data-plasmic-override={overrides.item438}
                          className={classNames("all", sty.item438)}
                        >
                          <div
                            data-plasmic-name={"left438"}
                            data-plasmic-override={overrides.left438}
                            className={classNames("all", sty.left438)}
                          >
                            <div
                              data-plasmic-name={"icon438"}
                              data-plasmic-override={overrides.icon438}
                              className={classNames("all", sty.icon438)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__f2C9Z)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title455"}
                            data-plasmic-override={overrides.title455}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title455
                            )}
                          >
                            {"Performance Dashboard"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item439"}
                            data-plasmic-override={overrides.item439}
                            className={classNames("all", sty.item439)}
                          >
                            <div
                              data-plasmic-name={"left439"}
                              data-plasmic-override={overrides.left439}
                              className={classNames("all", sty.left439)}
                            >
                              <div
                                data-plasmic-name={"icon439"}
                                data-plasmic-override={overrides.icon439}
                                className={classNames("all", sty.icon439)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yy6Xp)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title456"}
                              data-plasmic-override={overrides.title456}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title456
                              )}
                            >
                              {"Centralized Procedure Reporting"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item440"}
                            data-plasmic-override={overrides.item440}
                            className={classNames("all", sty.item440)}
                          >
                            <div
                              data-plasmic-name={"left440"}
                              data-plasmic-override={overrides.left440}
                              className={classNames("all", sty.left440)}
                            >
                              <div
                                data-plasmic-name={"icon440"}
                                data-plasmic-override={overrides.icon440}
                                className={classNames("all", sty.icon440)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xXyau)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title457"}
                              data-plasmic-override={overrides.title457}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title457
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item441"}
                            data-plasmic-override={overrides.item441}
                            className={classNames("all", sty.item441)}
                          >
                            <div
                              data-plasmic-name={"left441"}
                              data-plasmic-override={overrides.left441}
                              className={classNames("all", sty.left441)}
                            >
                              <div
                                data-plasmic-name={"icon441"}
                                data-plasmic-override={overrides.icon441}
                                className={classNames("all", sty.icon441)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__l3Ck)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title458"}
                              data-plasmic-override={overrides.title458}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title458
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item442"}
                            data-plasmic-override={overrides.item442}
                            className={classNames("all", sty.item442)}
                          >
                            <div
                              data-plasmic-name={"left442"}
                              data-plasmic-override={overrides.left442}
                              className={classNames("all", sty.left442)}
                            >
                              <div
                                data-plasmic-name={"icon442"}
                                data-plasmic-override={overrides.icon442}
                                className={classNames("all", sty.icon442)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__pas97)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title459"}
                              data-plasmic-override={overrides.title459}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title459
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item443"}
                            data-plasmic-override={overrides.item443}
                            className={classNames("all", sty.item443)}
                          >
                            <div
                              data-plasmic-name={"left443"}
                              data-plasmic-override={overrides.left443}
                              className={classNames("all", sty.left443)}
                            >
                              <div
                                data-plasmic-name={"icon443"}
                                data-plasmic-override={overrides.icon443}
                                className={classNames("all", sty.icon443)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___7S8Ut)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title460"}
                              data-plasmic-override={overrides.title460}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title460
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item444"}
                            data-plasmic-override={overrides.item444}
                            className={classNames("all", sty.item444)}
                          >
                            <div
                              data-plasmic-name={"left444"}
                              data-plasmic-override={overrides.left444}
                              className={classNames("all", sty.left444)}
                            >
                              <div
                                data-plasmic-name={"icon444"}
                                data-plasmic-override={overrides.icon444}
                                className={classNames("all", sty.icon444)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dflc)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title461"}
                              data-plasmic-override={overrides.title461}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title461
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item445"}
                            data-plasmic-override={overrides.item445}
                            className={classNames("all", sty.item445)}
                          >
                            <div
                              data-plasmic-name={"left445"}
                              data-plasmic-override={overrides.left445}
                              className={classNames("all", sty.left445)}
                            >
                              <div
                                data-plasmic-name={"icon445"}
                                data-plasmic-override={overrides.icon445}
                                className={classNames("all", sty.icon445)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fcimx)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title462"}
                              data-plasmic-override={overrides.title462}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title462
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item446"}
                            data-plasmic-override={overrides.item446}
                            className={classNames("all", sty.item446)}
                          >
                            <div
                              data-plasmic-name={"left446"}
                              data-plasmic-override={overrides.left446}
                              className={classNames("all", sty.left446)}
                            >
                              <div
                                data-plasmic-name={"icon446"}
                                data-plasmic-override={overrides.icon446}
                                className={classNames("all", sty.icon446)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__rEr2J)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title463"}
                              data-plasmic-override={overrides.title463}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title463
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item447"}
                            data-plasmic-override={overrides.item447}
                            className={classNames("all", sty.item447)}
                          >
                            <div
                              data-plasmic-name={"left447"}
                              data-plasmic-override={overrides.left447}
                              className={classNames("all", sty.left447)}
                            >
                              <div
                                data-plasmic-name={"icon447"}
                                data-plasmic-override={overrides.icon447}
                                className={classNames("all", sty.icon447)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gtsJu)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title464"}
                              data-plasmic-override={overrides.title464}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title464
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item448"}
                            data-plasmic-override={overrides.item448}
                            className={classNames("all", sty.item448)}
                          >
                            <div
                              data-plasmic-name={"left448"}
                              data-plasmic-override={overrides.left448}
                              className={classNames("all", sty.left448)}
                            >
                              <div
                                data-plasmic-name={"icon448"}
                                data-plasmic-override={overrides.icon448}
                                className={classNames("all", sty.icon448)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__fRKpB)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title465"}
                              data-plasmic-override={overrides.title465}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title465
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item449"}
                            data-plasmic-override={overrides.item449}
                            className={classNames("all", sty.item449)}
                          >
                            <div
                              data-plasmic-name={"left449"}
                              data-plasmic-override={overrides.left449}
                              className={classNames("all", sty.left449)}
                            >
                              <div
                                data-plasmic-name={"icon449"}
                                data-plasmic-override={overrides.icon449}
                                className={classNames("all", sty.icon449)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__s0Qbc)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title466"}
                              data-plasmic-override={overrides.title466}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title466
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item450"}
                            data-plasmic-override={overrides.item450}
                            className={classNames("all", sty.item450)}
                          >
                            <div
                              data-plasmic-name={"left450"}
                              data-plasmic-override={overrides.left450}
                              className={classNames("all", sty.left450)}
                            >
                              <div
                                data-plasmic-name={"icon450"}
                                data-plasmic-override={overrides.icon450}
                                className={classNames("all", sty.icon450)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__p9A3S)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title467"}
                              data-plasmic-override={overrides.title467}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title467
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item451"}
                            data-plasmic-override={overrides.item451}
                            className={classNames("all", sty.item451)}
                          >
                            <div
                              data-plasmic-name={"left451"}
                              data-plasmic-override={overrides.left451}
                              className={classNames("all", sty.left451)}
                            >
                              <div
                                data-plasmic-name={"icon451"}
                                data-plasmic-override={overrides.icon451}
                                className={classNames("all", sty.icon451)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___0TFav)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title468"}
                              data-plasmic-override={overrides.title468}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title468
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item452"}
                            data-plasmic-override={overrides.item452}
                            className={classNames("all", sty.item452)}
                          >
                            <div
                              data-plasmic-name={"left452"}
                              data-plasmic-override={overrides.left452}
                              className={classNames("all", sty.left452)}
                            >
                              <div
                                data-plasmic-name={"icon452"}
                                data-plasmic-override={overrides.icon452}
                                className={classNames("all", sty.icon452)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__gptns)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title469"}
                              data-plasmic-override={overrides.title469}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title469
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item453"}
                            data-plasmic-override={overrides.item453}
                            className={classNames("all", sty.item453)}
                          >
                            <div
                              data-plasmic-name={"left453"}
                              data-plasmic-override={overrides.left453}
                              className={classNames("all", sty.left453)}
                            >
                              <div
                                data-plasmic-name={"icon453"}
                                data-plasmic-override={overrides.icon453}
                                className={classNames("all", sty.icon453)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__pcQhj)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title470"}
                              data-plasmic-override={overrides.title470}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title470
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item454"}
                            data-plasmic-override={overrides.item454}
                            className={classNames("all", sty.item454)}
                          >
                            <div
                              data-plasmic-name={"left454"}
                              data-plasmic-override={overrides.left454}
                              className={classNames("all", sty.left454)}
                            >
                              <div
                                data-plasmic-name={"icon454"}
                                data-plasmic-override={overrides.icon454}
                                className={classNames("all", sty.icon454)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vZ8Xb)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title471"}
                              data-plasmic-override={overrides.title471}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title471
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item455"}
                            data-plasmic-override={overrides.item455}
                            className={classNames("all", sty.item455)}
                          >
                            <div
                              data-plasmic-name={"left455"}
                              data-plasmic-override={overrides.left455}
                              className={classNames("all", sty.left455)}
                            >
                              <div
                                data-plasmic-name={"icon455"}
                                data-plasmic-override={overrides.icon455}
                                className={classNames("all", sty.icon455)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__iwbw1)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title472"}
                              data-plasmic-override={overrides.title472}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title472
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item456"}
                            data-plasmic-override={overrides.item456}
                            className={classNames("all", sty.item456)}
                          >
                            <div
                              data-plasmic-name={"left456"}
                              data-plasmic-override={overrides.left456}
                              className={classNames("all", sty.left456)}
                            >
                              <div
                                data-plasmic-name={"icon456"}
                                data-plasmic-override={overrides.icon456}
                                className={classNames("all", sty.icon456)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__arYhU)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title473"}
                              data-plasmic-override={overrides.title473}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title473
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn15"}
                        data-plasmic-override={overrides.btn15}
                        className={classNames("__wab_instance", sty.btn15)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
                <div
                  data-plasmic-name={"narrowCard16"}
                  data-plasmic-override={overrides.narrowCard16}
                  className={classNames("all", sty.narrowCard16)}
                >
                  <div
                    data-plasmic-name={"header38"}
                    data-plasmic-override={overrides.header38}
                    className={classNames("all", sty.header38)}
                  >
                    <div
                      data-plasmic-name={"title474"}
                      data-plasmic-override={overrides.title474}
                      className={classNames("all", "__wab_text", sty.title474)}
                    >
                      {"Nursing Education"}
                    </div>
                    <Icon100Icon
                      className={classNames("all", sty.svg__nn2Zr)}
                      role={"img"}
                    />
                  </div>
                  <div
                    data-plasmic-name={"content16"}
                    data-plasmic-override={overrides.content16}
                    className={classNames("all", sty.content16)}
                  >
                    <div
                      data-plasmic-name={"desc16"}
                      data-plasmic-override={overrides.desc16}
                      className={classNames("all", "__wab_text", sty.desc16)}
                    >
                      {
                        "Specialized tools supporting nursing education and clinical competency."
                      }
                    </div>
                    <div
                      data-plasmic-name={"placeholder16"}
                      data-plasmic-override={overrides.placeholder16}
                      className={classNames("all", sty.placeholder16)}
                    >
                      {false ? (
                        <div
                          data-plasmic-name={"header39"}
                          data-plasmic-override={overrides.header39}
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.header39
                          )}
                        >
                          {"Title"}
                        </div>
                      ) : null}
                      <div
                        data-plasmic-name={"list27"}
                        data-plasmic-override={overrides.list27}
                        className={classNames("all", sty.list27)}
                      >
                        <div
                          data-plasmic-name={"item457"}
                          data-plasmic-override={overrides.item457}
                          className={classNames("all", sty.item457)}
                        >
                          <div
                            data-plasmic-name={"left457"}
                            data-plasmic-override={overrides.left457}
                            className={classNames("all", sty.left457)}
                          >
                            <div
                              data-plasmic-name={"icon457"}
                              data-plasmic-override={overrides.icon457}
                              className={classNames("all", sty.icon457)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__g0W1C)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title475"}
                            data-plasmic-override={overrides.title475}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title475
                            )}
                          >
                            {"Clinical Activity Logger"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item458"}
                          data-plasmic-override={overrides.item458}
                          className={classNames("all", sty.item458)}
                        >
                          <div
                            data-plasmic-name={"left458"}
                            data-plasmic-override={overrides.left458}
                            className={classNames("all", sty.left458)}
                          >
                            <div
                              data-plasmic-name={"icon458"}
                              data-plasmic-override={overrides.icon458}
                              className={classNames("all", sty.icon458)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__lWuaT)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title476"}
                            data-plasmic-override={overrides.title476}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title476
                            )}
                          >
                            {"Return Demonstration Management"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item459"}
                          data-plasmic-override={overrides.item459}
                          className={classNames("all", sty.item459)}
                        >
                          <div
                            data-plasmic-name={"left459"}
                            data-plasmic-override={overrides.left459}
                            className={classNames("all", sty.left459)}
                          >
                            <div
                              data-plasmic-name={"icon459"}
                              data-plasmic-override={overrides.icon459}
                              className={classNames("all", sty.icon459)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg___6DEeF)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title477"}
                            data-plasmic-override={overrides.title477}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title477
                            )}
                          >
                            {"Return Demonstration Testing"}
                          </div>
                        </div>
                        <div
                          data-plasmic-name={"item460"}
                          data-plasmic-override={overrides.item460}
                          className={classNames("all", sty.item460)}
                        >
                          <div
                            data-plasmic-name={"left460"}
                            data-plasmic-override={overrides.left460}
                            className={classNames("all", sty.left460)}
                          >
                            <div
                              data-plasmic-name={"icon460"}
                              data-plasmic-override={overrides.icon460}
                              className={classNames("all", sty.icon460)}
                            >
                              <Icon93Icon
                                className={classNames("all", sty.svg__tomWy)}
                                role={"img"}
                              />
                            </div>
                          </div>
                          <div
                            data-plasmic-name={"title478"}
                            data-plasmic-override={overrides.title478}
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.title478
                            )}
                          >
                            {"Clinical Learning Contracts"}
                          </div>
                        </div>
                        {false ? (
                          <div
                            data-plasmic-name={"item461"}
                            data-plasmic-override={overrides.item461}
                            className={classNames("all", sty.item461)}
                          >
                            <div
                              data-plasmic-name={"left461"}
                              data-plasmic-override={overrides.left461}
                              className={classNames("all", sty.left461)}
                            >
                              <div
                                data-plasmic-name={"icon461"}
                                data-plasmic-override={overrides.icon461}
                                className={classNames("all", sty.icon461)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__iupbk)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title479"}
                              data-plasmic-override={overrides.title479}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title479
                              )}
                            >
                              {"MyQuiz\u2122"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item462"}
                            data-plasmic-override={overrides.item462}
                            className={classNames("all", sty.item462)}
                          >
                            <div
                              data-plasmic-name={"left462"}
                              data-plasmic-override={overrides.left462}
                              className={classNames("all", sty.left462)}
                            >
                              <div
                                data-plasmic-name={"icon462"}
                                data-plasmic-override={overrides.icon462}
                                className={classNames("all", sty.icon462)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___94PmA)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title480"}
                              data-plasmic-override={overrides.title480}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title480
                              )}
                            >
                              {"Performance Dashboard"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item463"}
                            data-plasmic-override={overrides.item463}
                            className={classNames("all", sty.item463)}
                          >
                            <div
                              data-plasmic-name={"left463"}
                              data-plasmic-override={overrides.left463}
                              className={classNames("all", sty.left463)}
                            >
                              <div
                                data-plasmic-name={"icon463"}
                                data-plasmic-override={overrides.icon463}
                                className={classNames("all", sty.icon463)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___8M2Yw)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title481"}
                              data-plasmic-override={overrides.title481}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title481
                              )}
                            >
                              {"Centralized Procedure Reporting"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item464"}
                            data-plasmic-override={overrides.item464}
                            className={classNames("all", sty.item464)}
                          >
                            <div
                              data-plasmic-name={"left464"}
                              data-plasmic-override={overrides.left464}
                              className={classNames("all", sty.left464)}
                            >
                              <div
                                data-plasmic-name={"icon464"}
                                data-plasmic-override={overrides.icon464}
                                className={classNames("all", sty.icon464)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__kgKa5)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title482"}
                              data-plasmic-override={overrides.title482}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title482
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item465"}
                            data-plasmic-override={overrides.item465}
                            className={classNames("all", sty.item465)}
                          >
                            <div
                              data-plasmic-name={"left465"}
                              data-plasmic-override={overrides.left465}
                              className={classNames("all", sty.left465)}
                            >
                              <div
                                data-plasmic-name={"icon465"}
                                data-plasmic-override={overrides.icon465}
                                className={classNames("all", sty.icon465)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__yHx2S)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title483"}
                              data-plasmic-override={overrides.title483}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title483
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item466"}
                            data-plasmic-override={overrides.item466}
                            className={classNames("all", sty.item466)}
                          >
                            <div
                              data-plasmic-name={"left466"}
                              data-plasmic-override={overrides.left466}
                              className={classNames("all", sty.left466)}
                            >
                              <div
                                data-plasmic-name={"icon466"}
                                data-plasmic-override={overrides.icon466}
                                className={classNames("all", sty.icon466)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__sSeIx)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title484"}
                              data-plasmic-override={overrides.title484}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title484
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item467"}
                            data-plasmic-override={overrides.item467}
                            className={classNames("all", sty.item467)}
                          >
                            <div
                              data-plasmic-name={"left467"}
                              data-plasmic-override={overrides.left467}
                              className={classNames("all", sty.left467)}
                            >
                              <div
                                data-plasmic-name={"icon467"}
                                data-plasmic-override={overrides.icon467}
                                className={classNames("all", sty.icon467)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___5UVsA)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title485"}
                              data-plasmic-override={overrides.title485}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title485
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item468"}
                            data-plasmic-override={overrides.item468}
                            className={classNames("all", sty.item468)}
                          >
                            <div
                              data-plasmic-name={"left468"}
                              data-plasmic-override={overrides.left468}
                              className={classNames("all", sty.left468)}
                            >
                              <div
                                data-plasmic-name={"icon468"}
                                data-plasmic-override={overrides.icon468}
                                className={classNames("all", sty.icon468)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ba1G)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title486"}
                              data-plasmic-override={overrides.title486}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title486
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item469"}
                            data-plasmic-override={overrides.item469}
                            className={classNames("all", sty.item469)}
                          >
                            <div
                              data-plasmic-name={"left469"}
                              data-plasmic-override={overrides.left469}
                              className={classNames("all", sty.left469)}
                            >
                              <div
                                data-plasmic-name={"icon469"}
                                data-plasmic-override={overrides.icon469}
                                className={classNames("all", sty.icon469)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__sz7GK)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title487"}
                              data-plasmic-override={overrides.title487}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title487
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item470"}
                            data-plasmic-override={overrides.item470}
                            className={classNames("all", sty.item470)}
                          >
                            <div
                              data-plasmic-name={"left470"}
                              data-plasmic-override={overrides.left470}
                              className={classNames("all", sty.left470)}
                            >
                              <div
                                data-plasmic-name={"icon470"}
                                data-plasmic-override={overrides.icon470}
                                className={classNames("all", sty.icon470)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__vbbF)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title488"}
                              data-plasmic-override={overrides.title488}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title488
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item471"}
                            data-plasmic-override={overrides.item471}
                            className={classNames("all", sty.item471)}
                          >
                            <div
                              data-plasmic-name={"left471"}
                              data-plasmic-override={overrides.left471}
                              className={classNames("all", sty.left471)}
                            >
                              <div
                                data-plasmic-name={"icon471"}
                                data-plasmic-override={overrides.icon471}
                                className={classNames("all", sty.icon471)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wm9QQ)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title489"}
                              data-plasmic-override={overrides.title489}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title489
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item472"}
                            data-plasmic-override={overrides.item472}
                            className={classNames("all", sty.item472)}
                          >
                            <div
                              data-plasmic-name={"left472"}
                              data-plasmic-override={overrides.left472}
                              className={classNames("all", sty.left472)}
                            >
                              <div
                                data-plasmic-name={"icon472"}
                                data-plasmic-override={overrides.icon472}
                                className={classNames("all", sty.icon472)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___84FMy)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title490"}
                              data-plasmic-override={overrides.title490}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title490
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item473"}
                            data-plasmic-override={overrides.item473}
                            className={classNames("all", sty.item473)}
                          >
                            <div
                              data-plasmic-name={"left473"}
                              data-plasmic-override={overrides.left473}
                              className={classNames("all", sty.left473)}
                            >
                              <div
                                data-plasmic-name={"icon473"}
                                data-plasmic-override={overrides.icon473}
                                className={classNames("all", sty.icon473)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__wnUqz)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title491"}
                              data-plasmic-override={overrides.title491}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title491
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item474"}
                            data-plasmic-override={overrides.item474}
                            className={classNames("all", sty.item474)}
                          >
                            <div
                              data-plasmic-name={"left474"}
                              data-plasmic-override={overrides.left474}
                              className={classNames("all", sty.left474)}
                            >
                              <div
                                data-plasmic-name={"icon474"}
                                data-plasmic-override={overrides.icon474}
                                className={classNames("all", sty.icon474)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__dlRx1)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title492"}
                              data-plasmic-override={overrides.title492}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title492
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item475"}
                            data-plasmic-override={overrides.item475}
                            className={classNames("all", sty.item475)}
                          >
                            <div
                              data-plasmic-name={"left475"}
                              data-plasmic-override={overrides.left475}
                              className={classNames("all", sty.left475)}
                            >
                              <div
                                data-plasmic-name={"icon475"}
                                data-plasmic-override={overrides.icon475}
                                className={classNames("all", sty.icon475)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__ppIlz)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title493"}
                              data-plasmic-override={overrides.title493}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title493
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item476"}
                            data-plasmic-override={overrides.item476}
                            className={classNames("all", sty.item476)}
                          >
                            <div
                              data-plasmic-name={"left476"}
                              data-plasmic-override={overrides.left476}
                              className={classNames("all", sty.left476)}
                            >
                              <div
                                data-plasmic-name={"icon476"}
                                data-plasmic-override={overrides.icon476}
                                className={classNames("all", sty.icon476)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__qy0I1)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title494"}
                              data-plasmic-override={overrides.title494}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title494
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item477"}
                            data-plasmic-override={overrides.item477}
                            className={classNames("all", sty.item477)}
                          >
                            <div
                              data-plasmic-name={"left477"}
                              data-plasmic-override={overrides.left477}
                              className={classNames("all", sty.left477)}
                            >
                              <div
                                data-plasmic-name={"icon477"}
                                data-plasmic-override={overrides.icon477}
                                className={classNames("all", sty.icon477)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__xs5Us)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title495"}
                              data-plasmic-override={overrides.title495}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title495
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item478"}
                            data-plasmic-override={overrides.item478}
                            className={classNames("all", sty.item478)}
                          >
                            <div
                              data-plasmic-name={"left478"}
                              data-plasmic-override={overrides.left478}
                              className={classNames("all", sty.left478)}
                            >
                              <div
                                data-plasmic-name={"icon478"}
                                data-plasmic-override={overrides.icon478}
                                className={classNames("all", sty.icon478)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg___2CuEl)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title496"}
                              data-plasmic-override={overrides.title496}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title496
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item479"}
                            data-plasmic-override={overrides.item479}
                            className={classNames("all", sty.item479)}
                          >
                            <div
                              data-plasmic-name={"left479"}
                              data-plasmic-override={overrides.left479}
                              className={classNames("all", sty.left479)}
                            >
                              <div
                                data-plasmic-name={"icon479"}
                                data-plasmic-override={overrides.icon479}
                                className={classNames("all", sty.icon479)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__qihWf)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title497"}
                              data-plasmic-override={overrides.title497}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title497
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                        {false ? (
                          <div
                            data-plasmic-name={"item480"}
                            data-plasmic-override={overrides.item480}
                            className={classNames("all", sty.item480)}
                          >
                            <div
                              data-plasmic-name={"left480"}
                              data-plasmic-override={overrides.left480}
                              className={classNames("all", sty.left480)}
                            >
                              <div
                                data-plasmic-name={"icon480"}
                                data-plasmic-override={overrides.icon480}
                                className={classNames("all", sty.icon480)}
                              >
                                <Icon93Icon
                                  className={classNames("all", sty.svg__jwZt9)}
                                  role={"img"}
                                />
                              </div>
                            </div>
                            <div
                              data-plasmic-name={"title498"}
                              data-plasmic-override={overrides.title498}
                              className={classNames(
                                "all",
                                "__wab_text",
                                sty.title498
                              )}
                            >
                              {"Feature Item"}
                            </div>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {false ? (
                      <Button
                        data-plasmic-name={"btn16"}
                        data-plasmic-override={overrides.btn16}
                        className={classNames("__wab_instance", sty.btn16)}
                        size={"medium"}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  myEvaluations: [
    "myEvaluations",
    "desktop",
    "key2",
    "list",
    "row2",
    "narrowCard",
    "header",
    "title196",
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn",
    "figmaPaste",
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3",
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2",
    "row3",
    "figmaPaste2",
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4",
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5",
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6",
    "row4",
    "figmaPaste3",
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7",
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8",
    "tablet",
    "row6",
    "featuresProductHeader",
    "key4",
    "header4",
    "list11",
    "row7",
    "figmaPaste5",
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17",
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18",
    "row8",
    "figmaPaste6",
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19",
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20",
    "narrowCard21",
    "header44",
    "title502",
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21",
    "narrowCard22",
    "header46",
    "title527",
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22",
    "row9",
    "figmaPaste7",
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23",
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24",
    "row10",
    "row11",
    "figmaPaste8",
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25",
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26",
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15",
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "figmaPaste4",
    "narrowCard9",
    "header28",
    "title",
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9",
    "narrowCard10",
    "header30",
    "title26",
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10",
    "narrowCard11",
    "header5",
    "title51",
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11",
    "narrowCard12",
    "header7",
    "title76",
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12",
    "narrowCard13",
    "header32",
    "title399",
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13",
    "narrowCard14",
    "header34",
    "title424",
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14",
    "narrowCard15",
    "header36",
    "title449",
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15",
    "narrowCard16",
    "header38",
    "title474",
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  desktop: [
    "desktop",
    "key2",
    "list",
    "row2",
    "narrowCard",
    "header",
    "title196",
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn",
    "figmaPaste",
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3",
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2",
    "row3",
    "figmaPaste2",
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4",
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5",
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6",
    "row4",
    "figmaPaste3",
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7",
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  key2: [
    "key2",
    "list",
    "row2",
    "narrowCard",
    "header",
    "title196",
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn",
    "figmaPaste",
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3",
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2",
    "row3",
    "figmaPaste2",
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4",
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5",
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6",
    "row4",
    "figmaPaste3",
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7",
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  list: [
    "list",
    "row2",
    "narrowCard",
    "header",
    "title196",
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn",
    "figmaPaste",
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3",
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2",
    "row3",
    "figmaPaste2",
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4",
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5",
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6",
    "row4",
    "figmaPaste3",
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7",
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  row2: [
    "row2",
    "narrowCard",
    "header",
    "title196",
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn",
    "figmaPaste",
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3",
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2"
  ],
  narrowCard: [
    "narrowCard",
    "header",
    "title196",
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn"
  ],
  header: ["header", "title196"],
  title196: ["title196"],
  content: [
    "content",
    "desc",
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220",
    "btn"
  ],
  desc: ["desc"],
  placeholder: [
    "placeholder",
    "header13",
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220"
  ],
  header13: ["header13"],
  list16: [
    "list16",
    "item193",
    "left193",
    "icon193",
    "title197",
    "item194",
    "left194",
    "icon194",
    "title198",
    "item195",
    "left195",
    "icon195",
    "title199",
    "item196",
    "left196",
    "icon196",
    "title200",
    "item197",
    "left197",
    "icon197",
    "title201",
    "item198",
    "left198",
    "icon198",
    "title202",
    "item199",
    "left199",
    "icon199",
    "title203",
    "item200",
    "left200",
    "icon200",
    "title204",
    "item201",
    "left201",
    "icon201",
    "title205",
    "item202",
    "left202",
    "icon202",
    "title206",
    "item203",
    "left203",
    "icon203",
    "title207",
    "item204",
    "left204",
    "icon204",
    "title208",
    "item205",
    "left205",
    "icon205",
    "title209",
    "item206",
    "left206",
    "icon206",
    "title210",
    "item207",
    "left207",
    "icon207",
    "title211",
    "item208",
    "left208",
    "icon208",
    "title212",
    "item209",
    "left209",
    "icon209",
    "title213",
    "item210",
    "left210",
    "icon210",
    "title214",
    "item211",
    "left211",
    "icon211",
    "title215",
    "item212",
    "left212",
    "icon212",
    "title216",
    "item213",
    "left213",
    "icon213",
    "title217",
    "item214",
    "left214",
    "icon214",
    "title218",
    "item215",
    "left215",
    "icon215",
    "title219",
    "item216",
    "left216",
    "icon216",
    "title220"
  ],
  item193: ["item193", "left193", "icon193", "title197"],
  left193: ["left193", "icon193"],
  icon193: ["icon193"],
  title197: ["title197"],
  item194: ["item194", "left194", "icon194", "title198"],
  left194: ["left194", "icon194"],
  icon194: ["icon194"],
  title198: ["title198"],
  item195: ["item195", "left195", "icon195", "title199"],
  left195: ["left195", "icon195"],
  icon195: ["icon195"],
  title199: ["title199"],
  item196: ["item196", "left196", "icon196", "title200"],
  left196: ["left196", "icon196"],
  icon196: ["icon196"],
  title200: ["title200"],
  item197: ["item197", "left197", "icon197", "title201"],
  left197: ["left197", "icon197"],
  icon197: ["icon197"],
  title201: ["title201"],
  item198: ["item198", "left198", "icon198", "title202"],
  left198: ["left198", "icon198"],
  icon198: ["icon198"],
  title202: ["title202"],
  item199: ["item199", "left199", "icon199", "title203"],
  left199: ["left199", "icon199"],
  icon199: ["icon199"],
  title203: ["title203"],
  item200: ["item200", "left200", "icon200", "title204"],
  left200: ["left200", "icon200"],
  icon200: ["icon200"],
  title204: ["title204"],
  item201: ["item201", "left201", "icon201", "title205"],
  left201: ["left201", "icon201"],
  icon201: ["icon201"],
  title205: ["title205"],
  item202: ["item202", "left202", "icon202", "title206"],
  left202: ["left202", "icon202"],
  icon202: ["icon202"],
  title206: ["title206"],
  item203: ["item203", "left203", "icon203", "title207"],
  left203: ["left203", "icon203"],
  icon203: ["icon203"],
  title207: ["title207"],
  item204: ["item204", "left204", "icon204", "title208"],
  left204: ["left204", "icon204"],
  icon204: ["icon204"],
  title208: ["title208"],
  item205: ["item205", "left205", "icon205", "title209"],
  left205: ["left205", "icon205"],
  icon205: ["icon205"],
  title209: ["title209"],
  item206: ["item206", "left206", "icon206", "title210"],
  left206: ["left206", "icon206"],
  icon206: ["icon206"],
  title210: ["title210"],
  item207: ["item207", "left207", "icon207", "title211"],
  left207: ["left207", "icon207"],
  icon207: ["icon207"],
  title211: ["title211"],
  item208: ["item208", "left208", "icon208", "title212"],
  left208: ["left208", "icon208"],
  icon208: ["icon208"],
  title212: ["title212"],
  item209: ["item209", "left209", "icon209", "title213"],
  left209: ["left209", "icon209"],
  icon209: ["icon209"],
  title213: ["title213"],
  item210: ["item210", "left210", "icon210", "title214"],
  left210: ["left210", "icon210"],
  icon210: ["icon210"],
  title214: ["title214"],
  item211: ["item211", "left211", "icon211", "title215"],
  left211: ["left211", "icon211"],
  icon211: ["icon211"],
  title215: ["title215"],
  item212: ["item212", "left212", "icon212", "title216"],
  left212: ["left212", "icon212"],
  icon212: ["icon212"],
  title216: ["title216"],
  item213: ["item213", "left213", "icon213", "title217"],
  left213: ["left213", "icon213"],
  icon213: ["icon213"],
  title217: ["title217"],
  item214: ["item214", "left214", "icon214", "title218"],
  left214: ["left214", "icon214"],
  icon214: ["icon214"],
  title218: ["title218"],
  item215: ["item215", "left215", "icon215", "title219"],
  left215: ["left215", "icon215"],
  icon215: ["icon215"],
  title219: ["title219"],
  item216: ["item216", "left216", "icon216", "title220"],
  left216: ["left216", "icon216"],
  icon216: ["icon216"],
  title220: ["title220"],
  btn: ["btn"],
  figmaPaste: [
    "figmaPaste",
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3",
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2"
  ],
  narrowCard3: [
    "narrowCard3",
    "header14",
    "title221",
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3"
  ],
  header14: ["header14", "title221"],
  title221: ["title221"],
  content3: [
    "content3",
    "desc3",
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245",
    "btn3"
  ],
  desc3: ["desc3"],
  placeholder3: [
    "placeholder3",
    "header15",
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245"
  ],
  header15: ["header15"],
  list17: [
    "list17",
    "item217",
    "left217",
    "icon217",
    "title222",
    "item218",
    "left218",
    "icon218",
    "title223",
    "item219",
    "left219",
    "icon219",
    "title224",
    "item220",
    "left220",
    "icon220",
    "title225",
    "item221",
    "left221",
    "icon221",
    "title226",
    "item222",
    "left222",
    "icon222",
    "title227",
    "item223",
    "left223",
    "icon223",
    "title228",
    "item224",
    "left224",
    "icon224",
    "title229",
    "item225",
    "left225",
    "icon225",
    "title230",
    "item226",
    "left226",
    "icon226",
    "title231",
    "item227",
    "left227",
    "icon227",
    "title232",
    "item228",
    "left228",
    "icon228",
    "title233",
    "item229",
    "left229",
    "icon229",
    "title234",
    "item230",
    "left230",
    "icon230",
    "title235",
    "item231",
    "left231",
    "icon231",
    "title236",
    "item232",
    "left232",
    "icon232",
    "title237",
    "item233",
    "left233",
    "icon233",
    "title238",
    "item234",
    "left234",
    "icon234",
    "title239",
    "item235",
    "left235",
    "icon235",
    "title240",
    "item236",
    "left236",
    "icon236",
    "title241",
    "item237",
    "left237",
    "icon237",
    "title242",
    "item238",
    "left238",
    "icon238",
    "title243",
    "item239",
    "left239",
    "icon239",
    "title244",
    "item240",
    "left240",
    "icon240",
    "title245"
  ],
  item217: ["item217", "left217", "icon217", "title222"],
  left217: ["left217", "icon217"],
  icon217: ["icon217"],
  title222: ["title222"],
  item218: ["item218", "left218", "icon218", "title223"],
  left218: ["left218", "icon218"],
  icon218: ["icon218"],
  title223: ["title223"],
  item219: ["item219", "left219", "icon219", "title224"],
  left219: ["left219", "icon219"],
  icon219: ["icon219"],
  title224: ["title224"],
  item220: ["item220", "left220", "icon220", "title225"],
  left220: ["left220", "icon220"],
  icon220: ["icon220"],
  title225: ["title225"],
  item221: ["item221", "left221", "icon221", "title226"],
  left221: ["left221", "icon221"],
  icon221: ["icon221"],
  title226: ["title226"],
  item222: ["item222", "left222", "icon222", "title227"],
  left222: ["left222", "icon222"],
  icon222: ["icon222"],
  title227: ["title227"],
  item223: ["item223", "left223", "icon223", "title228"],
  left223: ["left223", "icon223"],
  icon223: ["icon223"],
  title228: ["title228"],
  item224: ["item224", "left224", "icon224", "title229"],
  left224: ["left224", "icon224"],
  icon224: ["icon224"],
  title229: ["title229"],
  item225: ["item225", "left225", "icon225", "title230"],
  left225: ["left225", "icon225"],
  icon225: ["icon225"],
  title230: ["title230"],
  item226: ["item226", "left226", "icon226", "title231"],
  left226: ["left226", "icon226"],
  icon226: ["icon226"],
  title231: ["title231"],
  item227: ["item227", "left227", "icon227", "title232"],
  left227: ["left227", "icon227"],
  icon227: ["icon227"],
  title232: ["title232"],
  item228: ["item228", "left228", "icon228", "title233"],
  left228: ["left228", "icon228"],
  icon228: ["icon228"],
  title233: ["title233"],
  item229: ["item229", "left229", "icon229", "title234"],
  left229: ["left229", "icon229"],
  icon229: ["icon229"],
  title234: ["title234"],
  item230: ["item230", "left230", "icon230", "title235"],
  left230: ["left230", "icon230"],
  icon230: ["icon230"],
  title235: ["title235"],
  item231: ["item231", "left231", "icon231", "title236"],
  left231: ["left231", "icon231"],
  icon231: ["icon231"],
  title236: ["title236"],
  item232: ["item232", "left232", "icon232", "title237"],
  left232: ["left232", "icon232"],
  icon232: ["icon232"],
  title237: ["title237"],
  item233: ["item233", "left233", "icon233", "title238"],
  left233: ["left233", "icon233"],
  icon233: ["icon233"],
  title238: ["title238"],
  item234: ["item234", "left234", "icon234", "title239"],
  left234: ["left234", "icon234"],
  icon234: ["icon234"],
  title239: ["title239"],
  item235: ["item235", "left235", "icon235", "title240"],
  left235: ["left235", "icon235"],
  icon235: ["icon235"],
  title240: ["title240"],
  item236: ["item236", "left236", "icon236", "title241"],
  left236: ["left236", "icon236"],
  icon236: ["icon236"],
  title241: ["title241"],
  item237: ["item237", "left237", "icon237", "title242"],
  left237: ["left237", "icon237"],
  icon237: ["icon237"],
  title242: ["title242"],
  item238: ["item238", "left238", "icon238", "title243"],
  left238: ["left238", "icon238"],
  icon238: ["icon238"],
  title243: ["title243"],
  item239: ["item239", "left239", "icon239", "title244"],
  left239: ["left239", "icon239"],
  icon239: ["icon239"],
  title244: ["title244"],
  item240: ["item240", "left240", "icon240", "title245"],
  left240: ["left240", "icon240"],
  icon240: ["icon240"],
  title245: ["title245"],
  btn3: ["btn3"],
  narrowCard2: [
    "narrowCard2",
    "header16",
    "title246",
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2"
  ],
  header16: ["header16", "title246"],
  title246: ["title246"],
  content2: [
    "content2",
    "desc2",
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270",
    "btn2"
  ],
  desc2: ["desc2"],
  placeholder2: [
    "placeholder2",
    "header17",
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270"
  ],
  header17: ["header17"],
  list18: [
    "list18",
    "item241",
    "left241",
    "icon241",
    "title247",
    "item242",
    "left242",
    "icon242",
    "title248",
    "item243",
    "left243",
    "icon243",
    "title249",
    "item244",
    "left244",
    "icon244",
    "title250",
    "item245",
    "left245",
    "icon245",
    "title251",
    "item246",
    "left246",
    "icon246",
    "title252",
    "item247",
    "left247",
    "icon247",
    "title253",
    "item248",
    "left248",
    "icon248",
    "title254",
    "item249",
    "left249",
    "icon249",
    "title255",
    "item250",
    "left250",
    "icon250",
    "title256",
    "item251",
    "left251",
    "icon251",
    "title257",
    "item252",
    "left252",
    "icon252",
    "title258",
    "item253",
    "left253",
    "icon253",
    "title259",
    "item254",
    "left254",
    "icon254",
    "title260",
    "item255",
    "left255",
    "icon255",
    "title261",
    "item256",
    "left256",
    "icon256",
    "title262",
    "item257",
    "left257",
    "icon257",
    "title263",
    "item258",
    "left258",
    "icon258",
    "title264",
    "item259",
    "left259",
    "icon259",
    "title265",
    "item260",
    "left260",
    "icon260",
    "title266",
    "item261",
    "left261",
    "icon261",
    "title267",
    "item262",
    "left262",
    "icon262",
    "title268",
    "item263",
    "left263",
    "icon263",
    "title269",
    "item264",
    "left264",
    "icon264",
    "title270"
  ],
  item241: ["item241", "left241", "icon241", "title247"],
  left241: ["left241", "icon241"],
  icon241: ["icon241"],
  title247: ["title247"],
  item242: ["item242", "left242", "icon242", "title248"],
  left242: ["left242", "icon242"],
  icon242: ["icon242"],
  title248: ["title248"],
  item243: ["item243", "left243", "icon243", "title249"],
  left243: ["left243", "icon243"],
  icon243: ["icon243"],
  title249: ["title249"],
  item244: ["item244", "left244", "icon244", "title250"],
  left244: ["left244", "icon244"],
  icon244: ["icon244"],
  title250: ["title250"],
  item245: ["item245", "left245", "icon245", "title251"],
  left245: ["left245", "icon245"],
  icon245: ["icon245"],
  title251: ["title251"],
  item246: ["item246", "left246", "icon246", "title252"],
  left246: ["left246", "icon246"],
  icon246: ["icon246"],
  title252: ["title252"],
  item247: ["item247", "left247", "icon247", "title253"],
  left247: ["left247", "icon247"],
  icon247: ["icon247"],
  title253: ["title253"],
  item248: ["item248", "left248", "icon248", "title254"],
  left248: ["left248", "icon248"],
  icon248: ["icon248"],
  title254: ["title254"],
  item249: ["item249", "left249", "icon249", "title255"],
  left249: ["left249", "icon249"],
  icon249: ["icon249"],
  title255: ["title255"],
  item250: ["item250", "left250", "icon250", "title256"],
  left250: ["left250", "icon250"],
  icon250: ["icon250"],
  title256: ["title256"],
  item251: ["item251", "left251", "icon251", "title257"],
  left251: ["left251", "icon251"],
  icon251: ["icon251"],
  title257: ["title257"],
  item252: ["item252", "left252", "icon252", "title258"],
  left252: ["left252", "icon252"],
  icon252: ["icon252"],
  title258: ["title258"],
  item253: ["item253", "left253", "icon253", "title259"],
  left253: ["left253", "icon253"],
  icon253: ["icon253"],
  title259: ["title259"],
  item254: ["item254", "left254", "icon254", "title260"],
  left254: ["left254", "icon254"],
  icon254: ["icon254"],
  title260: ["title260"],
  item255: ["item255", "left255", "icon255", "title261"],
  left255: ["left255", "icon255"],
  icon255: ["icon255"],
  title261: ["title261"],
  item256: ["item256", "left256", "icon256", "title262"],
  left256: ["left256", "icon256"],
  icon256: ["icon256"],
  title262: ["title262"],
  item257: ["item257", "left257", "icon257", "title263"],
  left257: ["left257", "icon257"],
  icon257: ["icon257"],
  title263: ["title263"],
  item258: ["item258", "left258", "icon258", "title264"],
  left258: ["left258", "icon258"],
  icon258: ["icon258"],
  title264: ["title264"],
  item259: ["item259", "left259", "icon259", "title265"],
  left259: ["left259", "icon259"],
  icon259: ["icon259"],
  title265: ["title265"],
  item260: ["item260", "left260", "icon260", "title266"],
  left260: ["left260", "icon260"],
  icon260: ["icon260"],
  title266: ["title266"],
  item261: ["item261", "left261", "icon261", "title267"],
  left261: ["left261", "icon261"],
  icon261: ["icon261"],
  title267: ["title267"],
  item262: ["item262", "left262", "icon262", "title268"],
  left262: ["left262", "icon262"],
  icon262: ["icon262"],
  title268: ["title268"],
  item263: ["item263", "left263", "icon263", "title269"],
  left263: ["left263", "icon263"],
  icon263: ["icon263"],
  title269: ["title269"],
  item264: ["item264", "left264", "icon264", "title270"],
  left264: ["left264", "icon264"],
  icon264: ["icon264"],
  title270: ["title270"],
  btn2: ["btn2"],
  row3: [
    "row3",
    "figmaPaste2",
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4",
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5",
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6"
  ],
  figmaPaste2: [
    "figmaPaste2",
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4",
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5",
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6"
  ],
  narrowCard4: [
    "narrowCard4",
    "header18",
    "title271",
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4"
  ],
  header18: ["header18", "title271"],
  title271: ["title271"],
  content4: [
    "content4",
    "desc4",
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295",
    "btn4"
  ],
  desc4: ["desc4"],
  placeholder4: [
    "placeholder4",
    "header19",
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295"
  ],
  header19: ["header19"],
  list19: [
    "list19",
    "item265",
    "left265",
    "icon265",
    "title272",
    "item266",
    "left266",
    "icon266",
    "title273",
    "item267",
    "left267",
    "icon267",
    "title274",
    "item268",
    "left268",
    "icon268",
    "title275",
    "item269",
    "left269",
    "icon269",
    "title276",
    "item270",
    "left270",
    "icon270",
    "title277",
    "item271",
    "left271",
    "icon271",
    "title278",
    "item272",
    "left272",
    "icon272",
    "title279",
    "item273",
    "left273",
    "icon273",
    "title280",
    "item274",
    "left274",
    "icon274",
    "title281",
    "item275",
    "left275",
    "icon275",
    "title282",
    "item276",
    "left276",
    "icon276",
    "title283",
    "item277",
    "left277",
    "icon277",
    "title284",
    "item278",
    "left278",
    "icon278",
    "title285",
    "item279",
    "left279",
    "icon279",
    "title286",
    "item280",
    "left280",
    "icon280",
    "title287",
    "item281",
    "left281",
    "icon281",
    "title288",
    "item282",
    "left282",
    "icon282",
    "title289",
    "item283",
    "left283",
    "icon283",
    "title290",
    "item284",
    "left284",
    "icon284",
    "title291",
    "item285",
    "left285",
    "icon285",
    "title292",
    "item286",
    "left286",
    "icon286",
    "title293",
    "item287",
    "left287",
    "icon287",
    "title294",
    "item288",
    "left288",
    "icon288",
    "title295"
  ],
  item265: ["item265", "left265", "icon265", "title272"],
  left265: ["left265", "icon265"],
  icon265: ["icon265"],
  title272: ["title272"],
  item266: ["item266", "left266", "icon266", "title273"],
  left266: ["left266", "icon266"],
  icon266: ["icon266"],
  title273: ["title273"],
  item267: ["item267", "left267", "icon267", "title274"],
  left267: ["left267", "icon267"],
  icon267: ["icon267"],
  title274: ["title274"],
  item268: ["item268", "left268", "icon268", "title275"],
  left268: ["left268", "icon268"],
  icon268: ["icon268"],
  title275: ["title275"],
  item269: ["item269", "left269", "icon269", "title276"],
  left269: ["left269", "icon269"],
  icon269: ["icon269"],
  title276: ["title276"],
  item270: ["item270", "left270", "icon270", "title277"],
  left270: ["left270", "icon270"],
  icon270: ["icon270"],
  title277: ["title277"],
  item271: ["item271", "left271", "icon271", "title278"],
  left271: ["left271", "icon271"],
  icon271: ["icon271"],
  title278: ["title278"],
  item272: ["item272", "left272", "icon272", "title279"],
  left272: ["left272", "icon272"],
  icon272: ["icon272"],
  title279: ["title279"],
  item273: ["item273", "left273", "icon273", "title280"],
  left273: ["left273", "icon273"],
  icon273: ["icon273"],
  title280: ["title280"],
  item274: ["item274", "left274", "icon274", "title281"],
  left274: ["left274", "icon274"],
  icon274: ["icon274"],
  title281: ["title281"],
  item275: ["item275", "left275", "icon275", "title282"],
  left275: ["left275", "icon275"],
  icon275: ["icon275"],
  title282: ["title282"],
  item276: ["item276", "left276", "icon276", "title283"],
  left276: ["left276", "icon276"],
  icon276: ["icon276"],
  title283: ["title283"],
  item277: ["item277", "left277", "icon277", "title284"],
  left277: ["left277", "icon277"],
  icon277: ["icon277"],
  title284: ["title284"],
  item278: ["item278", "left278", "icon278", "title285"],
  left278: ["left278", "icon278"],
  icon278: ["icon278"],
  title285: ["title285"],
  item279: ["item279", "left279", "icon279", "title286"],
  left279: ["left279", "icon279"],
  icon279: ["icon279"],
  title286: ["title286"],
  item280: ["item280", "left280", "icon280", "title287"],
  left280: ["left280", "icon280"],
  icon280: ["icon280"],
  title287: ["title287"],
  item281: ["item281", "left281", "icon281", "title288"],
  left281: ["left281", "icon281"],
  icon281: ["icon281"],
  title288: ["title288"],
  item282: ["item282", "left282", "icon282", "title289"],
  left282: ["left282", "icon282"],
  icon282: ["icon282"],
  title289: ["title289"],
  item283: ["item283", "left283", "icon283", "title290"],
  left283: ["left283", "icon283"],
  icon283: ["icon283"],
  title290: ["title290"],
  item284: ["item284", "left284", "icon284", "title291"],
  left284: ["left284", "icon284"],
  icon284: ["icon284"],
  title291: ["title291"],
  item285: ["item285", "left285", "icon285", "title292"],
  left285: ["left285", "icon285"],
  icon285: ["icon285"],
  title292: ["title292"],
  item286: ["item286", "left286", "icon286", "title293"],
  left286: ["left286", "icon286"],
  icon286: ["icon286"],
  title293: ["title293"],
  item287: ["item287", "left287", "icon287", "title294"],
  left287: ["left287", "icon287"],
  icon287: ["icon287"],
  title294: ["title294"],
  item288: ["item288", "left288", "icon288", "title295"],
  left288: ["left288", "icon288"],
  icon288: ["icon288"],
  title295: ["title295"],
  btn4: ["btn4"],
  narrowCard5: [
    "narrowCard5",
    "header20",
    "title296",
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5"
  ],
  header20: ["header20", "title296"],
  title296: ["title296"],
  content5: [
    "content5",
    "desc5",
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320",
    "btn5"
  ],
  desc5: ["desc5"],
  placeholder5: [
    "placeholder5",
    "header21",
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320"
  ],
  header21: ["header21"],
  list20: [
    "list20",
    "item289",
    "left289",
    "icon289",
    "title297",
    "item290",
    "left290",
    "icon290",
    "title298",
    "item291",
    "left291",
    "icon291",
    "title299",
    "item292",
    "left292",
    "icon292",
    "title300",
    "item293",
    "left293",
    "icon293",
    "title301",
    "item294",
    "left294",
    "icon294",
    "title302",
    "item295",
    "left295",
    "icon295",
    "title303",
    "item296",
    "left296",
    "icon296",
    "title304",
    "item297",
    "left297",
    "icon297",
    "title305",
    "item298",
    "left298",
    "icon298",
    "title306",
    "item299",
    "left299",
    "icon299",
    "title307",
    "item300",
    "left300",
    "icon300",
    "title308",
    "item301",
    "left301",
    "icon301",
    "title309",
    "item302",
    "left302",
    "icon302",
    "title310",
    "item303",
    "left303",
    "icon303",
    "title311",
    "item304",
    "left304",
    "icon304",
    "title312",
    "item305",
    "left305",
    "icon305",
    "title313",
    "item306",
    "left306",
    "icon306",
    "title314",
    "item307",
    "left307",
    "icon307",
    "title315",
    "item308",
    "left308",
    "icon308",
    "title316",
    "item309",
    "left309",
    "icon309",
    "title317",
    "item310",
    "left310",
    "icon310",
    "title318",
    "item311",
    "left311",
    "icon311",
    "title319",
    "item312",
    "left312",
    "icon312",
    "title320"
  ],
  item289: ["item289", "left289", "icon289", "title297"],
  left289: ["left289", "icon289"],
  icon289: ["icon289"],
  title297: ["title297"],
  item290: ["item290", "left290", "icon290", "title298"],
  left290: ["left290", "icon290"],
  icon290: ["icon290"],
  title298: ["title298"],
  item291: ["item291", "left291", "icon291", "title299"],
  left291: ["left291", "icon291"],
  icon291: ["icon291"],
  title299: ["title299"],
  item292: ["item292", "left292", "icon292", "title300"],
  left292: ["left292", "icon292"],
  icon292: ["icon292"],
  title300: ["title300"],
  item293: ["item293", "left293", "icon293", "title301"],
  left293: ["left293", "icon293"],
  icon293: ["icon293"],
  title301: ["title301"],
  item294: ["item294", "left294", "icon294", "title302"],
  left294: ["left294", "icon294"],
  icon294: ["icon294"],
  title302: ["title302"],
  item295: ["item295", "left295", "icon295", "title303"],
  left295: ["left295", "icon295"],
  icon295: ["icon295"],
  title303: ["title303"],
  item296: ["item296", "left296", "icon296", "title304"],
  left296: ["left296", "icon296"],
  icon296: ["icon296"],
  title304: ["title304"],
  item297: ["item297", "left297", "icon297", "title305"],
  left297: ["left297", "icon297"],
  icon297: ["icon297"],
  title305: ["title305"],
  item298: ["item298", "left298", "icon298", "title306"],
  left298: ["left298", "icon298"],
  icon298: ["icon298"],
  title306: ["title306"],
  item299: ["item299", "left299", "icon299", "title307"],
  left299: ["left299", "icon299"],
  icon299: ["icon299"],
  title307: ["title307"],
  item300: ["item300", "left300", "icon300", "title308"],
  left300: ["left300", "icon300"],
  icon300: ["icon300"],
  title308: ["title308"],
  item301: ["item301", "left301", "icon301", "title309"],
  left301: ["left301", "icon301"],
  icon301: ["icon301"],
  title309: ["title309"],
  item302: ["item302", "left302", "icon302", "title310"],
  left302: ["left302", "icon302"],
  icon302: ["icon302"],
  title310: ["title310"],
  item303: ["item303", "left303", "icon303", "title311"],
  left303: ["left303", "icon303"],
  icon303: ["icon303"],
  title311: ["title311"],
  item304: ["item304", "left304", "icon304", "title312"],
  left304: ["left304", "icon304"],
  icon304: ["icon304"],
  title312: ["title312"],
  item305: ["item305", "left305", "icon305", "title313"],
  left305: ["left305", "icon305"],
  icon305: ["icon305"],
  title313: ["title313"],
  item306: ["item306", "left306", "icon306", "title314"],
  left306: ["left306", "icon306"],
  icon306: ["icon306"],
  title314: ["title314"],
  item307: ["item307", "left307", "icon307", "title315"],
  left307: ["left307", "icon307"],
  icon307: ["icon307"],
  title315: ["title315"],
  item308: ["item308", "left308", "icon308", "title316"],
  left308: ["left308", "icon308"],
  icon308: ["icon308"],
  title316: ["title316"],
  item309: ["item309", "left309", "icon309", "title317"],
  left309: ["left309", "icon309"],
  icon309: ["icon309"],
  title317: ["title317"],
  item310: ["item310", "left310", "icon310", "title318"],
  left310: ["left310", "icon310"],
  icon310: ["icon310"],
  title318: ["title318"],
  item311: ["item311", "left311", "icon311", "title319"],
  left311: ["left311", "icon311"],
  icon311: ["icon311"],
  title319: ["title319"],
  item312: ["item312", "left312", "icon312", "title320"],
  left312: ["left312", "icon312"],
  icon312: ["icon312"],
  title320: ["title320"],
  btn5: ["btn5"],
  narrowCard6: [
    "narrowCard6",
    "header22",
    "title321",
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6"
  ],
  header22: ["header22", "title321"],
  title321: ["title321"],
  content6: [
    "content6",
    "desc6",
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345",
    "btn6"
  ],
  desc6: ["desc6"],
  placeholder6: [
    "placeholder6",
    "header23",
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345"
  ],
  header23: ["header23"],
  list21: [
    "list21",
    "item313",
    "left313",
    "icon313",
    "title322",
    "item314",
    "left314",
    "icon314",
    "title323",
    "item315",
    "left315",
    "icon315",
    "title324",
    "item316",
    "left316",
    "icon316",
    "title325",
    "item317",
    "left317",
    "icon317",
    "title326",
    "item318",
    "left318",
    "icon318",
    "title327",
    "item319",
    "left319",
    "icon319",
    "title328",
    "item320",
    "left320",
    "icon320",
    "title329",
    "item321",
    "left321",
    "icon321",
    "title330",
    "item322",
    "left322",
    "icon322",
    "title331",
    "item323",
    "left323",
    "icon323",
    "title332",
    "item324",
    "left324",
    "icon324",
    "title333",
    "item325",
    "left325",
    "icon325",
    "title334",
    "item326",
    "left326",
    "icon326",
    "title335",
    "item327",
    "left327",
    "icon327",
    "title336",
    "item328",
    "left328",
    "icon328",
    "title337",
    "item329",
    "left329",
    "icon329",
    "title338",
    "item330",
    "left330",
    "icon330",
    "title339",
    "item331",
    "left331",
    "icon331",
    "title340",
    "item332",
    "left332",
    "icon332",
    "title341",
    "item333",
    "left333",
    "icon333",
    "title342",
    "item334",
    "left334",
    "icon334",
    "title343",
    "item335",
    "left335",
    "icon335",
    "title344",
    "item336",
    "left336",
    "icon336",
    "title345"
  ],
  item313: ["item313", "left313", "icon313", "title322"],
  left313: ["left313", "icon313"],
  icon313: ["icon313"],
  title322: ["title322"],
  item314: ["item314", "left314", "icon314", "title323"],
  left314: ["left314", "icon314"],
  icon314: ["icon314"],
  title323: ["title323"],
  item315: ["item315", "left315", "icon315", "title324"],
  left315: ["left315", "icon315"],
  icon315: ["icon315"],
  title324: ["title324"],
  item316: ["item316", "left316", "icon316", "title325"],
  left316: ["left316", "icon316"],
  icon316: ["icon316"],
  title325: ["title325"],
  item317: ["item317", "left317", "icon317", "title326"],
  left317: ["left317", "icon317"],
  icon317: ["icon317"],
  title326: ["title326"],
  item318: ["item318", "left318", "icon318", "title327"],
  left318: ["left318", "icon318"],
  icon318: ["icon318"],
  title327: ["title327"],
  item319: ["item319", "left319", "icon319", "title328"],
  left319: ["left319", "icon319"],
  icon319: ["icon319"],
  title328: ["title328"],
  item320: ["item320", "left320", "icon320", "title329"],
  left320: ["left320", "icon320"],
  icon320: ["icon320"],
  title329: ["title329"],
  item321: ["item321", "left321", "icon321", "title330"],
  left321: ["left321", "icon321"],
  icon321: ["icon321"],
  title330: ["title330"],
  item322: ["item322", "left322", "icon322", "title331"],
  left322: ["left322", "icon322"],
  icon322: ["icon322"],
  title331: ["title331"],
  item323: ["item323", "left323", "icon323", "title332"],
  left323: ["left323", "icon323"],
  icon323: ["icon323"],
  title332: ["title332"],
  item324: ["item324", "left324", "icon324", "title333"],
  left324: ["left324", "icon324"],
  icon324: ["icon324"],
  title333: ["title333"],
  item325: ["item325", "left325", "icon325", "title334"],
  left325: ["left325", "icon325"],
  icon325: ["icon325"],
  title334: ["title334"],
  item326: ["item326", "left326", "icon326", "title335"],
  left326: ["left326", "icon326"],
  icon326: ["icon326"],
  title335: ["title335"],
  item327: ["item327", "left327", "icon327", "title336"],
  left327: ["left327", "icon327"],
  icon327: ["icon327"],
  title336: ["title336"],
  item328: ["item328", "left328", "icon328", "title337"],
  left328: ["left328", "icon328"],
  icon328: ["icon328"],
  title337: ["title337"],
  item329: ["item329", "left329", "icon329", "title338"],
  left329: ["left329", "icon329"],
  icon329: ["icon329"],
  title338: ["title338"],
  item330: ["item330", "left330", "icon330", "title339"],
  left330: ["left330", "icon330"],
  icon330: ["icon330"],
  title339: ["title339"],
  item331: ["item331", "left331", "icon331", "title340"],
  left331: ["left331", "icon331"],
  icon331: ["icon331"],
  title340: ["title340"],
  item332: ["item332", "left332", "icon332", "title341"],
  left332: ["left332", "icon332"],
  icon332: ["icon332"],
  title341: ["title341"],
  item333: ["item333", "left333", "icon333", "title342"],
  left333: ["left333", "icon333"],
  icon333: ["icon333"],
  title342: ["title342"],
  item334: ["item334", "left334", "icon334", "title343"],
  left334: ["left334", "icon334"],
  icon334: ["icon334"],
  title343: ["title343"],
  item335: ["item335", "left335", "icon335", "title344"],
  left335: ["left335", "icon335"],
  icon335: ["icon335"],
  title344: ["title344"],
  item336: ["item336", "left336", "icon336", "title345"],
  left336: ["left336", "icon336"],
  icon336: ["icon336"],
  title345: ["title345"],
  btn6: ["btn6"],
  row4: [
    "row4",
    "figmaPaste3",
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7",
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  figmaPaste3: [
    "figmaPaste3",
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7",
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  narrowCard7: [
    "narrowCard7",
    "header24",
    "title346",
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7"
  ],
  header24: ["header24", "title346"],
  title346: ["title346"],
  content7: [
    "content7",
    "desc7",
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370",
    "btn7"
  ],
  desc7: ["desc7"],
  placeholder7: [
    "placeholder7",
    "header25",
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370"
  ],
  header25: ["header25"],
  list22: [
    "list22",
    "item337",
    "left337",
    "icon337",
    "title347",
    "item338",
    "left338",
    "icon338",
    "title348",
    "item339",
    "left339",
    "icon339",
    "title349",
    "item340",
    "left340",
    "icon340",
    "title350",
    "item341",
    "left341",
    "icon341",
    "title351",
    "item342",
    "left342",
    "icon342",
    "title352",
    "item343",
    "left343",
    "icon343",
    "title353",
    "item344",
    "left344",
    "icon344",
    "title354",
    "item345",
    "left345",
    "icon345",
    "title355",
    "item346",
    "left346",
    "icon346",
    "title356",
    "item347",
    "left347",
    "icon347",
    "title357",
    "item348",
    "left348",
    "icon348",
    "title358",
    "item349",
    "left349",
    "icon349",
    "title359",
    "item350",
    "left350",
    "icon350",
    "title360",
    "item351",
    "left351",
    "icon351",
    "title361",
    "item352",
    "left352",
    "icon352",
    "title362",
    "item353",
    "left353",
    "icon353",
    "title363",
    "item354",
    "left354",
    "icon354",
    "title364",
    "item355",
    "left355",
    "icon355",
    "title365",
    "item356",
    "left356",
    "icon356",
    "title366",
    "item357",
    "left357",
    "icon357",
    "title367",
    "item358",
    "left358",
    "icon358",
    "title368",
    "item359",
    "left359",
    "icon359",
    "title369",
    "item360",
    "left360",
    "icon360",
    "title370"
  ],
  item337: ["item337", "left337", "icon337", "title347"],
  left337: ["left337", "icon337"],
  icon337: ["icon337"],
  title347: ["title347"],
  item338: ["item338", "left338", "icon338", "title348"],
  left338: ["left338", "icon338"],
  icon338: ["icon338"],
  title348: ["title348"],
  item339: ["item339", "left339", "icon339", "title349"],
  left339: ["left339", "icon339"],
  icon339: ["icon339"],
  title349: ["title349"],
  item340: ["item340", "left340", "icon340", "title350"],
  left340: ["left340", "icon340"],
  icon340: ["icon340"],
  title350: ["title350"],
  item341: ["item341", "left341", "icon341", "title351"],
  left341: ["left341", "icon341"],
  icon341: ["icon341"],
  title351: ["title351"],
  item342: ["item342", "left342", "icon342", "title352"],
  left342: ["left342", "icon342"],
  icon342: ["icon342"],
  title352: ["title352"],
  item343: ["item343", "left343", "icon343", "title353"],
  left343: ["left343", "icon343"],
  icon343: ["icon343"],
  title353: ["title353"],
  item344: ["item344", "left344", "icon344", "title354"],
  left344: ["left344", "icon344"],
  icon344: ["icon344"],
  title354: ["title354"],
  item345: ["item345", "left345", "icon345", "title355"],
  left345: ["left345", "icon345"],
  icon345: ["icon345"],
  title355: ["title355"],
  item346: ["item346", "left346", "icon346", "title356"],
  left346: ["left346", "icon346"],
  icon346: ["icon346"],
  title356: ["title356"],
  item347: ["item347", "left347", "icon347", "title357"],
  left347: ["left347", "icon347"],
  icon347: ["icon347"],
  title357: ["title357"],
  item348: ["item348", "left348", "icon348", "title358"],
  left348: ["left348", "icon348"],
  icon348: ["icon348"],
  title358: ["title358"],
  item349: ["item349", "left349", "icon349", "title359"],
  left349: ["left349", "icon349"],
  icon349: ["icon349"],
  title359: ["title359"],
  item350: ["item350", "left350", "icon350", "title360"],
  left350: ["left350", "icon350"],
  icon350: ["icon350"],
  title360: ["title360"],
  item351: ["item351", "left351", "icon351", "title361"],
  left351: ["left351", "icon351"],
  icon351: ["icon351"],
  title361: ["title361"],
  item352: ["item352", "left352", "icon352", "title362"],
  left352: ["left352", "icon352"],
  icon352: ["icon352"],
  title362: ["title362"],
  item353: ["item353", "left353", "icon353", "title363"],
  left353: ["left353", "icon353"],
  icon353: ["icon353"],
  title363: ["title363"],
  item354: ["item354", "left354", "icon354", "title364"],
  left354: ["left354", "icon354"],
  icon354: ["icon354"],
  title364: ["title364"],
  item355: ["item355", "left355", "icon355", "title365"],
  left355: ["left355", "icon355"],
  icon355: ["icon355"],
  title365: ["title365"],
  item356: ["item356", "left356", "icon356", "title366"],
  left356: ["left356", "icon356"],
  icon356: ["icon356"],
  title366: ["title366"],
  item357: ["item357", "left357", "icon357", "title367"],
  left357: ["left357", "icon357"],
  icon357: ["icon357"],
  title367: ["title367"],
  item358: ["item358", "left358", "icon358", "title368"],
  left358: ["left358", "icon358"],
  icon358: ["icon358"],
  title368: ["title368"],
  item359: ["item359", "left359", "icon359", "title369"],
  left359: ["left359", "icon359"],
  icon359: ["icon359"],
  title369: ["title369"],
  item360: ["item360", "left360", "icon360", "title370"],
  left360: ["left360", "icon360"],
  icon360: ["icon360"],
  title370: ["title370"],
  btn7: ["btn7"],
  narrowCard8: [
    "narrowCard8",
    "header26",
    "title371",
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  header26: ["header26", "title371"],
  title371: ["title371"],
  content8: [
    "content8",
    "desc8",
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395",
    "btn8"
  ],
  desc8: ["desc8"],
  placeholder8: [
    "placeholder8",
    "header27",
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395"
  ],
  header27: ["header27"],
  list23: [
    "list23",
    "item361",
    "left361",
    "icon361",
    "title372",
    "item362",
    "left362",
    "icon362",
    "title373",
    "item363",
    "left363",
    "icon363",
    "title374",
    "item364",
    "left364",
    "icon364",
    "title375",
    "item365",
    "left365",
    "icon365",
    "title376",
    "item366",
    "left366",
    "icon366",
    "title377",
    "item367",
    "left367",
    "icon367",
    "title378",
    "item368",
    "left368",
    "icon368",
    "title379",
    "item369",
    "left369",
    "icon369",
    "title380",
    "item370",
    "left370",
    "icon370",
    "title381",
    "item371",
    "left371",
    "icon371",
    "title382",
    "item372",
    "left372",
    "icon372",
    "title383",
    "item373",
    "left373",
    "icon373",
    "title384",
    "item374",
    "left374",
    "icon374",
    "title385",
    "item375",
    "left375",
    "icon375",
    "title386",
    "item376",
    "left376",
    "icon376",
    "title387",
    "item377",
    "left377",
    "icon377",
    "title388",
    "item378",
    "left378",
    "icon378",
    "title389",
    "item379",
    "left379",
    "icon379",
    "title390",
    "item380",
    "left380",
    "icon380",
    "title391",
    "item381",
    "left381",
    "icon381",
    "title392",
    "item382",
    "left382",
    "icon382",
    "title393",
    "item383",
    "left383",
    "icon383",
    "title394",
    "item384",
    "left384",
    "icon384",
    "title395"
  ],
  item361: ["item361", "left361", "icon361", "title372"],
  left361: ["left361", "icon361"],
  icon361: ["icon361"],
  title372: ["title372"],
  item362: ["item362", "left362", "icon362", "title373"],
  left362: ["left362", "icon362"],
  icon362: ["icon362"],
  title373: ["title373"],
  item363: ["item363", "left363", "icon363", "title374"],
  left363: ["left363", "icon363"],
  icon363: ["icon363"],
  title374: ["title374"],
  item364: ["item364", "left364", "icon364", "title375"],
  left364: ["left364", "icon364"],
  icon364: ["icon364"],
  title375: ["title375"],
  item365: ["item365", "left365", "icon365", "title376"],
  left365: ["left365", "icon365"],
  icon365: ["icon365"],
  title376: ["title376"],
  item366: ["item366", "left366", "icon366", "title377"],
  left366: ["left366", "icon366"],
  icon366: ["icon366"],
  title377: ["title377"],
  item367: ["item367", "left367", "icon367", "title378"],
  left367: ["left367", "icon367"],
  icon367: ["icon367"],
  title378: ["title378"],
  item368: ["item368", "left368", "icon368", "title379"],
  left368: ["left368", "icon368"],
  icon368: ["icon368"],
  title379: ["title379"],
  item369: ["item369", "left369", "icon369", "title380"],
  left369: ["left369", "icon369"],
  icon369: ["icon369"],
  title380: ["title380"],
  item370: ["item370", "left370", "icon370", "title381"],
  left370: ["left370", "icon370"],
  icon370: ["icon370"],
  title381: ["title381"],
  item371: ["item371", "left371", "icon371", "title382"],
  left371: ["left371", "icon371"],
  icon371: ["icon371"],
  title382: ["title382"],
  item372: ["item372", "left372", "icon372", "title383"],
  left372: ["left372", "icon372"],
  icon372: ["icon372"],
  title383: ["title383"],
  item373: ["item373", "left373", "icon373", "title384"],
  left373: ["left373", "icon373"],
  icon373: ["icon373"],
  title384: ["title384"],
  item374: ["item374", "left374", "icon374", "title385"],
  left374: ["left374", "icon374"],
  icon374: ["icon374"],
  title385: ["title385"],
  item375: ["item375", "left375", "icon375", "title386"],
  left375: ["left375", "icon375"],
  icon375: ["icon375"],
  title386: ["title386"],
  item376: ["item376", "left376", "icon376", "title387"],
  left376: ["left376", "icon376"],
  icon376: ["icon376"],
  title387: ["title387"],
  item377: ["item377", "left377", "icon377", "title388"],
  left377: ["left377", "icon377"],
  icon377: ["icon377"],
  title388: ["title388"],
  item378: ["item378", "left378", "icon378", "title389"],
  left378: ["left378", "icon378"],
  icon378: ["icon378"],
  title389: ["title389"],
  item379: ["item379", "left379", "icon379", "title390"],
  left379: ["left379", "icon379"],
  icon379: ["icon379"],
  title390: ["title390"],
  item380: ["item380", "left380", "icon380", "title391"],
  left380: ["left380", "icon380"],
  icon380: ["icon380"],
  title391: ["title391"],
  item381: ["item381", "left381", "icon381", "title392"],
  left381: ["left381", "icon381"],
  icon381: ["icon381"],
  title392: ["title392"],
  item382: ["item382", "left382", "icon382", "title393"],
  left382: ["left382", "icon382"],
  icon382: ["icon382"],
  title393: ["title393"],
  item383: ["item383", "left383", "icon383", "title394"],
  left383: ["left383", "icon383"],
  icon383: ["icon383"],
  title394: ["title394"],
  item384: ["item384", "left384", "icon384", "title395"],
  left384: ["left384", "icon384"],
  icon384: ["icon384"],
  title395: ["title395"],
  btn8: ["btn8"],
  tablet: [
    "tablet",
    "row6",
    "featuresProductHeader",
    "key4",
    "header4",
    "list11",
    "row7",
    "figmaPaste5",
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17",
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18",
    "row8",
    "figmaPaste6",
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19",
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20",
    "narrowCard21",
    "header44",
    "title502",
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21",
    "narrowCard22",
    "header46",
    "title527",
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22",
    "row9",
    "figmaPaste7",
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23",
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24",
    "row10",
    "row11",
    "figmaPaste8",
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25",
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26",
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  row6: ["row6", "featuresProductHeader"],
  featuresProductHeader: ["featuresProductHeader"],
  key4: [
    "key4",
    "header4",
    "list11",
    "row7",
    "figmaPaste5",
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17",
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18",
    "row8",
    "figmaPaste6",
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19",
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20",
    "narrowCard21",
    "header44",
    "title502",
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21",
    "narrowCard22",
    "header46",
    "title527",
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22",
    "row9",
    "figmaPaste7",
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23",
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24",
    "row10",
    "row11",
    "figmaPaste8",
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25",
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26"
  ],
  header4: ["header4"],
  list11: [
    "list11",
    "row7",
    "figmaPaste5",
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17",
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18",
    "row8",
    "figmaPaste6",
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19",
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20",
    "narrowCard21",
    "header44",
    "title502",
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21",
    "narrowCard22",
    "header46",
    "title527",
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22",
    "row9",
    "figmaPaste7",
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23",
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24",
    "row10",
    "row11",
    "figmaPaste8",
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25",
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26"
  ],
  row7: [
    "row7",
    "figmaPaste5",
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17",
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18"
  ],
  figmaPaste5: [
    "figmaPaste5",
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17",
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18"
  ],
  narrowCard17: [
    "narrowCard17",
    "header9",
    "title100",
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17"
  ],
  header9: ["header9", "title100"],
  title100: ["title100"],
  content17: [
    "content17",
    "desc17",
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123",
    "btn17"
  ],
  desc17: ["desc17"],
  placeholder17: [
    "placeholder17",
    "header10",
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123"
  ],
  header10: ["header10"],
  list7: [
    "list7",
    "item97",
    "left97",
    "icon97",
    "title2",
    "item98",
    "left98",
    "icon98",
    "title101",
    "item99",
    "left99",
    "icon99",
    "title102",
    "item100",
    "left100",
    "icon100",
    "title103",
    "item101",
    "left101",
    "icon101",
    "title104",
    "item102",
    "left102",
    "icon102",
    "title105",
    "item103",
    "left103",
    "icon103",
    "title106",
    "item104",
    "left104",
    "icon104",
    "title107",
    "item105",
    "left105",
    "icon105",
    "title108",
    "item106",
    "left106",
    "icon106",
    "title109",
    "item107",
    "left107",
    "icon107",
    "title110",
    "item108",
    "left108",
    "icon108",
    "title111",
    "item109",
    "left109",
    "icon109",
    "title112",
    "item110",
    "left110",
    "icon110",
    "title113",
    "item111",
    "left111",
    "icon111",
    "title114",
    "item112",
    "left112",
    "icon112",
    "title115",
    "item113",
    "left113",
    "icon113",
    "title116",
    "item114",
    "left114",
    "icon114",
    "title117",
    "item115",
    "left115",
    "icon115",
    "title118",
    "item116",
    "left116",
    "icon116",
    "title119",
    "item117",
    "left117",
    "icon117",
    "title120",
    "item118",
    "left118",
    "icon118",
    "title121",
    "item119",
    "left119",
    "icon119",
    "title122",
    "item120",
    "left120",
    "icon120",
    "title123"
  ],
  item97: ["item97", "left97", "icon97", "title2"],
  left97: ["left97", "icon97"],
  icon97: ["icon97"],
  title2: ["title2"],
  item98: ["item98", "left98", "icon98", "title101"],
  left98: ["left98", "icon98"],
  icon98: ["icon98"],
  title101: ["title101"],
  item99: ["item99", "left99", "icon99", "title102"],
  left99: ["left99", "icon99"],
  icon99: ["icon99"],
  title102: ["title102"],
  item100: ["item100", "left100", "icon100", "title103"],
  left100: ["left100", "icon100"],
  icon100: ["icon100"],
  title103: ["title103"],
  item101: ["item101", "left101", "icon101", "title104"],
  left101: ["left101", "icon101"],
  icon101: ["icon101"],
  title104: ["title104"],
  item102: ["item102", "left102", "icon102", "title105"],
  left102: ["left102", "icon102"],
  icon102: ["icon102"],
  title105: ["title105"],
  item103: ["item103", "left103", "icon103", "title106"],
  left103: ["left103", "icon103"],
  icon103: ["icon103"],
  title106: ["title106"],
  item104: ["item104", "left104", "icon104", "title107"],
  left104: ["left104", "icon104"],
  icon104: ["icon104"],
  title107: ["title107"],
  item105: ["item105", "left105", "icon105", "title108"],
  left105: ["left105", "icon105"],
  icon105: ["icon105"],
  title108: ["title108"],
  item106: ["item106", "left106", "icon106", "title109"],
  left106: ["left106", "icon106"],
  icon106: ["icon106"],
  title109: ["title109"],
  item107: ["item107", "left107", "icon107", "title110"],
  left107: ["left107", "icon107"],
  icon107: ["icon107"],
  title110: ["title110"],
  item108: ["item108", "left108", "icon108", "title111"],
  left108: ["left108", "icon108"],
  icon108: ["icon108"],
  title111: ["title111"],
  item109: ["item109", "left109", "icon109", "title112"],
  left109: ["left109", "icon109"],
  icon109: ["icon109"],
  title112: ["title112"],
  item110: ["item110", "left110", "icon110", "title113"],
  left110: ["left110", "icon110"],
  icon110: ["icon110"],
  title113: ["title113"],
  item111: ["item111", "left111", "icon111", "title114"],
  left111: ["left111", "icon111"],
  icon111: ["icon111"],
  title114: ["title114"],
  item112: ["item112", "left112", "icon112", "title115"],
  left112: ["left112", "icon112"],
  icon112: ["icon112"],
  title115: ["title115"],
  item113: ["item113", "left113", "icon113", "title116"],
  left113: ["left113", "icon113"],
  icon113: ["icon113"],
  title116: ["title116"],
  item114: ["item114", "left114", "icon114", "title117"],
  left114: ["left114", "icon114"],
  icon114: ["icon114"],
  title117: ["title117"],
  item115: ["item115", "left115", "icon115", "title118"],
  left115: ["left115", "icon115"],
  icon115: ["icon115"],
  title118: ["title118"],
  item116: ["item116", "left116", "icon116", "title119"],
  left116: ["left116", "icon116"],
  icon116: ["icon116"],
  title119: ["title119"],
  item117: ["item117", "left117", "icon117", "title120"],
  left117: ["left117", "icon117"],
  icon117: ["icon117"],
  title120: ["title120"],
  item118: ["item118", "left118", "icon118", "title121"],
  left118: ["left118", "icon118"],
  icon118: ["icon118"],
  title121: ["title121"],
  item119: ["item119", "left119", "icon119", "title122"],
  left119: ["left119", "icon119"],
  icon119: ["icon119"],
  title122: ["title122"],
  item120: ["item120", "left120", "icon120", "title123"],
  left120: ["left120", "icon120"],
  icon120: ["icon120"],
  title123: ["title123"],
  btn17: ["btn17"],
  narrowCard18: [
    "narrowCard18",
    "header11",
    "title124",
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18"
  ],
  header11: ["header11", "title124"],
  title124: ["title124"],
  content18: [
    "content18",
    "desc18",
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148",
    "btn18"
  ],
  desc18: ["desc18"],
  placeholder18: [
    "placeholder18",
    "header12",
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148"
  ],
  header12: ["header12"],
  list8: [
    "list8",
    "item121",
    "left121",
    "icon121",
    "title125",
    "item122",
    "left122",
    "icon122",
    "title126",
    "item123",
    "left123",
    "icon123",
    "title127",
    "item124",
    "left124",
    "icon124",
    "title128",
    "item125",
    "left125",
    "icon125",
    "title129",
    "item126",
    "left126",
    "icon126",
    "title130",
    "item127",
    "left127",
    "icon127",
    "title131",
    "item128",
    "left128",
    "icon128",
    "title132",
    "item129",
    "left129",
    "icon129",
    "title133",
    "item130",
    "left130",
    "icon130",
    "title134",
    "item131",
    "left131",
    "icon131",
    "title135",
    "item132",
    "left132",
    "icon132",
    "title136",
    "item133",
    "left133",
    "icon133",
    "title137",
    "item134",
    "left134",
    "icon134",
    "title138",
    "item135",
    "left135",
    "icon135",
    "title139",
    "item136",
    "left136",
    "icon136",
    "title140",
    "item137",
    "left137",
    "icon137",
    "title141",
    "item138",
    "left138",
    "icon138",
    "title142",
    "item139",
    "left139",
    "icon139",
    "title143",
    "item140",
    "left140",
    "icon140",
    "title144",
    "item141",
    "left141",
    "icon141",
    "title145",
    "item142",
    "left142",
    "icon142",
    "title146",
    "item143",
    "left143",
    "icon143",
    "title147",
    "item144",
    "left144",
    "icon144",
    "title148"
  ],
  item121: ["item121", "left121", "icon121", "title125"],
  left121: ["left121", "icon121"],
  icon121: ["icon121"],
  title125: ["title125"],
  item122: ["item122", "left122", "icon122", "title126"],
  left122: ["left122", "icon122"],
  icon122: ["icon122"],
  title126: ["title126"],
  item123: ["item123", "left123", "icon123", "title127"],
  left123: ["left123", "icon123"],
  icon123: ["icon123"],
  title127: ["title127"],
  item124: ["item124", "left124", "icon124", "title128"],
  left124: ["left124", "icon124"],
  icon124: ["icon124"],
  title128: ["title128"],
  item125: ["item125", "left125", "icon125", "title129"],
  left125: ["left125", "icon125"],
  icon125: ["icon125"],
  title129: ["title129"],
  item126: ["item126", "left126", "icon126", "title130"],
  left126: ["left126", "icon126"],
  icon126: ["icon126"],
  title130: ["title130"],
  item127: ["item127", "left127", "icon127", "title131"],
  left127: ["left127", "icon127"],
  icon127: ["icon127"],
  title131: ["title131"],
  item128: ["item128", "left128", "icon128", "title132"],
  left128: ["left128", "icon128"],
  icon128: ["icon128"],
  title132: ["title132"],
  item129: ["item129", "left129", "icon129", "title133"],
  left129: ["left129", "icon129"],
  icon129: ["icon129"],
  title133: ["title133"],
  item130: ["item130", "left130", "icon130", "title134"],
  left130: ["left130", "icon130"],
  icon130: ["icon130"],
  title134: ["title134"],
  item131: ["item131", "left131", "icon131", "title135"],
  left131: ["left131", "icon131"],
  icon131: ["icon131"],
  title135: ["title135"],
  item132: ["item132", "left132", "icon132", "title136"],
  left132: ["left132", "icon132"],
  icon132: ["icon132"],
  title136: ["title136"],
  item133: ["item133", "left133", "icon133", "title137"],
  left133: ["left133", "icon133"],
  icon133: ["icon133"],
  title137: ["title137"],
  item134: ["item134", "left134", "icon134", "title138"],
  left134: ["left134", "icon134"],
  icon134: ["icon134"],
  title138: ["title138"],
  item135: ["item135", "left135", "icon135", "title139"],
  left135: ["left135", "icon135"],
  icon135: ["icon135"],
  title139: ["title139"],
  item136: ["item136", "left136", "icon136", "title140"],
  left136: ["left136", "icon136"],
  icon136: ["icon136"],
  title140: ["title140"],
  item137: ["item137", "left137", "icon137", "title141"],
  left137: ["left137", "icon137"],
  icon137: ["icon137"],
  title141: ["title141"],
  item138: ["item138", "left138", "icon138", "title142"],
  left138: ["left138", "icon138"],
  icon138: ["icon138"],
  title142: ["title142"],
  item139: ["item139", "left139", "icon139", "title143"],
  left139: ["left139", "icon139"],
  icon139: ["icon139"],
  title143: ["title143"],
  item140: ["item140", "left140", "icon140", "title144"],
  left140: ["left140", "icon140"],
  icon140: ["icon140"],
  title144: ["title144"],
  item141: ["item141", "left141", "icon141", "title145"],
  left141: ["left141", "icon141"],
  icon141: ["icon141"],
  title145: ["title145"],
  item142: ["item142", "left142", "icon142", "title146"],
  left142: ["left142", "icon142"],
  icon142: ["icon142"],
  title146: ["title146"],
  item143: ["item143", "left143", "icon143", "title147"],
  left143: ["left143", "icon143"],
  icon143: ["icon143"],
  title147: ["title147"],
  item144: ["item144", "left144", "icon144", "title148"],
  left144: ["left144", "icon144"],
  icon144: ["icon144"],
  title148: ["title148"],
  btn18: ["btn18"],
  row8: [
    "row8",
    "figmaPaste6",
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19",
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20",
    "narrowCard21",
    "header44",
    "title502",
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21",
    "narrowCard22",
    "header46",
    "title527",
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22"
  ],
  figmaPaste6: [
    "figmaPaste6",
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19",
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20"
  ],
  narrowCard19: [
    "narrowCard19",
    "header40",
    "title149",
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19"
  ],
  header40: ["header40", "title149"],
  title149: ["title149"],
  content19: [
    "content19",
    "desc19",
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173",
    "btn19"
  ],
  desc19: ["desc19"],
  placeholder19: [
    "placeholder19",
    "header41",
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173"
  ],
  header41: ["header41"],
  list9: [
    "list9",
    "item145",
    "left145",
    "icon145",
    "title150",
    "item146",
    "left146",
    "icon146",
    "title151",
    "item147",
    "left147",
    "icon147",
    "title152",
    "item148",
    "left148",
    "icon148",
    "title153",
    "item149",
    "left149",
    "icon149",
    "title154",
    "item150",
    "left150",
    "icon150",
    "title155",
    "item151",
    "left151",
    "icon151",
    "title156",
    "item152",
    "left152",
    "icon152",
    "title157",
    "item153",
    "left153",
    "icon153",
    "title158",
    "item154",
    "left154",
    "icon154",
    "title159",
    "item155",
    "left155",
    "icon155",
    "title160",
    "item156",
    "left156",
    "icon156",
    "title161",
    "item157",
    "left157",
    "icon157",
    "title162",
    "item158",
    "left158",
    "icon158",
    "title163",
    "item159",
    "left159",
    "icon159",
    "title164",
    "item160",
    "left160",
    "icon160",
    "title165",
    "item161",
    "left161",
    "icon161",
    "title166",
    "item162",
    "left162",
    "icon162",
    "title167",
    "item163",
    "left163",
    "icon163",
    "title168",
    "item164",
    "left164",
    "icon164",
    "title169",
    "item165",
    "left165",
    "icon165",
    "title170",
    "item166",
    "left166",
    "icon166",
    "title171",
    "item167",
    "left167",
    "icon167",
    "title172",
    "item168",
    "left168",
    "icon168",
    "title173"
  ],
  item145: ["item145", "left145", "icon145", "title150"],
  left145: ["left145", "icon145"],
  icon145: ["icon145"],
  title150: ["title150"],
  item146: ["item146", "left146", "icon146", "title151"],
  left146: ["left146", "icon146"],
  icon146: ["icon146"],
  title151: ["title151"],
  item147: ["item147", "left147", "icon147", "title152"],
  left147: ["left147", "icon147"],
  icon147: ["icon147"],
  title152: ["title152"],
  item148: ["item148", "left148", "icon148", "title153"],
  left148: ["left148", "icon148"],
  icon148: ["icon148"],
  title153: ["title153"],
  item149: ["item149", "left149", "icon149", "title154"],
  left149: ["left149", "icon149"],
  icon149: ["icon149"],
  title154: ["title154"],
  item150: ["item150", "left150", "icon150", "title155"],
  left150: ["left150", "icon150"],
  icon150: ["icon150"],
  title155: ["title155"],
  item151: ["item151", "left151", "icon151", "title156"],
  left151: ["left151", "icon151"],
  icon151: ["icon151"],
  title156: ["title156"],
  item152: ["item152", "left152", "icon152", "title157"],
  left152: ["left152", "icon152"],
  icon152: ["icon152"],
  title157: ["title157"],
  item153: ["item153", "left153", "icon153", "title158"],
  left153: ["left153", "icon153"],
  icon153: ["icon153"],
  title158: ["title158"],
  item154: ["item154", "left154", "icon154", "title159"],
  left154: ["left154", "icon154"],
  icon154: ["icon154"],
  title159: ["title159"],
  item155: ["item155", "left155", "icon155", "title160"],
  left155: ["left155", "icon155"],
  icon155: ["icon155"],
  title160: ["title160"],
  item156: ["item156", "left156", "icon156", "title161"],
  left156: ["left156", "icon156"],
  icon156: ["icon156"],
  title161: ["title161"],
  item157: ["item157", "left157", "icon157", "title162"],
  left157: ["left157", "icon157"],
  icon157: ["icon157"],
  title162: ["title162"],
  item158: ["item158", "left158", "icon158", "title163"],
  left158: ["left158", "icon158"],
  icon158: ["icon158"],
  title163: ["title163"],
  item159: ["item159", "left159", "icon159", "title164"],
  left159: ["left159", "icon159"],
  icon159: ["icon159"],
  title164: ["title164"],
  item160: ["item160", "left160", "icon160", "title165"],
  left160: ["left160", "icon160"],
  icon160: ["icon160"],
  title165: ["title165"],
  item161: ["item161", "left161", "icon161", "title166"],
  left161: ["left161", "icon161"],
  icon161: ["icon161"],
  title166: ["title166"],
  item162: ["item162", "left162", "icon162", "title167"],
  left162: ["left162", "icon162"],
  icon162: ["icon162"],
  title167: ["title167"],
  item163: ["item163", "left163", "icon163", "title168"],
  left163: ["left163", "icon163"],
  icon163: ["icon163"],
  title168: ["title168"],
  item164: ["item164", "left164", "icon164", "title169"],
  left164: ["left164", "icon164"],
  icon164: ["icon164"],
  title169: ["title169"],
  item165: ["item165", "left165", "icon165", "title170"],
  left165: ["left165", "icon165"],
  icon165: ["icon165"],
  title170: ["title170"],
  item166: ["item166", "left166", "icon166", "title171"],
  left166: ["left166", "icon166"],
  icon166: ["icon166"],
  title171: ["title171"],
  item167: ["item167", "left167", "icon167", "title172"],
  left167: ["left167", "icon167"],
  icon167: ["icon167"],
  title172: ["title172"],
  item168: ["item168", "left168", "icon168", "title173"],
  left168: ["left168", "icon168"],
  icon168: ["icon168"],
  title173: ["title173"],
  btn19: ["btn19"],
  narrowCard20: [
    "narrowCard20",
    "header42",
    "title174",
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20"
  ],
  header42: ["header42", "title174"],
  title174: ["title174"],
  content20: [
    "content20",
    "desc20",
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501",
    "btn20"
  ],
  desc20: ["desc20"],
  placeholder20: [
    "placeholder20",
    "header43",
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501"
  ],
  header43: ["header43"],
  list10: [
    "list10",
    "item169",
    "left169",
    "icon169",
    "title175",
    "item170",
    "left170",
    "icon170",
    "title176",
    "item171",
    "left171",
    "icon171",
    "title177",
    "item172",
    "left172",
    "icon172",
    "title178",
    "item173",
    "left173",
    "icon173",
    "title179",
    "item174",
    "left174",
    "icon174",
    "title180",
    "item175",
    "left175",
    "icon175",
    "title181",
    "item176",
    "left176",
    "icon176",
    "title182",
    "item177",
    "left177",
    "icon177",
    "title183",
    "item178",
    "left178",
    "icon178",
    "title184",
    "item179",
    "left179",
    "icon179",
    "title185",
    "item180",
    "left180",
    "icon180",
    "title186",
    "item181",
    "left181",
    "icon181",
    "title187",
    "item182",
    "left182",
    "icon182",
    "title188",
    "item183",
    "left183",
    "icon183",
    "title189",
    "item184",
    "left184",
    "icon184",
    "title190",
    "item185",
    "left185",
    "icon185",
    "title191",
    "item186",
    "left186",
    "icon186",
    "title192",
    "item187",
    "left187",
    "icon187",
    "title193",
    "item188",
    "left188",
    "icon188",
    "title194",
    "item189",
    "left189",
    "icon189",
    "title195",
    "item190",
    "left190",
    "icon190",
    "title499",
    "item191",
    "left191",
    "icon191",
    "title500",
    "item192",
    "left192",
    "icon192",
    "title501"
  ],
  item169: ["item169", "left169", "icon169", "title175"],
  left169: ["left169", "icon169"],
  icon169: ["icon169"],
  title175: ["title175"],
  item170: ["item170", "left170", "icon170", "title176"],
  left170: ["left170", "icon170"],
  icon170: ["icon170"],
  title176: ["title176"],
  item171: ["item171", "left171", "icon171", "title177"],
  left171: ["left171", "icon171"],
  icon171: ["icon171"],
  title177: ["title177"],
  item172: ["item172", "left172", "icon172", "title178"],
  left172: ["left172", "icon172"],
  icon172: ["icon172"],
  title178: ["title178"],
  item173: ["item173", "left173", "icon173", "title179"],
  left173: ["left173", "icon173"],
  icon173: ["icon173"],
  title179: ["title179"],
  item174: ["item174", "left174", "icon174", "title180"],
  left174: ["left174", "icon174"],
  icon174: ["icon174"],
  title180: ["title180"],
  item175: ["item175", "left175", "icon175", "title181"],
  left175: ["left175", "icon175"],
  icon175: ["icon175"],
  title181: ["title181"],
  item176: ["item176", "left176", "icon176", "title182"],
  left176: ["left176", "icon176"],
  icon176: ["icon176"],
  title182: ["title182"],
  item177: ["item177", "left177", "icon177", "title183"],
  left177: ["left177", "icon177"],
  icon177: ["icon177"],
  title183: ["title183"],
  item178: ["item178", "left178", "icon178", "title184"],
  left178: ["left178", "icon178"],
  icon178: ["icon178"],
  title184: ["title184"],
  item179: ["item179", "left179", "icon179", "title185"],
  left179: ["left179", "icon179"],
  icon179: ["icon179"],
  title185: ["title185"],
  item180: ["item180", "left180", "icon180", "title186"],
  left180: ["left180", "icon180"],
  icon180: ["icon180"],
  title186: ["title186"],
  item181: ["item181", "left181", "icon181", "title187"],
  left181: ["left181", "icon181"],
  icon181: ["icon181"],
  title187: ["title187"],
  item182: ["item182", "left182", "icon182", "title188"],
  left182: ["left182", "icon182"],
  icon182: ["icon182"],
  title188: ["title188"],
  item183: ["item183", "left183", "icon183", "title189"],
  left183: ["left183", "icon183"],
  icon183: ["icon183"],
  title189: ["title189"],
  item184: ["item184", "left184", "icon184", "title190"],
  left184: ["left184", "icon184"],
  icon184: ["icon184"],
  title190: ["title190"],
  item185: ["item185", "left185", "icon185", "title191"],
  left185: ["left185", "icon185"],
  icon185: ["icon185"],
  title191: ["title191"],
  item186: ["item186", "left186", "icon186", "title192"],
  left186: ["left186", "icon186"],
  icon186: ["icon186"],
  title192: ["title192"],
  item187: ["item187", "left187", "icon187", "title193"],
  left187: ["left187", "icon187"],
  icon187: ["icon187"],
  title193: ["title193"],
  item188: ["item188", "left188", "icon188", "title194"],
  left188: ["left188", "icon188"],
  icon188: ["icon188"],
  title194: ["title194"],
  item189: ["item189", "left189", "icon189", "title195"],
  left189: ["left189", "icon189"],
  icon189: ["icon189"],
  title195: ["title195"],
  item190: ["item190", "left190", "icon190", "title499"],
  left190: ["left190", "icon190"],
  icon190: ["icon190"],
  title499: ["title499"],
  item191: ["item191", "left191", "icon191", "title500"],
  left191: ["left191", "icon191"],
  icon191: ["icon191"],
  title500: ["title500"],
  item192: ["item192", "left192", "icon192", "title501"],
  left192: ["left192", "icon192"],
  icon192: ["icon192"],
  title501: ["title501"],
  btn20: ["btn20"],
  narrowCard21: [
    "narrowCard21",
    "header44",
    "title502",
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21"
  ],
  header44: ["header44", "title502"],
  title502: ["title502"],
  content21: [
    "content21",
    "desc21",
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526",
    "btn21"
  ],
  desc21: ["desc21"],
  placeholder21: [
    "placeholder21",
    "header45",
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526"
  ],
  header45: ["header45"],
  list28: [
    "list28",
    "item481",
    "left481",
    "icon481",
    "title503",
    "item482",
    "left482",
    "icon482",
    "title504",
    "item483",
    "left483",
    "icon483",
    "title505",
    "item484",
    "left484",
    "icon484",
    "title506",
    "item485",
    "left485",
    "icon485",
    "title507",
    "item486",
    "left486",
    "icon486",
    "title508",
    "item487",
    "left487",
    "icon487",
    "title509",
    "item488",
    "left488",
    "icon488",
    "title510",
    "item489",
    "left489",
    "icon489",
    "title511",
    "item490",
    "left490",
    "icon490",
    "title512",
    "item491",
    "left491",
    "icon491",
    "title513",
    "item492",
    "left492",
    "icon492",
    "title514",
    "item493",
    "left493",
    "icon493",
    "title515",
    "item494",
    "left494",
    "icon494",
    "title516",
    "item495",
    "left495",
    "icon495",
    "title517",
    "item496",
    "left496",
    "icon496",
    "title518",
    "item497",
    "left497",
    "icon497",
    "title519",
    "item498",
    "left498",
    "icon498",
    "title520",
    "item499",
    "left499",
    "icon499",
    "title521",
    "item500",
    "left500",
    "icon500",
    "title522",
    "item501",
    "left501",
    "icon501",
    "title523",
    "item502",
    "left502",
    "icon502",
    "title524",
    "item503",
    "left503",
    "icon503",
    "title525",
    "item504",
    "left504",
    "icon504",
    "title526"
  ],
  item481: ["item481", "left481", "icon481", "title503"],
  left481: ["left481", "icon481"],
  icon481: ["icon481"],
  title503: ["title503"],
  item482: ["item482", "left482", "icon482", "title504"],
  left482: ["left482", "icon482"],
  icon482: ["icon482"],
  title504: ["title504"],
  item483: ["item483", "left483", "icon483", "title505"],
  left483: ["left483", "icon483"],
  icon483: ["icon483"],
  title505: ["title505"],
  item484: ["item484", "left484", "icon484", "title506"],
  left484: ["left484", "icon484"],
  icon484: ["icon484"],
  title506: ["title506"],
  item485: ["item485", "left485", "icon485", "title507"],
  left485: ["left485", "icon485"],
  icon485: ["icon485"],
  title507: ["title507"],
  item486: ["item486", "left486", "icon486", "title508"],
  left486: ["left486", "icon486"],
  icon486: ["icon486"],
  title508: ["title508"],
  item487: ["item487", "left487", "icon487", "title509"],
  left487: ["left487", "icon487"],
  icon487: ["icon487"],
  title509: ["title509"],
  item488: ["item488", "left488", "icon488", "title510"],
  left488: ["left488", "icon488"],
  icon488: ["icon488"],
  title510: ["title510"],
  item489: ["item489", "left489", "icon489", "title511"],
  left489: ["left489", "icon489"],
  icon489: ["icon489"],
  title511: ["title511"],
  item490: ["item490", "left490", "icon490", "title512"],
  left490: ["left490", "icon490"],
  icon490: ["icon490"],
  title512: ["title512"],
  item491: ["item491", "left491", "icon491", "title513"],
  left491: ["left491", "icon491"],
  icon491: ["icon491"],
  title513: ["title513"],
  item492: ["item492", "left492", "icon492", "title514"],
  left492: ["left492", "icon492"],
  icon492: ["icon492"],
  title514: ["title514"],
  item493: ["item493", "left493", "icon493", "title515"],
  left493: ["left493", "icon493"],
  icon493: ["icon493"],
  title515: ["title515"],
  item494: ["item494", "left494", "icon494", "title516"],
  left494: ["left494", "icon494"],
  icon494: ["icon494"],
  title516: ["title516"],
  item495: ["item495", "left495", "icon495", "title517"],
  left495: ["left495", "icon495"],
  icon495: ["icon495"],
  title517: ["title517"],
  item496: ["item496", "left496", "icon496", "title518"],
  left496: ["left496", "icon496"],
  icon496: ["icon496"],
  title518: ["title518"],
  item497: ["item497", "left497", "icon497", "title519"],
  left497: ["left497", "icon497"],
  icon497: ["icon497"],
  title519: ["title519"],
  item498: ["item498", "left498", "icon498", "title520"],
  left498: ["left498", "icon498"],
  icon498: ["icon498"],
  title520: ["title520"],
  item499: ["item499", "left499", "icon499", "title521"],
  left499: ["left499", "icon499"],
  icon499: ["icon499"],
  title521: ["title521"],
  item500: ["item500", "left500", "icon500", "title522"],
  left500: ["left500", "icon500"],
  icon500: ["icon500"],
  title522: ["title522"],
  item501: ["item501", "left501", "icon501", "title523"],
  left501: ["left501", "icon501"],
  icon501: ["icon501"],
  title523: ["title523"],
  item502: ["item502", "left502", "icon502", "title524"],
  left502: ["left502", "icon502"],
  icon502: ["icon502"],
  title524: ["title524"],
  item503: ["item503", "left503", "icon503", "title525"],
  left503: ["left503", "icon503"],
  icon503: ["icon503"],
  title525: ["title525"],
  item504: ["item504", "left504", "icon504", "title526"],
  left504: ["left504", "icon504"],
  icon504: ["icon504"],
  title526: ["title526"],
  btn21: ["btn21"],
  narrowCard22: [
    "narrowCard22",
    "header46",
    "title527",
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22"
  ],
  header46: ["header46", "title527"],
  title527: ["title527"],
  content22: [
    "content22",
    "desc22",
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551",
    "btn22"
  ],
  desc22: ["desc22"],
  placeholder22: [
    "placeholder22",
    "header47",
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551"
  ],
  header47: ["header47"],
  list29: [
    "list29",
    "item505",
    "left505",
    "icon505",
    "title528",
    "item506",
    "left506",
    "icon506",
    "title529",
    "item507",
    "left507",
    "icon507",
    "title530",
    "item508",
    "left508",
    "icon508",
    "title531",
    "item509",
    "left509",
    "icon509",
    "title532",
    "item510",
    "left510",
    "icon510",
    "title533",
    "item511",
    "left511",
    "icon511",
    "title534",
    "item512",
    "left512",
    "icon512",
    "title535",
    "item513",
    "left513",
    "icon513",
    "title536",
    "item514",
    "left514",
    "icon514",
    "title537",
    "item515",
    "left515",
    "icon515",
    "title538",
    "item516",
    "left516",
    "icon516",
    "title539",
    "item517",
    "left517",
    "icon517",
    "title540",
    "item518",
    "left518",
    "icon518",
    "title541",
    "item519",
    "left519",
    "icon519",
    "title542",
    "item520",
    "left520",
    "icon520",
    "title543",
    "item521",
    "left521",
    "icon521",
    "title544",
    "item522",
    "left522",
    "icon522",
    "title545",
    "item523",
    "left523",
    "icon523",
    "title546",
    "item524",
    "left524",
    "icon524",
    "title547",
    "item525",
    "left525",
    "icon525",
    "title548",
    "item526",
    "left526",
    "icon526",
    "title549",
    "item527",
    "left527",
    "icon527",
    "title550",
    "item528",
    "left528",
    "icon528",
    "title551"
  ],
  item505: ["item505", "left505", "icon505", "title528"],
  left505: ["left505", "icon505"],
  icon505: ["icon505"],
  title528: ["title528"],
  item506: ["item506", "left506", "icon506", "title529"],
  left506: ["left506", "icon506"],
  icon506: ["icon506"],
  title529: ["title529"],
  item507: ["item507", "left507", "icon507", "title530"],
  left507: ["left507", "icon507"],
  icon507: ["icon507"],
  title530: ["title530"],
  item508: ["item508", "left508", "icon508", "title531"],
  left508: ["left508", "icon508"],
  icon508: ["icon508"],
  title531: ["title531"],
  item509: ["item509", "left509", "icon509", "title532"],
  left509: ["left509", "icon509"],
  icon509: ["icon509"],
  title532: ["title532"],
  item510: ["item510", "left510", "icon510", "title533"],
  left510: ["left510", "icon510"],
  icon510: ["icon510"],
  title533: ["title533"],
  item511: ["item511", "left511", "icon511", "title534"],
  left511: ["left511", "icon511"],
  icon511: ["icon511"],
  title534: ["title534"],
  item512: ["item512", "left512", "icon512", "title535"],
  left512: ["left512", "icon512"],
  icon512: ["icon512"],
  title535: ["title535"],
  item513: ["item513", "left513", "icon513", "title536"],
  left513: ["left513", "icon513"],
  icon513: ["icon513"],
  title536: ["title536"],
  item514: ["item514", "left514", "icon514", "title537"],
  left514: ["left514", "icon514"],
  icon514: ["icon514"],
  title537: ["title537"],
  item515: ["item515", "left515", "icon515", "title538"],
  left515: ["left515", "icon515"],
  icon515: ["icon515"],
  title538: ["title538"],
  item516: ["item516", "left516", "icon516", "title539"],
  left516: ["left516", "icon516"],
  icon516: ["icon516"],
  title539: ["title539"],
  item517: ["item517", "left517", "icon517", "title540"],
  left517: ["left517", "icon517"],
  icon517: ["icon517"],
  title540: ["title540"],
  item518: ["item518", "left518", "icon518", "title541"],
  left518: ["left518", "icon518"],
  icon518: ["icon518"],
  title541: ["title541"],
  item519: ["item519", "left519", "icon519", "title542"],
  left519: ["left519", "icon519"],
  icon519: ["icon519"],
  title542: ["title542"],
  item520: ["item520", "left520", "icon520", "title543"],
  left520: ["left520", "icon520"],
  icon520: ["icon520"],
  title543: ["title543"],
  item521: ["item521", "left521", "icon521", "title544"],
  left521: ["left521", "icon521"],
  icon521: ["icon521"],
  title544: ["title544"],
  item522: ["item522", "left522", "icon522", "title545"],
  left522: ["left522", "icon522"],
  icon522: ["icon522"],
  title545: ["title545"],
  item523: ["item523", "left523", "icon523", "title546"],
  left523: ["left523", "icon523"],
  icon523: ["icon523"],
  title546: ["title546"],
  item524: ["item524", "left524", "icon524", "title547"],
  left524: ["left524", "icon524"],
  icon524: ["icon524"],
  title547: ["title547"],
  item525: ["item525", "left525", "icon525", "title548"],
  left525: ["left525", "icon525"],
  icon525: ["icon525"],
  title548: ["title548"],
  item526: ["item526", "left526", "icon526", "title549"],
  left526: ["left526", "icon526"],
  icon526: ["icon526"],
  title549: ["title549"],
  item527: ["item527", "left527", "icon527", "title550"],
  left527: ["left527", "icon527"],
  icon527: ["icon527"],
  title550: ["title550"],
  item528: ["item528", "left528", "icon528", "title551"],
  left528: ["left528", "icon528"],
  icon528: ["icon528"],
  title551: ["title551"],
  btn22: ["btn22"],
  row9: [
    "row9",
    "figmaPaste7",
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23",
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24"
  ],
  figmaPaste7: [
    "figmaPaste7",
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23",
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24"
  ],
  narrowCard23: [
    "narrowCard23",
    "header48",
    "title552",
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23"
  ],
  header48: ["header48", "title552"],
  title552: ["title552"],
  content23: [
    "content23",
    "desc23",
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576",
    "btn23"
  ],
  desc23: ["desc23"],
  placeholder23: [
    "placeholder23",
    "header49",
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576"
  ],
  header49: ["header49"],
  list30: [
    "list30",
    "item529",
    "left529",
    "icon529",
    "title553",
    "item530",
    "left530",
    "icon530",
    "title554",
    "item531",
    "left531",
    "icon531",
    "title555",
    "item532",
    "left532",
    "icon532",
    "title556",
    "item533",
    "left533",
    "icon533",
    "title557",
    "item534",
    "left534",
    "icon534",
    "title558",
    "item535",
    "left535",
    "icon535",
    "title559",
    "item536",
    "left536",
    "icon536",
    "title560",
    "item537",
    "left537",
    "icon537",
    "title561",
    "item538",
    "left538",
    "icon538",
    "title562",
    "item539",
    "left539",
    "icon539",
    "title563",
    "item540",
    "left540",
    "icon540",
    "title564",
    "item541",
    "left541",
    "icon541",
    "title565",
    "item542",
    "left542",
    "icon542",
    "title566",
    "item543",
    "left543",
    "icon543",
    "title567",
    "item544",
    "left544",
    "icon544",
    "title568",
    "item545",
    "left545",
    "icon545",
    "title569",
    "item546",
    "left546",
    "icon546",
    "title570",
    "item547",
    "left547",
    "icon547",
    "title571",
    "item548",
    "left548",
    "icon548",
    "title572",
    "item549",
    "left549",
    "icon549",
    "title573",
    "item550",
    "left550",
    "icon550",
    "title574",
    "item551",
    "left551",
    "icon551",
    "title575",
    "item552",
    "left552",
    "icon552",
    "title576"
  ],
  item529: ["item529", "left529", "icon529", "title553"],
  left529: ["left529", "icon529"],
  icon529: ["icon529"],
  title553: ["title553"],
  item530: ["item530", "left530", "icon530", "title554"],
  left530: ["left530", "icon530"],
  icon530: ["icon530"],
  title554: ["title554"],
  item531: ["item531", "left531", "icon531", "title555"],
  left531: ["left531", "icon531"],
  icon531: ["icon531"],
  title555: ["title555"],
  item532: ["item532", "left532", "icon532", "title556"],
  left532: ["left532", "icon532"],
  icon532: ["icon532"],
  title556: ["title556"],
  item533: ["item533", "left533", "icon533", "title557"],
  left533: ["left533", "icon533"],
  icon533: ["icon533"],
  title557: ["title557"],
  item534: ["item534", "left534", "icon534", "title558"],
  left534: ["left534", "icon534"],
  icon534: ["icon534"],
  title558: ["title558"],
  item535: ["item535", "left535", "icon535", "title559"],
  left535: ["left535", "icon535"],
  icon535: ["icon535"],
  title559: ["title559"],
  item536: ["item536", "left536", "icon536", "title560"],
  left536: ["left536", "icon536"],
  icon536: ["icon536"],
  title560: ["title560"],
  item537: ["item537", "left537", "icon537", "title561"],
  left537: ["left537", "icon537"],
  icon537: ["icon537"],
  title561: ["title561"],
  item538: ["item538", "left538", "icon538", "title562"],
  left538: ["left538", "icon538"],
  icon538: ["icon538"],
  title562: ["title562"],
  item539: ["item539", "left539", "icon539", "title563"],
  left539: ["left539", "icon539"],
  icon539: ["icon539"],
  title563: ["title563"],
  item540: ["item540", "left540", "icon540", "title564"],
  left540: ["left540", "icon540"],
  icon540: ["icon540"],
  title564: ["title564"],
  item541: ["item541", "left541", "icon541", "title565"],
  left541: ["left541", "icon541"],
  icon541: ["icon541"],
  title565: ["title565"],
  item542: ["item542", "left542", "icon542", "title566"],
  left542: ["left542", "icon542"],
  icon542: ["icon542"],
  title566: ["title566"],
  item543: ["item543", "left543", "icon543", "title567"],
  left543: ["left543", "icon543"],
  icon543: ["icon543"],
  title567: ["title567"],
  item544: ["item544", "left544", "icon544", "title568"],
  left544: ["left544", "icon544"],
  icon544: ["icon544"],
  title568: ["title568"],
  item545: ["item545", "left545", "icon545", "title569"],
  left545: ["left545", "icon545"],
  icon545: ["icon545"],
  title569: ["title569"],
  item546: ["item546", "left546", "icon546", "title570"],
  left546: ["left546", "icon546"],
  icon546: ["icon546"],
  title570: ["title570"],
  item547: ["item547", "left547", "icon547", "title571"],
  left547: ["left547", "icon547"],
  icon547: ["icon547"],
  title571: ["title571"],
  item548: ["item548", "left548", "icon548", "title572"],
  left548: ["left548", "icon548"],
  icon548: ["icon548"],
  title572: ["title572"],
  item549: ["item549", "left549", "icon549", "title573"],
  left549: ["left549", "icon549"],
  icon549: ["icon549"],
  title573: ["title573"],
  item550: ["item550", "left550", "icon550", "title574"],
  left550: ["left550", "icon550"],
  icon550: ["icon550"],
  title574: ["title574"],
  item551: ["item551", "left551", "icon551", "title575"],
  left551: ["left551", "icon551"],
  icon551: ["icon551"],
  title575: ["title575"],
  item552: ["item552", "left552", "icon552", "title576"],
  left552: ["left552", "icon552"],
  icon552: ["icon552"],
  title576: ["title576"],
  btn23: ["btn23"],
  narrowCard24: [
    "narrowCard24",
    "header50",
    "title577",
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24"
  ],
  header50: ["header50", "title577"],
  title577: ["title577"],
  content24: [
    "content24",
    "desc24",
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601",
    "btn24"
  ],
  desc24: ["desc24"],
  placeholder24: [
    "placeholder24",
    "header51",
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601"
  ],
  header51: ["header51"],
  list31: [
    "list31",
    "item553",
    "left553",
    "icon553",
    "title578",
    "item554",
    "left554",
    "icon554",
    "title579",
    "item555",
    "left555",
    "icon555",
    "title580",
    "item556",
    "left556",
    "icon556",
    "title581",
    "item557",
    "left557",
    "icon557",
    "title582",
    "item558",
    "left558",
    "icon558",
    "title583",
    "item559",
    "left559",
    "icon559",
    "title584",
    "item560",
    "left560",
    "icon560",
    "title585",
    "item561",
    "left561",
    "icon561",
    "title586",
    "item562",
    "left562",
    "icon562",
    "title587",
    "item563",
    "left563",
    "icon563",
    "title588",
    "item564",
    "left564",
    "icon564",
    "title589",
    "item565",
    "left565",
    "icon565",
    "title590",
    "item566",
    "left566",
    "icon566",
    "title591",
    "item567",
    "left567",
    "icon567",
    "title592",
    "item568",
    "left568",
    "icon568",
    "title593",
    "item569",
    "left569",
    "icon569",
    "title594",
    "item570",
    "left570",
    "icon570",
    "title595",
    "item571",
    "left571",
    "icon571",
    "title596",
    "item572",
    "left572",
    "icon572",
    "title597",
    "item573",
    "left573",
    "icon573",
    "title598",
    "item574",
    "left574",
    "icon574",
    "title599",
    "item575",
    "left575",
    "icon575",
    "title600",
    "item576",
    "left576",
    "icon576",
    "title601"
  ],
  item553: ["item553", "left553", "icon553", "title578"],
  left553: ["left553", "icon553"],
  icon553: ["icon553"],
  title578: ["title578"],
  item554: ["item554", "left554", "icon554", "title579"],
  left554: ["left554", "icon554"],
  icon554: ["icon554"],
  title579: ["title579"],
  item555: ["item555", "left555", "icon555", "title580"],
  left555: ["left555", "icon555"],
  icon555: ["icon555"],
  title580: ["title580"],
  item556: ["item556", "left556", "icon556", "title581"],
  left556: ["left556", "icon556"],
  icon556: ["icon556"],
  title581: ["title581"],
  item557: ["item557", "left557", "icon557", "title582"],
  left557: ["left557", "icon557"],
  icon557: ["icon557"],
  title582: ["title582"],
  item558: ["item558", "left558", "icon558", "title583"],
  left558: ["left558", "icon558"],
  icon558: ["icon558"],
  title583: ["title583"],
  item559: ["item559", "left559", "icon559", "title584"],
  left559: ["left559", "icon559"],
  icon559: ["icon559"],
  title584: ["title584"],
  item560: ["item560", "left560", "icon560", "title585"],
  left560: ["left560", "icon560"],
  icon560: ["icon560"],
  title585: ["title585"],
  item561: ["item561", "left561", "icon561", "title586"],
  left561: ["left561", "icon561"],
  icon561: ["icon561"],
  title586: ["title586"],
  item562: ["item562", "left562", "icon562", "title587"],
  left562: ["left562", "icon562"],
  icon562: ["icon562"],
  title587: ["title587"],
  item563: ["item563", "left563", "icon563", "title588"],
  left563: ["left563", "icon563"],
  icon563: ["icon563"],
  title588: ["title588"],
  item564: ["item564", "left564", "icon564", "title589"],
  left564: ["left564", "icon564"],
  icon564: ["icon564"],
  title589: ["title589"],
  item565: ["item565", "left565", "icon565", "title590"],
  left565: ["left565", "icon565"],
  icon565: ["icon565"],
  title590: ["title590"],
  item566: ["item566", "left566", "icon566", "title591"],
  left566: ["left566", "icon566"],
  icon566: ["icon566"],
  title591: ["title591"],
  item567: ["item567", "left567", "icon567", "title592"],
  left567: ["left567", "icon567"],
  icon567: ["icon567"],
  title592: ["title592"],
  item568: ["item568", "left568", "icon568", "title593"],
  left568: ["left568", "icon568"],
  icon568: ["icon568"],
  title593: ["title593"],
  item569: ["item569", "left569", "icon569", "title594"],
  left569: ["left569", "icon569"],
  icon569: ["icon569"],
  title594: ["title594"],
  item570: ["item570", "left570", "icon570", "title595"],
  left570: ["left570", "icon570"],
  icon570: ["icon570"],
  title595: ["title595"],
  item571: ["item571", "left571", "icon571", "title596"],
  left571: ["left571", "icon571"],
  icon571: ["icon571"],
  title596: ["title596"],
  item572: ["item572", "left572", "icon572", "title597"],
  left572: ["left572", "icon572"],
  icon572: ["icon572"],
  title597: ["title597"],
  item573: ["item573", "left573", "icon573", "title598"],
  left573: ["left573", "icon573"],
  icon573: ["icon573"],
  title598: ["title598"],
  item574: ["item574", "left574", "icon574", "title599"],
  left574: ["left574", "icon574"],
  icon574: ["icon574"],
  title599: ["title599"],
  item575: ["item575", "left575", "icon575", "title600"],
  left575: ["left575", "icon575"],
  icon575: ["icon575"],
  title600: ["title600"],
  item576: ["item576", "left576", "icon576", "title601"],
  left576: ["left576", "icon576"],
  icon576: ["icon576"],
  title601: ["title601"],
  btn24: ["btn24"],
  row10: ["row10"],
  row11: [
    "row11",
    "figmaPaste8",
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25",
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26"
  ],
  figmaPaste8: [
    "figmaPaste8",
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25",
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26"
  ],
  narrowCard25: [
    "narrowCard25",
    "header52",
    "title602",
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25"
  ],
  header52: ["header52", "title602"],
  title602: ["title602"],
  content25: [
    "content25",
    "desc25",
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626",
    "btn25"
  ],
  desc25: ["desc25"],
  placeholder25: [
    "placeholder25",
    "header53",
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626"
  ],
  header53: ["header53"],
  list32: [
    "list32",
    "item577",
    "left577",
    "icon577",
    "title603",
    "item578",
    "left578",
    "icon578",
    "title604",
    "item579",
    "left579",
    "icon579",
    "title605",
    "item580",
    "left580",
    "icon580",
    "title606",
    "item581",
    "left581",
    "icon581",
    "title607",
    "item582",
    "left582",
    "icon582",
    "title608",
    "item583",
    "left583",
    "icon583",
    "title609",
    "item584",
    "left584",
    "icon584",
    "title610",
    "item585",
    "left585",
    "icon585",
    "title611",
    "item586",
    "left586",
    "icon586",
    "title612",
    "item587",
    "left587",
    "icon587",
    "title613",
    "item588",
    "left588",
    "icon588",
    "title614",
    "item589",
    "left589",
    "icon589",
    "title615",
    "item590",
    "left590",
    "icon590",
    "title616",
    "item591",
    "left591",
    "icon591",
    "title617",
    "item592",
    "left592",
    "icon592",
    "title618",
    "item593",
    "left593",
    "icon593",
    "title619",
    "item594",
    "left594",
    "icon594",
    "title620",
    "item595",
    "left595",
    "icon595",
    "title621",
    "item596",
    "left596",
    "icon596",
    "title622",
    "item597",
    "left597",
    "icon597",
    "title623",
    "item598",
    "left598",
    "icon598",
    "title624",
    "item599",
    "left599",
    "icon599",
    "title625",
    "item600",
    "left600",
    "icon600",
    "title626"
  ],
  item577: ["item577", "left577", "icon577", "title603"],
  left577: ["left577", "icon577"],
  icon577: ["icon577"],
  title603: ["title603"],
  item578: ["item578", "left578", "icon578", "title604"],
  left578: ["left578", "icon578"],
  icon578: ["icon578"],
  title604: ["title604"],
  item579: ["item579", "left579", "icon579", "title605"],
  left579: ["left579", "icon579"],
  icon579: ["icon579"],
  title605: ["title605"],
  item580: ["item580", "left580", "icon580", "title606"],
  left580: ["left580", "icon580"],
  icon580: ["icon580"],
  title606: ["title606"],
  item581: ["item581", "left581", "icon581", "title607"],
  left581: ["left581", "icon581"],
  icon581: ["icon581"],
  title607: ["title607"],
  item582: ["item582", "left582", "icon582", "title608"],
  left582: ["left582", "icon582"],
  icon582: ["icon582"],
  title608: ["title608"],
  item583: ["item583", "left583", "icon583", "title609"],
  left583: ["left583", "icon583"],
  icon583: ["icon583"],
  title609: ["title609"],
  item584: ["item584", "left584", "icon584", "title610"],
  left584: ["left584", "icon584"],
  icon584: ["icon584"],
  title610: ["title610"],
  item585: ["item585", "left585", "icon585", "title611"],
  left585: ["left585", "icon585"],
  icon585: ["icon585"],
  title611: ["title611"],
  item586: ["item586", "left586", "icon586", "title612"],
  left586: ["left586", "icon586"],
  icon586: ["icon586"],
  title612: ["title612"],
  item587: ["item587", "left587", "icon587", "title613"],
  left587: ["left587", "icon587"],
  icon587: ["icon587"],
  title613: ["title613"],
  item588: ["item588", "left588", "icon588", "title614"],
  left588: ["left588", "icon588"],
  icon588: ["icon588"],
  title614: ["title614"],
  item589: ["item589", "left589", "icon589", "title615"],
  left589: ["left589", "icon589"],
  icon589: ["icon589"],
  title615: ["title615"],
  item590: ["item590", "left590", "icon590", "title616"],
  left590: ["left590", "icon590"],
  icon590: ["icon590"],
  title616: ["title616"],
  item591: ["item591", "left591", "icon591", "title617"],
  left591: ["left591", "icon591"],
  icon591: ["icon591"],
  title617: ["title617"],
  item592: ["item592", "left592", "icon592", "title618"],
  left592: ["left592", "icon592"],
  icon592: ["icon592"],
  title618: ["title618"],
  item593: ["item593", "left593", "icon593", "title619"],
  left593: ["left593", "icon593"],
  icon593: ["icon593"],
  title619: ["title619"],
  item594: ["item594", "left594", "icon594", "title620"],
  left594: ["left594", "icon594"],
  icon594: ["icon594"],
  title620: ["title620"],
  item595: ["item595", "left595", "icon595", "title621"],
  left595: ["left595", "icon595"],
  icon595: ["icon595"],
  title621: ["title621"],
  item596: ["item596", "left596", "icon596", "title622"],
  left596: ["left596", "icon596"],
  icon596: ["icon596"],
  title622: ["title622"],
  item597: ["item597", "left597", "icon597", "title623"],
  left597: ["left597", "icon597"],
  icon597: ["icon597"],
  title623: ["title623"],
  item598: ["item598", "left598", "icon598", "title624"],
  left598: ["left598", "icon598"],
  icon598: ["icon598"],
  title624: ["title624"],
  item599: ["item599", "left599", "icon599", "title625"],
  left599: ["left599", "icon599"],
  icon599: ["icon599"],
  title625: ["title625"],
  item600: ["item600", "left600", "icon600", "title626"],
  left600: ["left600", "icon600"],
  icon600: ["icon600"],
  title626: ["title626"],
  btn25: ["btn25"],
  narrowCard26: [
    "narrowCard26",
    "header54",
    "title627",
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26"
  ],
  header54: ["header54", "title627"],
  title627: ["title627"],
  content26: [
    "content26",
    "desc26",
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651",
    "btn26"
  ],
  desc26: ["desc26"],
  placeholder26: [
    "placeholder26",
    "header55",
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651"
  ],
  header55: ["header55"],
  list33: [
    "list33",
    "item601",
    "left601",
    "icon601",
    "title628",
    "item602",
    "left602",
    "icon602",
    "title629",
    "item603",
    "left603",
    "icon603",
    "title630",
    "item604",
    "left604",
    "icon604",
    "title631",
    "item605",
    "left605",
    "icon605",
    "title632",
    "item606",
    "left606",
    "icon606",
    "title633",
    "item607",
    "left607",
    "icon607",
    "title634",
    "item608",
    "left608",
    "icon608",
    "title635",
    "item609",
    "left609",
    "icon609",
    "title636",
    "item610",
    "left610",
    "icon610",
    "title637",
    "item611",
    "left611",
    "icon611",
    "title638",
    "item612",
    "left612",
    "icon612",
    "title639",
    "item613",
    "left613",
    "icon613",
    "title640",
    "item614",
    "left614",
    "icon614",
    "title641",
    "item615",
    "left615",
    "icon615",
    "title642",
    "item616",
    "left616",
    "icon616",
    "title643",
    "item617",
    "left617",
    "icon617",
    "title644",
    "item618",
    "left618",
    "icon618",
    "title645",
    "item619",
    "left619",
    "icon619",
    "title646",
    "item620",
    "left620",
    "icon620",
    "title647",
    "item621",
    "left621",
    "icon621",
    "title648",
    "item622",
    "left622",
    "icon622",
    "title649",
    "item623",
    "left623",
    "icon623",
    "title650",
    "item624",
    "left624",
    "icon624",
    "title651"
  ],
  item601: ["item601", "left601", "icon601", "title628"],
  left601: ["left601", "icon601"],
  icon601: ["icon601"],
  title628: ["title628"],
  item602: ["item602", "left602", "icon602", "title629"],
  left602: ["left602", "icon602"],
  icon602: ["icon602"],
  title629: ["title629"],
  item603: ["item603", "left603", "icon603", "title630"],
  left603: ["left603", "icon603"],
  icon603: ["icon603"],
  title630: ["title630"],
  item604: ["item604", "left604", "icon604", "title631"],
  left604: ["left604", "icon604"],
  icon604: ["icon604"],
  title631: ["title631"],
  item605: ["item605", "left605", "icon605", "title632"],
  left605: ["left605", "icon605"],
  icon605: ["icon605"],
  title632: ["title632"],
  item606: ["item606", "left606", "icon606", "title633"],
  left606: ["left606", "icon606"],
  icon606: ["icon606"],
  title633: ["title633"],
  item607: ["item607", "left607", "icon607", "title634"],
  left607: ["left607", "icon607"],
  icon607: ["icon607"],
  title634: ["title634"],
  item608: ["item608", "left608", "icon608", "title635"],
  left608: ["left608", "icon608"],
  icon608: ["icon608"],
  title635: ["title635"],
  item609: ["item609", "left609", "icon609", "title636"],
  left609: ["left609", "icon609"],
  icon609: ["icon609"],
  title636: ["title636"],
  item610: ["item610", "left610", "icon610", "title637"],
  left610: ["left610", "icon610"],
  icon610: ["icon610"],
  title637: ["title637"],
  item611: ["item611", "left611", "icon611", "title638"],
  left611: ["left611", "icon611"],
  icon611: ["icon611"],
  title638: ["title638"],
  item612: ["item612", "left612", "icon612", "title639"],
  left612: ["left612", "icon612"],
  icon612: ["icon612"],
  title639: ["title639"],
  item613: ["item613", "left613", "icon613", "title640"],
  left613: ["left613", "icon613"],
  icon613: ["icon613"],
  title640: ["title640"],
  item614: ["item614", "left614", "icon614", "title641"],
  left614: ["left614", "icon614"],
  icon614: ["icon614"],
  title641: ["title641"],
  item615: ["item615", "left615", "icon615", "title642"],
  left615: ["left615", "icon615"],
  icon615: ["icon615"],
  title642: ["title642"],
  item616: ["item616", "left616", "icon616", "title643"],
  left616: ["left616", "icon616"],
  icon616: ["icon616"],
  title643: ["title643"],
  item617: ["item617", "left617", "icon617", "title644"],
  left617: ["left617", "icon617"],
  icon617: ["icon617"],
  title644: ["title644"],
  item618: ["item618", "left618", "icon618", "title645"],
  left618: ["left618", "icon618"],
  icon618: ["icon618"],
  title645: ["title645"],
  item619: ["item619", "left619", "icon619", "title646"],
  left619: ["left619", "icon619"],
  icon619: ["icon619"],
  title646: ["title646"],
  item620: ["item620", "left620", "icon620", "title647"],
  left620: ["left620", "icon620"],
  icon620: ["icon620"],
  title647: ["title647"],
  item621: ["item621", "left621", "icon621", "title648"],
  left621: ["left621", "icon621"],
  icon621: ["icon621"],
  title648: ["title648"],
  item622: ["item622", "left622", "icon622", "title649"],
  left622: ["left622", "icon622"],
  icon622: ["icon622"],
  title649: ["title649"],
  item623: ["item623", "left623", "icon623", "title650"],
  left623: ["left623", "icon623"],
  icon623: ["icon623"],
  title650: ["title650"],
  item624: ["item624", "left624", "icon624", "title651"],
  left624: ["left624", "icon624"],
  icon624: ["icon624"],
  title651: ["title651"],
  btn26: ["btn26"],
  all3: [
    "all3",
    "title3",
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  title3: ["title3"],
  sections3: [
    "sections3",
    "col8",
    "list12",
    "col9",
    "section5",
    "list13",
    "section6",
    "list14",
    "col10",
    "list15"
  ],
  col8: ["col8", "list12"],
  list12: ["list12"],
  col9: ["col9", "section5", "list13", "section6", "list14", "col10", "list15"],
  section5: ["section5", "list13"],
  list13: ["list13"],
  section6: ["section6", "list14"],
  list14: ["list14"],
  col10: ["col10", "list15"],
  list15: ["list15"],
  mobile: [
    "mobile",
    "header3",
    "key3",
    "header2",
    "list6",
    "figmaPaste4",
    "narrowCard9",
    "header28",
    "title",
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9",
    "narrowCard10",
    "header30",
    "title26",
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10",
    "narrowCard11",
    "header5",
    "title51",
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11",
    "narrowCard12",
    "header7",
    "title76",
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12",
    "narrowCard13",
    "header32",
    "title399",
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13",
    "narrowCard14",
    "header34",
    "title424",
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14",
    "narrowCard15",
    "header36",
    "title449",
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15",
    "narrowCard16",
    "header38",
    "title474",
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  header3: ["header3"],
  key3: [
    "key3",
    "header2",
    "list6",
    "figmaPaste4",
    "narrowCard9",
    "header28",
    "title",
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9",
    "narrowCard10",
    "header30",
    "title26",
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10",
    "narrowCard11",
    "header5",
    "title51",
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11",
    "narrowCard12",
    "header7",
    "title76",
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12",
    "narrowCard13",
    "header32",
    "title399",
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13",
    "narrowCard14",
    "header34",
    "title424",
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14",
    "narrowCard15",
    "header36",
    "title449",
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15",
    "narrowCard16",
    "header38",
    "title474",
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  header2: ["header2"],
  list6: [
    "list6",
    "figmaPaste4",
    "narrowCard9",
    "header28",
    "title",
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9",
    "narrowCard10",
    "header30",
    "title26",
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10",
    "narrowCard11",
    "header5",
    "title51",
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11",
    "narrowCard12",
    "header7",
    "title76",
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12",
    "narrowCard13",
    "header32",
    "title399",
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13",
    "narrowCard14",
    "header34",
    "title424",
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14",
    "narrowCard15",
    "header36",
    "title449",
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15",
    "narrowCard16",
    "header38",
    "title474",
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  figmaPaste4: [
    "figmaPaste4",
    "narrowCard9",
    "header28",
    "title",
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9",
    "narrowCard10",
    "header30",
    "title26",
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10",
    "narrowCard11",
    "header5",
    "title51",
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11",
    "narrowCard12",
    "header7",
    "title76",
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12",
    "narrowCard13",
    "header32",
    "title399",
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13",
    "narrowCard14",
    "header34",
    "title424",
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14",
    "narrowCard15",
    "header36",
    "title449",
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15",
    "narrowCard16",
    "header38",
    "title474",
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  narrowCard9: [
    "narrowCard9",
    "header28",
    "title",
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9"
  ],
  header28: ["header28", "title"],
  title: ["title"],
  content9: [
    "content9",
    "desc9",
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25",
    "btn9"
  ],
  desc9: ["desc9"],
  placeholder9: [
    "placeholder9",
    "header29",
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25"
  ],
  header29: ["header29"],
  list24: [
    "list24",
    "item",
    "left",
    "icon",
    "title396",
    "item2",
    "left2",
    "icon2",
    "title397",
    "item3",
    "left3",
    "icon3",
    "title4",
    "item4",
    "left4",
    "icon4",
    "title5",
    "item5",
    "left5",
    "icon5",
    "title6",
    "item6",
    "left6",
    "icon6",
    "title7",
    "item7",
    "left7",
    "icon7",
    "title8",
    "item8",
    "left8",
    "icon8",
    "title9",
    "item9",
    "left9",
    "icon9",
    "title10",
    "item10",
    "left10",
    "icon10",
    "title11",
    "item11",
    "left11",
    "icon11",
    "title12",
    "item12",
    "left12",
    "icon12",
    "title13",
    "item13",
    "left13",
    "icon13",
    "title14",
    "item14",
    "left14",
    "icon14",
    "title15",
    "item15",
    "left15",
    "icon15",
    "title16",
    "item16",
    "left16",
    "icon16",
    "title17",
    "item17",
    "left17",
    "icon17",
    "title18",
    "item18",
    "left18",
    "icon18",
    "title19",
    "item19",
    "left19",
    "icon19",
    "title20",
    "item20",
    "left20",
    "icon20",
    "title21",
    "item21",
    "left21",
    "icon21",
    "title22",
    "item22",
    "left22",
    "icon22",
    "title23",
    "item23",
    "left23",
    "icon23",
    "title24",
    "item24",
    "left24",
    "icon24",
    "title25"
  ],
  item: ["item", "left", "icon", "title396"],
  left: ["left", "icon"],
  icon: ["icon"],
  title396: ["title396"],
  item2: ["item2", "left2", "icon2", "title397"],
  left2: ["left2", "icon2"],
  icon2: ["icon2"],
  title397: ["title397"],
  item3: ["item3", "left3", "icon3", "title4"],
  left3: ["left3", "icon3"],
  icon3: ["icon3"],
  title4: ["title4"],
  item4: ["item4", "left4", "icon4", "title5"],
  left4: ["left4", "icon4"],
  icon4: ["icon4"],
  title5: ["title5"],
  item5: ["item5", "left5", "icon5", "title6"],
  left5: ["left5", "icon5"],
  icon5: ["icon5"],
  title6: ["title6"],
  item6: ["item6", "left6", "icon6", "title7"],
  left6: ["left6", "icon6"],
  icon6: ["icon6"],
  title7: ["title7"],
  item7: ["item7", "left7", "icon7", "title8"],
  left7: ["left7", "icon7"],
  icon7: ["icon7"],
  title8: ["title8"],
  item8: ["item8", "left8", "icon8", "title9"],
  left8: ["left8", "icon8"],
  icon8: ["icon8"],
  title9: ["title9"],
  item9: ["item9", "left9", "icon9", "title10"],
  left9: ["left9", "icon9"],
  icon9: ["icon9"],
  title10: ["title10"],
  item10: ["item10", "left10", "icon10", "title11"],
  left10: ["left10", "icon10"],
  icon10: ["icon10"],
  title11: ["title11"],
  item11: ["item11", "left11", "icon11", "title12"],
  left11: ["left11", "icon11"],
  icon11: ["icon11"],
  title12: ["title12"],
  item12: ["item12", "left12", "icon12", "title13"],
  left12: ["left12", "icon12"],
  icon12: ["icon12"],
  title13: ["title13"],
  item13: ["item13", "left13", "icon13", "title14"],
  left13: ["left13", "icon13"],
  icon13: ["icon13"],
  title14: ["title14"],
  item14: ["item14", "left14", "icon14", "title15"],
  left14: ["left14", "icon14"],
  icon14: ["icon14"],
  title15: ["title15"],
  item15: ["item15", "left15", "icon15", "title16"],
  left15: ["left15", "icon15"],
  icon15: ["icon15"],
  title16: ["title16"],
  item16: ["item16", "left16", "icon16", "title17"],
  left16: ["left16", "icon16"],
  icon16: ["icon16"],
  title17: ["title17"],
  item17: ["item17", "left17", "icon17", "title18"],
  left17: ["left17", "icon17"],
  icon17: ["icon17"],
  title18: ["title18"],
  item18: ["item18", "left18", "icon18", "title19"],
  left18: ["left18", "icon18"],
  icon18: ["icon18"],
  title19: ["title19"],
  item19: ["item19", "left19", "icon19", "title20"],
  left19: ["left19", "icon19"],
  icon19: ["icon19"],
  title20: ["title20"],
  item20: ["item20", "left20", "icon20", "title21"],
  left20: ["left20", "icon20"],
  icon20: ["icon20"],
  title21: ["title21"],
  item21: ["item21", "left21", "icon21", "title22"],
  left21: ["left21", "icon21"],
  icon21: ["icon21"],
  title22: ["title22"],
  item22: ["item22", "left22", "icon22", "title23"],
  left22: ["left22", "icon22"],
  icon22: ["icon22"],
  title23: ["title23"],
  item23: ["item23", "left23", "icon23", "title24"],
  left23: ["left23", "icon23"],
  icon23: ["icon23"],
  title24: ["title24"],
  item24: ["item24", "left24", "icon24", "title25"],
  left24: ["left24", "icon24"],
  icon24: ["icon24"],
  title25: ["title25"],
  btn9: ["btn9"],
  narrowCard10: [
    "narrowCard10",
    "header30",
    "title26",
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10"
  ],
  header30: ["header30", "title26"],
  title26: ["title26"],
  content10: [
    "content10",
    "desc10",
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50",
    "btn10"
  ],
  desc10: ["desc10"],
  placeholder10: [
    "placeholder10",
    "header31",
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50"
  ],
  header31: ["header31"],
  list2: [
    "list2",
    "item25",
    "left25",
    "icon25",
    "title27",
    "item26",
    "left26",
    "icon26",
    "title28",
    "item27",
    "left27",
    "icon27",
    "title29",
    "item28",
    "left28",
    "icon28",
    "title30",
    "item29",
    "left29",
    "icon29",
    "title31",
    "item30",
    "left30",
    "icon30",
    "title32",
    "item31",
    "left31",
    "icon31",
    "title33",
    "item32",
    "left32",
    "icon32",
    "title34",
    "item33",
    "left33",
    "icon33",
    "title35",
    "item34",
    "left34",
    "icon34",
    "title36",
    "item35",
    "left35",
    "icon35",
    "title37",
    "item36",
    "left36",
    "icon36",
    "title38",
    "item37",
    "left37",
    "icon37",
    "title39",
    "item38",
    "left38",
    "icon38",
    "title40",
    "item39",
    "left39",
    "icon39",
    "title41",
    "item40",
    "left40",
    "icon40",
    "title42",
    "item41",
    "left41",
    "icon41",
    "title43",
    "item42",
    "left42",
    "icon42",
    "title44",
    "item43",
    "left43",
    "icon43",
    "title45",
    "item44",
    "left44",
    "icon44",
    "title46",
    "item45",
    "left45",
    "icon45",
    "title47",
    "item46",
    "left46",
    "icon46",
    "title48",
    "item47",
    "left47",
    "icon47",
    "title49",
    "item48",
    "left48",
    "icon48",
    "title50"
  ],
  item25: ["item25", "left25", "icon25", "title27"],
  left25: ["left25", "icon25"],
  icon25: ["icon25"],
  title27: ["title27"],
  item26: ["item26", "left26", "icon26", "title28"],
  left26: ["left26", "icon26"],
  icon26: ["icon26"],
  title28: ["title28"],
  item27: ["item27", "left27", "icon27", "title29"],
  left27: ["left27", "icon27"],
  icon27: ["icon27"],
  title29: ["title29"],
  item28: ["item28", "left28", "icon28", "title30"],
  left28: ["left28", "icon28"],
  icon28: ["icon28"],
  title30: ["title30"],
  item29: ["item29", "left29", "icon29", "title31"],
  left29: ["left29", "icon29"],
  icon29: ["icon29"],
  title31: ["title31"],
  item30: ["item30", "left30", "icon30", "title32"],
  left30: ["left30", "icon30"],
  icon30: ["icon30"],
  title32: ["title32"],
  item31: ["item31", "left31", "icon31", "title33"],
  left31: ["left31", "icon31"],
  icon31: ["icon31"],
  title33: ["title33"],
  item32: ["item32", "left32", "icon32", "title34"],
  left32: ["left32", "icon32"],
  icon32: ["icon32"],
  title34: ["title34"],
  item33: ["item33", "left33", "icon33", "title35"],
  left33: ["left33", "icon33"],
  icon33: ["icon33"],
  title35: ["title35"],
  item34: ["item34", "left34", "icon34", "title36"],
  left34: ["left34", "icon34"],
  icon34: ["icon34"],
  title36: ["title36"],
  item35: ["item35", "left35", "icon35", "title37"],
  left35: ["left35", "icon35"],
  icon35: ["icon35"],
  title37: ["title37"],
  item36: ["item36", "left36", "icon36", "title38"],
  left36: ["left36", "icon36"],
  icon36: ["icon36"],
  title38: ["title38"],
  item37: ["item37", "left37", "icon37", "title39"],
  left37: ["left37", "icon37"],
  icon37: ["icon37"],
  title39: ["title39"],
  item38: ["item38", "left38", "icon38", "title40"],
  left38: ["left38", "icon38"],
  icon38: ["icon38"],
  title40: ["title40"],
  item39: ["item39", "left39", "icon39", "title41"],
  left39: ["left39", "icon39"],
  icon39: ["icon39"],
  title41: ["title41"],
  item40: ["item40", "left40", "icon40", "title42"],
  left40: ["left40", "icon40"],
  icon40: ["icon40"],
  title42: ["title42"],
  item41: ["item41", "left41", "icon41", "title43"],
  left41: ["left41", "icon41"],
  icon41: ["icon41"],
  title43: ["title43"],
  item42: ["item42", "left42", "icon42", "title44"],
  left42: ["left42", "icon42"],
  icon42: ["icon42"],
  title44: ["title44"],
  item43: ["item43", "left43", "icon43", "title45"],
  left43: ["left43", "icon43"],
  icon43: ["icon43"],
  title45: ["title45"],
  item44: ["item44", "left44", "icon44", "title46"],
  left44: ["left44", "icon44"],
  icon44: ["icon44"],
  title46: ["title46"],
  item45: ["item45", "left45", "icon45", "title47"],
  left45: ["left45", "icon45"],
  icon45: ["icon45"],
  title47: ["title47"],
  item46: ["item46", "left46", "icon46", "title48"],
  left46: ["left46", "icon46"],
  icon46: ["icon46"],
  title48: ["title48"],
  item47: ["item47", "left47", "icon47", "title49"],
  left47: ["left47", "icon47"],
  icon47: ["icon47"],
  title49: ["title49"],
  item48: ["item48", "left48", "icon48", "title50"],
  left48: ["left48", "icon48"],
  icon48: ["icon48"],
  title50: ["title50"],
  btn10: ["btn10"],
  narrowCard11: [
    "narrowCard11",
    "header5",
    "title51",
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11"
  ],
  header5: ["header5", "title51"],
  title51: ["title51"],
  content11: [
    "content11",
    "desc11",
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75",
    "btn11"
  ],
  desc11: ["desc11"],
  placeholder11: [
    "placeholder11",
    "header6",
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75"
  ],
  header6: ["header6"],
  list3: [
    "list3",
    "item49",
    "left49",
    "icon49",
    "title52",
    "item50",
    "left50",
    "icon50",
    "title53",
    "item51",
    "left51",
    "icon51",
    "title54",
    "item52",
    "left52",
    "icon52",
    "title55",
    "item53",
    "left53",
    "icon53",
    "title56",
    "item54",
    "left54",
    "icon54",
    "title57",
    "item55",
    "left55",
    "icon55",
    "title58",
    "item56",
    "left56",
    "icon56",
    "title59",
    "item57",
    "left57",
    "icon57",
    "title60",
    "item58",
    "left58",
    "icon58",
    "title61",
    "item59",
    "left59",
    "icon59",
    "title62",
    "item60",
    "left60",
    "icon60",
    "title63",
    "item61",
    "left61",
    "icon61",
    "title64",
    "item62",
    "left62",
    "icon62",
    "title65",
    "item63",
    "left63",
    "icon63",
    "title66",
    "item64",
    "left64",
    "icon64",
    "title67",
    "item65",
    "left65",
    "icon65",
    "title68",
    "item66",
    "left66",
    "icon66",
    "title69",
    "item67",
    "left67",
    "icon67",
    "title70",
    "item68",
    "left68",
    "icon68",
    "title71",
    "item69",
    "left69",
    "icon69",
    "title72",
    "item70",
    "left70",
    "icon70",
    "title73",
    "item71",
    "left71",
    "icon71",
    "title74",
    "item72",
    "left72",
    "icon72",
    "title75"
  ],
  item49: ["item49", "left49", "icon49", "title52"],
  left49: ["left49", "icon49"],
  icon49: ["icon49"],
  title52: ["title52"],
  item50: ["item50", "left50", "icon50", "title53"],
  left50: ["left50", "icon50"],
  icon50: ["icon50"],
  title53: ["title53"],
  item51: ["item51", "left51", "icon51", "title54"],
  left51: ["left51", "icon51"],
  icon51: ["icon51"],
  title54: ["title54"],
  item52: ["item52", "left52", "icon52", "title55"],
  left52: ["left52", "icon52"],
  icon52: ["icon52"],
  title55: ["title55"],
  item53: ["item53", "left53", "icon53", "title56"],
  left53: ["left53", "icon53"],
  icon53: ["icon53"],
  title56: ["title56"],
  item54: ["item54", "left54", "icon54", "title57"],
  left54: ["left54", "icon54"],
  icon54: ["icon54"],
  title57: ["title57"],
  item55: ["item55", "left55", "icon55", "title58"],
  left55: ["left55", "icon55"],
  icon55: ["icon55"],
  title58: ["title58"],
  item56: ["item56", "left56", "icon56", "title59"],
  left56: ["left56", "icon56"],
  icon56: ["icon56"],
  title59: ["title59"],
  item57: ["item57", "left57", "icon57", "title60"],
  left57: ["left57", "icon57"],
  icon57: ["icon57"],
  title60: ["title60"],
  item58: ["item58", "left58", "icon58", "title61"],
  left58: ["left58", "icon58"],
  icon58: ["icon58"],
  title61: ["title61"],
  item59: ["item59", "left59", "icon59", "title62"],
  left59: ["left59", "icon59"],
  icon59: ["icon59"],
  title62: ["title62"],
  item60: ["item60", "left60", "icon60", "title63"],
  left60: ["left60", "icon60"],
  icon60: ["icon60"],
  title63: ["title63"],
  item61: ["item61", "left61", "icon61", "title64"],
  left61: ["left61", "icon61"],
  icon61: ["icon61"],
  title64: ["title64"],
  item62: ["item62", "left62", "icon62", "title65"],
  left62: ["left62", "icon62"],
  icon62: ["icon62"],
  title65: ["title65"],
  item63: ["item63", "left63", "icon63", "title66"],
  left63: ["left63", "icon63"],
  icon63: ["icon63"],
  title66: ["title66"],
  item64: ["item64", "left64", "icon64", "title67"],
  left64: ["left64", "icon64"],
  icon64: ["icon64"],
  title67: ["title67"],
  item65: ["item65", "left65", "icon65", "title68"],
  left65: ["left65", "icon65"],
  icon65: ["icon65"],
  title68: ["title68"],
  item66: ["item66", "left66", "icon66", "title69"],
  left66: ["left66", "icon66"],
  icon66: ["icon66"],
  title69: ["title69"],
  item67: ["item67", "left67", "icon67", "title70"],
  left67: ["left67", "icon67"],
  icon67: ["icon67"],
  title70: ["title70"],
  item68: ["item68", "left68", "icon68", "title71"],
  left68: ["left68", "icon68"],
  icon68: ["icon68"],
  title71: ["title71"],
  item69: ["item69", "left69", "icon69", "title72"],
  left69: ["left69", "icon69"],
  icon69: ["icon69"],
  title72: ["title72"],
  item70: ["item70", "left70", "icon70", "title73"],
  left70: ["left70", "icon70"],
  icon70: ["icon70"],
  title73: ["title73"],
  item71: ["item71", "left71", "icon71", "title74"],
  left71: ["left71", "icon71"],
  icon71: ["icon71"],
  title74: ["title74"],
  item72: ["item72", "left72", "icon72", "title75"],
  left72: ["left72", "icon72"],
  icon72: ["icon72"],
  title75: ["title75"],
  btn11: ["btn11"],
  narrowCard12: [
    "narrowCard12",
    "header7",
    "title76",
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12"
  ],
  header7: ["header7", "title76"],
  title76: ["title76"],
  content12: [
    "content12",
    "desc12",
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398",
    "btn12"
  ],
  desc12: ["desc12"],
  placeholder12: [
    "placeholder12",
    "header8",
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398"
  ],
  header8: ["header8"],
  list4: [
    "list4",
    "item73",
    "left73",
    "icon73",
    "title77",
    "item74",
    "left74",
    "icon74",
    "title78",
    "item75",
    "left75",
    "icon75",
    "title79",
    "item76",
    "left76",
    "icon76",
    "title80",
    "item77",
    "left77",
    "icon77",
    "title81",
    "item78",
    "left78",
    "icon78",
    "title82",
    "item79",
    "left79",
    "icon79",
    "title83",
    "item80",
    "left80",
    "icon80",
    "title84",
    "item81",
    "left81",
    "icon81",
    "title85",
    "item82",
    "left82",
    "icon82",
    "title86",
    "item83",
    "left83",
    "icon83",
    "title87",
    "item84",
    "left84",
    "icon84",
    "title88",
    "item85",
    "left85",
    "icon85",
    "title89",
    "item86",
    "left86",
    "icon86",
    "title90",
    "item87",
    "left87",
    "icon87",
    "title91",
    "item88",
    "left88",
    "icon88",
    "title92",
    "item89",
    "left89",
    "icon89",
    "title93",
    "item90",
    "left90",
    "icon90",
    "title94",
    "item91",
    "left91",
    "icon91",
    "title95",
    "item92",
    "left92",
    "icon92",
    "title96",
    "item93",
    "left93",
    "icon93",
    "title97",
    "item94",
    "left94",
    "icon94",
    "title98",
    "item95",
    "left95",
    "icon95",
    "title99",
    "item96",
    "left96",
    "icon96",
    "title398"
  ],
  item73: ["item73", "left73", "icon73", "title77"],
  left73: ["left73", "icon73"],
  icon73: ["icon73"],
  title77: ["title77"],
  item74: ["item74", "left74", "icon74", "title78"],
  left74: ["left74", "icon74"],
  icon74: ["icon74"],
  title78: ["title78"],
  item75: ["item75", "left75", "icon75", "title79"],
  left75: ["left75", "icon75"],
  icon75: ["icon75"],
  title79: ["title79"],
  item76: ["item76", "left76", "icon76", "title80"],
  left76: ["left76", "icon76"],
  icon76: ["icon76"],
  title80: ["title80"],
  item77: ["item77", "left77", "icon77", "title81"],
  left77: ["left77", "icon77"],
  icon77: ["icon77"],
  title81: ["title81"],
  item78: ["item78", "left78", "icon78", "title82"],
  left78: ["left78", "icon78"],
  icon78: ["icon78"],
  title82: ["title82"],
  item79: ["item79", "left79", "icon79", "title83"],
  left79: ["left79", "icon79"],
  icon79: ["icon79"],
  title83: ["title83"],
  item80: ["item80", "left80", "icon80", "title84"],
  left80: ["left80", "icon80"],
  icon80: ["icon80"],
  title84: ["title84"],
  item81: ["item81", "left81", "icon81", "title85"],
  left81: ["left81", "icon81"],
  icon81: ["icon81"],
  title85: ["title85"],
  item82: ["item82", "left82", "icon82", "title86"],
  left82: ["left82", "icon82"],
  icon82: ["icon82"],
  title86: ["title86"],
  item83: ["item83", "left83", "icon83", "title87"],
  left83: ["left83", "icon83"],
  icon83: ["icon83"],
  title87: ["title87"],
  item84: ["item84", "left84", "icon84", "title88"],
  left84: ["left84", "icon84"],
  icon84: ["icon84"],
  title88: ["title88"],
  item85: ["item85", "left85", "icon85", "title89"],
  left85: ["left85", "icon85"],
  icon85: ["icon85"],
  title89: ["title89"],
  item86: ["item86", "left86", "icon86", "title90"],
  left86: ["left86", "icon86"],
  icon86: ["icon86"],
  title90: ["title90"],
  item87: ["item87", "left87", "icon87", "title91"],
  left87: ["left87", "icon87"],
  icon87: ["icon87"],
  title91: ["title91"],
  item88: ["item88", "left88", "icon88", "title92"],
  left88: ["left88", "icon88"],
  icon88: ["icon88"],
  title92: ["title92"],
  item89: ["item89", "left89", "icon89", "title93"],
  left89: ["left89", "icon89"],
  icon89: ["icon89"],
  title93: ["title93"],
  item90: ["item90", "left90", "icon90", "title94"],
  left90: ["left90", "icon90"],
  icon90: ["icon90"],
  title94: ["title94"],
  item91: ["item91", "left91", "icon91", "title95"],
  left91: ["left91", "icon91"],
  icon91: ["icon91"],
  title95: ["title95"],
  item92: ["item92", "left92", "icon92", "title96"],
  left92: ["left92", "icon92"],
  icon92: ["icon92"],
  title96: ["title96"],
  item93: ["item93", "left93", "icon93", "title97"],
  left93: ["left93", "icon93"],
  icon93: ["icon93"],
  title97: ["title97"],
  item94: ["item94", "left94", "icon94", "title98"],
  left94: ["left94", "icon94"],
  icon94: ["icon94"],
  title98: ["title98"],
  item95: ["item95", "left95", "icon95", "title99"],
  left95: ["left95", "icon95"],
  icon95: ["icon95"],
  title99: ["title99"],
  item96: ["item96", "left96", "icon96", "title398"],
  left96: ["left96", "icon96"],
  icon96: ["icon96"],
  title398: ["title398"],
  btn12: ["btn12"],
  narrowCard13: [
    "narrowCard13",
    "header32",
    "title399",
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13"
  ],
  header32: ["header32", "title399"],
  title399: ["title399"],
  content13: [
    "content13",
    "desc13",
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423",
    "btn13"
  ],
  desc13: ["desc13"],
  placeholder13: [
    "placeholder13",
    "header33",
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423"
  ],
  header33: ["header33"],
  list5: [
    "list5",
    "item385",
    "left385",
    "icon385",
    "title400",
    "item386",
    "left386",
    "icon386",
    "title401",
    "item387",
    "left387",
    "icon387",
    "title402",
    "item388",
    "left388",
    "icon388",
    "title403",
    "item389",
    "left389",
    "icon389",
    "title404",
    "item390",
    "left390",
    "icon390",
    "title405",
    "item391",
    "left391",
    "icon391",
    "title406",
    "item392",
    "left392",
    "icon392",
    "title407",
    "item393",
    "left393",
    "icon393",
    "title408",
    "item394",
    "left394",
    "icon394",
    "title409",
    "item395",
    "left395",
    "icon395",
    "title410",
    "item396",
    "left396",
    "icon396",
    "title411",
    "item397",
    "left397",
    "icon397",
    "title412",
    "item398",
    "left398",
    "icon398",
    "title413",
    "item399",
    "left399",
    "icon399",
    "title414",
    "item400",
    "left400",
    "icon400",
    "title415",
    "item401",
    "left401",
    "icon401",
    "title416",
    "item402",
    "left402",
    "icon402",
    "title417",
    "item403",
    "left403",
    "icon403",
    "title418",
    "item404",
    "left404",
    "icon404",
    "title419",
    "item405",
    "left405",
    "icon405",
    "title420",
    "item406",
    "left406",
    "icon406",
    "title421",
    "item407",
    "left407",
    "icon407",
    "title422",
    "item408",
    "left408",
    "icon408",
    "title423"
  ],
  item385: ["item385", "left385", "icon385", "title400"],
  left385: ["left385", "icon385"],
  icon385: ["icon385"],
  title400: ["title400"],
  item386: ["item386", "left386", "icon386", "title401"],
  left386: ["left386", "icon386"],
  icon386: ["icon386"],
  title401: ["title401"],
  item387: ["item387", "left387", "icon387", "title402"],
  left387: ["left387", "icon387"],
  icon387: ["icon387"],
  title402: ["title402"],
  item388: ["item388", "left388", "icon388", "title403"],
  left388: ["left388", "icon388"],
  icon388: ["icon388"],
  title403: ["title403"],
  item389: ["item389", "left389", "icon389", "title404"],
  left389: ["left389", "icon389"],
  icon389: ["icon389"],
  title404: ["title404"],
  item390: ["item390", "left390", "icon390", "title405"],
  left390: ["left390", "icon390"],
  icon390: ["icon390"],
  title405: ["title405"],
  item391: ["item391", "left391", "icon391", "title406"],
  left391: ["left391", "icon391"],
  icon391: ["icon391"],
  title406: ["title406"],
  item392: ["item392", "left392", "icon392", "title407"],
  left392: ["left392", "icon392"],
  icon392: ["icon392"],
  title407: ["title407"],
  item393: ["item393", "left393", "icon393", "title408"],
  left393: ["left393", "icon393"],
  icon393: ["icon393"],
  title408: ["title408"],
  item394: ["item394", "left394", "icon394", "title409"],
  left394: ["left394", "icon394"],
  icon394: ["icon394"],
  title409: ["title409"],
  item395: ["item395", "left395", "icon395", "title410"],
  left395: ["left395", "icon395"],
  icon395: ["icon395"],
  title410: ["title410"],
  item396: ["item396", "left396", "icon396", "title411"],
  left396: ["left396", "icon396"],
  icon396: ["icon396"],
  title411: ["title411"],
  item397: ["item397", "left397", "icon397", "title412"],
  left397: ["left397", "icon397"],
  icon397: ["icon397"],
  title412: ["title412"],
  item398: ["item398", "left398", "icon398", "title413"],
  left398: ["left398", "icon398"],
  icon398: ["icon398"],
  title413: ["title413"],
  item399: ["item399", "left399", "icon399", "title414"],
  left399: ["left399", "icon399"],
  icon399: ["icon399"],
  title414: ["title414"],
  item400: ["item400", "left400", "icon400", "title415"],
  left400: ["left400", "icon400"],
  icon400: ["icon400"],
  title415: ["title415"],
  item401: ["item401", "left401", "icon401", "title416"],
  left401: ["left401", "icon401"],
  icon401: ["icon401"],
  title416: ["title416"],
  item402: ["item402", "left402", "icon402", "title417"],
  left402: ["left402", "icon402"],
  icon402: ["icon402"],
  title417: ["title417"],
  item403: ["item403", "left403", "icon403", "title418"],
  left403: ["left403", "icon403"],
  icon403: ["icon403"],
  title418: ["title418"],
  item404: ["item404", "left404", "icon404", "title419"],
  left404: ["left404", "icon404"],
  icon404: ["icon404"],
  title419: ["title419"],
  item405: ["item405", "left405", "icon405", "title420"],
  left405: ["left405", "icon405"],
  icon405: ["icon405"],
  title420: ["title420"],
  item406: ["item406", "left406", "icon406", "title421"],
  left406: ["left406", "icon406"],
  icon406: ["icon406"],
  title421: ["title421"],
  item407: ["item407", "left407", "icon407", "title422"],
  left407: ["left407", "icon407"],
  icon407: ["icon407"],
  title422: ["title422"],
  item408: ["item408", "left408", "icon408", "title423"],
  left408: ["left408", "icon408"],
  icon408: ["icon408"],
  title423: ["title423"],
  btn13: ["btn13"],
  narrowCard14: [
    "narrowCard14",
    "header34",
    "title424",
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14"
  ],
  header34: ["header34", "title424"],
  title424: ["title424"],
  content14: [
    "content14",
    "desc14",
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448",
    "btn14"
  ],
  desc14: ["desc14"],
  placeholder14: [
    "placeholder14",
    "header35",
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448"
  ],
  header35: ["header35"],
  list25: [
    "list25",
    "item409",
    "left409",
    "icon409",
    "title425",
    "item410",
    "left410",
    "icon410",
    "title426",
    "item411",
    "left411",
    "icon411",
    "title427",
    "item412",
    "left412",
    "icon412",
    "title428",
    "item413",
    "left413",
    "icon413",
    "title429",
    "item414",
    "left414",
    "icon414",
    "title430",
    "item415",
    "left415",
    "icon415",
    "title431",
    "item416",
    "left416",
    "icon416",
    "title432",
    "item417",
    "left417",
    "icon417",
    "title433",
    "item418",
    "left418",
    "icon418",
    "title434",
    "item419",
    "left419",
    "icon419",
    "title435",
    "item420",
    "left420",
    "icon420",
    "title436",
    "item421",
    "left421",
    "icon421",
    "title437",
    "item422",
    "left422",
    "icon422",
    "title438",
    "item423",
    "left423",
    "icon423",
    "title439",
    "item424",
    "left424",
    "icon424",
    "title440",
    "item425",
    "left425",
    "icon425",
    "title441",
    "item426",
    "left426",
    "icon426",
    "title442",
    "item427",
    "left427",
    "icon427",
    "title443",
    "item428",
    "left428",
    "icon428",
    "title444",
    "item429",
    "left429",
    "icon429",
    "title445",
    "item430",
    "left430",
    "icon430",
    "title446",
    "item431",
    "left431",
    "icon431",
    "title447",
    "item432",
    "left432",
    "icon432",
    "title448"
  ],
  item409: ["item409", "left409", "icon409", "title425"],
  left409: ["left409", "icon409"],
  icon409: ["icon409"],
  title425: ["title425"],
  item410: ["item410", "left410", "icon410", "title426"],
  left410: ["left410", "icon410"],
  icon410: ["icon410"],
  title426: ["title426"],
  item411: ["item411", "left411", "icon411", "title427"],
  left411: ["left411", "icon411"],
  icon411: ["icon411"],
  title427: ["title427"],
  item412: ["item412", "left412", "icon412", "title428"],
  left412: ["left412", "icon412"],
  icon412: ["icon412"],
  title428: ["title428"],
  item413: ["item413", "left413", "icon413", "title429"],
  left413: ["left413", "icon413"],
  icon413: ["icon413"],
  title429: ["title429"],
  item414: ["item414", "left414", "icon414", "title430"],
  left414: ["left414", "icon414"],
  icon414: ["icon414"],
  title430: ["title430"],
  item415: ["item415", "left415", "icon415", "title431"],
  left415: ["left415", "icon415"],
  icon415: ["icon415"],
  title431: ["title431"],
  item416: ["item416", "left416", "icon416", "title432"],
  left416: ["left416", "icon416"],
  icon416: ["icon416"],
  title432: ["title432"],
  item417: ["item417", "left417", "icon417", "title433"],
  left417: ["left417", "icon417"],
  icon417: ["icon417"],
  title433: ["title433"],
  item418: ["item418", "left418", "icon418", "title434"],
  left418: ["left418", "icon418"],
  icon418: ["icon418"],
  title434: ["title434"],
  item419: ["item419", "left419", "icon419", "title435"],
  left419: ["left419", "icon419"],
  icon419: ["icon419"],
  title435: ["title435"],
  item420: ["item420", "left420", "icon420", "title436"],
  left420: ["left420", "icon420"],
  icon420: ["icon420"],
  title436: ["title436"],
  item421: ["item421", "left421", "icon421", "title437"],
  left421: ["left421", "icon421"],
  icon421: ["icon421"],
  title437: ["title437"],
  item422: ["item422", "left422", "icon422", "title438"],
  left422: ["left422", "icon422"],
  icon422: ["icon422"],
  title438: ["title438"],
  item423: ["item423", "left423", "icon423", "title439"],
  left423: ["left423", "icon423"],
  icon423: ["icon423"],
  title439: ["title439"],
  item424: ["item424", "left424", "icon424", "title440"],
  left424: ["left424", "icon424"],
  icon424: ["icon424"],
  title440: ["title440"],
  item425: ["item425", "left425", "icon425", "title441"],
  left425: ["left425", "icon425"],
  icon425: ["icon425"],
  title441: ["title441"],
  item426: ["item426", "left426", "icon426", "title442"],
  left426: ["left426", "icon426"],
  icon426: ["icon426"],
  title442: ["title442"],
  item427: ["item427", "left427", "icon427", "title443"],
  left427: ["left427", "icon427"],
  icon427: ["icon427"],
  title443: ["title443"],
  item428: ["item428", "left428", "icon428", "title444"],
  left428: ["left428", "icon428"],
  icon428: ["icon428"],
  title444: ["title444"],
  item429: ["item429", "left429", "icon429", "title445"],
  left429: ["left429", "icon429"],
  icon429: ["icon429"],
  title445: ["title445"],
  item430: ["item430", "left430", "icon430", "title446"],
  left430: ["left430", "icon430"],
  icon430: ["icon430"],
  title446: ["title446"],
  item431: ["item431", "left431", "icon431", "title447"],
  left431: ["left431", "icon431"],
  icon431: ["icon431"],
  title447: ["title447"],
  item432: ["item432", "left432", "icon432", "title448"],
  left432: ["left432", "icon432"],
  icon432: ["icon432"],
  title448: ["title448"],
  btn14: ["btn14"],
  narrowCard15: [
    "narrowCard15",
    "header36",
    "title449",
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15"
  ],
  header36: ["header36", "title449"],
  title449: ["title449"],
  content15: [
    "content15",
    "desc15",
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473",
    "btn15"
  ],
  desc15: ["desc15"],
  placeholder15: [
    "placeholder15",
    "header37",
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473"
  ],
  header37: ["header37"],
  list26: [
    "list26",
    "item433",
    "left433",
    "icon433",
    "title450",
    "item434",
    "left434",
    "icon434",
    "title451",
    "item435",
    "left435",
    "icon435",
    "title452",
    "item436",
    "left436",
    "icon436",
    "title453",
    "item437",
    "left437",
    "icon437",
    "title454",
    "item438",
    "left438",
    "icon438",
    "title455",
    "item439",
    "left439",
    "icon439",
    "title456",
    "item440",
    "left440",
    "icon440",
    "title457",
    "item441",
    "left441",
    "icon441",
    "title458",
    "item442",
    "left442",
    "icon442",
    "title459",
    "item443",
    "left443",
    "icon443",
    "title460",
    "item444",
    "left444",
    "icon444",
    "title461",
    "item445",
    "left445",
    "icon445",
    "title462",
    "item446",
    "left446",
    "icon446",
    "title463",
    "item447",
    "left447",
    "icon447",
    "title464",
    "item448",
    "left448",
    "icon448",
    "title465",
    "item449",
    "left449",
    "icon449",
    "title466",
    "item450",
    "left450",
    "icon450",
    "title467",
    "item451",
    "left451",
    "icon451",
    "title468",
    "item452",
    "left452",
    "icon452",
    "title469",
    "item453",
    "left453",
    "icon453",
    "title470",
    "item454",
    "left454",
    "icon454",
    "title471",
    "item455",
    "left455",
    "icon455",
    "title472",
    "item456",
    "left456",
    "icon456",
    "title473"
  ],
  item433: ["item433", "left433", "icon433", "title450"],
  left433: ["left433", "icon433"],
  icon433: ["icon433"],
  title450: ["title450"],
  item434: ["item434", "left434", "icon434", "title451"],
  left434: ["left434", "icon434"],
  icon434: ["icon434"],
  title451: ["title451"],
  item435: ["item435", "left435", "icon435", "title452"],
  left435: ["left435", "icon435"],
  icon435: ["icon435"],
  title452: ["title452"],
  item436: ["item436", "left436", "icon436", "title453"],
  left436: ["left436", "icon436"],
  icon436: ["icon436"],
  title453: ["title453"],
  item437: ["item437", "left437", "icon437", "title454"],
  left437: ["left437", "icon437"],
  icon437: ["icon437"],
  title454: ["title454"],
  item438: ["item438", "left438", "icon438", "title455"],
  left438: ["left438", "icon438"],
  icon438: ["icon438"],
  title455: ["title455"],
  item439: ["item439", "left439", "icon439", "title456"],
  left439: ["left439", "icon439"],
  icon439: ["icon439"],
  title456: ["title456"],
  item440: ["item440", "left440", "icon440", "title457"],
  left440: ["left440", "icon440"],
  icon440: ["icon440"],
  title457: ["title457"],
  item441: ["item441", "left441", "icon441", "title458"],
  left441: ["left441", "icon441"],
  icon441: ["icon441"],
  title458: ["title458"],
  item442: ["item442", "left442", "icon442", "title459"],
  left442: ["left442", "icon442"],
  icon442: ["icon442"],
  title459: ["title459"],
  item443: ["item443", "left443", "icon443", "title460"],
  left443: ["left443", "icon443"],
  icon443: ["icon443"],
  title460: ["title460"],
  item444: ["item444", "left444", "icon444", "title461"],
  left444: ["left444", "icon444"],
  icon444: ["icon444"],
  title461: ["title461"],
  item445: ["item445", "left445", "icon445", "title462"],
  left445: ["left445", "icon445"],
  icon445: ["icon445"],
  title462: ["title462"],
  item446: ["item446", "left446", "icon446", "title463"],
  left446: ["left446", "icon446"],
  icon446: ["icon446"],
  title463: ["title463"],
  item447: ["item447", "left447", "icon447", "title464"],
  left447: ["left447", "icon447"],
  icon447: ["icon447"],
  title464: ["title464"],
  item448: ["item448", "left448", "icon448", "title465"],
  left448: ["left448", "icon448"],
  icon448: ["icon448"],
  title465: ["title465"],
  item449: ["item449", "left449", "icon449", "title466"],
  left449: ["left449", "icon449"],
  icon449: ["icon449"],
  title466: ["title466"],
  item450: ["item450", "left450", "icon450", "title467"],
  left450: ["left450", "icon450"],
  icon450: ["icon450"],
  title467: ["title467"],
  item451: ["item451", "left451", "icon451", "title468"],
  left451: ["left451", "icon451"],
  icon451: ["icon451"],
  title468: ["title468"],
  item452: ["item452", "left452", "icon452", "title469"],
  left452: ["left452", "icon452"],
  icon452: ["icon452"],
  title469: ["title469"],
  item453: ["item453", "left453", "icon453", "title470"],
  left453: ["left453", "icon453"],
  icon453: ["icon453"],
  title470: ["title470"],
  item454: ["item454", "left454", "icon454", "title471"],
  left454: ["left454", "icon454"],
  icon454: ["icon454"],
  title471: ["title471"],
  item455: ["item455", "left455", "icon455", "title472"],
  left455: ["left455", "icon455"],
  icon455: ["icon455"],
  title472: ["title472"],
  item456: ["item456", "left456", "icon456", "title473"],
  left456: ["left456", "icon456"],
  icon456: ["icon456"],
  title473: ["title473"],
  btn15: ["btn15"],
  narrowCard16: [
    "narrowCard16",
    "header38",
    "title474",
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  header38: ["header38", "title474"],
  title474: ["title474"],
  content16: [
    "content16",
    "desc16",
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498",
    "btn16"
  ],
  desc16: ["desc16"],
  placeholder16: [
    "placeholder16",
    "header39",
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498"
  ],
  header39: ["header39"],
  list27: [
    "list27",
    "item457",
    "left457",
    "icon457",
    "title475",
    "item458",
    "left458",
    "icon458",
    "title476",
    "item459",
    "left459",
    "icon459",
    "title477",
    "item460",
    "left460",
    "icon460",
    "title478",
    "item461",
    "left461",
    "icon461",
    "title479",
    "item462",
    "left462",
    "icon462",
    "title480",
    "item463",
    "left463",
    "icon463",
    "title481",
    "item464",
    "left464",
    "icon464",
    "title482",
    "item465",
    "left465",
    "icon465",
    "title483",
    "item466",
    "left466",
    "icon466",
    "title484",
    "item467",
    "left467",
    "icon467",
    "title485",
    "item468",
    "left468",
    "icon468",
    "title486",
    "item469",
    "left469",
    "icon469",
    "title487",
    "item470",
    "left470",
    "icon470",
    "title488",
    "item471",
    "left471",
    "icon471",
    "title489",
    "item472",
    "left472",
    "icon472",
    "title490",
    "item473",
    "left473",
    "icon473",
    "title491",
    "item474",
    "left474",
    "icon474",
    "title492",
    "item475",
    "left475",
    "icon475",
    "title493",
    "item476",
    "left476",
    "icon476",
    "title494",
    "item477",
    "left477",
    "icon477",
    "title495",
    "item478",
    "left478",
    "icon478",
    "title496",
    "item479",
    "left479",
    "icon479",
    "title497",
    "item480",
    "left480",
    "icon480",
    "title498"
  ],
  item457: ["item457", "left457", "icon457", "title475"],
  left457: ["left457", "icon457"],
  icon457: ["icon457"],
  title475: ["title475"],
  item458: ["item458", "left458", "icon458", "title476"],
  left458: ["left458", "icon458"],
  icon458: ["icon458"],
  title476: ["title476"],
  item459: ["item459", "left459", "icon459", "title477"],
  left459: ["left459", "icon459"],
  icon459: ["icon459"],
  title477: ["title477"],
  item460: ["item460", "left460", "icon460", "title478"],
  left460: ["left460", "icon460"],
  icon460: ["icon460"],
  title478: ["title478"],
  item461: ["item461", "left461", "icon461", "title479"],
  left461: ["left461", "icon461"],
  icon461: ["icon461"],
  title479: ["title479"],
  item462: ["item462", "left462", "icon462", "title480"],
  left462: ["left462", "icon462"],
  icon462: ["icon462"],
  title480: ["title480"],
  item463: ["item463", "left463", "icon463", "title481"],
  left463: ["left463", "icon463"],
  icon463: ["icon463"],
  title481: ["title481"],
  item464: ["item464", "left464", "icon464", "title482"],
  left464: ["left464", "icon464"],
  icon464: ["icon464"],
  title482: ["title482"],
  item465: ["item465", "left465", "icon465", "title483"],
  left465: ["left465", "icon465"],
  icon465: ["icon465"],
  title483: ["title483"],
  item466: ["item466", "left466", "icon466", "title484"],
  left466: ["left466", "icon466"],
  icon466: ["icon466"],
  title484: ["title484"],
  item467: ["item467", "left467", "icon467", "title485"],
  left467: ["left467", "icon467"],
  icon467: ["icon467"],
  title485: ["title485"],
  item468: ["item468", "left468", "icon468", "title486"],
  left468: ["left468", "icon468"],
  icon468: ["icon468"],
  title486: ["title486"],
  item469: ["item469", "left469", "icon469", "title487"],
  left469: ["left469", "icon469"],
  icon469: ["icon469"],
  title487: ["title487"],
  item470: ["item470", "left470", "icon470", "title488"],
  left470: ["left470", "icon470"],
  icon470: ["icon470"],
  title488: ["title488"],
  item471: ["item471", "left471", "icon471", "title489"],
  left471: ["left471", "icon471"],
  icon471: ["icon471"],
  title489: ["title489"],
  item472: ["item472", "left472", "icon472", "title490"],
  left472: ["left472", "icon472"],
  icon472: ["icon472"],
  title490: ["title490"],
  item473: ["item473", "left473", "icon473", "title491"],
  left473: ["left473", "icon473"],
  icon473: ["icon473"],
  title491: ["title491"],
  item474: ["item474", "left474", "icon474", "title492"],
  left474: ["left474", "icon474"],
  icon474: ["icon474"],
  title492: ["title492"],
  item475: ["item475", "left475", "icon475", "title493"],
  left475: ["left475", "icon475"],
  icon475: ["icon475"],
  title493: ["title493"],
  item476: ["item476", "left476", "icon476", "title494"],
  left476: ["left476", "icon476"],
  icon476: ["icon476"],
  title494: ["title494"],
  item477: ["item477", "left477", "icon477", "title495"],
  left477: ["left477", "icon477"],
  icon477: ["icon477"],
  title495: ["title495"],
  item478: ["item478", "left478", "icon478", "title496"],
  left478: ["left478", "icon478"],
  icon478: ["icon478"],
  title496: ["title496"],
  item479: ["item479", "left479", "icon479", "title497"],
  left479: ["left479", "icon479"],
  icon479: ["icon479"],
  title497: ["title497"],
  item480: ["item480", "left480", "icon480", "title498"],
  left480: ["left480", "icon480"],
  icon480: ["icon480"],
  title498: ["title498"],
  btn16: ["btn16"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  myEvaluations: "section";
  desktop: "div";
  key2: "div";
  list: "div";
  row2: "div";
  narrowCard: "div";
  header: "div";
  title196: "div";
  content: "div";
  desc: "div";
  placeholder: "div";
  header13: "div";
  list16: "div";
  item193: "div";
  left193: "div";
  icon193: "div";
  title197: "div";
  item194: "div";
  left194: "div";
  icon194: "div";
  title198: "div";
  item195: "div";
  left195: "div";
  icon195: "div";
  title199: "div";
  item196: "div";
  left196: "div";
  icon196: "div";
  title200: "div";
  item197: "div";
  left197: "div";
  icon197: "div";
  title201: "div";
  item198: "div";
  left198: "div";
  icon198: "div";
  title202: "div";
  item199: "div";
  left199: "div";
  icon199: "div";
  title203: "div";
  item200: "div";
  left200: "div";
  icon200: "div";
  title204: "div";
  item201: "div";
  left201: "div";
  icon201: "div";
  title205: "div";
  item202: "div";
  left202: "div";
  icon202: "div";
  title206: "div";
  item203: "div";
  left203: "div";
  icon203: "div";
  title207: "div";
  item204: "div";
  left204: "div";
  icon204: "div";
  title208: "div";
  item205: "div";
  left205: "div";
  icon205: "div";
  title209: "div";
  item206: "div";
  left206: "div";
  icon206: "div";
  title210: "div";
  item207: "div";
  left207: "div";
  icon207: "div";
  title211: "div";
  item208: "div";
  left208: "div";
  icon208: "div";
  title212: "div";
  item209: "div";
  left209: "div";
  icon209: "div";
  title213: "div";
  item210: "div";
  left210: "div";
  icon210: "div";
  title214: "div";
  item211: "div";
  left211: "div";
  icon211: "div";
  title215: "div";
  item212: "div";
  left212: "div";
  icon212: "div";
  title216: "div";
  item213: "div";
  left213: "div";
  icon213: "div";
  title217: "div";
  item214: "div";
  left214: "div";
  icon214: "div";
  title218: "div";
  item215: "div";
  left215: "div";
  icon215: "div";
  title219: "div";
  item216: "div";
  left216: "div";
  icon216: "div";
  title220: "div";
  btn: typeof Button;
  figmaPaste: "div";
  narrowCard3: "div";
  header14: "div";
  title221: "div";
  content3: "div";
  desc3: "div";
  placeholder3: "div";
  header15: "div";
  list17: "div";
  item217: "div";
  left217: "div";
  icon217: "div";
  title222: "div";
  item218: "div";
  left218: "div";
  icon218: "div";
  title223: "div";
  item219: "div";
  left219: "div";
  icon219: "div";
  title224: "div";
  item220: "div";
  left220: "div";
  icon220: "div";
  title225: "div";
  item221: "div";
  left221: "div";
  icon221: "div";
  title226: "div";
  item222: "div";
  left222: "div";
  icon222: "div";
  title227: "div";
  item223: "div";
  left223: "div";
  icon223: "div";
  title228: "div";
  item224: "div";
  left224: "div";
  icon224: "div";
  title229: "div";
  item225: "div";
  left225: "div";
  icon225: "div";
  title230: "div";
  item226: "div";
  left226: "div";
  icon226: "div";
  title231: "div";
  item227: "div";
  left227: "div";
  icon227: "div";
  title232: "div";
  item228: "div";
  left228: "div";
  icon228: "div";
  title233: "div";
  item229: "div";
  left229: "div";
  icon229: "div";
  title234: "div";
  item230: "div";
  left230: "div";
  icon230: "div";
  title235: "div";
  item231: "div";
  left231: "div";
  icon231: "div";
  title236: "div";
  item232: "div";
  left232: "div";
  icon232: "div";
  title237: "div";
  item233: "div";
  left233: "div";
  icon233: "div";
  title238: "div";
  item234: "div";
  left234: "div";
  icon234: "div";
  title239: "div";
  item235: "div";
  left235: "div";
  icon235: "div";
  title240: "div";
  item236: "div";
  left236: "div";
  icon236: "div";
  title241: "div";
  item237: "div";
  left237: "div";
  icon237: "div";
  title242: "div";
  item238: "div";
  left238: "div";
  icon238: "div";
  title243: "div";
  item239: "div";
  left239: "div";
  icon239: "div";
  title244: "div";
  item240: "div";
  left240: "div";
  icon240: "div";
  title245: "div";
  btn3: typeof Button;
  narrowCard2: "div";
  header16: "div";
  title246: "div";
  content2: "div";
  desc2: "div";
  placeholder2: "div";
  header17: "div";
  list18: "div";
  item241: "div";
  left241: "div";
  icon241: "div";
  title247: "div";
  item242: "div";
  left242: "div";
  icon242: "div";
  title248: "div";
  item243: "div";
  left243: "div";
  icon243: "div";
  title249: "div";
  item244: "div";
  left244: "div";
  icon244: "div";
  title250: "div";
  item245: "div";
  left245: "div";
  icon245: "div";
  title251: "div";
  item246: "div";
  left246: "div";
  icon246: "div";
  title252: "div";
  item247: "div";
  left247: "div";
  icon247: "div";
  title253: "div";
  item248: "div";
  left248: "div";
  icon248: "div";
  title254: "div";
  item249: "div";
  left249: "div";
  icon249: "div";
  title255: "div";
  item250: "div";
  left250: "div";
  icon250: "div";
  title256: "div";
  item251: "div";
  left251: "div";
  icon251: "div";
  title257: "div";
  item252: "div";
  left252: "div";
  icon252: "div";
  title258: "div";
  item253: "div";
  left253: "div";
  icon253: "div";
  title259: "div";
  item254: "div";
  left254: "div";
  icon254: "div";
  title260: "div";
  item255: "div";
  left255: "div";
  icon255: "div";
  title261: "div";
  item256: "div";
  left256: "div";
  icon256: "div";
  title262: "div";
  item257: "div";
  left257: "div";
  icon257: "div";
  title263: "div";
  item258: "div";
  left258: "div";
  icon258: "div";
  title264: "div";
  item259: "div";
  left259: "div";
  icon259: "div";
  title265: "div";
  item260: "div";
  left260: "div";
  icon260: "div";
  title266: "div";
  item261: "div";
  left261: "div";
  icon261: "div";
  title267: "div";
  item262: "div";
  left262: "div";
  icon262: "div";
  title268: "div";
  item263: "div";
  left263: "div";
  icon263: "div";
  title269: "div";
  item264: "div";
  left264: "div";
  icon264: "div";
  title270: "div";
  btn2: typeof Button;
  row3: "div";
  figmaPaste2: "div";
  narrowCard4: "div";
  header18: "div";
  title271: "div";
  content4: "div";
  desc4: "div";
  placeholder4: "div";
  header19: "div";
  list19: "div";
  item265: "div";
  left265: "div";
  icon265: "div";
  title272: "div";
  item266: "div";
  left266: "div";
  icon266: "div";
  title273: "div";
  item267: "div";
  left267: "div";
  icon267: "div";
  title274: "div";
  item268: "div";
  left268: "div";
  icon268: "div";
  title275: "div";
  item269: "div";
  left269: "div";
  icon269: "div";
  title276: "div";
  item270: "div";
  left270: "div";
  icon270: "div";
  title277: "div";
  item271: "div";
  left271: "div";
  icon271: "div";
  title278: "div";
  item272: "div";
  left272: "div";
  icon272: "div";
  title279: "div";
  item273: "div";
  left273: "div";
  icon273: "div";
  title280: "div";
  item274: "div";
  left274: "div";
  icon274: "div";
  title281: "div";
  item275: "div";
  left275: "div";
  icon275: "div";
  title282: "div";
  item276: "div";
  left276: "div";
  icon276: "div";
  title283: "div";
  item277: "div";
  left277: "div";
  icon277: "div";
  title284: "div";
  item278: "div";
  left278: "div";
  icon278: "div";
  title285: "div";
  item279: "div";
  left279: "div";
  icon279: "div";
  title286: "div";
  item280: "div";
  left280: "div";
  icon280: "div";
  title287: "div";
  item281: "div";
  left281: "div";
  icon281: "div";
  title288: "div";
  item282: "div";
  left282: "div";
  icon282: "div";
  title289: "div";
  item283: "div";
  left283: "div";
  icon283: "div";
  title290: "div";
  item284: "div";
  left284: "div";
  icon284: "div";
  title291: "div";
  item285: "div";
  left285: "div";
  icon285: "div";
  title292: "div";
  item286: "div";
  left286: "div";
  icon286: "div";
  title293: "div";
  item287: "div";
  left287: "div";
  icon287: "div";
  title294: "div";
  item288: "div";
  left288: "div";
  icon288: "div";
  title295: "div";
  btn4: typeof Button;
  narrowCard5: "div";
  header20: "div";
  title296: "div";
  content5: "div";
  desc5: "div";
  placeholder5: "div";
  header21: "div";
  list20: "div";
  item289: "div";
  left289: "div";
  icon289: "div";
  title297: "div";
  item290: "div";
  left290: "div";
  icon290: "div";
  title298: "div";
  item291: "div";
  left291: "div";
  icon291: "div";
  title299: "div";
  item292: "div";
  left292: "div";
  icon292: "div";
  title300: "div";
  item293: "div";
  left293: "div";
  icon293: "div";
  title301: "div";
  item294: "div";
  left294: "div";
  icon294: "div";
  title302: "div";
  item295: "div";
  left295: "div";
  icon295: "div";
  title303: "div";
  item296: "div";
  left296: "div";
  icon296: "div";
  title304: "div";
  item297: "div";
  left297: "div";
  icon297: "div";
  title305: "div";
  item298: "div";
  left298: "div";
  icon298: "div";
  title306: "div";
  item299: "div";
  left299: "div";
  icon299: "div";
  title307: "div";
  item300: "div";
  left300: "div";
  icon300: "div";
  title308: "div";
  item301: "div";
  left301: "div";
  icon301: "div";
  title309: "div";
  item302: "div";
  left302: "div";
  icon302: "div";
  title310: "div";
  item303: "div";
  left303: "div";
  icon303: "div";
  title311: "div";
  item304: "div";
  left304: "div";
  icon304: "div";
  title312: "div";
  item305: "div";
  left305: "div";
  icon305: "div";
  title313: "div";
  item306: "div";
  left306: "div";
  icon306: "div";
  title314: "div";
  item307: "div";
  left307: "div";
  icon307: "div";
  title315: "div";
  item308: "div";
  left308: "div";
  icon308: "div";
  title316: "div";
  item309: "div";
  left309: "div";
  icon309: "div";
  title317: "div";
  item310: "div";
  left310: "div";
  icon310: "div";
  title318: "div";
  item311: "div";
  left311: "div";
  icon311: "div";
  title319: "div";
  item312: "div";
  left312: "div";
  icon312: "div";
  title320: "div";
  btn5: typeof Button;
  narrowCard6: "div";
  header22: "div";
  title321: "div";
  content6: "div";
  desc6: "div";
  placeholder6: "div";
  header23: "div";
  list21: "div";
  item313: "div";
  left313: "div";
  icon313: "div";
  title322: "div";
  item314: "div";
  left314: "div";
  icon314: "div";
  title323: "div";
  item315: "div";
  left315: "div";
  icon315: "div";
  title324: "div";
  item316: "div";
  left316: "div";
  icon316: "div";
  title325: "div";
  item317: "div";
  left317: "div";
  icon317: "div";
  title326: "div";
  item318: "div";
  left318: "div";
  icon318: "div";
  title327: "div";
  item319: "div";
  left319: "div";
  icon319: "div";
  title328: "div";
  item320: "div";
  left320: "div";
  icon320: "div";
  title329: "div";
  item321: "div";
  left321: "div";
  icon321: "div";
  title330: "div";
  item322: "div";
  left322: "div";
  icon322: "div";
  title331: "div";
  item323: "div";
  left323: "div";
  icon323: "div";
  title332: "div";
  item324: "div";
  left324: "div";
  icon324: "div";
  title333: "div";
  item325: "div";
  left325: "div";
  icon325: "div";
  title334: "div";
  item326: "div";
  left326: "div";
  icon326: "div";
  title335: "div";
  item327: "div";
  left327: "div";
  icon327: "div";
  title336: "div";
  item328: "div";
  left328: "div";
  icon328: "div";
  title337: "div";
  item329: "div";
  left329: "div";
  icon329: "div";
  title338: "div";
  item330: "div";
  left330: "div";
  icon330: "div";
  title339: "div";
  item331: "div";
  left331: "div";
  icon331: "div";
  title340: "div";
  item332: "div";
  left332: "div";
  icon332: "div";
  title341: "div";
  item333: "div";
  left333: "div";
  icon333: "div";
  title342: "div";
  item334: "div";
  left334: "div";
  icon334: "div";
  title343: "div";
  item335: "div";
  left335: "div";
  icon335: "div";
  title344: "div";
  item336: "div";
  left336: "div";
  icon336: "div";
  title345: "div";
  btn6: typeof Button;
  row4: "div";
  figmaPaste3: "div";
  narrowCard7: "div";
  header24: "div";
  title346: "div";
  content7: "div";
  desc7: "div";
  placeholder7: "div";
  header25: "div";
  list22: "div";
  item337: "div";
  left337: "div";
  icon337: "div";
  title347: "div";
  item338: "div";
  left338: "div";
  icon338: "div";
  title348: "div";
  item339: "div";
  left339: "div";
  icon339: "div";
  title349: "div";
  item340: "div";
  left340: "div";
  icon340: "div";
  title350: "div";
  item341: "div";
  left341: "div";
  icon341: "div";
  title351: "div";
  item342: "div";
  left342: "div";
  icon342: "div";
  title352: "div";
  item343: "div";
  left343: "div";
  icon343: "div";
  title353: "div";
  item344: "div";
  left344: "div";
  icon344: "div";
  title354: "div";
  item345: "div";
  left345: "div";
  icon345: "div";
  title355: "div";
  item346: "div";
  left346: "div";
  icon346: "div";
  title356: "div";
  item347: "div";
  left347: "div";
  icon347: "div";
  title357: "div";
  item348: "div";
  left348: "div";
  icon348: "div";
  title358: "div";
  item349: "div";
  left349: "div";
  icon349: "div";
  title359: "div";
  item350: "div";
  left350: "div";
  icon350: "div";
  title360: "div";
  item351: "div";
  left351: "div";
  icon351: "div";
  title361: "div";
  item352: "div";
  left352: "div";
  icon352: "div";
  title362: "div";
  item353: "div";
  left353: "div";
  icon353: "div";
  title363: "div";
  item354: "div";
  left354: "div";
  icon354: "div";
  title364: "div";
  item355: "div";
  left355: "div";
  icon355: "div";
  title365: "div";
  item356: "div";
  left356: "div";
  icon356: "div";
  title366: "div";
  item357: "div";
  left357: "div";
  icon357: "div";
  title367: "div";
  item358: "div";
  left358: "div";
  icon358: "div";
  title368: "div";
  item359: "div";
  left359: "div";
  icon359: "div";
  title369: "div";
  item360: "div";
  left360: "div";
  icon360: "div";
  title370: "div";
  btn7: typeof Button;
  narrowCard8: "div";
  header26: "div";
  title371: "div";
  content8: "div";
  desc8: "div";
  placeholder8: "div";
  header27: "div";
  list23: "div";
  item361: "div";
  left361: "div";
  icon361: "div";
  title372: "div";
  item362: "div";
  left362: "div";
  icon362: "div";
  title373: "div";
  item363: "div";
  left363: "div";
  icon363: "div";
  title374: "div";
  item364: "div";
  left364: "div";
  icon364: "div";
  title375: "div";
  item365: "div";
  left365: "div";
  icon365: "div";
  title376: "div";
  item366: "div";
  left366: "div";
  icon366: "div";
  title377: "div";
  item367: "div";
  left367: "div";
  icon367: "div";
  title378: "div";
  item368: "div";
  left368: "div";
  icon368: "div";
  title379: "div";
  item369: "div";
  left369: "div";
  icon369: "div";
  title380: "div";
  item370: "div";
  left370: "div";
  icon370: "div";
  title381: "div";
  item371: "div";
  left371: "div";
  icon371: "div";
  title382: "div";
  item372: "div";
  left372: "div";
  icon372: "div";
  title383: "div";
  item373: "div";
  left373: "div";
  icon373: "div";
  title384: "div";
  item374: "div";
  left374: "div";
  icon374: "div";
  title385: "div";
  item375: "div";
  left375: "div";
  icon375: "div";
  title386: "div";
  item376: "div";
  left376: "div";
  icon376: "div";
  title387: "div";
  item377: "div";
  left377: "div";
  icon377: "div";
  title388: "div";
  item378: "div";
  left378: "div";
  icon378: "div";
  title389: "div";
  item379: "div";
  left379: "div";
  icon379: "div";
  title390: "div";
  item380: "div";
  left380: "div";
  icon380: "div";
  title391: "div";
  item381: "div";
  left381: "div";
  icon381: "div";
  title392: "div";
  item382: "div";
  left382: "div";
  icon382: "div";
  title393: "div";
  item383: "div";
  left383: "div";
  icon383: "div";
  title394: "div";
  item384: "div";
  left384: "div";
  icon384: "div";
  title395: "div";
  btn8: typeof Button;
  tablet: "div";
  row6: "div";
  featuresProductHeader: typeof FeaturesProductHeader;
  key4: "div";
  header4: "header";
  list11: "div";
  row7: "div";
  figmaPaste5: "div";
  narrowCard17: "div";
  header9: "div";
  title100: "div";
  content17: "div";
  desc17: "div";
  placeholder17: "div";
  header10: "div";
  list7: "div";
  item97: "div";
  left97: "div";
  icon97: "div";
  title2: "div";
  item98: "div";
  left98: "div";
  icon98: "div";
  title101: "div";
  item99: "div";
  left99: "div";
  icon99: "div";
  title102: "div";
  item100: "div";
  left100: "div";
  icon100: "div";
  title103: "div";
  item101: "div";
  left101: "div";
  icon101: "div";
  title104: "div";
  item102: "div";
  left102: "div";
  icon102: "div";
  title105: "div";
  item103: "div";
  left103: "div";
  icon103: "div";
  title106: "div";
  item104: "div";
  left104: "div";
  icon104: "div";
  title107: "div";
  item105: "div";
  left105: "div";
  icon105: "div";
  title108: "div";
  item106: "div";
  left106: "div";
  icon106: "div";
  title109: "div";
  item107: "div";
  left107: "div";
  icon107: "div";
  title110: "div";
  item108: "div";
  left108: "div";
  icon108: "div";
  title111: "div";
  item109: "div";
  left109: "div";
  icon109: "div";
  title112: "div";
  item110: "div";
  left110: "div";
  icon110: "div";
  title113: "div";
  item111: "div";
  left111: "div";
  icon111: "div";
  title114: "div";
  item112: "div";
  left112: "div";
  icon112: "div";
  title115: "div";
  item113: "div";
  left113: "div";
  icon113: "div";
  title116: "div";
  item114: "div";
  left114: "div";
  icon114: "div";
  title117: "div";
  item115: "div";
  left115: "div";
  icon115: "div";
  title118: "div";
  item116: "div";
  left116: "div";
  icon116: "div";
  title119: "div";
  item117: "div";
  left117: "div";
  icon117: "div";
  title120: "div";
  item118: "div";
  left118: "div";
  icon118: "div";
  title121: "div";
  item119: "div";
  left119: "div";
  icon119: "div";
  title122: "div";
  item120: "div";
  left120: "div";
  icon120: "div";
  title123: "div";
  btn17: typeof Button;
  narrowCard18: "div";
  header11: "div";
  title124: "div";
  content18: "div";
  desc18: "div";
  placeholder18: "div";
  header12: "div";
  list8: "div";
  item121: "div";
  left121: "div";
  icon121: "div";
  title125: "div";
  item122: "div";
  left122: "div";
  icon122: "div";
  title126: "div";
  item123: "div";
  left123: "div";
  icon123: "div";
  title127: "div";
  item124: "div";
  left124: "div";
  icon124: "div";
  title128: "div";
  item125: "div";
  left125: "div";
  icon125: "div";
  title129: "div";
  item126: "div";
  left126: "div";
  icon126: "div";
  title130: "div";
  item127: "div";
  left127: "div";
  icon127: "div";
  title131: "div";
  item128: "div";
  left128: "div";
  icon128: "div";
  title132: "div";
  item129: "div";
  left129: "div";
  icon129: "div";
  title133: "div";
  item130: "div";
  left130: "div";
  icon130: "div";
  title134: "div";
  item131: "div";
  left131: "div";
  icon131: "div";
  title135: "div";
  item132: "div";
  left132: "div";
  icon132: "div";
  title136: "div";
  item133: "div";
  left133: "div";
  icon133: "div";
  title137: "div";
  item134: "div";
  left134: "div";
  icon134: "div";
  title138: "div";
  item135: "div";
  left135: "div";
  icon135: "div";
  title139: "div";
  item136: "div";
  left136: "div";
  icon136: "div";
  title140: "div";
  item137: "div";
  left137: "div";
  icon137: "div";
  title141: "div";
  item138: "div";
  left138: "div";
  icon138: "div";
  title142: "div";
  item139: "div";
  left139: "div";
  icon139: "div";
  title143: "div";
  item140: "div";
  left140: "div";
  icon140: "div";
  title144: "div";
  item141: "div";
  left141: "div";
  icon141: "div";
  title145: "div";
  item142: "div";
  left142: "div";
  icon142: "div";
  title146: "div";
  item143: "div";
  left143: "div";
  icon143: "div";
  title147: "div";
  item144: "div";
  left144: "div";
  icon144: "div";
  title148: "div";
  btn18: typeof Button;
  row8: "div";
  figmaPaste6: "div";
  narrowCard19: "div";
  header40: "div";
  title149: "div";
  content19: "div";
  desc19: "div";
  placeholder19: "div";
  header41: "div";
  list9: "div";
  item145: "div";
  left145: "div";
  icon145: "div";
  title150: "div";
  item146: "div";
  left146: "div";
  icon146: "div";
  title151: "div";
  item147: "div";
  left147: "div";
  icon147: "div";
  title152: "div";
  item148: "div";
  left148: "div";
  icon148: "div";
  title153: "div";
  item149: "div";
  left149: "div";
  icon149: "div";
  title154: "div";
  item150: "div";
  left150: "div";
  icon150: "div";
  title155: "div";
  item151: "div";
  left151: "div";
  icon151: "div";
  title156: "div";
  item152: "div";
  left152: "div";
  icon152: "div";
  title157: "div";
  item153: "div";
  left153: "div";
  icon153: "div";
  title158: "div";
  item154: "div";
  left154: "div";
  icon154: "div";
  title159: "div";
  item155: "div";
  left155: "div";
  icon155: "div";
  title160: "div";
  item156: "div";
  left156: "div";
  icon156: "div";
  title161: "div";
  item157: "div";
  left157: "div";
  icon157: "div";
  title162: "div";
  item158: "div";
  left158: "div";
  icon158: "div";
  title163: "div";
  item159: "div";
  left159: "div";
  icon159: "div";
  title164: "div";
  item160: "div";
  left160: "div";
  icon160: "div";
  title165: "div";
  item161: "div";
  left161: "div";
  icon161: "div";
  title166: "div";
  item162: "div";
  left162: "div";
  icon162: "div";
  title167: "div";
  item163: "div";
  left163: "div";
  icon163: "div";
  title168: "div";
  item164: "div";
  left164: "div";
  icon164: "div";
  title169: "div";
  item165: "div";
  left165: "div";
  icon165: "div";
  title170: "div";
  item166: "div";
  left166: "div";
  icon166: "div";
  title171: "div";
  item167: "div";
  left167: "div";
  icon167: "div";
  title172: "div";
  item168: "div";
  left168: "div";
  icon168: "div";
  title173: "div";
  btn19: typeof Button;
  narrowCard20: "div";
  header42: "div";
  title174: "div";
  content20: "div";
  desc20: "div";
  placeholder20: "div";
  header43: "div";
  list10: "div";
  item169: "div";
  left169: "div";
  icon169: "div";
  title175: "div";
  item170: "div";
  left170: "div";
  icon170: "div";
  title176: "div";
  item171: "div";
  left171: "div";
  icon171: "div";
  title177: "div";
  item172: "div";
  left172: "div";
  icon172: "div";
  title178: "div";
  item173: "div";
  left173: "div";
  icon173: "div";
  title179: "div";
  item174: "div";
  left174: "div";
  icon174: "div";
  title180: "div";
  item175: "div";
  left175: "div";
  icon175: "div";
  title181: "div";
  item176: "div";
  left176: "div";
  icon176: "div";
  title182: "div";
  item177: "div";
  left177: "div";
  icon177: "div";
  title183: "div";
  item178: "div";
  left178: "div";
  icon178: "div";
  title184: "div";
  item179: "div";
  left179: "div";
  icon179: "div";
  title185: "div";
  item180: "div";
  left180: "div";
  icon180: "div";
  title186: "div";
  item181: "div";
  left181: "div";
  icon181: "div";
  title187: "div";
  item182: "div";
  left182: "div";
  icon182: "div";
  title188: "div";
  item183: "div";
  left183: "div";
  icon183: "div";
  title189: "div";
  item184: "div";
  left184: "div";
  icon184: "div";
  title190: "div";
  item185: "div";
  left185: "div";
  icon185: "div";
  title191: "div";
  item186: "div";
  left186: "div";
  icon186: "div";
  title192: "div";
  item187: "div";
  left187: "div";
  icon187: "div";
  title193: "div";
  item188: "div";
  left188: "div";
  icon188: "div";
  title194: "div";
  item189: "div";
  left189: "div";
  icon189: "div";
  title195: "div";
  item190: "div";
  left190: "div";
  icon190: "div";
  title499: "div";
  item191: "div";
  left191: "div";
  icon191: "div";
  title500: "div";
  item192: "div";
  left192: "div";
  icon192: "div";
  title501: "div";
  btn20: typeof Button;
  narrowCard21: "div";
  header44: "div";
  title502: "div";
  content21: "div";
  desc21: "div";
  placeholder21: "div";
  header45: "div";
  list28: "div";
  item481: "div";
  left481: "div";
  icon481: "div";
  title503: "div";
  item482: "div";
  left482: "div";
  icon482: "div";
  title504: "div";
  item483: "div";
  left483: "div";
  icon483: "div";
  title505: "div";
  item484: "div";
  left484: "div";
  icon484: "div";
  title506: "div";
  item485: "div";
  left485: "div";
  icon485: "div";
  title507: "div";
  item486: "div";
  left486: "div";
  icon486: "div";
  title508: "div";
  item487: "div";
  left487: "div";
  icon487: "div";
  title509: "div";
  item488: "div";
  left488: "div";
  icon488: "div";
  title510: "div";
  item489: "div";
  left489: "div";
  icon489: "div";
  title511: "div";
  item490: "div";
  left490: "div";
  icon490: "div";
  title512: "div";
  item491: "div";
  left491: "div";
  icon491: "div";
  title513: "div";
  item492: "div";
  left492: "div";
  icon492: "div";
  title514: "div";
  item493: "div";
  left493: "div";
  icon493: "div";
  title515: "div";
  item494: "div";
  left494: "div";
  icon494: "div";
  title516: "div";
  item495: "div";
  left495: "div";
  icon495: "div";
  title517: "div";
  item496: "div";
  left496: "div";
  icon496: "div";
  title518: "div";
  item497: "div";
  left497: "div";
  icon497: "div";
  title519: "div";
  item498: "div";
  left498: "div";
  icon498: "div";
  title520: "div";
  item499: "div";
  left499: "div";
  icon499: "div";
  title521: "div";
  item500: "div";
  left500: "div";
  icon500: "div";
  title522: "div";
  item501: "div";
  left501: "div";
  icon501: "div";
  title523: "div";
  item502: "div";
  left502: "div";
  icon502: "div";
  title524: "div";
  item503: "div";
  left503: "div";
  icon503: "div";
  title525: "div";
  item504: "div";
  left504: "div";
  icon504: "div";
  title526: "div";
  btn21: typeof Button;
  narrowCard22: "div";
  header46: "div";
  title527: "div";
  content22: "div";
  desc22: "div";
  placeholder22: "div";
  header47: "div";
  list29: "div";
  item505: "div";
  left505: "div";
  icon505: "div";
  title528: "div";
  item506: "div";
  left506: "div";
  icon506: "div";
  title529: "div";
  item507: "div";
  left507: "div";
  icon507: "div";
  title530: "div";
  item508: "div";
  left508: "div";
  icon508: "div";
  title531: "div";
  item509: "div";
  left509: "div";
  icon509: "div";
  title532: "div";
  item510: "div";
  left510: "div";
  icon510: "div";
  title533: "div";
  item511: "div";
  left511: "div";
  icon511: "div";
  title534: "div";
  item512: "div";
  left512: "div";
  icon512: "div";
  title535: "div";
  item513: "div";
  left513: "div";
  icon513: "div";
  title536: "div";
  item514: "div";
  left514: "div";
  icon514: "div";
  title537: "div";
  item515: "div";
  left515: "div";
  icon515: "div";
  title538: "div";
  item516: "div";
  left516: "div";
  icon516: "div";
  title539: "div";
  item517: "div";
  left517: "div";
  icon517: "div";
  title540: "div";
  item518: "div";
  left518: "div";
  icon518: "div";
  title541: "div";
  item519: "div";
  left519: "div";
  icon519: "div";
  title542: "div";
  item520: "div";
  left520: "div";
  icon520: "div";
  title543: "div";
  item521: "div";
  left521: "div";
  icon521: "div";
  title544: "div";
  item522: "div";
  left522: "div";
  icon522: "div";
  title545: "div";
  item523: "div";
  left523: "div";
  icon523: "div";
  title546: "div";
  item524: "div";
  left524: "div";
  icon524: "div";
  title547: "div";
  item525: "div";
  left525: "div";
  icon525: "div";
  title548: "div";
  item526: "div";
  left526: "div";
  icon526: "div";
  title549: "div";
  item527: "div";
  left527: "div";
  icon527: "div";
  title550: "div";
  item528: "div";
  left528: "div";
  icon528: "div";
  title551: "div";
  btn22: typeof Button;
  row9: "div";
  figmaPaste7: "div";
  narrowCard23: "div";
  header48: "div";
  title552: "div";
  content23: "div";
  desc23: "div";
  placeholder23: "div";
  header49: "div";
  list30: "div";
  item529: "div";
  left529: "div";
  icon529: "div";
  title553: "div";
  item530: "div";
  left530: "div";
  icon530: "div";
  title554: "div";
  item531: "div";
  left531: "div";
  icon531: "div";
  title555: "div";
  item532: "div";
  left532: "div";
  icon532: "div";
  title556: "div";
  item533: "div";
  left533: "div";
  icon533: "div";
  title557: "div";
  item534: "div";
  left534: "div";
  icon534: "div";
  title558: "div";
  item535: "div";
  left535: "div";
  icon535: "div";
  title559: "div";
  item536: "div";
  left536: "div";
  icon536: "div";
  title560: "div";
  item537: "div";
  left537: "div";
  icon537: "div";
  title561: "div";
  item538: "div";
  left538: "div";
  icon538: "div";
  title562: "div";
  item539: "div";
  left539: "div";
  icon539: "div";
  title563: "div";
  item540: "div";
  left540: "div";
  icon540: "div";
  title564: "div";
  item541: "div";
  left541: "div";
  icon541: "div";
  title565: "div";
  item542: "div";
  left542: "div";
  icon542: "div";
  title566: "div";
  item543: "div";
  left543: "div";
  icon543: "div";
  title567: "div";
  item544: "div";
  left544: "div";
  icon544: "div";
  title568: "div";
  item545: "div";
  left545: "div";
  icon545: "div";
  title569: "div";
  item546: "div";
  left546: "div";
  icon546: "div";
  title570: "div";
  item547: "div";
  left547: "div";
  icon547: "div";
  title571: "div";
  item548: "div";
  left548: "div";
  icon548: "div";
  title572: "div";
  item549: "div";
  left549: "div";
  icon549: "div";
  title573: "div";
  item550: "div";
  left550: "div";
  icon550: "div";
  title574: "div";
  item551: "div";
  left551: "div";
  icon551: "div";
  title575: "div";
  item552: "div";
  left552: "div";
  icon552: "div";
  title576: "div";
  btn23: typeof Button;
  narrowCard24: "div";
  header50: "div";
  title577: "div";
  content24: "div";
  desc24: "div";
  placeholder24: "div";
  header51: "div";
  list31: "div";
  item553: "div";
  left553: "div";
  icon553: "div";
  title578: "div";
  item554: "div";
  left554: "div";
  icon554: "div";
  title579: "div";
  item555: "div";
  left555: "div";
  icon555: "div";
  title580: "div";
  item556: "div";
  left556: "div";
  icon556: "div";
  title581: "div";
  item557: "div";
  left557: "div";
  icon557: "div";
  title582: "div";
  item558: "div";
  left558: "div";
  icon558: "div";
  title583: "div";
  item559: "div";
  left559: "div";
  icon559: "div";
  title584: "div";
  item560: "div";
  left560: "div";
  icon560: "div";
  title585: "div";
  item561: "div";
  left561: "div";
  icon561: "div";
  title586: "div";
  item562: "div";
  left562: "div";
  icon562: "div";
  title587: "div";
  item563: "div";
  left563: "div";
  icon563: "div";
  title588: "div";
  item564: "div";
  left564: "div";
  icon564: "div";
  title589: "div";
  item565: "div";
  left565: "div";
  icon565: "div";
  title590: "div";
  item566: "div";
  left566: "div";
  icon566: "div";
  title591: "div";
  item567: "div";
  left567: "div";
  icon567: "div";
  title592: "div";
  item568: "div";
  left568: "div";
  icon568: "div";
  title593: "div";
  item569: "div";
  left569: "div";
  icon569: "div";
  title594: "div";
  item570: "div";
  left570: "div";
  icon570: "div";
  title595: "div";
  item571: "div";
  left571: "div";
  icon571: "div";
  title596: "div";
  item572: "div";
  left572: "div";
  icon572: "div";
  title597: "div";
  item573: "div";
  left573: "div";
  icon573: "div";
  title598: "div";
  item574: "div";
  left574: "div";
  icon574: "div";
  title599: "div";
  item575: "div";
  left575: "div";
  icon575: "div";
  title600: "div";
  item576: "div";
  left576: "div";
  icon576: "div";
  title601: "div";
  btn24: typeof Button;
  row10: "div";
  row11: "div";
  figmaPaste8: "div";
  narrowCard25: "div";
  header52: "div";
  title602: "div";
  content25: "div";
  desc25: "div";
  placeholder25: "div";
  header53: "div";
  list32: "div";
  item577: "div";
  left577: "div";
  icon577: "div";
  title603: "div";
  item578: "div";
  left578: "div";
  icon578: "div";
  title604: "div";
  item579: "div";
  left579: "div";
  icon579: "div";
  title605: "div";
  item580: "div";
  left580: "div";
  icon580: "div";
  title606: "div";
  item581: "div";
  left581: "div";
  icon581: "div";
  title607: "div";
  item582: "div";
  left582: "div";
  icon582: "div";
  title608: "div";
  item583: "div";
  left583: "div";
  icon583: "div";
  title609: "div";
  item584: "div";
  left584: "div";
  icon584: "div";
  title610: "div";
  item585: "div";
  left585: "div";
  icon585: "div";
  title611: "div";
  item586: "div";
  left586: "div";
  icon586: "div";
  title612: "div";
  item587: "div";
  left587: "div";
  icon587: "div";
  title613: "div";
  item588: "div";
  left588: "div";
  icon588: "div";
  title614: "div";
  item589: "div";
  left589: "div";
  icon589: "div";
  title615: "div";
  item590: "div";
  left590: "div";
  icon590: "div";
  title616: "div";
  item591: "div";
  left591: "div";
  icon591: "div";
  title617: "div";
  item592: "div";
  left592: "div";
  icon592: "div";
  title618: "div";
  item593: "div";
  left593: "div";
  icon593: "div";
  title619: "div";
  item594: "div";
  left594: "div";
  icon594: "div";
  title620: "div";
  item595: "div";
  left595: "div";
  icon595: "div";
  title621: "div";
  item596: "div";
  left596: "div";
  icon596: "div";
  title622: "div";
  item597: "div";
  left597: "div";
  icon597: "div";
  title623: "div";
  item598: "div";
  left598: "div";
  icon598: "div";
  title624: "div";
  item599: "div";
  left599: "div";
  icon599: "div";
  title625: "div";
  item600: "div";
  left600: "div";
  icon600: "div";
  title626: "div";
  btn25: typeof Button;
  narrowCard26: "div";
  header54: "div";
  title627: "div";
  content26: "div";
  desc26: "div";
  placeholder26: "div";
  header55: "div";
  list33: "div";
  item601: "div";
  left601: "div";
  icon601: "div";
  title628: "div";
  item602: "div";
  left602: "div";
  icon602: "div";
  title629: "div";
  item603: "div";
  left603: "div";
  icon603: "div";
  title630: "div";
  item604: "div";
  left604: "div";
  icon604: "div";
  title631: "div";
  item605: "div";
  left605: "div";
  icon605: "div";
  title632: "div";
  item606: "div";
  left606: "div";
  icon606: "div";
  title633: "div";
  item607: "div";
  left607: "div";
  icon607: "div";
  title634: "div";
  item608: "div";
  left608: "div";
  icon608: "div";
  title635: "div";
  item609: "div";
  left609: "div";
  icon609: "div";
  title636: "div";
  item610: "div";
  left610: "div";
  icon610: "div";
  title637: "div";
  item611: "div";
  left611: "div";
  icon611: "div";
  title638: "div";
  item612: "div";
  left612: "div";
  icon612: "div";
  title639: "div";
  item613: "div";
  left613: "div";
  icon613: "div";
  title640: "div";
  item614: "div";
  left614: "div";
  icon614: "div";
  title641: "div";
  item615: "div";
  left615: "div";
  icon615: "div";
  title642: "div";
  item616: "div";
  left616: "div";
  icon616: "div";
  title643: "div";
  item617: "div";
  left617: "div";
  icon617: "div";
  title644: "div";
  item618: "div";
  left618: "div";
  icon618: "div";
  title645: "div";
  item619: "div";
  left619: "div";
  icon619: "div";
  title646: "div";
  item620: "div";
  left620: "div";
  icon620: "div";
  title647: "div";
  item621: "div";
  left621: "div";
  icon621: "div";
  title648: "div";
  item622: "div";
  left622: "div";
  icon622: "div";
  title649: "div";
  item623: "div";
  left623: "div";
  icon623: "div";
  title650: "div";
  item624: "div";
  left624: "div";
  icon624: "div";
  title651: "div";
  btn26: typeof Button;
  all3: "div";
  title3: "h2";
  sections3: "div";
  col8: "div";
  list12: "div";
  col9: "div";
  section5: "div";
  list13: "div";
  section6: "div";
  list14: "div";
  col10: "div";
  list15: "div";
  mobile: "div";
  header3: "div";
  key3: "div";
  header2: "header";
  list6: "div";
  figmaPaste4: "div";
  narrowCard9: "div";
  header28: "div";
  title: "div";
  content9: "div";
  desc9: "div";
  placeholder9: "div";
  header29: "div";
  list24: "div";
  item: "div";
  left: "div";
  icon: "div";
  title396: "div";
  item2: "div";
  left2: "div";
  icon2: "div";
  title397: "div";
  item3: "div";
  left3: "div";
  icon3: "div";
  title4: "div";
  item4: "div";
  left4: "div";
  icon4: "div";
  title5: "div";
  item5: "div";
  left5: "div";
  icon5: "div";
  title6: "div";
  item6: "div";
  left6: "div";
  icon6: "div";
  title7: "div";
  item7: "div";
  left7: "div";
  icon7: "div";
  title8: "div";
  item8: "div";
  left8: "div";
  icon8: "div";
  title9: "div";
  item9: "div";
  left9: "div";
  icon9: "div";
  title10: "div";
  item10: "div";
  left10: "div";
  icon10: "div";
  title11: "div";
  item11: "div";
  left11: "div";
  icon11: "div";
  title12: "div";
  item12: "div";
  left12: "div";
  icon12: "div";
  title13: "div";
  item13: "div";
  left13: "div";
  icon13: "div";
  title14: "div";
  item14: "div";
  left14: "div";
  icon14: "div";
  title15: "div";
  item15: "div";
  left15: "div";
  icon15: "div";
  title16: "div";
  item16: "div";
  left16: "div";
  icon16: "div";
  title17: "div";
  item17: "div";
  left17: "div";
  icon17: "div";
  title18: "div";
  item18: "div";
  left18: "div";
  icon18: "div";
  title19: "div";
  item19: "div";
  left19: "div";
  icon19: "div";
  title20: "div";
  item20: "div";
  left20: "div";
  icon20: "div";
  title21: "div";
  item21: "div";
  left21: "div";
  icon21: "div";
  title22: "div";
  item22: "div";
  left22: "div";
  icon22: "div";
  title23: "div";
  item23: "div";
  left23: "div";
  icon23: "div";
  title24: "div";
  item24: "div";
  left24: "div";
  icon24: "div";
  title25: "div";
  btn9: typeof Button;
  narrowCard10: "div";
  header30: "div";
  title26: "div";
  content10: "div";
  desc10: "div";
  placeholder10: "div";
  header31: "div";
  list2: "div";
  item25: "div";
  left25: "div";
  icon25: "div";
  title27: "div";
  item26: "div";
  left26: "div";
  icon26: "div";
  title28: "div";
  item27: "div";
  left27: "div";
  icon27: "div";
  title29: "div";
  item28: "div";
  left28: "div";
  icon28: "div";
  title30: "div";
  item29: "div";
  left29: "div";
  icon29: "div";
  title31: "div";
  item30: "div";
  left30: "div";
  icon30: "div";
  title32: "div";
  item31: "div";
  left31: "div";
  icon31: "div";
  title33: "div";
  item32: "div";
  left32: "div";
  icon32: "div";
  title34: "div";
  item33: "div";
  left33: "div";
  icon33: "div";
  title35: "div";
  item34: "div";
  left34: "div";
  icon34: "div";
  title36: "div";
  item35: "div";
  left35: "div";
  icon35: "div";
  title37: "div";
  item36: "div";
  left36: "div";
  icon36: "div";
  title38: "div";
  item37: "div";
  left37: "div";
  icon37: "div";
  title39: "div";
  item38: "div";
  left38: "div";
  icon38: "div";
  title40: "div";
  item39: "div";
  left39: "div";
  icon39: "div";
  title41: "div";
  item40: "div";
  left40: "div";
  icon40: "div";
  title42: "div";
  item41: "div";
  left41: "div";
  icon41: "div";
  title43: "div";
  item42: "div";
  left42: "div";
  icon42: "div";
  title44: "div";
  item43: "div";
  left43: "div";
  icon43: "div";
  title45: "div";
  item44: "div";
  left44: "div";
  icon44: "div";
  title46: "div";
  item45: "div";
  left45: "div";
  icon45: "div";
  title47: "div";
  item46: "div";
  left46: "div";
  icon46: "div";
  title48: "div";
  item47: "div";
  left47: "div";
  icon47: "div";
  title49: "div";
  item48: "div";
  left48: "div";
  icon48: "div";
  title50: "div";
  btn10: typeof Button;
  narrowCard11: "div";
  header5: "div";
  title51: "div";
  content11: "div";
  desc11: "div";
  placeholder11: "div";
  header6: "div";
  list3: "div";
  item49: "div";
  left49: "div";
  icon49: "div";
  title52: "div";
  item50: "div";
  left50: "div";
  icon50: "div";
  title53: "div";
  item51: "div";
  left51: "div";
  icon51: "div";
  title54: "div";
  item52: "div";
  left52: "div";
  icon52: "div";
  title55: "div";
  item53: "div";
  left53: "div";
  icon53: "div";
  title56: "div";
  item54: "div";
  left54: "div";
  icon54: "div";
  title57: "div";
  item55: "div";
  left55: "div";
  icon55: "div";
  title58: "div";
  item56: "div";
  left56: "div";
  icon56: "div";
  title59: "div";
  item57: "div";
  left57: "div";
  icon57: "div";
  title60: "div";
  item58: "div";
  left58: "div";
  icon58: "div";
  title61: "div";
  item59: "div";
  left59: "div";
  icon59: "div";
  title62: "div";
  item60: "div";
  left60: "div";
  icon60: "div";
  title63: "div";
  item61: "div";
  left61: "div";
  icon61: "div";
  title64: "div";
  item62: "div";
  left62: "div";
  icon62: "div";
  title65: "div";
  item63: "div";
  left63: "div";
  icon63: "div";
  title66: "div";
  item64: "div";
  left64: "div";
  icon64: "div";
  title67: "div";
  item65: "div";
  left65: "div";
  icon65: "div";
  title68: "div";
  item66: "div";
  left66: "div";
  icon66: "div";
  title69: "div";
  item67: "div";
  left67: "div";
  icon67: "div";
  title70: "div";
  item68: "div";
  left68: "div";
  icon68: "div";
  title71: "div";
  item69: "div";
  left69: "div";
  icon69: "div";
  title72: "div";
  item70: "div";
  left70: "div";
  icon70: "div";
  title73: "div";
  item71: "div";
  left71: "div";
  icon71: "div";
  title74: "div";
  item72: "div";
  left72: "div";
  icon72: "div";
  title75: "div";
  btn11: typeof Button;
  narrowCard12: "div";
  header7: "div";
  title76: "div";
  content12: "div";
  desc12: "div";
  placeholder12: "div";
  header8: "div";
  list4: "div";
  item73: "div";
  left73: "div";
  icon73: "div";
  title77: "div";
  item74: "div";
  left74: "div";
  icon74: "div";
  title78: "div";
  item75: "div";
  left75: "div";
  icon75: "div";
  title79: "div";
  item76: "div";
  left76: "div";
  icon76: "div";
  title80: "div";
  item77: "div";
  left77: "div";
  icon77: "div";
  title81: "div";
  item78: "div";
  left78: "div";
  icon78: "div";
  title82: "div";
  item79: "div";
  left79: "div";
  icon79: "div";
  title83: "div";
  item80: "div";
  left80: "div";
  icon80: "div";
  title84: "div";
  item81: "div";
  left81: "div";
  icon81: "div";
  title85: "div";
  item82: "div";
  left82: "div";
  icon82: "div";
  title86: "div";
  item83: "div";
  left83: "div";
  icon83: "div";
  title87: "div";
  item84: "div";
  left84: "div";
  icon84: "div";
  title88: "div";
  item85: "div";
  left85: "div";
  icon85: "div";
  title89: "div";
  item86: "div";
  left86: "div";
  icon86: "div";
  title90: "div";
  item87: "div";
  left87: "div";
  icon87: "div";
  title91: "div";
  item88: "div";
  left88: "div";
  icon88: "div";
  title92: "div";
  item89: "div";
  left89: "div";
  icon89: "div";
  title93: "div";
  item90: "div";
  left90: "div";
  icon90: "div";
  title94: "div";
  item91: "div";
  left91: "div";
  icon91: "div";
  title95: "div";
  item92: "div";
  left92: "div";
  icon92: "div";
  title96: "div";
  item93: "div";
  left93: "div";
  icon93: "div";
  title97: "div";
  item94: "div";
  left94: "div";
  icon94: "div";
  title98: "div";
  item95: "div";
  left95: "div";
  icon95: "div";
  title99: "div";
  item96: "div";
  left96: "div";
  icon96: "div";
  title398: "div";
  btn12: typeof Button;
  narrowCard13: "div";
  header32: "div";
  title399: "div";
  content13: "div";
  desc13: "div";
  placeholder13: "div";
  header33: "div";
  list5: "div";
  item385: "div";
  left385: "div";
  icon385: "div";
  title400: "div";
  item386: "div";
  left386: "div";
  icon386: "div";
  title401: "div";
  item387: "div";
  left387: "div";
  icon387: "div";
  title402: "div";
  item388: "div";
  left388: "div";
  icon388: "div";
  title403: "div";
  item389: "div";
  left389: "div";
  icon389: "div";
  title404: "div";
  item390: "div";
  left390: "div";
  icon390: "div";
  title405: "div";
  item391: "div";
  left391: "div";
  icon391: "div";
  title406: "div";
  item392: "div";
  left392: "div";
  icon392: "div";
  title407: "div";
  item393: "div";
  left393: "div";
  icon393: "div";
  title408: "div";
  item394: "div";
  left394: "div";
  icon394: "div";
  title409: "div";
  item395: "div";
  left395: "div";
  icon395: "div";
  title410: "div";
  item396: "div";
  left396: "div";
  icon396: "div";
  title411: "div";
  item397: "div";
  left397: "div";
  icon397: "div";
  title412: "div";
  item398: "div";
  left398: "div";
  icon398: "div";
  title413: "div";
  item399: "div";
  left399: "div";
  icon399: "div";
  title414: "div";
  item400: "div";
  left400: "div";
  icon400: "div";
  title415: "div";
  item401: "div";
  left401: "div";
  icon401: "div";
  title416: "div";
  item402: "div";
  left402: "div";
  icon402: "div";
  title417: "div";
  item403: "div";
  left403: "div";
  icon403: "div";
  title418: "div";
  item404: "div";
  left404: "div";
  icon404: "div";
  title419: "div";
  item405: "div";
  left405: "div";
  icon405: "div";
  title420: "div";
  item406: "div";
  left406: "div";
  icon406: "div";
  title421: "div";
  item407: "div";
  left407: "div";
  icon407: "div";
  title422: "div";
  item408: "div";
  left408: "div";
  icon408: "div";
  title423: "div";
  btn13: typeof Button;
  narrowCard14: "div";
  header34: "div";
  title424: "div";
  content14: "div";
  desc14: "div";
  placeholder14: "div";
  header35: "div";
  list25: "div";
  item409: "div";
  left409: "div";
  icon409: "div";
  title425: "div";
  item410: "div";
  left410: "div";
  icon410: "div";
  title426: "div";
  item411: "div";
  left411: "div";
  icon411: "div";
  title427: "div";
  item412: "div";
  left412: "div";
  icon412: "div";
  title428: "div";
  item413: "div";
  left413: "div";
  icon413: "div";
  title429: "div";
  item414: "div";
  left414: "div";
  icon414: "div";
  title430: "div";
  item415: "div";
  left415: "div";
  icon415: "div";
  title431: "div";
  item416: "div";
  left416: "div";
  icon416: "div";
  title432: "div";
  item417: "div";
  left417: "div";
  icon417: "div";
  title433: "div";
  item418: "div";
  left418: "div";
  icon418: "div";
  title434: "div";
  item419: "div";
  left419: "div";
  icon419: "div";
  title435: "div";
  item420: "div";
  left420: "div";
  icon420: "div";
  title436: "div";
  item421: "div";
  left421: "div";
  icon421: "div";
  title437: "div";
  item422: "div";
  left422: "div";
  icon422: "div";
  title438: "div";
  item423: "div";
  left423: "div";
  icon423: "div";
  title439: "div";
  item424: "div";
  left424: "div";
  icon424: "div";
  title440: "div";
  item425: "div";
  left425: "div";
  icon425: "div";
  title441: "div";
  item426: "div";
  left426: "div";
  icon426: "div";
  title442: "div";
  item427: "div";
  left427: "div";
  icon427: "div";
  title443: "div";
  item428: "div";
  left428: "div";
  icon428: "div";
  title444: "div";
  item429: "div";
  left429: "div";
  icon429: "div";
  title445: "div";
  item430: "div";
  left430: "div";
  icon430: "div";
  title446: "div";
  item431: "div";
  left431: "div";
  icon431: "div";
  title447: "div";
  item432: "div";
  left432: "div";
  icon432: "div";
  title448: "div";
  btn14: typeof Button;
  narrowCard15: "div";
  header36: "div";
  title449: "div";
  content15: "div";
  desc15: "div";
  placeholder15: "div";
  header37: "div";
  list26: "div";
  item433: "div";
  left433: "div";
  icon433: "div";
  title450: "div";
  item434: "div";
  left434: "div";
  icon434: "div";
  title451: "div";
  item435: "div";
  left435: "div";
  icon435: "div";
  title452: "div";
  item436: "div";
  left436: "div";
  icon436: "div";
  title453: "div";
  item437: "div";
  left437: "div";
  icon437: "div";
  title454: "div";
  item438: "div";
  left438: "div";
  icon438: "div";
  title455: "div";
  item439: "div";
  left439: "div";
  icon439: "div";
  title456: "div";
  item440: "div";
  left440: "div";
  icon440: "div";
  title457: "div";
  item441: "div";
  left441: "div";
  icon441: "div";
  title458: "div";
  item442: "div";
  left442: "div";
  icon442: "div";
  title459: "div";
  item443: "div";
  left443: "div";
  icon443: "div";
  title460: "div";
  item444: "div";
  left444: "div";
  icon444: "div";
  title461: "div";
  item445: "div";
  left445: "div";
  icon445: "div";
  title462: "div";
  item446: "div";
  left446: "div";
  icon446: "div";
  title463: "div";
  item447: "div";
  left447: "div";
  icon447: "div";
  title464: "div";
  item448: "div";
  left448: "div";
  icon448: "div";
  title465: "div";
  item449: "div";
  left449: "div";
  icon449: "div";
  title466: "div";
  item450: "div";
  left450: "div";
  icon450: "div";
  title467: "div";
  item451: "div";
  left451: "div";
  icon451: "div";
  title468: "div";
  item452: "div";
  left452: "div";
  icon452: "div";
  title469: "div";
  item453: "div";
  left453: "div";
  icon453: "div";
  title470: "div";
  item454: "div";
  left454: "div";
  icon454: "div";
  title471: "div";
  item455: "div";
  left455: "div";
  icon455: "div";
  title472: "div";
  item456: "div";
  left456: "div";
  icon456: "div";
  title473: "div";
  btn15: typeof Button;
  narrowCard16: "div";
  header38: "div";
  title474: "div";
  content16: "div";
  desc16: "div";
  placeholder16: "div";
  header39: "div";
  list27: "div";
  item457: "div";
  left457: "div";
  icon457: "div";
  title475: "div";
  item458: "div";
  left458: "div";
  icon458: "div";
  title476: "div";
  item459: "div";
  left459: "div";
  icon459: "div";
  title477: "div";
  item460: "div";
  left460: "div";
  icon460: "div";
  title478: "div";
  item461: "div";
  left461: "div";
  icon461: "div";
  title479: "div";
  item462: "div";
  left462: "div";
  icon462: "div";
  title480: "div";
  item463: "div";
  left463: "div";
  icon463: "div";
  title481: "div";
  item464: "div";
  left464: "div";
  icon464: "div";
  title482: "div";
  item465: "div";
  left465: "div";
  icon465: "div";
  title483: "div";
  item466: "div";
  left466: "div";
  icon466: "div";
  title484: "div";
  item467: "div";
  left467: "div";
  icon467: "div";
  title485: "div";
  item468: "div";
  left468: "div";
  icon468: "div";
  title486: "div";
  item469: "div";
  left469: "div";
  icon469: "div";
  title487: "div";
  item470: "div";
  left470: "div";
  icon470: "div";
  title488: "div";
  item471: "div";
  left471: "div";
  icon471: "div";
  title489: "div";
  item472: "div";
  left472: "div";
  icon472: "div";
  title490: "div";
  item473: "div";
  left473: "div";
  icon473: "div";
  title491: "div";
  item474: "div";
  left474: "div";
  icon474: "div";
  title492: "div";
  item475: "div";
  left475: "div";
  icon475: "div";
  title493: "div";
  item476: "div";
  left476: "div";
  icon476: "div";
  title494: "div";
  item477: "div";
  left477: "div";
  icon477: "div";
  title495: "div";
  item478: "div";
  left478: "div";
  icon478: "div";
  title496: "div";
  item479: "div";
  left479: "div";
  icon479: "div";
  title497: "div";
  item480: "div";
  left480: "div";
  icon480: "div";
  title498: "div";
  btn16: typeof Button;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCapabilitiesCards__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCapabilitiesCards__VariantsArgs;
    args?: PlasmicCapabilitiesCards__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicCapabilitiesCards__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicCapabilitiesCards__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCapabilitiesCards__ArgProps,
          internalVariantPropNames: PlasmicCapabilitiesCards__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCapabilitiesCards__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "myEvaluations") {
    func.displayName = "PlasmicCapabilitiesCards";
  } else {
    func.displayName = `PlasmicCapabilitiesCards.${nodeName}`;
  }
  return func;
}

export const PlasmicCapabilitiesCards = Object.assign(
  // Top-level PlasmicCapabilitiesCards renders the root element
  makeNodeComponent("myEvaluations"),
  {
    // Helper components rendering sub-elements
    desktop: makeNodeComponent("desktop"),
    key2: makeNodeComponent("key2"),
    list: makeNodeComponent("list"),
    row2: makeNodeComponent("row2"),
    narrowCard: makeNodeComponent("narrowCard"),
    header: makeNodeComponent("header"),
    title196: makeNodeComponent("title196"),
    content: makeNodeComponent("content"),
    desc: makeNodeComponent("desc"),
    placeholder: makeNodeComponent("placeholder"),
    header13: makeNodeComponent("header13"),
    list16: makeNodeComponent("list16"),
    item193: makeNodeComponent("item193"),
    left193: makeNodeComponent("left193"),
    icon193: makeNodeComponent("icon193"),
    title197: makeNodeComponent("title197"),
    item194: makeNodeComponent("item194"),
    left194: makeNodeComponent("left194"),
    icon194: makeNodeComponent("icon194"),
    title198: makeNodeComponent("title198"),
    item195: makeNodeComponent("item195"),
    left195: makeNodeComponent("left195"),
    icon195: makeNodeComponent("icon195"),
    title199: makeNodeComponent("title199"),
    item196: makeNodeComponent("item196"),
    left196: makeNodeComponent("left196"),
    icon196: makeNodeComponent("icon196"),
    title200: makeNodeComponent("title200"),
    item197: makeNodeComponent("item197"),
    left197: makeNodeComponent("left197"),
    icon197: makeNodeComponent("icon197"),
    title201: makeNodeComponent("title201"),
    item198: makeNodeComponent("item198"),
    left198: makeNodeComponent("left198"),
    icon198: makeNodeComponent("icon198"),
    title202: makeNodeComponent("title202"),
    item199: makeNodeComponent("item199"),
    left199: makeNodeComponent("left199"),
    icon199: makeNodeComponent("icon199"),
    title203: makeNodeComponent("title203"),
    item200: makeNodeComponent("item200"),
    left200: makeNodeComponent("left200"),
    icon200: makeNodeComponent("icon200"),
    title204: makeNodeComponent("title204"),
    item201: makeNodeComponent("item201"),
    left201: makeNodeComponent("left201"),
    icon201: makeNodeComponent("icon201"),
    title205: makeNodeComponent("title205"),
    item202: makeNodeComponent("item202"),
    left202: makeNodeComponent("left202"),
    icon202: makeNodeComponent("icon202"),
    title206: makeNodeComponent("title206"),
    item203: makeNodeComponent("item203"),
    left203: makeNodeComponent("left203"),
    icon203: makeNodeComponent("icon203"),
    title207: makeNodeComponent("title207"),
    item204: makeNodeComponent("item204"),
    left204: makeNodeComponent("left204"),
    icon204: makeNodeComponent("icon204"),
    title208: makeNodeComponent("title208"),
    item205: makeNodeComponent("item205"),
    left205: makeNodeComponent("left205"),
    icon205: makeNodeComponent("icon205"),
    title209: makeNodeComponent("title209"),
    item206: makeNodeComponent("item206"),
    left206: makeNodeComponent("left206"),
    icon206: makeNodeComponent("icon206"),
    title210: makeNodeComponent("title210"),
    item207: makeNodeComponent("item207"),
    left207: makeNodeComponent("left207"),
    icon207: makeNodeComponent("icon207"),
    title211: makeNodeComponent("title211"),
    item208: makeNodeComponent("item208"),
    left208: makeNodeComponent("left208"),
    icon208: makeNodeComponent("icon208"),
    title212: makeNodeComponent("title212"),
    item209: makeNodeComponent("item209"),
    left209: makeNodeComponent("left209"),
    icon209: makeNodeComponent("icon209"),
    title213: makeNodeComponent("title213"),
    item210: makeNodeComponent("item210"),
    left210: makeNodeComponent("left210"),
    icon210: makeNodeComponent("icon210"),
    title214: makeNodeComponent("title214"),
    item211: makeNodeComponent("item211"),
    left211: makeNodeComponent("left211"),
    icon211: makeNodeComponent("icon211"),
    title215: makeNodeComponent("title215"),
    item212: makeNodeComponent("item212"),
    left212: makeNodeComponent("left212"),
    icon212: makeNodeComponent("icon212"),
    title216: makeNodeComponent("title216"),
    item213: makeNodeComponent("item213"),
    left213: makeNodeComponent("left213"),
    icon213: makeNodeComponent("icon213"),
    title217: makeNodeComponent("title217"),
    item214: makeNodeComponent("item214"),
    left214: makeNodeComponent("left214"),
    icon214: makeNodeComponent("icon214"),
    title218: makeNodeComponent("title218"),
    item215: makeNodeComponent("item215"),
    left215: makeNodeComponent("left215"),
    icon215: makeNodeComponent("icon215"),
    title219: makeNodeComponent("title219"),
    item216: makeNodeComponent("item216"),
    left216: makeNodeComponent("left216"),
    icon216: makeNodeComponent("icon216"),
    title220: makeNodeComponent("title220"),
    btn: makeNodeComponent("btn"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    narrowCard3: makeNodeComponent("narrowCard3"),
    header14: makeNodeComponent("header14"),
    title221: makeNodeComponent("title221"),
    content3: makeNodeComponent("content3"),
    desc3: makeNodeComponent("desc3"),
    placeholder3: makeNodeComponent("placeholder3"),
    header15: makeNodeComponent("header15"),
    list17: makeNodeComponent("list17"),
    item217: makeNodeComponent("item217"),
    left217: makeNodeComponent("left217"),
    icon217: makeNodeComponent("icon217"),
    title222: makeNodeComponent("title222"),
    item218: makeNodeComponent("item218"),
    left218: makeNodeComponent("left218"),
    icon218: makeNodeComponent("icon218"),
    title223: makeNodeComponent("title223"),
    item219: makeNodeComponent("item219"),
    left219: makeNodeComponent("left219"),
    icon219: makeNodeComponent("icon219"),
    title224: makeNodeComponent("title224"),
    item220: makeNodeComponent("item220"),
    left220: makeNodeComponent("left220"),
    icon220: makeNodeComponent("icon220"),
    title225: makeNodeComponent("title225"),
    item221: makeNodeComponent("item221"),
    left221: makeNodeComponent("left221"),
    icon221: makeNodeComponent("icon221"),
    title226: makeNodeComponent("title226"),
    item222: makeNodeComponent("item222"),
    left222: makeNodeComponent("left222"),
    icon222: makeNodeComponent("icon222"),
    title227: makeNodeComponent("title227"),
    item223: makeNodeComponent("item223"),
    left223: makeNodeComponent("left223"),
    icon223: makeNodeComponent("icon223"),
    title228: makeNodeComponent("title228"),
    item224: makeNodeComponent("item224"),
    left224: makeNodeComponent("left224"),
    icon224: makeNodeComponent("icon224"),
    title229: makeNodeComponent("title229"),
    item225: makeNodeComponent("item225"),
    left225: makeNodeComponent("left225"),
    icon225: makeNodeComponent("icon225"),
    title230: makeNodeComponent("title230"),
    item226: makeNodeComponent("item226"),
    left226: makeNodeComponent("left226"),
    icon226: makeNodeComponent("icon226"),
    title231: makeNodeComponent("title231"),
    item227: makeNodeComponent("item227"),
    left227: makeNodeComponent("left227"),
    icon227: makeNodeComponent("icon227"),
    title232: makeNodeComponent("title232"),
    item228: makeNodeComponent("item228"),
    left228: makeNodeComponent("left228"),
    icon228: makeNodeComponent("icon228"),
    title233: makeNodeComponent("title233"),
    item229: makeNodeComponent("item229"),
    left229: makeNodeComponent("left229"),
    icon229: makeNodeComponent("icon229"),
    title234: makeNodeComponent("title234"),
    item230: makeNodeComponent("item230"),
    left230: makeNodeComponent("left230"),
    icon230: makeNodeComponent("icon230"),
    title235: makeNodeComponent("title235"),
    item231: makeNodeComponent("item231"),
    left231: makeNodeComponent("left231"),
    icon231: makeNodeComponent("icon231"),
    title236: makeNodeComponent("title236"),
    item232: makeNodeComponent("item232"),
    left232: makeNodeComponent("left232"),
    icon232: makeNodeComponent("icon232"),
    title237: makeNodeComponent("title237"),
    item233: makeNodeComponent("item233"),
    left233: makeNodeComponent("left233"),
    icon233: makeNodeComponent("icon233"),
    title238: makeNodeComponent("title238"),
    item234: makeNodeComponent("item234"),
    left234: makeNodeComponent("left234"),
    icon234: makeNodeComponent("icon234"),
    title239: makeNodeComponent("title239"),
    item235: makeNodeComponent("item235"),
    left235: makeNodeComponent("left235"),
    icon235: makeNodeComponent("icon235"),
    title240: makeNodeComponent("title240"),
    item236: makeNodeComponent("item236"),
    left236: makeNodeComponent("left236"),
    icon236: makeNodeComponent("icon236"),
    title241: makeNodeComponent("title241"),
    item237: makeNodeComponent("item237"),
    left237: makeNodeComponent("left237"),
    icon237: makeNodeComponent("icon237"),
    title242: makeNodeComponent("title242"),
    item238: makeNodeComponent("item238"),
    left238: makeNodeComponent("left238"),
    icon238: makeNodeComponent("icon238"),
    title243: makeNodeComponent("title243"),
    item239: makeNodeComponent("item239"),
    left239: makeNodeComponent("left239"),
    icon239: makeNodeComponent("icon239"),
    title244: makeNodeComponent("title244"),
    item240: makeNodeComponent("item240"),
    left240: makeNodeComponent("left240"),
    icon240: makeNodeComponent("icon240"),
    title245: makeNodeComponent("title245"),
    btn3: makeNodeComponent("btn3"),
    narrowCard2: makeNodeComponent("narrowCard2"),
    header16: makeNodeComponent("header16"),
    title246: makeNodeComponent("title246"),
    content2: makeNodeComponent("content2"),
    desc2: makeNodeComponent("desc2"),
    placeholder2: makeNodeComponent("placeholder2"),
    header17: makeNodeComponent("header17"),
    list18: makeNodeComponent("list18"),
    item241: makeNodeComponent("item241"),
    left241: makeNodeComponent("left241"),
    icon241: makeNodeComponent("icon241"),
    title247: makeNodeComponent("title247"),
    item242: makeNodeComponent("item242"),
    left242: makeNodeComponent("left242"),
    icon242: makeNodeComponent("icon242"),
    title248: makeNodeComponent("title248"),
    item243: makeNodeComponent("item243"),
    left243: makeNodeComponent("left243"),
    icon243: makeNodeComponent("icon243"),
    title249: makeNodeComponent("title249"),
    item244: makeNodeComponent("item244"),
    left244: makeNodeComponent("left244"),
    icon244: makeNodeComponent("icon244"),
    title250: makeNodeComponent("title250"),
    item245: makeNodeComponent("item245"),
    left245: makeNodeComponent("left245"),
    icon245: makeNodeComponent("icon245"),
    title251: makeNodeComponent("title251"),
    item246: makeNodeComponent("item246"),
    left246: makeNodeComponent("left246"),
    icon246: makeNodeComponent("icon246"),
    title252: makeNodeComponent("title252"),
    item247: makeNodeComponent("item247"),
    left247: makeNodeComponent("left247"),
    icon247: makeNodeComponent("icon247"),
    title253: makeNodeComponent("title253"),
    item248: makeNodeComponent("item248"),
    left248: makeNodeComponent("left248"),
    icon248: makeNodeComponent("icon248"),
    title254: makeNodeComponent("title254"),
    item249: makeNodeComponent("item249"),
    left249: makeNodeComponent("left249"),
    icon249: makeNodeComponent("icon249"),
    title255: makeNodeComponent("title255"),
    item250: makeNodeComponent("item250"),
    left250: makeNodeComponent("left250"),
    icon250: makeNodeComponent("icon250"),
    title256: makeNodeComponent("title256"),
    item251: makeNodeComponent("item251"),
    left251: makeNodeComponent("left251"),
    icon251: makeNodeComponent("icon251"),
    title257: makeNodeComponent("title257"),
    item252: makeNodeComponent("item252"),
    left252: makeNodeComponent("left252"),
    icon252: makeNodeComponent("icon252"),
    title258: makeNodeComponent("title258"),
    item253: makeNodeComponent("item253"),
    left253: makeNodeComponent("left253"),
    icon253: makeNodeComponent("icon253"),
    title259: makeNodeComponent("title259"),
    item254: makeNodeComponent("item254"),
    left254: makeNodeComponent("left254"),
    icon254: makeNodeComponent("icon254"),
    title260: makeNodeComponent("title260"),
    item255: makeNodeComponent("item255"),
    left255: makeNodeComponent("left255"),
    icon255: makeNodeComponent("icon255"),
    title261: makeNodeComponent("title261"),
    item256: makeNodeComponent("item256"),
    left256: makeNodeComponent("left256"),
    icon256: makeNodeComponent("icon256"),
    title262: makeNodeComponent("title262"),
    item257: makeNodeComponent("item257"),
    left257: makeNodeComponent("left257"),
    icon257: makeNodeComponent("icon257"),
    title263: makeNodeComponent("title263"),
    item258: makeNodeComponent("item258"),
    left258: makeNodeComponent("left258"),
    icon258: makeNodeComponent("icon258"),
    title264: makeNodeComponent("title264"),
    item259: makeNodeComponent("item259"),
    left259: makeNodeComponent("left259"),
    icon259: makeNodeComponent("icon259"),
    title265: makeNodeComponent("title265"),
    item260: makeNodeComponent("item260"),
    left260: makeNodeComponent("left260"),
    icon260: makeNodeComponent("icon260"),
    title266: makeNodeComponent("title266"),
    item261: makeNodeComponent("item261"),
    left261: makeNodeComponent("left261"),
    icon261: makeNodeComponent("icon261"),
    title267: makeNodeComponent("title267"),
    item262: makeNodeComponent("item262"),
    left262: makeNodeComponent("left262"),
    icon262: makeNodeComponent("icon262"),
    title268: makeNodeComponent("title268"),
    item263: makeNodeComponent("item263"),
    left263: makeNodeComponent("left263"),
    icon263: makeNodeComponent("icon263"),
    title269: makeNodeComponent("title269"),
    item264: makeNodeComponent("item264"),
    left264: makeNodeComponent("left264"),
    icon264: makeNodeComponent("icon264"),
    title270: makeNodeComponent("title270"),
    btn2: makeNodeComponent("btn2"),
    row3: makeNodeComponent("row3"),
    figmaPaste2: makeNodeComponent("figmaPaste2"),
    narrowCard4: makeNodeComponent("narrowCard4"),
    header18: makeNodeComponent("header18"),
    title271: makeNodeComponent("title271"),
    content4: makeNodeComponent("content4"),
    desc4: makeNodeComponent("desc4"),
    placeholder4: makeNodeComponent("placeholder4"),
    header19: makeNodeComponent("header19"),
    list19: makeNodeComponent("list19"),
    item265: makeNodeComponent("item265"),
    left265: makeNodeComponent("left265"),
    icon265: makeNodeComponent("icon265"),
    title272: makeNodeComponent("title272"),
    item266: makeNodeComponent("item266"),
    left266: makeNodeComponent("left266"),
    icon266: makeNodeComponent("icon266"),
    title273: makeNodeComponent("title273"),
    item267: makeNodeComponent("item267"),
    left267: makeNodeComponent("left267"),
    icon267: makeNodeComponent("icon267"),
    title274: makeNodeComponent("title274"),
    item268: makeNodeComponent("item268"),
    left268: makeNodeComponent("left268"),
    icon268: makeNodeComponent("icon268"),
    title275: makeNodeComponent("title275"),
    item269: makeNodeComponent("item269"),
    left269: makeNodeComponent("left269"),
    icon269: makeNodeComponent("icon269"),
    title276: makeNodeComponent("title276"),
    item270: makeNodeComponent("item270"),
    left270: makeNodeComponent("left270"),
    icon270: makeNodeComponent("icon270"),
    title277: makeNodeComponent("title277"),
    item271: makeNodeComponent("item271"),
    left271: makeNodeComponent("left271"),
    icon271: makeNodeComponent("icon271"),
    title278: makeNodeComponent("title278"),
    item272: makeNodeComponent("item272"),
    left272: makeNodeComponent("left272"),
    icon272: makeNodeComponent("icon272"),
    title279: makeNodeComponent("title279"),
    item273: makeNodeComponent("item273"),
    left273: makeNodeComponent("left273"),
    icon273: makeNodeComponent("icon273"),
    title280: makeNodeComponent("title280"),
    item274: makeNodeComponent("item274"),
    left274: makeNodeComponent("left274"),
    icon274: makeNodeComponent("icon274"),
    title281: makeNodeComponent("title281"),
    item275: makeNodeComponent("item275"),
    left275: makeNodeComponent("left275"),
    icon275: makeNodeComponent("icon275"),
    title282: makeNodeComponent("title282"),
    item276: makeNodeComponent("item276"),
    left276: makeNodeComponent("left276"),
    icon276: makeNodeComponent("icon276"),
    title283: makeNodeComponent("title283"),
    item277: makeNodeComponent("item277"),
    left277: makeNodeComponent("left277"),
    icon277: makeNodeComponent("icon277"),
    title284: makeNodeComponent("title284"),
    item278: makeNodeComponent("item278"),
    left278: makeNodeComponent("left278"),
    icon278: makeNodeComponent("icon278"),
    title285: makeNodeComponent("title285"),
    item279: makeNodeComponent("item279"),
    left279: makeNodeComponent("left279"),
    icon279: makeNodeComponent("icon279"),
    title286: makeNodeComponent("title286"),
    item280: makeNodeComponent("item280"),
    left280: makeNodeComponent("left280"),
    icon280: makeNodeComponent("icon280"),
    title287: makeNodeComponent("title287"),
    item281: makeNodeComponent("item281"),
    left281: makeNodeComponent("left281"),
    icon281: makeNodeComponent("icon281"),
    title288: makeNodeComponent("title288"),
    item282: makeNodeComponent("item282"),
    left282: makeNodeComponent("left282"),
    icon282: makeNodeComponent("icon282"),
    title289: makeNodeComponent("title289"),
    item283: makeNodeComponent("item283"),
    left283: makeNodeComponent("left283"),
    icon283: makeNodeComponent("icon283"),
    title290: makeNodeComponent("title290"),
    item284: makeNodeComponent("item284"),
    left284: makeNodeComponent("left284"),
    icon284: makeNodeComponent("icon284"),
    title291: makeNodeComponent("title291"),
    item285: makeNodeComponent("item285"),
    left285: makeNodeComponent("left285"),
    icon285: makeNodeComponent("icon285"),
    title292: makeNodeComponent("title292"),
    item286: makeNodeComponent("item286"),
    left286: makeNodeComponent("left286"),
    icon286: makeNodeComponent("icon286"),
    title293: makeNodeComponent("title293"),
    item287: makeNodeComponent("item287"),
    left287: makeNodeComponent("left287"),
    icon287: makeNodeComponent("icon287"),
    title294: makeNodeComponent("title294"),
    item288: makeNodeComponent("item288"),
    left288: makeNodeComponent("left288"),
    icon288: makeNodeComponent("icon288"),
    title295: makeNodeComponent("title295"),
    btn4: makeNodeComponent("btn4"),
    narrowCard5: makeNodeComponent("narrowCard5"),
    header20: makeNodeComponent("header20"),
    title296: makeNodeComponent("title296"),
    content5: makeNodeComponent("content5"),
    desc5: makeNodeComponent("desc5"),
    placeholder5: makeNodeComponent("placeholder5"),
    header21: makeNodeComponent("header21"),
    list20: makeNodeComponent("list20"),
    item289: makeNodeComponent("item289"),
    left289: makeNodeComponent("left289"),
    icon289: makeNodeComponent("icon289"),
    title297: makeNodeComponent("title297"),
    item290: makeNodeComponent("item290"),
    left290: makeNodeComponent("left290"),
    icon290: makeNodeComponent("icon290"),
    title298: makeNodeComponent("title298"),
    item291: makeNodeComponent("item291"),
    left291: makeNodeComponent("left291"),
    icon291: makeNodeComponent("icon291"),
    title299: makeNodeComponent("title299"),
    item292: makeNodeComponent("item292"),
    left292: makeNodeComponent("left292"),
    icon292: makeNodeComponent("icon292"),
    title300: makeNodeComponent("title300"),
    item293: makeNodeComponent("item293"),
    left293: makeNodeComponent("left293"),
    icon293: makeNodeComponent("icon293"),
    title301: makeNodeComponent("title301"),
    item294: makeNodeComponent("item294"),
    left294: makeNodeComponent("left294"),
    icon294: makeNodeComponent("icon294"),
    title302: makeNodeComponent("title302"),
    item295: makeNodeComponent("item295"),
    left295: makeNodeComponent("left295"),
    icon295: makeNodeComponent("icon295"),
    title303: makeNodeComponent("title303"),
    item296: makeNodeComponent("item296"),
    left296: makeNodeComponent("left296"),
    icon296: makeNodeComponent("icon296"),
    title304: makeNodeComponent("title304"),
    item297: makeNodeComponent("item297"),
    left297: makeNodeComponent("left297"),
    icon297: makeNodeComponent("icon297"),
    title305: makeNodeComponent("title305"),
    item298: makeNodeComponent("item298"),
    left298: makeNodeComponent("left298"),
    icon298: makeNodeComponent("icon298"),
    title306: makeNodeComponent("title306"),
    item299: makeNodeComponent("item299"),
    left299: makeNodeComponent("left299"),
    icon299: makeNodeComponent("icon299"),
    title307: makeNodeComponent("title307"),
    item300: makeNodeComponent("item300"),
    left300: makeNodeComponent("left300"),
    icon300: makeNodeComponent("icon300"),
    title308: makeNodeComponent("title308"),
    item301: makeNodeComponent("item301"),
    left301: makeNodeComponent("left301"),
    icon301: makeNodeComponent("icon301"),
    title309: makeNodeComponent("title309"),
    item302: makeNodeComponent("item302"),
    left302: makeNodeComponent("left302"),
    icon302: makeNodeComponent("icon302"),
    title310: makeNodeComponent("title310"),
    item303: makeNodeComponent("item303"),
    left303: makeNodeComponent("left303"),
    icon303: makeNodeComponent("icon303"),
    title311: makeNodeComponent("title311"),
    item304: makeNodeComponent("item304"),
    left304: makeNodeComponent("left304"),
    icon304: makeNodeComponent("icon304"),
    title312: makeNodeComponent("title312"),
    item305: makeNodeComponent("item305"),
    left305: makeNodeComponent("left305"),
    icon305: makeNodeComponent("icon305"),
    title313: makeNodeComponent("title313"),
    item306: makeNodeComponent("item306"),
    left306: makeNodeComponent("left306"),
    icon306: makeNodeComponent("icon306"),
    title314: makeNodeComponent("title314"),
    item307: makeNodeComponent("item307"),
    left307: makeNodeComponent("left307"),
    icon307: makeNodeComponent("icon307"),
    title315: makeNodeComponent("title315"),
    item308: makeNodeComponent("item308"),
    left308: makeNodeComponent("left308"),
    icon308: makeNodeComponent("icon308"),
    title316: makeNodeComponent("title316"),
    item309: makeNodeComponent("item309"),
    left309: makeNodeComponent("left309"),
    icon309: makeNodeComponent("icon309"),
    title317: makeNodeComponent("title317"),
    item310: makeNodeComponent("item310"),
    left310: makeNodeComponent("left310"),
    icon310: makeNodeComponent("icon310"),
    title318: makeNodeComponent("title318"),
    item311: makeNodeComponent("item311"),
    left311: makeNodeComponent("left311"),
    icon311: makeNodeComponent("icon311"),
    title319: makeNodeComponent("title319"),
    item312: makeNodeComponent("item312"),
    left312: makeNodeComponent("left312"),
    icon312: makeNodeComponent("icon312"),
    title320: makeNodeComponent("title320"),
    btn5: makeNodeComponent("btn5"),
    narrowCard6: makeNodeComponent("narrowCard6"),
    header22: makeNodeComponent("header22"),
    title321: makeNodeComponent("title321"),
    content6: makeNodeComponent("content6"),
    desc6: makeNodeComponent("desc6"),
    placeholder6: makeNodeComponent("placeholder6"),
    header23: makeNodeComponent("header23"),
    list21: makeNodeComponent("list21"),
    item313: makeNodeComponent("item313"),
    left313: makeNodeComponent("left313"),
    icon313: makeNodeComponent("icon313"),
    title322: makeNodeComponent("title322"),
    item314: makeNodeComponent("item314"),
    left314: makeNodeComponent("left314"),
    icon314: makeNodeComponent("icon314"),
    title323: makeNodeComponent("title323"),
    item315: makeNodeComponent("item315"),
    left315: makeNodeComponent("left315"),
    icon315: makeNodeComponent("icon315"),
    title324: makeNodeComponent("title324"),
    item316: makeNodeComponent("item316"),
    left316: makeNodeComponent("left316"),
    icon316: makeNodeComponent("icon316"),
    title325: makeNodeComponent("title325"),
    item317: makeNodeComponent("item317"),
    left317: makeNodeComponent("left317"),
    icon317: makeNodeComponent("icon317"),
    title326: makeNodeComponent("title326"),
    item318: makeNodeComponent("item318"),
    left318: makeNodeComponent("left318"),
    icon318: makeNodeComponent("icon318"),
    title327: makeNodeComponent("title327"),
    item319: makeNodeComponent("item319"),
    left319: makeNodeComponent("left319"),
    icon319: makeNodeComponent("icon319"),
    title328: makeNodeComponent("title328"),
    item320: makeNodeComponent("item320"),
    left320: makeNodeComponent("left320"),
    icon320: makeNodeComponent("icon320"),
    title329: makeNodeComponent("title329"),
    item321: makeNodeComponent("item321"),
    left321: makeNodeComponent("left321"),
    icon321: makeNodeComponent("icon321"),
    title330: makeNodeComponent("title330"),
    item322: makeNodeComponent("item322"),
    left322: makeNodeComponent("left322"),
    icon322: makeNodeComponent("icon322"),
    title331: makeNodeComponent("title331"),
    item323: makeNodeComponent("item323"),
    left323: makeNodeComponent("left323"),
    icon323: makeNodeComponent("icon323"),
    title332: makeNodeComponent("title332"),
    item324: makeNodeComponent("item324"),
    left324: makeNodeComponent("left324"),
    icon324: makeNodeComponent("icon324"),
    title333: makeNodeComponent("title333"),
    item325: makeNodeComponent("item325"),
    left325: makeNodeComponent("left325"),
    icon325: makeNodeComponent("icon325"),
    title334: makeNodeComponent("title334"),
    item326: makeNodeComponent("item326"),
    left326: makeNodeComponent("left326"),
    icon326: makeNodeComponent("icon326"),
    title335: makeNodeComponent("title335"),
    item327: makeNodeComponent("item327"),
    left327: makeNodeComponent("left327"),
    icon327: makeNodeComponent("icon327"),
    title336: makeNodeComponent("title336"),
    item328: makeNodeComponent("item328"),
    left328: makeNodeComponent("left328"),
    icon328: makeNodeComponent("icon328"),
    title337: makeNodeComponent("title337"),
    item329: makeNodeComponent("item329"),
    left329: makeNodeComponent("left329"),
    icon329: makeNodeComponent("icon329"),
    title338: makeNodeComponent("title338"),
    item330: makeNodeComponent("item330"),
    left330: makeNodeComponent("left330"),
    icon330: makeNodeComponent("icon330"),
    title339: makeNodeComponent("title339"),
    item331: makeNodeComponent("item331"),
    left331: makeNodeComponent("left331"),
    icon331: makeNodeComponent("icon331"),
    title340: makeNodeComponent("title340"),
    item332: makeNodeComponent("item332"),
    left332: makeNodeComponent("left332"),
    icon332: makeNodeComponent("icon332"),
    title341: makeNodeComponent("title341"),
    item333: makeNodeComponent("item333"),
    left333: makeNodeComponent("left333"),
    icon333: makeNodeComponent("icon333"),
    title342: makeNodeComponent("title342"),
    item334: makeNodeComponent("item334"),
    left334: makeNodeComponent("left334"),
    icon334: makeNodeComponent("icon334"),
    title343: makeNodeComponent("title343"),
    item335: makeNodeComponent("item335"),
    left335: makeNodeComponent("left335"),
    icon335: makeNodeComponent("icon335"),
    title344: makeNodeComponent("title344"),
    item336: makeNodeComponent("item336"),
    left336: makeNodeComponent("left336"),
    icon336: makeNodeComponent("icon336"),
    title345: makeNodeComponent("title345"),
    btn6: makeNodeComponent("btn6"),
    row4: makeNodeComponent("row4"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    narrowCard7: makeNodeComponent("narrowCard7"),
    header24: makeNodeComponent("header24"),
    title346: makeNodeComponent("title346"),
    content7: makeNodeComponent("content7"),
    desc7: makeNodeComponent("desc7"),
    placeholder7: makeNodeComponent("placeholder7"),
    header25: makeNodeComponent("header25"),
    list22: makeNodeComponent("list22"),
    item337: makeNodeComponent("item337"),
    left337: makeNodeComponent("left337"),
    icon337: makeNodeComponent("icon337"),
    title347: makeNodeComponent("title347"),
    item338: makeNodeComponent("item338"),
    left338: makeNodeComponent("left338"),
    icon338: makeNodeComponent("icon338"),
    title348: makeNodeComponent("title348"),
    item339: makeNodeComponent("item339"),
    left339: makeNodeComponent("left339"),
    icon339: makeNodeComponent("icon339"),
    title349: makeNodeComponent("title349"),
    item340: makeNodeComponent("item340"),
    left340: makeNodeComponent("left340"),
    icon340: makeNodeComponent("icon340"),
    title350: makeNodeComponent("title350"),
    item341: makeNodeComponent("item341"),
    left341: makeNodeComponent("left341"),
    icon341: makeNodeComponent("icon341"),
    title351: makeNodeComponent("title351"),
    item342: makeNodeComponent("item342"),
    left342: makeNodeComponent("left342"),
    icon342: makeNodeComponent("icon342"),
    title352: makeNodeComponent("title352"),
    item343: makeNodeComponent("item343"),
    left343: makeNodeComponent("left343"),
    icon343: makeNodeComponent("icon343"),
    title353: makeNodeComponent("title353"),
    item344: makeNodeComponent("item344"),
    left344: makeNodeComponent("left344"),
    icon344: makeNodeComponent("icon344"),
    title354: makeNodeComponent("title354"),
    item345: makeNodeComponent("item345"),
    left345: makeNodeComponent("left345"),
    icon345: makeNodeComponent("icon345"),
    title355: makeNodeComponent("title355"),
    item346: makeNodeComponent("item346"),
    left346: makeNodeComponent("left346"),
    icon346: makeNodeComponent("icon346"),
    title356: makeNodeComponent("title356"),
    item347: makeNodeComponent("item347"),
    left347: makeNodeComponent("left347"),
    icon347: makeNodeComponent("icon347"),
    title357: makeNodeComponent("title357"),
    item348: makeNodeComponent("item348"),
    left348: makeNodeComponent("left348"),
    icon348: makeNodeComponent("icon348"),
    title358: makeNodeComponent("title358"),
    item349: makeNodeComponent("item349"),
    left349: makeNodeComponent("left349"),
    icon349: makeNodeComponent("icon349"),
    title359: makeNodeComponent("title359"),
    item350: makeNodeComponent("item350"),
    left350: makeNodeComponent("left350"),
    icon350: makeNodeComponent("icon350"),
    title360: makeNodeComponent("title360"),
    item351: makeNodeComponent("item351"),
    left351: makeNodeComponent("left351"),
    icon351: makeNodeComponent("icon351"),
    title361: makeNodeComponent("title361"),
    item352: makeNodeComponent("item352"),
    left352: makeNodeComponent("left352"),
    icon352: makeNodeComponent("icon352"),
    title362: makeNodeComponent("title362"),
    item353: makeNodeComponent("item353"),
    left353: makeNodeComponent("left353"),
    icon353: makeNodeComponent("icon353"),
    title363: makeNodeComponent("title363"),
    item354: makeNodeComponent("item354"),
    left354: makeNodeComponent("left354"),
    icon354: makeNodeComponent("icon354"),
    title364: makeNodeComponent("title364"),
    item355: makeNodeComponent("item355"),
    left355: makeNodeComponent("left355"),
    icon355: makeNodeComponent("icon355"),
    title365: makeNodeComponent("title365"),
    item356: makeNodeComponent("item356"),
    left356: makeNodeComponent("left356"),
    icon356: makeNodeComponent("icon356"),
    title366: makeNodeComponent("title366"),
    item357: makeNodeComponent("item357"),
    left357: makeNodeComponent("left357"),
    icon357: makeNodeComponent("icon357"),
    title367: makeNodeComponent("title367"),
    item358: makeNodeComponent("item358"),
    left358: makeNodeComponent("left358"),
    icon358: makeNodeComponent("icon358"),
    title368: makeNodeComponent("title368"),
    item359: makeNodeComponent("item359"),
    left359: makeNodeComponent("left359"),
    icon359: makeNodeComponent("icon359"),
    title369: makeNodeComponent("title369"),
    item360: makeNodeComponent("item360"),
    left360: makeNodeComponent("left360"),
    icon360: makeNodeComponent("icon360"),
    title370: makeNodeComponent("title370"),
    btn7: makeNodeComponent("btn7"),
    narrowCard8: makeNodeComponent("narrowCard8"),
    header26: makeNodeComponent("header26"),
    title371: makeNodeComponent("title371"),
    content8: makeNodeComponent("content8"),
    desc8: makeNodeComponent("desc8"),
    placeholder8: makeNodeComponent("placeholder8"),
    header27: makeNodeComponent("header27"),
    list23: makeNodeComponent("list23"),
    item361: makeNodeComponent("item361"),
    left361: makeNodeComponent("left361"),
    icon361: makeNodeComponent("icon361"),
    title372: makeNodeComponent("title372"),
    item362: makeNodeComponent("item362"),
    left362: makeNodeComponent("left362"),
    icon362: makeNodeComponent("icon362"),
    title373: makeNodeComponent("title373"),
    item363: makeNodeComponent("item363"),
    left363: makeNodeComponent("left363"),
    icon363: makeNodeComponent("icon363"),
    title374: makeNodeComponent("title374"),
    item364: makeNodeComponent("item364"),
    left364: makeNodeComponent("left364"),
    icon364: makeNodeComponent("icon364"),
    title375: makeNodeComponent("title375"),
    item365: makeNodeComponent("item365"),
    left365: makeNodeComponent("left365"),
    icon365: makeNodeComponent("icon365"),
    title376: makeNodeComponent("title376"),
    item366: makeNodeComponent("item366"),
    left366: makeNodeComponent("left366"),
    icon366: makeNodeComponent("icon366"),
    title377: makeNodeComponent("title377"),
    item367: makeNodeComponent("item367"),
    left367: makeNodeComponent("left367"),
    icon367: makeNodeComponent("icon367"),
    title378: makeNodeComponent("title378"),
    item368: makeNodeComponent("item368"),
    left368: makeNodeComponent("left368"),
    icon368: makeNodeComponent("icon368"),
    title379: makeNodeComponent("title379"),
    item369: makeNodeComponent("item369"),
    left369: makeNodeComponent("left369"),
    icon369: makeNodeComponent("icon369"),
    title380: makeNodeComponent("title380"),
    item370: makeNodeComponent("item370"),
    left370: makeNodeComponent("left370"),
    icon370: makeNodeComponent("icon370"),
    title381: makeNodeComponent("title381"),
    item371: makeNodeComponent("item371"),
    left371: makeNodeComponent("left371"),
    icon371: makeNodeComponent("icon371"),
    title382: makeNodeComponent("title382"),
    item372: makeNodeComponent("item372"),
    left372: makeNodeComponent("left372"),
    icon372: makeNodeComponent("icon372"),
    title383: makeNodeComponent("title383"),
    item373: makeNodeComponent("item373"),
    left373: makeNodeComponent("left373"),
    icon373: makeNodeComponent("icon373"),
    title384: makeNodeComponent("title384"),
    item374: makeNodeComponent("item374"),
    left374: makeNodeComponent("left374"),
    icon374: makeNodeComponent("icon374"),
    title385: makeNodeComponent("title385"),
    item375: makeNodeComponent("item375"),
    left375: makeNodeComponent("left375"),
    icon375: makeNodeComponent("icon375"),
    title386: makeNodeComponent("title386"),
    item376: makeNodeComponent("item376"),
    left376: makeNodeComponent("left376"),
    icon376: makeNodeComponent("icon376"),
    title387: makeNodeComponent("title387"),
    item377: makeNodeComponent("item377"),
    left377: makeNodeComponent("left377"),
    icon377: makeNodeComponent("icon377"),
    title388: makeNodeComponent("title388"),
    item378: makeNodeComponent("item378"),
    left378: makeNodeComponent("left378"),
    icon378: makeNodeComponent("icon378"),
    title389: makeNodeComponent("title389"),
    item379: makeNodeComponent("item379"),
    left379: makeNodeComponent("left379"),
    icon379: makeNodeComponent("icon379"),
    title390: makeNodeComponent("title390"),
    item380: makeNodeComponent("item380"),
    left380: makeNodeComponent("left380"),
    icon380: makeNodeComponent("icon380"),
    title391: makeNodeComponent("title391"),
    item381: makeNodeComponent("item381"),
    left381: makeNodeComponent("left381"),
    icon381: makeNodeComponent("icon381"),
    title392: makeNodeComponent("title392"),
    item382: makeNodeComponent("item382"),
    left382: makeNodeComponent("left382"),
    icon382: makeNodeComponent("icon382"),
    title393: makeNodeComponent("title393"),
    item383: makeNodeComponent("item383"),
    left383: makeNodeComponent("left383"),
    icon383: makeNodeComponent("icon383"),
    title394: makeNodeComponent("title394"),
    item384: makeNodeComponent("item384"),
    left384: makeNodeComponent("left384"),
    icon384: makeNodeComponent("icon384"),
    title395: makeNodeComponent("title395"),
    btn8: makeNodeComponent("btn8"),
    tablet: makeNodeComponent("tablet"),
    row6: makeNodeComponent("row6"),
    featuresProductHeader: makeNodeComponent("featuresProductHeader"),
    key4: makeNodeComponent("key4"),
    header4: makeNodeComponent("header4"),
    list11: makeNodeComponent("list11"),
    row7: makeNodeComponent("row7"),
    figmaPaste5: makeNodeComponent("figmaPaste5"),
    narrowCard17: makeNodeComponent("narrowCard17"),
    header9: makeNodeComponent("header9"),
    title100: makeNodeComponent("title100"),
    content17: makeNodeComponent("content17"),
    desc17: makeNodeComponent("desc17"),
    placeholder17: makeNodeComponent("placeholder17"),
    header10: makeNodeComponent("header10"),
    list7: makeNodeComponent("list7"),
    item97: makeNodeComponent("item97"),
    left97: makeNodeComponent("left97"),
    icon97: makeNodeComponent("icon97"),
    title2: makeNodeComponent("title2"),
    item98: makeNodeComponent("item98"),
    left98: makeNodeComponent("left98"),
    icon98: makeNodeComponent("icon98"),
    title101: makeNodeComponent("title101"),
    item99: makeNodeComponent("item99"),
    left99: makeNodeComponent("left99"),
    icon99: makeNodeComponent("icon99"),
    title102: makeNodeComponent("title102"),
    item100: makeNodeComponent("item100"),
    left100: makeNodeComponent("left100"),
    icon100: makeNodeComponent("icon100"),
    title103: makeNodeComponent("title103"),
    item101: makeNodeComponent("item101"),
    left101: makeNodeComponent("left101"),
    icon101: makeNodeComponent("icon101"),
    title104: makeNodeComponent("title104"),
    item102: makeNodeComponent("item102"),
    left102: makeNodeComponent("left102"),
    icon102: makeNodeComponent("icon102"),
    title105: makeNodeComponent("title105"),
    item103: makeNodeComponent("item103"),
    left103: makeNodeComponent("left103"),
    icon103: makeNodeComponent("icon103"),
    title106: makeNodeComponent("title106"),
    item104: makeNodeComponent("item104"),
    left104: makeNodeComponent("left104"),
    icon104: makeNodeComponent("icon104"),
    title107: makeNodeComponent("title107"),
    item105: makeNodeComponent("item105"),
    left105: makeNodeComponent("left105"),
    icon105: makeNodeComponent("icon105"),
    title108: makeNodeComponent("title108"),
    item106: makeNodeComponent("item106"),
    left106: makeNodeComponent("left106"),
    icon106: makeNodeComponent("icon106"),
    title109: makeNodeComponent("title109"),
    item107: makeNodeComponent("item107"),
    left107: makeNodeComponent("left107"),
    icon107: makeNodeComponent("icon107"),
    title110: makeNodeComponent("title110"),
    item108: makeNodeComponent("item108"),
    left108: makeNodeComponent("left108"),
    icon108: makeNodeComponent("icon108"),
    title111: makeNodeComponent("title111"),
    item109: makeNodeComponent("item109"),
    left109: makeNodeComponent("left109"),
    icon109: makeNodeComponent("icon109"),
    title112: makeNodeComponent("title112"),
    item110: makeNodeComponent("item110"),
    left110: makeNodeComponent("left110"),
    icon110: makeNodeComponent("icon110"),
    title113: makeNodeComponent("title113"),
    item111: makeNodeComponent("item111"),
    left111: makeNodeComponent("left111"),
    icon111: makeNodeComponent("icon111"),
    title114: makeNodeComponent("title114"),
    item112: makeNodeComponent("item112"),
    left112: makeNodeComponent("left112"),
    icon112: makeNodeComponent("icon112"),
    title115: makeNodeComponent("title115"),
    item113: makeNodeComponent("item113"),
    left113: makeNodeComponent("left113"),
    icon113: makeNodeComponent("icon113"),
    title116: makeNodeComponent("title116"),
    item114: makeNodeComponent("item114"),
    left114: makeNodeComponent("left114"),
    icon114: makeNodeComponent("icon114"),
    title117: makeNodeComponent("title117"),
    item115: makeNodeComponent("item115"),
    left115: makeNodeComponent("left115"),
    icon115: makeNodeComponent("icon115"),
    title118: makeNodeComponent("title118"),
    item116: makeNodeComponent("item116"),
    left116: makeNodeComponent("left116"),
    icon116: makeNodeComponent("icon116"),
    title119: makeNodeComponent("title119"),
    item117: makeNodeComponent("item117"),
    left117: makeNodeComponent("left117"),
    icon117: makeNodeComponent("icon117"),
    title120: makeNodeComponent("title120"),
    item118: makeNodeComponent("item118"),
    left118: makeNodeComponent("left118"),
    icon118: makeNodeComponent("icon118"),
    title121: makeNodeComponent("title121"),
    item119: makeNodeComponent("item119"),
    left119: makeNodeComponent("left119"),
    icon119: makeNodeComponent("icon119"),
    title122: makeNodeComponent("title122"),
    item120: makeNodeComponent("item120"),
    left120: makeNodeComponent("left120"),
    icon120: makeNodeComponent("icon120"),
    title123: makeNodeComponent("title123"),
    btn17: makeNodeComponent("btn17"),
    narrowCard18: makeNodeComponent("narrowCard18"),
    header11: makeNodeComponent("header11"),
    title124: makeNodeComponent("title124"),
    content18: makeNodeComponent("content18"),
    desc18: makeNodeComponent("desc18"),
    placeholder18: makeNodeComponent("placeholder18"),
    header12: makeNodeComponent("header12"),
    list8: makeNodeComponent("list8"),
    item121: makeNodeComponent("item121"),
    left121: makeNodeComponent("left121"),
    icon121: makeNodeComponent("icon121"),
    title125: makeNodeComponent("title125"),
    item122: makeNodeComponent("item122"),
    left122: makeNodeComponent("left122"),
    icon122: makeNodeComponent("icon122"),
    title126: makeNodeComponent("title126"),
    item123: makeNodeComponent("item123"),
    left123: makeNodeComponent("left123"),
    icon123: makeNodeComponent("icon123"),
    title127: makeNodeComponent("title127"),
    item124: makeNodeComponent("item124"),
    left124: makeNodeComponent("left124"),
    icon124: makeNodeComponent("icon124"),
    title128: makeNodeComponent("title128"),
    item125: makeNodeComponent("item125"),
    left125: makeNodeComponent("left125"),
    icon125: makeNodeComponent("icon125"),
    title129: makeNodeComponent("title129"),
    item126: makeNodeComponent("item126"),
    left126: makeNodeComponent("left126"),
    icon126: makeNodeComponent("icon126"),
    title130: makeNodeComponent("title130"),
    item127: makeNodeComponent("item127"),
    left127: makeNodeComponent("left127"),
    icon127: makeNodeComponent("icon127"),
    title131: makeNodeComponent("title131"),
    item128: makeNodeComponent("item128"),
    left128: makeNodeComponent("left128"),
    icon128: makeNodeComponent("icon128"),
    title132: makeNodeComponent("title132"),
    item129: makeNodeComponent("item129"),
    left129: makeNodeComponent("left129"),
    icon129: makeNodeComponent("icon129"),
    title133: makeNodeComponent("title133"),
    item130: makeNodeComponent("item130"),
    left130: makeNodeComponent("left130"),
    icon130: makeNodeComponent("icon130"),
    title134: makeNodeComponent("title134"),
    item131: makeNodeComponent("item131"),
    left131: makeNodeComponent("left131"),
    icon131: makeNodeComponent("icon131"),
    title135: makeNodeComponent("title135"),
    item132: makeNodeComponent("item132"),
    left132: makeNodeComponent("left132"),
    icon132: makeNodeComponent("icon132"),
    title136: makeNodeComponent("title136"),
    item133: makeNodeComponent("item133"),
    left133: makeNodeComponent("left133"),
    icon133: makeNodeComponent("icon133"),
    title137: makeNodeComponent("title137"),
    item134: makeNodeComponent("item134"),
    left134: makeNodeComponent("left134"),
    icon134: makeNodeComponent("icon134"),
    title138: makeNodeComponent("title138"),
    item135: makeNodeComponent("item135"),
    left135: makeNodeComponent("left135"),
    icon135: makeNodeComponent("icon135"),
    title139: makeNodeComponent("title139"),
    item136: makeNodeComponent("item136"),
    left136: makeNodeComponent("left136"),
    icon136: makeNodeComponent("icon136"),
    title140: makeNodeComponent("title140"),
    item137: makeNodeComponent("item137"),
    left137: makeNodeComponent("left137"),
    icon137: makeNodeComponent("icon137"),
    title141: makeNodeComponent("title141"),
    item138: makeNodeComponent("item138"),
    left138: makeNodeComponent("left138"),
    icon138: makeNodeComponent("icon138"),
    title142: makeNodeComponent("title142"),
    item139: makeNodeComponent("item139"),
    left139: makeNodeComponent("left139"),
    icon139: makeNodeComponent("icon139"),
    title143: makeNodeComponent("title143"),
    item140: makeNodeComponent("item140"),
    left140: makeNodeComponent("left140"),
    icon140: makeNodeComponent("icon140"),
    title144: makeNodeComponent("title144"),
    item141: makeNodeComponent("item141"),
    left141: makeNodeComponent("left141"),
    icon141: makeNodeComponent("icon141"),
    title145: makeNodeComponent("title145"),
    item142: makeNodeComponent("item142"),
    left142: makeNodeComponent("left142"),
    icon142: makeNodeComponent("icon142"),
    title146: makeNodeComponent("title146"),
    item143: makeNodeComponent("item143"),
    left143: makeNodeComponent("left143"),
    icon143: makeNodeComponent("icon143"),
    title147: makeNodeComponent("title147"),
    item144: makeNodeComponent("item144"),
    left144: makeNodeComponent("left144"),
    icon144: makeNodeComponent("icon144"),
    title148: makeNodeComponent("title148"),
    btn18: makeNodeComponent("btn18"),
    row8: makeNodeComponent("row8"),
    figmaPaste6: makeNodeComponent("figmaPaste6"),
    narrowCard19: makeNodeComponent("narrowCard19"),
    header40: makeNodeComponent("header40"),
    title149: makeNodeComponent("title149"),
    content19: makeNodeComponent("content19"),
    desc19: makeNodeComponent("desc19"),
    placeholder19: makeNodeComponent("placeholder19"),
    header41: makeNodeComponent("header41"),
    list9: makeNodeComponent("list9"),
    item145: makeNodeComponent("item145"),
    left145: makeNodeComponent("left145"),
    icon145: makeNodeComponent("icon145"),
    title150: makeNodeComponent("title150"),
    item146: makeNodeComponent("item146"),
    left146: makeNodeComponent("left146"),
    icon146: makeNodeComponent("icon146"),
    title151: makeNodeComponent("title151"),
    item147: makeNodeComponent("item147"),
    left147: makeNodeComponent("left147"),
    icon147: makeNodeComponent("icon147"),
    title152: makeNodeComponent("title152"),
    item148: makeNodeComponent("item148"),
    left148: makeNodeComponent("left148"),
    icon148: makeNodeComponent("icon148"),
    title153: makeNodeComponent("title153"),
    item149: makeNodeComponent("item149"),
    left149: makeNodeComponent("left149"),
    icon149: makeNodeComponent("icon149"),
    title154: makeNodeComponent("title154"),
    item150: makeNodeComponent("item150"),
    left150: makeNodeComponent("left150"),
    icon150: makeNodeComponent("icon150"),
    title155: makeNodeComponent("title155"),
    item151: makeNodeComponent("item151"),
    left151: makeNodeComponent("left151"),
    icon151: makeNodeComponent("icon151"),
    title156: makeNodeComponent("title156"),
    item152: makeNodeComponent("item152"),
    left152: makeNodeComponent("left152"),
    icon152: makeNodeComponent("icon152"),
    title157: makeNodeComponent("title157"),
    item153: makeNodeComponent("item153"),
    left153: makeNodeComponent("left153"),
    icon153: makeNodeComponent("icon153"),
    title158: makeNodeComponent("title158"),
    item154: makeNodeComponent("item154"),
    left154: makeNodeComponent("left154"),
    icon154: makeNodeComponent("icon154"),
    title159: makeNodeComponent("title159"),
    item155: makeNodeComponent("item155"),
    left155: makeNodeComponent("left155"),
    icon155: makeNodeComponent("icon155"),
    title160: makeNodeComponent("title160"),
    item156: makeNodeComponent("item156"),
    left156: makeNodeComponent("left156"),
    icon156: makeNodeComponent("icon156"),
    title161: makeNodeComponent("title161"),
    item157: makeNodeComponent("item157"),
    left157: makeNodeComponent("left157"),
    icon157: makeNodeComponent("icon157"),
    title162: makeNodeComponent("title162"),
    item158: makeNodeComponent("item158"),
    left158: makeNodeComponent("left158"),
    icon158: makeNodeComponent("icon158"),
    title163: makeNodeComponent("title163"),
    item159: makeNodeComponent("item159"),
    left159: makeNodeComponent("left159"),
    icon159: makeNodeComponent("icon159"),
    title164: makeNodeComponent("title164"),
    item160: makeNodeComponent("item160"),
    left160: makeNodeComponent("left160"),
    icon160: makeNodeComponent("icon160"),
    title165: makeNodeComponent("title165"),
    item161: makeNodeComponent("item161"),
    left161: makeNodeComponent("left161"),
    icon161: makeNodeComponent("icon161"),
    title166: makeNodeComponent("title166"),
    item162: makeNodeComponent("item162"),
    left162: makeNodeComponent("left162"),
    icon162: makeNodeComponent("icon162"),
    title167: makeNodeComponent("title167"),
    item163: makeNodeComponent("item163"),
    left163: makeNodeComponent("left163"),
    icon163: makeNodeComponent("icon163"),
    title168: makeNodeComponent("title168"),
    item164: makeNodeComponent("item164"),
    left164: makeNodeComponent("left164"),
    icon164: makeNodeComponent("icon164"),
    title169: makeNodeComponent("title169"),
    item165: makeNodeComponent("item165"),
    left165: makeNodeComponent("left165"),
    icon165: makeNodeComponent("icon165"),
    title170: makeNodeComponent("title170"),
    item166: makeNodeComponent("item166"),
    left166: makeNodeComponent("left166"),
    icon166: makeNodeComponent("icon166"),
    title171: makeNodeComponent("title171"),
    item167: makeNodeComponent("item167"),
    left167: makeNodeComponent("left167"),
    icon167: makeNodeComponent("icon167"),
    title172: makeNodeComponent("title172"),
    item168: makeNodeComponent("item168"),
    left168: makeNodeComponent("left168"),
    icon168: makeNodeComponent("icon168"),
    title173: makeNodeComponent("title173"),
    btn19: makeNodeComponent("btn19"),
    narrowCard20: makeNodeComponent("narrowCard20"),
    header42: makeNodeComponent("header42"),
    title174: makeNodeComponent("title174"),
    content20: makeNodeComponent("content20"),
    desc20: makeNodeComponent("desc20"),
    placeholder20: makeNodeComponent("placeholder20"),
    header43: makeNodeComponent("header43"),
    list10: makeNodeComponent("list10"),
    item169: makeNodeComponent("item169"),
    left169: makeNodeComponent("left169"),
    icon169: makeNodeComponent("icon169"),
    title175: makeNodeComponent("title175"),
    item170: makeNodeComponent("item170"),
    left170: makeNodeComponent("left170"),
    icon170: makeNodeComponent("icon170"),
    title176: makeNodeComponent("title176"),
    item171: makeNodeComponent("item171"),
    left171: makeNodeComponent("left171"),
    icon171: makeNodeComponent("icon171"),
    title177: makeNodeComponent("title177"),
    item172: makeNodeComponent("item172"),
    left172: makeNodeComponent("left172"),
    icon172: makeNodeComponent("icon172"),
    title178: makeNodeComponent("title178"),
    item173: makeNodeComponent("item173"),
    left173: makeNodeComponent("left173"),
    icon173: makeNodeComponent("icon173"),
    title179: makeNodeComponent("title179"),
    item174: makeNodeComponent("item174"),
    left174: makeNodeComponent("left174"),
    icon174: makeNodeComponent("icon174"),
    title180: makeNodeComponent("title180"),
    item175: makeNodeComponent("item175"),
    left175: makeNodeComponent("left175"),
    icon175: makeNodeComponent("icon175"),
    title181: makeNodeComponent("title181"),
    item176: makeNodeComponent("item176"),
    left176: makeNodeComponent("left176"),
    icon176: makeNodeComponent("icon176"),
    title182: makeNodeComponent("title182"),
    item177: makeNodeComponent("item177"),
    left177: makeNodeComponent("left177"),
    icon177: makeNodeComponent("icon177"),
    title183: makeNodeComponent("title183"),
    item178: makeNodeComponent("item178"),
    left178: makeNodeComponent("left178"),
    icon178: makeNodeComponent("icon178"),
    title184: makeNodeComponent("title184"),
    item179: makeNodeComponent("item179"),
    left179: makeNodeComponent("left179"),
    icon179: makeNodeComponent("icon179"),
    title185: makeNodeComponent("title185"),
    item180: makeNodeComponent("item180"),
    left180: makeNodeComponent("left180"),
    icon180: makeNodeComponent("icon180"),
    title186: makeNodeComponent("title186"),
    item181: makeNodeComponent("item181"),
    left181: makeNodeComponent("left181"),
    icon181: makeNodeComponent("icon181"),
    title187: makeNodeComponent("title187"),
    item182: makeNodeComponent("item182"),
    left182: makeNodeComponent("left182"),
    icon182: makeNodeComponent("icon182"),
    title188: makeNodeComponent("title188"),
    item183: makeNodeComponent("item183"),
    left183: makeNodeComponent("left183"),
    icon183: makeNodeComponent("icon183"),
    title189: makeNodeComponent("title189"),
    item184: makeNodeComponent("item184"),
    left184: makeNodeComponent("left184"),
    icon184: makeNodeComponent("icon184"),
    title190: makeNodeComponent("title190"),
    item185: makeNodeComponent("item185"),
    left185: makeNodeComponent("left185"),
    icon185: makeNodeComponent("icon185"),
    title191: makeNodeComponent("title191"),
    item186: makeNodeComponent("item186"),
    left186: makeNodeComponent("left186"),
    icon186: makeNodeComponent("icon186"),
    title192: makeNodeComponent("title192"),
    item187: makeNodeComponent("item187"),
    left187: makeNodeComponent("left187"),
    icon187: makeNodeComponent("icon187"),
    title193: makeNodeComponent("title193"),
    item188: makeNodeComponent("item188"),
    left188: makeNodeComponent("left188"),
    icon188: makeNodeComponent("icon188"),
    title194: makeNodeComponent("title194"),
    item189: makeNodeComponent("item189"),
    left189: makeNodeComponent("left189"),
    icon189: makeNodeComponent("icon189"),
    title195: makeNodeComponent("title195"),
    item190: makeNodeComponent("item190"),
    left190: makeNodeComponent("left190"),
    icon190: makeNodeComponent("icon190"),
    title499: makeNodeComponent("title499"),
    item191: makeNodeComponent("item191"),
    left191: makeNodeComponent("left191"),
    icon191: makeNodeComponent("icon191"),
    title500: makeNodeComponent("title500"),
    item192: makeNodeComponent("item192"),
    left192: makeNodeComponent("left192"),
    icon192: makeNodeComponent("icon192"),
    title501: makeNodeComponent("title501"),
    btn20: makeNodeComponent("btn20"),
    narrowCard21: makeNodeComponent("narrowCard21"),
    header44: makeNodeComponent("header44"),
    title502: makeNodeComponent("title502"),
    content21: makeNodeComponent("content21"),
    desc21: makeNodeComponent("desc21"),
    placeholder21: makeNodeComponent("placeholder21"),
    header45: makeNodeComponent("header45"),
    list28: makeNodeComponent("list28"),
    item481: makeNodeComponent("item481"),
    left481: makeNodeComponent("left481"),
    icon481: makeNodeComponent("icon481"),
    title503: makeNodeComponent("title503"),
    item482: makeNodeComponent("item482"),
    left482: makeNodeComponent("left482"),
    icon482: makeNodeComponent("icon482"),
    title504: makeNodeComponent("title504"),
    item483: makeNodeComponent("item483"),
    left483: makeNodeComponent("left483"),
    icon483: makeNodeComponent("icon483"),
    title505: makeNodeComponent("title505"),
    item484: makeNodeComponent("item484"),
    left484: makeNodeComponent("left484"),
    icon484: makeNodeComponent("icon484"),
    title506: makeNodeComponent("title506"),
    item485: makeNodeComponent("item485"),
    left485: makeNodeComponent("left485"),
    icon485: makeNodeComponent("icon485"),
    title507: makeNodeComponent("title507"),
    item486: makeNodeComponent("item486"),
    left486: makeNodeComponent("left486"),
    icon486: makeNodeComponent("icon486"),
    title508: makeNodeComponent("title508"),
    item487: makeNodeComponent("item487"),
    left487: makeNodeComponent("left487"),
    icon487: makeNodeComponent("icon487"),
    title509: makeNodeComponent("title509"),
    item488: makeNodeComponent("item488"),
    left488: makeNodeComponent("left488"),
    icon488: makeNodeComponent("icon488"),
    title510: makeNodeComponent("title510"),
    item489: makeNodeComponent("item489"),
    left489: makeNodeComponent("left489"),
    icon489: makeNodeComponent("icon489"),
    title511: makeNodeComponent("title511"),
    item490: makeNodeComponent("item490"),
    left490: makeNodeComponent("left490"),
    icon490: makeNodeComponent("icon490"),
    title512: makeNodeComponent("title512"),
    item491: makeNodeComponent("item491"),
    left491: makeNodeComponent("left491"),
    icon491: makeNodeComponent("icon491"),
    title513: makeNodeComponent("title513"),
    item492: makeNodeComponent("item492"),
    left492: makeNodeComponent("left492"),
    icon492: makeNodeComponent("icon492"),
    title514: makeNodeComponent("title514"),
    item493: makeNodeComponent("item493"),
    left493: makeNodeComponent("left493"),
    icon493: makeNodeComponent("icon493"),
    title515: makeNodeComponent("title515"),
    item494: makeNodeComponent("item494"),
    left494: makeNodeComponent("left494"),
    icon494: makeNodeComponent("icon494"),
    title516: makeNodeComponent("title516"),
    item495: makeNodeComponent("item495"),
    left495: makeNodeComponent("left495"),
    icon495: makeNodeComponent("icon495"),
    title517: makeNodeComponent("title517"),
    item496: makeNodeComponent("item496"),
    left496: makeNodeComponent("left496"),
    icon496: makeNodeComponent("icon496"),
    title518: makeNodeComponent("title518"),
    item497: makeNodeComponent("item497"),
    left497: makeNodeComponent("left497"),
    icon497: makeNodeComponent("icon497"),
    title519: makeNodeComponent("title519"),
    item498: makeNodeComponent("item498"),
    left498: makeNodeComponent("left498"),
    icon498: makeNodeComponent("icon498"),
    title520: makeNodeComponent("title520"),
    item499: makeNodeComponent("item499"),
    left499: makeNodeComponent("left499"),
    icon499: makeNodeComponent("icon499"),
    title521: makeNodeComponent("title521"),
    item500: makeNodeComponent("item500"),
    left500: makeNodeComponent("left500"),
    icon500: makeNodeComponent("icon500"),
    title522: makeNodeComponent("title522"),
    item501: makeNodeComponent("item501"),
    left501: makeNodeComponent("left501"),
    icon501: makeNodeComponent("icon501"),
    title523: makeNodeComponent("title523"),
    item502: makeNodeComponent("item502"),
    left502: makeNodeComponent("left502"),
    icon502: makeNodeComponent("icon502"),
    title524: makeNodeComponent("title524"),
    item503: makeNodeComponent("item503"),
    left503: makeNodeComponent("left503"),
    icon503: makeNodeComponent("icon503"),
    title525: makeNodeComponent("title525"),
    item504: makeNodeComponent("item504"),
    left504: makeNodeComponent("left504"),
    icon504: makeNodeComponent("icon504"),
    title526: makeNodeComponent("title526"),
    btn21: makeNodeComponent("btn21"),
    narrowCard22: makeNodeComponent("narrowCard22"),
    header46: makeNodeComponent("header46"),
    title527: makeNodeComponent("title527"),
    content22: makeNodeComponent("content22"),
    desc22: makeNodeComponent("desc22"),
    placeholder22: makeNodeComponent("placeholder22"),
    header47: makeNodeComponent("header47"),
    list29: makeNodeComponent("list29"),
    item505: makeNodeComponent("item505"),
    left505: makeNodeComponent("left505"),
    icon505: makeNodeComponent("icon505"),
    title528: makeNodeComponent("title528"),
    item506: makeNodeComponent("item506"),
    left506: makeNodeComponent("left506"),
    icon506: makeNodeComponent("icon506"),
    title529: makeNodeComponent("title529"),
    item507: makeNodeComponent("item507"),
    left507: makeNodeComponent("left507"),
    icon507: makeNodeComponent("icon507"),
    title530: makeNodeComponent("title530"),
    item508: makeNodeComponent("item508"),
    left508: makeNodeComponent("left508"),
    icon508: makeNodeComponent("icon508"),
    title531: makeNodeComponent("title531"),
    item509: makeNodeComponent("item509"),
    left509: makeNodeComponent("left509"),
    icon509: makeNodeComponent("icon509"),
    title532: makeNodeComponent("title532"),
    item510: makeNodeComponent("item510"),
    left510: makeNodeComponent("left510"),
    icon510: makeNodeComponent("icon510"),
    title533: makeNodeComponent("title533"),
    item511: makeNodeComponent("item511"),
    left511: makeNodeComponent("left511"),
    icon511: makeNodeComponent("icon511"),
    title534: makeNodeComponent("title534"),
    item512: makeNodeComponent("item512"),
    left512: makeNodeComponent("left512"),
    icon512: makeNodeComponent("icon512"),
    title535: makeNodeComponent("title535"),
    item513: makeNodeComponent("item513"),
    left513: makeNodeComponent("left513"),
    icon513: makeNodeComponent("icon513"),
    title536: makeNodeComponent("title536"),
    item514: makeNodeComponent("item514"),
    left514: makeNodeComponent("left514"),
    icon514: makeNodeComponent("icon514"),
    title537: makeNodeComponent("title537"),
    item515: makeNodeComponent("item515"),
    left515: makeNodeComponent("left515"),
    icon515: makeNodeComponent("icon515"),
    title538: makeNodeComponent("title538"),
    item516: makeNodeComponent("item516"),
    left516: makeNodeComponent("left516"),
    icon516: makeNodeComponent("icon516"),
    title539: makeNodeComponent("title539"),
    item517: makeNodeComponent("item517"),
    left517: makeNodeComponent("left517"),
    icon517: makeNodeComponent("icon517"),
    title540: makeNodeComponent("title540"),
    item518: makeNodeComponent("item518"),
    left518: makeNodeComponent("left518"),
    icon518: makeNodeComponent("icon518"),
    title541: makeNodeComponent("title541"),
    item519: makeNodeComponent("item519"),
    left519: makeNodeComponent("left519"),
    icon519: makeNodeComponent("icon519"),
    title542: makeNodeComponent("title542"),
    item520: makeNodeComponent("item520"),
    left520: makeNodeComponent("left520"),
    icon520: makeNodeComponent("icon520"),
    title543: makeNodeComponent("title543"),
    item521: makeNodeComponent("item521"),
    left521: makeNodeComponent("left521"),
    icon521: makeNodeComponent("icon521"),
    title544: makeNodeComponent("title544"),
    item522: makeNodeComponent("item522"),
    left522: makeNodeComponent("left522"),
    icon522: makeNodeComponent("icon522"),
    title545: makeNodeComponent("title545"),
    item523: makeNodeComponent("item523"),
    left523: makeNodeComponent("left523"),
    icon523: makeNodeComponent("icon523"),
    title546: makeNodeComponent("title546"),
    item524: makeNodeComponent("item524"),
    left524: makeNodeComponent("left524"),
    icon524: makeNodeComponent("icon524"),
    title547: makeNodeComponent("title547"),
    item525: makeNodeComponent("item525"),
    left525: makeNodeComponent("left525"),
    icon525: makeNodeComponent("icon525"),
    title548: makeNodeComponent("title548"),
    item526: makeNodeComponent("item526"),
    left526: makeNodeComponent("left526"),
    icon526: makeNodeComponent("icon526"),
    title549: makeNodeComponent("title549"),
    item527: makeNodeComponent("item527"),
    left527: makeNodeComponent("left527"),
    icon527: makeNodeComponent("icon527"),
    title550: makeNodeComponent("title550"),
    item528: makeNodeComponent("item528"),
    left528: makeNodeComponent("left528"),
    icon528: makeNodeComponent("icon528"),
    title551: makeNodeComponent("title551"),
    btn22: makeNodeComponent("btn22"),
    row9: makeNodeComponent("row9"),
    figmaPaste7: makeNodeComponent("figmaPaste7"),
    narrowCard23: makeNodeComponent("narrowCard23"),
    header48: makeNodeComponent("header48"),
    title552: makeNodeComponent("title552"),
    content23: makeNodeComponent("content23"),
    desc23: makeNodeComponent("desc23"),
    placeholder23: makeNodeComponent("placeholder23"),
    header49: makeNodeComponent("header49"),
    list30: makeNodeComponent("list30"),
    item529: makeNodeComponent("item529"),
    left529: makeNodeComponent("left529"),
    icon529: makeNodeComponent("icon529"),
    title553: makeNodeComponent("title553"),
    item530: makeNodeComponent("item530"),
    left530: makeNodeComponent("left530"),
    icon530: makeNodeComponent("icon530"),
    title554: makeNodeComponent("title554"),
    item531: makeNodeComponent("item531"),
    left531: makeNodeComponent("left531"),
    icon531: makeNodeComponent("icon531"),
    title555: makeNodeComponent("title555"),
    item532: makeNodeComponent("item532"),
    left532: makeNodeComponent("left532"),
    icon532: makeNodeComponent("icon532"),
    title556: makeNodeComponent("title556"),
    item533: makeNodeComponent("item533"),
    left533: makeNodeComponent("left533"),
    icon533: makeNodeComponent("icon533"),
    title557: makeNodeComponent("title557"),
    item534: makeNodeComponent("item534"),
    left534: makeNodeComponent("left534"),
    icon534: makeNodeComponent("icon534"),
    title558: makeNodeComponent("title558"),
    item535: makeNodeComponent("item535"),
    left535: makeNodeComponent("left535"),
    icon535: makeNodeComponent("icon535"),
    title559: makeNodeComponent("title559"),
    item536: makeNodeComponent("item536"),
    left536: makeNodeComponent("left536"),
    icon536: makeNodeComponent("icon536"),
    title560: makeNodeComponent("title560"),
    item537: makeNodeComponent("item537"),
    left537: makeNodeComponent("left537"),
    icon537: makeNodeComponent("icon537"),
    title561: makeNodeComponent("title561"),
    item538: makeNodeComponent("item538"),
    left538: makeNodeComponent("left538"),
    icon538: makeNodeComponent("icon538"),
    title562: makeNodeComponent("title562"),
    item539: makeNodeComponent("item539"),
    left539: makeNodeComponent("left539"),
    icon539: makeNodeComponent("icon539"),
    title563: makeNodeComponent("title563"),
    item540: makeNodeComponent("item540"),
    left540: makeNodeComponent("left540"),
    icon540: makeNodeComponent("icon540"),
    title564: makeNodeComponent("title564"),
    item541: makeNodeComponent("item541"),
    left541: makeNodeComponent("left541"),
    icon541: makeNodeComponent("icon541"),
    title565: makeNodeComponent("title565"),
    item542: makeNodeComponent("item542"),
    left542: makeNodeComponent("left542"),
    icon542: makeNodeComponent("icon542"),
    title566: makeNodeComponent("title566"),
    item543: makeNodeComponent("item543"),
    left543: makeNodeComponent("left543"),
    icon543: makeNodeComponent("icon543"),
    title567: makeNodeComponent("title567"),
    item544: makeNodeComponent("item544"),
    left544: makeNodeComponent("left544"),
    icon544: makeNodeComponent("icon544"),
    title568: makeNodeComponent("title568"),
    item545: makeNodeComponent("item545"),
    left545: makeNodeComponent("left545"),
    icon545: makeNodeComponent("icon545"),
    title569: makeNodeComponent("title569"),
    item546: makeNodeComponent("item546"),
    left546: makeNodeComponent("left546"),
    icon546: makeNodeComponent("icon546"),
    title570: makeNodeComponent("title570"),
    item547: makeNodeComponent("item547"),
    left547: makeNodeComponent("left547"),
    icon547: makeNodeComponent("icon547"),
    title571: makeNodeComponent("title571"),
    item548: makeNodeComponent("item548"),
    left548: makeNodeComponent("left548"),
    icon548: makeNodeComponent("icon548"),
    title572: makeNodeComponent("title572"),
    item549: makeNodeComponent("item549"),
    left549: makeNodeComponent("left549"),
    icon549: makeNodeComponent("icon549"),
    title573: makeNodeComponent("title573"),
    item550: makeNodeComponent("item550"),
    left550: makeNodeComponent("left550"),
    icon550: makeNodeComponent("icon550"),
    title574: makeNodeComponent("title574"),
    item551: makeNodeComponent("item551"),
    left551: makeNodeComponent("left551"),
    icon551: makeNodeComponent("icon551"),
    title575: makeNodeComponent("title575"),
    item552: makeNodeComponent("item552"),
    left552: makeNodeComponent("left552"),
    icon552: makeNodeComponent("icon552"),
    title576: makeNodeComponent("title576"),
    btn23: makeNodeComponent("btn23"),
    narrowCard24: makeNodeComponent("narrowCard24"),
    header50: makeNodeComponent("header50"),
    title577: makeNodeComponent("title577"),
    content24: makeNodeComponent("content24"),
    desc24: makeNodeComponent("desc24"),
    placeholder24: makeNodeComponent("placeholder24"),
    header51: makeNodeComponent("header51"),
    list31: makeNodeComponent("list31"),
    item553: makeNodeComponent("item553"),
    left553: makeNodeComponent("left553"),
    icon553: makeNodeComponent("icon553"),
    title578: makeNodeComponent("title578"),
    item554: makeNodeComponent("item554"),
    left554: makeNodeComponent("left554"),
    icon554: makeNodeComponent("icon554"),
    title579: makeNodeComponent("title579"),
    item555: makeNodeComponent("item555"),
    left555: makeNodeComponent("left555"),
    icon555: makeNodeComponent("icon555"),
    title580: makeNodeComponent("title580"),
    item556: makeNodeComponent("item556"),
    left556: makeNodeComponent("left556"),
    icon556: makeNodeComponent("icon556"),
    title581: makeNodeComponent("title581"),
    item557: makeNodeComponent("item557"),
    left557: makeNodeComponent("left557"),
    icon557: makeNodeComponent("icon557"),
    title582: makeNodeComponent("title582"),
    item558: makeNodeComponent("item558"),
    left558: makeNodeComponent("left558"),
    icon558: makeNodeComponent("icon558"),
    title583: makeNodeComponent("title583"),
    item559: makeNodeComponent("item559"),
    left559: makeNodeComponent("left559"),
    icon559: makeNodeComponent("icon559"),
    title584: makeNodeComponent("title584"),
    item560: makeNodeComponent("item560"),
    left560: makeNodeComponent("left560"),
    icon560: makeNodeComponent("icon560"),
    title585: makeNodeComponent("title585"),
    item561: makeNodeComponent("item561"),
    left561: makeNodeComponent("left561"),
    icon561: makeNodeComponent("icon561"),
    title586: makeNodeComponent("title586"),
    item562: makeNodeComponent("item562"),
    left562: makeNodeComponent("left562"),
    icon562: makeNodeComponent("icon562"),
    title587: makeNodeComponent("title587"),
    item563: makeNodeComponent("item563"),
    left563: makeNodeComponent("left563"),
    icon563: makeNodeComponent("icon563"),
    title588: makeNodeComponent("title588"),
    item564: makeNodeComponent("item564"),
    left564: makeNodeComponent("left564"),
    icon564: makeNodeComponent("icon564"),
    title589: makeNodeComponent("title589"),
    item565: makeNodeComponent("item565"),
    left565: makeNodeComponent("left565"),
    icon565: makeNodeComponent("icon565"),
    title590: makeNodeComponent("title590"),
    item566: makeNodeComponent("item566"),
    left566: makeNodeComponent("left566"),
    icon566: makeNodeComponent("icon566"),
    title591: makeNodeComponent("title591"),
    item567: makeNodeComponent("item567"),
    left567: makeNodeComponent("left567"),
    icon567: makeNodeComponent("icon567"),
    title592: makeNodeComponent("title592"),
    item568: makeNodeComponent("item568"),
    left568: makeNodeComponent("left568"),
    icon568: makeNodeComponent("icon568"),
    title593: makeNodeComponent("title593"),
    item569: makeNodeComponent("item569"),
    left569: makeNodeComponent("left569"),
    icon569: makeNodeComponent("icon569"),
    title594: makeNodeComponent("title594"),
    item570: makeNodeComponent("item570"),
    left570: makeNodeComponent("left570"),
    icon570: makeNodeComponent("icon570"),
    title595: makeNodeComponent("title595"),
    item571: makeNodeComponent("item571"),
    left571: makeNodeComponent("left571"),
    icon571: makeNodeComponent("icon571"),
    title596: makeNodeComponent("title596"),
    item572: makeNodeComponent("item572"),
    left572: makeNodeComponent("left572"),
    icon572: makeNodeComponent("icon572"),
    title597: makeNodeComponent("title597"),
    item573: makeNodeComponent("item573"),
    left573: makeNodeComponent("left573"),
    icon573: makeNodeComponent("icon573"),
    title598: makeNodeComponent("title598"),
    item574: makeNodeComponent("item574"),
    left574: makeNodeComponent("left574"),
    icon574: makeNodeComponent("icon574"),
    title599: makeNodeComponent("title599"),
    item575: makeNodeComponent("item575"),
    left575: makeNodeComponent("left575"),
    icon575: makeNodeComponent("icon575"),
    title600: makeNodeComponent("title600"),
    item576: makeNodeComponent("item576"),
    left576: makeNodeComponent("left576"),
    icon576: makeNodeComponent("icon576"),
    title601: makeNodeComponent("title601"),
    btn24: makeNodeComponent("btn24"),
    row10: makeNodeComponent("row10"),
    row11: makeNodeComponent("row11"),
    figmaPaste8: makeNodeComponent("figmaPaste8"),
    narrowCard25: makeNodeComponent("narrowCard25"),
    header52: makeNodeComponent("header52"),
    title602: makeNodeComponent("title602"),
    content25: makeNodeComponent("content25"),
    desc25: makeNodeComponent("desc25"),
    placeholder25: makeNodeComponent("placeholder25"),
    header53: makeNodeComponent("header53"),
    list32: makeNodeComponent("list32"),
    item577: makeNodeComponent("item577"),
    left577: makeNodeComponent("left577"),
    icon577: makeNodeComponent("icon577"),
    title603: makeNodeComponent("title603"),
    item578: makeNodeComponent("item578"),
    left578: makeNodeComponent("left578"),
    icon578: makeNodeComponent("icon578"),
    title604: makeNodeComponent("title604"),
    item579: makeNodeComponent("item579"),
    left579: makeNodeComponent("left579"),
    icon579: makeNodeComponent("icon579"),
    title605: makeNodeComponent("title605"),
    item580: makeNodeComponent("item580"),
    left580: makeNodeComponent("left580"),
    icon580: makeNodeComponent("icon580"),
    title606: makeNodeComponent("title606"),
    item581: makeNodeComponent("item581"),
    left581: makeNodeComponent("left581"),
    icon581: makeNodeComponent("icon581"),
    title607: makeNodeComponent("title607"),
    item582: makeNodeComponent("item582"),
    left582: makeNodeComponent("left582"),
    icon582: makeNodeComponent("icon582"),
    title608: makeNodeComponent("title608"),
    item583: makeNodeComponent("item583"),
    left583: makeNodeComponent("left583"),
    icon583: makeNodeComponent("icon583"),
    title609: makeNodeComponent("title609"),
    item584: makeNodeComponent("item584"),
    left584: makeNodeComponent("left584"),
    icon584: makeNodeComponent("icon584"),
    title610: makeNodeComponent("title610"),
    item585: makeNodeComponent("item585"),
    left585: makeNodeComponent("left585"),
    icon585: makeNodeComponent("icon585"),
    title611: makeNodeComponent("title611"),
    item586: makeNodeComponent("item586"),
    left586: makeNodeComponent("left586"),
    icon586: makeNodeComponent("icon586"),
    title612: makeNodeComponent("title612"),
    item587: makeNodeComponent("item587"),
    left587: makeNodeComponent("left587"),
    icon587: makeNodeComponent("icon587"),
    title613: makeNodeComponent("title613"),
    item588: makeNodeComponent("item588"),
    left588: makeNodeComponent("left588"),
    icon588: makeNodeComponent("icon588"),
    title614: makeNodeComponent("title614"),
    item589: makeNodeComponent("item589"),
    left589: makeNodeComponent("left589"),
    icon589: makeNodeComponent("icon589"),
    title615: makeNodeComponent("title615"),
    item590: makeNodeComponent("item590"),
    left590: makeNodeComponent("left590"),
    icon590: makeNodeComponent("icon590"),
    title616: makeNodeComponent("title616"),
    item591: makeNodeComponent("item591"),
    left591: makeNodeComponent("left591"),
    icon591: makeNodeComponent("icon591"),
    title617: makeNodeComponent("title617"),
    item592: makeNodeComponent("item592"),
    left592: makeNodeComponent("left592"),
    icon592: makeNodeComponent("icon592"),
    title618: makeNodeComponent("title618"),
    item593: makeNodeComponent("item593"),
    left593: makeNodeComponent("left593"),
    icon593: makeNodeComponent("icon593"),
    title619: makeNodeComponent("title619"),
    item594: makeNodeComponent("item594"),
    left594: makeNodeComponent("left594"),
    icon594: makeNodeComponent("icon594"),
    title620: makeNodeComponent("title620"),
    item595: makeNodeComponent("item595"),
    left595: makeNodeComponent("left595"),
    icon595: makeNodeComponent("icon595"),
    title621: makeNodeComponent("title621"),
    item596: makeNodeComponent("item596"),
    left596: makeNodeComponent("left596"),
    icon596: makeNodeComponent("icon596"),
    title622: makeNodeComponent("title622"),
    item597: makeNodeComponent("item597"),
    left597: makeNodeComponent("left597"),
    icon597: makeNodeComponent("icon597"),
    title623: makeNodeComponent("title623"),
    item598: makeNodeComponent("item598"),
    left598: makeNodeComponent("left598"),
    icon598: makeNodeComponent("icon598"),
    title624: makeNodeComponent("title624"),
    item599: makeNodeComponent("item599"),
    left599: makeNodeComponent("left599"),
    icon599: makeNodeComponent("icon599"),
    title625: makeNodeComponent("title625"),
    item600: makeNodeComponent("item600"),
    left600: makeNodeComponent("left600"),
    icon600: makeNodeComponent("icon600"),
    title626: makeNodeComponent("title626"),
    btn25: makeNodeComponent("btn25"),
    narrowCard26: makeNodeComponent("narrowCard26"),
    header54: makeNodeComponent("header54"),
    title627: makeNodeComponent("title627"),
    content26: makeNodeComponent("content26"),
    desc26: makeNodeComponent("desc26"),
    placeholder26: makeNodeComponent("placeholder26"),
    header55: makeNodeComponent("header55"),
    list33: makeNodeComponent("list33"),
    item601: makeNodeComponent("item601"),
    left601: makeNodeComponent("left601"),
    icon601: makeNodeComponent("icon601"),
    title628: makeNodeComponent("title628"),
    item602: makeNodeComponent("item602"),
    left602: makeNodeComponent("left602"),
    icon602: makeNodeComponent("icon602"),
    title629: makeNodeComponent("title629"),
    item603: makeNodeComponent("item603"),
    left603: makeNodeComponent("left603"),
    icon603: makeNodeComponent("icon603"),
    title630: makeNodeComponent("title630"),
    item604: makeNodeComponent("item604"),
    left604: makeNodeComponent("left604"),
    icon604: makeNodeComponent("icon604"),
    title631: makeNodeComponent("title631"),
    item605: makeNodeComponent("item605"),
    left605: makeNodeComponent("left605"),
    icon605: makeNodeComponent("icon605"),
    title632: makeNodeComponent("title632"),
    item606: makeNodeComponent("item606"),
    left606: makeNodeComponent("left606"),
    icon606: makeNodeComponent("icon606"),
    title633: makeNodeComponent("title633"),
    item607: makeNodeComponent("item607"),
    left607: makeNodeComponent("left607"),
    icon607: makeNodeComponent("icon607"),
    title634: makeNodeComponent("title634"),
    item608: makeNodeComponent("item608"),
    left608: makeNodeComponent("left608"),
    icon608: makeNodeComponent("icon608"),
    title635: makeNodeComponent("title635"),
    item609: makeNodeComponent("item609"),
    left609: makeNodeComponent("left609"),
    icon609: makeNodeComponent("icon609"),
    title636: makeNodeComponent("title636"),
    item610: makeNodeComponent("item610"),
    left610: makeNodeComponent("left610"),
    icon610: makeNodeComponent("icon610"),
    title637: makeNodeComponent("title637"),
    item611: makeNodeComponent("item611"),
    left611: makeNodeComponent("left611"),
    icon611: makeNodeComponent("icon611"),
    title638: makeNodeComponent("title638"),
    item612: makeNodeComponent("item612"),
    left612: makeNodeComponent("left612"),
    icon612: makeNodeComponent("icon612"),
    title639: makeNodeComponent("title639"),
    item613: makeNodeComponent("item613"),
    left613: makeNodeComponent("left613"),
    icon613: makeNodeComponent("icon613"),
    title640: makeNodeComponent("title640"),
    item614: makeNodeComponent("item614"),
    left614: makeNodeComponent("left614"),
    icon614: makeNodeComponent("icon614"),
    title641: makeNodeComponent("title641"),
    item615: makeNodeComponent("item615"),
    left615: makeNodeComponent("left615"),
    icon615: makeNodeComponent("icon615"),
    title642: makeNodeComponent("title642"),
    item616: makeNodeComponent("item616"),
    left616: makeNodeComponent("left616"),
    icon616: makeNodeComponent("icon616"),
    title643: makeNodeComponent("title643"),
    item617: makeNodeComponent("item617"),
    left617: makeNodeComponent("left617"),
    icon617: makeNodeComponent("icon617"),
    title644: makeNodeComponent("title644"),
    item618: makeNodeComponent("item618"),
    left618: makeNodeComponent("left618"),
    icon618: makeNodeComponent("icon618"),
    title645: makeNodeComponent("title645"),
    item619: makeNodeComponent("item619"),
    left619: makeNodeComponent("left619"),
    icon619: makeNodeComponent("icon619"),
    title646: makeNodeComponent("title646"),
    item620: makeNodeComponent("item620"),
    left620: makeNodeComponent("left620"),
    icon620: makeNodeComponent("icon620"),
    title647: makeNodeComponent("title647"),
    item621: makeNodeComponent("item621"),
    left621: makeNodeComponent("left621"),
    icon621: makeNodeComponent("icon621"),
    title648: makeNodeComponent("title648"),
    item622: makeNodeComponent("item622"),
    left622: makeNodeComponent("left622"),
    icon622: makeNodeComponent("icon622"),
    title649: makeNodeComponent("title649"),
    item623: makeNodeComponent("item623"),
    left623: makeNodeComponent("left623"),
    icon623: makeNodeComponent("icon623"),
    title650: makeNodeComponent("title650"),
    item624: makeNodeComponent("item624"),
    left624: makeNodeComponent("left624"),
    icon624: makeNodeComponent("icon624"),
    title651: makeNodeComponent("title651"),
    btn26: makeNodeComponent("btn26"),
    all3: makeNodeComponent("all3"),
    title3: makeNodeComponent("title3"),
    sections3: makeNodeComponent("sections3"),
    col8: makeNodeComponent("col8"),
    list12: makeNodeComponent("list12"),
    col9: makeNodeComponent("col9"),
    section5: makeNodeComponent("section5"),
    list13: makeNodeComponent("list13"),
    section6: makeNodeComponent("section6"),
    list14: makeNodeComponent("list14"),
    col10: makeNodeComponent("col10"),
    list15: makeNodeComponent("list15"),
    mobile: makeNodeComponent("mobile"),
    header3: makeNodeComponent("header3"),
    key3: makeNodeComponent("key3"),
    header2: makeNodeComponent("header2"),
    list6: makeNodeComponent("list6"),
    figmaPaste4: makeNodeComponent("figmaPaste4"),
    narrowCard9: makeNodeComponent("narrowCard9"),
    header28: makeNodeComponent("header28"),
    title: makeNodeComponent("title"),
    content9: makeNodeComponent("content9"),
    desc9: makeNodeComponent("desc9"),
    placeholder9: makeNodeComponent("placeholder9"),
    header29: makeNodeComponent("header29"),
    list24: makeNodeComponent("list24"),
    item: makeNodeComponent("item"),
    left: makeNodeComponent("left"),
    icon: makeNodeComponent("icon"),
    title396: makeNodeComponent("title396"),
    item2: makeNodeComponent("item2"),
    left2: makeNodeComponent("left2"),
    icon2: makeNodeComponent("icon2"),
    title397: makeNodeComponent("title397"),
    item3: makeNodeComponent("item3"),
    left3: makeNodeComponent("left3"),
    icon3: makeNodeComponent("icon3"),
    title4: makeNodeComponent("title4"),
    item4: makeNodeComponent("item4"),
    left4: makeNodeComponent("left4"),
    icon4: makeNodeComponent("icon4"),
    title5: makeNodeComponent("title5"),
    item5: makeNodeComponent("item5"),
    left5: makeNodeComponent("left5"),
    icon5: makeNodeComponent("icon5"),
    title6: makeNodeComponent("title6"),
    item6: makeNodeComponent("item6"),
    left6: makeNodeComponent("left6"),
    icon6: makeNodeComponent("icon6"),
    title7: makeNodeComponent("title7"),
    item7: makeNodeComponent("item7"),
    left7: makeNodeComponent("left7"),
    icon7: makeNodeComponent("icon7"),
    title8: makeNodeComponent("title8"),
    item8: makeNodeComponent("item8"),
    left8: makeNodeComponent("left8"),
    icon8: makeNodeComponent("icon8"),
    title9: makeNodeComponent("title9"),
    item9: makeNodeComponent("item9"),
    left9: makeNodeComponent("left9"),
    icon9: makeNodeComponent("icon9"),
    title10: makeNodeComponent("title10"),
    item10: makeNodeComponent("item10"),
    left10: makeNodeComponent("left10"),
    icon10: makeNodeComponent("icon10"),
    title11: makeNodeComponent("title11"),
    item11: makeNodeComponent("item11"),
    left11: makeNodeComponent("left11"),
    icon11: makeNodeComponent("icon11"),
    title12: makeNodeComponent("title12"),
    item12: makeNodeComponent("item12"),
    left12: makeNodeComponent("left12"),
    icon12: makeNodeComponent("icon12"),
    title13: makeNodeComponent("title13"),
    item13: makeNodeComponent("item13"),
    left13: makeNodeComponent("left13"),
    icon13: makeNodeComponent("icon13"),
    title14: makeNodeComponent("title14"),
    item14: makeNodeComponent("item14"),
    left14: makeNodeComponent("left14"),
    icon14: makeNodeComponent("icon14"),
    title15: makeNodeComponent("title15"),
    item15: makeNodeComponent("item15"),
    left15: makeNodeComponent("left15"),
    icon15: makeNodeComponent("icon15"),
    title16: makeNodeComponent("title16"),
    item16: makeNodeComponent("item16"),
    left16: makeNodeComponent("left16"),
    icon16: makeNodeComponent("icon16"),
    title17: makeNodeComponent("title17"),
    item17: makeNodeComponent("item17"),
    left17: makeNodeComponent("left17"),
    icon17: makeNodeComponent("icon17"),
    title18: makeNodeComponent("title18"),
    item18: makeNodeComponent("item18"),
    left18: makeNodeComponent("left18"),
    icon18: makeNodeComponent("icon18"),
    title19: makeNodeComponent("title19"),
    item19: makeNodeComponent("item19"),
    left19: makeNodeComponent("left19"),
    icon19: makeNodeComponent("icon19"),
    title20: makeNodeComponent("title20"),
    item20: makeNodeComponent("item20"),
    left20: makeNodeComponent("left20"),
    icon20: makeNodeComponent("icon20"),
    title21: makeNodeComponent("title21"),
    item21: makeNodeComponent("item21"),
    left21: makeNodeComponent("left21"),
    icon21: makeNodeComponent("icon21"),
    title22: makeNodeComponent("title22"),
    item22: makeNodeComponent("item22"),
    left22: makeNodeComponent("left22"),
    icon22: makeNodeComponent("icon22"),
    title23: makeNodeComponent("title23"),
    item23: makeNodeComponent("item23"),
    left23: makeNodeComponent("left23"),
    icon23: makeNodeComponent("icon23"),
    title24: makeNodeComponent("title24"),
    item24: makeNodeComponent("item24"),
    left24: makeNodeComponent("left24"),
    icon24: makeNodeComponent("icon24"),
    title25: makeNodeComponent("title25"),
    btn9: makeNodeComponent("btn9"),
    narrowCard10: makeNodeComponent("narrowCard10"),
    header30: makeNodeComponent("header30"),
    title26: makeNodeComponent("title26"),
    content10: makeNodeComponent("content10"),
    desc10: makeNodeComponent("desc10"),
    placeholder10: makeNodeComponent("placeholder10"),
    header31: makeNodeComponent("header31"),
    list2: makeNodeComponent("list2"),
    item25: makeNodeComponent("item25"),
    left25: makeNodeComponent("left25"),
    icon25: makeNodeComponent("icon25"),
    title27: makeNodeComponent("title27"),
    item26: makeNodeComponent("item26"),
    left26: makeNodeComponent("left26"),
    icon26: makeNodeComponent("icon26"),
    title28: makeNodeComponent("title28"),
    item27: makeNodeComponent("item27"),
    left27: makeNodeComponent("left27"),
    icon27: makeNodeComponent("icon27"),
    title29: makeNodeComponent("title29"),
    item28: makeNodeComponent("item28"),
    left28: makeNodeComponent("left28"),
    icon28: makeNodeComponent("icon28"),
    title30: makeNodeComponent("title30"),
    item29: makeNodeComponent("item29"),
    left29: makeNodeComponent("left29"),
    icon29: makeNodeComponent("icon29"),
    title31: makeNodeComponent("title31"),
    item30: makeNodeComponent("item30"),
    left30: makeNodeComponent("left30"),
    icon30: makeNodeComponent("icon30"),
    title32: makeNodeComponent("title32"),
    item31: makeNodeComponent("item31"),
    left31: makeNodeComponent("left31"),
    icon31: makeNodeComponent("icon31"),
    title33: makeNodeComponent("title33"),
    item32: makeNodeComponent("item32"),
    left32: makeNodeComponent("left32"),
    icon32: makeNodeComponent("icon32"),
    title34: makeNodeComponent("title34"),
    item33: makeNodeComponent("item33"),
    left33: makeNodeComponent("left33"),
    icon33: makeNodeComponent("icon33"),
    title35: makeNodeComponent("title35"),
    item34: makeNodeComponent("item34"),
    left34: makeNodeComponent("left34"),
    icon34: makeNodeComponent("icon34"),
    title36: makeNodeComponent("title36"),
    item35: makeNodeComponent("item35"),
    left35: makeNodeComponent("left35"),
    icon35: makeNodeComponent("icon35"),
    title37: makeNodeComponent("title37"),
    item36: makeNodeComponent("item36"),
    left36: makeNodeComponent("left36"),
    icon36: makeNodeComponent("icon36"),
    title38: makeNodeComponent("title38"),
    item37: makeNodeComponent("item37"),
    left37: makeNodeComponent("left37"),
    icon37: makeNodeComponent("icon37"),
    title39: makeNodeComponent("title39"),
    item38: makeNodeComponent("item38"),
    left38: makeNodeComponent("left38"),
    icon38: makeNodeComponent("icon38"),
    title40: makeNodeComponent("title40"),
    item39: makeNodeComponent("item39"),
    left39: makeNodeComponent("left39"),
    icon39: makeNodeComponent("icon39"),
    title41: makeNodeComponent("title41"),
    item40: makeNodeComponent("item40"),
    left40: makeNodeComponent("left40"),
    icon40: makeNodeComponent("icon40"),
    title42: makeNodeComponent("title42"),
    item41: makeNodeComponent("item41"),
    left41: makeNodeComponent("left41"),
    icon41: makeNodeComponent("icon41"),
    title43: makeNodeComponent("title43"),
    item42: makeNodeComponent("item42"),
    left42: makeNodeComponent("left42"),
    icon42: makeNodeComponent("icon42"),
    title44: makeNodeComponent("title44"),
    item43: makeNodeComponent("item43"),
    left43: makeNodeComponent("left43"),
    icon43: makeNodeComponent("icon43"),
    title45: makeNodeComponent("title45"),
    item44: makeNodeComponent("item44"),
    left44: makeNodeComponent("left44"),
    icon44: makeNodeComponent("icon44"),
    title46: makeNodeComponent("title46"),
    item45: makeNodeComponent("item45"),
    left45: makeNodeComponent("left45"),
    icon45: makeNodeComponent("icon45"),
    title47: makeNodeComponent("title47"),
    item46: makeNodeComponent("item46"),
    left46: makeNodeComponent("left46"),
    icon46: makeNodeComponent("icon46"),
    title48: makeNodeComponent("title48"),
    item47: makeNodeComponent("item47"),
    left47: makeNodeComponent("left47"),
    icon47: makeNodeComponent("icon47"),
    title49: makeNodeComponent("title49"),
    item48: makeNodeComponent("item48"),
    left48: makeNodeComponent("left48"),
    icon48: makeNodeComponent("icon48"),
    title50: makeNodeComponent("title50"),
    btn10: makeNodeComponent("btn10"),
    narrowCard11: makeNodeComponent("narrowCard11"),
    header5: makeNodeComponent("header5"),
    title51: makeNodeComponent("title51"),
    content11: makeNodeComponent("content11"),
    desc11: makeNodeComponent("desc11"),
    placeholder11: makeNodeComponent("placeholder11"),
    header6: makeNodeComponent("header6"),
    list3: makeNodeComponent("list3"),
    item49: makeNodeComponent("item49"),
    left49: makeNodeComponent("left49"),
    icon49: makeNodeComponent("icon49"),
    title52: makeNodeComponent("title52"),
    item50: makeNodeComponent("item50"),
    left50: makeNodeComponent("left50"),
    icon50: makeNodeComponent("icon50"),
    title53: makeNodeComponent("title53"),
    item51: makeNodeComponent("item51"),
    left51: makeNodeComponent("left51"),
    icon51: makeNodeComponent("icon51"),
    title54: makeNodeComponent("title54"),
    item52: makeNodeComponent("item52"),
    left52: makeNodeComponent("left52"),
    icon52: makeNodeComponent("icon52"),
    title55: makeNodeComponent("title55"),
    item53: makeNodeComponent("item53"),
    left53: makeNodeComponent("left53"),
    icon53: makeNodeComponent("icon53"),
    title56: makeNodeComponent("title56"),
    item54: makeNodeComponent("item54"),
    left54: makeNodeComponent("left54"),
    icon54: makeNodeComponent("icon54"),
    title57: makeNodeComponent("title57"),
    item55: makeNodeComponent("item55"),
    left55: makeNodeComponent("left55"),
    icon55: makeNodeComponent("icon55"),
    title58: makeNodeComponent("title58"),
    item56: makeNodeComponent("item56"),
    left56: makeNodeComponent("left56"),
    icon56: makeNodeComponent("icon56"),
    title59: makeNodeComponent("title59"),
    item57: makeNodeComponent("item57"),
    left57: makeNodeComponent("left57"),
    icon57: makeNodeComponent("icon57"),
    title60: makeNodeComponent("title60"),
    item58: makeNodeComponent("item58"),
    left58: makeNodeComponent("left58"),
    icon58: makeNodeComponent("icon58"),
    title61: makeNodeComponent("title61"),
    item59: makeNodeComponent("item59"),
    left59: makeNodeComponent("left59"),
    icon59: makeNodeComponent("icon59"),
    title62: makeNodeComponent("title62"),
    item60: makeNodeComponent("item60"),
    left60: makeNodeComponent("left60"),
    icon60: makeNodeComponent("icon60"),
    title63: makeNodeComponent("title63"),
    item61: makeNodeComponent("item61"),
    left61: makeNodeComponent("left61"),
    icon61: makeNodeComponent("icon61"),
    title64: makeNodeComponent("title64"),
    item62: makeNodeComponent("item62"),
    left62: makeNodeComponent("left62"),
    icon62: makeNodeComponent("icon62"),
    title65: makeNodeComponent("title65"),
    item63: makeNodeComponent("item63"),
    left63: makeNodeComponent("left63"),
    icon63: makeNodeComponent("icon63"),
    title66: makeNodeComponent("title66"),
    item64: makeNodeComponent("item64"),
    left64: makeNodeComponent("left64"),
    icon64: makeNodeComponent("icon64"),
    title67: makeNodeComponent("title67"),
    item65: makeNodeComponent("item65"),
    left65: makeNodeComponent("left65"),
    icon65: makeNodeComponent("icon65"),
    title68: makeNodeComponent("title68"),
    item66: makeNodeComponent("item66"),
    left66: makeNodeComponent("left66"),
    icon66: makeNodeComponent("icon66"),
    title69: makeNodeComponent("title69"),
    item67: makeNodeComponent("item67"),
    left67: makeNodeComponent("left67"),
    icon67: makeNodeComponent("icon67"),
    title70: makeNodeComponent("title70"),
    item68: makeNodeComponent("item68"),
    left68: makeNodeComponent("left68"),
    icon68: makeNodeComponent("icon68"),
    title71: makeNodeComponent("title71"),
    item69: makeNodeComponent("item69"),
    left69: makeNodeComponent("left69"),
    icon69: makeNodeComponent("icon69"),
    title72: makeNodeComponent("title72"),
    item70: makeNodeComponent("item70"),
    left70: makeNodeComponent("left70"),
    icon70: makeNodeComponent("icon70"),
    title73: makeNodeComponent("title73"),
    item71: makeNodeComponent("item71"),
    left71: makeNodeComponent("left71"),
    icon71: makeNodeComponent("icon71"),
    title74: makeNodeComponent("title74"),
    item72: makeNodeComponent("item72"),
    left72: makeNodeComponent("left72"),
    icon72: makeNodeComponent("icon72"),
    title75: makeNodeComponent("title75"),
    btn11: makeNodeComponent("btn11"),
    narrowCard12: makeNodeComponent("narrowCard12"),
    header7: makeNodeComponent("header7"),
    title76: makeNodeComponent("title76"),
    content12: makeNodeComponent("content12"),
    desc12: makeNodeComponent("desc12"),
    placeholder12: makeNodeComponent("placeholder12"),
    header8: makeNodeComponent("header8"),
    list4: makeNodeComponent("list4"),
    item73: makeNodeComponent("item73"),
    left73: makeNodeComponent("left73"),
    icon73: makeNodeComponent("icon73"),
    title77: makeNodeComponent("title77"),
    item74: makeNodeComponent("item74"),
    left74: makeNodeComponent("left74"),
    icon74: makeNodeComponent("icon74"),
    title78: makeNodeComponent("title78"),
    item75: makeNodeComponent("item75"),
    left75: makeNodeComponent("left75"),
    icon75: makeNodeComponent("icon75"),
    title79: makeNodeComponent("title79"),
    item76: makeNodeComponent("item76"),
    left76: makeNodeComponent("left76"),
    icon76: makeNodeComponent("icon76"),
    title80: makeNodeComponent("title80"),
    item77: makeNodeComponent("item77"),
    left77: makeNodeComponent("left77"),
    icon77: makeNodeComponent("icon77"),
    title81: makeNodeComponent("title81"),
    item78: makeNodeComponent("item78"),
    left78: makeNodeComponent("left78"),
    icon78: makeNodeComponent("icon78"),
    title82: makeNodeComponent("title82"),
    item79: makeNodeComponent("item79"),
    left79: makeNodeComponent("left79"),
    icon79: makeNodeComponent("icon79"),
    title83: makeNodeComponent("title83"),
    item80: makeNodeComponent("item80"),
    left80: makeNodeComponent("left80"),
    icon80: makeNodeComponent("icon80"),
    title84: makeNodeComponent("title84"),
    item81: makeNodeComponent("item81"),
    left81: makeNodeComponent("left81"),
    icon81: makeNodeComponent("icon81"),
    title85: makeNodeComponent("title85"),
    item82: makeNodeComponent("item82"),
    left82: makeNodeComponent("left82"),
    icon82: makeNodeComponent("icon82"),
    title86: makeNodeComponent("title86"),
    item83: makeNodeComponent("item83"),
    left83: makeNodeComponent("left83"),
    icon83: makeNodeComponent("icon83"),
    title87: makeNodeComponent("title87"),
    item84: makeNodeComponent("item84"),
    left84: makeNodeComponent("left84"),
    icon84: makeNodeComponent("icon84"),
    title88: makeNodeComponent("title88"),
    item85: makeNodeComponent("item85"),
    left85: makeNodeComponent("left85"),
    icon85: makeNodeComponent("icon85"),
    title89: makeNodeComponent("title89"),
    item86: makeNodeComponent("item86"),
    left86: makeNodeComponent("left86"),
    icon86: makeNodeComponent("icon86"),
    title90: makeNodeComponent("title90"),
    item87: makeNodeComponent("item87"),
    left87: makeNodeComponent("left87"),
    icon87: makeNodeComponent("icon87"),
    title91: makeNodeComponent("title91"),
    item88: makeNodeComponent("item88"),
    left88: makeNodeComponent("left88"),
    icon88: makeNodeComponent("icon88"),
    title92: makeNodeComponent("title92"),
    item89: makeNodeComponent("item89"),
    left89: makeNodeComponent("left89"),
    icon89: makeNodeComponent("icon89"),
    title93: makeNodeComponent("title93"),
    item90: makeNodeComponent("item90"),
    left90: makeNodeComponent("left90"),
    icon90: makeNodeComponent("icon90"),
    title94: makeNodeComponent("title94"),
    item91: makeNodeComponent("item91"),
    left91: makeNodeComponent("left91"),
    icon91: makeNodeComponent("icon91"),
    title95: makeNodeComponent("title95"),
    item92: makeNodeComponent("item92"),
    left92: makeNodeComponent("left92"),
    icon92: makeNodeComponent("icon92"),
    title96: makeNodeComponent("title96"),
    item93: makeNodeComponent("item93"),
    left93: makeNodeComponent("left93"),
    icon93: makeNodeComponent("icon93"),
    title97: makeNodeComponent("title97"),
    item94: makeNodeComponent("item94"),
    left94: makeNodeComponent("left94"),
    icon94: makeNodeComponent("icon94"),
    title98: makeNodeComponent("title98"),
    item95: makeNodeComponent("item95"),
    left95: makeNodeComponent("left95"),
    icon95: makeNodeComponent("icon95"),
    title99: makeNodeComponent("title99"),
    item96: makeNodeComponent("item96"),
    left96: makeNodeComponent("left96"),
    icon96: makeNodeComponent("icon96"),
    title398: makeNodeComponent("title398"),
    btn12: makeNodeComponent("btn12"),
    narrowCard13: makeNodeComponent("narrowCard13"),
    header32: makeNodeComponent("header32"),
    title399: makeNodeComponent("title399"),
    content13: makeNodeComponent("content13"),
    desc13: makeNodeComponent("desc13"),
    placeholder13: makeNodeComponent("placeholder13"),
    header33: makeNodeComponent("header33"),
    list5: makeNodeComponent("list5"),
    item385: makeNodeComponent("item385"),
    left385: makeNodeComponent("left385"),
    icon385: makeNodeComponent("icon385"),
    title400: makeNodeComponent("title400"),
    item386: makeNodeComponent("item386"),
    left386: makeNodeComponent("left386"),
    icon386: makeNodeComponent("icon386"),
    title401: makeNodeComponent("title401"),
    item387: makeNodeComponent("item387"),
    left387: makeNodeComponent("left387"),
    icon387: makeNodeComponent("icon387"),
    title402: makeNodeComponent("title402"),
    item388: makeNodeComponent("item388"),
    left388: makeNodeComponent("left388"),
    icon388: makeNodeComponent("icon388"),
    title403: makeNodeComponent("title403"),
    item389: makeNodeComponent("item389"),
    left389: makeNodeComponent("left389"),
    icon389: makeNodeComponent("icon389"),
    title404: makeNodeComponent("title404"),
    item390: makeNodeComponent("item390"),
    left390: makeNodeComponent("left390"),
    icon390: makeNodeComponent("icon390"),
    title405: makeNodeComponent("title405"),
    item391: makeNodeComponent("item391"),
    left391: makeNodeComponent("left391"),
    icon391: makeNodeComponent("icon391"),
    title406: makeNodeComponent("title406"),
    item392: makeNodeComponent("item392"),
    left392: makeNodeComponent("left392"),
    icon392: makeNodeComponent("icon392"),
    title407: makeNodeComponent("title407"),
    item393: makeNodeComponent("item393"),
    left393: makeNodeComponent("left393"),
    icon393: makeNodeComponent("icon393"),
    title408: makeNodeComponent("title408"),
    item394: makeNodeComponent("item394"),
    left394: makeNodeComponent("left394"),
    icon394: makeNodeComponent("icon394"),
    title409: makeNodeComponent("title409"),
    item395: makeNodeComponent("item395"),
    left395: makeNodeComponent("left395"),
    icon395: makeNodeComponent("icon395"),
    title410: makeNodeComponent("title410"),
    item396: makeNodeComponent("item396"),
    left396: makeNodeComponent("left396"),
    icon396: makeNodeComponent("icon396"),
    title411: makeNodeComponent("title411"),
    item397: makeNodeComponent("item397"),
    left397: makeNodeComponent("left397"),
    icon397: makeNodeComponent("icon397"),
    title412: makeNodeComponent("title412"),
    item398: makeNodeComponent("item398"),
    left398: makeNodeComponent("left398"),
    icon398: makeNodeComponent("icon398"),
    title413: makeNodeComponent("title413"),
    item399: makeNodeComponent("item399"),
    left399: makeNodeComponent("left399"),
    icon399: makeNodeComponent("icon399"),
    title414: makeNodeComponent("title414"),
    item400: makeNodeComponent("item400"),
    left400: makeNodeComponent("left400"),
    icon400: makeNodeComponent("icon400"),
    title415: makeNodeComponent("title415"),
    item401: makeNodeComponent("item401"),
    left401: makeNodeComponent("left401"),
    icon401: makeNodeComponent("icon401"),
    title416: makeNodeComponent("title416"),
    item402: makeNodeComponent("item402"),
    left402: makeNodeComponent("left402"),
    icon402: makeNodeComponent("icon402"),
    title417: makeNodeComponent("title417"),
    item403: makeNodeComponent("item403"),
    left403: makeNodeComponent("left403"),
    icon403: makeNodeComponent("icon403"),
    title418: makeNodeComponent("title418"),
    item404: makeNodeComponent("item404"),
    left404: makeNodeComponent("left404"),
    icon404: makeNodeComponent("icon404"),
    title419: makeNodeComponent("title419"),
    item405: makeNodeComponent("item405"),
    left405: makeNodeComponent("left405"),
    icon405: makeNodeComponent("icon405"),
    title420: makeNodeComponent("title420"),
    item406: makeNodeComponent("item406"),
    left406: makeNodeComponent("left406"),
    icon406: makeNodeComponent("icon406"),
    title421: makeNodeComponent("title421"),
    item407: makeNodeComponent("item407"),
    left407: makeNodeComponent("left407"),
    icon407: makeNodeComponent("icon407"),
    title422: makeNodeComponent("title422"),
    item408: makeNodeComponent("item408"),
    left408: makeNodeComponent("left408"),
    icon408: makeNodeComponent("icon408"),
    title423: makeNodeComponent("title423"),
    btn13: makeNodeComponent("btn13"),
    narrowCard14: makeNodeComponent("narrowCard14"),
    header34: makeNodeComponent("header34"),
    title424: makeNodeComponent("title424"),
    content14: makeNodeComponent("content14"),
    desc14: makeNodeComponent("desc14"),
    placeholder14: makeNodeComponent("placeholder14"),
    header35: makeNodeComponent("header35"),
    list25: makeNodeComponent("list25"),
    item409: makeNodeComponent("item409"),
    left409: makeNodeComponent("left409"),
    icon409: makeNodeComponent("icon409"),
    title425: makeNodeComponent("title425"),
    item410: makeNodeComponent("item410"),
    left410: makeNodeComponent("left410"),
    icon410: makeNodeComponent("icon410"),
    title426: makeNodeComponent("title426"),
    item411: makeNodeComponent("item411"),
    left411: makeNodeComponent("left411"),
    icon411: makeNodeComponent("icon411"),
    title427: makeNodeComponent("title427"),
    item412: makeNodeComponent("item412"),
    left412: makeNodeComponent("left412"),
    icon412: makeNodeComponent("icon412"),
    title428: makeNodeComponent("title428"),
    item413: makeNodeComponent("item413"),
    left413: makeNodeComponent("left413"),
    icon413: makeNodeComponent("icon413"),
    title429: makeNodeComponent("title429"),
    item414: makeNodeComponent("item414"),
    left414: makeNodeComponent("left414"),
    icon414: makeNodeComponent("icon414"),
    title430: makeNodeComponent("title430"),
    item415: makeNodeComponent("item415"),
    left415: makeNodeComponent("left415"),
    icon415: makeNodeComponent("icon415"),
    title431: makeNodeComponent("title431"),
    item416: makeNodeComponent("item416"),
    left416: makeNodeComponent("left416"),
    icon416: makeNodeComponent("icon416"),
    title432: makeNodeComponent("title432"),
    item417: makeNodeComponent("item417"),
    left417: makeNodeComponent("left417"),
    icon417: makeNodeComponent("icon417"),
    title433: makeNodeComponent("title433"),
    item418: makeNodeComponent("item418"),
    left418: makeNodeComponent("left418"),
    icon418: makeNodeComponent("icon418"),
    title434: makeNodeComponent("title434"),
    item419: makeNodeComponent("item419"),
    left419: makeNodeComponent("left419"),
    icon419: makeNodeComponent("icon419"),
    title435: makeNodeComponent("title435"),
    item420: makeNodeComponent("item420"),
    left420: makeNodeComponent("left420"),
    icon420: makeNodeComponent("icon420"),
    title436: makeNodeComponent("title436"),
    item421: makeNodeComponent("item421"),
    left421: makeNodeComponent("left421"),
    icon421: makeNodeComponent("icon421"),
    title437: makeNodeComponent("title437"),
    item422: makeNodeComponent("item422"),
    left422: makeNodeComponent("left422"),
    icon422: makeNodeComponent("icon422"),
    title438: makeNodeComponent("title438"),
    item423: makeNodeComponent("item423"),
    left423: makeNodeComponent("left423"),
    icon423: makeNodeComponent("icon423"),
    title439: makeNodeComponent("title439"),
    item424: makeNodeComponent("item424"),
    left424: makeNodeComponent("left424"),
    icon424: makeNodeComponent("icon424"),
    title440: makeNodeComponent("title440"),
    item425: makeNodeComponent("item425"),
    left425: makeNodeComponent("left425"),
    icon425: makeNodeComponent("icon425"),
    title441: makeNodeComponent("title441"),
    item426: makeNodeComponent("item426"),
    left426: makeNodeComponent("left426"),
    icon426: makeNodeComponent("icon426"),
    title442: makeNodeComponent("title442"),
    item427: makeNodeComponent("item427"),
    left427: makeNodeComponent("left427"),
    icon427: makeNodeComponent("icon427"),
    title443: makeNodeComponent("title443"),
    item428: makeNodeComponent("item428"),
    left428: makeNodeComponent("left428"),
    icon428: makeNodeComponent("icon428"),
    title444: makeNodeComponent("title444"),
    item429: makeNodeComponent("item429"),
    left429: makeNodeComponent("left429"),
    icon429: makeNodeComponent("icon429"),
    title445: makeNodeComponent("title445"),
    item430: makeNodeComponent("item430"),
    left430: makeNodeComponent("left430"),
    icon430: makeNodeComponent("icon430"),
    title446: makeNodeComponent("title446"),
    item431: makeNodeComponent("item431"),
    left431: makeNodeComponent("left431"),
    icon431: makeNodeComponent("icon431"),
    title447: makeNodeComponent("title447"),
    item432: makeNodeComponent("item432"),
    left432: makeNodeComponent("left432"),
    icon432: makeNodeComponent("icon432"),
    title448: makeNodeComponent("title448"),
    btn14: makeNodeComponent("btn14"),
    narrowCard15: makeNodeComponent("narrowCard15"),
    header36: makeNodeComponent("header36"),
    title449: makeNodeComponent("title449"),
    content15: makeNodeComponent("content15"),
    desc15: makeNodeComponent("desc15"),
    placeholder15: makeNodeComponent("placeholder15"),
    header37: makeNodeComponent("header37"),
    list26: makeNodeComponent("list26"),
    item433: makeNodeComponent("item433"),
    left433: makeNodeComponent("left433"),
    icon433: makeNodeComponent("icon433"),
    title450: makeNodeComponent("title450"),
    item434: makeNodeComponent("item434"),
    left434: makeNodeComponent("left434"),
    icon434: makeNodeComponent("icon434"),
    title451: makeNodeComponent("title451"),
    item435: makeNodeComponent("item435"),
    left435: makeNodeComponent("left435"),
    icon435: makeNodeComponent("icon435"),
    title452: makeNodeComponent("title452"),
    item436: makeNodeComponent("item436"),
    left436: makeNodeComponent("left436"),
    icon436: makeNodeComponent("icon436"),
    title453: makeNodeComponent("title453"),
    item437: makeNodeComponent("item437"),
    left437: makeNodeComponent("left437"),
    icon437: makeNodeComponent("icon437"),
    title454: makeNodeComponent("title454"),
    item438: makeNodeComponent("item438"),
    left438: makeNodeComponent("left438"),
    icon438: makeNodeComponent("icon438"),
    title455: makeNodeComponent("title455"),
    item439: makeNodeComponent("item439"),
    left439: makeNodeComponent("left439"),
    icon439: makeNodeComponent("icon439"),
    title456: makeNodeComponent("title456"),
    item440: makeNodeComponent("item440"),
    left440: makeNodeComponent("left440"),
    icon440: makeNodeComponent("icon440"),
    title457: makeNodeComponent("title457"),
    item441: makeNodeComponent("item441"),
    left441: makeNodeComponent("left441"),
    icon441: makeNodeComponent("icon441"),
    title458: makeNodeComponent("title458"),
    item442: makeNodeComponent("item442"),
    left442: makeNodeComponent("left442"),
    icon442: makeNodeComponent("icon442"),
    title459: makeNodeComponent("title459"),
    item443: makeNodeComponent("item443"),
    left443: makeNodeComponent("left443"),
    icon443: makeNodeComponent("icon443"),
    title460: makeNodeComponent("title460"),
    item444: makeNodeComponent("item444"),
    left444: makeNodeComponent("left444"),
    icon444: makeNodeComponent("icon444"),
    title461: makeNodeComponent("title461"),
    item445: makeNodeComponent("item445"),
    left445: makeNodeComponent("left445"),
    icon445: makeNodeComponent("icon445"),
    title462: makeNodeComponent("title462"),
    item446: makeNodeComponent("item446"),
    left446: makeNodeComponent("left446"),
    icon446: makeNodeComponent("icon446"),
    title463: makeNodeComponent("title463"),
    item447: makeNodeComponent("item447"),
    left447: makeNodeComponent("left447"),
    icon447: makeNodeComponent("icon447"),
    title464: makeNodeComponent("title464"),
    item448: makeNodeComponent("item448"),
    left448: makeNodeComponent("left448"),
    icon448: makeNodeComponent("icon448"),
    title465: makeNodeComponent("title465"),
    item449: makeNodeComponent("item449"),
    left449: makeNodeComponent("left449"),
    icon449: makeNodeComponent("icon449"),
    title466: makeNodeComponent("title466"),
    item450: makeNodeComponent("item450"),
    left450: makeNodeComponent("left450"),
    icon450: makeNodeComponent("icon450"),
    title467: makeNodeComponent("title467"),
    item451: makeNodeComponent("item451"),
    left451: makeNodeComponent("left451"),
    icon451: makeNodeComponent("icon451"),
    title468: makeNodeComponent("title468"),
    item452: makeNodeComponent("item452"),
    left452: makeNodeComponent("left452"),
    icon452: makeNodeComponent("icon452"),
    title469: makeNodeComponent("title469"),
    item453: makeNodeComponent("item453"),
    left453: makeNodeComponent("left453"),
    icon453: makeNodeComponent("icon453"),
    title470: makeNodeComponent("title470"),
    item454: makeNodeComponent("item454"),
    left454: makeNodeComponent("left454"),
    icon454: makeNodeComponent("icon454"),
    title471: makeNodeComponent("title471"),
    item455: makeNodeComponent("item455"),
    left455: makeNodeComponent("left455"),
    icon455: makeNodeComponent("icon455"),
    title472: makeNodeComponent("title472"),
    item456: makeNodeComponent("item456"),
    left456: makeNodeComponent("left456"),
    icon456: makeNodeComponent("icon456"),
    title473: makeNodeComponent("title473"),
    btn15: makeNodeComponent("btn15"),
    narrowCard16: makeNodeComponent("narrowCard16"),
    header38: makeNodeComponent("header38"),
    title474: makeNodeComponent("title474"),
    content16: makeNodeComponent("content16"),
    desc16: makeNodeComponent("desc16"),
    placeholder16: makeNodeComponent("placeholder16"),
    header39: makeNodeComponent("header39"),
    list27: makeNodeComponent("list27"),
    item457: makeNodeComponent("item457"),
    left457: makeNodeComponent("left457"),
    icon457: makeNodeComponent("icon457"),
    title475: makeNodeComponent("title475"),
    item458: makeNodeComponent("item458"),
    left458: makeNodeComponent("left458"),
    icon458: makeNodeComponent("icon458"),
    title476: makeNodeComponent("title476"),
    item459: makeNodeComponent("item459"),
    left459: makeNodeComponent("left459"),
    icon459: makeNodeComponent("icon459"),
    title477: makeNodeComponent("title477"),
    item460: makeNodeComponent("item460"),
    left460: makeNodeComponent("left460"),
    icon460: makeNodeComponent("icon460"),
    title478: makeNodeComponent("title478"),
    item461: makeNodeComponent("item461"),
    left461: makeNodeComponent("left461"),
    icon461: makeNodeComponent("icon461"),
    title479: makeNodeComponent("title479"),
    item462: makeNodeComponent("item462"),
    left462: makeNodeComponent("left462"),
    icon462: makeNodeComponent("icon462"),
    title480: makeNodeComponent("title480"),
    item463: makeNodeComponent("item463"),
    left463: makeNodeComponent("left463"),
    icon463: makeNodeComponent("icon463"),
    title481: makeNodeComponent("title481"),
    item464: makeNodeComponent("item464"),
    left464: makeNodeComponent("left464"),
    icon464: makeNodeComponent("icon464"),
    title482: makeNodeComponent("title482"),
    item465: makeNodeComponent("item465"),
    left465: makeNodeComponent("left465"),
    icon465: makeNodeComponent("icon465"),
    title483: makeNodeComponent("title483"),
    item466: makeNodeComponent("item466"),
    left466: makeNodeComponent("left466"),
    icon466: makeNodeComponent("icon466"),
    title484: makeNodeComponent("title484"),
    item467: makeNodeComponent("item467"),
    left467: makeNodeComponent("left467"),
    icon467: makeNodeComponent("icon467"),
    title485: makeNodeComponent("title485"),
    item468: makeNodeComponent("item468"),
    left468: makeNodeComponent("left468"),
    icon468: makeNodeComponent("icon468"),
    title486: makeNodeComponent("title486"),
    item469: makeNodeComponent("item469"),
    left469: makeNodeComponent("left469"),
    icon469: makeNodeComponent("icon469"),
    title487: makeNodeComponent("title487"),
    item470: makeNodeComponent("item470"),
    left470: makeNodeComponent("left470"),
    icon470: makeNodeComponent("icon470"),
    title488: makeNodeComponent("title488"),
    item471: makeNodeComponent("item471"),
    left471: makeNodeComponent("left471"),
    icon471: makeNodeComponent("icon471"),
    title489: makeNodeComponent("title489"),
    item472: makeNodeComponent("item472"),
    left472: makeNodeComponent("left472"),
    icon472: makeNodeComponent("icon472"),
    title490: makeNodeComponent("title490"),
    item473: makeNodeComponent("item473"),
    left473: makeNodeComponent("left473"),
    icon473: makeNodeComponent("icon473"),
    title491: makeNodeComponent("title491"),
    item474: makeNodeComponent("item474"),
    left474: makeNodeComponent("left474"),
    icon474: makeNodeComponent("icon474"),
    title492: makeNodeComponent("title492"),
    item475: makeNodeComponent("item475"),
    left475: makeNodeComponent("left475"),
    icon475: makeNodeComponent("icon475"),
    title493: makeNodeComponent("title493"),
    item476: makeNodeComponent("item476"),
    left476: makeNodeComponent("left476"),
    icon476: makeNodeComponent("icon476"),
    title494: makeNodeComponent("title494"),
    item477: makeNodeComponent("item477"),
    left477: makeNodeComponent("left477"),
    icon477: makeNodeComponent("icon477"),
    title495: makeNodeComponent("title495"),
    item478: makeNodeComponent("item478"),
    left478: makeNodeComponent("left478"),
    icon478: makeNodeComponent("icon478"),
    title496: makeNodeComponent("title496"),
    item479: makeNodeComponent("item479"),
    left479: makeNodeComponent("left479"),
    icon479: makeNodeComponent("icon479"),
    title497: makeNodeComponent("title497"),
    item480: makeNodeComponent("item480"),
    left480: makeNodeComponent("left480"),
    icon480: makeNodeComponent("icon480"),
    title498: makeNodeComponent("title498"),
    btn16: makeNodeComponent("btn16"),

    // Metadata about props expected for PlasmicCapabilitiesCards
    internalVariantProps: PlasmicCapabilitiesCards__VariantProps,
    internalArgProps: PlasmicCapabilitiesCards__ArgProps
  }
);

export default PlasmicCapabilitiesCards;
/* prettier-ignore-end */
